// AUTO-GENERATED chunk 'app-tail' by build_bundle.py
// Modules: app-renderers.js, screener-presets.js, learn-panes.js, chart-engine.js, ticker-renderer-hf-skeleton.js, ticker-renderer-graham.js, ticker-renderer-phase2-pending.js, ticker-renderer.js, ticker-renderer-13f.js, ticker-renderer-consensus.js

// ═══ app-renderers.js ═══
;"use strict";
// @ts-nocheck
// ──────────────────────────────────────────────────────────────────────────
// app-renderers.ts — NH9 step 1 split half 2 of 2 (renderers + tail)
// Sliced from the original static/js/app.ts after init() closing `}`
// (original line 3276 onward). See
// docs/plans/NH9_BUNDLE_APP_SPLIT_BOOT_AUDIT.md §"Step 1" + OWNER Q1=A.
//
// Pair file: app-init.ts (must concatenate FIRST in JS_MODULES + the
// app chunk so the cross-chunk var globals are declared before this
// file references them as ambient — per R3 in the NH9 plan).
// ──────────────────────────────────────────────────────────────────────────
// Handle resize for charts. Squad Mobile P1: window.resize fires before
// iOS completes its layout reflow on orientation change, so the chart
// renders with stale pixel dimensions and stays misaligned ~200ms.
// ResizeObserver on the chart container fires AFTER layout settles —
// always picks up the final size. Falls back to window.resize on browsers
// without ResizeObserver (very old).
var _resizeRAF = null;
function _scheduleChartRedraw() {
    if (_resizeRAF)
        return;
    _resizeRAF = requestAnimationFrame(function () {
        _resizeRAF = null;
        if (currentView === 'ticker' && typeof _redrawCombo === 'function') {
            _redrawCombo();
        }
    });
}
if (typeof ResizeObserver !== 'undefined') {
    // FE-STORM P2-A lifecycle: disconnect a prior instance before creating a
    // new one — a double-evaluated chunk (the OXFORD-LEDGE-BROWSER-11 class)
    // re-runs this top-level block, and without the disconnect the orphaned
    // observer keeps firing _scheduleChartRedraw forever. Ref rides window so
    // the re-evaluated scope still sees it.
    var _prevChartObs = window._olPanelResizeObs;
    if (_prevChartObs && typeof _prevChartObs.disconnect === 'function') {
        try {
            _prevChartObs.disconnect();
        }
        catch (_e0) { /* noop */ }
    }
    var _chartResizeObs = new ResizeObserver(_scheduleChartRedraw);
    window._olPanelResizeObs = _chartResizeObs;
    // Observe the chart container once it exists. Defer because dashboard.html
    // may not have rendered the canvas wrapper yet at app.js eval time.
    setTimeout(function () {
        var target = document.getElementById('chart-panel') || document.getElementById('combo-canvas');
        if (target) {
            try {
                _chartResizeObs.observe(target);
            }
            catch (_e) { }
        }
    }, 0);
    // Still listen to window.resize as a safety net for layout changes that
    // don't trigger a container resize (e.g. tab visibility change, theme switch).
    window.addEventListener('resize', _scheduleChartRedraw);
}
else {
    window.addEventListener('resize', _scheduleChartRedraw);
}
// ── TOAST NOTIFICATIONS ──
//
// F18 (Code-Review-Cowork audit 2026-05-12): two correctness gaps in
// the prior implementation:
//   (a) The 5-toast cap shifted out the OLDEST toast — which could be
//       an error message the user hasn't seen yet. The audit noted
//       error-severity messages are "the one thing they need to see
//       and the one most likely to be dropped."
//   (b) No FIFO queue: non-error toasts beyond the cap were lost
//       silently when 5+ fired in close succession (batch actions).
//
// F18 changes:
//   1. Error-severity toasts are MUST-SHOW: when the cap is hit AND
//      the incoming toast is `error`, evict the oldest NON-error
//      visible toast before adding. If all 5 visible are errors and
//      the new one is also error, fall back to evicting the oldest.
//      Non-error incoming toasts that hit the cap go to the queue.
//   2. FIFO queue (`_toastQueue`) holds waiting toasts; each dismiss
//      drains one entry. Queue is bounded at 20 to prevent unbounded
//      growth during a hot loop; entries beyond that are dropped.
//   3. Container gets aria-live='polite' + role='status' for screen
//      readers (assigned once at first showToast; idempotent).
var _toastQueue = [];
var _TOAST_QUEUE_MAX = 20;
var _TOAST_CAP = 5;
function _isErrorToast(type) {
    // 'error' is the canonical severity; some callers pass 'critical'
    // or 'danger' which we also treat as must-show.
    if (!type)
        return false;
    var t = String(type).toLowerCase();
    return t === 'error' || t === 'critical' || t === 'danger';
}
function _drainToastQueue() {
    // Called after a visible toast dismisses. If the cap has room,
    // surface the next queued entry — no further recursion needed
    // because each shown toast schedules its own dismiss.
    if (_toastQueue.length === 0)
        return;
    const container = document.getElementById('toast-container');
    if (!container)
        return;
    if (container.querySelectorAll('.toast').length >= _TOAST_CAP)
        return;
    const next = _toastQueue.shift();
    if (next)
        showToast(next.msg, next.type, next.duration, { html: next.html });
}
// F-17 (external code review 2026-05-21 MED): severity-based default
// duration policy. ~90 showToast() call sites used durations from 2500
// to 10000ms with no consistent semantics. Standardize: info=2.5s,
// success=4s, warning=5s, error/critical=8s (with explicit dismiss).
// Callers can still override by passing an explicit non-4000 duration
// (we only override the 4000 default — picked explicitly because it
// was the legacy default and most call sites accepted it).
function _f17DurationForType(type, callerDuration) {
    // Caller passed an explicit non-default — honor it (back-compat).
    if (callerDuration !== 4000)
        return callerDuration;
    var t = String(type || '').toLowerCase();
    if (t === 'info' || t === '')
        return 2500;
    if (t === 'success')
        return 4000;
    if (t === 'warning')
        return 5000;
    if (t === 'error' || t === 'critical' || t === 'danger')
        return 8000;
    return callerDuration;
}
// F-17 same-type collapse window: when N+1 same-type toasts arrive
// within a 2-second window, the (N+1)th and beyond collapse into a
// counter chip on the most-recent same-type visible toast ("3 alerts
// fired"). Prevents the 9:30am-portfolio-alerts wall-of-toasts feel.
var _F17_COLLAPSE_WINDOW_MS = 2000;
function showToast(msg, type = '', duration = 4000, { html = false } = {}) {
    const container = document.getElementById('toast-container');
    if (!container)
        return;
    // F18: ARIA live region on the container so screen readers announce
    // each toast as it appears. Idempotent — only sets once.
    if (!container.getAttribute('aria-live')) {
        container.setAttribute('aria-live', 'polite');
        container.setAttribute('role', 'status');
        container.setAttribute('aria-atomic', 'false');
    }
    // F-17: apply severity-based duration policy before dedup/collapse.
    duration = _f17DurationForType(type, duration);
    // S33: Dedup — skip if identical toast already visible
    const existing = container.querySelectorAll('.toast');
    for (var _ti = 0; _ti < existing.length; _ti++) {
        if (existing[_ti].textContent === msg)
            return existing[_ti];
    }
    // F-17 same-type collapse: if a same-type toast appeared in the last
    // 2 seconds, collapse this new one into a counter chip on the most-
    // recent same-type visible toast. Skip for error-class (those are
    // must-show per existing eviction policy) so a flurry of errors
    // still surfaces each one.
    if (type && !_isErrorToast(type)) {
        var _now = Date.now();
        for (var _ci = existing.length - 1; _ci >= 0; _ci--) {
            var _peer = existing[_ci];
            if (!_peer.classList.contains(type))
                continue;
            var _peerTs = _peer._f17Ts;
            if (typeof _peerTs !== 'number' || _now - _peerTs > _F17_COLLAPSE_WINDOW_MS)
                continue;
            // Increment the collapse counter chip on the peer
            var _count = (_peer._f17Count || 1) + 1;
            _peer._f17Count = _count;
            var _badge = _peer.querySelector('.toast-collapse-badge');
            if (!_badge) {
                _badge = document.createElement('span');
                _badge.className = 'toast-collapse-badge';
                _peer.appendChild(_badge);
            }
            _badge.textContent = '+' + (_count - 1) + ' more';
            // Reset peer timer + extend by half the new toast's duration so
            // the user has time to see the updated counter.
            try {
                clearTimeout(_peer._toastTimer);
            }
            catch (_e) { /* defensive */ }
            (function (_pp, _dd) {
                var _t = setTimeout(function () {
                    _pp.classList.add('toast-exiting');
                    setTimeout(function () {
                        _pp.remove();
                        try {
                            _drainToastQueue();
                        }
                        catch (_e) { /* defensive */ }
                    }, 300);
                }, Math.max(_dd, 3000));
                _pp._toastTimer = _t;
            })(_peer, duration);
            return _peer;
        }
    }
    if (existing.length >= _TOAST_CAP) {
        const incomingIsError = _isErrorToast(type);
        if (incomingIsError) {
            // F18: must-show — evict the oldest non-error visible. If all
            // 5 are errors, fall back to evicting the oldest of any kind
            // (no perfect answer; the new one is at least timely).
            var _evicted = null;
            for (var _vi = 0; _vi < existing.length; _vi++) {
                var _candidate = existing[_vi];
                if (!_candidate.classList.contains('error') &&
                    !_candidate.classList.contains('critical') &&
                    !_candidate.classList.contains('danger')) {
                    _evicted = _candidate;
                    break;
                }
            }
            if (_evicted === null)
                _evicted = existing[0];
            clearTimeout(_evicted._toastTimer);
            _evicted.remove();
        }
        else {
            // F18: non-error overflow — enqueue and return. Drain hook on
            // each dismiss surfaces queued entries when space frees.
            if (_toastQueue.length < _TOAST_QUEUE_MAX) {
                _toastQueue.push({ msg: String(msg), type: type, duration: duration, html: html });
            }
            return null;
        }
    }
    const el = document.createElement('div');
    el.className = 'toast ' + type;
    // F-17: stamp the timestamp so a subsequent same-type toast within
    // the 2s collapse window can find this peer and increment its counter
    // chip instead of stacking another visible toast.
    el._f17Ts = Date.now();
    el._f17Count = 1;
    // SVG icons for each toast type
    const _toastIcons = {
        success: '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><circle cx="10" cy="10" r="9" stroke="var(--text-positive)" stroke-width="1.5" fill="none"/><path d="M6 10.5l2.5 2.5L14 7.5" stroke="var(--text-positive)" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>',
        error: '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><circle cx="10" cy="10" r="9" stroke="var(--chart-loss)" stroke-width="1.5" fill="none"/><path d="M7 7l6 6M13 7l-6 6" stroke="var(--chart-loss)" stroke-width="1.8" stroke-linecap="round"/></svg>',
        warning: '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M10 2.5L1.5 17.5h17L10 2.5z" stroke="var(--gold-brand)" stroke-width="1.5" stroke-linejoin="round" fill="none"/><path d="M10 8v4" stroke="var(--gold-brand)" stroke-width="1.8" stroke-linecap="round"/><circle cx="10" cy="14.5" r="0.8" fill="var(--gold-brand)"/></svg>',
        info: '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><circle cx="10" cy="10" r="9" stroke="var(--chart-primary)" stroke-width="1.5" fill="none"/><path d="M10 9v5" stroke="var(--chart-primary)" stroke-width="1.8" stroke-linecap="round"/><circle cx="10" cy="6.5" r="0.8" fill="var(--chart-primary)"/></svg>'
    };
    const iconSvg = _toastIcons[type] || '';
    const iconHtml = iconSvg ? '<span class="toast-icon">' + iconSvg + '</span>' : '';
    const msgSpan = '<span class="toast-msg">' + (html ? msg : msg.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')) + '</span>';
    el.innerHTML = iconHtml + msgSpan;
    container.appendChild(el);
    const timer = setTimeout(() => {
        el.classList.add('toast-exiting');
        setTimeout(() => {
            el.remove();
            // F18: drain one queued toast per dismiss so non-error overflow
            // surfaces in FIFO order as visible toasts complete.
            try {
                _drainToastQueue();
            }
            catch (_e) { /* defensive */ }
        }, 300);
    }, duration);
    el._toastTimer = timer;
    return el;
}
// 2026-05-07 NH8: canonical-toast helper. Routes a toast through
// `window.OLErrorCopy.lookup(code)` so the user-facing copy stays in
// lockstep with the registry in static/js/error-copy.ts. Falls back to
// the literal `fallback` string if the registry isn't loaded yet (boot
// race) or showToast is unavailable. Use this instead of inlining
// "Please try again" strings — the registry's wording is reviewed once
// and reused everywhere.
function _showCanonicalToast(code, fallback, duration = 5000) {
    try {
        var w = window;
        if (w && w.OLErrorCopy && typeof w.OLErrorCopy.lookup === 'function' && typeof showToast === 'function') {
            var r = w.OLErrorCopy.lookup(code);
            showToast(r.body, r.severity || 'error', duration);
            return;
        }
    }
    catch (_e) { /* fall through to fallback */ }
    if (typeof showToast === 'function')
        showToast(fallback, 'error', duration);
}
// ── RECENT TICKERS ──
// 2026-09-26 (external review P1-12): drop any stored entry that is not a
// ticker shape -- a crafted share link could have persisted markup here before
// switchTicker validated. Same shape as app-init.ts _OL_TICKER_RE (pinned equal
// by tests/test_frontend_security_wp_d_contract.py); inlined because this runs
// at module load, before app-init's helpers are guaranteed to exist.
var _recentTickers = (OLStorage.get('recentTickers', []) || []).filter(function (r) {
    return !!r && typeof r.ticker === 'string' && /^\^?[A-Z0-9][A-Z0-9.\-=\/]{0,14}$/.test(r.ticker);
});
function _trackRecentTicker(t) {
    _recentTickers = _recentTickers.filter(r => r.ticker !== t);
    _recentTickers.unshift({ ticker: t, ts: Date.now() });
    if (_recentTickers.length > 15)
        _recentTickers.length = 15;
    OLStorage.set('recentTickers', _recentTickers);
}
function _relativeTime(ts) {
    // #93 (A16 Phase 3): prefer the canonical timeAgo (uncapped epoch-ms mode) —
    // byte-identical output. typeof guard + the inline fallback below keep it
    // cross-chunk safe (formatting.js may not have parsed yet in some load orders).
    if (typeof timeAgo === 'function') {
        var _r = timeAgo(ts, { uncapped: true });
        if (_r)
            return _r;
    }
    const diff = Math.floor((Date.now() - ts) / 1000);
    if (diff < 60)
        return 'just now';
    if (diff < 3600)
        return Math.floor(diff / 60) + 'm ago';
    if (diff < 86400)
        return Math.floor(diff / 3600) + 'h ago';
    return Math.floor(diff / 86400) + 'd ago';
}
function _relativeTimeISO(iso) {
    if (!iso)
        return '';
    const diff = Math.floor((Date.now() - new Date(iso).getTime()) / 1000);
    if (diff < 0)
        return '';
    if (diff < 60)
        return 'just now';
    if (diff < 3600)
        return Math.floor(diff / 60) + 'm ago';
    if (diff < 86400)
        return Math.floor(diff / 3600) + 'h ago';
    if (diff < 2592000)
        return Math.floor(diff / 86400) + 'd ago';
    return Math.floor(diff / 2592000) + 'mo ago';
}
// ── COMMAND PALETTE ──
var cmdOpen = false;
var cmdSelectedIdx = 0;
function getCommands() {
    const cmds = [
        { type: 'view', label: 'Live', action: () => setView('macro'), hint: '1' },
        { type: 'view', label: 'News', action: () => setView('news'), hint: '2' },
        { type: 'view', label: 'Ticker', action: () => setView('ticker'), hint: '3' },
        { type: 'view', label: 'Portfolio', action: () => setView('portfolio'), hint: '4' },
        { type: 'view', label: 'Watchlist', action: () => setView('watchlist'), hint: '5' },
        { type: 'view', label: 'Learn', action: () => setView('learn'), hint: '6' },
        { type: 'view', label: 'Screener', action: () => setView('screener'), hint: 'S' },
        { type: 'view', label: 'Company Financials', action: () => setView('fundamentals'), hint: 'F' },
        { type: 'view', label: 'Calendar', action: () => setView('calendar'), hint: '' },
        { type: 'view', label: 'Ownership', action: () => setView('13f'), hint: '' },
        { type: 'view', label: 'Credit', action: () => setView('credit'), hint: '' },
        { type: 'view', label: 'Business Loan Funds (BDCs)', action: () => setView('bdc'), hint: 'B' },
        { type: 'action', label: 'Refresh Data', action: () => refreshCurrent(), hint: 'R' },
        { type: 'action', label: 'Quick Compare (side-by-side)', action: () => { if (typeof openCompareModal === 'function')
                openCompareModal(); }, hint: 'C' },
        { type: 'action', label: 'ETF Compare (overlap + expense)', action: () => { if (typeof openETFCompare === 'function')
                openETFCompare(); }, hint: '' },
        { type: 'action', label: 'Browse glossary terms', action: () => { if (typeof openGlossaryBrowse === 'function')
                openGlossaryBrowse(); }, hint: '' },
        { type: 'action', label: 'Explore a random stock', action: () => randomTicker(), hint: '' },
        { type: 'action', label: 'Ask AI about current ticker', action: () => { if (typeof toggleAskAiPanel === 'function')
                toggleAskAiPanel(); }, hint: 'A' },
        { type: 'action', label: 'Open practice mode', action: () => { if (typeof togglePracticeMode === 'function')
                togglePracticeMode(); }, hint: 'P' },
        { type: 'action', label: 'Print one-pager', action: () => { if (typeof exportTickerPDF === 'function')
                exportTickerPDF(); }, hint: 'Ctrl+P' },
        { type: 'action', label: 'Export report', action: function () {
                // F-06 (2026-05-21 external code review): stripped the two
                // prompt() dialogs for "Prepared by" and "Client name" — they
                // cheapen a deliverable users print and share with clients, and
                // the fields were already optional so most users hit Cancel.
                // Report now opens directly. Follow-up: replace with a styled
                // modal collecting both fields with a Skip option (see doc F-06).
                if (typeof activeTicker !== 'undefined' && activeTicker) {
                    var _reportUrl = '/api/export/report?symbol=' + encodeURIComponent(activeTicker) + '&format=html';
                    window.open(_reportUrl, '_blank', 'noopener,noreferrer');
                }
                else {
                    showToast('No ticker loaded', 'warning');
                }
            }, hint: '' },
        { type: 'action', label: 'Copy summary', action: () => { if (typeof copyTickerSummary === 'function')
                copyTickerSummary(); }, hint: '' },
        { type: 'action', label: 'Value Creation Score', action: () => { if (typeof openValueScorePanel === 'function')
                openValueScorePanel(); }, hint: '' },
        { type: 'action', label: 'Add to Watchlist', action: function () {
                if (!authGate('add to watchlist'))
                    return;
                if (typeof activeTicker !== 'undefined' && activeTicker) {
                    if (typeof addToWatchlist === 'function')
                        addToWatchlist(activeTicker);
                    else
                        showToast(activeTicker + ' — use the Watchlist view to add', 'info');
                }
            }, icon: '\u2605', hint: '' },
        { type: 'action', label: 'Remove from Session', action: function () {
                if (typeof activeTicker !== 'undefined' && activeTicker)
                    removeTicker(activeTicker);
            }, icon: '\u2715', hint: '' },
        { type: 'action', label: 'Search Transcripts', action: () => { setView('ticker'); setTimeout(() => { var ts = document.getElementById('transcripts-section'); if (ts) {
                ts.scrollIntoView({ behavior: 'smooth', block: 'start' });
                var inp = document.getElementById('transcript-search-input');
                if (inp)
                    inp.focus();
            } }, 300); }, hint: '' },
        { type: 'action', label: 'Berkshire 13F', action: () => { setView('13f'); setTimeout(() => { const inp = document.getElementById('f13-fund-input'); if (inp) {
                inp.value = 'Berkshire Hathaway';
                search13fFund();
            } }, 200); }, hint: '' },
        { type: 'action', label: 'Remove from Watchlist', action: function () {
                if (typeof activeTicker !== 'undefined' && activeTicker) {
                    fetch(SERVER + '/api/watchlist', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ action: 'remove', ticker: activeTicker })
                    }).then(function () {
                        showToast(activeTicker + ' removed from watchlist', 'success', 2000);
                        if (typeof renderWatchlist === 'function')
                            renderWatchlist();
                    }).catch(function () { _showCanonicalToast('network', 'Unable to remove from watchlist. Please try again.'); });
                }
            }, hint: '' },
        { type: 'action', label: 'Add to Session', action: function () {
                // F-06 (2026-05-21 external code review): replaced prompt() with
                // focus on the existing #ticker-input search bar (which has live
                // autocomplete via /api/ticker-search at app-init.ts:2317). The
                // prompt was a broken-feeling unstyled dialog with no validation
                // or autocomplete — sending users to the proper search bar gives
                // them the full autocomplete experience the rest of the app uses.
                var _tickerInput = document.getElementById('ticker-input');
                if (_tickerInput) {
                    _tickerInput.focus();
                    _tickerInput.select();
                    showToast('Type a ticker in the search bar above (e.g., AAPL)', 'info', 3000);
                }
                else {
                    showToast('Ticker search unavailable on this view', 'warning');
                }
            }, hint: '' },
        { type: 'action', label: 'Export Data', action: function () {
                if (currentView === 'portfolio') {
                    if (typeof TierGate !== 'undefined' && TierGate.canCall && !TierGate.canCall('/api/export') && typeof showToast === 'function') {
                        showToast('CSV export is a Researcher feature. <a href="/?upgrade=plus" class="toast-link">Upgrade to Researcher</a>', '', 5000, { html: true });
                        return;
                    }
                    window.location.href = '/api/export?type=portfolio';
                }
                else if (currentView === '13f' && typeof _download13fCSV === 'function') {
                    _download13fCSV();
                }
                else if (currentView === 'watchlist' && typeof _downloadWatchlistCSV === 'function') {
                    _downloadWatchlistCSV();
                }
                else if (currentView === 'credit' && typeof _downloadCreditBatchCSV === 'function') {
                    _downloadCreditBatchCSV();
                }
                else {
                    if (typeof exportTickerPDF === 'function')
                        exportTickerPDF();
                }
            }, hint: '' },
        { type: 'action', label: 'Toggle Focus Mode', action: () => toggleFocusMode(), hint: '' },
        { type: 'action', label: 'Comp Table — Full-Page', desc: 'Compare companies with export', action: () => { setView('comps'); }, hint: '' },
        { type: 'action', label: 'Comps Builder - Build Full Comps Sheet', action: () => { if (typeof openCompsBuilder === 'function')
                openCompsBuilder(); }, hint: '' },
        { type: 'action', label: 'Custom Chart Builder', action: () => { if (typeof toggleCustomChartBuilder === 'function')
                toggleCustomChartBuilder(); }, hint: 'Ctrl+Shift+C' },
        { type: 'action', label: 'Copy Ticker URL', action: () => shareCopyLink(), hint: '' },
    ];
    const allT = [...new Set([...tickers, ...PORTFOLIO_TICKERS])];
    allT.forEach(t => {
        const d = getData(t);
        const company = d ? (d.company || '') : '';
        cmds.push({ type: 'ticker', label: `${t}${company ? ' — ' + company : ''}`, action: () => switchTicker(t), hint: '' });
    });
    return cmds;
}
// SF-23 vestige removed 2026-05-17: toggleMoreDropdown / the
// first-visit tools-collapse helpers (_applyToolsCollapseIfFirstVisit /
// _expandAllTools) + their state flags drove the deleted
// #more-dropdown-* topbar markup (gone 2026-05-07, Phase C). All
// getElementById('more-dropdown-*') returned null in prod; this whole
// block was dead. See closeMoreDropdown no-op shim below for the one
// symbol kept (6 live set-view/comps callers).
// CYCLE5 Ticket 7 (Jobs) — Door II focused-ticker helpers.
//
// The "Research a company" onboarding door routes straight to a
// ticker view with chrome stripped, so the valuation answer is the
// chapter-one reveal rather than buried under morning-brief, pulse
// bar, and full nav. CSS class .door2-focused on <body> does the
// visual work (see dashboard-styles.css); these helpers manage the
// state transitions.
//
// Exit triggers:
//   1. User clicks the "Show full dashboard" chip (top of screen)
//   2. User navigates away from ticker view (persists if they come
//      back, but becomes invisible while elsewhere)
//   3. localStorage cleared (privacy mode / incognito / reset)
function _exitDoor2Focused() {
    document.body.classList.remove('door2-focused');
    try {
        OLStorage.remove('ol_door2_focused');
    }
    catch (_e) { }
}
// Restore focused-mode on page-reload if the user was mid-Door-II.
// Fires on DOMContentLoaded so the class is set before any render
// (prevents an ugly flash of full-chrome UI before CSS hides it).
document.addEventListener('DOMContentLoaded', function () {
    try {
        if (OLStorage.getString('ol_door2_focused', null) === '1') {
            document.body.classList.add('door2-focused');
        }
    }
    catch (_e) { /* storage disabled — skip restore */ }
});
// CYCLE5 Ticket 9 (Thaler) — first-loss volatility-normalization tooltip.
// Fires ONCE per user lifetime the first time a watched ticker's daily
// change hits ≤-2%. Rationale: loss aversion makes beginners 2.5x more
// reactive to red than green of the same magnitude. A pre-framed
// "this is normal" nudge beats letting them panic-sell. Links to
// bf-6 (Recency Bias) — the canonical module on "the last datapoint
// feels predictive when it isn't."
//
// Implementation:
//   - Gated by localStorage 'ol_first_loss_shown'. Set after display.
//   - Gated by typeof showToast guard so the app doesn't crash if the
//     toast module hasn't loaded on an edge path.
//   - Uses showToast with dismissable html — neutral tone, not
//     consolation ("we saw X go red — this is normal market volatility").
//   - Zero user-facing copy that shames the decline or implies alarm.
//
// NOT triggered by:
//   - Sub-2% moves (-0.1% to -1.99% are routine, don't burn the
//     one-shot nudge on noise)
//   - Hypothetical portfolio total (harder to track per-user; daily
//     ticker change is the observable proxy the tab-bar already shows)
//   - Subsequent red moves (one-time only, not a recurring lecture)
var _firstLossCheckedThisSession = false;
function _maybeShowFirstLossTooltip(ticker, pct) {
    if (_firstLossCheckedThisSession)
        return;
    // Short-circuit read once per session for perf
    _firstLossCheckedThisSession = true;
    try {
        if (OLStorage.getString('ol_first_loss_shown', null) === 'true')
            return;
    }
    catch (e) {
        return; /* storage disabled — don't spam, just skip */
    }
    // Defer to next tick so the tab-render call stack completes first.
    setTimeout(function () {
        if (typeof showToast !== 'function')
            return;
        var pctStr = (pct < 0 ? '' : '+') + pct.toFixed(1) + '%';
        var msg = '<strong>' + escHtml(ticker) + ' ' + pctStr + ' — this is normal.</strong>' +
            '<br>Single-day moves of 2-5% happen roughly 20 days a year in US stocks, ' +
            'usually noise — not signal. ' +
            '<a href="/?view=learn&module=bf-6" class="toast-link">' +
            'Why recency bias magnifies losses &rarr;</a>';
        showToast(msg, '', 10000, { html: true, dismissable: true });
        try {
            OLStorage.setString('ol_first_loss_shown', 'true');
        }
        catch (e) { }
    }, 100);
}
// SF-23 vestige: #more-dropdown markup deleted 2026-05-07 (Phase C); kept as a no-op so the 6 live set-view/comps callers don't ReferenceError. Safe to delete fully once those call-sites are removed.
function closeMoreDropdown() { }
// Close MORE dropdown on Escape
document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
        // 2026-05-06 brand-audit Round 3: feature sidecar Escape close
        var fsP = document.getElementById('feature-sidecar');
        var fsO = document.getElementById('feature-sidecar-overlay');
        if (fsP && !fsP.classList.contains('d-none')) {
            // This listener runs BEFORE the central Escape chain; mark the key spent
            // so the chain's practice-mode branch does not also fire on it.
            e.preventDefault(); // CHAOS 2026-09-25
            fsP.classList.add('d-none');
            if (fsO)
                fsO.classList.add('d-none');
            document.body.style.overflow = ''; // MA #30: release the scroll-lock
            var fsB = document.querySelector('[data-action="toggle-feature-sidecar"]');
            if (fsB)
                fsB.setAttribute('aria-expanded', 'false');
            // 2026-06-19 audit Phase-1 [High]: return focus to the hamburger
            // on Escape (matches the SSR nav-toggle.ts pattern).
            if (fsB instanceof HTMLElement)
                fsB.focus();
        }
    }
});
// 2026-06-19 audit Phase-1 [High] (HEAD-verified — the original finding's
// inline-init.ts #mobile-nav-overlay target was dead code, deleted
// 2026-05-07; the live SPA drawer is this feature-sidecar). It already had
// tap-outside-close + Escape-close + aria-expanded, but NO focus management.
// Port the SSR nav-toggle.ts focus-trap: move focus into the drawer on open,
// trap Tab within it while open, and return focus to the hamburger on close
// (WCAG 2.4.3 focus order / 2.1.2 no keyboard trap-escape).
function _olSidecarFocusables() {
    var p = document.getElementById('feature-sidecar');
    if (!p || p.classList.contains('d-none'))
        return [];
    var nodes = p.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])');
    return Array.prototype.slice.call(nodes).filter(function (el) {
        return el.offsetParent !== null; // visible only
    });
}
// Exposed so the two open-paths (this chunk's toggle handler + the
// app-init.ts pre-hydration fallback) can pull focus in on open.
window._olSidecarFocusFirst = function () {
    var f = _olSidecarFocusables();
    if (f.length)
        f[0].focus();
};
document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab')
        return;
    var f = _olSidecarFocusables();
    if (!f.length)
        return; // sidecar closed → no trap
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
    }
    else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
    }
});
// The one way to close the sidecar; one writer so the MA #30 scroll-lock
// release cannot be dropped by a copied close path.
function _closeFeatureSidecar() {
    var p = document.getElementById('feature-sidecar');
    var o = document.getElementById('feature-sidecar-overlay');
    var b = document.querySelector('[data-action="toggle-feature-sidecar"]');
    if (p)
        p.classList.add('d-none');
    if (o)
        o.classList.add('d-none');
    document.body.style.overflow = ''; // MA #30: release the scroll-lock
    if (b)
        b.setAttribute('aria-expanded', 'false');
}
// N2 (mobile audit 2026-09-25): the backdrop RECEIVES the dismissing tap.
// Until this date `.ol-feature-sidecar-overlay` was pointer-events:none, so
// the tap that closed the drawer landed on whatever sat under the backdrop --
// a ticker row, a nav tab, a card -- and activated it. One listener, capture
// phase so it runs before any bubble-phase delegate: when the target IS the
// backdrop, close the drawer and stop the event dead. The panel itself is a
// sibling above the backdrop (z 1000 over 999) and stays fully interactive.
// The CSS half is `pointer-events: auto` on the overlay rule in
// oxford-dashboard.css; without it this listener never sees the tap.
// Pins: tests/test_mobile_overlay_exits_2026_09_25_contract.py
document.addEventListener('click', function (e) {
    var o = document.getElementById('feature-sidecar-overlay');
    if (!o || o.classList.contains('d-none') || e.target !== o)
        return;
    e.preventDefault();
    e.stopPropagation();
    _closeFeatureSidecar();
}, true);
// N20 (mobile audit 2026-09-25): sidecar items that exist only for their
// data-action carry `href="#"` so they stay real anchors for the focus order.
// The delegated handlers never preventDefault, so each tap ALSO navigated to
// `#` -- a scroll-to-top jump under the Peer comparison / Practice mode items.
// One guard for the whole drawer, keyed on the `#` href, so a handler added
// later gets it for free and a real navigation (`/bonds/`) is never touched.
document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || typeof t.closest !== 'function')
        return;
    var hashItem = t.closest('#feature-sidecar a[href="#"][data-action]');
    if (hashItem)
        e.preventDefault();
}, true);
// 2026-05-06 brand-audit Round 3: feature sidecar click-outside-to-close.
// Mirrors the apikeys + askai click-outside pattern. The document-level
// listener checks whether the click was inside the panel — if not, close.
// (Since N2 above the backdrop catches its own tap; this remains the close
// path for a click that lands OUTSIDE both backdrop and panel, e.g. on
// chrome that sits above the backdrop in the z ladder.)
document.addEventListener('click', function (e) {
    var fsP = document.getElementById('feature-sidecar');
    var t = e.target;
    if (!fsP || fsP.classList.contains('d-none') || !t || typeof t.closest !== 'function')
        return;
    if (t.closest('#feature-sidecar'))
        return;
    if (t.closest('[data-action="toggle-feature-sidecar"]'))
        return;
    _closeFeatureSidecar(); // click outside
}, true);
// OWNER QA 2026-07-28: close the sidecar on ANY item click. 11 plain <a href>
// entries had no close path, so the dismissing click loaded an unintended page.
// Full rationale: tests/test_feature_sidecar_closes_on_item_click_contract.py
document.addEventListener('click', function (e) {
    var fsP = document.getElementById('feature-sidecar');
    var t = e.target;
    if (!fsP || fsP.classList.contains('d-none') || !t || typeof t.closest !== 'function')
        return;
    if (!t.closest('#feature-sidecar'))
        return; // outside -> other handler
    var a = t.closest('a[href]');
    if (!a)
        return; // not a link (eyebrow, close X)
    // Unconditional: exempting data-action items skips `open-comps-builder` and
    // `toggle-practice-mode`, which act WITHOUT closing. Only the toggle is out.
    if (a.getAttribute('data-action') === 'toggle-feature-sidecar')
        return;
    // Modified click = new tab, reader stays here -> leave the panel open.
    var me = e;
    if (me && (me.metaKey || me.ctrlKey || me.shiftKey || me.button === 1))
        return;
    _closeFeatureSidecar();
}, true);
// Responsive: show watchlist in MORE dropdown at narrow widths
(function () {
    const mq = window.matchMedia('(max-width: 900px)');
    function handleResize(e) {
        const mobileWatchlist = document.getElementById('more-watchlist-mobile');
        if (mobileWatchlist)
            mobileWatchlist.classList.toggle('hidden', !e.matches);
    }
    mq.addEventListener('change', handleResize);
    handleResize(mq);
})();
function openCommandPalette() {
    _materializeView('command-palette').then(function () {
        cmdOpen = true;
        cmdSelectedIdx = 0;
        const el = document.getElementById('command-palette');
        const inp = document.getElementById('cmd-input');
        if (!el || !inp)
            return;
        el.classList.add('open');
        inp.value = '';
        inp.focus();
        renderCommandResults('');
        // Ensure keydown listener is attached (template may not exist at parse time)
        if (!inp._cmdListenerAttached) {
            inp.addEventListener('input', e => renderCommandResults(e.target.value));
            inp.addEventListener('keydown', e => {
                const filtered = document.getElementById('cmd-results')?._filtered || [];
                if (e.key === 'ArrowDown') {
                    e.preventDefault();
                    cmdSelectedIdx = Math.min(cmdSelectedIdx + 1, filtered.length - 1);
                    renderCommandResults(e.target.value);
                }
                else if (e.key === 'ArrowUp') {
                    e.preventDefault();
                    cmdSelectedIdx = Math.max(cmdSelectedIdx - 1, 0);
                    renderCommandResults(e.target.value);
                }
                else if (e.key === 'Enter') {
                    e.preventDefault();
                    cmdExecute(cmdSelectedIdx);
                }
                else if (e.key === 'Escape') {
                    closeCommandPalette();
                }
            });
            inp._cmdListenerAttached = true;
        }
    });
}
function closeCommandPalette() {
    cmdOpen = false;
    document.getElementById('command-palette')?.classList.remove('open');
}
// 2026-04-30 evening — SSR shell deep-link to dashboard search.
//
// `ssr_renderer.py:_render_sp_header` ships a `<a href="/?cmd=open">SEARCH /</a>`
// affordance in the marketing chrome (pricing.html / learn-index.html /
// stocks/ etc.). Pre-fix the affordance was a non-interactive <span> with
// `aria-hidden="true"` — looked clickable, did nothing on click, and the
// `/` keyboard hint was aspirational because the SSR pages don't load the
// SPA's command-palette handler. OWNER flagged it on /pricing.
//
// Fix: SSR converts the span to an <a href="/?cmd=open">; this hook fires
// on the dashboard right after `openCommandPalette` is defined, opens the
// palette, and `history.replaceState` cleans up the URL so a refresh
// doesn't keep firing the palette. `?cmd=open` is intentionally generic
// so future shell affordances (Ctrl+K hint, mobile bottom-bar search)
// can reuse the same param.
(function _wireCmdOpenUrlParam() {
    try {
        var p = new URLSearchParams(window.location.search);
        if (p.get('cmd') !== 'open')
            return;
        p.delete('cmd');
        var newSearch = p.toString();
        var newUrl = window.location.pathname + (newSearch ? '?' + newSearch : '') + window.location.hash;
        history.replaceState({}, '', newUrl);
        // Defer until after the SPA's DOMContentLoaded init has materialized
        // dashboard.html shell + view stubs; openCommandPalette uses
        // _materializeView which itself defers through a Promise, so a single
        // setTimeout(0) is enough to let the bootstrap settle.
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', function () { setTimeout(openCommandPalette, 0); });
        }
        else {
            setTimeout(openCommandPalette, 0);
        }
    }
    catch (_e) { /* hash reading failure → palette doesn't open; click-fall-through is the click-and-press-/ degraded path */ }
})();
var _cmdSearchTimer = null;
function renderCommandResults(query) {
    const cmds = getCommands();
    const q = query.toLowerCase().trim();
    const filtered = q ? cmds.filter(c => c.label.toLowerCase().includes(q)) : cmds;
    const groups = {};
    filtered.forEach(c => { (groups[c.type] = groups[c.type] || []).push(c); });
    // Inject recent tickers when query is empty
    if (!q && _recentTickers.length > 0) {
        _recentTickers.forEach(r => {
            const d = getData(r.ticker);
            const company = d ? (d.company || '') : '';
            (groups['recent'] = groups['recent'] || []).push({
                type: 'recent', label: `${r.ticker}${company ? ' — ' + company : ''}`,
                hint: _relativeTime(r.ts), action: () => switchTicker(r.ticker)
            });
        });
    }
    // Demo mode: match against DEMO_DATA keys client-side
    if (q && typeof DEMO_DATA !== 'undefined' && !isLive) {
        Object.keys(DEMO_DATA).forEach(sym => {
            if (sym.toLowerCase().includes(q) || (DEMO_DATA[sym].company || '').toLowerCase().includes(q)) {
                const d = DEMO_DATA[sym];
                if (!groups['ticker']?.some(c => c.label.startsWith(sym))) {
                    (groups['ticker'] = groups['ticker'] || []).push({
                        type: 'ticker', label: `${sym}${d.company ? ' — ' + d.company : ''}`,
                        hint: 'demo', action: () => { addTickerBySymbol(sym); }
                    });
                }
            }
        });
    }
    // If query has 2+ chars and few/no ticker matches, trigger live search
    const hasTickerMatches = (groups['ticker'] || []).length > 0;
    if (q && q.length >= 2 && isLive) {
        clearTimeout(_cmdSearchTimer);
        // NM3 (2026-05-07): show a "searching" spinner immediately so the
        // user has feedback during the 300ms debounce + 4-way fan-out.
        // Pre-fix the palette went silent for ~500ms-1s while the live
        // search fetched. Spinner is removed when results render.
        _cmdSetSearchingState(true);
        _cmdSearchTimer = setTimeout(() => _cmdLiveSearch(q), 300);
    }
    else {
        _cmdSetSearchingState(false);
    }
    _renderCommandGroups(groups);
}
// NM3: small spinner indicator wired in/out of the cmd-results header.
// Idempotent: safe to call repeatedly with the same value.
function _cmdSetSearchingState(searching) {
    const el = document.getElementById('cmd-results');
    if (!el)
        return;
    let chip = document.getElementById('cmd-search-spinner');
    if (searching) {
        if (!chip) {
            chip = document.createElement('div');
            chip.id = 'cmd-search-spinner';
            chip.className = 'cmd-search-spinner';
            chip.setAttribute('role', 'status');
            chip.setAttribute('aria-live', 'polite');
            chip.textContent = 'Searching live data…';
            el.parentNode?.insertBefore(chip, el);
        }
    }
    else if (chip) {
        chip.remove();
    }
}
function _renderCommandGroups(groups) {
    const typeLabels = {
        recent: 'RECENT TICKERS',
        view: 'VIEWS',
        ticker: 'TICKERS',
        action: 'ACTIONS',
        search: 'ADD NEW TICKER',
        company: 'COMPANIES',
        borrower: 'BDC BORROWERS',
        filer: '13F FILERS',
        news: 'NEWS HEADLINES',
    };
    // Ordering balances "least-keystrokes-to-act" against the typical
    // user query (recent + add-new-ticker first, then organic fuzzy
    // matches across the rest of the platform).
    const typeOrder = ['recent', 'search', 'company', 'borrower', 'filer', 'news', 'view', 'action', 'ticker'];
    let html = '';
    let globalIdx = 0;
    const sortedEntries = Object.entries(groups).sort((a, b) => {
        const ai = typeOrder.indexOf(a[0]), bi = typeOrder.indexOf(b[0]);
        return (ai === -1 ? 99 : ai) - (bi === -1 ? 99 : bi);
    });
    for (const [type, items] of sortedEntries) {
        html += `<div class="cmd-category">${typeLabels[type] || type.toUpperCase()}</div>`;
        items.forEach(c => {
            const sel = globalIdx === cmdSelectedIdx ? ' selected' : '';
            html += `<div class="cmd-item${sel}" data-action="cmd-execute" data-idx="${globalIdx}">
        <span class="cmd-item-label">${escHtml(c.label)}</span>
        ${c.hint ? `<span class="cmd-item-hint">${escHtml(c.hint)}</span>` : ''}
      </div>`;
            globalIdx++;
        });
    }
    if (globalIdx === 0)
        html = '<div class="search-no-results">No results — searching...</div>';
    const _cmdResults = document.getElementById('cmd-results');
    if (_cmdResults) {
        _cmdResults.innerHTML = html;
        _cmdResults._filtered = sortedEntries.flatMap(([, items]) => items);
    }
}
// Helper: fetch + JSON-parse with timeout, swallowing errors. Returns
// `fallback` (default `null`) on any failure so Promise.all can complete
// even when one endpoint is rate-limited / 404 / 5xx.
function _cmdSafeFetch(url, fallback) {
    if (typeof fallback === 'undefined')
        fallback = null;
    return fetch(url, { signal: AbortSignal.timeout(5000) })
        .then(r => r.ok ? r.json() : fallback)
        .catch(() => fallback);
}
async function _cmdLiveSearch(q) {
    // Unified search (P1, 2026-04-24): query 4 endpoints in parallel and
    // merge results into typed categories. The returned categories are:
    //   'search'   — ticker symbols (from /api/ticker-search, the original)
    //   'company'  — company-name fuzzy matches (from /api/company/search)
    //   'borrower' — BDC portfolio companies (from /api/bdc/autocomplete)
    //   'news'     — news headlines mentioning the query (from /api/news/search)
    //
    // ROADMAP P1 — "high user-retention signal" Board finding. Replaces
    // the prior single-endpoint /api/ticker-search call.
    if (!cmdOpen)
        return;
    try {
        // NH1 (2026-05-07): one HTTP call to /api/search/all instead of
        // 4 parallel fetches. Server-side fan-out via asyncio.gather +
        // per-bucket failure isolation. Saves 3 connection setups on
        // mobile + collapses 4 rate-limit tokens to 1 + emits one
        // observability log line instead of 4 correlated ones.
        // Fallback: if the endpoint is unreachable (404/5xx), the
        // _cmdSafeFetch fallback gives us empty buckets so the local
        // command list still renders correctly.
        const unifiedRes = await _cmdSafeFetch(`${SERVER}/api/search/all?q=${encodeURIComponent(q)}&limit=5`, { tickers: [], companies: [], borrowers: [], news: [], filers: [] });
        const tickerRes = (unifiedRes && unifiedRes.tickers) || [];
        const companyRes = { results: (unifiedRes && unifiedRes.companies) || [] };
        const borrowerRes = { results: (unifiedRes && unifiedRes.borrowers) || [] };
        const newsRes = { results: (unifiedRes && unifiedRes.news) || [] };
        const filerResults = (unifiedRes && Array.isArray(unifiedRes.filers)) ? unifiedRes.filers : [];
        // Re-get current state and append search results
        const currentQuery = (document.getElementById('cmd-input')?.value || '').toLowerCase().trim();
        if (currentQuery !== q || !cmdOpen)
            return; // Query changed, discard
        const cmds = getCommands();
        const filtered = cmds.filter(c => c.label.toLowerCase().includes(q));
        const groups = {};
        filtered.forEach(c => { (groups[c.type] = groups[c.type] || []).push(c); });
        // ── Tickers (ADD NEW TICKER) ──
        const existingSyms = new Set([...tickers, ...PORTFOLIO_TICKERS]);
        const tickerResults = Array.isArray(tickerRes) ? tickerRes : [];
        const tickerSyms = new Set(tickerResults.map(r => (r.symbol || '').toUpperCase()));
        tickerResults.forEach(r => {
            const sym = r.symbol;
            // Wave-5 QA (2026-07-17): Morningstar-style 0P… internal identifiers
            // (0P0001ISKL.L, 0P0000GBDS.BO) surface with name === symbol — index
            // noise no human searches for. Skip when there's no real name.
            if (/^0P[0-9A-Z]/.test(sym || '') && (!r.name || r.name === sym))
                return;
            const inSession = existingSyms.has(sym);
            (groups['search'] = groups['search'] || []).push({
                type: 'search',
                label: `${sym}${r.name ? ' — ' + r.name : ''}`,
                hint: inSession ? 'already added' : (r.exchange || '+ add'),
                action: () => { addTickerBySymbol(sym); }
            });
        });
        // ── Company name matches (dedupe vs ticker results) ──
        const companyResults = (companyRes && Array.isArray(companyRes.results)) ? companyRes.results : [];
        companyResults.forEach(r => {
            const sym = (r.ticker || '').toUpperCase();
            if (!sym || tickerSyms.has(sym))
                return; // already in ticker list
            (groups['company'] = groups['company'] || []).push({
                type: 'company',
                label: `${sym}${r.name ? ' — ' + r.name : ''}`,
                hint: r.sector || 'open',
                action: () => { addTickerBySymbol(sym); }
            });
        });
        // ── BDC borrower matches ──
        const borrowerResults = (borrowerRes && Array.isArray(borrowerRes.results)) ? borrowerRes.results : [];
        borrowerResults.slice(0, 5).forEach(b => {
            const name = b.borrowerName || b.name || (typeof b === 'string' ? b : '');
            if (!name)
                return;
            (groups['borrower'] = groups['borrower'] || []).push({
                type: 'borrower',
                label: name,
                hint: 'BDC borrower',
                action: () => {
                    setView('bdc');
                    setTimeout(() => {
                        const inp = document.getElementById('bdc-borrower-input');
                        if (inp) {
                            inp.value = name;
                            if (typeof bdcSearchBorrower === 'function')
                                bdcSearchBorrower();
                        }
                    }, 200);
                }
            });
        });
        // ── 13F institutional-filer matches ──
        // Each hit carries a ready-to-navigate /13f/<cik>-<slug> path (server-built),
        // so selecting one jumps straight to the filer's ownership page.
        filerResults.slice(0, 5).forEach(f => {
            const name = f.fund_name || '';
            const path = f.path || '';
            if (!name || !path)
                return;
            (groups['filer'] = groups['filer'] || []).push({
                type: 'filer',
                label: name,
                hint: '13F filer',
                action: () => { window.location.href = path; }
            });
        });
        // ── News headline matches ──
        const newsItems = (newsRes && Array.isArray(newsRes.results)) ? newsRes.results
            : (newsRes && Array.isArray(newsRes.items)) ? newsRes.items
                : [];
        newsItems.slice(0, 4).forEach(a => {
            const title = a.headline || a.title || '';
            if (!title)
                return;
            // Wave-5 QA (2026-07-17): some /api/search/all news rows carry ticker
            // entries as OBJECTS ({symbol,...}) — template-stringifying one painted
            // an "[object Object]" badge in the dropdown (observed live). Accept
            // only string symbols, unwrapping the common object shapes first.
            // N1 (QA 2026-10-05): never tickers[0] (ticker-ordered: AAPL on an Nvidia
            // story). news.ts's picker when its chunk is loaded; else primary or a lone ticker.
            const _tks = Array.isArray(a.tickers) ? a.tickers : [];
            const _pick = window._newsDisplayTicker;
            let _tRaw = a.ticker || (typeof _pick === 'function' ? _pick(title, _tks)
                : (_tks.find((t) => t && t.isPrimary) || (_tks.length === 1 ? _tks[0] : ''))) || '';
            if (_tRaw && typeof _tRaw === 'object')
                _tRaw = _tRaw.symbol || _tRaw.ticker || '';
            const ticker = typeof _tRaw === 'string' ? _tRaw : '';
            (groups['news'] = groups['news'] || []).push({
                type: 'news',
                label: title.length > 80 ? title.slice(0, 77) + '...' : title,
                hint: ticker || 'news',
                action: () => {
                    setView('news');
                    // Best-effort: pre-fill the news search input with the query
                    setTimeout(() => {
                        const inp = document.getElementById('news-search-input');
                        if (inp) {
                            inp.value = q;
                            if (typeof searchNews === 'function')
                                searchNews();
                        }
                    }, 200);
                }
            });
        });
        _renderCommandGroups(groups);
    }
    catch (e) {
        // NM1 (2026-05-07): bind + log instead of silent swallow. The
        // upstream Promise.all wraps each fetch in _cmdSafeFetch which
        // already returns a fallback on failure, so this catch only
        // fires for *unexpected* errors (parse failures, render bugs).
        // Silent swallow hid those for ~6 months. Now: console.warn for
        // dev visibility + Sentry breadcrumb for prod telemetry.
        if (typeof console !== 'undefined' && console.warn) {
            console.warn('[cmd-palette] live search render failed:', e);
        }
        try {
            const _w = window;
            if (_w.Sentry && typeof _w.Sentry.addBreadcrumb === 'function') {
                _w.Sentry.addBreadcrumb({
                    category: 'cmd-palette',
                    level: 'warning',
                    message: 'live_search_render_failed',
                    data: { error: e?.message || String(e) },
                });
            }
        }
        catch (_inner) { /* breadcrumb best-effort */ }
    }
    finally {
        _cmdSetSearchingState(false);
    }
}
// Helper: add ticker by symbol (from command palette search)
function addTickerBySymbol(sym) {
    // 2026-09-26 (external review P1-12): validated BEFORE renderTabs, which puts
    // the symbol into a data-ticker attribute; switchTicker re-checks it anyway.
    sym = (typeof olNormalizeTicker === 'function') ? olNormalizeTicker(sym) : String(sym || '').trim().toUpperCase();
    if (!sym)
        return;
    // No ticker cap on any tier (OWNER 2026-09-24, SF-MONETIZATION-V3: the
    // browser-only free caps were removed, Learner included).
    if (!tickers.includes(sym))
        tickers.push(sym);
    renderTabs();
    switchTicker(sym); // routes through shared navigation + _trackRecentTicker
    // Achievement: first ticker + unique ticker tracking + international
    if (typeof trackAchievement === 'function')
        trackAchievement('first_ticker');
    var _uniqueTickers = OLStorage.get('ol_unique_tickers', []);
    if (_uniqueTickers.indexOf(sym) < 0) {
        _uniqueTickers.push(sym);
        OLStorage.set('ol_unique_tickers', _uniqueTickers);
    }
    if (typeof setAchievement === 'function')
        setAchievement('fifty_analyses', _uniqueTickers.length);
    if (sym && /\.[A-Z]{1,2}$/.test(sym)) {
        if (typeof trackAchievement === 'function')
            trackAchievement('international');
    }
}
function cmdExecute(idx) {
    const filtered = document.getElementById('cmd-results')?._filtered || [];
    if (filtered[idx]) {
        filtered[idx].action();
        closeCommandPalette();
        // Achievement: command palette — only track when user actually selects an item
        if (typeof trackAchievement === 'function')
            trackAchievement('cmd_palette');
        if (typeof trackAchievement === 'function')
            trackAchievement('cmd_palette_uses');
    }
}
document.getElementById('cmd-input')?.addEventListener('input', e => renderCommandResults(e.target.value));
document.getElementById('cmd-input')?.addEventListener('keydown', e => {
    const filtered = document.getElementById('cmd-results')?._filtered || [];
    if (e.key === 'ArrowDown') {
        e.preventDefault();
        cmdSelectedIdx = Math.min(cmdSelectedIdx + 1, filtered.length - 1);
        renderCommandResults(e.target.value);
    }
    else if (e.key === 'ArrowUp') {
        e.preventDefault();
        cmdSelectedIdx = Math.max(cmdSelectedIdx - 1, 0);
        renderCommandResults(e.target.value);
    }
    else if (e.key === 'Enter') {
        e.preventDefault();
        cmdExecute(cmdSelectedIdx);
    }
    else if (e.key === 'Escape') {
        closeCommandPalette();
    }
});
// #109 (2026-06-03): cmd-item hover-select was an inline onmouseenter="..."
// (CSP script-src 'self' blocks inline handlers). Delegate via mouseover on the
// results container; act only when entering a NEW item (mouseenter-like) to
// avoid re-render spam. The click is still data-action="cmd-execute".
document.getElementById('cmd-results')?.addEventListener('mouseover', e => {
    const el = e.target && e.target.closest ? e.target.closest('.cmd-item[data-idx]') : null;
    if (!el)
        return;
    const idx = parseInt(el.getAttribute('data-idx'), 10);
    if (isNaN(idx) || idx === cmdSelectedIdx)
        return;
    cmdSelectedIdx = idx;
    const ci = document.getElementById('cmd-input');
    renderCommandResults(ci ? ci.value : '');
});
// ── KEYBOARD SHORTCUTS MODAL ──
var _kbFocusTrapCleanup = null;
var _kbTriggerEl = null;
function toggleKbModal() {
    // N7 (mobile audit 2026-09-25): the "Keyboard shortcuts" button lives INSIDE
    // the Settings drawer, and the drawer (--z-settings 10020) outranks this
    // modal (--z-modal-2 10001), so opening from there painted the modal BEHIND
    // the drawer -- a silent dead control. Close the drawer before opening (never
    // re-rank the z ladder; tools/check_css_zindex_ladder.py gates it). Done
    // synchronously, before the materialize hop, so `_kbTriggerEl` below records
    // the drawer's own opener -- the element the drawer just returned focus to --
    // and closing the modal lands the reader back on the topbar gear.
    var _kbOv0 = document.getElementById('kb-modal-overlay');
    if (!(_kbOv0 && _kbOv0.classList.contains('open')))
        _olCloseSettingsPanel();
    _materializeView('kb-modal-overlay').then(function () {
        const overlay = document.getElementById('kb-modal-overlay');
        if (!overlay)
            return;
        const wasOpen = overlay.classList.contains('open');
        if (!wasOpen)
            _kbTriggerEl = document.activeElement;
        overlay.classList.toggle('open');
        // Enable single-letter shortcuts once user discovers the shortcuts modal
        if (!wasOpen) {
            try {
                OLStorage.setString('ol_shortcuts_discovered', '1');
            }
            catch (e) { }
        }
        // Activate/deactivate focus trap (B-29)
        if (!wasOpen && typeof trapFocus === 'function') {
            _kbFocusTrapCleanup = trapFocus(overlay);
        }
        else if (wasOpen && _kbFocusTrapCleanup) {
            _kbFocusTrapCleanup();
            _kbFocusTrapCleanup = null;
            // Return focus to trigger element
            if (_kbTriggerEl) {
                try {
                    _kbTriggerEl.focus();
                }
                catch (e) { }
                _kbTriggerEl = null;
            }
        }
    });
}
document.addEventListener('click', (e) => {
    const overlay = document.getElementById('kb-modal-overlay');
    if (overlay && overlay.classList.contains('open') && e.target === overlay)
        toggleKbModal();
});
// ── KEYBOARD SHORTCUTS ──
document.addEventListener('keydown', e => {
    // Command palette takes priority
    if ((e.ctrlKey || e.metaKey) && e.key === 'k') {
        e.preventDefault();
        if (cmdOpen)
            closeCommandPalette();
        else
            openCommandPalette();
        return;
    }
    if ((e.ctrlKey || e.metaKey) && e.key === 'p') {
        e.preventDefault();
        if (typeof exportTickerPDF === 'function')
            exportTickerPDF();
        return;
    }
    if ((e.ctrlKey || e.metaKey) && e.shiftKey && (e.key === 'c' || e.key === 'C')) {
        e.preventDefault();
        if (typeof toggleCustomChartBuilder === 'function')
            toggleCustomChartBuilder();
        return;
    }
    // Don't intercept when typing in inputs/textareas
    if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA' || e.target.isContentEditable)
        return;
    const key = e.key;
    // Single-letter shortcuts only active after user discovers them (opens ? modal or selects Advanced)
    // Number keys (1-8), /, ?, Escape, arrows always work regardless
    const _letterShortcutsEnabled = OLStorage.getString('ol_shortcuts_discovered', null) === '1';
    const isLetterKey = /^[a-zA-Z]$/.test(key);
    // F4 (CHAOS 2026-09-28): K is the documented door to YOUR API KEYS (the
    // bottom-bar key icon went with the bar; /mcp, /api-docs, llms.txt and the
    // MCP refusals all say "press K"), so like `?` it works for everyone, not
    // only after the shortcut modal was opened once.
    if (isLetterKey && !_letterShortcutsEnabled && key !== '?' && key !== 'k')
        return;
    _track('keyboard', { key });
    // Achievement: track unique keyboard shortcuts used
    var _usedShortcuts = OLStorage.get('ol_used_shortcuts', []);
    if (_usedShortcuts.indexOf(key) < 0) {
        _usedShortcuts.push(key);
        OLStorage.set('ol_used_shortcuts', _usedShortcuts);
    }
    if (typeof setAchievement === 'function')
        setAchievement('keyboard_shortcuts', _usedShortcuts.length);
    if (typeof setAchievement === 'function')
        setAchievement('shortcuts_used', _usedShortcuts.length);
    // View shortcuts: 1-8 (matches tab order left to right)
    if (key === '1') {
        e.preventDefault();
        setView('macro');
    } // LIVE
    else if (key === '2') {
        e.preventDefault();
        setView('news');
    } // NEWS
    else if (key === '3') {
        e.preventDefault();
        setView('ticker');
    } // TICKER
    else if (key === '4') {
        e.preventDefault();
        setView('portfolio');
    } // PORTFOLIO
    else if (key === '5') {
        e.preventDefault();
        setView('watchlist');
    } // WATCHLIST
    else if (key === '6') {
        e.preventDefault();
        setView('learn');
    } // LEARN
    else if (key === '7') {
        e.preventDefault();
        setView('screener');
    } // SCREENER
    else if (key === '8') {
        e.preventDefault();
        setView('fundamentals');
    } // FUNDAMENTALS
    else if (key === 'f' || key === 'F') {
        e.preventDefault();
        setView('fundamentals');
    }
    else if (key === 's' || key === 'S') {
        e.preventDefault();
        setView('screener');
    }
    else if (key === 'e' || key === 'E') {
        e.preventDefault();
        setView('etf-screener');
    }
    else if (key === 'b' || key === 'B') {
        e.preventDefault();
        setView('bdc');
    }
    else if (key === 'u' || key === 'U') {
        e.preventDefault();
        setView('usage');
    }
    else if (key === 'n' || key === 'N') {
        e.preventDefault();
        setView('news');
    }
    else if (key === 't' || key === 'T') {
        e.preventDefault();
        setView('ticker');
    }
    else if (key === 'w' || key === 'W') {
        e.preventDefault();
        setView('watchlist');
    }
    else if (key === 'l' || key === 'L') {
        e.preventDefault();
        setView('learn');
    }
    // Q to open Quick Compare modal (was C, but that blocks Ctrl+C copy)
    else if (key === 'q' || key === 'Q') {
        e.preventDefault();
        if (_cmpOpen) {
            if (typeof closeCompareModal === 'function')
                closeCompareModal();
        }
        else {
            if (typeof openCompareModal === 'function')
                openCompareModal();
            if (typeof trackAchievement === 'function')
                trackAchievement('comparisons_run');
        }
    }
    // / to open command palette (unified search)
    else if (key === '/') {
        e.preventDefault();
        openCommandPalette();
    }
    // R to refresh current ticker
    else if (key === 'r' || key === 'R') {
        e.preventDefault();
        refreshCurrent();
    }
    // Escape to close modals / blur focused input (B-27)
    // First, delegate to the _modalEscapeStack for any dynamically-registered overlays.
    // handleModalEscape() iterates the stack highest-priority first, closes the topmost
    // visible overlay, and returns true so we can bail out immediately.
    else if (key === 'Escape') {
        if (typeof handleModalEscape === 'function' && handleModalEscape()) {
            e.preventDefault();
            return;
        }
        // N8 (mobile audit 2026-09-25): the Settings drawer is a role="dialog"
        // aria-modal="true" surface at the top of the z ladder (--z-settings) and
        // was never in this chain -- Escape fell through to whatever sat under it.
        // The helper returns false when the drawer is closed, so nothing below
        // moves when it is not the topmost surface.
        if (_olCloseSettingsPanel()) {
            e.preventDefault();
            return;
        }
        // Welcome overlay — not on escape stack yet, handled explicitly
        var welcomeOv = document.getElementById('welcome-overlay');
        if (welcomeOv && welcomeOv.classList.contains('open')) {
            if (typeof _dismissWelcome === 'function')
                _dismissWelcome('expert', 'macro');
            else
                welcomeOv.classList.remove('open');
            return;
        }
        // Auth modal / dropdown
        var authOv = document.getElementById('auth-modal-overlay');
        if (authOv && authOv.classList.contains('open')) {
            authCloseModal();
            return;
        }
        var authDd = document.getElementById('auth-dropdown');
        if (authDd && authDd.classList.contains('open')) {
            authCloseDropdown();
            return;
        }
        // Flag-based panels. typeof guards: these flags live in lazy
        // chunks (ask-ai.js, api-keys.js, compare-modal.js) that may not
        // have loaded yet when the user presses Escape. A bare reference
        // throws ReferenceError at the cross-chunk boundary.
        if (typeof _askAiOpen !== 'undefined' && _askAiOpen) {
            if (typeof toggleAskAiPanel === 'function')
                toggleAskAiPanel();
            return;
        }
        if (typeof _apiKeysPanelOpen !== 'undefined' && _apiKeysPanelOpen) {
            if (typeof toggleApiKeysPanel === 'function')
                toggleApiKeysPanel();
            return;
        }
        if (typeof _cmpOpen !== 'undefined' && _cmpOpen) {
            if (typeof closeCompareModal === 'function')
                closeCompareModal();
            return;
        }
        // DOM-state modals not yet on the stack
        var cfm = document.getElementById('company-facts-modal');
        if (cfm && cfm.classList.contains('visible')) {
            cfm.classList.remove('visible');
            return;
        }
        var kbOv = document.getElementById('kb-modal-overlay');
        if (kbOv && kbOv.classList.contains('open')) {
            toggleKbModal();
            return;
        }
        var cmdPal = document.getElementById('command-palette');
        if (cmdPal && cmdPal.classList.contains('open')) {
            cmdPal.classList.remove('open');
            return;
        }
        var cbOv2 = document.getElementById('comps-builder-overlay');
        if (cbOv2 && cbOv2.classList.contains('open')) {
            closeCompsBuilder();
            return;
        }
        var cbOv = document.querySelector('.cb-modal-overlay');
        if (cbOv) {
            cbOv.remove();
            return;
        }
        var glossModal = document.getElementById('gloss-modal');
        if (glossModal && glossModal.classList.contains('open')) {
            glossModal.classList.remove('open');
            return;
        }
        var glossBook = document.getElementById('gloss-book-overlay');
        if (glossBook && glossBook.classList.contains('open')) {
            glossBook.classList.remove('open');
            return;
        }
        var onboardOv = document.getElementById('onboard-modal-overlay');
        if (onboardOv && !onboardOv.classList.contains('hidden')) {
            onboardOv.classList.add('hidden');
            return;
        }
        var cbPanel = document.getElementById('custom-chart-panel');
        if (cbPanel && !cbPanel.classList.contains('hidden')) {
            if (typeof toggleCustomChartBuilder === 'function')
                toggleCustomChartBuilder();
            return;
        }
        // N4 (mobile audit 2026-09-25): the practice overlay had no branch here --
        // its only exits were the Settings drawer row, the sidecar row, a
        // dismissable FAB and the `P` key. Last in the chain on purpose: it is the
        // lowest surface in the ladder (--z-dropdown), so every modal above it
        // closes first.
        // CHAOS 2026-09-25: ~20 surfaces close from their OWN Escape listeners
        // without stopping the key. Exit practice only when nothing else owned it:
        // an earlier listener marks defaultPrevented; a later one's surface is
        // still on screen right now. Contract:
        // tests/test_chaos_practice_escape_ownership_2026_09_25_contract.py
        if (!e.defaultPrevented && !_olOtherDialogOnScreen() && _exitPracticeMode()) {
            e.preventDefault();
            return;
        }
        // Fallback: blur any focused input
        if (document.activeElement)
            document.activeElement.blur();
    }
    // ? to toggle shortcuts modal
    else if (key === '?') {
        e.preventDefault();
        toggleKbModal();
    }
    // D = cycle density mode (I-26); Shift+D = discover random ticker
    else if (key === 'D' && e.shiftKey) {
        e.preventDefault();
        randomTicker();
    }
    else if ((key === 'd' || key === 'D') && !e.shiftKey) {
        e.preventDefault();
        _cycleDensityWithToast();
    }
    // P = toggle practice mode
    else if (key === 'p' || key === 'P') {
        e.preventDefault();
        if (typeof togglePracticeMode === 'function')
            togglePracticeMode();
    }
    // K = toggle API keys panel
    // K = YOUR API KEYS, through the same delegated action as every other door:
    // it loads the premium chunk when api-keys.js is not loaded yet (a bare
    // toggleApiKeysPanel() call was a silent no-op before that chunk).
    else if (key === 'k') {
        e.preventDefault();
        if (typeof _delegatedActions !== 'undefined' && typeof _delegatedActions['toggle-api-keys-panel'] === 'function')
            _delegatedActions['toggle-api-keys-panel'](e);
    }
    // A = toggle Ask AI panel
    else if (key === 'a') {
        e.preventDefault();
        if (typeof toggleAskAiPanel === 'function')
            toggleAskAiPanel();
        else
            _loadChunk('premium').then(function () { if (typeof toggleAskAiPanel === 'function')
                toggleAskAiPanel(); });
    }
    // G = toggle research mode (ticker view only)
    else if (key === 'g' || key === 'G') {
        if (currentView === 'ticker') {
            e.preventDefault();
            toggleResearchMode();
        }
    }
    // Left/Right arrow to switch tickers
    else if (key === 'ArrowLeft' || key === 'ArrowRight') {
        const idx = tickers.indexOf(activeTicker);
        if (idx >= 0) {
            const next = key === 'ArrowRight' ? (idx + 1) % tickers.length : (idx - 1 + tickers.length) % tickers.length;
            switchTicker(tickers[next]);
        }
    }
});
// ── LEDGE-FACT ROTATION (top strip, primary content, static) ──
// 2026-07-21 FACTS-PRIMARY (OWNER): the Ledge Fact ticker is the PRIMARY
// content of the top strip (#pulse-fact-region) — moved back from the bottom
// bar (#pulse-footer-fact, removed). Facts rotate every ~15s with a gentle
// opacity crossfade; since 2026-09-03 (OWNER) an OVERFLOWING fact ping-pong
// scrolls so its tail is readable -- short facts stay static. Only the hot shard is fetched (150KB, ~1,300 entries) —
// the 1.78MB rest shard was dropped entirely as item #3 cleanup in S47.
var _PULSE_TIPS = [];
var _pulseStripIdx = 0;
function _shufflePulseTips() {
    for (let i = _PULSE_TIPS.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        const tmp = _PULSE_TIPS[i];
        _PULSE_TIPS[i] = _PULSE_TIPS[j];
        _PULSE_TIPS[j] = tmp;
    }
}
// >>> ledge-fact-pace -- sliced out and EXECUTED under node by
// tests/test_ledge_fact_scroll_pace_contract.py (the full measurement lives
// there); keep it self-contained: window / document / setTimeout only.
// OWNER 2026-10-19 ("scrolls far too fast on mobile"): the old 14s cycle cap
// existed only to fit the fixed 15s rotation, so a 427-588px mobile overflow
// travelled at 53-72 px/s vs ~30 on desktop. Now the pace is fixed and the
// rotation waits for the scroll. The 09-05 keyframe shape stays in CSS (the
// cycle follows from distance, so holds scale with the fact; CSS-only keeps
// the strict CSP and the reduced-motion opt-out where they were).
var LEDGE_FACT_SCROLL_PX_PER_S = 30; // forward-leg reading pace on every viewport
// Mirrors @keyframes pf-fact-scroll (hold 0-14%, travel 14-72%, tail hold
// 72-92%, rewind); the contract fails if CSS and these stop agreeing.
var LEDGE_FACT_TRAVEL_START = 0.14;
var LEDGE_FACT_TRAVEL_END = 0.72;
var LEDGE_FACT_TAIL_END = 0.92;
var LEDGE_FACT_MIN_CYCLE_S = 6; // the 09-03 floor: a barely-overflowing fact keeps readable holds
var LEDGE_FACT_ROTATE_MS = 15000; // static facts and reduced motion (since 07-21)
/** Cycle (s) that moves `overflowPx` at the reading pace. No cap. */
function _ledgeFactCycleS(overflowPx) {
    var travelS = overflowPx / LEDGE_FACT_SCROLL_PX_PER_S;
    return Math.max(LEDGE_FACT_MIN_CYCLE_S, travelS / (LEDGE_FACT_TRAVEL_END - LEDGE_FACT_TRAVEL_START));
}
/** Delay (ms) before the next fact (cycleS null = static / reduced motion).
 *  Always past the first forward pass + tail hold; later, 15s stands unless it
 *  lands mid-travel, then that loop's tail hold -- never a cut mid-read. */
function _ledgeFactRotateDelayMs(cycleS) {
    if (!cycleS || !(cycleS > 0))
        return LEDGE_FACT_ROTATE_MS;
    var baseS = LEDGE_FACT_ROTATE_MS / 1000;
    var firstTailEndS = LEDGE_FACT_TAIL_END * cycleS;
    if (baseS <= firstTailEndS)
        return Math.ceil(firstTailEndS * 1000);
    var loop = Math.floor(baseS / cycleS);
    var phase = baseS / cycleS - loop;
    if (phase > LEDGE_FACT_TRAVEL_START && phase < LEDGE_FACT_TRAVEL_END) {
        return Math.ceil((loop + LEDGE_FACT_TAIL_END) * cycleS * 1000);
    }
    return LEDGE_FACT_ROTATE_MS;
}
function _ledgeFactReducedMotion() {
    try {
        return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    }
    catch (_e) {
        return false; // no matchMedia: motion allowed; the CSS still governs the animation
    }
}
/** Self-scheduling rotation (replaced the fixed setInterval 2026-10-19).
 *  `store` keeps the ONE pending handle so the double-init guard can clear it. */
function _ledgeFactRotateChain(showNext, currentCycleS, store) {
    var delayMs = _ledgeFactRotateDelayMs(_ledgeFactReducedMotion() ? null : currentCycleS());
    store(setTimeout(function () {
        try {
            // P1-3 (2026-07-01 network-storm audit): skip the swap while the tab is
            // backgrounded -- but still reschedule (finally), or the chain strands.
            if (!document.hidden)
                showNext();
        }
        finally {
            _ledgeFactRotateChain(showNext, currentCycleS, store);
        }
    }, delayMs));
}
function _ledgeFactStartRotation(showNext, currentCycleS) {
    // F17 (2026-05-12 audit P2): double-init guard. A re-init (reload-router /
    // SPA re-route) could land here twice; the window slot always holds the
    // chain's one pending timer, so clearing it kills the prior chain.
    try {
        const _w = window;
        if (_w._footerFactRotateTimer)
            clearTimeout(_w._footerFactRotateTimer);
        _ledgeFactRotateChain(showNext, currentCycleS, function (h) { _w._footerFactRotateTimer = h; });
    }
    catch (_e) {
        // 2026-06-11 external review: this path must not stack a second rotator;
        // FE review 2026-07-19 P2: it runs the same chain, so the hidden guard holds.
        if (!showNext._fallbackTimer) {
            _ledgeFactRotateChain(showNext, currentCycleS, function (h) { showNext._fallbackTimer = h; });
        }
    }
}
// <<< ledge-fact-pace
// LH-2 (2026-06-23): pulse-facts-hot.json (~103 KB) was the single largest
// non-LCP payload on cold-anon ticker/news, and the prior fixed `setTimeout(…,
// 3000)` still landed INSIDE the Slow-4G LCP window (prod FCP 2.5s / LCP 5.9s),
// competing for throttled bandwidth with the LCP element. Defer to
// requestIdleCallback so it fires only once the thread goes idle (post-LCP/TTI),
// with a long setTimeout fallback for browsers without rIC. The footer fact is
// ambient chrome — populating it ~1s later is imperceptible.
var _deferPulseFacts = function (cb) {
    var w = window;
    if (typeof w.requestIdleCallback === 'function') {
        w.requestIdleCallback(cb, { timeout: 8000 });
    }
    else {
        setTimeout(cb, 6000);
    }
};
_deferPulseFacts(function () {
    fetch('/static/data/pulse-facts-hot.json').then(function (r) { return r.ok ? r.json() : null; }).then(function (facts) {
        if (!facts || !facts.length)
            return;
        _PULSE_TIPS = facts;
        _shufflePulseTips();
        // 2026-07-21 FACTS-PRIMARY: facts render in the TOP strip
        // (#pulse-fact-region), NOT the bottom-bar #pulse-footer-fact (removed).
        var _factRegion = document.getElementById('pulse-fact-region');
        if (_factRegion) {
            // Cycle (s) of the fact on screen, null when static (see ledge-fact-pace).
            var _factCycleS = null;
            function _showNextFact() {
                var tip = _PULSE_TIPS[_pulseStripIdx % _PULSE_TIPS.length];
                _pulseStripIdx++;
                // S47 fix: pulse-facts-hot.json is an array of bare strings, not
                // {text, type} objects — rendering was producing "LEDGE FACT
                // undefined". Accept both shapes for forward compat.
                var text, type;
                if (typeof tip === 'string') {
                    text = tip;
                    type = 'fact';
                }
                else if (tip && typeof tip === 'object') {
                    text = tip.text || '';
                    type = tip.type || 'fact';
                }
                else {
                    return; // malformed entry — skip silently
                }
                if (!text)
                    return;
                _factCycleS = null; // a new fact is about to replace the old one
                var label = type === 'quote' ? 'QUOTE' : 'FACT';
                // Build via DOM nodes (not innerHTML) so the strict CSP script/style
                // policy is unaffected and the text content can't smuggle markup.
                // The "LEDGE FACT/QUOTE" prefix reuses the shared .ledge-fact-label
                // convention (milestones-view / observatory pulse); the body is the
                // now-primary content. Short facts sit static; overflowing facts
                // scroll (OWNER 2026-09-03) -- see the scrollwrap block below.
                while (_factRegion.firstChild)
                    _factRegion.removeChild(_factRegion.firstChild);
                var labelEl = document.createElement('b');
                labelEl.className = 'ledge-fact-label';
                labelEl.textContent = 'LEDGE ' + label;
                _factRegion.appendChild(labelEl);
                _factRegion.appendChild(document.createTextNode(' '));
                var bodyEl = document.createElement('span');
                bodyEl.className = 'ledge-fact-body';
                bodyEl.textContent = text;
                // A long fact loses its tail: the region is overflow:hidden and the
                // mask-image fades the last 28px, so a sentence can stop mid-word
                // (MEASURED 2026-08-27 on prod: scrollWidth 814 vs clientWidth 725).
                // The 08-27 fix was `title`-only, honoring the 07-21 "remove the
                // scrolling text" ruling. OWNER 2026-09-03 ("LEDGE FACT still does
                // not have a scroll") updates that contract: an overflowing fact now
                // ping-pong scrolls so the whole sentence is readable in place. The
                // title stays -- it is the hover affordance AND the only one under
                // prefers-reduced-motion, where the CSS disables the animation.
                bodyEl.title = text;
                var wrapEl = document.createElement('span');
                wrapEl.className = 'ledge-fact-scrollwrap';
                wrapEl.appendChild(bodyEl);
                _factRegion.appendChild(wrapEl);
                // Overflow-gated: short facts stay perfectly static. Measure AFTER
                // insertion (widths are 0 before layout), pace by distance so long
                // facts do not sprint, and hand CSS the exact travel via a custom
                // property (inline style PROPERTY writes pass the strict CSP; only
                // injected <style> tags are blocked). 2026-10-19: the pace no longer
                // has a 14s cap (it made mobile sprint) -- see ledge-fact-pace.
                var _overflowPx = bodyEl.scrollWidth - wrapEl.clientWidth;
                if (_overflowPx > 8) {
                    _factCycleS = _ledgeFactCycleS(_overflowPx);
                    wrapEl.style.setProperty('--pf-scroll-dist', String(-_overflowPx - 8) + 'px');
                    wrapEl.style.setProperty('--pf-scroll-time', _factCycleS + 's');
                    wrapEl.classList.add('pf-scroll');
                }
                // Re-trigger the crossfade keyframe (a reflow read restarts it). The
                // keyframe is disabled under prefers-reduced-motion in CSS.
                _factRegion.classList.remove('pf-fade-in');
                void _factRegion.offsetWidth;
                _factRegion.classList.add('pf-fade-in');
            }
            _showNextFact();
            // F17 double-init guard, P1-3 hidden skip, catch-path fallback: ledge-fact-pace.
            _ledgeFactStartRotation(_showNextFact, function () { return _factCycleS; });
        }
    }).catch(function () { });
}); // deferred via _deferPulseFacts (requestIdleCallback) — see comment above
// renderMarketPulse — called by news.js and init to trigger pulse bar refresh
async function renderMarketPulse() {
    // Populate pulse-content with compact market data strip
    const el = document.getElementById('pulse-content');
    if (!el)
        return;
    // FACTS-PRIMARY + SLIM SURVIVORS (OWNER 2026-07-21): the market cluster
    // shows ONLY on the 5 market views AND only on desktop (>=720px, the
    // sanctioned DS-#73 desktop rung — kept in lock-step with the oxford.css
    // #pulse-content gate). On mobile and on every non-market view the top strip
    // is facts-only. CSS gates #pulse-content visually; this guard also skips the
    // /api/indicators fetch + DOM write on the excluded surfaces so they pay zero
    // cost. The facts region (#pulse-fact-region) is a separate element and
    // always renders.
    const _marketViews = { ticker: 1, portfolio: 1, watchlist: 1, macro: 1, screener: 1 };
    const _curView = (document.body && document.body.getAttribute('data-view')) || '';
    const _isDesktop = typeof window !== 'undefined' && window.innerWidth >= 720;
    if (!_marketViews[_curView] || !_isDesktop) {
        el.textContent = '';
        return;
    }
    // Use indicatorsCache from news.js if available, otherwise fetch
    let cache = (typeof indicatorsCache !== 'undefined' && indicatorsCache && Object.keys(indicatorsCache).length > 1) ? indicatorsCache : null;
    if (!cache) {
        try {
            // FE-AUDIT 2026-06-25: route through OLApi.getIndicators so this pulse-bar
            // fetch shares one in-flight request with the other cold-news indicators
            // callers (was 3× concurrent on a cold /?view=news load). Returns a cloned
            // Response, so the res.ok/res.json handling below is unchanged.
            const _sig = (typeof getViewAwareSignal === 'function' ? getViewAwareSignal(20000) : AbortSignal.timeout(20000));
            const _ola = window.OLApi;
            const res = (_ola && typeof _ola.getIndicators === 'function')
                ? await _ola.getIndicators({ signal: _sig })
                : await fetch((typeof SERVER !== 'undefined' ? SERVER : '') + '/api/indicators', { signal: _sig });
            if (res.ok) {
                cache = await res.json();
                if (typeof indicatorsCache !== 'undefined')
                    indicatorsCache = cache;
            }
        }
        catch (e) { /* silent — indicators may take time to warm up */ }
    }
    if (!cache || Object.keys(cache).length < 2) {
        // Show rotating fact strip only (no market data yet)
        el.textContent = '';
        return;
    }
    // S21-F: Extract 10yr Treasury rate for bond/BDC yield context.
    // Backend exposes treasuryRate10yr in the indicators response; cache it
    // globally so bdc-view.js and bond-screener.js can reference it for
    // risk-free rate comparisons without making separate API calls.
    if (cache.treasuryRate10yr != null) {
        window._treasuryRate10yr = cache.treasuryRate10yr;
        // OWNER ruling 2026-10-26: "fred" when the scalar was read through FRED
        // (routes_market_fastapi), so a surface quoting it can carry FRED's notice.
        window._treasuryRate10yrSource = cache.treasuryRate10yrSource || null;
    }
    // FACTS-PRIMARY slim cluster (OWNER 2026-07-21) — exactly THREE survivors
    // after backend commit e2bb153e fail-closed the third-party FRED series
    // (ICE HY/IG credit spreads + CBOE VIX) off /api/indicators: equity (S&P
    // 500, GSPC, via SPY proxy when the index level is unavailable), rates
    // (10-Yr Treasury yield, US10Y), commodity (Gold, GLD). US10Y is a
    // treasury.gov yield item (the dead TLH key never rendered). VIXY and HY
    // OAS (BAMLH0A0HYM2) were dropped WITH the fail-close, so the OAS/bps +
    // invert-color branches went with them.
    const keySymbols = ['GSPC', 'US10Y', 'GLD'];
    // Honest-labeling rule (user_trust, BOARD CYCLE 2026-05-22 P2): never label
    // an ETF proxy as its index. When the S&P index level is unavailable we quote
    // the SPY ETF and relabel it "SPY" (below). GLD is likewise an ETF share
    // price, NOT spot gold $/oz — the ticker label is the honest one.
    const shortNames = { 'DJI': 'DOW', 'GSPC': 'S&P', 'IXIC': 'NDQ', 'US10Y': '10Y', 'USO': 'OIL', 'GLD': 'GLD', 'BINANCE:BTCUSDT': 'BTC' };
    // Fallback: if FMP index data unavailable, map GSPC to its SPY ETF proxy and
    // relabel (ETF price != index value — honest label, not a multiplied guess).
    const _etfFallback = { 'DJI': 'DIA', 'GSPC': 'SPY', 'IXIC': 'QQQ' };
    const _etfProxyLabel = { 'DJI': 'DIA', 'GSPC': 'SPY', 'IXIC': 'QQQ' };
    // Flatten all indicator groups to find our key symbols
    const allItems = [];
    for (const [group, items] of Object.entries(cache)) {
        if (!Array.isArray(items))
            continue;
        items.forEach(item => allItems.push(item));
    }
    let html = '';
    const pulseSepAfter = new Set([0, 1]); // divide the 3 asset classes: S&P | 10Y | GLD
    const nonEquitySymbols = new Set(['US10Y', 'USO', 'GLD', 'BINANCE:BTCUSDT']);
    for (let ki = 0; ki < keySymbols.length; ki++) {
        const sym = keySymbols[ki];
        var item = allItems.find(i => i.symbol === sym);
        var _usingEtfProxy = false;
        // Fallback to ETF proxy if real index data not available
        if ((!item || !item.price) && _etfFallback[sym]) {
            item = allItems.find(i => i.symbol === _etfFallback[sym]);
            if (item && item.price)
                _usingEtfProxy = true;
        }
        if (!item || !item.price)
            continue;
        const chg = item.changePct || 0;
        const cls = chg > 0 ? 'pos' : chg < 0 ? 'neg' : '';
        const sign = chg >= 0 ? '+' : '';
        var name = shortNames[sym] || item.name || sym;
        var displayPrice = item.price;
        // When using ETF proxy, show ETF ticker instead of index name
        if (_usingEtfProxy && _etfProxyLabel[sym]) {
            name = _etfProxyLabel[sym];
        }
        var priceStr;
        var chgHtml = '';
        var titleStr = item.name || sym;
        if (item.isYield) {
            // #88: Treasury yield item (US10Y) \u2014 price IS the yield in %. The 1-day
            // move is expressed in BASIS POINTS (changeBps) per the #71 M2/R7 rule:
            // changePct is null on yield items, so the generic % chip would lie.
            priceStr = displayPrice.toFixed(2) + '%';
            // 2026-09-28 audit: the yield's observation date rides on the tooltip.
            if (item.asOf)
                titleStr += ' · as of ' + String(item.asOf);
            var cb = (typeof item.changeBps === 'number') ? item.changeBps : null;
            // 2026-10-05 prod QA (Y1): a stale print (backend `stale`, older than the
            // business-day limit) shows its date in place of the 1-day move -- the
            // strip read "10Y 4.71% +4.0 bps" from a July print, as if it were today.
            if (item.stale === true && item.asOf) {
                chgHtml = '<span class="pulse-item-chg">as of ' + escHtml(String(item.asOf)) + '</span>';
            }
            else if (cb !== null) {
                var ycls = cb > 0 ? 'pos' : cb < 0 ? 'neg' : '';
                chgHtml = '<span class="pulse-item-chg ' + ycls + '">' + (cb >= 0 ? '+' : '') + cb.toFixed(1) + ' bps</span>';
            }
        }
        else {
            priceStr = displayPrice >= 100 ? Math.round(displayPrice).toLocaleString() : displayPrice.toFixed(2);
            chgHtml = '<span class="pulse-item-chg ' + cls + '">' + sign + chg.toFixed(2) + '%</span>';
        }
        // OWNER ruling 2026-10-26: FRED's API notice on a chip that shows a FRED figure
        // (the 10Y when the resolver took it from "FRED (DGS)"). CHAOS fred-notice F5: the
        // full sentence as a span crushed the nowrap bar's fact region to 0px at 800px, so
        // the chip carries a compact FRED(R) mark whose title and text hold the sentence.
        if (olIsFredFigure(item))
            chgHtml += olFredNoticeHtml(true, 'mark');
        const fadeClass = nonEquitySymbols.has(sym) ? ' pulse-fade-in' : '';
        html += '<span class="pulse-item' + fadeClass + '" title="' + escHtml(titleStr) + '">'
            + '<span class="pulse-item-name">' + name + '</span>'
            + '<span class="pulse-item-price">' + priceStr + '</span>'
            + chgHtml
            + '</span>';
        if (pulseSepAfter.has(ki))
            html += '<span class="pulse-group-sep"></span>';
    }
    // Personal chip (OWNER brainstorm item 1, board-dispositioned BUILD
    // 2026-09-04): the user's own biggest mover, appended AFTER the three
    // market chips. Rails, each load-bearing:
    //   - logged-in only (olIsAnonymous) — the anon strip is byte-identical;
    //   - REAL portfolio only (_isDefaultPortfolio guard) — a "your mover"
    //     chip computed from the demo AAPL/MSFT set would be false
    //     personalization wearing the user's name;
    //   - CACHE-ONLY (dataCache) — zero new requests on the most-hit view;
    //     the chip appears once this session has loaded the user's quotes
    //     (portfolio/ticker views fill the cache) and is honestly absent
    //     before that. The title says exactly that scope;
    //   - the ratified FACTS-PRIMARY three-chip market cluster above is
    //     untouched — that ruling was about licensed market series, and this
    //     chip is the user's own data.
    try {
        var _anonFn = window.olIsAnonymous;
        var _isAnon = (typeof _anonFn === 'function') ? _anonFn() : true;
        var _isDemo = (typeof _isDefaultPortfolio === 'function') ? _isDefaultPortfolio() : true;
        if (html && !_isAnon && !_isDemo
            && typeof PORTFOLIO_TICKERS !== 'undefined' && Array.isArray(PORTFOLIO_TICKERS)
            && typeof dataCache !== 'undefined') {
            var _pmBest = null;
            var _pmBestAbs = 0;
            for (var _pi = 0; _pi < PORTFOLIO_TICKERS.length; _pi++) {
                var _pt = String(PORTFOLIO_TICKERS[_pi] || '').toUpperCase();
                var _pd = dataCache[_pt];
                var _pp = _pd && (_pd.price && typeof _pd.price.current === 'number' ? _pd.price.current
                    : (typeof _pd.price === 'number' ? _pd.price : null));
                var _pc = _pd && (_pd.price && typeof _pd.price.changePct === 'number' ? _pd.price.changePct
                    : (typeof _pd.changePct === 'number' ? _pd.changePct : null));
                if (_pp === null || _pc === null || !isFinite(_pp) || !isFinite(_pc))
                    continue;
                if (Math.abs(_pc) >= _pmBestAbs) {
                    _pmBestAbs = Math.abs(_pc);
                    _pmBest = { t: _pt, p: _pp, c: _pc };
                }
            }
            if (_pmBest) {
                var _pmCls = _pmBest.c > 0 ? 'pos' : _pmBest.c < 0 ? 'neg' : '';
                var _pmSign = _pmBest.c >= 0 ? '+' : '';
                var _pmPrice = _pmBest.p >= 100 ? Math.round(_pmBest.p).toLocaleString() : _pmBest.p.toFixed(2);
                html += '<span class="pulse-group-sep"></span>'
                    + '<span class="pulse-item pulse-item--personal" title="'
                    + escHtml(_pmBest.t + ' — the biggest mover among your portfolio tickers, '
                        + 'from the quotes loaded in this session') + '">'
                    + '<span class="pulse-item-personal-tag">YOURS</span>'
                    + '<span class="pulse-item-name">' + escHtml(_pmBest.t) + '</span>'
                    + '<span class="pulse-item-price">' + _pmPrice + '</span>'
                    + '<span class="pulse-item-chg ' + _pmCls + '">' + _pmSign + _pmBest.c.toFixed(2) + '%</span>'
                    + '</span>';
            }
        }
    }
    catch (_pmErr) { /* the personal chip is enrichment — never break the strip */ }
    // Market session indicator — ambient pill at end of pulse bar
    if (html) {
        var _etNow = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/New_York' }));
        var _etDay = _etNow.getDay();
        var _etMin = _etNow.getHours() * 60 + _etNow.getMinutes();
        var _sessionLabel = '';
        if (_etDay === 0 || _etDay === 6) {
            // EXT-AUDIT #53 (2026-07-05): on mobile this pill is the bar's ONLY
            // visible child — a bare 'Closed' floating under the header answered
            // no question ('what is closed?'). Name the subject.
            _sessionLabel = 'Markets closed';
        }
        else if (_etMin < 570) {
            _sessionLabel = 'Pre-Market';
        }
        else if (_etMin >= 960) {
            _sessionLabel = 'After Hours';
        }
        if (_sessionLabel) {
            html += '<span class="pulse-session">' + _sessionLabel + '</span>';
        }
        el.innerHTML = html;
    }
    else {
        el.textContent = '';
    }
}
// renderGovernance — governance data is rendered in company profile panel; this ensures no errors
function renderGovernance(ticker) {
    // Governance data (management, proxy) rendered via renderCompanyProfilePanel
    // This stub prevents ReferenceError when called from ticker data flow
}
// ── FOCUS MODE TOGGLE ──
var _focusTimer = null;
// FE P1-3 (2026-07-11): the focus_minutes tick was the only raw interval
// that wrote to the network on a never-pausing timer — trackAchievement
// ('focus_minutes') -> _msPersist -> POST /api/milestones/progress every
// 60s for authed users, with NO document.hidden guard and NO view-change
// teardown (_restoreFocusMode re-applied the CSS on ticker switch but
// never touched the timer). Worst case: one authenticated background
// write per tab per minute, in hidden tabs, indefinitely.
//
// Now OLPolling-managed (key 'ticker:focus-minutes'):
//   - hidden-pause is automatic (polling.ts pauses every handle while
//     document.hidden — the timer truly stops, not body-guarded);
//   - the view-router's clearByKeyPrefix(currentView + ':') teardown
//     reaps it on ticker-view exit, so navigating away stops the count;
//   - _restoreFocusMode (re)starts it on ticker re-entry/reload, closing
//     the symmetric UNDER-count (CSS restored but timer dead after a
//     reload). create()'s same-key de-dup clears the stale handle, so
//     repeated renderData calls never stack timers (the 60s phase resets
//     on ticker switch — a conservative under-count, never an over-count);
//   - ambient lane: 1 tick/min must neither consume one of the 3 capped
//     view-poll slots (starving live prices) nor sit queued behind them
//     (silently never counting). clearByKeyPrefix is lane-agnostic, so
//     the view teardown still reaps it.
// Raw-interval fallback (OLPolling chunk not yet evaluated) keeps an
// explicit !document.hidden gate.
function _focusTick() {
    if (typeof trackAchievement === 'function')
        trackAchievement('focus_minutes');
}
function _startFocusTimer() {
    if (typeof OLPolling !== 'undefined' && OLPolling && typeof OLPolling.create === 'function') {
        if (_focusTimer) {
            clearInterval(_focusTimer);
            _focusTimer = null;
        }
        OLPolling.create({
            key: 'ticker:focus-minutes',
            intervalMs: 60000,
            maxIterations: 1e9, // cleared by toggle-off / view teardown, not by count
            ambient: true,
            onTick: _focusTick,
        });
        return;
    }
    if (_focusTimer)
        clearInterval(_focusTimer);
    _focusTimer = setInterval(function () {
        if (document.hidden)
            return; // P1-3: no background writes
        _focusTick();
    }, 60000);
}
function _stopFocusTimer() {
    if (typeof OLPolling !== 'undefined' && OLPolling && typeof OLPolling.clearByKeyPrefix === 'function') {
        OLPolling.clearByKeyPrefix('ticker:focus-minutes');
    }
    if (_focusTimer) {
        clearInterval(_focusTimer);
        _focusTimer = null;
    }
}
function toggleFocusMode() {
    const tv = document.getElementById('ticker-view');
    if (!tv)
        return;
    tv.classList.toggle('focus-mode');
    const isActive = tv.classList.contains('focus-mode');
    const btn = document.getElementById('focus-toggle-btn');
    if (btn) {
        btn.classList.toggle('active', isActive);
        btn.textContent = isActive ? 'Exit focus' : 'Focus';
    }
    try {
        OLStorage.setString('focusMode', isActive ? '1' : '');
    }
    catch (e) { }
    // Achievement: track focus minutes (P1-3: OLPolling-managed, see above)
    if (isActive)
        _startFocusTimer();
    else
        _stopFocusTimer();
}
// Restore focus mode from localStorage on ticker switch
function _restoreFocusMode() {
    try {
        const fm = OLStorage.getString('focusMode', null);
        const tv = document.getElementById('ticker-view');
        const btn = document.getElementById('focus-toggle-btn');
        if (fm === '1' && tv) {
            tv.classList.add('focus-mode');
            if (btn) {
                btn.classList.add('active');
                btn.textContent = 'Exit focus';
            }
            // P1-3: the timer follows the CSS now — restore (re)starts the count
            // (it was reaped on view exit / never survived a reload before).
            _startFocusTimer();
        }
        else if (tv) {
            tv.classList.remove('focus-mode');
            if (btn) {
                btn.classList.remove('active');
                btn.textContent = 'Focus';
            }
            _stopFocusTimer();
        }
    }
    catch (e) { }
}
// ── WELCOME SCREEN (first-time users) ──
// §WELCOME — extracted to static/js/welcome-flow.js
// Loaded by init() after onboarding completes.
// Lazy-loaded via _loadModule('milestones-view') when milestones view is opened.
// §TOUR — extracted to static/js/tooltip-tour.js
// §BDC — extracted to static/js/bdc-view.js
// Feature discovery & tour -- extracted to static/js/feature-discovery.js
// === ARCHIVE STATS POLLING -- DELETED 2026-09-26 (external review P1-4) ===
// It fetched /api/news/stats every 30s in every tab, hidden ones included,
// BEFORE checking that #sb-archive exists -- and no template renders
// #sb-archive (CSS hides it anyway). Before the premium chunk loaded, each tick
// threw a swallowed ReferenceError. features-extra.ts's fe:archivestats (which
// returns early when #sb-archive is absent) is the one owner if it returns.
// Quick Compare modal -- extracted to static/js/compare-modal.js
// ── REBUILT IMPLIED GROWTH (Reverse-DCF with Terminal Growth) ──
function _rebuildImpliedGrowth(ticker) {
    var secEl = document.getElementById('implied-growth-' + ticker);
    if (!secEl)
        return;
    var d = getData(ticker);
    if (!d)
        return;
    var f = d.financials || {};
    var p = d.price || {};
    var m = d.metrics || {};
    var di = d.debtInfo || {};
    var fcfRaw = f.freeCashFlow || 0;
    var mktCapB = p.marketCap || 0;
    var debt = f.totalDebt || di.totalDebt || 0;
    var cash = f.cash || di.cash || di.cashAndEquivalents || 0;
    var evB = mktCapB > 0 ? (mktCapB * 1000 + debt - cash) / 1000 : (m.evEbitda && f.ebitda ? m.evEbitda * f.ebitda / 1000 : 0);
    var fcfDisp = fcfRaw !== 0 ? fmt(Math.abs(fcfRaw), 0) : '';
    var evDisp = evB > 0 ? fmt(evB, 2) : '';
    var histGrowth = f.revenueGrowth != null ? f.revenueGrowth : null;
    secEl.innerHTML =
        '<div class="ig2-grid">' +
            '<label class="ig2-label">Current FCF ($M)' +
            // EXT-AUDIT #58a (2026-07-06): when FCF has no prefill (thin cached
            // snapshot — #52 class) say WHY instead of a blank the user reads as
            // "the calculator is asking me for a number it should know".
            '<input type="number" id="ig2-fcf-' + ticker + '" value="' + fcfDisp + '"' + (fcfDisp ? '' : ' placeholder="FCF still syncing — enter manually"') + ' class="ig2-input" data-input-action="calc-implied-growth-2" data-ticker="' + escHtml(ticker) + '">' +
            '</label>' +
            '<label class="ig2-label">Enterprise Value ($B)' +
            '<input type="number" id="ig2-ev-' + ticker + '" value="' + evDisp + '" step="0.1" class="ig2-input" data-input-action="calc-implied-growth-2" data-ticker="' + escHtml(ticker) + '">' +
            '</label>' +
            '</div>' +
            '<label class="ig2-slider-label">Discount Rate (WACC): <strong id="ig2-dr-val-' + ticker + '" class="color-text-primary">10%</strong>' +
            '<input type="range" id="ig2-dr-' + ticker + '" value="10" min="6" max="15" step="0.5" class="ig2-slider" data-input-action="slider-update-label" data-ticker="' + escHtml(ticker) + '" data-label-id="ig2-dr-val-' + ticker + '" data-suffix="%" data-calc-action="calc-implied-growth-2">' +
            '</label>' +
            '<label class="ig2-slider-label">Terminal Growth: <strong id="ig2-tg-val-' + ticker + '" class="color-text-primary">2.5%</strong>' +
            '<input type="range" id="ig2-tg-' + ticker + '" value="2.5" min="0" max="4" step="0.5" class="ig2-slider" data-input-action="slider-update-label" data-ticker="' + escHtml(ticker) + '" data-label-id="ig2-tg-val-' + ticker + '" data-suffix="%" data-calc-action="calc-implied-growth-2">' +
            '</label>' +
            '<label class="ig2-slider-label-last">Projection Period: <strong id="ig2-yrs-val-' + ticker + '" class="color-text-primary">10 yrs</strong>' +
            '<input type="range" id="ig2-yrs-' + ticker + '" value="10" min="5" max="20" step="1" class="ig2-slider" data-input-action="slider-update-label" data-ticker="' + escHtml(ticker) + '" data-label-id="ig2-yrs-val-' + ticker + '" data-suffix=" yrs" data-calc-action="calc-implied-growth-2">' +
            '</label>' +
            '<div id="ig2-result-' + ticker + '" class="ig2-result-box">Enter values above</div>' +
            '<div id="ig2-signal-' + ticker + '" class="ig2-signal-box"></div>';
    secEl.dataset.histGrowth = histGrowth != null ? histGrowth : '';
    setTimeout(function () { _calcImpliedGrowth2(ticker); }, 30);
}
function _calcImpliedGrowth2(ticker) {
    var fcfEl = document.getElementById('ig2-fcf-' + ticker);
    var evEl = document.getElementById('ig2-ev-' + ticker);
    var drEl = document.getElementById('ig2-dr-' + ticker);
    var tgEl = document.getElementById('ig2-tg-' + ticker);
    var yrsEl = document.getElementById('ig2-yrs-' + ticker);
    var resEl = document.getElementById('ig2-result-' + ticker);
    var sigEl = document.getElementById('ig2-signal-' + ticker);
    if (!fcfEl || !evEl || !drEl || !tgEl || !yrsEl || !resEl)
        return;
    var fcf = parseFloat(fcfEl.value);
    var evB = parseFloat(evEl.value);
    var dr = parseFloat(drEl.value) / 100;
    var tg = parseFloat(tgEl.value) / 100;
    var yrs = parseInt(yrsEl.value);
    function _setResColor(el, cls) {
        el.classList.remove('result-color--muted', 'result-color--info', 'result-color--warning', 'result-color--danger', 'result-color--secondary');
        if (cls)
            el.classList.add(cls);
    }
    if (!fcf || fcf <= 0 || !evB || evB <= 0 || !dr || dr <= 0) {
        _setResColor(resEl, 'result-color--muted');
        resEl.textContent = fcf <= 0 && fcf ? 'Negative FCF \u2014 model requires positive FCF' : 'Enter values above';
        if (sigEl)
            sigEl.textContent = '';
        return;
    }
    if (tg >= dr) {
        _setResColor(resEl, 'result-color--warning');
        resEl.textContent = 'Terminal growth must be less than discount rate';
        if (sigEl)
            sigEl.textContent = '';
        return;
    }
    var evM = evB * 1000;
    function evAtGrowth(g) {
        var pv = 0;
        for (var t = 1; t <= yrs; t++) {
            pv += fcf * Math.pow(1 + g, t) / Math.pow(1 + dr, t);
        }
        var termFcf = fcf * Math.pow(1 + g, yrs) * (1 + tg);
        var tv = termFcf / (dr - tg);
        pv += tv / Math.pow(1 + dr, yrs);
        return pv;
    }
    var lo = -0.30, hi = 0.60;
    var evLo = evAtGrowth(lo);
    var evHi = evAtGrowth(hi);
    if (evM < evLo) {
        _setResColor(resEl, 'result-color--danger');
        resEl.innerHTML = 'Implied CAGR: <strong class="fs-16">&lt; -30%</strong>';
        if (sigEl)
            sigEl.textContent = 'Market is pricing in severe FCF decline beyond -30% annual.';
        return;
    }
    if (evM > evHi) {
        _setResColor(resEl, 'result-color--danger');
        resEl.innerHTML = 'Implied CAGR: <strong class="fs-16">&gt; 60%</strong>';
        if (sigEl)
            sigEl.textContent = 'Market is pricing in extreme growth beyond 60% annual.';
        return;
    }
    for (var i = 0; i < 60; i++) {
        var mid = (lo + hi) / 2;
        if (evAtGrowth(mid) < evM)
            lo = mid;
        else
            hi = mid;
    }
    var impliedG = ((lo + hi) / 2) * 100;
    var secEl2 = document.getElementById('implied-growth-' + ticker);
    var histGrowth = secEl2 && secEl2.dataset.histGrowth ? parseFloat(secEl2.dataset.histGrowth) : null;
    var colorCls;
    if (impliedG < 0)
        colorCls = 'result-color--danger';
    else if (impliedG <= 15)
        colorCls = 'result-color--info';
    else if (impliedG <= 30)
        colorCls = 'result-color--warning';
    else
        colorCls = 'result-color--danger';
    _setResColor(resEl, colorCls);
    resEl.innerHTML = 'Implied ' + yrs + 'Y FCF CAGR: <strong class="fs-16">' + fmt(impliedG, 1) + '%</strong>';
    if (sigEl) {
        if (histGrowth != null && !isNaN(histGrowth)) {
            var signalCls, signalText;
            if (impliedG < histGrowth) {
                signalCls = 'result-color--info';
                signalText = 'Implied growth (' + fmt(impliedG, 1) + '%) is BELOW historical revenue growth (' + fmt(histGrowth, 1) + '%). Market may be undervaluing growth potential.';
            }
            else if (impliedG > histGrowth * 2) {
                signalCls = 'result-color--danger';
                signalText = 'Implied growth (' + fmt(impliedG, 1) + '%) is MORE THAN 2x historical revenue growth (' + fmt(histGrowth, 1) + '%). Market may be pricing in aggressive expansion.';
            }
            else {
                signalCls = 'result-color--secondary';
                signalText = 'Implied growth (' + fmt(impliedG, 1) + '%) vs historical (' + fmt(histGrowth, 1) + '%). Priced roughly in line with recent performance.';
            }
            _setResColor(sigEl, signalCls);
            sigEl.innerHTML = signalText;
        }
        else {
            _setResColor(sigEl, 'result-color--muted');
            sigEl.innerHTML = 'At a ' + fmt(dr * 100, 1) + '% discount rate and ' + fmt(tg * 100, 1) + '% terminal growth, the market is pricing in ' + fmt(impliedG, 1) + '% annual FCF growth over ' + yrs + ' years.';
        }
    }
}
// Override old _calcImpliedGrowth to delegate to new version
(function () {
    var _origCalcIG = typeof _calcImpliedGrowth === 'function' ? _calcImpliedGrowth : null;
    window._calcImpliedGrowth = function (ticker) {
        if (document.getElementById('ig2-fcf-' + ticker)) {
            _calcImpliedGrowth2(ticker);
        }
        else if (_origCalcIG) {
            _origCalcIG(ticker);
        }
    };
})();
// Observe DOM for new implied-growth panels and rebuild with sliders
(function () {
    var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mut) {
            mut.addedNodes.forEach(function (node) {
                if (node.nodeType !== 1)
                    return;
                var panels = [];
                if (node.id && node.id.startsWith('implied-growth-'))
                    panels.push(node);
                if (node.querySelectorAll) {
                    node.querySelectorAll('[id^="implied-growth-"]').forEach(function (el) { panels.push(el); });
                }
                panels.forEach(function (el) {
                    var t = el.id.replace('implied-growth-', '');
                    if (!document.getElementById('ig2-fcf-' + t)) {
                        setTimeout(function () { _rebuildImpliedGrowth(t); }, 60);
                    }
                });
            });
        });
    });
    setTimeout(function () {
        var mainEl = document.getElementById('main') || document.getElementById('content-wrapper');
        if (mainEl)
            observer.observe(mainEl, { childList: true, subtree: true });
        if (typeof activeTicker !== 'undefined' && activeTicker && document.getElementById('implied-growth-' + activeTicker)) {
            _rebuildImpliedGrowth(activeTicker);
        }
    }, 200);
})();
// ── FEATURE: News View — Prior/Search/Live buttons ──
var _headlinesMode = 'live';
function loadLiveHeadlines() {
    _headlinesMode = 'live';
    const _hlLive = document.getElementById('headlines-live-btn');
    if (_hlLive)
        _hlLive.classList.add('d-none');
    const _hlPrior = document.getElementById('headlines-prior-btn');
    if (_hlPrior)
        _hlPrior.classList.remove('d-none');
    const _hlWrap = document.getElementById('headline-search-wrap');
    if (_hlWrap)
        _hlWrap.classList.add('d-none');
    const el = document.getElementById('market-headlines');
    if (!el)
        return;
    if (headlinesCache && headlinesCache.length > 0) {
        const EXCLUDED_SOURCES = new Set(['Yahoo Finance', 'Zacks', 'PR Newswire Finance', 'GamesIndustry.biz', 'Game Developer', 'VGC', 'IGN', 'Eurogamer', 'PC Gamer', 'Polygon', 'The Verge Gaming', 'Dot Esports', 'FiercePharma', 'FierceBiotech', 'FierceHealthcare', 'BioPharma Dive', 'Endpoints News', 'STAT News', 'Drug Channels', 'NEJM', 'The Lancet', 'CDC Newsroom']);
        const filtered = headlinesCache.filter(n => !EXCLUDED_SOURCES.has(n.source) && !isClickbait(n.headline));
        _safeSetHTML(el, filtered.slice(0, 60).map(n => renderNewsItem(n, false)).join(''));
    }
    else {
        // P2-30: centralized empty state
        el.innerHTML = OLEmpty.render({ icon: 'N', title: 'No live headlines', body: 'Check back in a few minutes — live feeds refresh continuously.' });
    }
}
var _priorOffset = 0;
var _PRIOR_PAGE_SIZE = 60;
async function loadPriorHeadlines(append) {
    _headlinesMode = 'prior';
    const _hlLive2 = document.getElementById('headlines-live-btn');
    if (_hlLive2)
        _hlLive2.classList.remove('d-none');
    const _hlPrior2 = document.getElementById('headlines-prior-btn');
    if (_hlPrior2)
        _hlPrior2.classList.add('d-none');
    const _hlWrap2 = document.getElementById('headline-search-wrap');
    if (_hlWrap2)
        _hlWrap2.classList.add('d-none');
    const el = document.getElementById('market-headlines');
    if (!el)
        return;
    if (!append) {
        _priorOffset = 0;
        el.innerHTML = '<div class="news-archive-loading">Loading archived headlines...</div>';
    }
    else {
        // Remove existing "Load More" button before appending
        var oldBtn = el.querySelector('.news-load-more');
        if (oldBtn)
            oldBtn.remove();
    }
    try {
        // days=3650 is the route's max (Query le=3650); the prior value 9999
        // exceeded it → FastAPI 422 → the catch below painted "Unable to load
        // archived headlines" on every Prior click (OWNER prod-QA 2026-05-31).
        // 3650d (~10y) is effectively the whole archive; offset paging walks back.
        const res = await fetch(`${SERVER}/api/news/search?days=3650&limit=${_PRIOR_PAGE_SIZE}&offset=${_priorOffset}`, { signal: (typeof getViewAwareSignal === 'function' ? getViewAwareSignal(15000) : AbortSignal.timeout(15000)) });
        if (!res.ok)
            throw new Error('HTTP ' + res.status);
        const data = await res.json();
        const items = data.results || data;
        if (Array.isArray(items) && items.length > 0) {
            var html = items.map(n => renderNewsItem(n, false)).join('');
            if (items.length >= _PRIOR_PAGE_SIZE) {
                html += '<div class="news-load-more" data-action="load-more-prior">Load more headlines...</div>';
            }
            if (append) {
                el.insertAdjacentHTML('beforeend', html);
            }
            else {
                el.innerHTML = html;
            }
            _priorOffset += items.length;
        }
        else if (!append) {
            // P2-30: centralized empty state
            el.innerHTML = OLEmpty.render({ icon: 'A', title: 'No archived headlines', body: 'Try a different search or come back later.' });
        }
    }
    catch (e) {
        if (!append)
            el.innerHTML = '<div class="dim-msg">Unable to load archived headlines. Please try again.</div>';
    }
}
async function searchHeadlines() {
    const inp = document.getElementById('headline-search-input');
    if (!inp || !inp.value.trim())
        return;
    const q = inp.value.trim();
    _headlinesMode = 'search';
    const _hlLive3 = document.getElementById('headlines-live-btn');
    if (_hlLive3)
        _hlLive3.classList.remove('d-none');
    const _hlPrior3 = document.getElementById('headlines-prior-btn');
    if (_hlPrior3)
        _hlPrior3.classList.remove('d-none');
    const el = document.getElementById('market-headlines');
    if (!el)
        return;
    el.innerHTML = '<div class="news-searching">Searching...</div>';
    try {
        const res = await fetch(`${SERVER}/api/news/search?q=${encodeURIComponent(q)}`, { signal: (typeof getViewAwareSignal === 'function' ? getViewAwareSignal(15000) : AbortSignal.timeout(15000)) });
        if (!res.ok)
            throw new Error('HTTP ' + res.status);
        const data = await res.json();
        const items = data.results || data;
        if (Array.isArray(items) && items.length > 0) {
            el.innerHTML = '<div class="news-result-count">' + items.length + ' result' + (items.length !== 1 ? 's' : '') + ' for \u201c' + escHtml(q) + '\u201d</div>' +
                items.map(n => renderNewsItem(n, false)).join('');
        }
        else {
            // P2-30: centralized empty state
            // DS-P2b: OLEmpty.body is NOT escaped (supports inline markup) \u2014 q is
            // the user's search string, so escape it HERE (the retired emptyState()
            // escaped desc internally).
            el.innerHTML = OLEmpty.render({ icon: '?', title: 'No results', body: 'Nothing matched \u201c' + escHtml(q) + '\u201d. Try broader keywords.' });
        }
    }
    catch (e) {
        el.innerHTML = '<div class="dim-msg">Unable to search headlines. Please try again.</div>';
    }
}
// ── SHARED NEWS STATS CACHE (deduplicates /api/news/stats calls) ──
// 2026-04-26: moved from features-extra.js (premium chunk) to app.js
// (always-loaded core) because the news view is free-tier but consumed
// this helper. Anonymous users were hitting the early-return guard in
// _loadSentimentStrip below, leaving Archive Sentiment as dashes. The
// duplicate declaration in features-extra.js is harmless (last-loaded
// wins, both shapes identical) and is kept for SSR pages that use it
// without app.js.
if (typeof _newsStatsCache === 'undefined')
    var _newsStatsCache = { data: null, ts: 0 };
if (typeof _fetchNewsStats !== 'function') {
    var _fetchNewsStats = async function () {
        if (_newsStatsCache.data && Date.now() - _newsStatsCache.ts < 60000)
            return _newsStatsCache.data;
        try {
            // FE-AUDIT 2026-06-25: shared in-flight via OLApi.getNewsStats (cloned
            // Response) so concurrent cold-news sentiment + archive-stats callers
            // collapse to one network request.
            var _nsSig = (typeof getViewAwareSignal === 'function' ? getViewAwareSignal(8000) : AbortSignal.timeout(8000));
            var _nsApi = window.OLApi;
            var res = (_nsApi && typeof _nsApi.getNewsStats === 'function')
                ? await _nsApi.getNewsStats({ signal: _nsSig })
                : await fetch(SERVER + '/api/news/stats', { signal: _nsSig });
            if (!res.ok)
                return null;
            _newsStatsCache.data = await res.json();
            _newsStatsCache.ts = Date.now();
            return _newsStatsCache.data;
        }
        catch (err) {
            /* @__PURE__ */ _olDebugWarn('Fetch failed:', err);
            return null;
        }
    };
}
// ── FEATURE: Sentiment Strip from /api/news/stats ──
// Called from renderNewsView() after the news DOM is materialized.
// Previously an IIFE that ran at parse time before the template existed.
function _loadSentimentStrip() {
    if (typeof SERVER === 'undefined')
        return;
    if (typeof _fetchNewsStats !== 'function')
        return;
    _fetchNewsStats()
        .then(data => {
        if (!data)
            return;
        const host = document.getElementById('sent-windows');
        if (!host)
            return;
        // News #4 (2026-07-15): render 7D/30D/90D windowed rows from the additive
        // /api/news/stats `sentimentWindows` field (SQLite news_articles.publishedAt
        // windows). Each row: label \u00B7 proportional bar (gold positive / muted-slate
        // neutral / terracotta negative \u2014 the sanctioned 3-color set, no raw
        // green/red) \u00B7 colored X%/Y%/Z% breakout so the pos/neu/neg order is
        // self-documenting. Falls back to a single overall row from bySentiment when
        // the backend (older edge cache) has not sent sentimentWindows yet.
        const wins = data.sentimentWindows || data.sentiment_windows || null;
        const rows = [];
        if (wins) {
            rows.push(['7D', wins['7d'] || wins['7D'] || {}]);
            rows.push(['30D', wins['30d'] || wins['30D'] || {}]);
            rows.push(['90D', wins['90d'] || wins['90D'] || {}]);
        }
        else {
            const bs = data.bySentiment || data.by_sentiment || {};
            rows.push(['All', {
                    positive: bs.positive || bs.Positive || 0,
                    neutral: bs.neutral || bs.Neutral || 0,
                    negative: bs.negative || bs.Negative || 0,
                }]);
        }
        // CSSOM .style (not an inline style attribute) so the flex-grow sizing is
        // CSP-safe on the strict style-src; createElement (no innerHTML with data).
        const frag = document.createDocumentFragment();
        rows.forEach(function (entry) {
            const label = entry[0];
            const w = entry[1] || {};
            const pos = Number(w.positive) || 0;
            const neu = Number(w.neutral) || 0;
            const neg = Number(w.negative) || 0;
            const tot = Number(w.total) || (pos + neu + neg);
            const row = document.createElement('div');
            row.className = 'sentiment-win';
            const lab = document.createElement('span');
            lab.className = 'sentiment-win__label';
            lab.textContent = label;
            row.appendChild(lab);
            if (tot <= 0) {
                const empty = document.createElement('span');
                empty.className = 'sentiment-win__pct text-muted';
                empty.textContent = 'not enough data';
                row.appendChild(empty);
                row.setAttribute('aria-label', label + ': not enough data');
                frag.appendChild(row);
                return;
            }
            const bar = document.createElement('div');
            bar.className = 'sentiment-win__bar';
            ['pos', 'neu', 'neg'].forEach(function (k, i) {
                const s = document.createElement('span');
                s.className = 'news-sent-bar__seg news-sent-bar__' + k;
                s.setAttribute('aria-hidden', 'true');
                s.style.flexGrow = String([pos, neu, neg][i]);
                bar.appendChild(s);
            });
            row.appendChild(bar);
            // pos + neg rounded independently (the numbers users read for
            // bullish/bearish); the residual lands in neu (the largest bucket, where
            // +/-1% is imperceptible) so the three always sum to exactly 100%.
            const pPos = Math.round(pos / tot * 100);
            const pNeg = Math.round(neg / tot * 100);
            const pNeu = Math.max(0, 100 - pPos - pNeg);
            const pct = document.createElement('span');
            pct.className = 'sentiment-win__pct';
            ['pos', 'neu', 'neg'].forEach(function (k, i) {
                if (i > 0) {
                    pct.appendChild(document.createTextNode(' / '));
                }
                const v = document.createElement('span');
                v.className = 'sentiment-win__p sentiment-win__p--' + k;
                v.textContent = [pPos, pNeu, pNeg][i] + '%';
                pct.appendChild(v);
            });
            row.appendChild(pct);
            row.setAttribute('aria-label', label + ' sentiment: ' + pPos + '% positive, ' + pNeu + '% neutral, ' + pNeg + '% negative');
            frag.appendChild(row);
        });
        host.replaceChildren(frag);
    })
        .catch(() => { });
}
// ── FEATURE: Glossary Tooltip Clickable (HIGH-1) ──
function _glossTooltipClick() {
    if (typeof _lastHoveredGlossTerm !== 'undefined' && _lastHoveredGlossTerm) {
        if (typeof _glossModalOpen === 'function')
            _glossModalOpen(_lastHoveredGlossTerm);
    }
}
// ── API Upgrade MODAL -- DELETED 2026-09-26 (CHAOS RTQ T8, OWNER "we do not
// have real time quotes"). showApiUpgradeModal had no caller left after the
// ticker hero stopped opening it, and its copy sold real-time data
// ("Get Real-Time Market Data", "powers Oxford Ledge real-time data").
// Its three data-action handlers went with it.
// "Try AI" discovery glow — stops after 5 clicks
(function () {
    var aiBtn = document.getElementById('askai-btn');
    if (!aiBtn)
        return;
    var clicks = parseInt(OLStorage.getString('aiGlowClicks', null) || '0');
    if (clicks < 3) {
        aiBtn.classList.add('ai-glow-active');
        aiBtn.addEventListener('click', function () {
            clicks++;
            try {
                OLStorage.setString('aiGlowClicks', String(clicks));
            }
            catch (e) { }
            if (clicks >= 3) {
                aiBtn.classList.remove('ai-glow-active');
            }
        });
    }
})();
// ── P0-1: Cookie Consent Banner — essential-only notice (NOT a consent gate) ─
// COUNSEL 2026-05-17 (docs/board/audit/2026-05-17_COUNSEL_minicycle_residue.md
// F2-F4): banner gates ONLY strictly-necessary first-party storage; an
// accept-only ack is legally sufficient — a reject option is NOT a live GDPR
// obligation here. The dead 'cookie-reject' delegation entry + the prior
// over-stated comment were removed (#116). RE-TRIGGER: a genuinely
// non-essential cookie -> reject becomes a live obligation; re-add it then.
// Show banner on load; the accept handler is in _delegatedActions (data-action).
(function () {
    if (OLStorage.getString('ol_cookie_consent', null) || OLStorage.getString('cookieConsent', null))
        return;
    var banner = document.getElementById('cookie-consent-banner');
    if (!banner)
        return;
    banner.classList.remove('d-none');
})();
// Share card generator extracted to /static/js/share-card.js
// §DELEGATION ══════════════════════════════════════════════════════════════════
// ── E4: Central Event Delegation ──
// Replaces inline onclick handlers with data-action attributes for security (XSS prevention) and performance.
// Elements use data-action="actionName" with optional data-* params; this single listener dispatches them.
function _syncTopbarLevelLabel() {
    var el = document.getElementById('topbar-level-label');
    if (!el)
        return;
    var labels = { beginner: 'BGN', learner: 'LRN', expert: 'EXP' };
    var cur = OLStorage.getString('_userLevel', null) || OLStorage.getString('ol_user_level', null) || 'beginner';
    el.textContent = labels[cur] || 'BGN';
}
try {
    _syncTopbarLevelLabel();
}
catch (e) { }
// F3.8 (SF-23 OWNER ratification 2026-05-07, Q5=YES delete):
// _applyMinLevelGating function DELETED. It iterated every
// `[data-min-level]` element and gated visibility based on
// localStorage skillLevel — but F3.1 Phase C (commit 639c6017)
// deleted every `data-min-level` element on dashboard.html, so the
// function had been a no-op for hours. Removed entirely along with
// its 2 init invocations + window export. If a future feature wants
// the data-min-level pattern back, reintroduce as a fresh impl in
// the file that needs it.
window._applyMinLevelGating = function () { };
// ── LEARN detail panes (_gbp* glossary browse + _otd* on-this-date) ──
// EXTRACTED to learn-panes.ts (2026-08-24, #99 D1b second cut of this
// file). Same chunk, so the _delegatedActions handlers below keep
// resolving them as chunk globals at event time. The delegation map and
// pane WIRING stay here — only the pane bodies moved.
// ── Settings drawer open/close (N8, mobile audit 2026-09-25) ──
// #ol-settings-panel is role="dialog" aria-modal="true" (dashboard.html) but
// until this date the open handler set data-open + the body scroll-lock and
// nothing else: no focus trap (only the kb modal used trapFocus), no focus
// return, and no Escape branch. Two writers below own the whole lifecycle so
// the sidecar's "Settings" row and the topbar gear cannot drift apart again
// (the sidecar path had already dropped the scroll-lock).
var _olSettingsTrapCleanup = null;
var _olSettingsOpenerEl = null;
function _olSettingsPanelIsOpen() {
    var p = document.getElementById('ol-settings-panel');
    return !!(p && p.getAttribute('data-open') === 'true');
}
function _olOpenSettingsPanel() {
    var p = document.getElementById('ol-settings-panel');
    if (!p)
        return;
    var wasOpen = p.getAttribute('data-open') === 'true';
    p.setAttribute('data-open', 'true');
    p.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    if (!wasOpen) {
        // Record the opener BEFORE moving focus, so close can hand it back.
        var ae = document.activeElement;
        _olSettingsOpenerEl = (ae && ae !== document.body) ? ae : null;
        if (typeof trapFocus === 'function')
            _olSettingsTrapCleanup = trapFocus(p);
        // First control in the drawer is the Close button (dashboard.html).
        var first = p.querySelector('.ol-settings-panel-close, button:not([disabled]), a[href]');
        if (first && typeof first.focus === 'function') {
            try {
                first.focus();
            }
            catch (_e) { /* non-fatal */ }
        }
    }
    if (typeof _olRefreshSettingsPanel === 'function')
        _olRefreshSettingsPanel();
}
// Returns true when it closed something, so the Escape chain can stop there.
function _olCloseSettingsPanel() {
    var p = document.getElementById('ol-settings-panel');
    if (!p || p.getAttribute('data-open') !== 'true')
        return false;
    p.setAttribute('data-open', 'false');
    p.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (typeof _olSettingsTrapCleanup === 'function') {
        try {
            _olSettingsTrapCleanup();
        }
        catch (_e) { /* non-fatal */ }
    }
    _olSettingsTrapCleanup = null;
    var opener = _olSettingsOpenerEl;
    _olSettingsOpenerEl = null;
    if (opener && typeof opener.focus === 'function' && document.contains(opener)) {
        try {
            opener.focus();
        }
        catch (_e) { /* non-fatal */ }
    }
    return true;
}
// ── Practice-mode exit (N4, mobile audit 2026-09-25) ──
// Returns true when practice mode (or its stranded overlay) was on and is now
// off. `practiceMode` + `togglePracticeMode` live in the screener-options
// chunk, which may not have loaded; the overlay's `active` class is the
// DOM-side truth when they have not. Used by the overlay's own "Exit practice"
// button and by the Escape chain.
function _exitPracticeMode() {
    var ov = document.getElementById('practice-sector-overlay');
    var on = (typeof practiceMode !== 'undefined' && practiceMode);
    var shown = !!(ov && ov.classList.contains('active'));
    if (!on && !shown)
        return false;
    if (on && typeof togglePracticeMode === 'function')
        togglePracticeMode();
    else if (ov)
        ov.classList.remove('active');
    return true;
}
// True when a dialog OTHER than the practice overlay is visibly on screen --
// its own Escape listener (registered after the central chain) owns the key.
// Parked drawers (aria-modal kept, slid off-screen), display:none,
// visibility:hidden and aria-hidden surfaces do not count. (CHAOS 2026-09-25)
function _olOtherDialogOnScreen() {
    var ds = document.querySelectorAll('[role="dialog"], [aria-modal="true"]');
    var vw = (typeof window !== 'undefined' && window.innerWidth) || 0;
    var vh = (typeof window !== 'undefined' && window.innerHeight) || 0;
    for (var i = 0; i < ds.length; i++) {
        var d = ds[i];
        if (d.id === 'practice-sector-overlay' || d.hidden || d.getAttribute('aria-hidden') === 'true')
            continue;
        if (typeof d.getBoundingClientRect !== 'function')
            continue;
        var r = d.getBoundingClientRect();
        if (!r || r.width === 0 || r.height === 0)
            continue;
        if (r.right <= 0 || r.bottom <= 0 || r.left >= vw || r.top >= vh)
            continue;
        if (typeof window !== 'undefined' && typeof window.getComputedStyle === 'function'
            && window.getComputedStyle(d).visibility === 'hidden')
            continue;
        return true;
    }
    return false;
}
// Screener "Export all fundamentals" (OWNER 2026-09-26). The server caps the
// CSV at the screener's own result ceiling (services/data_bulk_csv.py
// BULK_CSV_MAX_TICKERS); the button never asks for more.
var _SCR_BULK_CSV_MAX = 500;
// The Investor upgrade overlay for the bulk export (premium-gate.ts
// 'bulk-export'). A click must always lead somewhere: when the catalogue is
// not loaded, or has no entry, go to /pricing rather than do nothing (the
// tier-gate.ts P1-16 rule).
function _scrOpenBulkExportGate() {
    var w = window;
    if (typeof w.showPremiumGateResult === 'function') {
        if (w.showPremiumGateResult('bulk-export') === 'unknown')
            window.location.href = '/pricing';
        return;
    }
    if (typeof w.showPremiumGate === 'function' && w.showPremiumGate('bulk-export'))
        return;
    window.location.href = '/pricing';
}
// A signed-out reader (401) needs to sign in, not to upgrade (CHAOS
// 2026-09-27 T6). The auth modal in sign-in mode when it is loaded, else the
// ?signin=1 deep link app-init.ts handles, carrying the screener view back.
function _scrOpenBulkExportSignIn() {
    var w = window;
    if (typeof w.authOpenModal === 'function') {
        w.authOpenModal('signin');
        return;
    }
    window.location.href = '/?signin=1&view=screener';
}
// AbortSignal.timeout is missing on older browsers; calling it there threw
// before the fetch and before any toast (CHAOS 2026-09-27 T6). Same guard as
// tier-gate.ts _loadRegistry: no signal is better than no request.
function _scrBulkExportSignal(ms) {
    try {
        if (typeof AbortSignal !== 'undefined' && typeof AbortSignal.timeout === 'function')
            return AbortSignal.timeout(ms);
    }
    catch (_e) { /* fall through to no timeout */ }
    return undefined;
}
// ── "Ask your assistant" line on the data panels (R-MCP-AWARE rule 2) ──
// BOARD R7 / B7 (docs/board/audit/2026-09-26_BOARD_mcp_awareness_cycle.md
// §3b, §4b, §6; OWNER-greenlit 2026-09-27): a signed-in reader also gets a
// "Copy question" text button that copies the question shown, verbatim. The
// builder lives HERE (app-tail, loaded on every view) rather than in the lazy
// `research` chunk so the BDC panel (`premium`) and the filings panel
// (ticker-renderer, this chunk) share ONE markup with holders + insider.
// Question rules (09-23 DESIGN+VOICE): <= 110 chars, the company named WITH its
// ticker, no asserted number, a checking question (never buy or sell), no key or
// credential words. Each surface is answered by a FREE keyless tool, pinned in
// tests/test_mcp_ask_your_assistant_link_contract.py. Key state is unknown here
// without a network call, so the setup link always stays BESIDE the copy button.
function olMcpAskQuestion(surface, ticker, name, bare) {
    var forms = {
        holders_panel: ['Which institutions hold the most {s} shares, according to their latest 13F filings?',
            'Which institutions hold the most {s} shares, per their latest 13F filings?'],
        // VOICE 2026-09-27: no "together" (09-23 ruling); a cluster is 3+ insiders
        // within 30 days (data/insider_cluster.py WINDOW_DAYS), hence "same month".
        insider_panel: ['Have several {s} insiders bought or sold within the same month, per Form 4 filings?',
            'Have several {s} insiders traded within the same month, per Form 4 filings?'],
        bdc_panel: ['How much of the loan book at {s} is on non-accrual, per its latest filing?',
            'How much of the loan book at {s} is on non-accrual?'],
        filings_panel: ['What events has {s} reported in its recent 8-K filings?',
            'What has {s} reported in recent 8-K filings?'],
    }[surface];
    var t = String(ticker || '').trim();
    if (!forms || !t)
        return '';
    // A leading "The", an SEC state tag ("APPLE INC /CA/", "/DE/") and a legal
    // suffix cost characters and say nothing ("Apple Inc." -> "Apple").
    var n = String(name || '').trim().replace(/^the\s+/i, '').replace(/\s+\/[a-z]{2,3}\/\s*$/i, '').replace(/[\s,]+(inc|incorporated|corp|corporation|co|company|ltd|limited|plc|llc|l\.?p|n\.?v|s\.?a|ag)\.?$/i, '').trim();
    var s = (n && n.toUpperCase() !== t.toUpperCase()) ? n + ' (' + t + ')' : (bare ? t : '');
    for (var i = 0; s && i < forms.length; i++) {
        var q = forms[i].split('{s}').join(s); // split/join: a '$' in a name is text, not a pattern
        if (q.length <= 110)
            return q;
    }
    return '';
}
// The company name the ticker view already holds (hero logic, ticker-renderer.ts).
function _olMcpAskNameOf(d) {
    if (!d)
        return '';
    var ci = d.companyInfo || d.profile || {};
    return String((d.company && d.company !== d.ticker ? d.company : '') || ci.name || ci.longName || ci.shortName || '');
}
// One line: kicker, the question, [Copy question + its live region when signed
// in and the question names the company], the setup link with ?from= BEFORE the
// fragment (MCPW-2). A question without the name is shown but never copied.
function olMcpEntryHtml(surface, ticker, name) {
    var cached = (typeof dataCache !== 'undefined' && dataCache) ? dataCache[ticker] : null;
    var named = olMcpAskQuestion(surface, ticker, name || _olMcpAskNameOf(cached));
    var prompt = named || olMcpAskQuestion(surface, ticker, null, true);
    if (!prompt)
        return '';
    var canCopy = !!named && typeof _authUser !== 'undefined' && !!_authUser; // the session global; no fetch
    return '<aside class="ol-mcp-entry" data-mcp-entry="' + escHtml(surface) + '" aria-label="Use this data in your AI assistant">'
        + '<span class="ol-mcp-entry-kicker">Ask your assistant about this:</span> '
        + '<q class="ol-mcp-entry-prompt">' + escHtml(prompt) + '</q> '
        + (canCopy ? '<button type="button" class="ol-mcp-entry-copy" data-action="mcp-copy-question">Copy question</button>'
            + '<span class="sr-only" aria-live="polite"></span> ' : '')
        + '<a class="ol-mcp-entry-link" href="/mcp?from=' + encodeURIComponent(surface) + '#setup">Connect your assistant &rarr;</a>'
        + '</aside>';
}
// Same behaviour as the shared copy-snippet.js module the SSR pages load (not
// in the SPA bundle, so this follows the api-keys / sdk-copy-install precedent):
// "Copied" for 1500ms, "Copied to clipboard" into the line's own
// polite live region, and "Select and copy" with the question selected when
// the clipboard is absent or refuses. Never silently nothing (VOICE V-8).
function olMcpCopyQuestion(btn) {
    var box = btn && btn.closest ? btn.closest('.ol-mcp-entry') : null;
    var q = box ? box.querySelector('.ol-mcp-entry-prompt') : null;
    var text = q ? (q.textContent || '') : '';
    if (!text)
        return Promise.resolve(false);
    var live = box.querySelector('.sr-only');
    var pending = Number(btn.getAttribute('data-copy-timer') || 0);
    if (pending) {
        window.clearTimeout(pending);
        btn.removeAttribute('data-copy-timer');
    }
    var fail = function () {
        btn.textContent = 'Select and copy';
        try {
            var sel = window.getSelection(), r = document.createRange();
            r.selectNodeContents(q);
            sel.removeAllRanges();
            sel.addRange(r);
        }
        catch (_e) { /* nothing selectable: the label still says what to do */ }
        return false;
    };
    var clip = typeof navigator !== 'undefined' ? navigator.clipboard : undefined;
    if (!clip || typeof clip.writeText !== 'function')
        return Promise.resolve(fail());
    var p;
    try {
        p = clip.writeText(text);
    }
    catch (_e) {
        return Promise.resolve(fail());
    }
    return p.then(function () {
        btn.textContent = 'Copied'; // no check mark: U+2713 is a banned symbol glyph (BRAND.md)
        btn.setAttribute('data-copy-timer', String(window.setTimeout(function () {
            btn.textContent = 'Copy question';
            btn.removeAttribute('data-copy-timer');
        }, 1500)));
        if (live) {
            live.textContent = '';
            window.setTimeout(function () { live.textContent = 'Copied to clipboard'; }, 50);
        }
        return true;
    }, fail);
}
var _delegatedActions = {
    // 'dismiss-mobile-notice' removed 2026-04-04: the #mobile-notice element was
    // deleted from dashboard.html (CYCLE UI/Design audit — trust-eroding banner).
    // News filter chips — registered here so they work immediately even before
    // the news.js module or core-views chunk loads (which registers a duplicate
    // document-level handler via initNews). Both handlers are idempotent.
    'news-filter': function (e) { var el = e.target.closest('[data-action]'); if (el && typeof setNewsFilter === 'function')
        setNewsFilter(el.dataset.filter || null); },
    // #184 (2026-05-21): CSP-clean replacements for the last 2 inline-event-
    // handler holdouts that survived prior cleanup sweeps. Both fire on
    // /?view=ticker surfaces (peer comparison table + BDC SOI panel for
    // BDC-ticker views) and got blocked by strict script-src CSP — real
    // feature break (checkboxes did nothing; search box did nothing).
    // peer-view.ts:318 used onchange="_togglePeerCol(...)"; now uses
    // data-action-change="toggle-peer-col" + data-col-key.
    'toggle-peer-col': function (e) {
        var el = e.target.closest('[data-col-key]');
        if (!el || !el.dataset)
            return;
        var key = el.dataset.colKey;
        if (!key || typeof _togglePeerCol !== 'function')
            return;
        _togglePeerCol(key, e.target.checked === true);
    },
    // bdc-soi-panel.ts:123 used oninput="_filterSOI(this.value)"; now uses
    // data-action-input="bdc-soi-filter".
    'bdc-soi-filter': function (e) {
        if (typeof _filterSOI !== 'function')
            return;
        _filterSOI(e.target.value || '');
    },
    // EW-1 + EW-2 (2026-04-26): retry button on /api/institutional-holders/changes
    // failure. Clears cache for the ticker and re-fires the panel renderer.
    'hf-changes-retry': function (e) {
        var el = e.target.closest('[data-action]');
        var t = el && el.dataset && el.dataset.ticker;
        if (!t)
            return;
        try {
            if (typeof _hfChangesCache !== 'undefined')
                delete _hfChangesCache[t];
        }
        catch (_) { }
        if (typeof renderHFChangesPanel === 'function')
            renderHFChangesPanel(t);
    },
    // #189 step 4 (2026-05-19 OWNER prod-QA): chip click toggles a per-ticker
    // bucket filter on the Institutional Investors Δ-table. Empty `data-bucket`
    // (from the × button in the as-of label) clears the filter.
    'hf-filter-bucket': function (e) {
        var el = e.target.closest('[data-action]');
        if (!el || !el.dataset)
            return;
        var t = el.dataset.ticker;
        var bucket = el.dataset.bucket || null;
        if (!t)
            return;
        // Toggle: clicking the active chip clears; clicking the × also clears
        // (bucket is null in that case).
        _hfBucketFilter = (_hfBucketFilter === bucket) ? null : bucket;
        if (typeof renderHFChangesPanel === 'function')
            renderHFChangesPanel(t);
    },
    'news-load-more': function () { if (typeof loadMoreNews === 'function')
        loadMoreNews(); },
    'close-onboard-overlay': function () { _closeOnboardOverlay(); },
    'focus-ticker-input': function () { var inp = document.getElementById('ticker-input'); if (inp) {
        inp.focus();
        inp.select();
    } },
    'fd-set-goal': function (e) { var el = e.target.closest('[data-goal]'); if (el && typeof _renderFdGrid === 'function')
        _renderFdGrid(el.dataset.goal); },
    'ob-preset': function (e) { var el = e.target.closest('[data-action]'); var _obT; try {
        _obT = JSON.parse(el.dataset.tickers || '[]');
    }
    catch (e) {
        _obT = [];
    } _obPreset(_obT); },
    'welcome-preset': function (e) { var el = e.target.closest('[data-action]'); var _wpT; try {
        _wpT = JSON.parse(el.dataset.tickers || '[]');
    }
    catch (e) {
        _wpT = [];
    } _welcomePreset(_wpT); },
    'welcome-remove-ticker': function (e) {
        var el = e.target.closest('[data-action]');
        var ticker = el && el.dataset.ticker;
        if (!ticker)
            return;
        var idx = PORTFOLIO_TICKERS.indexOf(ticker);
        if (idx >= 0)
            PORTFOLIO_TICKERS.splice(idx, 1);
        window._welcomeTickers = PORTFOLIO_TICKERS.slice();
        // Deselect preset buttons since we've customized
        document.querySelectorAll('#welcome-overlay .welcome-preset-btn').forEach(function (btn) { btn.classList.remove('selected'); });
        _renderWelcomeChips();
    },
    'dismiss-welcome': function () { _dismissWelcome(); },
    'dismiss-features-cta': function () {
        var cta = document.getElementById('news-features-cta');
        if (cta)
            cta.classList.add('hidden');
        try {
            OLStorage.setString('ol_features_cta_dismissed', '1');
        }
        catch (_e) { }
    },
    'dismiss-provider-banner': function () {
        var bar = document.getElementById('ol-provider-banner');
        // 2026-04-30 DESIGN audit P0 telemetry — capture the dismiss rate
        // so we can compare against impressions (provider_banner_shown).
        // Read severity from the data-attr set at render time. Fire BEFORE
        // removing the bar so a partial-failure half-state can't leave the
        // event unsent.
        try {
            if (typeof _track === 'function') {
                var severity = bar ? (bar.getAttribute('data-severity') || 'unknown') : 'unknown';
                _track('provider_banner_dismissed', { severity: severity });
            }
        }
        catch (_e) { }
        if (bar && bar.parentNode)
            bar.parentNode.removeChild(bar);
        try {
            var today = new Date().toISOString().slice(0, 10);
            OLStorage.setString('ol_provider_banner_dismissed_' + today, '1');
        }
        catch (_e) { }
    },
    'set-macro-period': function (e) {
        // 2026-04-26 Option B — single time-period selector for the macro index
        // grid. Toggling the tab updates window._olMacroPeriod + localStorage, then
        // re-renders the period-dependent regions so the index cards pick up the new
        // period field (changePct / mmPct / ytdPct / yyPct).
        //
        // Markets-2 (2026-07-15): this used to call the FULL renderMacroView(), which
        // rebuilt the ENTIRE macro view — index cards + calendar strip + yield curve
        // + briefing — so the "ON THE CALENDAR" panel flickered on every MTD/YTD/30D
        // click. It now calls _mvRerenderPeriod(), which replaces ONLY the hero strip
        // + index columns (+ down-day note + tab pressed-state) in place, leaving the
        // calendar / yield-curve / briefing DOM untouched. Falls back to the full
        // render if the scoped path is unavailable or throws.
        var btn = e && e.target ? e.target.closest('[data-action="set-macro-period"]') : null;
        if (!btn)
            return;
        var period = btn.getAttribute('data-period');
        if (!period)
            return;
        window._olMacroPeriod = period;
        try {
            OLStorage.setString('ol_macro_period', period);
        }
        catch (_e) { }
        if (typeof _mvRerenderPeriod === 'function') {
            try {
                _mvRerenderPeriod();
            }
            catch (_e) {
                if (typeof renderMacroView === 'function') {
                    try {
                        renderMacroView();
                    }
                    catch (_e2) { }
                }
            }
        }
        else if (typeof renderMacroView === 'function') {
            try {
                renderMacroView();
            }
            catch (_e) { }
        }
    },
    'welcome-trending-refresh': function () {
        // RU-2 v2 (2026-04-26) — replace the static curated chip list
        // with live tickers from /api/index-movers (existing endpoint).
        // Falls back to the SSR-baked static list if the fetch fails or
        // returns thin data. Fires once on welcome-overlay materialize
        // via a one-shot init below; re-fires only if the user clicks
        // a "refresh" affordance (not yet exposed; reserved for v3).
        var strip = document.querySelector('.welcome-trending-strip');
        if (!strip)
            return;
        fetch('/api/index-movers', { headers: { 'Accept': 'application/json' }, signal: (typeof getViewAwareSignal === 'function' ? getViewAwareSignal(4000) : AbortSignal.timeout(4000)) })
            .then(function (r) { return r.ok ? r.json() : null; })
            .then(function (data) {
            if (!data || !Array.isArray(data) || data.length < 4)
                return;
            // index-movers returns gainers + decliners interleaved. Take 8
            // by impact magnitude (already sorted upstream). Each entry
            // has ticker + name + change_pct.
            var picks = data.slice(0, 8).map(function (m) { return (m.ticker || '').toUpperCase(); }).filter(Boolean);
            if (picks.length < 4)
                return;
            var chips = strip.querySelectorAll('.welcome-trending-chip');
            for (var i = 0; i < chips.length && i < picks.length; i++) {
                chips[i].textContent = picks[i];
                chips[i].setAttribute('data-ticker', picks[i]);
            }
            // Re-label the strip to acknowledge the live source
            var label = strip.querySelector('.welcome-trending-label');
            if (label)
                label.textContent = 'Today\u2019s movers:';
        })
            .catch(function () { });
    },
    'welcome-trending-pick': function (e) {
        // RU-2 (2026-04-26) — trending-strip chip → ticker view + auto-load.
        // Bypasses the welcome-door flow but still writes the same
        // localStorage keys so the user is treated as onboarded.
        var el = e.target.closest('[data-action="welcome-trending-pick"]');
        if (!el)
            return;
        var ticker = el.dataset.ticker;
        if (!ticker)
            return;
        var overlay = document.getElementById('welcome-overlay');
        if (overlay)
            overlay.classList.remove('open');
        try {
            OLStorage.setString('onboardingDone', '1');
            OLStorage.setString('ol_welcome_shown', '1');
            OLStorage.setString('ol_default_view', 'ticker');
            if (!OLStorage.getString('ol_welcome_ts', null)) {
                OLStorage.setString('ol_welcome_ts', String(Date.now()));
            }
        }
        catch (_e) { }
        if (typeof activeTicker !== 'undefined') {
            try {
                activeTicker = ticker;
                if (typeof switchTicker === 'function')
                    switchTicker(ticker);
            }
            catch (_e) { }
        }
        if (typeof setView === 'function')
            setView('ticker');
    },
    'welcome-door': function (_e) {
        // 2026-05-28 (OWNER directive — Surface 2 kill): no-op stub.
        // The welcome-overlay door grid was retired from dashboard.html;
        // there is no DOM remaining for [data-action="welcome-door"] to
        // dispatch from. The named entry stays in the delegated-action
        // map so any cached bundle on a stale tab doesn't ReferenceError;
        // the stub does nothing because the welcome gallery at /welcome
        // (NUS-4.2 welcome-observatory) is now the post-registration
        // opening page and its CTAs route directly via real <a href>s,
        // not the dashboard's delegated-action system. The companion
        // 'exit-door2-focused' action stays wired below to clear any
        // residual ol_door2_focused localStorage from pre-retirement
        // sessions (the safety net that runs on view change).
    },
    'hero-explore': function (e) {
        e.preventDefault();
        _dismissWelcome();
        window.location.href = '/stock/AAPL';
    },
    // Quick ticker chip on welcome screen — fill input and trigger lookup
    'welcome-quick-ticker': function (e) {
        var el = e.target.closest('[data-action]');
        var ticker = el && el.dataset.ticker;
        if (!ticker)
            return;
        var input = document.getElementById('welcome-demo-ticker');
        if (input) {
            input.value = ticker;
        }
        var goBtn = document.getElementById('welcome-demo-go');
        if (goBtn)
            goBtn.click();
    },
    // Surprise Me — pick a random ticker and show it in the demo widget
    'welcome-surprise-me': function () {
        var _surpriseList = ['AAPL', 'TSLA', 'NVDA', 'DIS', 'NFLX', 'AMZN', 'COST', 'SBUX', 'NKE', 'BA', 'SQ', 'PLTR', 'RIVN', 'ABNB', 'SNOW'];
        var pick = _surpriseList[Math.floor(Math.random() * _surpriseList.length)];
        var input = document.getElementById('welcome-demo-ticker');
        if (input) {
            input.value = pick;
        }
        var goBtn = document.getElementById('welcome-demo-go');
        if (goBtn)
            goBtn.click();
    },
    // Legacy step-transition actions (no-ops for backward compat)
    'welcome-use-presets': function () { },
    'welcome-enter-own': function () { },
    'hero-setup': function () { },
    // quickstart-bar removed (mini-CYCLE #1, 2026-04-16) — handlers kept
    // as no-ops so stale localStorage triggers don't throw.
    'dismiss-quickstart': function () { },
    'quickstart-go': function () { },
    'dismiss-buffett-cta': function () { if (typeof dismissBuffettCta === 'function')
        dismissBuffettCta(); },
    'go-home': function (e) {
        // #68 (2026-06-02): the logo is <a href="/" data-action="go-home" title="Home">.
        // The prior setView(default||'ticker') was a NO-OP whenever the user was
        // already on the default view (e.g. ANY /?view=ticker page) — so the Home
        // logo appeared dead, with nothing in Network (a same-view setView issues
        // no request) and the anchor's own "/" navigation evidently suppressed by
        // another document click listener. Navigate EXPLICITLY to the anchor's real
        // href so the logo ALWAYS returns home regardless of the current view.
        // N10 (OWNER 2026-09-25, mobile audit): SUPERSEDES #120. The logo goes to
        // /welcome for EVERYONE, signed in or not; the anon interception that
        // opened the sign-in modal instead is retired (the Sign in button beside
        // the logo is the sign-in path). The anchor's href is /welcome (dashboard.html,
        // OWNER 2026-06-12); /welcome is also the fallback when no href is found.
        // Pinned at runtime by tests/test_mobile_audit_wave2_copy_nav_contract.py.
        if (e && e.preventDefault)
            e.preventDefault();
        var a = (e && e.target && e.target.closest)
            ? e.target.closest('a[href], [data-action="go-home"]')
            : null;
        var href = (a && a.getAttribute && a.getAttribute('href')) || '/welcome';
        window.location.href = href;
    },
    'nav-back': function () { if (typeof _navBack === 'function')
        _navBack();
    else
        history.back(); },
    'nav-forward': function () { if (typeof _navForward === 'function')
        _navForward();
    else
        history.forward(); },
    'set-view': function (e) {
        var el = e.target.closest('[data-action]');
        var view = el && el.dataset.view;
        // Truly external SSR-only pages (not SPA views) keep hard navigation
        var externalUrls = { pricing: '/pricing' };
        if (view && externalUrls[view]) {
            window.location.href = externalUrls[view];
            return;
        }
        if (view)
            setView(view);
    },
    'set-view-close-more': function (e) {
        var el = e.target.closest('[data-action]');
        var view = el && el.dataset.view;
        var externalUrls = { pricing: '/pricing' };
        if (view && externalUrls[view]) {
            window.location.href = externalUrls[view];
            return;
        }
        if (view)
            setView(view);
        if (typeof closeMoreDropdown === 'function')
            closeMoreDropdown();
    },
    'set-view-close-mobile': function (e) {
        var el = e.target.closest('[data-action]');
        var view = el && el.dataset.view;
        var externalUrls = { pricing: '/pricing' };
        if (view && externalUrls[view]) {
            window.location.href = externalUrls[view];
            return;
        }
        if (view)
            setView(view);
    },
    // 'set-view-close-mobile-more' / 'toggle-mobile-more-sheet' /
    // 'close-mobile-more-sheet' retired 2026-05-31 (2g completion) — the mobile
    // overflow sheet they drove was orphaned + removed; views reachable via the
    // hamburger feature-sidecar.
    // I-12 ticker-sheet actions ('open-ticker-sheet' / 'close-ticker-sheet' /
    // 'ticker-sheet-add' / 'ticker-sheet-switch' / 'ticker-sheet-remove')
    // retired 2026-07-06 (#47 wave A2) — the mobile row-2 ticker sheet + its
    // `#ticker-row2-btn` opener were removed from dashboard.html; the driver
    // in mobile-helpers.ts was deleted in the same commit.
    // SF-23 vestige removed 2026-05-17: 'toggle-more-dropdown' /
    // 'expand-all-tools' actions drove the deleted #more-dropdown markup.
    'exit-door2-focused': function () { _exitDoor2Focused(); },
    'open-command-palette': function () { openCommandPalette(); },
    'open-comps-builder': function (e) {
        if (typeof openCompsBuilder === 'function') {
            openCompsBuilder();
            closeMoreDropdown();
            return;
        }
        // Show loading feedback on the button while the comp-builder module lazy-loads
        var btn = e && e.target && e.target.closest('[data-action="open-comps-builder"]');
        var origText = btn ? btn.textContent : null;
        if (btn) {
            btn.textContent = 'Loading\u2026';
            btn.disabled = true;
        }
        _loadModule('comp-builder').then(function () {
            if (btn) {
                btn.textContent = origText;
                btn.disabled = false;
            }
            if (typeof openCompsBuilder === 'function') {
                openCompsBuilder();
                closeMoreDropdown();
            }
        }).catch(function () {
            if (btn) {
                btn.textContent = origText;
                btn.disabled = false;
            }
            _showCanonicalToast('api_unavailable', 'Peer Comparison unavailable \u2014 try again shortly', 4000);
        });
    },
    'open-comps-view': function () { if (typeof setView === 'function')
        setView('comps'); closeMoreDropdown(); },
    'close-comps-builder-backdrop': function (e) { if (e.target === e.target.closest('[data-action="close-comps-builder-backdrop"]') && typeof closeCompsBuilder === 'function')
        closeCompsBuilder(); },
    'random-ticker': function () { if (typeof randomTicker === 'function') {
        randomTicker();
    }
    else {
        _loadModule('screener-options').then(function () { if (typeof randomTicker === 'function')
            randomTicker(); }).catch(function () { if (typeof showToast === 'function')
            showToast('Random ticker unavailable', 'error', 3000); });
    } },
    // 2026-04-26 hotfix: when 'auth-toggle' is fired from inside the Settings
    // panel (z-index: 11000), the auth modal opened at z-index 10001 was
    // landing BEHIND the panel — invisible + non-interactive. Close any open
    // Settings panel first, then open auth. Also: read data-auth-mode so the
    // "Create account" button (data-auth-mode="register") opens the register
    // tab instead of falling back to sign-in.
    'auth-toggle': function (e) {
        var p = document.getElementById('ol-settings-panel');
        if (p && p.getAttribute('data-open') === 'true') {
            p.setAttribute('data-open', 'false');
            p.setAttribute('aria-hidden', 'true');
            document.body.style.overflow = '';
        }
        var btn = e && e.target ? e.target.closest('[data-action="auth-toggle"]') : null;
        var mode = btn ? btn.getAttribute('data-auth-mode') : null;
        if (mode === 'register' && typeof authOpenModal === 'function') {
            authOpenModal('register');
        }
        else if (typeof authToggle === 'function') {
            authToggle();
        }
    },
    'set-view-close-auth-dd': function (e) { setView(e.target.closest('[data-action]').dataset.view); if (typeof authCloseDropdown === 'function')
        authCloseDropdown(); },
    'open-billing-portal-close-dd': function () { _openBillingPortal(); if (typeof authCloseDropdown === 'function')
        authCloseDropdown(); },
    // 'auth-sign-out' duplicate removed 2026-05-15 (top-bar audit P1):
    // this thin handler was last-wins-shadowed by the robust one
    // (~line 2850: e.preventDefault + authSignOut/window.signOut/
    // redirect fallback). De-duped per BUILDER. (A build-lint for
    // duplicate _delegatedActions keys is a queued follow-up — the
    // dup-key class is currently ungated.)
    // CSP-clean replacement for the legacy `href="javascript:location.reload()"`
    // refresh button used by view-router.js + render-error UI.
    'page-reload': function () { try {
        location.reload();
    }
    catch (_e) { } },
    // LEARN: toggle Beginner/Intermediate/Advanced as a filter chip on
    // the modules grid. The handler lives in learning-paths.js (lazy
    // research chunk) and is exposed on window after that chunk loads;
    // here we only need to delegate the click to it.
    'lp-toggle-level': function (e) {
        var btn = e && e.target ? e.target.closest('[data-action="lp-toggle-level"]') : null;
        var lvl = btn ? btn.getAttribute('data-level') : null;
        if (lvl && typeof window._lpToggleLevelFilter === 'function') {
            window._lpToggleLevelFilter(lvl);
        }
    },
    'add-ticker': function () { addTicker(); },
    'remove-ticker': function () { removeTicker(); },
    'dismiss-morning-brief': function () { if (typeof dismissMorningBrief === 'function')
        dismissMorningBrief(); if (typeof trackUniqueAchievement === 'function')
        trackUniqueAchievement('briefs_read', new Date().toDateString()); },
    // S21-F CSP fix 2026-04-05: migrated from inline onclick on the Market
    // Briefing toggle/refresh spans (macro-view.js renderMarketBriefing).
    // Inline handlers were silently blocked by script-src 'self' in prod.
    'briefing-toggle': function () { if (typeof toggleBriefing === 'function')
        toggleBriefing(); },
    'briefing-refresh': function () { if (typeof refreshBriefing === 'function')
        refreshBriefing(); },
    // S21-F 2026-04-05: retry handlers for macro-view loading watchdog +
    // error states. Previously the watchdog used inline onclick attributes
    // which were blocked by script-src 'self' in prod, making every Retry
    // button in the LIVE view non-functional when the server was slow.
    'macro-retry-view': function () { if (typeof renderMacroView === 'function')
        renderMacroView(); },
    'macro-retry-global': function () { if (typeof renderGlobalMarkets === 'function')
        renderGlobalMarkets(); },
    'macro-retry-movers': function () { if (typeof renderIndexMovers === 'function')
        renderIndexMovers(); },
    // M1 (2026-07-14 OWNER prod-QA): the Market Briefing's honest-failure Retry.
    // refreshBriefing() re-fetches /api/headlines?refresh=1, clears the failed
    // flag on success, and re-renders — so a transient stall is one click from
    // recovering instead of an indefinite "Headlines loading…".
    'macro-retry-briefing': function () { if (typeof refreshBriefing === 'function')
        refreshBriefing(); },
    'personal-briefing': function (e) {
        var actionEl = (e && e.target) ? e.target.closest('[data-action]') : null;
        var promptType = actionEl ? (actionEl.getAttribute('data-prompt') || 'market') : 'market';
        var portfolioList = (typeof PORTFOLIO_TICKERS !== 'undefined' && PORTFOLIO_TICKERS.length > 0)
            ? 'My portfolio: ' + PORTFOLIO_TICKERS.join(', ') + '. '
            : '';
        var watchlistStr = '';
        var wl = OLStorage.get('ol_watchlist', []);
        if (wl.length > 0)
            watchlistStr = 'My watchlist: ' + wl.map(function (w) { return w.ticker || w; }).join(', ') + '. ';
        var prompts = {
            market: 'Give me a market briefing for today. What are the key moves across major indices, rates, commodities, and FX, what should I watch, and what is the overall market sentiment? Keep it general — do not focus on any specific portfolio.',
            portfolio: portfolioList + watchlistStr + 'Is there any recent news affecting my portfolio or watchlist holdings? Flag anything I should pay attention to - earnings, analyst changes, insider activity, or price moves.',
            sectors: 'What are the strongest and weakest sectors today? Any notable sector rotations or trends developing this week? Which sectors are outperforming and why?',
            risks: portfolioList + 'What are the biggest risks in the market right now? Flag any macro concerns, geopolitical events, upcoming economic data releases, or earnings that could create volatility for my holdings.',
        };
        function _openAndSend() {
            if (typeof toggleAskAiPanel === 'function')
                toggleAskAiPanel(true);
            setTimeout(function () {
                var input = document.getElementById('askai-question') || document.getElementById('askai-input');
                if (input) {
                    input.value = prompts[promptType] || prompts.market;
                    input.focus();
                    if (typeof _askAiSubmit === 'function')
                        _askAiSubmit();
                }
            }, 300);
        }
        if (typeof toggleAskAiPanel === 'function') {
            _openAndSend();
        }
        else {
            _loadChunk('premium').then(function () { setTimeout(_openAndSend, 100); }).catch(function () { showToast('Unable to load AI panel', 'error'); });
        }
    },
    'toggle-ask-ai-panel': function () {
        if (typeof toggleAskAiPanel === 'function') {
            toggleAskAiPanel();
            return;
        }
        // ask-ai.js is in the premium chunk; same standalone-fetch 502
        // failure mode as api-keys above.
        _loadChunk('premium').then(function () { if (typeof toggleAskAiPanel === 'function')
            toggleAskAiPanel(); }).catch(function () { showToast('Unable to load AI panel', 'error'); });
    },
    'trade-btn-click': function (e) { _tradeBtnClick(e); },
    'toggle-share-dropdown': function (e) {
        // 2026-06-19 audit Phase-1 [Low]: keep aria-expanded in sync so AT
        // announces the share menu's open/closed state.
        var _btn = e.target.closest('[data-action]');
        var _open = _btn.nextElementSibling.classList.toggle('show');
        _btn.setAttribute('aria-expanded', _open ? 'true' : 'false');
    },
    'share-copy-card': function (e) { e.preventDefault(); if (typeof generateShareCard === 'function')
        generateShareCard(); if (typeof trackUniqueAchievement === 'function')
        trackUniqueAchievement('shares_total', (activeTicker || '') + '_card'); e.target.closest('.trade-dropdown').classList.remove('show'); },
    'share-copy-summary': function (e) { e.preventDefault(); if (typeof copyTickerSummary === 'function')
        copyTickerSummary(); e.target.closest('.trade-dropdown').classList.remove('show'); },
    'share-deep-link': function (e) { e.preventDefault(); if (typeof copyDeepLink === 'function')
        copyDeepLink(); if (typeof trackUniqueAchievement === 'function')
        trackUniqueAchievement('shares_total', (activeTicker || '') + '_deeplink'); e.target.closest('.trade-dropdown').classList.remove('show'); },
    'share-export-pdf': function (e) { e.preventDefault(); if (typeof exportTickerPDF === 'function')
        exportTickerPDF(); e.target.closest('.trade-dropdown').classList.remove('show'); },
    'share-export-report': function (e) { e.preventDefault(); if (typeof TierGate !== 'undefined' && TierGate.canCall && !TierGate.canCall('/api/export/report') && typeof showToast === 'function') {
        showToast('Report export is a Researcher feature. <a href="/?upgrade=plus" class="toast-link">Upgrade to Researcher</a>', '', 5000, { html: true });
        var _ddg = e.target.closest('.trade-dropdown');
        if (_ddg)
            _ddg.classList.remove('show');
        return;
    } if (typeof activeTicker !== 'undefined' && activeTicker) {
        window.open('/api/export/report?symbol=' + encodeURIComponent(activeTicker) + '&format=html', '_blank', 'noopener,noreferrer');
    }
    else {
        showToast('No ticker loaded', 'warning');
    } var _dd = e.target.closest('.trade-dropdown'); if (_dd)
        _dd.classList.remove('show'); },
    'close-share-dropdown': function (e) { var dd = e.target.closest('.trade-dropdown'); if (dd)
        dd.classList.remove('show'); },
    'toggle-focus-mode': function () { toggleFocusMode(); },
    'refresh-current': function () { refreshCurrent(); },
    'toggle-hero-details': function () { toggleHeroDetails(); },
    'toggle-credit-overlay': function () { toggleCreditOverlay(); },
    'navigate-credit-view': function (e) { e.preventDefault(); setView('credit'); },
    'set-chart-mode': function (e) { if (typeof setChartMode === 'function')
        setChartMode(e.target.closest('[data-action]').dataset.mode); },
    'chart-reset-zoom': function () { if (typeof chartResetZoom === 'function')
        chartResetZoom(); },
    'export-chart-png': function () { if (typeof exportChartPNG === 'function')
        exportChartPNG(); },
    'toggle-indicator': function (e) { if (typeof toggleIndicator === 'function')
        toggleIndicator(e.target.closest('[data-action]').dataset.ind); },
    'toggle-vwap': function () { if (typeof toggleVWAP === 'function')
        toggleVWAP(); },
    'toggle-peers-panel': function () { if (typeof togglePeersPanel === 'function')
        togglePeersPanel(); },
    'open-peer-edit-modal': function (e) { e.stopPropagation(); if (typeof openPeerEditModal === 'function')
        openPeerEditModal(); },
    'toggle-ann-compose': function () { var box = document.getElementById('annotations-compose'); if (!box)
        return; var vis = !box.classList.contains('d-none'); if (vis) {
        box.classList.add('d-none');
        box.classList.remove('d-flex');
    }
    else {
        box.classList.remove('d-none');
        box.classList.add('d-flex');
    } var _annToggle = document.getElementById('ann-compose-toggle'); if (_annToggle)
        _annToggle.textContent = vis ? '+ Add annotation' : '- Cancel'; },
    'set-ann-cat': function (e) { _setAnnCat(e.target.closest('[data-action]')); },
    'post-annotation': function () { _postAnnotation(); },
    'apply-payoff-strategy': function (e) { if (typeof applyPayoffStrategy === 'function')
        applyPayoffStrategy(e.target.closest('[data-action]').dataset.strategy); },
    'clear-payoff-legs': function () { if (typeof clearPayoffLegs === 'function')
        clearPayoffLegs(); },
    'add-payoff-leg': function () { if (typeof addPayoffLeg === 'function')
        addPayoffLeg(); },
    'search-13f-ticker': function () { search13fTicker(); },
    'download-13f-csv': function () { _download13fCSV(); },
    'search-13f-fund': function () { search13fFund(); },
    'try-13f-fund': function (e) { var _f13 = document.getElementById('f13-fund-input'); if (_f13)
        _f13.value = e.target.closest('[data-action]').dataset.fundName; search13fFund(); },
    // 2026-05-12 (user-flagged): RANDOM buttons on the 13F view's
    // left + right panels. Mirrors the screener/BDC random-pick
    // pattern. Curated pools — left = high-recognition tickers
    // across sectors so users learn the surface; right = featured
    // 13F filers with public-interest portfolios.
    'random-13f-ticker': function () {
        var _f13_tickers = ['AAPL', 'MSFT', 'NVDA', 'GOOGL', 'AMZN', 'META', 'TSLA', 'BRK.B', 'JPM', 'V', 'JNJ', 'WMT', 'PG', 'XOM', 'KO', 'DIS', 'NFLX', 'BA', 'COST', 'CRM'];
        var _inp = document.getElementById('f13-ticker-input');
        if (_inp)
            _inp.value = _f13_tickers[Math.floor(Math.random() * _f13_tickers.length)];
        if (typeof search13fTicker === 'function')
            search13fTicker();
    },
    'random-13f-fund': function () {
        var _f13_funds = ['Berkshire Hathaway', 'ARK', 'Bridgewater', 'Point72', 'Tiger Global', 'Renaissance', 'Citadel', 'Two Sigma', 'D.E. Shaw', 'Pershing Square', 'Greenlight', 'Baupost', 'Third Point', 'Appaloosa', 'Sequoia Fund'];
        var _inp = document.getElementById('f13-fund-input');
        if (_inp)
            _inp.value = _f13_funds[Math.floor(Math.random() * _f13_funds.length)];
        if (typeof search13fFund === 'function')
            search13fFund();
    },
    'sotd-explore': function () { sotdExplore(); },
    'load-live-headlines': function () { loadLiveHeadlines(); },
    'load-prior-headlines': function () { loadPriorHeadlines(false); },
    'load-more-prior': function () { loadPriorHeadlines(true); },
    'toggle-ind-compare': function () { if (typeof toggleIndCompare === 'function')
        toggleIndCompare();
    else if (typeof showToast === 'function')
        showToast('Compare loading\u2026', 'info', 2000); },
    'set-portfolio-tab': function (e) {
        // #82: this was the lone handler in this map calling its fn BARE (no typeof
        // guard like every sibling). If the core-portfolio chunk (portfolio.ts,
        // which owns setPortfolioTab) hasn't hydrated — or failed to load (#63 chunk
        // class) — `setPortfolioTab(...)` threw a ReferenceError and the tab never
        // switched. Guard + lazy-load the chunk, then apply. Also null-safe on the
        // closest() lookup (same deref-crash class noted in setPortfolioTab itself).
        var btn = e && e.target && e.target.closest ? e.target.closest('[data-action]') : null;
        if (!btn)
            return;
        var tab = btn.dataset.tab;
        if (typeof setPortfolioTab === 'function') {
            setPortfolioTab(tab);
            return;
        }
        if (typeof _loadChunk === 'function') {
            _loadChunk('core-portfolio').then(function () {
                if (typeof setPortfolioTab === 'function')
                    setPortfolioTab(tab);
            }).catch(function () { if (typeof showToast === 'function')
                showToast('Portfolio tools are still loading…', 'info', 2000); });
        }
    },
    'export-portfolio-csv': function () { if (typeof TierGate !== 'undefined' && TierGate.canCall && !TierGate.canCall('/api/export') && typeof showToast === 'function') {
        showToast('CSV export is a Researcher feature. <a href="/?upgrade=plus" class="toast-link">Upgrade to Researcher</a>', '', 5000, { html: true });
        return;
    } window.location.href = '/api/export?type=portfolio'; if (typeof trackUniqueAchievement === 'function')
        trackUniqueAchievement('exports_total', 'portfolio_' + new Date().toDateString()); },
    'import-portfolio': function () { if (typeof openPortfolioImportModal === 'function')
        openPortfolioImportModal(); },
    'heatmap-sector-click': function (e) { var sector = e.target.closest('[data-action]').dataset.sector; if (sector && typeof showToast === 'function')
        showToast(sector + ' sector selected', '', 2000); },
    'port-import-csv': function () { if (typeof openPortfolioImportModal === 'function')
        openPortfolioImportModal(); },
    'port-import-paste': function () { if (typeof openPortfolioImportModal === 'function') {
        openPortfolioImportModal();
        setTimeout(function () { var b = document.querySelector('[data-tab=paste]'); if (b)
            b.click(); }, 100);
    } },
    'port-import-template': function () { if (typeof downloadPortfolioTemplate === 'function')
        downloadPortfolioTemplate(); },
    // Portfolio Phase 4: migrated inline onclick → data-action delegation
    'port-sort': function (e) { var col = parseInt(e.target.closest('[data-action]').dataset.col, 10); if (typeof sortPortfolio === 'function')
        sortPortfolio(col); },
    'port-perf-mode': function (e) { e.stopPropagation(); var m = e.target.closest('[data-action]').dataset.mode; window._portfolioPerfMode = m; if (typeof renderPortfolio === 'function')
        renderPortfolio(); },
    'port-switch-ticker': function (e) { var el = e.target.closest('[data-action="port-switch-ticker"]'); if (!el)
        return; if (e.target.closest('[data-action="port-open-cost-basis"], [data-action="port-remove-ticker"], [data-action="port-perf-mode"], [data-action="port-sort"]'))
        return; var t = el.dataset.ticker; if (t && typeof switchTicker === 'function')
        switchTicker(t); },
    'port-open-cost-basis': function (e) { e.stopPropagation(); var t = e.target.closest('[data-action]').dataset.ticker; if (t && typeof openCostBasisModal === 'function')
        openCostBasisModal(t); },
    'port-remove-ticker': function (e) { e.stopPropagation(); var t = e.target.closest('[data-action]').dataset.ticker; if (t && typeof removePortfolioTicker === 'function')
        removePortfolioTicker(t); },
    'port-focus-search': function () { var inp = document.getElementById('ticker-input'); if (inp)
        inp.focus(); },
    'port-close-modal': function (e) { var ov = e.target.closest('.cb-modal-overlay'); if (ov)
        ov.remove(); },
    'port-save-cost-basis': function (e) { var t = e.target.closest('[data-action]').dataset.ticker; if (t && typeof saveCostBasis === 'function')
        saveCostBasis(t); },
    // v3 product portfolio surface (static/js/product/surfaces/portfolio.ts):
    // wire its inline cost-basis form Save (previously a dead data-action) +
    // the per-row edit/remove buttons. Each delegates to OLProduct.surfaces.*.
    'port-save-cost-basis-inline': function (e) { if (e && e.preventDefault)
        e.preventDefault(); var s = window.OLProduct && window.OLProduct.surfaces; if (s && typeof s.saveCostBasisInline === 'function')
        s.saveCostBasisInline(); },
    'port-cb-edit': function (e) { e.stopPropagation(); var t = e.target.closest('[data-action]').dataset.ticker; var s = window.OLProduct && window.OLProduct.surfaces; if (t && s && typeof s.editCostBasis === 'function')
        s.editCostBasis(t); },
    'port-cb-remove': function (e) { e.stopPropagation(); var t = e.target.closest('[data-action]').dataset.ticker; var s = window.OLProduct && window.OLProduct.surfaces; if (t && s && typeof s.removePosition === 'function')
        s.removePosition(t); },
    'port-cb-undo-remove': function () { var s = window.OLProduct && window.OLProduct.surfaces; if (s && typeof s.undoRemovePosition === 'function')
        s.undoRemovePosition(); },
    // X2 (2026-07-14 OWNER prod-QA): retry a stuck portfolio quote (the "Couldn't
    // load — Retry" affordance the no-quote row surfaces after one failed sync).
    'port-retry-quote': function (e) { e.stopPropagation(); var el = e.target.closest('[data-action="port-retry-quote"]'); if (!el)
        return; var t = el.dataset.ticker; var s = window.OLProduct && window.OLProduct.surfaces; if (t && s && typeof s.retryQuote === 'function')
        s.retryQuote(t); },
    'port-import-tab': function (e) { var el = e.target.closest('[data-action]'); var tab = el.dataset.tabTarget; if (tab && typeof switchImportTab === 'function')
        switchImportTab(el, tab); },
    'port-trigger-file-input': function (e) { if (e.target.closest('#import-csv-file'))
        return; var fi = document.getElementById('import-csv-file'); if (fi)
        fi.click(); },
    'port-preview-paste': function () { if (typeof previewPasteImport === 'function')
        previewPasteImport(); },
    'port-confirm-import': function () { if (typeof confirmPortfolioImport === 'function')
        confirmPortfolioImport(); },
    'port-close-and-import': function (e) { var ov = e.target.closest('.cb-modal-overlay'); if (ov)
        ov.remove(); if (typeof openPortfolioImportModal === 'function')
        openPortfolioImportModal(); },
    // F9 (Code-Review-Cowork audit 2026-05-12): per-broker "Notify me"
    // waitlist signup. POSTs to /api/waitlist/broker-sync which emits a
    // Sentry breadcrumb (no DB write yet — OWNER call on schema). On
    // success the button text confirms inline; on failure it falls back
    // to a toast so the user knows it didn't go through silently.
    'port-broker-notify': function (e) {
        var btn = e.target.closest('[data-action="port-broker-notify"]');
        if (!btn || btn.disabled)
            return;
        var brokerId = btn.dataset.brokerId || '';
        var brokerName = btn.dataset.brokerName || brokerId;
        if (!brokerId)
            return;
        btn.disabled = true;
        btn.textContent = 'Sending…';
        try {
            fetch('/api/waitlist/broker-sync', {
                method: 'POST',
                credentials: 'same-origin',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ broker_id: brokerId }),
                signal: AbortSignal.timeout(15000), // FE review 2026-07-19 P2: button was stuck at "Sending..." on a hang
            })
                .then(function (r) { return r.ok ? r.json() : Promise.reject('HTTP ' + r.status); })
                .then(function () {
                btn.textContent = 'On the list';
                btn.classList.add('port-broker-notify--done');
            })
                .catch(function () {
                btn.disabled = false;
                btn.textContent = 'Notify me';
                if (typeof showToast === 'function') {
                    showToast("Couldn't sign you up for " + brokerName + " updates. Try again in a moment.", 'error', 4000);
                }
            });
        }
        catch (_e) {
            btn.disabled = false;
            btn.textContent = 'Notify me';
        }
    },
    'connect-broker': function () { if (typeof openBrokerConnectModal === 'function')
        openBrokerConnectModal(); },
    'set-weight-mode': function (e) { if (typeof setWeightMode === 'function')
        setWeightMode(e.target.closest('[data-action]').dataset.mode); },
    'toggle-port-cols': function (e) { togglePortCols(e.target.closest('[data-action]')); },
    'cal-upcoming': function () { calShowAll = false; calLookback = 365; calRenderCap = 250; if (typeof renderCalendarView === 'function')
        renderCalendarView(); },
    'cal-1y': function () { calShowAll = true; calLookback = 365; calRenderCap = 250; if (typeof renderCalendarView === 'function')
        renderCalendarView(); },
    'cal-2y': function () { calShowAll = true; calLookback = 730; calRenderCap = 250; if (typeof renderCalendarView === 'function')
        renderCalendarView(); },
    'cal-toggle-econ': function (e) { calShowEcon = !calShowEcon; calRenderCap = 250; e.target.closest('[data-action]').classList.toggle('active'); if (typeof renderCalendarView === 'function')
        renderCalendarView(); },
    'cal-toggle-ticker': function (e) { calShowTicker = !calShowTicker; calRenderCap = 250; e.target.closest('[data-action]').classList.toggle('active'); if (typeof renderCalendarView === 'function')
        renderCalendarView(); },
    'cal-toggle-type': function (e) { var el = e.target.closest('[data-action]'); toggleCalType(el.dataset.calType, el); },
    'cal-toggle-div-forecast': function (e) { calShowDivForecast = !calShowDivForecast; e.target.closest('[data-action]').classList.toggle('active'); if (typeof renderCalendarView === 'function')
        renderCalendarView(); },
    'load-sample-bonds': function () {
        if (typeof loadSampleBonds === 'function') {
            loadSampleBonds();
            return;
        }
        var el = document.getElementById('credit-watchlist-table');
        if (el)
            el.innerHTML = '<div class="status-msg status-msg--muted">Loading sample bonds...</div>';
        fetch(((typeof SERVER !== 'undefined') ? SERVER : '') + '/api/credit/watchlist', { signal: (typeof getViewAwareSignal === 'function' ? getViewAwareSignal(15000) : AbortSignal.timeout(15000)) })
            .then(function (r) { return r.ok ? r.json() : Promise.reject('HTTP ' + r.status); })
            .then(function (data) {
            var bonds = Array.isArray(data) ? data : (data && data.bonds ? data.bonds : []);
            if (!bonds.length) {
                if (el)
                    el.innerHTML = '<div class="status-msg status-msg--muted">No sample bonds available.</div>';
                return;
            }
            // K12 (2026-09-14): no CUSIP column. The credit/bond view was
            // COUNSEL 2026-08-07 sect.1A row 9 -- a table cell, a detail-card
            // meta line and a search-result subtitle all printed the identifier.
            var rows = '';
            for (var i = 0; i < Math.min(bonds.length, 20); i++) {
                var b = bonds[i];
                rows += '<tr><td class="td-primary">' + escHtml(b.issuer || b.name || b.label || '') + '</td>'
                    + '<td class="td-data">' + (b.coupon != null ? b.coupon + '%' : '\u2014') + '</td>'
                    + '<td class="td-muted">' + escHtml(b.maturity || '') + '</td></tr>';
            }
            if (el)
                _safeSetHTML(el, '<table class="data-table"><thead><tr><th>Issuer</th><th class="text-right">Coupon</th><th class="text-right">Maturity</th></tr></thead><tbody>' + rows + '</tbody></table>');
        })
            .catch(function () { if (el)
            el.innerHTML = '<div class="status-msg status-msg--muted">Failed to load sample bonds.</div>'; });
    },
    'load-random-bond': function () {
        if (typeof loadRandomBond === 'function') {
            loadRandomBond();
            return;
        }
        var el = document.getElementById('credit-preview') || document.getElementById('credit-watchlist-table');
        if (el)
            el.innerHTML = '<div class="status-msg status-msg--muted">Loading random bond...</div>';
        fetch(((typeof SERVER !== 'undefined') ? SERVER : '') + '/api/credit/bond?random=1', { signal: (typeof getViewAwareSignal === 'function' ? getViewAwareSignal(15000) : AbortSignal.timeout(15000)) })
            .then(function (r) { return r.ok ? r.json() : Promise.reject('HTTP ' + r.status); })
            .then(function (b) {
            if (!b || b.error) {
                if (el)
                    el.innerHTML = '<div class="status-msg status-msg--muted">' + escHtml((b && b.error) || 'No bond data available.') + '</div>';
                return;
            }
            var html = '<div class="detail-card">'
                + '<div class="detail-card__title">' + escHtml(b.issuer || b.name || 'Bond') + '</div>'
                + (b.coupon != null ? '<div class="detail-card__meta">Coupon: ' + b.coupon + '%</div>' : '')
                + (b.maturity ? '<div class="detail-card__meta">Maturity: ' + escHtml(b.maturity) + '</div>' : '')
                + (b.price != null ? '<div class="detail-card__price">Price: $' + Number(b.price).toFixed(2) + '</div>' : '')
                + (b.yield_pct != null ? '<div class="detail-card__yield">Yield: ' + Number(b.yield_pct).toFixed(3) + '%</div>' : '')
                + '</div>';
            if (el)
                _safeSetHTML(el, html);
        })
            .catch(function () { if (el)
            el.innerHTML = '<div class="status-msg status-msg--muted">Failed to load bond.</div>'; });
    },
    'credit-lookup-and-add': function () {
        if (typeof creditLookupAndAdd === 'function') {
            creditLookupAndAdd();
            return;
        }
        var cusipIn = document.getElementById('credit-cusip-input');
        var labelIn = document.getElementById('credit-label-input');
        var preview = document.getElementById('credit-preview');
        if (!cusipIn || !cusipIn.value.trim()) {
            if (preview)
                preview.innerHTML = '<div class="status-msg status-msg--error">Enter a CUSIP.</div>';
            return;
        }
        var cusip = cusipIn.value.trim().toUpperCase();
        if (preview)
            preview.innerHTML = '<div class="status-msg status-msg--muted">Looking up ' + escHtml(cusip) + '...</div>';
        // K12 (2026-09-14): GET /api/credit/bond is retired (410 Gone). The body
        // is parsed on EVERY status so the server's one-line reason is what the
        // user reads, not a generic "lookup failed".
        fetch(((typeof SERVER !== 'undefined') ? SERVER : '') + '/api/credit/bond?cusip=' + encodeURIComponent(cusip), { signal: (typeof getViewAwareSignal === 'function' ? getViewAwareSignal(15000) : AbortSignal.timeout(15000)) })
            .then(function (r) { return r.json(); })
            .then(function (b) {
            if (!b || b.error) {
                if (preview)
                    preview.innerHTML = '<div class="status-msg status-msg--error">' + escHtml((b && b.error) || ('Bond not found for ' + cusip + '.')) + '</div>';
                return;
            }
            var html = '<div class="detail-card detail-card--success">'
                + '<div class="detail-card__added">Bond Added</div>'
                + '<div class="detail-card__title">' + escHtml(b.issuer || b.name || 'Bond') + '</div>'
                + (b.coupon != null ? '<div class="detail-card__meta">Coupon: ' + b.coupon + '%</div>' : '')
                + (b.maturity ? '<div class="detail-card__meta">Maturity: ' + escHtml(b.maturity) + '</div>' : '')
                + (b.price != null ? '<div class="detail-card__price">Price: $' + Number(b.price).toFixed(2) + '</div>' : '')
                + '</div>';
            if (preview)
                _safeSetHTML(preview, html);
        })
            .catch(function () { if (preview)
            preview.innerHTML = '<div class="status-msg status-msg--error">Lookup failed for ' + escHtml(cusip) + '.</div>'; });
    },
    'run-credit-batch': function () { if (typeof runCreditBatch === 'function')
        runCreditBatch(); },
    'download-credit-batch-csv': function () { if (typeof _downloadCreditBatchCSV === 'function')
        _downloadCreditBatchCSV(); },
    'load-credit-portfolio': function () {
        if (typeof loadCreditPortfolio === 'function') {
            loadCreditPortfolio();
            return;
        }
        var el = document.getElementById('credit-portfolio-table');
        if (el)
            el.innerHTML = '<div class="status-msg status-msg--muted">Loading portfolio credit data...</div>';
        var ptickers = (typeof PORTFOLIO_TICKERS !== 'undefined' ? PORTFOLIO_TICKERS : []).concat(typeof tickers !== 'undefined' ? tickers : []);
        var unique = [];
        var seen = {};
        for (var i = 0; i < ptickers.length; i++) {
            if (!seen[ptickers[i]]) {
                seen[ptickers[i]] = 1;
                unique.push(ptickers[i]);
            }
        }
        if (!unique.length) {
            if (el)
                el.innerHTML = '<div class="status-msg status-msg--muted">No tickers in portfolio.</div>';
            return;
        }
        fetch(((typeof SERVER !== 'undefined') ? SERVER : '') + '/api/credit/portfolio?tickers=' + encodeURIComponent(unique.join(',')), { signal: (typeof getViewAwareSignal === 'function' ? getViewAwareSignal(15000) : AbortSignal.timeout(15000)) })
            .then(function (r) { return r.ok ? r.json() : Promise.reject('HTTP ' + r.status); })
            .then(function (data) {
            var items = Array.isArray(data) ? data : (data && data.companies ? data.companies : []);
            if (!items.length) {
                if (el)
                    el.innerHTML = '<div class="status-msg status-msg--muted">No credit data available.</div>';
                return;
            }
            var rows = '';
            for (var j = 0; j < items.length; j++) {
                var c = items[j];
                var ratingCls = (c.rating || '').indexOf('A') === 0 ? 'td-green' : (c.rating || '').indexOf('B') === 0 ? 'td-gold' : '';
                rows += '<tr><td class="td-primary">' + escHtml(c.ticker || '') + '</td>'
                    + '<td class="' + ratingCls + '">' + escHtml(c.rating || '\u2014') + '</td>'
                    + '<td class="td-data">' + (c.debt_to_equity != null ? c.debt_to_equity.toFixed(2) + 'x' : '\u2014') + '</td></tr>';
            }
            if (el)
                _safeSetHTML(el, '<table class="data-table"><thead><tr><th>Ticker</th><th>Rating</th><th class="text-right">D/E</th></tr></thead><tbody>' + rows + '</tbody></table>');
        })
            .catch(function () { if (el)
            el.innerHTML = '<div class="status-msg status-msg--muted">Credit portfolio data unavailable.</div>'; });
    },
    'set-fund-period': function (e) { _setFundPeriod(e.target.closest('[data-action]').dataset.period); },
    'download-fundamentals-csv': function () { if (typeof _downloadFundamentalsCSV === 'function')
        _downloadFundamentalsCSV(); if (typeof trackUniqueAchievement === 'function')
        trackUniqueAchievement('exports_total', (activeTicker || 'fundamentals') + '_' + new Date().toDateString()); },
    // 2026-05-20 OWNER prod-QA #228: in-page ticker switcher on
    // /?view=fundamentals — user types a ticker and presses Enter,
    // dispatcher calls switchTicker which updates activeTicker +
    // URL + re-renders. Input is in static/templates/fundamentals-
    // view.html (#fundamentals-ticker-switch).
    'fundamentals-switch-ticker': function (e) {
        var input = e.target;
        if (!input || typeof input.value !== 'string')
            return;
        var t = input.value.trim().toUpperCase();
        if (!t || !/^[A-Z][A-Z0-9.\-]{0,9}$/.test(t))
            return;
        input.value = '';
        if (typeof switchTicker === 'function')
            switchTicker(t);
    },
    'download-screener-csv': function () { if (typeof _downloadScreenerCSV === 'function')
        _downloadScreenerCSV(); if (typeof trackUniqueAchievement === 'function')
        trackUniqueAchievement('exports_total', 'screener_' + new Date().toDateString()); },
    'apply-screener-preset': function (e) {
        var btn = e && e.target ? e.target.closest('[data-preset-id]') : null;
        var pid = btn ? btn.getAttribute('data-preset-id') : '';
        if (pid && typeof _applyScreenerPreset === 'function')
            _applyScreenerPreset(pid);
    },
    'clear-screener-preset': function () {
        if (typeof _clearScreenerPreset === 'function')
            _clearScreenerPreset();
        if (typeof _updateSaveButtonVisibility === 'function')
            _updateSaveButtonVisibility();
    },
    // S4: custom preset CRUD (localStorage-only)
    'save-custom-preset': function () {
        if (typeof _showSavePresetForm === 'function')
            _showSavePresetForm();
    },
    'submit-save-preset': function () {
        var input = document.getElementById('scr-preset-save-name');
        var name = input ? input.value : '';
        if (typeof _saveCustomPreset === 'function')
            _saveCustomPreset(name);
    },
    'cancel-save-preset': function () {
        if (typeof _hideSavePresetForm === 'function')
            _hideSavePresetForm();
    },
    'delete-custom-preset': function (e) {
        var btn = e && e.target ? e.target.closest('[data-preset-id]') : null;
        var pid = btn ? btn.getAttribute('data-preset-id') : '';
        if (pid && typeof _deleteCustomPreset === 'function')
            _deleteCustomPreset(pid);
    },
    'run-mf-screener': function () { if (typeof runMultiFactorScreener === 'function')
        runMultiFactorScreener(); },
    'run-screener': function () {
        if (typeof trackUniqueAchievement === 'function')
            trackUniqueAchievement('screener_runs', new Date().toDateString());
        if (typeof runScreener === 'function') {
            runScreener();
            return;
        }
        var resEl = document.getElementById('screener-results') || document.getElementById('inline-screener-results');
        if (!resEl)
            return;
        resEl.innerHTML = '<div class="status-msg status-msg--muted">Running screener...</div>';
        // Same map as screener-options.ts _scrFilterParams (which is not loaded
        // when this branch runs): every control's data-scr-param, divided by
        // data-scr-div ($M -> $B for market cap, #44). This list used to name six
        // controls by hand and dropped P/E, EV/EBITDA, yield, P/B and ROE.
        var params = [];
        var scrEls = document.querySelectorAll('[data-scr-param]');
        for (var si = 0; si < scrEls.length; si++) {
            var scrVal = String(scrEls[si].value == null ? '' : scrEls[si].value).trim();
            if (!scrVal)
                continue;
            var scrDiv = Number(scrEls[si].getAttribute('data-scr-div'));
            params.push(scrEls[si].getAttribute('data-scr-param') + '=' + encodeURIComponent(scrDiv ? Number(scrVal) / scrDiv : scrVal));
        }
        var url = ((typeof SERVER !== 'undefined') ? SERVER : '') + '/api/screener' + (params.length ? '?' + params.join('&') : '');
        fetch(url, { signal: AbortSignal.timeout(15000) })
            .then(function (r) { return r.ok ? r.json() : Promise.reject('HTTP ' + r.status); })
            .then(function (data) {
            var stocks = Array.isArray(data) ? data : (data && data.results ? data.results : []);
            var universe = (data && typeof data.universe_size === 'number') ? data.universe_size : null;
            var covNote = (data && data.coverage_note) ? String(data.coverage_note) : '';
            var banner = '';
            if (universe != null) {
                banner = '<div class="status-msg status-msg--muted app-screener-banner">'
                    + 'Showing ' + stocks.length + ' of ' + universe.toLocaleString() + ' tickers scanned'
                    + (covNote ? ' \u2014 ' + escHtml(covNote) : '')
                    + '</div>';
            }
            if (!stocks.length) {
                _safeSetHTML(resEl, banner + '<div class="status-msg status-msg--muted">No results match your filters.</div>');
                return;
            }
            var rows = '';
            for (var i = 0; i < Math.min(stocks.length, 50); i++) {
                var s = stocks[i];
                rows += '<tr class="ol-cursor-pointer" data-action="switch-ticker" data-ticker="' + escHtml(s.ticker || s.symbol || '') + '">'
                    + '<td class="td-primary">' + escHtml(s.ticker || s.symbol || '') + '</td>'
                    + '<td>' + escHtml(s.name || s.company || '') + '</td>'
                    + '<td class="td-data">' + (s.price != null ? '$' + Number(s.price).toFixed(2) : '\u2014') + '</td>'
                    + '<td class="td-gold">' + (s.score != null ? s.score : '\u2014') + '</td>'
                    + '</tr>';
            }
            _safeSetHTML(resEl, banner + '<table class="data-table"><thead><tr><th>Ticker</th><th>Company</th><th class="text-right">Price</th><th class="text-right">Score</th></tr></thead><tbody>' + rows + '</tbody></table>');
        })
            .catch(function () { resEl.innerHTML = '<div class="status-msg status-msg--muted">Screener unavailable. Try again later.</div>'; });
    },
    'bdc-search-borrower': function () {
        if (typeof bdcSearchBorrower === 'function') {
            bdcSearchBorrower();
            return;
        }
        var inp = document.getElementById('bdc-borrower-input');
        var el = document.getElementById('bdc-borrower-results');
        if (!inp || !inp.value.trim()) {
            if (el)
                el.innerHTML = '<div class="status-msg status-msg--error">Enter a borrower name.</div>';
            return;
        }
        if (el)
            el.innerHTML = '<div class="status-msg status-msg--muted">Searching...</div>';
        fetch(((typeof SERVER !== 'undefined') ? SERVER : '') + '/api/bdc/borrower?q=' + encodeURIComponent(inp.value.trim()), { signal: (typeof getViewAwareSignal === 'function' ? getViewAwareSignal(15000) : AbortSignal.timeout(15000)) })
            .then(function (r) { return r.ok ? r.json() : Promise.reject('HTTP ' + r.status); })
            .then(function (data) {
            var results = Array.isArray(data) ? data : (data && data.results ? data.results : (data && data.borrowers ? data.borrowers : []));
            if (!results.length) {
                if (el)
                    el.innerHTML = '<div class="status-msg status-msg--muted">No borrowers found for "' + escHtml(inp.value.trim()) + '".</div>';
                return;
            }
            var html = '<div class="search-results-list">';
            for (var i = 0; i < Math.min(results.length, 25); i++) {
                var b = results[i];
                html += '<div class="search-result-row">'
                    + '<div><div class="search-result-row__name">' + escHtml(b.borrower || b.name || b.company || '') + '</div>'
                    + (b.bdc_ticker || b.bdc ? '<div class="search-result-row__sub">Lender: ' + escHtml(b.bdc_ticker || b.bdc || '') + '</div>' : '')
                    + '</div>'
                    + (b.amount || b.investment ? '<div class="search-result-row__value">' + (b.amount ? '$' + Number(b.amount).toLocaleString() : escHtml(b.investment || '')) + '</div>' : '')
                    + '</div>';
            }
            html += '</div>';
            if (el)
                _safeSetHTML(el, html);
        })
            .catch(function () { if (el)
            el.innerHTML = '<div class="status-msg status-msg--muted">Search failed. Try again.</div>'; });
    },
    'bdc-random-borrower': function () {
        if (typeof bdcRandomBorrower === 'function') {
            bdcRandomBorrower();
            return;
        }
        var inp = document.getElementById('bdc-borrower-input');
        var examples = ['Zendesk', 'Kaseya', 'Cotiviti', 'Medallia', 'Pluralsight', 'Solera'];
        if (inp)
            inp.value = examples[Math.floor(Math.random() * examples.length)];
        var handler = _delegatedActions['bdc-search-borrower'];
        if (handler)
            handler();
    },
    'bdc-refresh-data': function () { if (typeof bdcRefreshData === 'function')
        bdcRefreshData(); },
    // BDC browser Phase B (2026-10-25, V7/V8): the mode switch (its applier is in the always-loaded app-init chunk), the cross-links and the trail (bdc-browser-nav.ts).
    'bdc-set-mode': function (e) { var b = e && e.target ? e.target.closest('[data-bdc-mode-target]') : null; var m = b ? b.getAttribute('data-bdc-mode-target') : null; if (typeof bdcSetMode === 'function')
        bdcSetMode(m);
    else if (typeof _bdcApplyMode === 'function')
        _bdcApplyMode(m); },
    'bdc-open-book': function (e) { var b = e && e.target ? e.target.closest('[data-ticker]') : null; if (b && typeof bdcOpenBook === 'function')
        bdcOpenBook(b.getAttribute('data-ticker') || ''); },
    'bdc-open-borrower': function (e) { var b = e && e.target ? e.target.closest('[data-borrower-norm]') : null; if (b && typeof bdcOpenBorrower === 'function')
        bdcOpenBorrower(b.getAttribute('data-borrower-norm') || '', b.getAttribute('data-borrower-name') || ''); },
    'bdc-filter-industry': function (e) { var b = e && e.target ? e.target.closest('[data-action="bdc-filter-industry"]') : null; if (b && typeof bdcFilterIndustry === 'function')
        bdcFilterIndustry(b.hasAttribute('data-industry-clear') ? null : b.getAttribute('data-industry')); },
    'bdc-trail-hop': function (e) { var b = e && e.target ? e.target.closest('[data-bdc-hop-key]') : null; if (b && typeof bdcTrailHop === 'function')
        bdcTrailHop(b.getAttribute('data-bdc-hop-mode'), b.getAttribute('data-bdc-hop-key'), b.getAttribute('data-bdc-hop-label')); },
    'bdc-search-bdc': function (e) {
        // If clicked from a BDC card, populate the input first
        var cardEl = e && e.target ? e.target.closest('[data-ticker]') : null;
        var inp = document.getElementById('bdc-ticker-input');
        if (cardEl && cardEl.dataset.ticker && inp) {
            inp.value = cardEl.dataset.ticker;
        }
        if (typeof bdcSearchBdc === 'function') {
            bdcSearchBdc();
            return;
        }
        var el = document.getElementById('bdc-ticker-results');
        if (!inp || !inp.value.trim()) {
            if (el)
                el.innerHTML = '<div class="status-msg status-msg--error">Enter a BDC ticker.</div>';
            return;
        }
        var ticker = inp.value.trim().toUpperCase();
        if (el)
            el.innerHTML = '<div class="status-msg status-msg--muted">Loading ' + escHtml(ticker) + ' holdings...</div>';
        fetch(((typeof SERVER !== 'undefined') ? SERVER : '') + '/api/bdc/holdings?ticker=' + encodeURIComponent(ticker), { signal: (typeof getViewAwareSignal === 'function' ? getViewAwareSignal(15000) : AbortSignal.timeout(15000)) })
            .then(function (r) { return r.ok ? r.json() : Promise.reject('HTTP ' + r.status); })
            .then(function (data) {
            var holdings = Array.isArray(data) ? data : (data && data.holdings ? data.holdings : []);
            if (!holdings.length) {
                if (el)
                    el.innerHTML = '<div class="status-msg status-msg--muted">No holdings found for ' + escHtml(ticker) + '.</div>';
                return;
            }
            // Server-authoritative paywall (mirrors bdc-view.ts #153 fix): the
            // backend server-truncates holdings to a free preview for non-plus
            // and sends the true pre-truncation count in `locked_total`. Sizing
            // off holdings.length here would read the truncated preview size,
            // collapse the gated count to 0, and silently drop the upgrade
            // banner (the 2026-05-19 double-truncation collision). This is the
            // graceful-degradation path (fires only when bdc-view.ts didn't
            // load) so the banner uses GLOBAL classes \u2014 bdc-free-gate* CSS is
            // hydrated by _hydrateBdcStyles in the absent bdc-view.ts module.
            var serverLocked = !Array.isArray(data) && !!(data && data.locked === true);
            var lockedTotal = (data && typeof data.locked_total === 'number') ? data.locked_total : null;
            var totalHoldings = (serverLocked && lockedTotal != null && lockedTotal > holdings.length) ? lockedTotal : holdings.length;
            var rows = '';
            for (var i = 0; i < Math.min(holdings.length, 30); i++) {
                var h = holdings[i];
                rows += '<tr>'
                    + '<td class="td-primary">' + escHtml(h.borrower || h.company || h.name || '') + '</td>'
                    + '<td>' + escHtml(h.type || h.asset_type || '') + '</td>'
                    + '<td class="td-gold">' + (h.fair_value != null ? '$' + Number(h.fair_value).toLocaleString() : (h.amount != null ? '$' + Number(h.amount).toLocaleString() : '\u2014')) + '</td>'
                    + '</tr>';
            }
            var gatedCount = Math.max(0, totalHoldings - holdings.length);
            var banner = '';
            if (serverLocked && gatedCount > 0) {
                var upMsg = (data && data.upgrade && data.upgrade.message)
                    ? String(data.upgrade.message)
                    : (gatedCount + ' more portfolio compan' + (gatedCount === 1 ? 'y' : 'ies') + ' with full deal terms, rates, and mark-to-market data.');
                banner = '<div class="status-msg status-msg--muted bdc-fallback-gate">'
                    + '<div class="td-primary">Upgrade to see all ' + totalHoldings + ' holdings</div>'
                    + '<div>' + escHtml(upMsg) + '</div>'
                    + '<button type="button" class="btn-primary" data-action="bdc-show-paywall" data-feature="paywall_bdc_holdings">View plans</button>'
                    + '<div class="status-msg--muted">New accounts get a 7-day Researcher trial.</div>'
                    + '</div>';
            }
            if (el)
                _safeSetHTML(el, '<div class="td-primary app-13f-port-header">' + escHtml(ticker) + ' Portfolio (' + totalHoldings + ' holdings)</div>'
                    + '<table class="data-table"><thead><tr><th>Borrower</th><th>Type</th><th class="text-right">Fair Value</th></tr></thead><tbody>' + rows + '</tbody></table>'
                    + banner);
        })
            .catch(function () { if (el)
            el.innerHTML = '<div class="status-msg status-msg--muted">Holdings unavailable for ' + escHtml(ticker) + '.</div>'; });
    },
    'bdc-random-bdc': function () {
        if (typeof bdcRandomBdc === 'function') {
            bdcRandomBdc();
            return;
        }
        var inp = document.getElementById('bdc-ticker-input');
        var examples = ['ARCC', 'MAIN', 'BXSL', 'HTGC', 'GBDC', 'PSEC', 'TPVG', 'FSK', 'TSLX', 'OBDC'];
        if (inp)
            inp.value = examples[Math.floor(Math.random() * examples.length)];
        var handler = _delegatedActions['bdc-search-bdc'];
        if (handler)
            handler();
    },
    'bdc-stress-test-show': function () {
        var p = document.getElementById('bdc-stress-panel');
        if (!p)
            return;
        p.classList.remove('d-none');
        var _sd = p.querySelector('details');
        if (_sd)
            _sd.open = true; // Phase C (2026-10-25): the stress section is collapsible, closed by default
        // Pre-click Plus gate (CHAMP 2026-05-05): bdc-view.ts _bdcStressTierGate, shared with the <details> toggle.
        if (typeof _bdcStressTierGate === 'function')
            _bdcStressTierGate(p);
        p.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    },
    'bdc-stress-run': function () {
        if (typeof runBdcStressTest === 'function')
            runBdcStressTest();
    },
    'download-watchlist-csv': function () { _downloadWatchlistCSV(); },
    'toggle-wl-view': function (e) { if (typeof toggleWlView === 'function')
        toggleWlView(e.target.closest('[data-action]').dataset.wlView); },
    // v3 product-surface Compact/Expanded toggle. The legacy 'toggle-wl-view'
    // above reads dataset.wlView and re-renders the LEGACY surface; the v3
    // surface emits 'wl-view-toggle' + data-mode and re-reads the mode from
    // OLStorage('wlViewMode') in _readViewMode(). Persist-then-re-render.
    'wl-view-toggle': function (e) {
        var el = e.target.closest('[data-action]');
        if (!el)
            return;
        var mode = el.dataset.mode;
        if (mode !== 'compact' && mode !== 'expanded')
            return;
        try {
            if (typeof OLStorage !== 'undefined' && OLStorage.setString)
                OLStorage.setString('wlViewMode', mode);
        }
        catch (_e) { }
        var root = document.getElementById('watchlist-view');
        if (root && window.OLProduct && window.OLProduct.surfaces && typeof window.OLProduct.surfaces.renderWatchlist === 'function') {
            window.OLProduct.surfaces.renderWatchlist(root);
        }
    },
    'wl-add-ticker': function () { if (typeof wlAddTicker === 'function')
        wlAddTicker(); },
    'wl-batch-add': function () {
        // P1-7: Paste multiple tickers at once
        var overlay = document.getElementById('wl-batch-overlay');
        if (overlay) {
            overlay.classList.toggle('hidden');
            return;
        }
        overlay = document.createElement('div');
        overlay.id = 'wl-batch-overlay';
        overlay.className = 'csp-modal-card';
        overlay.innerHTML = '<div class="app-modal-inner-400">'
            + '<h2 class="panel-title">Add Multiple Tickers</h2>'
            + '<textarea id="wl-batch-input" placeholder="Paste tickers separated by commas, spaces, or new lines&#10;Example: AAPL, MSFT, GOOG, AMZN" rows="4" class="credit-input ol-textarea-full"></textarea>'
            + '<div class="d-flex gap-8 ol-flex-end">'
            + '<button data-action="wl-batch-cancel" class="btn-ghost">Cancel</button>'
            + '<button data-action="wl-batch-confirm" class="btn-primary">Add all</button>'
            + '</div></div>';
        document.body.appendChild(overlay);
    },
    'wl-batch-cancel': function () { var o = document.getElementById('wl-batch-overlay'); if (o)
        o.remove(); },
    'wl-batch-confirm': async function () {
        // F14 (2026-05-12 Code-Review-Cowork audit P1): on success, the
        // batch-add MUST trigger a watchlist re-render so the user sees
        // their additions land — without this, they close the modal and
        // perceive the platform's most premium feature as broken. Day-2
        // retention is measurably reduced when activation moments are muted.
        //
        // Three structural improvements over the prior code:
        //   1. Promise.allSettled (not forEach + counter race) so partial
        //      failures surface to the user instead of silently swallowing.
        //   2. Await all fetches before showing the result toast.
        //   3. Call renderWatchlist() if defined so the new rows appear
        //      before the modal close-animation completes.
        var input = document.getElementById('wl-batch-input');
        if (!input)
            return;
        var tickers = input.value.toUpperCase().split(/[,\s\n]+/).filter(function (t) { return /^[A-Z]{1,6}$/.test(t.trim()); });
        if (tickers.length === 0) {
            if (typeof showToast === 'function')
                showToast('No valid tickers found. Use 1-6 letter symbols.', 'warn');
            return;
        }
        var csrf = typeof _getCsrfToken === 'function' ? _getCsrfToken() : '';
        // 2026-06-12 audit 6.3: anonymous batch-adds go to the device-local
        // list (watchlist.ts _wlAnonAdd) — the server requires auth.
        var _anonAdd = (typeof _wlIsAnon === 'function' && _wlIsAnon()
            && typeof _wlAnonAdd === 'function') ? _wlAnonAdd : null;
        var addPromise = function (ticker) {
            if (_anonAdd) {
                var r = _anonAdd(ticker.trim());
                return Promise.resolve(r === 'added' || r === 'duplicate');
            }
            return fetch('/api/watchlist', {
                method: 'POST',
                credentials: 'same-origin',
                headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': csrf },
                body: JSON.stringify({ action: 'add', ticker: ticker.trim() }),
            }).then(function (resp) { return resp.ok; });
        };
        var results = await Promise.allSettled(tickers.map(addPromise));
        var ok = results.filter(function (r) {
            return r.status === 'fulfilled' && r.value === true;
        }).length;
        var failed = tickers.length - ok;
        if (typeof showToast === 'function') {
            if (failed === 0) {
                showToast('Added ' + ok + ' ticker' + (ok === 1 ? '' : 's') + ' to watchlist', 'success');
            }
            else if (ok === 0) {
                showToast('Could not add tickers — please try again.', 'error');
            }
            else {
                showToast('Added ' + ok + ' of ' + tickers.length + ' — ' + failed + ' failed', 'warning');
            }
        }
        var o = document.getElementById('wl-batch-overlay');
        if (o)
            o.remove();
        // Refresh the watchlist view so the new rows appear. The canonical
        // helper lives in static/js/watchlist.ts; check at runtime since
        // it ships in a different bundle chunk and may not be loaded on
        // surfaces that imported app-renderers first.
        try {
            if (typeof renderWatchlist === 'function') {
                await renderWatchlist();
            }
            else if (typeof window !== 'undefined' && typeof window.renderWatchlist === 'function') {
                await window.renderWatchlist();
            }
        }
        catch (_e) { /* defensive: render failure shouldn't break the success toast */ }
    },
    'toggle-practice-mode': function (e) { if (e && e.preventDefault)
        e.preventDefault(); var _csp = _delegatedActions['close-settings-panel']; if (_csp)
        _csp(); _materializeView('practice-sector-overlay').then(function () { if (typeof togglePracticeMode === 'function') {
        togglePracticeMode();
    }
    else {
        _loadModule('screener-options').then(function () { if (typeof togglePracticeMode === 'function')
            togglePracticeMode(); });
    } }); },
    'dismiss-practice-fab': function (e) { e.stopPropagation(); try {
        OLStorage.setString('practice_fab_dismissed', '1');
    }
    catch (e2) { } var fab = document.getElementById('practice-mode-fab'); if (fab)
        fab.classList.add('hidden'); },
    'welcome-signup': function () { if (typeof authOpenModal === 'function')
        authOpenModal('register');
    else if (typeof authToggle === 'function')
        authToggle(); var wb = document.getElementById('welcome-bar'); if (wb)
        wb.remove(); },
    'welcome-dismiss': function () { var wb = document.getElementById('welcome-bar'); if (wb)
        wb.remove(); try {
        OLStorage.setString('ol_welcomed', '1');
    }
    catch (e) { } },
    'lp-back-to-grid': function (e) { e.preventDefault(); if (typeof renderLearningPaths === 'function') {
        renderLearningPaths();
        setTimeout(function () { var el = document.getElementById('learn-view-content'); if (el && el.parentElement && typeof _lpGridScrollPos !== 'undefined')
            el.parentElement.scrollTop = _lpGridScrollPos; }, 50);
    } },
    'notif-switch-ticker': function (e) { var el = e.target.closest('[data-action]'); if (el && typeof notifClickAction === 'function')
        notifClickAction(el.dataset.ticker); },
    // UX-4: notifications dismiss + clear-all delegated handlers (replaced inline onclick).
    'ntf-clear-all': function (e) { e.preventDefault(); e.stopPropagation(); if (typeof clearAllNotifs === 'function')
        clearAllNotifs(); },
    'ntf-dismiss': function (e) { e.preventDefault(); e.stopPropagation(); var el = e.target.closest('[data-action]'); if (el && el.dataset.notifId && typeof dismissNotification === 'function')
        dismissNotification(el.dataset.notifId); },
    // UX-4: ask-ai delegated handlers (replaced inline onclick).
    'askai-dismiss-demo': function (e) { e.preventDefault(); if (typeof _askAiDismissDemo === 'function')
        _askAiDismissDemo(); },
    'askai-toggle-settings': function (e) { e.preventDefault(); if (typeof _askAiToggleSettings === 'function')
        _askAiToggleSettings(); },
    // 2026-04-26 cliff fix: fallback was '/pricing' — kept user in SPA via the
    // /?signup=1 deep-link (mirrors the auth-dropdown trial CTA pattern).
    'askai-signup': function (e) { e.preventDefault(); if (typeof window.authOpenModal === 'function')
        window.authOpenModal('register');
    else
        window.location.href = '/?signup=1'; },
    'askai-show-rationale': function (e) { var el = e.target.closest('[data-action]'); if (el && typeof _askAiShowRationale === 'function')
        _askAiShowRationale(e, el); },
    'askai-use-suggestion': function (e) { var el = e.target.closest('[data-action]'); if (el && typeof _askAiUseSuggestion === 'function')
        _askAiUseSuggestion(el); },
    'askai-more-suggestions': function (e) { e.preventDefault(); if (typeof _askAiMoreSuggestions === 'function')
        _askAiMoreSuggestions(); },
    'askai-delete-note': function (e) { e.preventDefault(); var el = e.target.closest('[data-action]'); if (el && el.dataset.noteIdx != null && typeof _askAiDeleteNote === 'function')
        _askAiDeleteNote(parseInt(el.dataset.noteIdx, 10)); },
    // UX-4: practicum Enter-key handler (replaced inline onkeydown).
    'prac-add-ticker': function (e) { if (typeof _pracAddTicker === 'function')
        _pracAddTicker(); },
    'lp-search-open': function (e) { var el = e.target.closest('[data-action]'); if (el && typeof _lpOpenPath === 'function') {
        _lpOpenPath(el.dataset.pathId);
        setTimeout(function () { var modEl = document.getElementById('lp-mod-' + el.dataset.modId); if (modEl) {
            modEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
            modEl.click();
        } }, 200);
    } },
    'lp-open-path': function (e) { e.preventDefault(); var el = e.target.closest('[data-action]'); if (el && el.dataset.pathId && typeof _lpOpenPath === 'function')
        _lpOpenPath(el.dataset.pathId); },
    // Random parity (OWNER feature 2026-04-26): each of the four learn
    // surfaces (Modules / Ledge Reads / Investment Lore / Market History)
    // gets a Random button next to its search bar. Pick respects the
    // active filter — surprise within the user's current scope.
    'lp-random': function () {
        // 2026-05-04 OWNER fix: Random must skip paths whose prerequisites
        // aren't met. Cards with unmet prereqs carry .lp-card-locked (set in
        // learning-paths.js renderer via _lpIsPathLocked). Picking a locked
        // path drops the user on a banner instead of a startable lesson.
        var notLocked = function (c) { return !c.classList.contains('lp-card-locked'); };
        var isVisible = function (c) { return c.style.display !== 'none' && !c.classList.contains('hidden') && !c.classList.contains('lp-card-hidden-by-filter'); };
        var allCards = Array.prototype.slice.call(document.querySelectorAll('#lp-modules-pane .lp-card'));
        // 1st choice: visible AND unlocked (respects active filter chip).
        var pool = allCards.filter(function (c) { return isVisible(c) && notLocked(c); });
        // 2nd choice: any unlocked card (filter excluded all unlocked → ignore filter).
        if (!pool.length)
            pool = allCards.filter(notLocked);
        // 3rd choice (defensive — beginner paths always unlock so this should
        // be unreachable): fall through to any visible card.
        if (!pool.length)
            pool = allCards.filter(isVisible);
        if (!pool.length)
            pool = allCards;
        if (!pool.length)
            return;
        var pick = pool[Math.floor(Math.random() * pool.length)];
        var pathId = pick.getAttribute('data-path-id');
        if (pathId && typeof _lpOpenPath === 'function')
            _lpOpenPath(pathId);
    },
    'lore-random': function () { if (typeof _loreRandom === 'function')
        _loreRandom(); },
    'dc-random': function () { if (typeof _dcRandom === 'function')
        _dcRandom(); },
    'lp-start-first-card': function (e) { e.preventDefault(); var fp = document.querySelector('.lp-card'); if (fp && fp.dataset.pathId && typeof _lpOpenPath === 'function')
        _lpOpenPath(fp.dataset.pathId); },
    // LEARN module-level delegated handlers (CSP regression fix 2026-04-25):
    // these were inline onclick= in learning-paths.js until the strict CSP
    // landed; the lp-card path migrated earlier but the inner module-list
    // sites + path-chooser cards were missed. Each handler defers to the
    // named function in learning-paths.js (education chunk) and no-ops
    // gracefully if the chunk hasn't loaded yet.
    'lp-choose-path': function (e) {
        e.preventDefault();
        var el = e.target.closest('[data-action]');
        if (!el)
            return;
        if (typeof _lpChoosePath === 'function')
            _lpChoosePath(el.dataset.pathKey);
    },
    // Brainstorm #20 (2026-09-04): the mastered-module one-pager anchor lives
    // INSIDE the lp-toggle-module header. It carries its own data-action so the
    // central dispatcher resolves the ANCHOR as the closest action -- and this
    // handler deliberately does nothing: no preventDefault, so the browser
    // follows the href natively, and the header toggle never fires for it.
    'lp-onepager': function () { },
    'lp-toggle-module': function (e) {
        e.preventDefault();
        var el = e.target.closest('[data-action]');
        if (!el)
            return;
        if (typeof _lpToggleModule === 'function')
            _lpToggleModule(el.dataset.moduleId, el);
    },
    'lp-show-locked-toast': function (e) {
        e.preventDefault();
        var el = e.target.closest('[data-action]');
        if (!el)
            return;
        if (typeof _lpShowLockedToast === 'function')
            _lpShowLockedToast(el.dataset.prevTitle || '');
    },
    'lp-open-drawer': function (e) {
        e.preventDefault();
        var el = e.target.closest('[data-action]');
        if (!el)
            return;
        if (typeof _lpOpenDrawer === 'function')
            _lpOpenDrawer(el.dataset.moduleId);
    },
    // Credit/BONDS view delegation. credit-view.js used to inject inline
    // onclick="creditSortBy('...')" handlers which the strict CSP blocks.
    // Each handler defers to the named function in credit-view.js when the
    // research chunk is loaded; otherwise it's a silent no-op (the chunk
    // is loading and the row will re-render on completion).
    'credit-pf-toggle': function (e) {
        var el = e.target.closest('[data-action]');
        if (!el)
            return;
        var p = document.getElementById(el.dataset.pfId);
        if (p)
            p.style.display = (p.style.display === 'none' ? 'block' : 'none');
    },
    'credit-sort-by': function (e) {
        var el = e.target.closest('[data-action]');
        if (!el)
            return;
        if (typeof creditSortBy === 'function')
            creditSortBy(el.dataset.sortKey);
    },
    'credit-toggle-expand': function (e) {
        var el = e.target.closest('[data-action="credit-toggle-expand"]');
        if (!el)
            return;
        if (typeof creditToggleExpand === 'function')
            creditToggleExpand(el.dataset.bondId);
    },
    'credit-quick-remove': function (e) {
        e.stopPropagation();
        var el = e.target.closest('[data-action]');
        if (!el)
            return;
        if (typeof creditQuickRemove === 'function')
            creditQuickRemove(el.dataset.bondId, el);
    },
    'credit-noop': function (e) { e.stopPropagation(); },
    'credit-view-issuer': function (e) {
        e.preventDefault();
        e.stopPropagation();
        var el = e.target.closest('[data-action]');
        if (!el)
            return;
        if (typeof addTickerBySymbol === 'function')
            addTickerBySymbol(el.dataset.ticker);
        if (typeof setView === 'function')
            setView('ticker');
    },
    'credit-remove-bond': function (e) {
        var el = e.target.closest('[data-action]');
        if (!el)
            return;
        if (typeof creditRemoveBond === 'function')
            creditRemoveBond(el.dataset.bondId);
    },
    'credit-force-add': function (e) {
        var el = e.target.closest('[data-action]');
        if (!el)
            return;
        if (typeof creditForceAdd === 'function')
            creditForceAdd(el.dataset.cusip);
    },
    'credit-confirm-add': function (e) {
        var el = e.target.closest('[data-action]');
        if (!el)
            return;
        if (typeof creditConfirmAdd === 'function')
            creditConfirmAdd(el.dataset.cusip, el.dataset.issuer || '');
    },
    'credit-add-all-bonds': function (e) {
        var el = e.target.closest('[data-action]');
        if (!el)
            return;
        if (typeof creditAddAllBonds === 'function')
            creditAddAllBonds(parseInt(el.dataset.groupIdx, 10));
    },
    'credit-add-single-bond': function (e) {
        var el = e.target.closest('[data-action]');
        if (!el)
            return;
        if (typeof creditAddSingleBond === 'function')
            creditAddSingleBond(parseInt(el.dataset.groupIdx, 10), parseInt(el.dataset.bondIdx, 10));
    },
    'cp-sort-by': function (e) {
        var el = e.target.closest('[data-action]');
        if (!el)
            return;
        if (typeof cpSortBy === 'function')
            cpSortBy(el.dataset.sortKey);
    },
    // Brand v2 Phase 5b — Settings panel + ChromeB ancillary handlers.
    // N8 (2026-09-25): both route through the one open/close pair above so the
    // focus trap, the focus return and the scroll-lock cannot diverge by path.
    'open-settings-panel': function () { _olOpenSettingsPanel(); },
    'close-settings-panel': function () { _olCloseSettingsPanel(); },
    'set-theme': function (e) {
        var el = e.target.closest('[data-action]');
        if (!el)
            return;
        var v = el.dataset.themeValue;
        document.documentElement.setAttribute('data-theme', v);
        try {
            OLStorage.setString('ol_theme', v);
        }
        catch (_) { }
        if (typeof _olRefreshSettingsPanel === 'function')
            _olRefreshSettingsPanel();
    },
    'set-density': function (e) {
        var el = e.target.closest('[data-action]');
        if (!el)
            return;
        var v = el.dataset.densityValue;
        document.documentElement.setAttribute('data-density', v);
        try {
            OLStorage.setString('ol_density', v);
        }
        catch (_) { }
        if (typeof _olRefreshSettingsPanel === 'function')
            _olRefreshSettingsPanel();
    },
    'set-chrome': function (e) {
        /* Anchor href handles navigation; this only highlights the active
           segment before the page reloads to ?brand=v2 or ?brand=legacy. */
        var el = e.target.closest('[data-action]');
        if (!el)
            return;
        if (typeof _olRefreshSettingsPanel === 'function')
            _olRefreshSettingsPanel();
    },
    // 2026-04-28: removed duplicate 'set-user-level' handler that was dead
    // code (overridden by the canonical handler ~280 lines below near
    // 'cycle-user-level'). The kept handler now correctly reads
    // `dataset.levelValue` and persists the selection.
    'auth-sign-out': function (e) {
        e.preventDefault();
        if (typeof authSignOut === 'function')
            authSignOut();
        else if (typeof window.signOut === 'function')
            window.signOut();
        else {
            // #42: this navigated by GET to a POST-only+CSRF route, so it 405'd and
            // left the user signed in. `keepalive` or the navigation aborts the POST.
            // Full reasoning: tests/test_fe_navigation_method_agreement_contract.py
            var _csrf = typeof _getCsrfToken === 'function' ? _getCsrfToken() : '';
            try {
                fetch('/api/auth/logout', {
                    method: 'POST', credentials: 'same-origin', keepalive: true,
                    headers: { 'X-CSRF-Token': _csrf },
                }).catch(function () { });
            }
            catch (_e) { /* navigate regardless */ }
            window.location.href = '/';
        }
    },
    // 'go-home' duplicate removed 2026-05-15 (top-bar audit P1): a
    // second 'go-home' (setView('macro')) was last-wins-shadowing the
    // canonical handler ~line 2037 which honours ol_default_view +
    // avoids the macro→news watchdog toast (squad #5). Canonical is
    // now the single source of truth (BUILDER finding).
    // Practice games delegation. practice-games.js used to inject inline onclick= handlers
    // which the strict CSP blocks. Each handler defers to the named function in
    // practice-games.js when the education chunk is loaded; otherwise it's a silent no-op.
    'pg-start-game': function (e) {
        var el = e.target.closest('[data-action]');
        if (!el)
            return;
        if (typeof _pgStartGame === 'function')
            _pgStartGame(el.dataset.gameType);
    },
    'pg-set-difficulty-and-start': function (e) {
        var el = e.target.closest('[data-action]');
        if (!el)
            return;
        if (typeof _pgSetDifficulty === 'function')
            _pgSetDifficulty(el.dataset.gameType, el.dataset.level);
        if (typeof _pgStartGame === 'function')
            _pgStartGame(el.dataset.gameType);
    },
    'pg-overunder-answer': function (e) {
        var el = e.target.closest('[data-action]');
        if (!el)
            return;
        if (typeof _pgOverUnderAnswer !== 'function')
            return;
        _pgOverUnderAnswer(el.dataset.guessedAbove === 'true', el.dataset.isAbove === 'true', parseFloat(el.dataset.actual), parseFloat(el.dataset.median), el.dataset.metricLabel, el.dataset.ticker, el.dataset.company, el.dataset.sector);
    },
    'pg-bullbear-answer': function (e) {
        var el = e.target.closest('[data-action]');
        if (!el)
            return;
        if (typeof _pgBullBearAnswer === 'function')
            _pgBullBearAnswer(el.dataset.side, el.dataset.correct, el);
    },
    'pg-metric-match-answer': function (e) {
        var el = e.target.closest('[data-action]');
        if (!el)
            return;
        if (typeof _pgMetricMatchAnswer === 'function')
            _pgMetricMatchAnswer(el, el.dataset.termChosen, el.dataset.termCorrect);
    },
    'pg-estimate-submit': function (e) {
        if (typeof _pgEstimateSubmit === 'function')
            _pgEstimateSubmit();
    },
    'pg-buildratio-submit': function (e) {
        if (typeof _pgBuildRatioSubmit === 'function')
            _pgBuildRatioSubmit();
    },
    'pg-scenario-review': function (e) {
        if (typeof _pgScenarioReview === 'function')
            _pgScenarioReview();
    },
    'pg-scenario-next': function (e) {
        if (typeof _pgScenarioNext === 'function')
            _pgScenarioNext();
    },
    // Input event handlers (fired via data-action-input / data-action-change).
    'credit-pf-recalc': function (e) {
        var el = e.target.closest('[data-action-input]');
        if (!el)
            return;
        if (typeof window._pfCalc === 'function')
            window._pfCalc(el.dataset.pfId, parseFloat(el.dataset.pfCash) || 0);
    },
    'credit-save-notes': function (e) {
        var el = e.target.closest('[data-action-change]');
        if (!el)
            return;
        if (typeof creditSaveNotes === 'function')
            creditSaveNotes(el.dataset.bondId, el.value);
    },
    // Inline ETF screener fallback — runs before research chunk loads.
    // Once the chunk lands, renderETFScreener() replaces this surface.
    'etf-search': function (e) {
        e.preventDefault();
        var input = document.getElementById('inline-etf-search');
        var results = document.getElementById('inline-etf-results');
        if (!input || !results)
            return;
        var ticker = (input.value || '').trim().toUpperCase();
        if (!/^[A-Z]{1,6}$/.test(ticker)) {
            results.textContent = 'Enter a 1-6 letter ETF ticker.';
            return;
        }
        results.textContent = 'Loading ' + ticker + '...';
        fetch('/api/etf?ticker=' + encodeURIComponent(ticker), { credentials: 'same-origin', signal: AbortSignal.timeout(15000) })
            .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
            .then(function (d) {
            if (!d || d.error) {
                results.textContent = (d && d.error) ? d.error : 'No data for ' + ticker + '.';
                return;
            }
            var rows = [];
            if (d.name)
                rows.push(['Name', d.name]);
            if (d.expense_ratio != null)
                rows.push(['Expense ratio', (d.expense_ratio * 100).toFixed(2) + '%']);
            if (d.aum)
                rows.push(['AUM', d.aum]);
            if (d.category)
                rows.push(['Category', d.category]);
            if (d.ytd_return != null)
                rows.push(['YTD return', (d.ytd_return * 100).toFixed(2) + '%']);
            var html = '<table class="inline-table"><tbody>';
            rows.forEach(function (r) { html += '<tr><td class="muted">' + r[0] + '</td><td>' + r[1] + '</td></tr>'; });
            html += '</tbody></table>';
            if (typeof _loadModule === 'function')
                _loadModule('etf-screener');
            results.innerHTML = html;
        })
            .catch(function () { results.textContent = 'ETF lookup unavailable. Loading full screener...'; if (typeof _loadModule === 'function')
            _loadModule('etf-screener'); });
    },
    'toggle-reading-list': function () { var p = document.getElementById('reading-list-panel'); if (!p)
        return; p.classList.toggle('d-none'); if (!p.classList.contains('d-none') && typeof renderReadingList === 'function')
        renderReadingList(); },
    // 2026-04-25 PM: SPA Learn surfaces (Modules / Ledge Reads / Investment
    // Lore / Market History) are now a tab system instead of stacked
    // toggle-buttons that surfaced content way below the module grid. The
    // 4 panes: #lp-modules-pane (rendered inside #learn-view-content) +
    // 3 sibling panels (#reading-list-panel / #investment-lore-panel /
    // #defunct-companies-panel) outside #learn-view-content. The handler
    // hides all 4 then shows the chosen one + lazy-loads its renderer
    // module if needed. Aria-selected + the lp-tab-active class stay in
    // sync for screen readers and visual treatment.
    'learn-tab': function (e) {
        var btn = e && e.target ? e.target.closest('[data-action="learn-tab"]') : null;
        if (!btn)
            return;
        var tab = btn.getAttribute('data-tab') || 'modules';
        // Sub-link writeback (2026-07-10 OWNER): reflect the active tab in the URL
        // so each Learn header (Ledge Reads / Investment Lore / Market History /
        // Glossary / On This Date) is a copyable, refresh-stable link. The INBOUND
        // ?view=learn&tab=X restore already existed (views.ts + the welcome tiles);
        // this closes the loop by WRITING the URL on click. replaceState (no new
        // history entry) mirrors _setUrlPreset. Modules is the default landing, so
        // its URL is the clean bare ?view=learn (tab param dropped) — the inbound
        // restore treats a missing tab as modules.
        try {
            var _lpParams = new URLSearchParams(window.location.search);
            _lpParams.set('view', 'learn');
            if (tab && tab !== 'modules')
                _lpParams.set('tab', tab);
            else
                _lpParams.delete('tab');
            // Clear stale single-lesson deep-link params so a tab URL is a clean
            // tab URL (module/path/section belong to the modules surface, not a tab).
            _lpParams.delete('section');
            var _lpQs = _lpParams.toString();
            window.history.replaceState(null, '', window.location.pathname + (_lpQs ? '?' + _lpQs : '') + window.location.hash);
        }
        catch (_lpe) { /* no-op in unsupported browsers */ }
        // Update tab button states
        var allTabs = document.querySelectorAll('.lp-tab');
        for (var i = 0; i < allTabs.length; i++) {
            var t = allTabs[i];
            var isActive = t === btn;
            t.classList.toggle('lp-tab-active', isActive);
            t.setAttribute('aria-selected', isActive ? 'true' : 'false');
        }
        // Pane map: tab name → element id
        var paneMap = {
            'modules': 'lp-modules-pane',
            'reading': 'reading-list-panel',
            'lore': 'investment-lore-panel',
            'history': 'defunct-companies-panel',
            // #128 (OWNER 2026-05-18): in-app Glossary browse pane so the
            // welcome "Glossary" tile routes /?view=learn&tab=glossary instead
            // of the SSR /glossary/ SEO page (feedback_prefer_inapp_over_seo_routing).
            'glossary': 'lp-glossary-panel',
            // #130 (CHAOS-K1 follow-up, 2026-05-19): in-app On-This-Date pane
            // so the welcome "On this date" tile routes /?view=learn&tab=
            // on-this-date instead of the SSR /lore/on-this-date/ SEO page.
            // SSR route stays (EXCEPTION clause — crawler/anon/cold-entry).
            'on-this-date': 'lp-on-this-date-panel',
        };
        var allPaneIds = ['lp-modules-pane', 'reading-list-panel', 'investment-lore-panel', 'defunct-companies-panel', 'lp-glossary-panel', 'lp-on-this-date-panel'];
        for (var j = 0; j < allPaneIds.length; j++) {
            var pane = document.getElementById(allPaneIds[j]);
            if (!pane)
                continue;
            if (allPaneIds[j] === paneMap[tab]) {
                pane.classList.remove('d-none');
                pane.classList.remove('hidden');
                pane.classList.add('lp-pane-active');
            }
            else {
                pane.classList.add('d-none');
                pane.classList.remove('lp-pane-active');
            }
        }
        // #88 UI (2026-06-03 OWNER): the Landing pane (#lp-landing-pane — the
        // "WHERE TO START" path cards) is the MODULES-tab surface. It must show
        // ONLY on the Modules tab and hide on the other 5 — previously it stayed
        // visible regardless of which tab was active (the path cards bled into
        // Ledge Reads / Lore / History / Glossary / On This Date).
        var _lpLanding = document.getElementById('lp-landing-pane');
        if (_lpLanding) {
            if (tab === 'modules') {
                _lpLanding.classList.remove('d-none');
                _lpLanding.classList.add('lp-pane-active');
            }
            else {
                _lpLanding.classList.add('d-none');
                _lpLanding.classList.remove('lp-pane-active');
            }
        }
        // SF-HANDOFF-REDESIGN PR1 Phase 3.B (2026-05-27): try the new
        // OLLearn.surfaces.* renderer FIRST. If it exists + doesn't throw,
        // skip the legacy if/else chain below. If it's absent (chunk-load
        // race) or throws, fall through to legacy — Sentry captures the
        // exception so we know if a surface is broken. This guarded swap
        // means the new UI ships LIVE with a silent safety net.
        var _v3FnMap = {
            'reading': 'renderReads',
            'lore': 'renderLore',
            'history': 'renderHistory',
            'glossary': 'renderGlossary',
            'on-this-date': 'renderOnThisDate',
            'modules': 'renderModules',
        };
        var _v3FnName = _v3FnMap[tab];
        var _v3Pane = paneMap[tab] ? document.getElementById(paneMap[tab]) : null;
        if (_v3FnName && _v3Pane && window.OLLearn && window.OLLearn.surfaces && typeof window.OLLearn.surfaces[_v3FnName] === 'function') {
            var _callV3Surface = function () {
                try {
                    window.OLLearn.surfaces[_v3FnName](_v3Pane);
                    return true;
                }
                catch (e) {
                    if (window.Sentry && window.Sentry.captureException) {
                        window.Sentry.captureException(e, { tags: { surface: 'learn-v3', tab: tab } });
                    }
                    if (typeof console !== 'undefined' && console.error) {
                        console.error('[learn-v3] surface render failed, falling back to legacy:', tab, e);
                    }
                    return false;
                }
            };
            // 2026-06-13 (OWNER QA: in-app Glossary tab showed "0 ENTRIES"):
            // the V3 glossary surface (learn/surfaces/glossary.ts) reads its
            // ENTRY data from window.GLOSSARY (the PG /api/learn/glossary fetch
            // is editorial enrichment only). window.GLOSSARY lives in
            // glossary.js — a SEPARATE chunk from the education-chunk surfaces
            // — so on the in-app glossary-tab path the surface can render
            // before glossary.js has loaded, yielding an empty dictionary. The
            // legacy path below already _loadModule('glossary')'d first; the V3
            // path did not. Load it, THEN render (and re-read the now-populated
            // global). Other tabs are self-contained and call straight through.
            if (tab === 'glossary' && !(window.GLOSSARY) && typeof _loadModule === 'function') {
                _loadModule('glossary').then(function () {
                    if (!_callV3Surface()) {
                        _renderGlossaryBrowsePane();
                    }
                });
                return;
            }
            if (_callV3Surface())
                return;
        }
        // Lazy-render the chosen non-modules surface (lazy-load the chunk if
        // its render function isn't on window yet — same pattern as the
        // legacy toggle-X handlers above).
        if (tab === 'reading') {
            if (typeof renderReadingList === 'function') {
                renderReadingList();
            }
            else if (typeof _loadModule === 'function') {
                _loadModule('reading-list').then(function () { if (typeof renderReadingList === 'function')
                    renderReadingList(); });
            }
        }
        else if (tab === 'lore') {
            if (typeof renderInvestmentLore === 'function') {
                renderInvestmentLore();
            }
            else if (typeof _loadModule === 'function') {
                _loadModule('investment-lore').then(function () { if (typeof renderInvestmentLore === 'function')
                    renderInvestmentLore(); });
            }
        }
        else if (tab === 'history') {
            if (typeof renderDefunctCompanies === 'function') {
                renderDefunctCompanies();
            }
            else if (typeof _loadModule === 'function') {
                _loadModule('defunct-companies').then(function () { if (typeof renderDefunctCompanies === 'function')
                    renderDefunctCompanies(); });
            }
        }
        else if (tab === 'glossary') {
            // #128: the in-app Glossary browse pane. GLOSSARY lives in
            // glossary.js which shares the `education` chunk with
            // learning-paths.js, so it is already loaded whenever this
            // tablist is on screen; the _loadModule fallback is belt-and-
            // suspenders for a future chunk split.
            if (typeof GLOSSARY !== 'undefined' && GLOSSARY) {
                _renderGlossaryBrowsePane();
            }
            else if (typeof _loadModule === 'function') {
                _loadModule('glossary').then(function () { _renderGlossaryBrowsePane(); });
            }
        }
        else if (tab === 'on-this-date') {
            // #130: the in-app On-This-Date pane. Self-contained — it lazy-
            // fetches /api/learn/on-this-date itself (no GLOSSARY-style
            // shared dict dependency), so no _loadModule fallback is needed.
            if (typeof _renderOnThisDatePane === 'function') {
                _renderOnThisDatePane();
            }
        }
    },
    // Investment Lore (DATA CZAR P1 — wired 2026-04-04, was orphan content)
    'toggle-investment-lore': function () { var p = document.getElementById('investment-lore-panel'); if (!p)
        return; p.classList.toggle('d-none'); if (!p.classList.contains('d-none')) {
        if (typeof renderInvestmentLore === 'function') {
            renderInvestmentLore();
        }
        else {
            _loadModule('investment-lore').then(function () { if (typeof renderInvestmentLore === 'function')
                renderInvestmentLore(); });
        }
    } },
    // LEARN redesign Phase 1.2 — skill tree opt-in drawer. Default closed;
    // cards-grid is the primary path-discovery surface. State persists via
    // localStorage so the choice is remembered across visits.
    'toggle-skill-tree': function (e) {
        var btn = e && e.target ? e.target.closest('[data-action]') : null;
        var drawer = document.getElementById('lp-tree-drawer');
        if (!drawer)
            return;
        var isHidden = drawer.classList.toggle('hidden');
        var open = !isHidden;
        if (btn) {
            btn.setAttribute('aria-expanded', String(open));
            var chev = btn.querySelector('.lp-tree-toggle-chev');
            if (chev)
                chev.textContent = open ? '\u25BC' : '\u25B6';
        }
        try {
            OLStorage.setString('ol_lp_tree_open', open ? '1' : '0');
        }
        catch (_e) { }
    },
    'lore-filter-era': function (e) { var el = e.target.closest('[data-era]'); if (el && typeof _loreFilterEra === 'function')
        _loreFilterEra(el.getAttribute('data-era')); },
    'open-lore-detail': function (e) { var el = e.target.closest('[data-lore-idx]'); if (el && typeof _openLoreDetail === 'function')
        _openLoreDetail(parseInt(el.getAttribute('data-lore-idx'), 10)); },
    'close-lore-detail': function () { if (typeof _closeLoreDetail === 'function')
        _closeLoreDetail(); },
    // #128: in-app Glossary browse pane interactions. `gbp-open` reuses
    // the existing term-detail modal opener (_glossModalOpen — a window
    // global from the classic-script glossary.js; same opener the legacy
    // openGlossaryBrowse rows use) so there is NO duplicated term-detail
    // wiring. `gbp-search` debounces the in-pane filter, mirroring the
    // 150ms debounce of the legacy modal browse.
    'gbp-open': function (e) {
        var el = e && e.target ? e.target.closest('[data-term]') : null;
        if (!el)
            return;
        var term = el.getAttribute('data-term') || '';
        if (term && typeof _glossModalOpen === 'function') {
            _glossModalOpen(term);
        }
    },
    'gbp-search': function (e) {
        var el = e && e.target ? e.target : null;
        if (!el)
            return;
        clearTimeout(_gbpSearchTimer);
        _gbpSearchTimer = setTimeout(function () {
            if (typeof _gbpSearch === 'function')
                _gbpSearch(el);
        }, 150);
    },
    // #169: explicit opt-in to render the full ~799-term glossary. The
    // capped initial browse view trades completeness for the <1000
    // live-DOM budget; a browse-mode user can override it on demand.
    'gbp-show-all': function () {
        if (typeof _gbpShowAll === 'function')
            _gbpShowAll();
    },
    // #175: Glossary CATEGORY chip filter. Mirrors 'otd-filter-theme'
    // exactly (closest [data-cat] ancestor -> _gbpFilterCat) so the
    // three learn tabs share one chip idiom.
    'gbp-filter-cat': function (e) {
        var el = e.target.closest('[data-cat]');
        if (el && typeof _gbpFilterCat === 'function') {
            _gbpFilterCat(el.getAttribute('data-cat'));
        }
    },
    // #130: in-app On-This-Date pane search. Debounced 150ms, mirroring
    // the gbp-search glossary-pane handler exactly.
    'otd-search': function (e) {
        var el = e && e.target ? e.target : null;
        if (!el)
            return;
        clearTimeout(_otdSearchTimer);
        _otdSearchTimer = setTimeout(function () {
            if (typeof _otdSearch === 'function')
                _otdSearch(el);
        }, 150);
    },
    // #130: retry affordance on the On-This-Date fetch-failure fallback —
    // re-fires the lazy render (never-strand: a failed first fetch is
    // recoverable without a full reload).
    'otd-retry': function () {
        if (typeof _renderOnThisDatePane === 'function')
            _renderOnThisDatePane();
    },
    // #168 (OWNER prod-QA 2026-05-19): On-This-Date THEME chip filter.
    // Mirrors 'lore-filter-era' exactly (closest [data-theme] ancestor
    // -> _otdFilterTheme) so the two learn tabs share one chip idiom.
    'otd-filter-theme': function (e) {
        var el = e.target.closest('[data-theme]');
        if (el && typeof _otdFilterTheme === 'function') {
            _otdFilterTheme(el.getAttribute('data-theme'));
        }
    },
    'toggle-defunct-companies': function () {
        var p = document.getElementById('defunct-companies-panel');
        if (!p)
            return;
        p.classList.toggle('d-none');
        if (!p.classList.contains('d-none')) {
            if (typeof renderDefunctCompanies === 'function') {
                renderDefunctCompanies();
                return;
            }
            _loadModule('defunct-companies').then(function () { if (typeof renderDefunctCompanies === 'function')
                renderDefunctCompanies(); });
        }
    },
    'open-defunct-detail': function (e) { var el = e.target.closest('[data-defunct-idx]'); if (el && typeof _openDefunctDetail === 'function')
        _openDefunctDetail(parseInt(el.getAttribute('data-defunct-idx'), 10)); },
    'close-defunct-detail': function () { if (typeof _closeDefunctDetail === 'function')
        _closeDefunctDetail(); },
    'close-overlay-self': function (e) { var overlay = e.target.closest('[data-action="close-overlay-self"]'); if (e.target === overlay)
        overlay.classList.remove('open'); },
    'close-command-palette': function (e) { var overlay = e.target.closest('[data-action="close-command-palette"]'); if (e.target === overlay)
        closeCommandPalette(); },
    // N3 (mobile audit 2026-09-25): the palette's only pointer close was the
    // backdrop tap above, and mobile.css makes .cmd-modal 100dvh on phones -- no
    // backdrop left to tap. The visible "Close" button in the modal head
    // (static/templates/command-palette.html) is a real control, not the overlay
    // guard, so it closes unconditionally.
    'cmd-close': function (e) { if (e && e.preventDefault)
        e.preventDefault(); closeCommandPalette(); },
    // N4 (mobile audit 2026-09-25): the practice overlay's own exit control.
    'exit-practice-mode': function (e) { if (e && e.preventDefault)
        e.preventDefault(); _exitPracticeMode(); },
    'auth-close-modal': function () { if (typeof authCloseModal === 'function')
        authCloseModal(); },
    'auth-switch-tab': function (e) { if (typeof authSwitchTab === 'function')
        authSwitchTab(e.target.closest('[data-action]').dataset.tab); },
    'auth-toggle-mode': function () { if (typeof authToggleMode === 'function')
        authToggleMode(); },
    'auth-toggle-pw': function (e) { if (typeof authTogglePasswordVisibility === 'function')
        authTogglePasswordVisibility(e.target.closest('.auth-pw-toggle')); },
    'auth-sign-in-google': function () { if (typeof authSignInGoogle === 'function')
        authSignInGoogle(); },
    'auth-sign-in-github': function () { if (typeof authSignInGitHub === 'function')
        authSignInGitHub(); },
    'close-peer-edit-modal': function () { if (typeof closePeerEditModal === 'function')
        closePeerEditModal(); },
    'close-peer-edit-modal-backdrop': function (e) { if (e.target === e.target.closest('[data-action="close-peer-edit-modal-backdrop"]') && typeof closePeerEditModal === 'function')
        closePeerEditModal(); },
    'save-peer-edit-modal': function () { if (typeof savePeerEditModal === 'function')
        savePeerEditModal(); },
    'pg-switch-game': function (e) { if (typeof pgSwitchGame === 'function')
        pgSwitchGame(e.target.closest('[data-action]').dataset.game); },
    'practice-next-manual': function () { _practiceNextManual(); },
    'open-feature-discovery': function (e) {
        if (e && e.preventDefault)
            e.preventDefault();
        // #SETTINGS-DRAWER z-index fix: the settings panel (#ol-settings-panel,
        // z-index 11000 + backdrop) must close first, else the feature-discovery
        // overlay (z-index 10002) opens BEHIND it = silent dead control.
        var _csp = _delegatedActions['close-settings-panel'];
        if (_csp)
            _csp();
        if (typeof openFeatureDiscovery === 'function') {
            openFeatureDiscovery();
            return;
        }
        // If not loaded, navigate to /features/ rather than loading core-utils
        // chunk on-demand (which can freeze on slower machines).
        window.location.href = '/features/';
    },
    'replay-walkthrough': function () {
        // S36 audit 5.1d: allow replaying walkthrough from any page
        if (typeof Walkthrough !== 'undefined' && Walkthrough.start) {
            Walkthrough.start();
            return;
        }
        _loadModule('walkthrough').then(function () { if (typeof Walkthrough !== 'undefined')
            Walkthrough.start(); });
    },
    'open-glossary-browse': function (e) {
        if (e && e.preventDefault)
            e.preventDefault();
        // #SETTINGS-DRAWER z-index fix: close the settings panel (z 11000) before
        // opening the glossary modal (z 10000), else it paints behind the drawer.
        var _csp = _delegatedActions['close-settings-panel'];
        if (_csp)
            _csp();
        if (typeof openGlossaryBrowse === 'function') {
            openGlossaryBrowse();
            return;
        }
        // Load JUST glossary.js (~13KB) + its tooltip dep (~5KB), NOT the
        // full education chunk (489KB) which froze the main thread. The
        // glossary module is self-contained enough to run standalone — it
        // only needs GLOSSARY dict (defined at top of glossary.js itself).
        Promise.all([
            _loadModule('glossary'),
            _loadModule('glossary-tooltip-component'),
        ]).then(function () {
            if (typeof openGlossaryBrowse === 'function')
                openGlossaryBrowse();
        }).catch(function () {
            // If standalone load fails (missing dep), fall back to SSR page
            window.location.href = '/glossary/';
        });
    },
    // 2026-05-06 brand-audit Round 3 (OWNER ratified hidden-fallback per
    // COUNSEL Peirce posture): email/password is collapsed by default.
    // This handler reveals the form when user clicks "Sign in with email".
    // The disclosure link itself hides; the form sections (.auth-modal-
    // body-section) reveal. State persists for the lifetime of the modal
    // session — close+reopen the modal to collapse again.
    'auth-show-email-fallback': function (e) {
        if (e && e.preventDefault)
            e.preventDefault();
        var disclosure = document.getElementById('auth-email-disclosure');
        var sections = document.querySelectorAll('.auth-modal-body-section');
        var btn = document.querySelector('[data-action="auth-show-email-fallback"]');
        if (disclosure)
            disclosure.classList.add('d-none');
        sections.forEach(function (el) { el.classList.remove('d-none'); });
        if (btn)
            btn.setAttribute('aria-expanded', 'true');
        // Move focus to the first email input for keyboard users
        setTimeout(function () {
            var firstInput = document.getElementById('auth-signin-email');
            if (firstInput && typeof firstInput.focus === 'function') {
                firstInput.focus();
            }
        }, 50);
    },
    // 2026-05-06 brand-audit Round 3 (OWNER ratified): hamburger sidecar
    // listing all features by category. Editorial register: hairline,
    // tracked-caps eyebrows, serif item titles, no icons. Mirrors the
    // open/close pattern of apikeys + askai panels.
    'toggle-feature-sidecar': function (e) {
        // 2026-06-03: single-toggle stamp — the app-init.ts pre-hydration fallback
        // may also fire on this same click; whichever runs first wins, the other
        // no-ops. Without this the double-toggle netted to a no-op ("dead
        // hamburger" — the panel kept its d-none, confirmed in prod DOM).
        if (e && e._olFeatureSidecarToggled)
            return;
        if (e)
            e._olFeatureSidecarToggled = true;
        if (e && e.preventDefault)
            e.preventDefault();
        var overlay = document.getElementById('feature-sidecar-overlay');
        var panel = document.getElementById('feature-sidecar');
        var btn = document.querySelector('[data-action="toggle-feature-sidecar"]');
        if (!overlay || !panel)
            return;
        var isOpen = !panel.classList.contains('d-none');
        if (isOpen) {
            panel.classList.add('d-none');
            overlay.classList.add('d-none');
            if (btn)
                btn.setAttribute('aria-expanded', 'false');
            document.body.style.overflow = ''; // MA #30: release the background scroll-lock
        }
        else {
            overlay.classList.remove('d-none');
            panel.classList.remove('d-none');
            if (btn)
                btn.setAttribute('aria-expanded', 'true');
            // MA #30 (browser-verified gap 2026-07-25): lock the background — with
            // the drawer open the page behind still scrolled 400px on prod.
            document.body.style.overflow = 'hidden';
            // 2026-06-19 audit Phase-1 [High]: move focus into the drawer on open.
            var _ff = window._olSidecarFocusFirst;
            if (typeof _ff === 'function')
                _ff();
        }
    },
    // Sidecar-aware delegated handlers — close the sidecar on click,
    // then chain to the original action. Lets sidecar items navigate
    // without a stale-open panel hovering after the click.
    'set-view-close-feature-sidecar': function (e) {
        // OWNER QA 2026-06-23: the sidecar items are <a href="/?view=…"> (progressive
        // enhancement). Without preventDefault the browser ALSO follows the href = a
        // full page reload, during which the OPEN sidecar lingers on screen until the
        // new page boots — reads as "the sidecar didn't close on navigate". Prevent
        // the default so setView() drives a client-side nav and the d-none close below
        // is instant. Modified clicks (ctrl/cmd/shift/middle) fall through so the
        // href still opens the view in a new tab.
        var me = e;
        if (me && (me.metaKey || me.ctrlKey || me.shiftKey || me.button === 1))
            return;
        if (e && e.preventDefault)
            e.preventDefault();
        var t = (e && e.target) ? e.target.closest('[data-action]') : null;
        var view = t ? t.getAttribute('data-view') : null;
        // Stash the item's data-tab (or null) so a view renderer can open the right
        // sub-segment: setView()'s pushState rewrites the URL to bare ?view=<view>,
        // dropping any ?tab= the anchor href carried, so the client-side path can't
        // rely on location.search. Always write (null when absent) to prevent a
        // stale read from a prior click. Consumed+cleared by _inlineRenderIndustry.
        var _tab = t ? t.getAttribute('data-tab') : null;
        try {
            window.__olPendingViewTab = _tab;
        }
        catch (_e) { /* noop */ }
        _closeFeatureSidecar();
        // INP (RUM 2026-08-06: 2,392ms on this selector): yield to paint so the
        // close PAINTS before the ~51KB setView build runs in its own task.
        // Mechanism + pins: tests/test_sidecar_setview_yields_to_paint_contract.py
        if (view && typeof setView === 'function') {
            requestAnimationFrame(function () { setTimeout(function () { setView(view); }, 0); });
        }
    },
    'toggle-ask-ai-panel-close-feature-sidecar': function (e) {
        if (e && e.preventDefault)
            e.preventDefault();
        _closeFeatureSidecar();
        // Defer + chain to the askai toggle so it animates after the sidecar.
        // Bug 2026-05-11: previously called `window.toggleAskAiPanel` but the
        // function lives at module top-level in ask-ai.ts (line 1134) and is
        // NOT attached to window — `typeof window.toggleAskAiPanel` is always
        // 'undefined' here, so the click silently no-op'd. Mirror the working
        // 'toggle-ask-ai-panel' handler above (line 2105): bare identifier +
        // premium-chunk lazy-load fallback.
        setTimeout(function () {
            if (typeof toggleAskAiPanel === 'function') {
                toggleAskAiPanel();
                return;
            }
            _loadChunk('premium').then(function () {
                if (typeof toggleAskAiPanel === 'function')
                    toggleAskAiPanel();
            }).catch(function () {
                if (typeof showToast === 'function')
                    showToast('Unable to load AI panel', 'error');
            });
        }, 50);
    },
    // 2026-06-12 audit 3.6 (OWNER ratified "promote within Learn"): the
    // sidecar Glossary item used to href to the SSR /glossary/ SEO page —
    // the exact engaged-user bounce feedback_prefer_inapp_over_seo_routing
    // forbids and that #128 already fixed for the welcome tile. This
    // handler routes in-app: close the sidecar, switch to the Learn view,
    // then click the .lp-tab[data-tab="glossary"] button (the one source
    // of truth — the learn-tab paneMap above does the pane switch + lazy
    // render). Bounded poll mirrors views.ts's _lpClickTab: the Learn view
    // renders async, and for anon users the auth gate renders NO .lp-tab
    // buttons, so the poll gives up quietly after 5s.
    // N5 (OWNER 2026-09-25, mobile audit): a SIGNED-OUT reader goes to the public
    // /glossary/ page instead -- the in-app tab is a sign-up gate for them. The
    // signal is olIsAnonymous() (auth-state.ts, the synchronous ol_csrf_hmac
    // check; ol_session is HttpOnly), falling back to _userTier. When the signal
    // cannot be read the reader also goes to /glossary/: that URL is right for
    // both states, because routes/pages.py 302s an ol_session holder to the
    // in-app tab. Signed-in readers keep the in-app route below (no round trip).
    'open-learn-glossary-close-feature-sidecar': function (e) {
        if (e && e.preventDefault)
            e.preventDefault();
        _closeFeatureSidecar();
        var _gAnon = true;
        try {
            var _gw = window;
            // CHAOS 2026-09-25: an in-session sign-out sets _userTier = 'anonymous'
            // (auth-handlers.ts) and olIsAnonymous() reads ANY truthy tier as signed
            // in, so after a sign-out it answers false -- check the explicit value
            // first or a just-signed-out reader lands on the Learn sign-up gate.
            _gAnon = (_gw._userTier === 'anonymous') || ((typeof _gw.olIsAnonymous === 'function')
                ? !!_gw.olIsAnonymous()
                : (_gw._userTier === undefined));
        }
        catch (_e) {
            _gAnon = true;
        }
        if (_gAnon) {
            window.location.href = '/glossary/';
            return;
        }
        if (typeof setView === 'function')
            setView('learn');
        var _glossWaited = 0;
        var _glossIv = setInterval(function () {
            _glossWaited += 100;
            var btn = document.querySelector('.lp-tab[data-tab="glossary"]');
            if (btn) {
                clearInterval(_glossIv);
                try {
                    btn.click();
                }
                catch (_e) { /* defensive */ }
                return;
            }
            if (_glossWaited > 5000)
                clearInterval(_glossIv);
        }, 100);
    },
    'open-settings-panel-close-feature-sidecar': function (e) {
        if (e && e.preventDefault)
            e.preventDefault();
        _closeFeatureSidecar();
        // N8 (2026-09-25): was a hand-rolled attribute pair that skipped the
        // scroll-lock; the shared opener owns trap + focus + lock.
        _olOpenSettingsPanel();
    },
    'toggle-api-keys-panel': function (e) {
        // 2026-04-26 fix: link is `<a href="#">` inside the settings dropdown.
        // Without preventDefault, clicking adds `#` to the URL (visible
        // navigation tick) AND the settings dropdown intercepts/closes the
        // click before the panel can render. Block both.
        if (e && e.preventDefault)
            e.preventDefault();
        // Close the settings panel first so the API-keys panel slides over a
        // clean canvas. The setView-style settings dropdown self-closes on
        // outside-click but explicit close is faster + race-free.
        var settingsPanel = document.getElementById('ol-settings-panel');
        if (settingsPanel && settingsPanel.classList.contains('open')) {
            settingsPanel.classList.remove('open');
        }
        if (typeof toggleApiKeysPanel === 'function') {
            toggleApiKeysPanel();
            return;
        }
        // api-keys.js lives in the premium chunk (build_bundle.py
        // CSS_CHUNKS['premium']). The standalone /static/js/api-keys.js
        // path is not served on prod (Render returns 502), so we must
        // load the chunk that contains it.
        _loadChunk('premium').then(function () {
            if (typeof toggleApiKeysPanel === 'function') {
                toggleApiKeysPanel();
            }
            else {
                if (typeof console !== 'undefined')
                    console.error('[ll-keys] toggleApiKeysPanel undefined after premium chunk load');
                if (typeof showToast === 'function')
                    showToast('Unable to load LLM & API Keys panel — please refresh.', 'error', 4000);
            }
        }).catch(function (err) {
            if (typeof console !== 'undefined')
                console.error('[ll-keys] premium chunk load failed:', err);
            if (typeof showToast === 'function')
                showToast('Could not load LLM & API Keys panel.', 'error', 4000);
        });
    },
    'open-customize-tickers': function () { openCustomizeTickers(); },
    'toggle-theme': function () {
        var html = document.documentElement;
        var current = html.getAttribute('data-theme');
        var next = current === 'light' ? 'dark' : 'light';
        html.setAttribute('data-theme', next);
        try {
            OLStorage.setString('ol_theme', next);
        }
        catch (e) { /* QuotaExceededError — theme still applied to DOM */ }
        // #63c: icon is a pure-CSS swap on <html data-theme> (shared
        // .ol-chrome-theme-ico contract, oxford.css). Do NOT reintroduce
        // an innerHTML/textContent write on #topbar-theme-toggle here --
        // it destroys the declared dual-<svg> children
        // (feedback_never_destroy_dom) and re-forks SSR vs SPA. Setting
        // data-theme above is sufficient. Gated by
        // tests/test_ssr_chrome_convergence_contract.py.
    },
    'cycle-density': function () {
        var body = document.body;
        var levels = ['normal', 'compact', 'spacious'];
        var current = OLStorage.getString('ol_density', null) || 'normal';
        var idx = (levels.indexOf(current) + 1) % levels.length;
        var next = levels[idx];
        levels.forEach(function (l) { body.classList.remove('density-' + l); });
        body.classList.add('density-' + next);
        try {
            OLStorage.setString('ol_density', next);
        }
        catch (e) { /* QuotaExceededError — density still applied to DOM */ }
    },
    'toggle-kb-modal': function () { toggleKbModal(); },
    // #114 (2026-08-12): restored from the telemetry shim F3.8 left here on
    // 2026-05-07. That deletion cited the topstrip pill as the surviving
    // control; the pill was retired 2026-06-02 citing auto-detection that
    // does not exist. Between them the product had NO skill-level control in
    // either direction. Full history + the invariants:
    // tests/test_skill_level_control_reachable_contract.py.
    'set-user-level': function (e) {
        var el = e.target.closest('[data-action]');
        if (!el)
            return;
        var level = el.dataset.levelValue;
        // Binary space per F3.8 Q2/Q3: app-init's _isBeginnerSkillLevel reads
        // ONLY 'beginner' as beginner; anything else silently means advanced,
        // so refuse rather than persist a value that looks set and is not.
        if (level !== 'beginner' && level !== 'advanced')
            return;
        var prior = null;
        try {
            prior = OLStorage.getString('ol_user_level', null)
                || OLStorage.getString('skillLevel', null);
        }
        catch (_) { }
        // BOTH keys — readers are split (app-init/ask-ai take `ol_user_level ||
        // skillLevel`; glossary/learning-paths take skillLevel alone), so one
        // write leaves half the product on the old level. welcome-flow does the
        // same for the same reason.
        try {
            OLStorage.setString('ol_user_level', level);
        }
        catch (_) { }
        try {
            OLStorage.setString('skillLevel', level);
        }
        catch (_) { }
        // Live effect, mirroring app-init's boot-time _applyBeginnerMode (which
        // is scoped inside that IIFE and unreachable from here).
        if (document.body) {
            document.body.classList.toggle('beginner-mode', level === 'beginner');
        }
        var liveBtn = document.getElementById('view-macro-btn');
        if (liveBtn) {
            var txt = (liveBtn.textContent || '').trim();
            if (level === 'beginner' && txt === 'LIVE')
                liveBtn.textContent = 'MARKETS';
            else if (level !== 'beginner' && txt === 'MARKETS')
                liveBtn.textContent = 'LIVE';
        }
        // F3.8 Q4: same event name + payload as welcome-flow's door write, so
        // the two writers are comparable in one query.
        if (typeof _track === 'function') {
            _track('skill_level_changed', {
                from: prior || 'unknown', to: level, source: 'settings_panel',
            });
        }
        if (typeof _olRefreshSettingsPanel === 'function')
            _olRefreshSettingsPanel();
    },
    'cycle-user-level': function () {
        if (typeof _track === 'function') {
            _track('skill_level_changed_via_deprecated_action', {
                source: 'cycle-user-level',
                note: 'F3.8 deleted this action 2026-05-07; reaching this handler '
                    + 'means a stale caller exists somewhere',
            });
        }
    },
    'set-welcome-level': function (e) {
        var el = e.target.closest('[data-action]');
        var level = el.dataset.level;
        document.querySelectorAll('.welcome-level-chip').forEach(function (b) {
            b.classList.toggle('active', b.dataset.level === level);
        });
        if (typeof _setUserLevel === 'function')
            _setUserLevel(level);
        if (typeof MetricInsights !== 'undefined')
            MetricInsights.setLevel(level);
        // Dynamic welcome content based on selected level
        var headlines = {
            beginner: 'Learn investing with real companies and real data.',
            learner: 'Your research platform. No paywall.',
            expert: 'Institutional-grade depth. Free and transparent.'
        };
        var taglines = {
            beginner: 'Every number explained in plain English. Practice games, guided lessons, and an AI tutor that teaches instead of just answering.',
            learner: 'Compare any company to its sector peers instantly. 10-year financials, valuation models, and AI that knows the data you\u2019re looking at.',
            expert: 'Parse SEC filings in seconds, not hours. Track what hedge funds own, screen bonds by yield, and build with our API.'
        };
        var subs = {
            beginner: '<strong>P/E</strong> = price vs. profits (lower = cheaper) \u2022 <strong>Market Cap</strong> = total company value \u2022 <strong>Dividend</strong> = cash paid to shareholders',
            learner: 'Sector-relative metrics show if a stock is cheap or expensive <em>for its industry</em> \u2014 not just vs. arbitrary thresholds.',
            expert: 'Private credit analysis, BDC holdings, covenant tracking, earnings transcripts \u2014 data most free platforms don\u2019t touch.'
        };
        var stats = {
            beginner: [['Plain English', 'Every metric explained'], ['AI Tutor', 'Asks questions, not just answers'], ['Practice', 'Build real skills'], ['Free', 'No paywall, ever']],
            learner: [['10 Years', 'Full financial history'], ['Peer Context', 'vs. sector, not guesswork'], ['Valuations', 'DCF, EPV, Graham built in'], ['AI Research', 'Knows your data']],
            expert: [['SEC Filings', '10-K, 10-Q, 13F, Form 4'], ['Private Credit', 'BDC holdings + recovery rates'], ['Bond Screener', 'Yield, duration, credit quality'], ['SDK + API', 'Python client + MCP tools']]
        };
        var ctas = { beginner: 'Start learning', learner: 'Start researching', expert: 'Open research suite' };
        var presetLabels = { beginner: 'PICK COMPANIES YOU KNOW', learner: 'START WITH A WATCHLIST', expert: 'SEED YOUR UNIVERSE' };
        var h = document.getElementById('welcome-headline');
        if (h)
            h.textContent = headlines[level] || headlines.beginner;
        var t = document.getElementById('welcome-tagline');
        if (t)
            t.textContent = taglines[level] || taglines.beginner;
        var s = document.getElementById('welcome-sub');
        if (s)
            s.innerHTML = subs[level] || subs.beginner;
        var ctaBtn = document.querySelector('.welcome-start-btn');
        if (ctaBtn)
            ctaBtn.textContent = ctas[level] || ctas.beginner;
        var presetLabel = document.querySelector('.welcome-section-label');
        if (presetLabel)
            presetLabel.textContent = presetLabels[level] || presetLabels.beginner;
        // Show LEARN hint only for beginners
        var learnHint = document.getElementById('welcome-learn-hint');
        if (learnHint)
            learnHint.classList.toggle('d-none', level !== 'beginner');
    },
    // Goal selection moved to Settings page
    // Q1 pointer-events refactor (2026-04-29): removed
    // `toggle-api-keys-panel-backdrop` + `toggle-askai-panel-backdrop`
    // handlers. The overlay HTML no longer carries those data-actions
    // and CSS marks the overlays `pointer-events: none`, so these
    // delegated handlers were dead code — but kept around they invited
    // a future contributor to "fix" the overlay by re-adding the data-
    // action attribute, resurrecting the S55 z-index click-trap.
    // Click-outside-to-close lives in ask-ai.js + api-keys.js as
    // explicit capture-phase document listeners now.
    'create-user-api-key': function () { _createUserApiKey(); },
    'open-askai-from-apikeys': function () { if (typeof toggleApiKeysPanel === 'function')
        toggleApiKeysPanel(); setTimeout(function () { if (typeof toggleAskAiPanel === 'function')
        toggleAskAiPanel(); }, 300); },
    'askai-save-key': function () { _askAiSaveKeyFromInput(); },
    // T2.4 (CHAOS §2.6): test the key without persisting. Server makes
    // a 1-token upstream call; key never written to DB or logs.
    'askai-test-key': function () { if (typeof _askAiTestKey === 'function')
        _askAiTestKey(); },
    'askai-remove-key': function () { _askAiRemoveKey(); },
    'askai-submit': function () { if (typeof _askAiSubmit === 'function')
        _askAiSubmit(); },
    'askai-stop': function () { _askAiStop(); },
    'askai-clear': function () { _askAiClear(); },
    'gloss-tooltip-click': function () { _glossTooltipClick(); },
    'gloss-set-level': function (e) { _glossSetLevel(e.target.closest('[data-action]').dataset.level); },
    'gloss-modal-close': function () { _glossModalClose(); },
    'close-compare-modal-backdrop': function (e) { if (e.target === e.target.closest('[data-action="close-compare-modal-backdrop"]')) {
        if (typeof closeCompareModal === 'function')
            closeCompareModal();
    } },
    'close-compare-modal': function () { if (typeof closeCompareModal === 'function')
        closeCompareModal(); },
    'close-company-facts-modal-backdrop': function (e) { if (e.target === e.target.closest('[data-action="close-company-facts-modal-backdrop"]'))
        document.getElementById('company-facts-modal')?.classList.remove('visible'); },
    'close-company-facts-modal': function () { document.getElementById('company-facts-modal')?.classList.remove('visible'); },
    'close-feature-discovery-backdrop': function (e) { if (e.target === e.target.closest('[data-action="close-feature-discovery-backdrop"]') && typeof closeFeatureDiscovery === 'function')
        closeFeatureDiscovery(); },
    'close-feature-discovery': function () { if (typeof closeFeatureDiscovery === 'function')
        closeFeatureDiscovery(); },
    // ── CISO P0: XSS-safe delegated actions replacing inline onclick with user input ──
    'select-suggest': function (e) { var el = e.target.closest('[data-action]'); selectSuggest(el.dataset.sym); },
    'switch-ticker': function (e) { var el = e.target.closest('[data-action]'); switchTicker(el.dataset.ticker); },
    'kpi-expand': function (e) { if (typeof _kpiExpandRow === 'function')
        _kpiExpandRow(e.target.closest('[data-action]')); }, // K9 industry ranked view
    'kpi-compare': function (e) { if (typeof _kpiOpenCompare === 'function')
        _kpiOpenCompare(e); }, // K6 step 3: ticker-page Comps -> Industry table
    // CSP Phase 3: behavioral-nudge dismiss (replaces inline onclick on the
    // ticker-renderer.js banner). The button sits inside #ticker-behavioral-nudge
    // and clicking it hides the wrapper.
    'dismiss-beh-nudge': function (e) { var btn = e.target.closest('[data-action]'); var w = btn && btn.closest('#ticker-behavioral-nudge'); if (w)
        w.style.display = 'none'; },
    'load-13f-holdings': function (e) { var el = e.target.closest('[data-action]'); load13fHoldings(el.dataset.cik, el.dataset.name); },
    'add-ticker-by-symbol': function (e) { var el = e.target.closest('[data-action]'); addTickerBySymbol(el.dataset.sym); },
    'iv-switch-tab': function (e) { var el = e.target.closest('[data-action]'); _ivSwitchTab(el.dataset.ticker, el.dataset.tab); },
    'delete-annotation': function (e) { var el = e.target.closest('[data-action]'); _deleteAnnotation(parseInt(el.dataset.annId, 10), el.dataset.ticker); },
    'search-13f-back': function () { search13fFund(); },
    'set-ticker-chart-period': function (e) { var el = e.target.closest('[data-action]'); if (typeof setTickerChartPeriod === 'function')
        setTickerChartPeriod(el.dataset.period); },
    'set-preferred-broker': function (e) { e.preventDefault(); e.stopPropagation(); var el = e.target.closest('[data-action]'); _setPreferredBroker(el.dataset.broker); },
    'show-company-facts': function (e) { e.stopPropagation(); if (typeof showCompanyFactsModal === 'function')
        showCompanyFactsModal(); },
    'dismiss-metric-hint': function (e) { e.target.closest('[data-action]').remove(); try {
        OLStorage.setString('_metricHintSeen', '1');
    }
    catch (e2) { } },
    'dismiss-premium-nudge': function (e) { var el = e.target.closest('[data-action]'); _dismissPremiumNudge(el.dataset.nudgeKey, el); },
    'cmd-execute': function (e) { var el = e.target.closest('[data-action]'); cmdExecute(parseInt(el.dataset.idx, 10)); },
    'cmd-hover': function (e) { var el = e.target.closest('[data-action]'); cmdSelectedIdx = parseInt(el.dataset.idx, 10); renderCommandResults(document.getElementById('cmd-input').value); },
    'start-checkout': function (e) { var el = e.target.closest('[data-action]'); _startCheckout(el.dataset.tier, el.dataset.period); },
    'beta-dismiss': function () { _betaDismiss(); },
    'skip-tour': function () { skipTour(); },
    'next-tour-step': function () { nextTourStep(); },
    'toggle-section': function (e) {
        var el = e.target.closest('[data-action]');
        var sec = document.getElementById(el.dataset.sectionId);
        if (!sec)
            return;
        var isCollapsing = !sec.classList.contains('d-none');
        sec.classList.toggle('d-none', isCollapsing);
        // ARIA: announce expanded/collapsed state for screen readers
        el.setAttribute('aria-expanded', isCollapsing ? 'false' : 'true');
        var arrow = el.querySelector('.ig-arrow,.iv-arrow');
        if (arrow)
            arrow.textContent = isCollapsing ? '\u25B6' : '\u25BC';
    },
    'set-usage-cap': function (e) { var el = e.target.closest('[data-action]'); _setUsageCap(parseInt(el.dataset.cap, 10)); },
    'set-custom-cap': function () { _setCustomCap(); },
    'toggle-cap-options': function () { _toggleCapOptions(); },
    'open-billing-portal': function () { _openBillingPortal(); },
    'toggle-email-pref': function (e) { var el = e.target.closest('[data-action]'); _toggleEmailPref(el.dataset.prefKey, el.checked); },
    'kms-toggle-tooltip': function (e) { e.target.closest('[data-action]').classList.toggle('tooltip-visible'); },
    'toggle-analytics-section': function (e) { var el = e.target.closest('[data-action]'); if (el && el.dataset.section && typeof toggleAnalyticsSection === 'function')
        toggleAnalyticsSection(el.dataset.section); },
    'set-vwap-period': function (e) { var el = e.target.closest('[data-action]'); if (el && el.dataset.period && typeof setVWAPPeriod === 'function')
        setVWAPPeriod(el.dataset.period); },
    'set-ce-filter': function (e) { var el = e.target.closest('[data-action]'); if (el && typeof _setCEFilter === 'function')
        _setCEFilter(el.dataset.filterType, el.dataset.ticker); },
    'fy-view-mode': function (e) { var el = e.target.closest('[data-action]'); if (el && el.dataset.mode) {
        if (typeof _fyViewMode !== 'undefined')
            window._fyViewMode = el.dataset.mode;
        else
            _fyViewMode = el.dataset.mode;
        var d = typeof getData === 'function' ? getData(activeTicker) : null;
        if (d && typeof renderFiveYearHistory === 'function')
            renderFiveYearHistory(d.fiveYearHistory);
    } },
    'undo-remove-portfolio-ticker': function () { undoRemovePortfolioTicker(); },
    'undo-remove-ticker': function () { undoRemoveTicker(); },
    'cross-search-fund': function (e) { e.stopPropagation(); var el = e.target.closest('[data-action]'); crossSearchFund(el.dataset.holder); },
    // F4.2 (SF-23 audit 2026-05-07): 13F is OWNER-policy public SEC data
    // per pricing.html:150-154 ("OWNER policy: 13F is public SEC data;
    // not paywalled. /api/institutional-holders[/changes] now anon-OK").
    // Pre-fix this gated show-all behind _isProUser() and routed free
    // users to showPremiumGate('13f'). Post-fix every tier (including
    // anon) gets the full holdings list — the policy already un-paywalled
    // the backend; this closes the FE side.
    // 2026-07-08 fix: this button lives in the holders-BY-TICKER panel, not a
    // fund context — the old load13fHoldings(cik, fundName) referenced vars that
    // don't exist there (ReferenceError: cik is not defined, swallowed by the
    // render catch). Correct behavior: flip the show-all flag and RE-RUN the
    // ticker search (reads #f13-ticker-input, re-renders uncapped).
    'f13-show-all': function () { _f13ShowAll = true; if (typeof search13fTicker === 'function')
        search13fTicker(); },
    // NH2 (2026-05-07): bdc-view paywall CTAs route through showPremiumGate
    // so the in-app upgrade flow opens instead of full-page navigating
    // away to /?upgrade=plus (which lost BDC view state on click).
    // data-feature carries the canonical featureId
    // (paywall_bdc_holders / paywall_bdc_holdings / paywall_bdc_stress_test).
    'bdc-show-paywall': function (e) {
        var el = e.target.closest('[data-action]');
        var feat = (el && el.dataset && el.dataset.feature) || 'paywall_bdc';
        if (typeof showPremiumGate === 'function') {
            showPremiumGate(feat);
        }
        else {
            // Defensive shim — if premium-gate.js hasn't loaded yet (boot race),
            // fall back to the legacy URL so the user still gets the upgrade
            // surface, just via full-page navigation.
            window.location.href = '/?upgrade=plus';
        }
    },
    'copy-ticker-summary': function () { if (typeof copyTickerSummary === 'function')
        copyTickerSummary(); },
    'export-ticker-pdf': function () { if (typeof exportTickerPDF === 'function')
        exportTickerPDF(); },
    'toggle-share-menu': function () { toggleShareMenu(); },
    'share-copy-summary-ql': function () { shareCopySummary(); },
    'share-copy-for-ai': function () { shareCopyForAI(); },
    'share-via-email': function () { shareViaEmail(); },
    'generate-share-card': function () {
        if (typeof generateShareCard === 'function') {
            generateShareCard();
            return;
        }
        _loadModule('share-card').then(function () { if (typeof generateShareCard === 'function')
            generateShareCard(); });
    },
    'share-copy-link': function () { shareCopyLink(); },
    'nudge-close': function (e) { e.target.closest('[data-action]').parentElement.remove(); },
    // ── I-07/I-10 Phase 2c additions — extracted from inline onclick ──────────
    // Socratic mode badge toggle (was: onclick="_askAiToggleSocraticMode()")
    'toggle-socratic-mode': function () { if (typeof _askAiToggleSocraticMode === 'function')
        _askAiToggleSocraticMode(); },
    // SF-12 12D: Research mode badge toggle (grounded, cited-filings answers)
    'toggle-research-mode': function () { if (typeof _askAiToggleResearchMode === 'function')
        _askAiToggleResearchMode(); },
    // SDK install command copy button (was: inline clipboard + text swap).
    // SF-MCP-CONNECT-HOWTO T3b (OWNER Q-9, 2026-09-13): same behaviour as the
    // shared copy-snippet.js module the SSR pages load -- label "Copied" (brand
    // rule: no exclamation) for 1500ms plus a polite live-region announcement
    // -- kept local because this chunk never loads that module. The status
    // node is created next to the button via createElement/appendChild.
    'sdk-copy-install': function (e) {
        var btn = e.target.closest('[data-action]');
        var cmd = (document.getElementById('sdk-install-cmd') || {}).textContent || 'pip install ol-sdk';
        var host = btn ? btn.parentElement : null;
        var status = host ? host.querySelector('.sr-only[aria-live="polite"]') : null;
        if (host && !status) {
            status = document.createElement('span');
            status.className = 'sr-only';
            status.setAttribute('aria-live', 'polite');
            host.appendChild(status);
        }
        if (navigator.clipboard) {
            navigator.clipboard.writeText(cmd).then(function () {
                if (btn) {
                    btn.textContent = 'Copied';
                }
                if (status) {
                    status.textContent = 'Copied to clipboard';
                }
                setTimeout(function () {
                    if (btn) {
                        btn.textContent = 'Copy';
                    }
                    if (status) {
                        status.textContent = '';
                    }
                }, 1500);
            }).catch(function () {
                if (btn) {
                    btn.textContent = 'Select and copy';
                    setTimeout(function () { btn.textContent = 'Copy'; }, 1500);
                }
            });
        }
    },
    // R7 (BOARD 2026-09-26): "Copy question" on a data panel's ask-your-assistant line.
    'mcp-copy-question': function (e) {
        var btn = e.target.closest('[data-action]');
        if (btn) {
            e.preventDefault();
            void olMcpCopyQuestion(btn);
        }
    },
    // Inner modal div — absorb clicks so they don't bubble to backdrop close handler
    // (was: onclick="event.stopPropagation()" on .cb-modal)
    'stop-propagation': function (e) { e.stopPropagation(); },
    // Toggle Custom Chart Builder (was: inline onclick on cb-toggle-btn)
    'toggle-custom-chart-builder': function () {
        if (typeof toggleCustomChartBuilder === 'function') {
            toggleCustomChartBuilder();
            return;
        }
        _loadModule('custom-charts').then(function () { if (typeof toggleCustomChartBuilder === 'function')
            toggleCustomChartBuilder(); });
    },
    // Transcript controls (were: inline onclick on Load / Search / Summarize buttons)
    'load-transcript': function () { if (typeof loadTranscript === 'function')
        loadTranscript(); },
    'search-transcripts': function () { if (typeof searchTranscripts === 'function')
        searchTranscripts(); },
    'summarize-transcript-ai': function () { if (typeof summarizeTranscriptWithAI === 'function')
        summarizeTranscriptWithAI(); },
    // Ask AI panel from LEARN view (was: onclick="toggleAskAiPanel()")
    'toggle-ask-ai-from-learn': function () {
        if (typeof toggleAskAiPanel === 'function') {
            toggleAskAiPanel();
            return;
        }
        // #262 D1b (2026-07-27): the Path-B research cluster now lives in the
        // ask-ai-research.js sibling. This is the ONE standalone (non-chunk) entry
        // to the panel, so it must pull BOTH halves — otherwise Research mode is
        // undefined here and _askAiSubmitResearch throws on its own error path.
        Promise.all([_loadModule('ask-ai'), _loadModule('ask-ai-research'),
            _loadModule('ask-ai-context'), _loadModule('ask-ai-affordances'), // T7 (2026-09-13): the two further halves
            _loadModule('ask-ai-provenance'), _loadModule('ask-ai-debate')]) // 2026-09-28: provenance + debate legs
            .then(function () { if (typeof toggleAskAiPanel === 'function')
            toggleAskAiPanel(); });
    },
    // Calendar retry (inline fallback)
    'cal-retry': function () {
        _calendarCache = null;
        if (typeof renderCalendarView === 'function') {
            renderCalendarView();
            return;
        }
        _inlineRenderCalendar();
    },
    // Issuer search (triggered by a dedicated button if added, or via Enter key below)
    'select-issuer-result': function (e) {
        // K12 (2026-09-14): a search result no longer carries the bond's CUSIP
        // (/api/bond-search stopped serialising it), so "Select" fills the label
        // only. Add-by-CUSIP from a search row is the accepted casualty (COUNSEL
        // 2026-08-07 sect.5B.3).
        var el = e.target.closest('[data-action]');
        var issuer = el.dataset.issuer || '';
        var li = document.getElementById('credit-label-input');
        if (li)
            li.value = issuer;
    },
    'credit-issuer-search-go': function () {
        var inp = document.getElementById('credit-issuer-search');
        var el = document.getElementById('credit-issuer-results');
        var spinner = document.getElementById('credit-search-spinner');
        if (!inp || !inp.value.trim())
            return;
        if (spinner) {
            spinner.classList.remove('d-none');
            spinner.textContent = 'searching...';
        }
        if (el)
            el.textContent = '';
        fetch(((typeof SERVER !== 'undefined') ? SERVER : '') + '/api/bond-search?query=' + encodeURIComponent(inp.value.trim()), { signal: (typeof getViewAwareSignal === 'function' ? getViewAwareSignal(15000) : AbortSignal.timeout(15000)) })
            .then(function (r) { return r.ok ? r.json() : Promise.reject('HTTP ' + r.status); })
            .then(function (data) {
            if (spinner)
                spinner.classList.add('d-none');
            var bonds = Array.isArray(data) ? data : (data && data.results ? data.results : (data && data.bonds ? data.bonds : []));
            if (!bonds.length) {
                if (el)
                    el.innerHTML = '<div class="status-msg status-msg--muted">No bonds found for "' + escHtml(inp.value.trim()) + '".</div>';
                return;
            }
            var html = '';
            for (var i = 0; i < Math.min(bonds.length, 15); i++) {
                var b = bonds[i];
                var subParts = [];
                if (b.coupon != null)
                    subParts.push(b.coupon + '%');
                if (b.maturity)
                    subParts.push(escHtml(b.maturity));
                html += '<div class="search-result-row">'
                    + '<div><div class="search-result-row__name">' + escHtml(b.issuer || b.name || '') + '</div>'
                    + '<div class="search-result-row__sub">' + subParts.join(' | ') + '</div></div>'
                    + '<button data-action="select-issuer-result" data-issuer="' + escHtml(b.issuer || b.name || '') + '" class="credit-select-btn">Select</button>'
                    + '</div>';
            }
            if (el)
                _safeSetHTML(el, html);
        })
            .catch(function () {
            if (spinner)
                spinner.classList.add('d-none');
            if (el)
                el.innerHTML = '<div class="status-msg status-msg--muted">Issuer search failed.</div>';
        });
    },
    // ── Portfolio Practicum (?view=practicum) ─────────────────────────────────
    'prac-set-goal': function (e) {
        var el = e.target.closest('[data-action]');
        if (el && typeof _pracGoal !== 'undefined') {
            _pracGoal = el.dataset.goal;
            _pracRender();
        }
    },
    'prac-remove': function (e) {
        var el = e.target.closest('[data-action]');
        var idx = parseInt(el && el.dataset.idx, 10);
        if (typeof _pracTickers !== 'undefined' && !isNaN(idx)) {
            _pracTickers.splice(idx, 1);
            _pracRender();
        }
    },
    'prac-review': function () {
        if (typeof _pracDoReview === 'function') {
            _pracDoReview();
            return;
        }
        _loadChunk('education').then(function () { if (typeof _pracDoReview === 'function')
            _pracDoReview(); }).catch(function () { showToast('Unable to load AI review', 'error', 3000); });
    },
    'prac-complete': function () {
        if (typeof _pracComplete === 'function') {
            _pracComplete();
            return;
        }
        _loadChunk('education').then(function () { if (typeof _pracComplete === 'function')
            _pracComplete(); });
    },
    // ── I-24: Ticker module customize panel ───────────────────────────────────
    // Wire open-ticker-customize, tm-cancel, tm-reset, tm-save into central
    // dispatcher.  TickerModules handles the same events via its own document
    // listener (id-based fallback); _delegatedActions covers closest()-based
    // matching for robustness when e.target is a child element.
    'open-ticker-customize': function () {
        if (typeof TickerModules !== 'undefined' && typeof TickerModules.openModal === 'function') {
            TickerModules.openModal();
        }
    },
    'tm-cancel': function () {
        if (typeof TickerModules !== 'undefined' && typeof TickerModules.closeModal === 'function') {
            TickerModules.closeModal();
        }
    },
    'tm-reset': function () {
        if (typeof TickerModules !== 'undefined' && typeof TickerModules.resetModal === 'function') {
            TickerModules.resetModal();
        }
    },
    'tm-save': function () {
        if (typeof TickerModules !== 'undefined' && typeof TickerModules.saveModal === 'function') {
            TickerModules.saveModal();
        }
    },
    // ── I-16: Share dropdown "More options" toggle ────────────────────────────
    // Moved from standalone data-freshness.js listener into _delegatedActions so
    // the central dispatcher owns it.  The standalone listener in data-freshness.js
    // has been removed to prevent double-toggle.
    'share-toggle-more': function (e) {
        var btn = e.target.closest('[data-action="share-toggle-more"]');
        if (!btn)
            return;
        var items = btn.parentElement
            ? btn.parentElement.querySelector('.share-more-items')
            : null;
        if (!items)
            return;
        var isOpen = items.classList.contains('open');
        items.classList.toggle('open', !isOpen);
        btn.setAttribute('aria-expanded', String(!isOpen));
        var arrow = btn.querySelector('.share-more-arrow');
        if (arrow)
            arrow.textContent = isOpen ? '\u25be' : '\u25b4';
    },
    // P2-4: Cookie consent delegation
    'cookie-accept': function () {
        // OWNER ruling 2026-10-13: the banner is a notice, so "Got it" records an
        // acknowledgement only -- never an `analytics` flag (inline-init.ts note).
        OLStorage.set('ol_cookie_consent', { notice: 'acknowledged', ts: Date.now() });
        OLStorage.setString('cookieConsent', 'acknowledged');
        var banner = document.getElementById('cookie-consent-banner');
        if (banner) {
            // #94 (2026-06-03): the inline-init show-path sets `style.display:flex`
            // INLINE, which overrides the .d-none class — so adding the class alone
            // never hid the banner and "Got it" appeared to do nothing (the banner
            // seemed to show continually). Clear the inline display so the dismiss
            // actually hides it.
            banner.style.display = 'none';
            banner.classList.add('d-none');
        }
    },
    /* 'cookie-reject' delegation removed (#116): dead — no data-action=
       "cookie-reject" element exists; reject is not a live GDPR obligation
       for essential-only storage (COUNSEL 2026-05-17). See the banner note. */
    // ── CSP-3F: adaptive-ui.js level-upgrade banner buttons ──────────────────
    // Replaces inline onclick= handlers that violated script-src CSP.
    'banner-unlock-level': function (e) {
        var btn = e.target.closest('[data-action]');
        if (typeof _setUserLevel === 'function')
            _setUserLevel('learner');
        var banner = btn && btn.closest('#level-upgrade-banner');
        if (banner)
            banner.remove();
        try {
            OLStorage.setString('ol_level_banner_dismissed', '1');
        }
        catch (ex) { }
    },
    'banner-dismiss-level': function (e) {
        var btn = e.target.closest('[data-action]');
        var banner = btn && btn.closest('#level-upgrade-banner');
        if (banner)
            banner.remove();
        try {
            OLStorage.setString('ol_level_banner_dismissed', '1');
        }
        catch (ex) { }
    },
    // ── CSP-3F: news.js learn-bite toggle ────────────────────────────────────
    // Replaces inline onclick= handler that violated script-src CSP.
    'nw-toggle-learn-bite': function (e) {
        var el = e.target.closest('[data-action]');
        var targetId = el && el.dataset.target;
        var target = targetId && document.getElementById(targetId);
        if (!target)
            return;
        target.classList.toggle('nw-learn-explainer--hidden');
    },
    // ── CSP screener-options.js migration ────────────────────────────────────
    // All inline onclick/onchange handlers in screener-options.js migrated to
    // data-action delegation to comply with strict script-src CSP (no unsafe-inline).
    'scr-sort-mf': function (e) {
        var el = e.target.closest('[data-action]');
        if (!el)
            return;
        if (typeof _sortMF === 'function')
            _sortMF(parseInt(el.dataset.colIdx, 10));
    },
    'scr-pick-ticker': function (e) {
        var el = e.target.closest('[data-action="scr-pick-ticker"]');
        if (!el)
            return;
        var ticker = el.dataset.ticker;
        if (!ticker)
            return;
        if (typeof addTickerBySymbol === 'function')
            addTickerBySymbol(ticker);
        if (typeof switchTicker === 'function')
            switchTicker(ticker);
    },
    'scr-run-magic-formula': function () {
        if (typeof runMagicFormula === 'function')
            runMagicFormula();
    },
    'scr-sort-screener': function (e) {
        var el = e.target.closest('[data-action]');
        if (!el)
            return;
        if (typeof _sortScreener === 'function')
            _sortScreener(parseInt(el.dataset.colIdx, 10));
    },
    // OWNER 2026-09-26 ("Fix + give it bulk export"; BOARD review
    // docs/board/audit/2026-09-26_BOARD_pricing_pitch_by_plan.md). This used to
    // window.open('/api/data/bulk?...&format=csv') -- a route that never read
    // `format`, so an Investor got a tab of JSON and anyone below Investor got a
    // tab of raw 402 JSON. Now: gate FIRST (the premium-gate overlay, no
    // request), then fetch the real CSV (/api/data/bulk.csv) and save it; a 402
    // that still arrives (tier not loaded yet, registry miss) opens the same
    // overlay. Nothing is ever navigated to, so no tab can show an error body.
    'scr-export-fundamentals-csv': function () {
        if (typeof _scrLastResults === 'undefined' || !_scrLastResults || !_scrLastResults.length) {
            if (typeof showToast === 'function')
                showToast('Run a screen first, then export its results.', 'info', 4000);
            return;
        }
        var tickers = _scrLastResults.map(function (r) { return r && r.ticker; })
            .filter(function (t) { return !!t; }).slice(0, _SCR_BULK_CSV_MAX);
        var url = '/api/data/bulk.csv?tickers=' + encodeURIComponent(tickers.join(',')) + '&fields=fundamentals,metrics';
        if (typeof TierGate !== 'undefined' && TierGate && typeof TierGate.canCall === 'function' && !TierGate.canCall(url)) {
            _scrOpenBulkExportGate();
            return;
        }
        if (typeof showToast === 'function')
            showToast('Preparing the fundamentals file...', 'info', 2500);
        fetch(url, { credentials: 'include', signal: _scrBulkExportSignal(60000) })
            .then(function (r) {
            if (r.status === 401) {
                _scrOpenBulkExportSignIn();
                return null;
            }
            if (r.status === 402) {
                // The tier-gate interceptor raises the overlay itself on its own
                // synthetic 402; a real server 402 is ours to show.
                if (!r._tierGateIntercept)
                    _scrOpenBulkExportGate();
                return null;
            }
            if (r.status === 429) {
                if (typeof showToast === 'function')
                    showToast('The bulk export allows 10 files an hour. Please try again later.', 'warning', 6000);
                return null;
            }
            if (r.status === 400 || r.status === 403 || r.status === 503) {
                // The server's own sentence (it never echoes what was sent).
                return r.json().then(function (b) {
                    if (typeof showToast === 'function')
                        showToast((b && b.error) || 'Could not build the fundamentals file.', 'warning', 7000);
                    return null;
                }, function () { throw new Error('HTTP ' + r.status); });
            }
            if (!r.ok)
                throw new Error('HTTP ' + r.status);
            var withheld = parseInt(r.headers.get('X-Rows-Withheld') || '0', 10) || 0;
            var fnMatch = /filename="([^"]+)"/.exec(r.headers.get('Content-Disposition') || '');
            var filename = fnMatch ? fnMatch[1] : 'oxford_ledge_fundamentals.csv';
            return r.blob().then(function (blob) { return { blob: blob, withheld: withheld, filename: filename }; });
        })
            .then(function (res) {
            if (!res)
                return;
            var a = document.createElement('a');
            a.href = URL.createObjectURL(res.blob);
            a.download = res.filename;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            setTimeout(function () { URL.revokeObjectURL(a.href); }, 1000);
            if (typeof showToast === 'function') {
                showToast(res.withheld
                    ? 'Exported ' + tickers.length + ' companies. ' + res.withheld + ' have no figures from SEC filings on file; the file lists why.'
                    : 'Exported ' + tickers.length + ' companies.', 'success', 5000);
            }
            if (typeof trackUniqueAchievement === 'function')
                trackUniqueAchievement('exports_total', 'bulk_fundamentals_' + new Date().toDateString());
        })
            .catch(function () {
            if (typeof showToast === 'function')
                showToast('Could not build the fundamentals file. Please try again.', 'error', 5000);
        });
    },
    'scr-pin-results': function () {
        if (typeof _pinScreenerResults === 'function')
            _pinScreenerResults();
    },
    'scr-clear-pinned': function () {
        if (typeof _clearPinnedScreener === 'function')
            _clearPinnedScreener();
    },
    'scr-remove-pinned': function (e) {
        var el = e.target.closest('[data-action]');
        if (!el)
            return;
        if (typeof _removePinnedSet === 'function')
            _removePinnedSet(parseInt(el.dataset.pinIdx, 10));
    },
    'scr-toast-dismiss': function (e) {
        var btn = e.target.closest('[data-action="scr-toast-dismiss"]');
        if (!btn)
            return;
        var toast = btn.parentElement;
        if (!toast)
            return;
        toast.style.animation = 'toastOut 0.3s ease forwards';
        if (toast._toastTimer)
            clearTimeout(toast._toastTimer);
        setTimeout(function () { if (toast.parentElement)
            toast.parentElement.removeChild(toast); }, 300);
    },
    'scr-practice-guess': function (e) {
        var el = e.target.closest('[data-action]');
        if (!el)
            return;
        if (typeof _practiceHandleGuess === 'function')
            _practiceHandleGuess(el.dataset.sector);
    },
    'scr-fetch-options': function (e) {
        var el = e.target.closest('[data-action]');
        if (!el)
            return;
        if (typeof fetchOptions === 'function')
            fetchOptions(el.dataset.ticker, el.dataset.expiry);
    },
    'scr-add-spread-leg': function (e) {
        var el = e.target.closest('[data-action="scr-add-spread-leg"]');
        if (!el)
            return;
        if (typeof addSpreadLeg === 'function')
            addSpreadLeg(el.dataset.optType, parseFloat(el.dataset.strike), parseFloat(el.dataset.premium) || 0, 1);
    },
    // scr-update-payoff-leg fires on change events from payoff leg inputs/selects.
    // Uses data-action-change attribute; dispatcher wires change events the same way.
    'scr-update-payoff-leg': function (e) {
        var el = e.target.closest('[data-action-change="scr-update-payoff-leg"]');
        if (!el)
            return;
        if (typeof updatePayoffLeg === 'function')
            updatePayoffLeg(parseInt(el.dataset.legIdx, 10), el.dataset.legField, el.value);
    },
    'scr-remove-payoff-leg': function (e) {
        var el = e.target.closest('[data-action]');
        if (!el)
            return;
        if (typeof removePayoffLeg === 'function')
            removePayoffLeg(parseInt(el.dataset.legIdx, 10));
    },
};
// SPA nav delegation for topbar / dropdown <a data-view> links.
// Buttons with data-action="set-view*" already work without reload;
// the legacy <a href> items did a full page reload, dropping
// DataCache + active ticker. Intercept those before they hit the
// browser's link handler. Honor middle-click + modifier-click +
// shift-click so users can still open in a new tab.
document.addEventListener('click', function (e) {
    if (e.defaultPrevented)
        return;
    if (e.button !== 0)
        return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey)
        return;
    var a = e.target.closest('a[data-view]');
    if (!a)
        return;
    if (a.target && a.target !== '_self')
        return;
    var v = a.dataset.view;
    if (!v || typeof setView !== 'function')
        return;
    e.preventDefault();
    // S55 (2026-04-28): topbar <a> elements carry BOTH data-view AND
    // data-action="set-view". Without stopImmediatePropagation the
    // central [data-action] dispatcher (registered later, also at
    // document level) fires on the same click and calls setView(v) a
    // SECOND time. The double-invocation re-runs abortViewFetches()
    // which kills the fetches the first call just started — the
    // macro-view 8s watchdog then trips and silently redirects to
    // News. Same pattern technically afflicts every <a data-view>
    // link in the topbar; it only surfaced as a user-visible bug on
    // Markets because Markets is the only view with a watchdog.
    e.stopImmediatePropagation();
    try {
        setView(v);
    }
    catch (_e) {
        window.location.href = a.href;
    }
    // Mirror the button-side close behavior for items inside dropdowns.
    // SF-23 vestige removed 2026-05-17: #more-dropdown-menu branch (markup deleted 2026-05-07).
    // #mobile-nav-overlay branch removed 2026-07-06 (#47 wave A2): the overlay
    // markup was deleted from dashboard.html 2026-05-07, so a.closest() could
    // never match.
}, true);
// Central click delegation handler
document.addEventListener('click', function (e) {
    var actionEl = e.target.closest('[data-action]');
    if (!actionEl)
        return;
    var action = actionEl.dataset.action;
    // Check comprehensive _delegatedActions first, then legacy _actionHandlers
    if (action && Object.prototype.hasOwnProperty.call(_delegatedActions, action)) {
        _delegatedActions[action](e);
    }
    else if (action && _actionHandlers[action]) {
        _actionHandlers[action](e, actionEl);
    }
    else if (action) {
        // Don't warn-or-toast for actions handled by module-internal delegation
        // (watchlist wl-*, news news-*, context ctx-*, etf etf-*, …). Those are
        // handled by the el-scoped listener where they're rendered; the central
        // dispatcher only ever sees the bubbled event, so warning here is noise.
        // 2026-06-03 (#101 OWNER prod-QA): the warn was OUTSIDE this guard, so the
        // research-quick-start banner's own listener (news.ts:1938) handled the
        // dismiss correctly yet the bubbled event still logged "No handler for:
        // dismiss-research-qs" on every view (preserve-log carried it across nav).
        // Moving the warn inside !_isInternal + listing the banner's exact actions
        // silences it without changing the working dismiss behavior.
        var _internalPrefixes = ['wl-', 'news-', 'ctx-', 'etf-', 'filter-', 'quiz-', 'drawer-', 'lp-', 'ob-', 'se-', 'dismiss-'];
        var _internalExact = ['dismiss-research-qs', 'open-research-qs-primary', 'open-research-qs-secondary', 'issue-trial-key', 'copy-new-trial-key', 'copy-new-api-key', 'revoke-api-key', 'save-api-key', 'test-api-key']; // last six: api-keys panel scoped actions (2026-08-10, same #101 class)
        var _isInternal = _internalPrefixes.some(function (p) { return action.indexOf(p) === 0; })
            || _internalExact.indexOf(action) >= 0;
        if (!_isInternal) {
            // Unhandled action — module may not be loaded yet. Log + nudge.
            if (typeof console !== 'undefined')
                console.warn('[action] No handler for:', action);
            if (typeof showToast === 'function')
                showToast('Loading feature...', 'info', 2000);
        }
    }
});
// Enter-key delegation for inputs with data-action-enter
document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter')
        return;
    var el = e.target.closest('[data-action-enter]');
    if (!el)
        return;
    var action = el.dataset.actionEnter;
    if (action && Object.prototype.hasOwnProperty.call(_delegatedActions, action)) {
        e.preventDefault();
        _delegatedActions[action](e);
    }
});
// Input + change event delegation. Replaces inline oninput=/onchange= handlers
// blocked by strict CSP. Mirrors the click + keydown patterns above.
document.addEventListener('input', function (e) {
    var el = e.target.closest('[data-action-input]');
    if (!el)
        return;
    var action = el.dataset.actionInput;
    if (action && Object.prototype.hasOwnProperty.call(_delegatedActions, action))
        _delegatedActions[action](e);
});
document.addEventListener('change', function (e) {
    var el = e.target.closest('[data-action-change]');
    if (!el)
        return;
    var action = el.dataset.actionChange;
    if (action && Object.prototype.hasOwnProperty.call(_delegatedActions, action))
        _delegatedActions[action](e);
});
// Central mousedown delegation (needed for dropdown suggests — mousedown fires before blur)
document.addEventListener('mousedown', function (e) {
    var actionEl = e.target.closest('[data-action]');
    if (!actionEl)
        return;
    var action = actionEl.dataset.action;
    if (action === 'select-suggest' && _delegatedActions[action]) {
        _delegatedActions[action](e);
    }
});
// Debounced issuer search on input (fires search after 400ms pause)
var _issuerSearchTimer = null;
document.addEventListener('input', function (e) {
    if (e.target.id !== 'credit-issuer-search')
        return;
    clearTimeout(_issuerSearchTimer);
    var val = e.target.value.trim();
    if (val.length < 2) {
        var el = document.getElementById('credit-issuer-results');
        if (el)
            el.innerHTML = '';
        return;
    }
    _issuerSearchTimer = setTimeout(function () {
        if (_delegatedActions['credit-issuer-search-go'])
            _delegatedActions['credit-issuer-search-go']();
    }, 400);
});
// Enter key handlers for BDC and credit search inputs
document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter')
        return;
    var id = e.target.id;
    if (id === 'bdc-borrower-input') {
        e.preventDefault();
        if (_delegatedActions['bdc-search-borrower'])
            _delegatedActions['bdc-search-borrower']();
    }
    else if (id === 'bdc-ticker-input') {
        e.preventDefault();
        if (_delegatedActions['bdc-search-bdc'])
            _delegatedActions['bdc-search-bdc']();
    }
    else if (id === 'credit-issuer-search') {
        e.preventDefault();
        if (_delegatedActions['credit-issuer-search-go'])
            _delegatedActions['credit-issuer-search-go']();
    }
    else if (id === 'credit-cusip-input') {
        e.preventDefault();
        if (_delegatedActions['credit-lookup-and-add'])
            _delegatedActions['credit-lookup-and-add']();
    }
    // Wave-7 QA (2026-07-17): the watchlist add input only worked via the
    // "+ Add" button — Enter did nothing (observed live). Route it through
    // the same delegated action the button dispatches.
    else if (id === 'wl-add-input') {
        e.preventDefault();
        if (_delegatedActions['wl-add-ticker'])
            _delegatedActions['wl-add-ticker']();
    }
});
// Learn path card click handler — expand to show modules inline
document.addEventListener('click', function (e) {
    var card = e.target.closest('[data-path-id]');
    if (!card)
        return;
    var pathId = card.getAttribute('data-path-id');
    if (!pathId || !_learnPathsCache)
        return;
    // Find the path in cache
    var path = null;
    for (var i = 0; i < _learnPathsCache.length; i++) {
        if (_learnPathsCache[i].id === pathId) {
            path = _learnPathsCache[i];
            break;
        }
    }
    if (!path)
        return;
    // Toggle: if already expanded, collapse
    var existing = card.querySelector('.learn-modules-inline');
    if (existing) {
        existing.remove();
        return;
    }
    // Remove other expansions
    var all = document.querySelectorAll('.learn-modules-inline');
    for (var r = 0; r < all.length; r++)
        all[r].remove();
    var modules = path.modules || path.lessons || [];
    if (!modules.length)
        return;
    var html = '<div class="learn-modules-inline learn-expand">';
    for (var m = 0; m < modules.length; m++) {
        var mod = modules[m];
        var mTitle = mod.title || mod.name || 'Module ' + (m + 1);
        var mDesc = mod.description || mod.summary || '';
        html += '<div class="learn-expand__item">'
            + '<span class="learn-expand__idx">' + (m + 1) + '.</span>'
            + '<div><div class="learn-expand__title">' + escHtml(mTitle) + '</div>'
            + (mDesc ? '<div class="learn-expand__desc">' + escHtml(mDesc.substring(0, 100)) + (mDesc.length > 100 ? '...' : '') + '</div>' : '')
            + '</div></div>';
    }
    html += '</div>';
    card.insertAdjacentHTML('beforeend', html);
});
// Central input delegation for calculator inputs
document.addEventListener('input', function (e) {
    var actionEl = e.target.closest('[data-input-action]');
    if (!actionEl)
        return;
    var action = actionEl.dataset.inputAction;
    var ticker = actionEl.dataset.ticker || '';
    if (action === 'calc-implied-growth') {
        if (typeof _calcImpliedGrowth === 'function')
            _calcImpliedGrowth(ticker);
    }
    else if (action === 'calc-intrinsic-dcf') {
        _calcIntrinsicDCF(ticker);
    }
    else if (action === 'calc-intrinsic-epv') {
        _calcIntrinsicEPV(ticker);
    }
    else if (action === 'calc-intrinsic-graham') {
        _calcIntrinsicGraham(ticker);
    }
    else if (action === 'calc-implied-growth-2') {
        _calcImpliedGrowth2(ticker);
    }
    else if (action === 'save-ticker-note') {
        _debounceSaveTickerNote(ticker);
    }
    else if (action === 'save-ticker-note-blur') {
        _saveTickerNote(ticker);
    }
    else if (action === 'lore-search') {
        if (typeof _loreSearch === 'function')
            _loreSearch(e.target.value);
    }
    else if (action === 'slider-update-label') {
        var labelEl = document.getElementById(actionEl.dataset.labelId);
        if (labelEl)
            labelEl.textContent = actionEl.value + (actionEl.dataset.suffix || '%');
        // Also trigger the associated calc
        var calcAction = actionEl.dataset.calcAction;
        if (calcAction === 'calc-intrinsic-dcf')
            _calcIntrinsicDCF(ticker);
        else if (calcAction === 'calc-implied-growth-2')
            _calcImpliedGrowth2(ticker);
    }
});
// Central blur delegation for scratchpad. Capture-phase on document, so it
// also sees the WINDOW's own blur (alt-tab), whose target has no .closest
// (Sentry OXFORD-LEDGE-BROWSER-1D, 13 events / 2 users, 2026-10-04).
document.addEventListener('blur', function (e) {
    var t = e.target;
    var actionEl = t && typeof t.closest === 'function' ? t.closest('[data-blur-action]') : null;
    if (!actionEl)
        return;
    if (actionEl.dataset.blurAction === 'save-ticker-note') {
        _saveTickerNote(actionEl.dataset.ticker || '');
    }
}, true);
// Central change delegation handler for select elements
document.addEventListener('change', function (e) {
    var actionEl = e.target.closest('[data-change-action]');
    if (!actionEl)
        return;
    var action = actionEl.dataset.changeAction;
    if (action === 'ind-compare-change')
        onIndCompareChange();
    else if (action === 'askai-provider-change')
        _askAiOnProviderChange();
    else if (action === 'toggle-email-pref')
        _toggleEmailPref(actionEl.dataset.prefKey, actionEl.checked);
});
// §MOBILE — extracted to static/js/mobile-helpers.js
// ── /?panel=api-keys deep link (SF-MCP-CONNECT-HOWTO T5, OWNER 2026-09-13) ──
// The OWNER could not find where to create an Oxford Ledge key: the only
// entry was the bottom-bar key icon (dashboard.html `toggle-api-keys-panel`),
// and /?view=settings never opened the panel. The how-to's step 1 now links
// `/?panel=api-keys`. app-init.ts captures the param inside init() (setView's
// pushState drops every param but `view`), strips it with replaceState so a
// reload cannot re-open the panel, then calls this. It lives HERE, not in
// app-init.ts, because init() is invoked from this file's tail -- so it is
// defined before the hook can fire -- and app-init.ts sits at its line budget.
//
// Order of decisions, each one the auth-resolve point the caller waits on:
//   1. `_authUser` set -> /api/auth/me resolved a session -> open the panel
//      through the delegated action (same cross-chunk, typeof-guarded read
//      settings-panel.ts:openApiKeys uses).
//   2. no `ol_csrf_hmac` cookie -> provably no session (auth-state.ts
//      signal 3) -> the normal sign-in modal, NEVER the panel.
//   3. cookie present, /api/auth/me still in flight -> wait, bounded (~10s).
function _openApiKeysPanelOnceAuthed(tries) {
    var n = tries || 0;
    var authed = (typeof _authUser !== 'undefined' && !!_authUser);
    var anon = false;
    try {
        anon = document.cookie.indexOf('ol_csrf_hmac=') === -1;
    }
    catch (_e) {
        anon = true;
    }
    if (!authed && !anon) {
        if (n < 40)
            setTimeout(function () { _openApiKeysPanelOnceAuthed(n + 1); }, 250);
        return;
    }
    if (!authed) {
        if (typeof authOpenModal === 'function')
            authOpenModal('signin');
        return;
    }
    var acts = (typeof _delegatedActions !== 'undefined') ? _delegatedActions : null;
    var fn = acts && acts['toggle-api-keys-panel'];
    if (typeof fn === 'function')
        fn();
}
// ── INIT BOOTSTRAP (moved from tooltip-tour.js S37 — must be in app chunk) ──
init().then(function () {
    // S27: Load core chunk after init (news, portfolio, watchlist).
    // Modules are lazy-init so no MutationObservers/timers start on parse.
    // S43: Removed standalone _loadModule calls for achievements, modals,
    // daily-goals — all three are in JS_CHUNKS (education, core-views) and
    // loading them standalone causes const redeclaration SyntaxErrors when
    // the chunk subsequently loads the same file.
    //
    // F-20 Phase 4 P0 fix (2026-05-28): removed the unconditional 8s-delay
    // `_loadChunk('education')` block that previously fired here. It existed
    // to populate `#daily-goal-widget` in the statusbar, but that surface was
    // RETIRED by mini-CYCLE #3 (see dashboard.html line ~1249-1252: "Replaces
    // the daily-goal-widget (streak section). Less intrusive position…").
    // Zero `id="daily-goal-widget"` mount points exist in any tracked
    // template/SSR/dashboard surface — `getElementById(...)` always returned
    // null, so the chunk was fetched (386 KiB raw wire) purely to no-op.
    // Lighthouse measurement 2026-05-28 confirmed `/?view=news` cold-anon
    // load-shed 161.7 KiB unused from this leak (42% of the wire). LEARN
    // surfaces still get `bundle-education` via the legitimate
    // `_loadChunk('education')` paths: view-router's `setView('learn')` /
    // setView('milestones') / practicum view (`_pracEl`) and the practice-
    // mode action handlers (`prac-review` / `prac-complete` in this file).
    // Contract test: tests/test_bundle_education_no_leak_contract.py.
    // S28: Load view-specific enhanced modules for current view (staggered)
    setTimeout(function () { _loadViewModules(currentView); }, 5000);
    // S27: Connect SSE stream for server-pushed data.
    // macro-perf (2026-07-07): the EventSource open to /api/stream was on the
    // load-time critical path (~438ms, Lighthouse on /?view=macro). Initial
    // indicators + headlines come from their own REST fetches (/api/indicators,
    // /api/headlines w/ archive fallback); the SSE only PUSHES live updates, and
    // #market-headlines exists only on the News view. So opening it post-idle
    // (past the LCP/TTI window) is imperceptible — same rIC-with-timeout-fallback
    // pattern as the LH-2 pulse-facts defer above.
    if (typeof _connectSSE === 'function') {
        if (typeof window.requestIdleCallback === 'function') {
            window.requestIdleCallback(function () { _connectSSE(); }, { timeout: 3000 });
        }
        else {
            setTimeout(function () { _connectSSE(); }, 1500);
        }
    }
    // Progressive access: signup bar for unauthenticated users
    // Gated: only show after 3+ tickers viewed OR 60+ seconds of usage
    if ((typeof _authUser === 'undefined' || !_authUser) && !OLStorage.getString('ol_welcomed', null)) {
        var _signupBarTickerCount = 0;
        var _signupBarStartTime = Date.now();
        var _signupBarShown = false;
        function _maybeShowSignupBar() {
            if (_signupBarShown)
                return;
            // #B (2026-06-03 OWNER prod-QA): re-check auth at SHOW time. The outer
            // gate evaluated _authUser ONCE at init, but auth resolves async — an
            // authed user whose /api/auth/me landed AFTER init would otherwise get
            // the anon "Create a free account" bar 60s later (reads as "your login
            // didn't take" — corrosive for a logged-in user). olIsAnonymous()
            // (ol_csrf_hmac-based, auth-state.ts) is the reliable synchronous signal;
            // ol_session is HttpOnly so _authUser alone races
            // (feedback_httponly_session_cookie_use_csrf_hmac).
            var _w = window;
            var _anon = (typeof _w.olIsAnonymous === 'function')
                ? _w.olIsAnonymous()
                : ((typeof _authUser === 'undefined' || !_authUser) && document.cookie.indexOf('ol_csrf_hmac=') === -1);
            if (!_anon) {
                _signupBarShown = true;
                return;
            } // authed — never show it
            var elapsed = (Date.now() - _signupBarStartTime) / 1000;
            if (_signupBarTickerCount < 3 && elapsed < 60)
                return;
            _signupBarShown = true;
            var bar = document.createElement('div');
            bar.id = 'welcome-bar';
            bar.className = 'csp-upgrade-bar';
            bar.innerHTML = '<span>Create a free account to save your progress, track portfolios, and open up every tool.</span>'
                + '<button data-action="welcome-signup" class="btn-primary">Create a free account</button>'
                + '<button data-action="welcome-dismiss" class="btn-ghost">Not now</button>';
            document.body.appendChild(bar);
            try {
                OLStorage.setString('ol_welcomed', '1');
            }
            catch (e) { }
        }
        // Track ticker views via custom event (fired by switchTicker/loadTicker)
        document.addEventListener('ol:ticker-viewed', function () {
            _signupBarTickerCount++;
            _maybeShowSignupBar();
        });
        // Check time-based gate every 15 seconds
        var _signupBarTimer = setInterval(function () {
            _maybeShowSignupBar();
            if (_signupBarShown)
                clearInterval(_signupBarTimer);
        }, 15000);
    }
}).catch(function (e) {
    console.error('Init failed:', e);
    // Dismiss any stuck overlays so user isn't trapped
    document.querySelectorAll('.open').forEach(function (el) { el.classList.remove('open'); });
    var bridge = document.getElementById('wt-loading-bridge');
    if (bridge && bridge.parentNode)
        bridge.parentNode.removeChild(bridge);
    // 2026-04-11: Init error toast suppressed for end users — it was leaking
    // technical errors like "Cannot set properties of null (setting 'textContent')"
    // from the splash null-deref to first-time visitors, looking broken even
    // though the page is functional. Keep server-side logging via /api/metrics
    // so we still get telemetry, but no visible toast. Visible only in a
    // DEBUG_BUILD (F15 Phase 4: the legacy _OL_DEBUG global is retired —
    // dev builds via OL_DEBUG_BUILD=1 get the toast).
    var errDetail = e ? (e.message || String(e)) : 'unknown';
    if (typeof DEBUG_BUILD !== 'undefined' && DEBUG_BUILD && typeof showToast === 'function') {
        showToast('Init error: ' + errDetail, 'error', 30000);
    }
    // Always POST to server for logging — no UI surface, but we want telemetry
    try {
        fetch('/api/metrics', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ event: 'init_error', error: errDetail, stack: e && e.stack ? e.stack.substring(0, 500) : '' }) });
    }
    catch (_) { }
    // Still connect SSE even if init failed — indicators/headlines can still push data
    if (typeof _connectSSE === 'function')
        _connectSSE();
});
// Old tour disabled — walkthrough.js handles onboarding
// setTimeout(startTour, 2000);
// Ensure glossary is initialized (fallback if DOMContentLoaded already fired).
// 2026-04-05: Deferred to setTimeout(0) because app.js is now the first entry
// in bundle.min.js. _glossTip is declared with `let` in glossary.js (later in
// the bundle), so referencing it synchronously here hits the Temporal Dead Zone
// and throws an uncaught ReferenceError that kills the entire bundle.
setTimeout(function () {
    try {
        if (typeof _glossTip !== 'undefined' && !_glossTip && typeof _initGlossary === 'function')
            _initGlossary();
    }
    catch (e) { }
}, 0);
// 2026-05-08 (E2E welcome-overlay re-relocation): the welcome bootstrap
// IIFE was relocated FROM here TO the bottom of welcome-flow.ts. The
// IIFE landed in this tail-chunk file when NH9 step 1 (commit
// 233a843e) sliced app.ts; bundle-app-tail.min.js loads with
// `<script defer fetchpriority="low">` which the browser can
// deprioritize indefinitely under CI load, so test_welcome_screen_
// appears was racing the tail-chunk load (30s timeout). Moving the
// IIFE to welcome-flow.ts (last file in JS_CHUNKS["app-init"]) puts
// it on the critical path — bundle-app-init.min.js has both a
// `<link rel="preload">` hint AND `<script defer>` without low-
// priority modifier. See welcome-flow.ts:381+ for the relocated code.
//# sourceMappingURL=app-renderers.js.map
;
// ═══ screener-presets.js ═══
;"use strict";
// @ts-nocheck
// ^ MUST be line 1 or it is silently ineffective. INHERITED from
// app-renderers.ts, not chosen: this code was written and has always
// run under nocheck; turning checking on is a separate change.
// ──────────────────────────────────────────────────────────────────────────
// screener-presets.ts — the screener preset chips + custom-preset store.
//
// #202/ADMIN-9 (2026-08-16): cut out of app-renderers.ts, which sat at
// EXACTLY its 5,779-line size budget. 5,780 -> 5,175. This is the whole
// SCREENER PRESETS block (CYCLE5 #3) verbatim — built-in preset chips,
// URL preset deep-links, the insider facet params, and the localStorage-backed
// custom-preset save/apply/delete family. One cohesive seam: everything
// here renders or applies a screener PRESET; the screener itself (filters,
// results table) lives elsewhere.
//
// ── LOAD-ORDER INVARIANT ──
// ZERO module-scope executed statements: literal-initialised `var`s (scalars,
// array and object literals) and function declarations.
// Nothing runs or is read at parse time. Every caller — the delegated
// actions in app-renderers.ts (typeof-guarded), view-router.ts, and the
// app-init callers this block was built for — invokes at runtime.
// Adjacency is therefore NOT load-bearing (the chrome-indicators.ts
// argument, #125); what IS required is membership in the SAME 'app-tail'
// chunk in tools/build_bundle.py. This feature's own origin incident is a
// silently-empty chip bar behind typeof guards (fab21fd5/4ad2655a) — if
// this file drops out of the chunk, that exact defect returns with no
// console error. tests/test_screener_presets_s51.py pins the membership.
// ──────────────────────────────────────────────────────────────────────────
// ═══ SCREENER PRESETS (CYCLE5 #3 — fix for fab21fd5 / 4ad2655a incomplete ship) ═══
// The fab21fd5 feature commit wired up HTML + CSS + JSON + dispatcher but never
// defined the three functions that actually render chips and apply presets.
// The 4ad2655a "hotfix" claimed to add them but the diff only patched
// _makePremiumHint (the CSP fix). Callers at app.js:4339 and
// bundle-app.js:6292 are both guarded with `typeof === 'function'`, so the
// chip bar silently rendered empty with no console error. This block supplies
// the missing implementations. All styling via pre-existing .scr-preset-*
// utility classes — no inline style="" (CSP-safe).
var _screenerPresetsCache = null;
var _screenerPresetsFetching = null;
// Metric 3: active preset id — set when a preset is applied, cleared on
// _clearScreenerPreset. Read by _saveCustomPreset to tag the "saved-from"
// preset so we can measure what fraction of preset sessions convert to
// a saved custom preset.
var _activePresetId = '';
// The active built-in preset's insiderOverlay, or null (see INSIDER FACET below).
var _scrInsiderFilter = null;
// Preset-key <-> DOM-id map for every screener filter control. The keys are
// the screener-presets.json / saved-custom-preset namespace (market cap in $M
// as mktcap_*_m); the wire params live on the controls as data-scr-param.
// tests/test_screener_filter_param_map_contract.py pins this list to the
// template's controls and to every key the presets JSON uses.
var _SCR_FILTER_IDS = [
    { id: 'scr-pe-min', key: 'pe_min' },
    { id: 'scr-pe-max', key: 'pe_max' },
    { id: 'scr-ev-min', key: 'evEbitda_min' },
    { id: 'scr-ev-max', key: 'evEbitda_max' },
    { id: 'scr-mc-min', key: 'mktcap_min_m' },
    { id: 'scr-mc-max', key: 'mktcap_max_m' },
    { id: 'scr-ebitev-min', key: 'ebitev_min' },
    { id: 'scr-ebitev-max', key: 'ebitev_max' },
    { id: 'scr-sector', key: 'sector' },
    { id: 'scr-divyield-min', key: 'div_yield_min' },
    { id: 'scr-pb-max', key: 'pb_max' },
    { id: 'scr-roe-min', key: 'roe_min' },
    { id: 'scr-de-max', key: 'debt_equity_max' },
    { id: 'scr-near-low', key: 'near_52w_low' },
    { id: 'scr-ipo-after', key: 'ipo_after' },
    { id: 'scr-confluence', key: 'confluence' }
];
// QA 2026-10-13 P1 (R3): the filters that read a vendor price or a figure
// computed from one, in this file's preset-key namespace. The server refuses
// them for a viewer who may not see vendor prices
// (services/public_price_gate.SCREENER_PRICE_FILTER_KEYS, wire names; the two
// market-cap keys are mktcap_min/mktcap_max there). For that viewer the inputs
// are disabled with the reason and a sign-in link, and a preset that relies on
// them says so instead of quietly screening a different universe.
var _SCR_PRICE_FILTER_KEYS = [
    'pe_min', 'pe_max', 'evEbitda_min', 'evEbitda_max', 'mktcap_min_m', 'mktcap_max_m',
    'ebitev_min', 'ebitev_max', 'div_yield_min', 'pb_max', 'near_52w_low'
];
// The reason, agreeing with its subject: "needs" for one filter, "need" for a
// list (QA 2026-10-17: the banner read "...near-52-week-low filters needs").
function _scrPriceFilterReason(count) {
    return (count === 1 ? 'needs' : 'need') + ' market prices, shown to signed-in users';
}
var _scrPriceFiltersLocked = false;
var _SCR_PRESET_KEY_LABELS = {
    pe_min: 'P/E min', pe_max: 'P/E max', evEbitda_min: 'EV/EBITDA min', evEbitda_max: 'EV/EBITDA max',
    mktcap_min_m: 'market cap min', mktcap_max_m: 'market cap max', ebitev_min: 'EBIT/EV min',
    ebitev_max: 'EBIT/EV max', div_yield_min: 'dividend yield min', pb_max: 'P/B max',
    near_52w_low: 'near 52-week low'
};
// Before the first response: a meta tag carries the public switch
// (OL_PUBLIC_VENDOR_PRICES, ssr_assets.dashboard_flag_meta_tags) and the
// ol_csrf_hmac cookie marks a session. Every /api/screener response then
// re-syncs from the server's `price_filters_available`, which is authoritative.
function _scrViewerSeesPrices() {
    try {
        if (document.querySelector('meta[name="ol-public-vendor-prices"]'))
            return true;
        var u = window._olCurrentUser;
        if (u && u.email)
            return true;
        return document.cookie.indexOf('ol_csrf_hmac=') !== -1;
    }
    catch (e) {
        return true;
    }
}
// Split a preset's filters into those this viewer can apply and the labels of
// those it cannot. Pure; the node contract runs it.
function _scrSplitPresetFilters(filters, locked) {
    var apply = {}, skipped = [];
    for (var k in filters) {
        if (!Object.prototype.hasOwnProperty.call(filters, k))
            continue;
        if (locked && _SCR_PRICE_FILTER_KEYS.indexOf(k) !== -1)
            skipped.push(_SCR_PRESET_KEY_LABELS[k] || k);
        else
            apply[k] = filters[k];
    }
    return { apply: apply, skipped: skipped };
}
// The caption line for a preset whose price filters were not applied.
function _scrPresetLockNoteHtml(skipped, ran) {
    if (!skipped || !skipped.length)
        return '';
    return '<div class="scr-preset-caption__unsupported">Not applied: '
        + skipped.join(', ').replace(/</g, '&lt;') + ' — ' + _scrPriceFilterReason(skipped.length) + '. '
        + (ran ? 'These results are a wider screen than the preset describes. '
            : 'This preset has no filter that works without them, so it was not run. ')
        + '<a href="#" data-action="auth-toggle">Sign in</a></div>';
}
function _scrSyncPriceFilterLock(available) {
    _scrPriceFiltersLocked = !available;
    for (var i = 0; i < _SCR_FILTER_IDS.length; i++) {
        if (_SCR_PRICE_FILTER_KEYS.indexOf(_SCR_FILTER_IDS[i].key) === -1)
            continue;
        var el = document.getElementById(_SCR_FILTER_IDS[i].id);
        if (!el)
            continue;
        el.disabled = !available;
        if (available) {
            el.removeAttribute('title');
        }
        else {
            el.value = '';
            el.setAttribute('title', 'This filter ' + _scrPriceFilterReason(1) + '.');
        }
    }
    var hint = document.getElementById('scr-filter-hint');
    if (!hint)
        return;
    hint.textContent = '';
    if (available)
        return;
    var note = document.createElement('div');
    note.className = 'scr-coverage-banner';
    note.setAttribute('role', 'note');
    note.setAttribute('data-scr-price-lock', '1');
    note.appendChild(document.createTextNode('P/E, EV/EBITDA, market cap, EBIT/EV, dividend yield, P/B and near-52-week-low filters '
        + _scrPriceFilterReason(_SCR_PRICE_FILTER_KEYS.length) + '. '));
    var a = document.createElement('a');
    a.href = '#';
    a.setAttribute('data-action', 'auth-toggle');
    a.textContent = 'Sign in';
    note.appendChild(a);
    hint.appendChild(note);
}
function _initScreenerPresets() {
    var chipsHost = document.getElementById('scr-presets-chips');
    if (!chipsHost)
        return; // screener view not rendered yet
    _scrSyncPriceFilterLock(_scrViewerSeesPrices());
    // CLS 2026-08-04: the template now ships inert placeholder chips so the
    // bar reserves its real height on cold load. They are NOT hydration -- a
    // bare children-count guard would see them and return, leaving the
    // placeholders permanently in place with no click handlers
    // (feedback_paste_time_silent_noop). Count only real chips.
    if (chipsHost.querySelector('[data-preset-id]'))
        return; // already hydrated — idempotent
    if (_screenerPresetsCache) {
        _renderScreenerPresetChips(_screenerPresetsCache);
        return;
    }
    if (_screenerPresetsFetching)
        return; // fetch in-flight
    // QA 2026-10-17: 'default', not 'force-cache'. This URL is unversioned and the
    // file is edited in place; force-cache returns a stored copy at ANY age
    // (max-age ignored), so browsers that loaded it before b2b0443b kept the old
    // quality-compounders preset. tests/test_static_data_fetch_cache_contract.py
    _screenerPresetsFetching = fetch('/static/data/screener-presets.json', { cache: 'default' })
        .then(function (r) { return r.ok ? r.json() : Promise.reject('HTTP ' + r.status); })
        .then(function (data) {
        _screenerPresetsCache = (data && Array.isArray(data.presets)) ? data.presets : [];
        _renderScreenerPresetChips(_screenerPresetsCache);
    })
        .catch(function () {
        // Silent fail — hide the "PRESETS:" label so it doesn't look broken.
        var bar = document.getElementById('scr-presets-bar');
        if (bar)
            bar.classList.add('d-none');
    })
        .then(function () { _screenerPresetsFetching = null; });
}
function _renderScreenerPresetChips(presets) {
    var chipsHost = document.getElementById('scr-presets-chips');
    if (!chipsHost)
        return;
    if (!presets || !presets.length) {
        // No presets to paint. Drop the placeholders rather than leaving 22
        // dead chips standing, and hide the bar the same way the fetch-failure
        // path does.
        chipsHost.innerHTML = '';
        var emptyBar = document.getElementById('scr-presets-bar');
        if (emptyBar)
            emptyBar.classList.add('d-none');
        return;
    }
    var html = '';
    for (var i = 0; i < presets.length; i++) {
        var p = presets[i];
        if (!p || !p.id || !p.name)
            continue;
        var starCls = p.differentiator ? ' scr-preset-chip--star' : '';
        var title = p.category ? (' title="' + String(p.category).replace(/"/g, '&quot;') + '"') : '';
        html += '<button type="button" class="scr-preset-chip' + starCls + '"'
            + ' data-action="apply-screener-preset"'
            + ' data-preset-id="' + String(p.id).replace(/"/g, '&quot;') + '"'
            + ' aria-selected="false" role="option"' + title + '>'
            + String(p.name).replace(/</g, '&lt;')
            + '</button>';
    }
    chipsHost.innerHTML = html;
    // S4: append custom (user-saved) preset chips after built-in chips.
    if (typeof _renderCustomPresetChips === 'function')
        _renderCustomPresetChips();
    // S4: wire filter-input listeners to toggle the Save button visibility.
    if (typeof _wireSaveButtonListeners === 'function')
        _wireSaveButtonListeners();
    // S1: auto-apply preset from URL once chips exist. Deferred so the
    // caller's assignments (_screenerPresetsCache, etc.) complete first.
    setTimeout(_maybeAutoApplyUrlPreset, 0);
}
// S1: URL-shareable preset state. Read `?preset=<id>` on screener view
// show; update URL (via history.replaceState — no reload) whenever a
// preset is applied or cleared. Works alongside the existing ?view=
// param the SPA router uses.
function _getUrlPresetId() {
    try {
        return new URLSearchParams(window.location.search).get('preset') || '';
    }
    catch (e) {
        return '';
    }
}
function _setUrlPreset(pid) {
    try {
        var params = new URLSearchParams(window.location.search);
        if (pid)
            params.set('preset', pid);
        else
            params.delete('preset');
        var qs = params.toString();
        var newUrl = window.location.pathname + (qs ? '?' + qs : '') + window.location.hash;
        window.history.replaceState(null, '', newUrl);
    }
    catch (e) { /* no-op in unsupported browsers */ }
}
// Auto-apply preset from URL once the chips are hydrated. Idempotent —
// bails if the URL has no ?preset=, or the preset has already been
// activated (aria-selected=true on some chip).
function _maybeAutoApplyUrlPreset() {
    var pid = _getUrlPresetId();
    if (!pid || !_screenerPresetsCache)
        return;
    var chipsHost = document.getElementById('scr-presets-chips');
    if (!chipsHost)
        return;
    var alreadyActive = chipsHost.querySelector('.scr-preset-chip[aria-selected="true"]');
    if (alreadyActive && alreadyActive.getAttribute('data-preset-id') === pid)
        return;
    if (typeof _applyScreenerPreset === 'function')
        _applyScreenerPreset(pid);
}
// S5: clear active preset + all filter inputs + caption. Wired via
// data-action="clear-screener-preset" on the Clear button (see template).
function _clearScreenerPreset() {
    for (var j = 0; j < _SCR_FILTER_IDS.length; j++) {
        var el = document.getElementById(_SCR_FILTER_IDS[j].id);
        if (el)
            el.value = '';
    }
    var chipsHost = document.getElementById('scr-presets-chips');
    if (chipsHost) {
        var chips = chipsHost.querySelectorAll('.scr-preset-chip');
        for (var c = 0; c < chips.length; c++)
            chips[c].setAttribute('aria-selected', 'false');
    }
    var cap = document.getElementById('scr-preset-caption');
    if (cap)
        cap.textContent = '';
    var reset = document.getElementById('scr-presets-reset');
    if (reset)
        reset.classList.add('hidden');
    // S1: drop ?preset= from URL so a subsequent share doesn't carry a
    // preset the user just manually cleared.
    _setUrlPreset('');
    // Metric 3: clear the active preset so a later save isn't misattributed.
    _activePresetId = '';
    _scrInsiderFilter = null;
    // Don't auto-run the screener on clear — the user is signaling they
    // want to take over the filter state manually.
}
// S6: lightweight local analytics for preset usage. Pure localStorage;
// no server roundtrip. Key is monthly-rollover ("ol_preset_usage_YYYY-MM")
// so future preset-pruning decisions can pull the in-month tally.
//
// S51 addition: ALSO fire a server-side 'screener_preset_used' event
// through the existing _track → /api/analytics/event pipeline so the
// admin dashboard can aggregate across users. localStorage tracking
// stays as a per-user debug aid; server aggregation is what drives
// the measurement-plan §7 signals (CTR per pid, diversity, tier-
// conversion assist).
function _trackPresetUsage(pid) {
    if (!pid)
        return;
    var key = 'ol_preset_usage_' + new Date().toISOString().slice(0, 7);
    var counts = OLStorage.get(key, {});
    counts[pid] = (counts[pid] || 0) + 1;
    counts._total = (counts._total || 0) + 1;
    counts._lastAt = Date.now();
    OLStorage.set(key, counts);
    // Server-side fanout. Guarded with typeof — during early-page-load
    // window.onerror scenarios _track might not be defined yet.
    try {
        if (typeof _track === 'function') {
            _track('screener_preset_used', { preset_id: pid });
        }
    }
    catch (e) { /* non-blocking */ }
}
function _applyScreenerPreset(pid) {
    if (!pid)
        return;
    // S4: route custom presets to their own applier (they are not in the
    // JSON-backed _screenerPresetsCache).
    if (pid.indexOf('custom_') === 0) {
        if (typeof _applyCustomPreset === 'function')
            _applyCustomPreset(pid);
        return;
    }
    if (!_screenerPresetsCache)
        return;
    _trackPresetUsage(pid);
    var preset = null;
    for (var i = 0; i < _screenerPresetsCache.length; i++) {
        if (_screenerPresetsCache[i].id === pid) {
            preset = _screenerPresetsCache[i];
            break;
        }
    }
    if (!preset)
        return;
    // Screener Phase 5: server-side preset click analytics. Paired with the
    // localStorage-only _trackPresetUsage above so the admin can see
    // cross-user popularity for preset-pruning decisions. Fires via the
    // existing _track batch (10-event buffer + beforeunload flush).
    try {
        if (typeof _track === 'function') {
            _track('screener.preset_applied', {
                preset_id: pid,
                category: preset.category || '',
                differentiator: !!preset.differentiator
            });
        }
    }
    catch (e) { /* no-op; telemetry must never break the feature */ }
    // Metric 3: remember the active preset so a subsequent Save-as-custom
    // can attribute the save to its source preset.
    _activePresetId = pid;
    // Clear existing filter values, then map JSON filter keys -> DOM ids. Both
    // come from _SCR_FILTER_IDS: two hand lists here had drifted from it, so a
    // preset's debt_equity_max / near_52w_low / ipo_after landed nowhere.
    var keyMap = {};
    for (var j = 0; j < _SCR_FILTER_IDS.length; j++) {
        keyMap[_SCR_FILTER_IDS[j].key] = _SCR_FILTER_IDS[j].id;
        var el = document.getElementById(_SCR_FILTER_IDS[j].id);
        if (el)
            el.value = '';
    }
    // QA 2026-10-13 P1: price-derived filters are not filled for a viewer who
    // may not use them; the caption names them (_scrPresetLockNoteHtml).
    var _split = _scrSplitPresetFilters(preset.filters || {}, _scrPriceFiltersLocked);
    var filters = _split.apply;
    // The insider facet is a filed-figure filter, so an insider preset still runs
    // (as a wider screen, said so) when its price filters are locked.
    _scrInsiderFilter = preset.insiderOverlay || null;
    var _canRun = !_split.skipped.length || Object.keys(filters).length > 0 || !!_scrInsiderFilter;
    for (var k in filters) {
        if (!Object.prototype.hasOwnProperty.call(filters, k))
            continue;
        var domId = keyMap[k];
        if (!domId)
            continue;
        var fEl = document.getElementById(domId);
        if (!fEl)
            continue;
        fEl.value = _scrPresetFilterValue(k, filters[k]);
    }
    // aria-selected on the clicked chip
    var chipsHost = document.getElementById('scr-presets-chips');
    if (chipsHost) {
        var chips = chipsHost.querySelectorAll('.scr-preset-chip');
        for (var c = 0; c < chips.length; c++) {
            chips[c].setAttribute('aria-selected', chips[c].getAttribute('data-preset-id') === pid ? 'true' : 'false');
        }
    }
    // S5: reveal the Clear button now that a preset is active.
    var reset = document.getElementById('scr-presets-reset');
    if (reset)
        reset.classList.remove('hidden');
    // S1: persist preset id to URL so the result is shareable.
    _setUrlPreset(pid);
    // Caption: description + rationale + unsupported-filter warnings
    var cap = document.getElementById('scr-preset-caption');
    if (cap) {
        var desc = preset.description ? String(preset.description).replace(/</g, '&lt;') : '';
        var rat = preset.rationale ? '<div class="scr-preset-caption__rationale">' + String(preset.rationale).replace(/</g, '&lt;') + '</div>' : '';
        var uns = '';
        if (preset.unsupportedFilters && preset.unsupportedFilters.length) {
            var parts = [];
            for (var u = 0; u < preset.unsupportedFilters.length; u++) {
                var item = preset.unsupportedFilters[u];
                if (item && item.label)
                    parts.push(String(item.label).replace(/</g, '&lt;'));
            }
            if (parts.length)
                uns = '<div class="scr-preset-caption__unsupported">Approximation — these filters not yet supported: ' + parts.join('; ') + '</div>';
        }
        cap.innerHTML = '<div>' + desc + '</div>' + rat + uns + _scrPresetLockNoteHtml(_split.skipped, _canRun);
    }
    if (!_canRun)
        return;
    // The insider facet travels with the screen itself (_scrInsiderParams).
    if (typeof runScreener === 'function') {
        try {
            runScreener();
        }
        catch (e) { }
    }
}
// ═══ INSIDER FACET (P0, prod browser QA 2026-10-18) ═══
// The three "Insider Activity" presets used to overlay /api/insider-activity
// here, on the client. It read keys that endpoint never returns
// (data.activity / row.transaction_type; the wire is transactions[] +
// transType), so the tally was always empty; that endpoint is a ~50-row recent
// feed, not a market-wide aggregate; and every failure path (a silent .catch,
// an empty-results early return, an 800 ms setTimeout race) left the
// UNFILTERED value ranking on screen under a caption about insider buying.
// The filter is now server-side: the preset's insiderOverlay becomes
// insider_days / insider_min_buys / insider_net_positive on /api/screener
// (routes/routes_analysis_fastapi/screener.py _insider_facet), and the view
// shows no row unless the response says the facet was applied.
// tests/test_screener_insider_facet_contract.py runs these under node.
function _scrInsiderParamsFor(overlay) {
    if (!overlay)
        return [];
    var days = Math.round(Number(overlay.days));
    var minBuys = Math.round(Number(overlay.minNetBuys));
    return [['insider_days', String(days >= 1 && days <= 365 ? days : 30)],
        ['insider_min_buys', String(minBuys >= 1 && minBuys <= 1000 ? minBuys : 1)],
        ['insider_net_positive', overlay.requireNetPositive === false ? '0' : '1']];
}
function _scrInsiderParams() { return _scrInsiderParamsFor(_scrInsiderFilter); }
// True only when the server says the facet filtered every row. Anything else
// (no block, a 503 block, an older server that ignored the params) is closed.
function _scrInsiderApplied(data) {
    var f = data && data.insider_filter;
    return !!(f && f.applied === true && f.available === true);
}
function _scrInsiderUnavailableHtml() {
    return '<div class="scr-coverage-banner" role="alert" data-scr-insider-unavailable="1">'
        + 'Insider data unavailable — no results shown. The insider filter could not be '
        + 'checked against SEC Form 4 filings just now, so no unfiltered list is shown in its '
        + 'place. Please try again shortly.</div>';
}
// The table's insider cell: NET SHARES (the quantity the filter tests, CHAOS
// 2026-10-19 F2), then the purchase and sale counts it came from. The counts
// are Form 4 transactions, not people: one insider buying in three lots is
// three purchases.
function _scrInsiderCellHtml(r) {
    if (!r || typeof r.insiderBuys !== 'number')
        return '—';
    var sh = Number(r.insiderNetShares) || 0;
    var shTxt = (sh > 0 ? '+' : sh < 0 ? '−' : '') + Math.abs(Math.round(sh)).toLocaleString('en-US') + ' sh';
    return shTxt + '<span class="scr-analyst-count">'
        + r.insiderBuys + ' purchase' + (r.insiderBuys === 1 ? '' : 's') + ' · '
        + r.insiderSells + ' sale' + (r.insiderSells === 1 ? '' : 's') + '</span>';
}
// ═══ S4: Save Custom Preset (localStorage, inline form) ═══
// Pure client-side. Zero backend. Cap at 50 to prevent runaway growth.
var _SCR_CUSTOM_PRESETS_KEY = 'ol_screener_custom_presets';
var _SCR_CUSTOM_PRESETS_CAP = 50;
function _slugifyPresetName(name) {
    return String(name || '')
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9\-]+/g, '-')
        .replace(/^-+|-+$/g, '')
        .slice(0, 40) || 'preset';
}
function _readCustomPresets() {
    try {
        var raw = OLStorage.getString(_SCR_CUSTOM_PRESETS_KEY, null);
        if (!raw)
            return [];
        var arr = JSON.parse(raw);
        return Array.isArray(arr) ? arr : [];
    }
    catch (e) {
        return [];
    }
}
function _writeCustomPresets(arr) {
    if (!Array.isArray(arr))
        return false;
    // Cap guard — trim oldest if somehow exceeded.
    if (arr.length > _SCR_CUSTOM_PRESETS_CAP) {
        arr = arr.slice(-_SCR_CUSTOM_PRESETS_CAP);
    }
    if (OLStorage.set(_SCR_CUSTOM_PRESETS_KEY, arr))
        return true;
    // OLStorage.set returns false on quota exceeded; surface toast if available.
    if (typeof showToast === 'function') {
        try {
            showToast('Could not save preset (storage full).', 'error');
        }
        catch (_) { }
    }
    return false;
}
function _captureFilterSnapshot() {
    var snap = {};
    for (var i = 0; i < _SCR_FILTER_IDS.length; i++) {
        var f = _SCR_FILTER_IDS[i];
        var el = document.getElementById(f.id);
        if (!el)
            continue;
        var v = (el.value != null) ? String(el.value).trim() : '';
        if (v !== '')
            snap[f.key] = v;
    }
    return snap;
}
function _hasAnyFilterValue() {
    for (var i = 0; i < _SCR_FILTER_IDS.length; i++) {
        var el = document.getElementById(_SCR_FILTER_IDS[i].id);
        if (el && el.value != null && String(el.value).trim() !== '')
            return true;
    }
    return false;
}
function _updateSaveButtonVisibility() {
    var btn = document.getElementById('scr-presets-save');
    if (!btn)
        return;
    if (_hasAnyFilterValue())
        btn.classList.remove('hidden');
    else
        btn.classList.add('hidden');
}
var _scrSaveBtnListenersWired = false;
function _wireSaveButtonListeners() {
    if (_scrSaveBtnListenersWired)
        return;
    var any = false;
    for (var i = 0; i < _SCR_FILTER_IDS.length; i++) {
        var el = document.getElementById(_SCR_FILTER_IDS[i].id);
        if (!el)
            continue;
        any = true;
        el.addEventListener('input', _updateSaveButtonVisibility);
        el.addEventListener('change', _updateSaveButtonVisibility);
    }
    if (any)
        _scrSaveBtnListenersWired = true;
    _updateSaveButtonVisibility();
}
function _showSavePresetForm() {
    if (!_hasAnyFilterValue()) {
        if (typeof showToast === 'function') {
            try {
                showToast('Set some filters first, then save.', 'info');
            }
            catch (_) { }
        }
        return;
    }
    var form = document.getElementById('scr-preset-save-form');
    var input = document.getElementById('scr-preset-save-name');
    if (!form || !input)
        return;
    form.classList.remove('hidden');
    input.value = '';
    setTimeout(function () { try {
        input.focus();
    }
    catch (_) { } }, 0);
    // Enter submits, Escape cancels — only wire once.
    if (!input._s4Wired) {
        input._s4Wired = true;
        input.addEventListener('keydown', function (e) {
            if (e.key === 'Enter') {
                e.preventDefault();
                _saveCustomPreset(input.value);
            }
            else if (e.key === 'Escape') {
                e.preventDefault();
                _hideSavePresetForm();
            }
        });
    }
}
function _hideSavePresetForm() {
    var form = document.getElementById('scr-preset-save-form');
    if (form)
        form.classList.add('hidden');
}
function _saveCustomPreset(rawName) {
    // Strip HTML tags, collapse whitespace, trim, length-cap.
    var name = String(rawName == null ? '' : rawName)
        .replace(/<[^>]*>/g, '')
        .replace(/\s+/g, ' ')
        .trim()
        .slice(0, 60);
    if (!name) {
        if (typeof showToast === 'function') {
            try {
                showToast('Preset name cannot be empty.', 'error');
            }
            catch (_) { }
        }
        return;
    }
    var filters = _captureFilterSnapshot();
    var hasAny = false;
    for (var k in filters) {
        if (Object.prototype.hasOwnProperty.call(filters, k)) {
            hasAny = true;
            break;
        }
    }
    if (!hasAny) {
        if (typeof showToast === 'function') {
            try {
                showToast('No filters set to save.', 'info');
            }
            catch (_) { }
        }
        return;
    }
    var slug = _slugifyPresetName(name);
    var arr = _readCustomPresets();
    // Dedupe by slug — update existing entry.
    var matchedIdx = -1;
    for (var i = 0; i < arr.length; i++) {
        if (arr[i] && typeof arr[i].id === 'string' && arr[i].id.indexOf('custom_' + slug + '_') === 0) {
            matchedIdx = i;
            break;
        }
    }
    var now = Date.now();
    var entry = {
        id: 'custom_' + slug + '_' + now.toString(36),
        name: name,
        filters: filters,
        createdAt: now
    };
    if (matchedIdx >= 0) {
        // Preserve original id to keep chip focus stable.
        entry.id = arr[matchedIdx].id;
        arr[matchedIdx] = entry;
    }
    else {
        if (arr.length >= _SCR_CUSTOM_PRESETS_CAP) {
            if (typeof showToast === 'function') {
                try {
                    showToast('Preset limit reached (' + _SCR_CUSTOM_PRESETS_CAP + '). Delete one first.', 'error');
                }
                catch (_) { }
            }
            return;
        }
        arr.push(entry);
    }
    if (!_writeCustomPresets(arr))
        return;
    _hideSavePresetForm();
    _renderCustomPresetChips();
    // Metric 3: save-as-custom conversion telemetry. from_preset_id is
    // the built-in preset that was active when the user clicked Save
    // (empty string if they built filters manually). Aggregated into
    // topSavedPresetSources in get_analytics_summary so admin can see
    // which built-ins users tune + save vs. apply-as-is.
    try {
        if (typeof _track === 'function') {
            _track('screener.preset_saved', {
                from_preset_id: _activePresetId || '',
                was_update: matchedIdx >= 0
            });
        }
    }
    catch (e) { }
    if (typeof showToast === 'function') {
        try {
            showToast('Preset saved: ' + name, 'success');
        }
        catch (_) { }
    }
}
function _deleteCustomPreset(pid) {
    if (!pid)
        return;
    var arr = _readCustomPresets();
    var out = [];
    for (var i = 0; i < arr.length; i++) {
        if (arr[i] && arr[i].id !== pid)
            out.push(arr[i]);
    }
    _writeCustomPresets(out);
    _renderCustomPresetChips();
    // If the deleted preset was active, clear the filter state.
    var chipsHost = document.getElementById('scr-presets-chips');
    if (chipsHost) {
        var active = chipsHost.querySelector('.scr-preset-chip[aria-selected="true"]');
        if (!active && typeof _clearScreenerPreset === 'function') {
            // no-op — user can clear manually
        }
    }
}
function _escScrAttr(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }
function _escScrText(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
function _renderCustomPresetChips() {
    var chipsHost = document.getElementById('scr-presets-chips');
    if (!chipsHost)
        return;
    // Remove any existing custom chips first (idempotent re-render).
    var existing = chipsHost.querySelectorAll('.scr-preset-chip--custom-wrap, .scr-preset-chip--custom');
    for (var e = 0; e < existing.length; e++) {
        var node = existing[e];
        if (node && node.parentNode)
            node.parentNode.removeChild(node);
    }
    var arr = _readCustomPresets();
    if (!arr.length)
        return;
    var frag = document.createDocumentFragment();
    for (var i = 0; i < arr.length; i++) {
        var p = arr[i];
        if (!p || !p.id || !p.name)
            continue;
        var chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'scr-preset-chip scr-preset-chip--custom';
        chip.setAttribute('data-action', 'apply-screener-preset');
        chip.setAttribute('data-preset-id', p.id);
        chip.setAttribute('aria-selected', 'false');
        chip.setAttribute('role', 'option');
        chip.setAttribute('title', 'Custom preset — saved ' + new Date(p.createdAt || Date.now()).toLocaleDateString());
        // Name text (safe textContent — XSS-proof)
        var label = document.createElement('span');
        label.className = 'scr-preset-chip__label';
        label.textContent = p.name;
        chip.appendChild(label);
        // Delete button
        var del = document.createElement('span');
        del.setAttribute('role', 'button');
        del.setAttribute('tabindex', '0');
        del.className = 'scr-preset-chip__delete';
        del.setAttribute('data-action', 'delete-custom-preset');
        del.setAttribute('data-preset-id', p.id);
        del.setAttribute('aria-label', 'Delete custom preset');
        del.setAttribute('title', 'Delete preset');
        del.textContent = '\u2715';
        // Keyboard: Enter/Space on the delete span
        del.addEventListener('keydown', (function (id) {
            return function (ev) {
                if (ev.key === 'Enter' || ev.key === ' ') {
                    ev.preventDefault();
                    ev.stopPropagation();
                    _deleteCustomPreset(id);
                }
            };
        })(p.id));
        // Prevent the chip's apply-action from firing when clicking delete.
        del.addEventListener('click', (function (id) {
            return function (ev) { ev.preventDefault(); ev.stopPropagation(); _deleteCustomPreset(id); };
        })(p.id));
        chip.appendChild(del);
        frag.appendChild(chip);
    }
    chipsHost.appendChild(frag);
}
function _applyCustomPreset(pid) {
    var arr = _readCustomPresets();
    var preset = null;
    for (var i = 0; i < arr.length; i++) {
        if (arr[i] && arr[i].id === pid) {
            preset = arr[i];
            break;
        }
    }
    if (!preset)
        return;
    // Phase 5 analytics: custom preset click (category=custom). preset_id
    // is the opaque "custom_<uuid>" so it can't leak user-specific info,
    // just confirms the feature is used.
    try {
        if (typeof _track === 'function') {
            _track('screener.preset_applied', { preset_id: pid, category: 'custom', differentiator: false });
        }
    }
    catch (e) { }
    _activePresetId = pid;
    _scrInsiderFilter = null; // a saved custom preset carries filters only
    // Reset all inputs first.
    for (var j = 0; j < _SCR_FILTER_IDS.length; j++) {
        var el = document.getElementById(_SCR_FILTER_IDS[j].id);
        if (el)
            el.value = '';
    }
    // Apply snapshot by key.
    var keyToId = {};
    for (var k = 0; k < _SCR_FILTER_IDS.length; k++)
        keyToId[_SCR_FILTER_IDS[k].key] = _SCR_FILTER_IDS[k].id;
    var _split = _scrSplitPresetFilters(preset.filters || {}, _scrPriceFiltersLocked);
    var filters = _split.apply;
    var _canRun = !_split.skipped.length || Object.keys(filters).length > 0;
    for (var fk in filters) {
        if (!Object.prototype.hasOwnProperty.call(filters, fk))
            continue;
        var domId = keyToId[fk];
        if (!domId)
            continue;
        var fEl = document.getElementById(domId);
        if (!fEl)
            continue;
        fEl.value = _scrPresetFilterValue(fk, filters[fk]);
    }
    // aria-selected state.
    var chipsHost = document.getElementById('scr-presets-chips');
    if (chipsHost) {
        var chips = chipsHost.querySelectorAll('.scr-preset-chip');
        for (var c = 0; c < chips.length; c++) {
            chips[c].setAttribute('aria-selected', chips[c].getAttribute('data-preset-id') === pid ? 'true' : 'false');
        }
    }
    var reset = document.getElementById('scr-presets-reset');
    if (reset)
        reset.classList.remove('hidden');
    _setUrlPreset(pid);
    _trackPresetUsage(pid);
    _updateSaveButtonVisibility();
    // Caption
    var cap = document.getElementById('scr-preset-caption');
    if (cap)
        cap.innerHTML = '<div>Custom preset: ' + _escScrText(preset.name) + '</div>'
            + _scrPresetLockNoteHtml(_split.skipped, _canRun);
    // Run the screener
    if (_canRun && typeof runScreener === 'function') {
        try {
            runScreener();
        }
        catch (e) { }
    }
}
// OWNER ruling 4 follow-up (2026-10-04): the confluence values were renamed
// (partial_bullish -> partial_net_adding, partial_bearish -> partial_net_reducing).
// A preset saved before then stores the old <option> value, which the select no
// longer has -- assigning it silently yields "Any" and the preset runs
// unfiltered under its saved name (CHAOS 2026-10-04 F1). Both apply paths map
// through here. Self-contained so tests/test_screener_preset_legacy_values_contract.py
// can run it under node.
function _scrPresetFilterValue(key, v) {
    var legacy = {
        confluence: { partial_bullish: 'partial_net_adding', partial_bearish: 'partial_net_reducing' }
    };
    var m = legacy[key];
    return (m && typeof v === 'string' && Object.prototype.hasOwnProperty.call(m, v)) ? m[v] : v;
}
//# sourceMappingURL=screener-presets.js.map
;
// ═══ learn-panes.js ═══
;"use strict";
// @ts-nocheck
// ──────────────────────────────────────────────────────────────────────────
// LEARN detail panes — the Glossary Browse pane (#128/#175, _gbp*) and the
// On-This-Date pane (#131/OWNER almanac, _otd*), EXTRACTED VERBATIM from
// app-renderers.ts (2026-08-24, #99 D1b: 5,175 of 5,175 budget — zero
// headroom; this is the file's second cut after #202 screener-presets).
//
// Like screener-presets.js and chrome-indicators.js before it, adjacency
// in the chunk lists is NOT load-bearing: the block is six literal-
// initialised `var`s and eighteen function declarations with ZERO module-
// scope executed code. What IS required is SAME-CHUNK membership (`app`):
// the _delegatedActions handlers in app-renderers.ts ('gbp-open',
// 'gbp-search', 'gbp-show-all', 'gbp-filter-cat', 'otd-*') call these at
// event time as bare chunk globals, and dropping the file from the bundle
// would silently no-op both panes with no console error — the exact
// fab21fd5 defect class the screener-presets note records.
// ──────────────────────────────────────────────────────────────────────────
// #128: debounce handle for the in-pane glossary search (mirrors the
// _gbSearchTimer the legacy modal browse uses; module-scoped so a
// rapid keystroke run never stacks setTimeouts).
var _gbpSearchTimer = null;
// #175 (OWNER): active glossary category-filter slug. 'all' = every
// category (the default). Mirrors _otdFilter (the On-This-Date theme
// chip) exactly so the three learn tabs share one filter idiom. A term
// is in-category iff GLOSSARY_CATEGORY[term] === _gbpFilter; composes
// with both the text search AND the GBP_INITIAL_CAP cap.
var _gbpFilter = 'all';
// #128 (OWNER 2026-05-18): in-app Glossary browse pane.
//
// Renders the full GLOSSARY term map (the ~735-entry dict that lives in
// glossary.js, declared globally via globals.d.ts) into the
// #lp-glossary-panel learn-tab pane so the welcome "Glossary"
// observatory tile can deep-link IN-APP (/?view=learn&tab=glossary)
// instead of bouncing engaged users to the SSR /glossary/ SEO page
// (feedback_prefer_inapp_over_seo_routing). The SSR route + the
// existing modal browse (openGlossaryBrowse) are UNCHANGED — this is
// the pane twin, not a replacement.
//
// Data source is reused, NOT duplicated: the definitions come straight
// from the global GLOSSARY dict. Clicking a term reuses the existing
// term-detail modal opener (_glossModalOpen, a window global from the
// classic-script glossary.js) — no new term-detail wiring.
//
// DOM safety: #lp-glossary-panel is a leaf detail panel (no canvas,
// WebSocket widget, or IntersectionObserver target inside it), so
// innerHTML here is safe and mirrors renderInvestmentLore's pattern
// (feedback_never_destroy_dom: the rule is about chrome/pane parents
// that hold reusable singletons, which this is not).
// #131 (CHAOS K6, 2026-05-18): single source of truth for the glossary
// browse-pane row markup + escaping. _renderGlossaryBrowsePane (initial
// render) and _gbpSearch (debounced filter) previously each carried a
// byte-identical copy of this loop + _esc — a latent silent-divergence
// (edit the row markup in one, the init vs filtered views drift). Both
// now call _gbpRowsHtml so they cannot diverge.
function _gbpEsc(s) {
    return String(s == null ? '' : s)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;')
        .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}
// G: the GLOSSARY record. terms: pre-sorted keys. filter: raw user
// string ('' on initial render). Behaviour identical to the prior twin
// copies (incl. the no-matches message using the raw filter string).
// #169 (DESIGN, #168 follow-up): the unfiltered browse view used to
// emit ALL ~799 term rows at once (~2.4K DOM nodes from one pane) —
// over the <1000 live-DOM budget when combined with the rest of the
// learn view. `cap` bounds ONLY the unfiltered browse render; an
// active search (`q` non-empty) still spans the FULL corpus uncapped
// (search must be able to find any of the 799 terms). `cap` falsy/0
// = uncapped (the explicit "show all" opt-in via _gbpShowAll).
var GBP_INITIAL_CAP = 120;
// #175: `cat` is the active category slug ('all' or falsy = every
// category). The category predicate is applied FIRST (it narrows the
// corpus), then the existing text-search + cap logic runs unchanged
// over the in-category subset — so search still spans the full corpus
// WITHIN the active category, and the capped browse view is still
// capped per-category. GLOSSARY_CATEGORY is the glossary.ts taxonomy
// (typeof-guarded: absent map = no category narrowing, safe default).
function _gbpRowsHtml(G, terms, filter, cap, cat) {
    var q = (filter || '').toLowerCase().trim();
    var limit = (!q && cap) ? cap : 0;
    var activeCat = (cat && cat !== 'all') ? cat : '';
    var CAT = (typeof GLOSSARY_CATEGORY !== 'undefined' && GLOSSARY_CATEGORY)
        ? GLOSSARY_CATEGORY : null;
    var out = '';
    var shown = 0;
    var total = 0;
    for (var i = 0; i < terms.length; i++) {
        var t = terms[i];
        var def = G[t] || '';
        if (activeCat && (!CAT || CAT[t] !== activeCat))
            continue;
        if (q && t.toLowerCase().indexOf(q) < 0 && def.toLowerCase().indexOf(q) < 0)
            continue;
        total++;
        if (limit && shown >= limit)
            continue;
        shown++;
        var shortDef = def.length > 160 ? def.slice(0, 157) + '...' : def;
        out += '<button type="button" class="gb-row gbp-row" data-action="gbp-open" data-term="'
            + _gbpEsc(t) + '">'
            + '<span class="gb-term">' + _gbpEsc(t) + '</span>'
            + '<span class="gb-def">' + _gbpEsc(shortDef) + '</span>'
            + '</button>';
    }
    if (!shown) {
        // #175: differentiate the empty states (mirrors _otdRowsHtml). A
        // live text query names it; a category with no remaining matches
        // (only reachable via search-within-category) says so plainly.
        if (q) {
            out = '<div class="gb-no-matches">No terms matching "' + _gbpEsc(filter) + '"'
                + (activeCat ? ' in this category' : '') + '</div>';
        }
        else {
            out = '<div class="gb-no-matches">No terms in this category.</div>';
        }
    }
    else if (limit && total > limit) {
        out += '<div class="gb-no-matches gbp-more">Showing the first ' + limit + ' of '
            + total + ' terms. Search above to jump to any term, or '
            + '<button type="button" class="gbp-showall-btn" data-action="gbp-show-all">'
            + 'show all ' + total + '</button>.</div>';
    }
    return out;
}
function _gbpSortedTerms(G) {
    return Object.keys(G).sort(function (a, b) {
        return a.toLowerCase().localeCompare(b.toLowerCase());
    });
}
// #175: category chip bar — mirrors _otdChipsHtml (and through it
// investment-lore.ts's .li-level-filters / .li-filter-btn idiom)
// verbatim so the Glossary tab feels uniform with the other learn
// tabs. 'All' first, then one chip per GLOSSARY_CATEGORY_ORDER entry
// in file order. data-action="gbp-filter-cat" + data-cat is dispatched
// by the delegated handler. typeof-guarded: absent order list = just
// the 'All' chip (graceful — the pane still works uncategorized).
function _gbpChipsHtml() {
    var order = (typeof GLOSSARY_CATEGORY_ORDER !== 'undefined' && GLOSSARY_CATEGORY_ORDER)
        ? GLOSSARY_CATEGORY_ORDER : [];
    var allActive = (_gbpFilter || 'all') === 'all';
    var h = '<div class="li-level-filters">'
        + '<button class="li-filter-btn' + (allActive ? ' active' : '') + '" '
        + 'type="button" data-action="gbp-filter-cat" data-cat="all">'
        + 'All</button>';
    for (var i = 0; i < order.length; i++) {
        var slug = order[i][0];
        var isActive = _gbpFilter === slug;
        h += '<button class="li-filter-btn' + (isActive ? ' active' : '') + '" '
            + 'type="button" data-action="gbp-filter-cat" data-cat="'
            + _gbpEsc(slug) + '">' + _gbpEsc(order[i][1]) + '</button>';
    }
    return h + '</div>';
}
function _renderGlossaryBrowsePane() {
    var el = document.getElementById('lp-glossary-panel');
    if (!el)
        return;
    var G = (typeof GLOSSARY !== 'undefined' && GLOSSARY)
        ? GLOSSARY
        : null;
    if (!G) {
        el.innerHTML = '<div class="loading-msg">Glossary unavailable. Retry shortly.</div>';
        return;
    }
    var terms = _gbpSortedTerms(G);
    var html = ''
        + '<h2 class="panel-title rl-title">GLOSSARY</h2>'
        + '<div class="dc-subtitle">' + terms.length
        + ' financial terms with real-market context. '
        + 'Click any term for the full entry.</div>'
        + '<div class="rl-controls">'
        + '<input type="text" id="gbp-search" class="rl-search-input" '
        + 'placeholder="Search ' + terms.length + ' terms..." '
        + 'data-action-input="gbp-search" autocomplete="off" '
        + 'aria-label="Search glossary terms">'
        + '</div>'
        // #175: category chip bar — same position as the On-This-Date pane
        // (between the search input and the #gbp-results grid).
        + _gbpChipsHtml()
        + '<div id="gbp-results" class="gb-results">'
        + _gbpRowsHtml(G, terms, '', GBP_INITIAL_CAP, _gbpFilter) + '</div>';
    el.innerHTML = html;
    // #287e (OWNER 2026-07-27): consume the /glossary/<term> deep-link anchor.
    // routes/pages.py:serve_glossary 302s AUTHED users to
    // /?view=learn&tab=glossary#term-<slug> — but this pane ignored the hash,
    // so a KPI column-header click landed on the pane TOP instead of the
    // term's definition. Resolve the slug back to its GLOSSARY key (same
    // lowercase/non-alnum-collapse form the route's _glossary_anchor_slug and
    // glossary-page.ts's slugifyTerm produce) and open the existing
    // term-detail modal. Consume-once: the hash is cleared so a later
    // re-render of the pane doesn't re-open the modal.
    try {
        // QA 2026-09-03: the boot URL-rewrite clears location.hash before
        // this renders on a cold authed deep-link -- prefer the live hash,
        // fall back to the boot stash (app-init), consume BOTH once.
        var _gbpHash = (window.location.hash || window._olBootHash || '').replace(/^#/, '');
        if (_gbpHash.indexOf('term-') === 0) {
            var _gbpWantSlug = _gbpHash.substring(5);
            var _gbpSlugOf = function (s) {
                return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, '-')
                    .replace(/-+/g, '-').replace(/^-|-$/g, '');
            };
            for (var _gi = 0; _gi < terms.length; _gi++) {
                if (_gbpSlugOf(terms[_gi]) === _gbpWantSlug) {
                    if (typeof _glossModalOpen === 'function')
                        _glossModalOpen(terms[_gi]);
                    break;
                }
            }
            window.history.replaceState(null, '', window.location.pathname + window.location.search);
            try {
                window._olBootHash = '';
            }
            catch (_e2) { /* consumed */ }
        }
    }
    catch (_e) { /* best-effort deep-link — never break the pane render */ }
}
// Filter handler for the in-pane glossary search (data-action-input).
function _gbpSearch(elOrEvt) {
    var input = (elOrEvt && elOrEvt.target) ? elOrEvt.target : elOrEvt;
    var val = (input && typeof input.value === 'string') ? input.value : '';
    var results = document.getElementById('gbp-results');
    if (!results)
        return;
    var G = (typeof GLOSSARY !== 'undefined' && GLOSSARY)
        ? GLOSSARY : null;
    if (!G)
        return;
    // #169: pass the cap so a cleared search box returns to the bounded
    // browse view (a non-empty `val` makes _gbpRowsHtml ignore the cap
    // and span the full corpus — search still finds any of the 799).
    // #175: thread the active category so search composes WITHIN it.
    results.innerHTML = _gbpRowsHtml(G, _gbpSortedTerms(G), val, GBP_INITIAL_CAP, _gbpFilter);
}
// #169: explicit "show all" escape hatch for the capped browse view.
// Re-renders the full sorted corpus uncapped (cap=0) — the DOM-budget
// cost is then a deliberate user opt-in, not the default page weight.
function _gbpShowAll() {
    var results = document.getElementById('gbp-results');
    if (!results)
        return;
    var G = (typeof GLOSSARY !== 'undefined' && GLOSSARY)
        ? GLOSSARY : null;
    if (!G)
        return;
    // #175: still scoped to the active category — "show all" lifts the
    // DOM cap, not the category narrowing (uncapped within-category).
    results.innerHTML = _gbpRowsHtml(G, _gbpSortedTerms(G), '', 0, _gbpFilter);
}
// #175: category-chip handler. Mirrors _otdFilterTheme (and through it
// investment-lore.ts's _loreFilterEra) exactly: set the active
// category then re-render ONLY the #gbp-results grid + refresh the
// chip active state IN PLACE so the search box keeps its value/focus
// (a full-pane innerHTML would drop the in-flight search text). The
// #gbp-results / .gbp-row grid contract (#168) is preserved —
// _gbpRowsHtml still emits the same card markup, and the cap is
// re-applied so switching category returns to the bounded browse view.
function _gbpFilterCat(cat) {
    _gbpFilter = cat || 'all';
    var panel = document.getElementById('lp-glossary-panel');
    if (!panel)
        return;
    var results = panel.querySelector('#gbp-results');
    var G = (typeof GLOSSARY !== 'undefined' && GLOSSARY)
        ? GLOSSARY : null;
    if (results && G) {
        var searchEl = panel.querySelector('#gbp-search');
        var curQ = (searchEl && typeof searchEl.value === 'string') ? searchEl.value : '';
        results.innerHTML = _gbpRowsHtml(G, _gbpSortedTerms(G), curQ, GBP_INITIAL_CAP, _gbpFilter);
    }
    // Refresh chip active state in place (no full re-render — keeps the
    // search box value/focus stable).
    var bar = panel.querySelector('.li-level-filters');
    if (bar) {
        var btns = bar.querySelectorAll('.li-filter-btn');
        for (var i = 0; i < btns.length; i++) {
            var b = btns[i];
            var bc = b.getAttribute('data-cat') || 'all';
            if (bc === _gbpFilter)
                b.classList.add('active');
            else
                b.classList.remove('active');
        }
    }
}
// ---------------------------------------------------------------------------
// #130 (CHAOS-K1 follow-up, 2026-05-19): in-app On-This-Date browse pane.
//
// Mirrors the #128 in-app Glossary pane exactly (single established
// pattern — not a new one): a leaf learn-tab pane (#lp-on-this-date-panel,
// no canvas/WS/IO inside it) hydrated from the SAME dedicated almanac the
// SSR /lore/on-this-date/{slug} page uses (static/data/on-this-date.json),
// so the welcome "On this date" observatory tile can deep-link IN-APP
// (/?view=learn&tab=on-this-date) instead of bouncing engaged users to the
// SSR SEO page (feedback_prefer_inapp_over_seo_routing).
//
// Background: #128 first tried to route on-this-date through the *lore*
// corpus claiming it was a superset; CHAOS-K1 (docs/board/audit/
// 2026-05-18_CHAOS_glossary_onthisdate_inapp.md) DISPROVED that (lore is a
// themed narrative collection, on-this-date.json is a date-keyed almanac
// incl. civic events), so it was reverted to SSR-only. This builds the
// REAL in-app twin against the dedicated almanac — the correct fix.
//
// The SSR route + template are UNCHANGED (the EXCEPTION clause:
// crawler/anon/cold-entry still served by SSR; the in-app twin does NOT
// strand it). Data is reused, NOT duplicated — a single static fetch of
// the same file the Python helper (_load_static_json) reads.
//
// CHAOS Pattern-K hardening (UGC-adjacent reader-facing content +
// routing change):
//   - Every almanac field (year/headline/body) is XSS-escaped via _otdEsc
//     (the same escape contract _gbpEsc uses) before it touches the DOM.
//   - Empty/unfetchable JSON degrades to a readable message + a link to
//     the SSR page — never a blank screen / never a thrown render.
//   - innerHTML target is a leaf detail panel (no canvas/WS/IO singletons)
//     — feedback_never_destroy_dom preserved (same posture as the
//     glossary pane + renderInvestmentLore).
//   - No module-top-level window-global read — the fetch is lazy, fired by
//     the learn-tab action only when the pane is shown
//     (feedback_module_top_level_global_race: nothing races here).
//
// Cached on first fetch so a rapid tab toggle does not re-hit the file.
var _otdData = null;
var _otdFetchInflight = false;
var _otdSearchTimer = null;
// #168 (OWNER prod-QA 2026-05-19): the flat calendar-sorted list read
// "haphazard / seemingly irrelevant." OWNER ratified grouping by THEME
// (4 buckets) reusing the Investment-Lore filter-chip idiom so the
// On-This-Date tab feels uniform with the other learn tabs. 'all' = the
// default (every theme, grouped under headings inside the one
// #otd-results editorial grid — the just-shipped #168 CSS contract).
var _otdFilter = 'all';
// slug -> display label. Order here = chip + heading order (panic,
// policy, plumbing, companies — mirrors the through-line). OWNER fixed
// 4 buckets; do NOT add a 5th.
var _OTD_THEMES = [
    ['crashes-crises', 'Crashes & Crises'],
    ['policy-regulation', 'Policy & Regulation'],
    ['market-structure', 'Market Structure'],
    ['company-milestones', 'Company Milestones'],
];
function _otdEsc(s) {
    return String(s == null ? '' : s)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;')
        .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}
// Month index (1-12) → short name. Local table so a missing/odd month
// degrades to '' rather than throwing (no Intl/Date parsing on
// curated-but-untrusted-shape data).
var _OTD_MONTHS = ['', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
function _otdDateLabel(month, day) {
    var m = parseInt(String(month), 10);
    var d = parseInt(String(day), 10);
    if (!(m >= 1 && m <= 12) || !(d >= 1 && d <= 31))
        return '';
    return _OTD_MONTHS[m] + ' ' + d;
}
// #168 (OWNER 2026-05-19): grouped by THEME, not the old flat calendar
// list (the prod-QA "haphazard / seemingly irrelevant" defect). Mirrors
// investment-lore.ts: ONE grid, re-render the filtered subset. Default
// (_otdFilter==='all') shows every theme under a full-bleed
// .otd-theme-head band INSIDE #otd-results so .otd-row cards stay direct
// grid children (the just-shipped #168 CSS +
// test_learn_tab_editorial_grid_parity contract). All rendered almanac
// fields stay funnelled through _otdEsc (the #130 escape contract).
function _otdRowsHtml(rows, filter) {
    var q = (filter || '').toLowerCase().trim();
    var theme = _otdFilter || 'all';
    var sorted = rows.slice().sort(function (a, b) {
        var am = parseInt(String(a.month), 10) || 0;
        var bm = parseInt(String(b.month), 10) || 0;
        return am !== bm ? am - bm
            : (parseInt(String(a.day), 10) || 0) - (parseInt(String(b.day), 10) || 0);
    });
    var matched = [];
    for (var i = 0; i < sorted.length; i++) {
        var e = sorted[i];
        if (!e || typeof e !== 'object' || !e.headline)
            continue;
        var hay = (String(e.headline) + ' ' + String(e.body || '') + ' ' + String(e.year || '')).toLowerCase();
        if (q && hay.indexOf(q) < 0)
            continue;
        if (theme !== 'all' && String(e.theme == null ? '' : e.theme) !== theme)
            continue;
        matched.push(e);
    }
    if (!matched.length) {
        if (q)
            return '<div class="gb-no-matches">No events matching "' + _otdEsc(filter) + '"</div>';
        return '<div class="gb-no-matches">No events available right now.</div>';
    }
    function _card(e2) {
        var headline = e2.headline == null ? '' : String(e2.headline);
        var body = e2.body == null ? '' : String(e2.body);
        var year = e2.year == null ? '' : String(e2.year);
        var dl = _otdDateLabel(e2.month, e2.day);
        var meta = (dl ? dl : '');
        if (year)
            meta = meta ? (meta + ', ' + year) : year;
        return '<div class="otd-row gb-row">'
            + '<div class="otd-meta gb-term">' + _otdEsc(meta) + '</div>'
            + '<div class="otd-headline">' + _otdEsc(headline) + '</div>'
            + (body ? '<div class="otd-body gb-def">' + _otdEsc(body) + '</div>' : '')
            + '</div>';
    }
    var out = '';
    if (theme !== 'all') {
        // Single theme chip active — flat card list (the chip names it).
        for (var j = 0; j < matched.length; j++)
            out += _card(matched[j]);
        return out;
    }
    // 'all' — bucket by theme in the OWNER-fixed canonical order, each
    // behind a full-bleed .otd-theme-head band (grid-column:1/-1) so the
    // .otd-row cards stay direct #otd-results grid children.
    for (var t = 0; t < _OTD_THEMES.length; t++) {
        var slugT = _OTD_THEMES[t][0];
        var group = matched.filter(function (ev) {
            return String(ev.theme == null ? '' : ev.theme) === slugT;
        });
        if (!group.length)
            continue;
        out += '<div class="otd-theme-head">' + _otdEsc(_OTD_THEMES[t][1]) + '</div>';
        for (var g = 0; g < group.length; g++)
            out += _card(group[g]);
    }
    return out;
}
// The OWNER-approved through-line shown above the events. Markets'
// recurring forces: panic (Crashes & Crises), policy (Policy &
// Regulation), plumbing (Market Structure), and the companies caught
// between (Company Milestones) — the four theme buckets the chips
// filter. Plain ASCII straight-quotes only (CLAUDE.md §4).
var _OTD_THROUGHLINE = 'Every era of markets rotates through the same '
    + 'forces - panic, policy, plumbing, and the companies caught between.';
// Theme chip bar — mirrors investment-lore.ts:133-144's
// .li-level-filters / .li-filter-btn idiom verbatim so On-This-Date
// feels uniform with the other learn tabs. 'All' first, then the 4
// OWNER-fixed buckets in canonical order. data-action="otd-filter-theme"
// + data-theme is dispatched by the delegated handler.
function _otdChipsHtml() {
    var allActive = (_otdFilter || 'all') === 'all';
    var h = '<div class="li-level-filters">'
        + '<button class="li-filter-btn' + (allActive ? ' active' : '') + '" '
        + 'type="button" data-action="otd-filter-theme" data-theme="all">'
        + 'All</button>';
    for (var i = 0; i < _OTD_THEMES.length; i++) {
        var slug = _OTD_THEMES[i][0];
        var isActive = _otdFilter === slug;
        h += '<button class="li-filter-btn' + (isActive ? ' active' : '') + '" '
            + 'type="button" data-action="otd-filter-theme" data-theme="'
            + _otdEsc(slug) + '">' + _otdEsc(_OTD_THEMES[i][1]) + '</button>';
    }
    return h + '</div>';
}
function _otdRenderInto(el) {
    if (!el)
        return;
    var rows = Array.isArray(_otdData) ? _otdData : [];
    var html = ''
        + '<h2 class="panel-title rl-title">ON THIS DATE</h2>'
        + '<div class="dc-subtitle">' + (rows.length || 0)
        + ' moments that shaped markets, grouped by theme. '
        + _otdEsc(_OTD_THROUGHLINE) + '</div>'
        + '<div class="rl-controls">'
        + '<input type="text" id="otd-search" class="rl-search-input" '
        + 'placeholder="Search ' + (rows.length || 0) + ' events..." '
        + 'data-action-input="otd-search" autocomplete="off" '
        + 'aria-label="Search historical market events">'
        + '</div>'
        + _otdChipsHtml()
        + '<div id="otd-results" class="gb-results">' + _otdRowsHtml(rows, '') + '</div>';
    el.innerHTML = html;
}
// Public entry point — called by the learn-tab action when the
// on-this-date tab is selected. Lazy-fetches the almanac once; on fetch
// failure renders a graceful never-blank-screen fallback that still
// points at the SSR archive (the EXCEPTION-clause surface).
function _renderOnThisDatePane() {
    var el = document.getElementById('lp-on-this-date-panel');
    if (!el)
        return;
    if (Array.isArray(_otdData)) {
        _otdRenderInto(el);
        return;
    }
    if (_otdFetchInflight)
        return; // a fetch is already running — don't stack
    el.innerHTML = '<div class="loading-msg">Loading historical events...</div>';
    _otdFetchInflight = true;
    // SF-HANDOFF-REDESIGN PR0 Phase 2 (2026-05-26): swap direct JSON
    // fetch → /api/learn/on-this-date. The route returns
    // `{entries: [...]}` (v97-backed with server-side JSON fallback);
    // the renderer below filters by month/day client-side so we omit
    // query params to fetch the full almanac in one round-trip
    // (matches the pre-PR0 contract).
    // FE review 2026-07-19 P2: timeout-bound + .finally on the inflight flag -
    // a hung socket used to wedge _otdFetchInflight true forever, blocking all
    // future re-renders of this pane behind "Loading historical events...".
    fetch('/api/learn/on-this-date', { credentials: 'same-origin', signal: AbortSignal.timeout(15000) })
        .then(function (r) {
        if (!r || !r.ok)
            throw new Error('on-this-date fetch ' + (r && r.status));
        return r.json();
    })
        .then(function (data) {
        // Wire shape: { entries: [...] }. Defend the legacy bare-array
        // path so a partial rollback or local-dev cache miss doesn't
        // break the panel — `Array.isArray(data)` accepts either.
        var entries = Array.isArray(data)
            ? data
            : (data && Array.isArray(data.entries) ? data.entries : []);
        _otdData = entries;
        _otdFetchInflight = false;
        var live = document.getElementById('lp-on-this-date-panel');
        if (live)
            _otdRenderInto(live);
    })
        .catch(function (_e) {
        _otdFetchInflight = false;
        var live = document.getElementById('lp-on-this-date-panel');
        if (live) {
            // Fetch failed — never a blank screen. A "Retry" button (the
            // gb-row affordance the glossary pane uses) re-fires the lazy
            // render; no dead link (no SSR on-this-date index exists).
            live.innerHTML = '<h2 class="panel-title rl-title">ON THIS DATE</h2>'
                + '<div class="gb-no-matches">Could not load historical events '
                + 'right now. <button type="button" class="gb-row" '
                + 'data-action="otd-retry">Retry</button></div>';
        }
    })
        .finally(function () { _otdFetchInflight = false; }); // FE review 2026-07-19 P2: abort/timeout paths must never wedge the flag;
}
// Filter handler for the in-pane on-this-date search (data-action-input).
// Re-renders ONLY the #otd-results grid (the search box keeps focus +
// the chip bar is untouched) — _otdRowsHtml honours the active
// _otdFilter theme chip so search composes with the theme filter.
function _otdSearch(elOrEvt) {
    var input = (elOrEvt && elOrEvt.target) ? elOrEvt.target : elOrEvt;
    var val = (input && typeof input.value === 'string') ? input.value : '';
    var results = document.getElementById('otd-results');
    if (!results)
        return;
    var rows = Array.isArray(_otdData) ? _otdData : [];
    results.innerHTML = _otdRowsHtml(rows, val);
}
// Theme-chip handler (#168). Mirrors investment-lore.ts's
// _loreFilterEra: set the active theme then re-render. We re-render
// ONLY the #otd-results grid + refresh the chip active state so the
// search box keeps its value/focus (full-pane innerHTML would drop the
// in-flight search text). The #otd-results / .otd-row CSS contract is
// preserved — _otdRowsHtml still emits the same grid + card markup.
function _otdFilterTheme(theme) {
    _otdFilter = theme || 'all';
    var panel = document.getElementById('lp-on-this-date-panel');
    if (!panel)
        return;
    var results = panel.querySelector('#otd-results');
    var rows = Array.isArray(_otdData) ? _otdData : [];
    if (results) {
        var searchEl = panel.querySelector('#otd-search');
        var curQ = (searchEl && typeof searchEl.value === 'string') ? searchEl.value : '';
        results.innerHTML = _otdRowsHtml(rows, curQ);
    }
    // Refresh chip active state in place (no full re-render — keeps the
    // search box value/focus stable).
    var bar = panel.querySelector('.li-level-filters');
    if (bar) {
        var btns = bar.querySelectorAll('.li-filter-btn');
        for (var i = 0; i < btns.length; i++) {
            var b = btns[i];
            var bt = b.getAttribute('data-theme') || 'all';
            if (bt === _otdFilter)
                b.classList.add('active');
            else
                b.classList.remove('active');
        }
    }
}
//# sourceMappingURL=learn-panes.js.map
;
// ═══ chart-engine.js ═══
;"use strict";
// @ts-nocheck
// ── chart-engine.js ──────────────────────────────────────────────────────
//
// TS Migration Phase 2 PR 47 (2026-05-04): renamed .js → .ts.
// Plan: docs/plans/JS_MIGRATION_PHASE_0_AUDIT.md.
//
// This file is the SOURCE OF TRUTH; chart-engine.js is the build artifact
// produced by `npx tsc -p tsconfig.build.json` (gitignored).
//
// Chart rendering engine: renderComboChart, drawComboChart, indicators,
// zoom/pan, crosshair hover, annual financials fallback — extracted
// from app.js §CHART. Heavy canvas + 2D-context code with deep
// cross-chunk surface (THEME, chartMode, chartAnnotations, chartViewport,
// chartPanState, calcSMA, calcRSI, calcMACD, calcBollinger, fmtVol,
// tagCanvasA11y, fetchTickerChart self-recursion, etc.).
//
// `// @ts-nocheck` rationale: see matching block in macro-view.ts. This
// PR does the structural rename so .ts becomes the source of truth in
// the build pipeline; strict typing of a 1470-LOC canvas renderer with
// dense cross-chunk THEME/state surface would inflate PR scope without
// catching real bugs (the JS has been production-stable since S40+).
// A follow-up can tighten incrementally.
//
// 2026-05-04 PR 43/45 hotfix lesson preserved: top-level identifiers
// use `var` (matches the original) so cross-file redeclaration in the
// bundle stays tolerated.
// §CHART ═══════════════════════════════════════════════════════════════════════
// ── Lazy Chart.js loader (T1 perf: 65KB gz off initial load) ──
// Chart.js is only needed by custom-charts.js (Chart Builder). Downloaded
// on first use, cached for subsequent calls. All consumers should call
// _ensureChartJs().then(...) before using the Chart constructor.
var _chartJsLoaded = false;
var _chartJsLoadPromise = null;
function _ensureChartJs() {
    if (_chartJsLoaded || typeof Chart !== 'undefined') {
        _chartJsLoaded = true;
        return Promise.resolve();
    }
    if (_chartJsLoadPromise)
        return _chartJsLoadPromise;
    // Squad Performance P2: Chart.js self-hosted at /static/js/vendor/ to
    // eliminate the jsdelivr CDN SPOF (and the resulting "Charts unavailable"
    // user-visible failure mode noted in earlier user reports).
    _chartJsLoadPromise = new Promise(function (resolve, reject) {
        var s = document.createElement('script');
        s.src = '/static/js/vendor/chart.umd.min.js?v=4.4.7';
        s.onload = function () { _chartJsLoaded = true; resolve(); };
        s.onerror = function () { reject(new Error('Chart.js failed to load')); };
        document.head.appendChild(s);
    });
    return _chartJsLoadPromise;
}
// Private state (only used within chart-engine.js):
//   _chartRendering, activeIndicators, SMA_COLORS, chartOverlay, _chartPeriodDebounce
var _chartRendering = false;
// Provenance for the NEXT draw only (e.g. 'Local data'). It rides the stats
// line, so a resize redraw keeps it and the stats line stays visible -- the
// caption used to REPLACE the stats line until the next redraw replaced it.
var _comboSourceNote = '';
function renderComboChart(prices, volumes, dates, avgVolume, unusualFlags, ohlc) {
    if (_chartRendering) {
        _comboSourceNote = '';
        return;
    } // prevent concurrent renders (and drop a caption meant for this draw)
    _chartRendering = true;
    try {
        return _renderComboChartInner(prices, volumes, dates, avgVolume, unusualFlags, ohlc);
    }
    finally {
        _chartRendering = false;
    }
}
// Show chart empty state as overlay (preserves canvas for future renders)
function _showChartEmptyState(container, msg, desc) {
    _hideChartEmptyState(container);
    // Hide canvas but don't destroy it
    var canvas = container.querySelector('#combo-canvas');
    if (canvas)
        canvas.style.display = 'none';
    var overlay = document.createElement('div');
    // .chart-empty-overlay is the JS marker (queried for removal on redraw);
    // styling now rides the canonical OLEmpty markup (DESIGN audit P1-5).
    overlay.className = 'chart-empty-overlay';
    overlay.innerHTML = OLEmpty.render({
        icon: '<svg width="48" height="48" viewBox="0 0 48 48" fill="none">'
            + '<rect x="8" y="32" width="6" height="8" rx="1" fill="var(--text-muted)" opacity="0.3"/>'
            + '<rect x="18" y="24" width="6" height="16" rx="1" fill="var(--text-muted)" opacity="0.4"/>'
            + '<rect x="28" y="16" width="6" height="24" rx="1" fill="var(--text-muted)" opacity="0.5"/>'
            + '<rect x="38" y="8" width="6" height="32" rx="1" fill="var(--text-muted)" opacity="0.3"/>'
            + '<line x1="4" y1="42" x2="48" y2="42" stroke="var(--text-muted)" stroke-width="1" opacity="0.3"/>'
            + '</svg>',
        title: msg || 'No chart data',
        body: desc || 'Try a different time period',
    });
    container.appendChild(overlay);
}
function _hideChartEmptyState(container) {
    if (!container)
        return;
    var old = container.querySelector('.chart-empty-overlay');
    if (old)
        old.remove();
    var canvas = container.querySelector('#combo-canvas');
    if (canvas)
        canvas.style.display = '';
}
// ── QA-6 (2026-10-04 prod QA): every draw is sliced to the SELECTED period ──
// The 5D button was active on load while the chart drew ~6 months ("124
// sessions", Apr-Sep axis): the provider path has no intraday bars for 5D, so
// the local fallback drew its whole 365-day series, and the ticker snapshot's
// sparkline re-render drew its own window whatever button was active. Slicing
// here, at the one entry every caller of the #combo-canvas chart goes through,
// makes the drawn window, the active button and the stats line agree.
// Calendar windows are measured back from the series' LAST bar, so a weekend
// or a stale store never empties the window.
var _OL_PERIOD_WINDOW_DAYS = {
    '1m': 30, '1mo': 30, '3m': 90, '3mo': 90, '6m': 180, '6mo': 180,
    '1y': 365, '2y': 730, '5y': 1825, '10y': 3650, '20y': 7300,
};
function _olIsIntradayStamp(d) {
    return typeof d === 'string' && /[ T]\d{2}:\d{2}/.test(d);
}
// Pure: returns the series cut to `period`, plus `intradayUnavailable` when the
// period needs intraday bars (1D) and only daily bars exist. Unknown periods,
// 'max', and series without one date per bar are returned as given.
function _olSliceSeriesToPeriod(series, period) {
    var prices = series.prices;
    var n = Array.isArray(prices) ? prices.length : 0;
    var dates = series.dates;
    var out = {
        prices: prices, volumes: series.volumes, dates: dates, ohlc: series.ohlc,
        unusualFlags: series.unusualFlags, intraday: false, intradayUnavailable: false,
    };
    if (!period || n < 1 || !Array.isArray(dates) || dates.length !== n)
        return out;
    var intraday = _olIsIntradayStamp(dates[n - 1]);
    out.intraday = intraday;
    var day = function (d) { return String(d || '').slice(0, 10); };
    var lastDay = day(dates[n - 1]);
    var start = 0;
    if (period === '1d') {
        if (!intraday) {
            out.intradayUnavailable = true;
            out.prices = [];
            out.volumes = [];
            out.dates = [];
            out.ohlc = null;
            out.unusualFlags = null;
            return out;
        }
        start = n - 1;
        while (start > 0 && day(dates[start - 1]) === lastDay)
            start--;
    }
    else if (period === '5d') {
        if (intraday) {
            var seen = 1;
            start = n - 1;
            while (start > 0) {
                if (day(dates[start - 1]) !== day(dates[start])) {
                    if (seen === 5)
                        break;
                    seen++;
                }
                start--;
            }
        }
        else {
            start = Math.max(0, n - 5);
        }
    }
    else if (period === 'ytd') {
        var jan1 = lastDay.slice(0, 4) + '-01-01';
        while (start < n - 1 && day(dates[start]) < jan1)
            start++;
    }
    else if (_OL_PERIOD_WINDOW_DAYS[period]) {
        var lastMs = Date.parse(lastDay + 'T00:00:00Z');
        if (isNaN(lastMs))
            return out;
        var cutoff = new Date(lastMs - _OL_PERIOD_WINDOW_DAYS[period] * 86400000).toISOString().slice(0, 10);
        while (start < n - 1 && day(dates[start]) < cutoff)
            start++;
    }
    else {
        return out; // 'max' or an unknown period: draw what was fetched
    }
    if (start <= 0)
        return out;
    var cut = function (arr) { return (Array.isArray(arr) && arr.length === n) ? arr.slice(start) : null; };
    out.prices = prices.slice(start);
    out.volumes = cut(series.volumes);
    out.dates = dates.slice(start);
    out.ohlc = cut(series.ohlc);
    out.unusualFlags = cut(series.unusualFlags);
    return out;
}
function _renderComboChartInner(prices, volumes, dates, avgVolume, unusualFlags, ohlc) {
    var _sourceNote = _comboSourceNote;
    _comboSourceNote = '';
    var _period = (typeof tickerChartPeriod !== 'undefined') ? tickerChartPeriod : null;
    var _tk = (typeof activeTicker !== 'undefined') ? activeTicker : null;
    var _isIntraday = false;
    if (prices && prices.length >= 2) {
        var _cut = _olSliceSeriesToPeriod({ prices: prices, volumes: volumes, dates: dates, ohlc: ohlc, unusualFlags: unusualFlags }, _period);
        // A late daily-bar draw (the snapshot sparkline re-render) must not replace
        // an intraday 1D/5D chart already on screen for this ticker.
        if ((_period === '1d' || _period === '5d') && !_cut.intraday && chartDisplayData &&
            chartDisplayData.intraday && chartDisplayData.ticker === _tk &&
            chartDisplayData.period === _period) {
            return;
        }
        var _canvasEl = document.getElementById('combo-canvas');
        var _infoEl = document.getElementById('chart-info-label');
        if (_cut.intradayUnavailable || _cut.prices.length < 2) {
            // Honest note instead of a chart: never draw a window other than the
            // selected one. The overlay keeps the canvas (feedback_never_destroy_dom).
            chartDisplayData = null;
            if (_infoEl)
                _infoEl.textContent = '';
            if (_canvasEl && _canvasEl.parentElement) {
                if (_cut.intradayUnavailable) {
                    _showChartEmptyState(_canvasEl.parentElement, 'No intraday prices for 1D', 'Only daily closes are available' + (_tk ? ' for ' + _tk : '') + ' — choose 5D or longer');
                }
                else {
                    _showChartEmptyState(_canvasEl.parentElement, 'Not enough price history for this period', 'Try a longer period');
                }
            }
            return;
        }
        prices = _cut.prices;
        volumes = _cut.volumes;
        dates = _cut.dates;
        ohlc = _cut.ohlc;
        unusualFlags = _cut.unusualFlags;
        _isIntraday = _cut.intraday;
    }
    // Issue 8: When no price chart data, try annual financials fallback before showing empty state
    if (!prices || prices.length < 2) {
        var chartEl = document.getElementById('combo-canvas');
        if (chartEl && chartEl.parentElement) {
            var _ticker = typeof activeTicker !== 'undefined' ? activeTicker : null;
            var titleEl = document.getElementById('ticker-chart-title');
            if (_ticker && titleEl) {
                _tryAnnualFinancialsFallback(_ticker, chartEl.parentElement, titleEl);
            }
            else {
                var _td = typeof getData === 'function' && _ticker ? getData(_ticker) : null;
                var _degraded = _td && _td._provider_degraded;
                var _stillPolling = _ticker && typeof phasePollingTimers !== 'undefined' && phasePollingTimers[_ticker];
                var _chartMsg = 'No chart data for this period';
                var _chartDesc = 'Try a different time period or check if the market is open';
                if (_stillPolling) {
                    _chartMsg = 'Loading price history\u2026';
                    _chartDesc = 'Waiting for market data provider';
                }
                else if (_degraded) {
                    _chartMsg = 'Chart data unavailable \u2014 ' + (_td._source || 'data provider') + ' degraded';
                }
                else if (_td && _td.dataPhase === 2) {
                    _chartMsg = 'Price history unavailable';
                    _chartDesc = 'No price data returned from any provider';
                }
                _showChartEmptyState(chartEl.parentElement, _chartMsg, _chartDesc);
            }
        }
        return;
    }
    // Clear any empty state overlay before drawing
    var _chartBox = document.getElementById('combo-canvas');
    if (_chartBox && _chartBox.parentElement)
        _hideChartEmptyState(_chartBox.parentElement);
    chartDisplayData = { prices, volumes, dates, avgVolume, unusualFlags, ohlc: ohlc || null,
        intraday: _isIntraday, ticker: _tk, period: _period, sourceNote: _sourceNote };
    // UX-N6: restore zoom intent from sessionStorage (fractional bounds carry
    // across tickers / periods). Falls back to fully-zoomed-out on miss.
    var _restored = (typeof _restoreViewportFraction === 'function' && prices)
        ? _restoreViewportFraction(prices.length) : null;
    if (_restored) {
        chartViewport = _restored;
    }
    else {
        chartViewport = { startIdx: 0, endIdx: prices ? prices.length - 1 : -1 };
    }
    const canvas = document.getElementById('combo-canvas');
    if (canvas)
        drawComboChart(canvas, prices, volumes, dates, avgVolume, unusualFlags);
    // A11y data-table sibling now emitted from inside drawComboChart's render
    // path (UX-1) — covers viewport zoom/pan redraws too. The legacy
    // addChartAccessibility call here referenced a non-existent `combo-chart`
    // element id and quietly did nothing; removed in 4d7dfba2 follow-up.
}
function _getViewportSlice() {
    // 2026-06-09: guard on Array.isArray, not truthiness. A truthy-but-non-array
    // `prices`/`volumes`/etc. (e.g. a malformed payload or a stale chartDisplayData
    // left over from a prior ticker view, fired by a leftover canvas resize/redraw)
    // made `all.volumes.slice(...)` throw `…slice is not a function` on every
    // _redrawCombo. Array-check each series so a bad field degrades to null
    // instead of throwing.
    if (!chartDisplayData || !Array.isArray(chartDisplayData.prices) || !chartDisplayData.prices.length)
        return null;
    const all = chartDisplayData;
    const total = all.prices.length;
    let s = Math.max(0, chartViewport.startIdx);
    let e = chartViewport.endIdx < 0 ? total - 1 : Math.min(chartViewport.endIdx, total - 1);
    if (e - s < 9) { // minimum 10 candles
        const mid = Math.floor((s + e) / 2);
        s = Math.max(0, mid - 4);
        e = Math.min(total - 1, s + 9);
        s = Math.max(0, e - 9);
    }
    return {
        prices: all.prices.slice(s, e + 1),
        volumes: Array.isArray(all.volumes) ? all.volumes.slice(s, e + 1) : null,
        dates: Array.isArray(all.dates) ? all.dates.slice(s, e + 1) : null,
        ohlc: Array.isArray(all.ohlc) ? all.ohlc.slice(s, e + 1) : null,
        unusualFlags: Array.isArray(all.unusualFlags) ? all.unusualFlags.slice(s, e + 1) : null,
        avgVolume: all.avgVolume,
        startIdx: s, endIdx: e, totalLen: total
    };
}
function drawComboChart(canvas, prices, volumes, dates, avgVolume, unusualFlags) {
    if (!prices || prices.length < 2)
        return;
    const ctx = canvas.getContext('2d');
    const dpr = window.devicePixelRatio || 1;
    const rect = canvas.parentElement;
    const w = rect.clientWidth - 16;
    if (w <= 0) {
        canvas._retryCount = (canvas._retryCount || 0) + 1;
        if (canvas._retryCount < 20 && document.contains(canvas))
            setTimeout(() => {
                if (document.contains(canvas))
                    drawComboChart(canvas, prices, volumes, dates, avgVolume, unusualFlags);
            }, 200);
        return;
    }
    canvas._retryCount = 0;
    // Apply viewport slicing for zoom/pan
    const vp = _getViewportSlice();
    const vPrices = vp ? vp.prices : prices;
    const vVolumes = vp ? vp.volumes : volumes;
    const vDates = vp ? vp.dates : dates;
    const vOhlc = vp ? vp.ohlc : (chartDisplayData && chartDisplayData.ohlc);
    const vUnusual = vp ? vp.unusualFlags : unusualFlags;
    const h = 240;
    canvas.width = w * dpr;
    canvas.height = h * dpr;
    canvas.style.width = w + 'px';
    canvas.style.height = h + 'px';
    ctx.scale(dpr, dpr);
    ctx.clearRect(0, 0, w, h);
    const hasAnnotations = chartAnnotations && ((chartAnnotations.earnings && chartAnnotations.earnings.length) || (chartAnnotations.dividends && chartAnnotations.dividends.length));
    const pad = { top: hasAnnotations ? 18 : 10, bottom: 22, left: 52, right: 8 };
    const cw = w - pad.left - pad.right;
    const fullH = h - pad.top - pad.bottom;
    // Volume occupies bottom 20% of chart area
    const volZoneH = fullH * 0.20;
    const priceZoneH = fullH * 0.75;
    const priceBottom = pad.top + priceZoneH;
    const volTop = h - pad.bottom - volZoneH;
    const n = vPrices.length;
    // EW-PARTIAL-13c: volume bars are toggleable. Default-on behavior is
    // preserved: the bars draw unless `activeIndicators.volume === false`
    // (set by the user clicking the VOL button when it was previously on).
    // First-time users see volume bars exactly as before.
    const _showVolume = activeIndicators.volume !== false;
    const hasVol = vVolumes && vVolumes.length >= n && _showVolume;
    // ── Volume bars (draw first, behind price line) ────────────────────
    let volMax = 0;
    if (hasVol) {
        volMax = vVolumes.reduce((a, b) => a > b ? a : b, -Infinity);
        const avg = avgVolume || (vVolumes.reduce((a, b) => a + b, 0) / vVolumes.length);
        const barW = Math.max(1, (cw / n) * 0.8);
        vVolumes.forEach((v, i) => {
            const x = pad.left + ((i + 0.5) / n) * cw - barW / 2;
            const barH = volMax > 0 ? (v / volMax) * volZoneH : 0;
            const y = h - pad.bottom - barH;
            const isUnusual = vUnusual ? vUnusual[i] : (v >= avg * 2);
            ctx.fillStyle = isUnusual ? THEME.volUnusual : THEME.volNormal;
            ctx.fillRect(x, y, barW, barH);
        });
        // Avg volume line
        if (avg > 0 && volMax > 0) {
            const avgY = h - pad.bottom - (avg / volMax) * volZoneH;
            if (avgY >= volTop && avgY <= h - pad.bottom) {
                ctx.strokeStyle = THEME.avgVolLine;
                ctx.lineWidth = 1;
                ctx.setLineDash([3, 3]);
                ctx.beginPath();
                ctx.moveTo(pad.left, avgY);
                ctx.lineTo(pad.left + cw, avgY);
                ctx.stroke();
                ctx.setLineDash([]);
            }
        }
        // Volume label
        ctx.fillStyle = THEME.chartSub;
        ctx.font = '10px Consolas, monospace';
        ctx.textAlign = 'left';
        ctx.fillText('VOL', pad.left + 2, volTop + 10);
    }
    // ── Determine price range ──────────────────────────────────────────
    var _ohlcValid = vOhlc && vOhlc.length === n && vOhlc.some(function (b) { return b && b.o != null && b.h != null && b.l != null; });
    var useCandlestick = chartMode === 'candle' && _ohlcValid;
    var pMin, pMax;
    if (useCandlestick) {
        pMin = vOhlc.reduce(function (a, bar) { return bar && bar.l != null ? Math.min(a, bar.l) : a; }, Infinity);
        pMax = vOhlc.reduce(function (a, bar) { return bar && bar.h != null ? Math.max(a, bar.h) : a; }, -Infinity);
    }
    else {
        pMin = vPrices.reduce((a, b) => a < b ? a : b, Infinity);
        pMax = vPrices.reduce((a, b) => a > b ? a : b, -Infinity);
    }
    // Add 2% margin to price range
    const margin = (pMax - pMin) * 0.02 || 0.01;
    pMin -= margin;
    pMax += margin;
    const pRange = pMax - pMin || 1;
    const isUp = vPrices[n - 1] >= vPrices[0];
    // ── Grid lines (price zone) with price labels on Y axis ────────────
    ctx.strokeStyle = THEME.gridLine;
    ctx.lineWidth = 1;
    const gridLines = 5;
    for (let i = 0; i <= gridLines; i++) {
        const y = pad.top + (priceZoneH * i / gridLines);
        ctx.beginPath();
        ctx.moveTo(pad.left, y);
        ctx.lineTo(w - pad.right, y);
        ctx.stroke();
        // Y-axis price label
        const price = pMax - (i / gridLines) * pRange;
        ctx.fillStyle = THEME.chartLabel;
        ctx.font = '10px Consolas, monospace';
        ctx.textAlign = 'right';
        ctx.fillText('$' + price.toFixed(2), pad.left - 4, y + 3);
    }
    // ── Price rendering (line or candlestick) ───────────────────────────
    if (useCandlestick) {
        const barSpacing = cw / n;
        const bodyW = Math.max(1, Math.min(barSpacing * 0.7, 12));
        const wickW = Math.max(1, Math.min(bodyW * 0.15, 2));
        vOhlc.forEach(function (bar, i) {
            if (!bar || bar.o == null || bar.h == null || bar.l == null || bar.c == null)
                return;
            var cx = pad.left + ((i + 0.5) / n) * cw;
            var oY = pad.top + priceZoneH - ((bar.o - pMin) / pRange) * priceZoneH;
            var cY = pad.top + priceZoneH - ((bar.c - pMin) / pRange) * priceZoneH;
            var hY = pad.top + priceZoneH - ((bar.h - pMin) / pRange) * priceZoneH;
            var lY = pad.top + priceZoneH - ((bar.l - pMin) / pRange) * priceZoneH;
            var bullish = bar.c >= bar.o;
            const color = bullish ? THEME.green : THEME.red;
            // Wick
            ctx.strokeStyle = color;
            ctx.lineWidth = wickW;
            ctx.beginPath();
            ctx.moveTo(cx, hY);
            ctx.lineTo(cx, lY);
            ctx.stroke();
            // Body
            const bodyTop = Math.min(oY, cY);
            const bodyH = Math.max(1, Math.abs(oY - cY));
            if (bullish) {
                // Hollow body for up candles (outline only)
                ctx.strokeStyle = color;
                ctx.lineWidth = 1;
                ctx.strokeRect(cx - bodyW / 2, bodyTop, bodyW, bodyH);
                ctx.fillStyle = 'rgba(212,184,92,0.15)'; // gold gain-area fill (was banned green)
                ctx.fillRect(cx - bodyW / 2, bodyTop, bodyW, bodyH);
            }
            else {
                ctx.fillStyle = color;
                ctx.fillRect(cx - bodyW / 2, bodyTop, bodyW, bodyH);
            }
        });
    }
    else {
        // ── Line + gradient rendering ──
        // #49 (2026-07-06 OWNER brand note): the price line was direction-colored
        // (gain-gold / loss-coral) — a coral line reads "down/bad" for the whole
        // series even when it rises, and red is reserved for nothing in brand v2.
        // Neutral chart ink (--chart-primary, same family as the sparklines);
        // direction still reads from the change chip + axis values.
        ctx.strokeStyle = THEME.blue;
        ctx.lineWidth = 2;
        ctx.beginPath();
        vPrices.forEach((p, i) => {
            const x = pad.left + ((i + 0.5) / n) * cw;
            const y = pad.top + priceZoneH - ((p - pMin) / pRange) * priceZoneH;
            i === 0 ? ctx.moveTo(x, y) : ctx.lineTo(x, y);
        });
        ctx.stroke();
        const lastX = pad.left + ((n - 0.5) / n) * cw;
        const firstX = pad.left + (0.5 / n) * cw;
        ctx.lineTo(lastX, priceBottom);
        ctx.lineTo(firstX, priceBottom);
        ctx.closePath();
        const grad = ctx.createLinearGradient(0, pad.top, 0, priceBottom);
        grad.addColorStop(0, THEME.accentAlpha); // #49: neutral fill under the neutral line
        grad.addColorStop(1, 'rgba(0,0,0,0)');
        ctx.fillStyle = grad;
        ctx.fill();
    }
    // ── Date labels ────────────────────────────────────────────────────
    if (vDates && vDates.length > 1) {
        ctx.fillStyle = THEME.muted;
        ctx.textAlign = 'center';
        ctx.font = '10px Consolas, monospace';
        const isIntraday = vDates[0] && vDates[0].includes(' ');
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        const labelCount = Math.min(7, n);
        const step = Math.max(1, Math.floor(n / labelCount));
        for (let i = 0; i < n; i += step) {
            const x = pad.left + ((i + 0.5) / n) * cw;
            let label = '';
            if (vDates[i]) {
                if (isIntraday) {
                    label = vDates[i].slice(11);
                }
                else {
                    const parts = vDates[i].split('-');
                    const mon = months[parseInt(parts[1], 10) - 1] || parts[1];
                    const day = parts[2];
                    const yr = parts[0].slice(2);
                    label = n <= 60 ? `${mon} ${day}` : `${mon} '${yr}`;
                }
            }
            // 2026-10-05 prod QA (390px): a centre-aligned label at the first or
            // last tick hung half off the canvas ("Sep '2" cut at the right edge).
            // Clamp the centre so the whole label stays inside [0, w].
            const _halfW = ctx.measureText(label).width / 2;
            const _labelX = Math.min(Math.max(x, _halfW + 1), w - _halfW - 1);
            ctx.fillText(label, _labelX, h - 4);
        }
    }
    // ── Info label ─────────────────────────────────────────────────────
    // QA-6: AVG VOL describes the DRAWN window. The caller's avgVolume (the
    // provider's trailing average) is only the fallback when the window carries
    // no volume at all.
    const _winVolSum = (vVolumes && vVolumes.length) ? vVolumes.reduce((a, b) => a + (b || 0), 0) : 0;
    const avg = _winVolSum > 0 ? _winVolSum / vVolumes.length : (avgVolume || 0);
    const totalPts = chartDisplayData ? chartDisplayData.prices.length : n;
    const _srcNote = (chartDisplayData && chartDisplayData.sourceNote) ? ` | ${chartDisplayData.sourceNote}` : '';
    const zoomInfo = (vp && n < totalPts) ? ` | ZOOM ${n}/${totalPts}` : '';
    const _chartInfoLabel = document.getElementById('chart-info-label');
    // 2026-05-20 OWNER prod-QA #230: "${n} pts" was ambiguous (looks
    // like "262 points" — price points? S&P move? chart data points?).
    // Each n IS one trading session of OHLC data on the chart, so
    // "sessions" is unambiguous and term-of-art for daily-resolution
    // candles. Singular: "1 session". Same shape, clearer meaning.
    const _sessionLbl = n === 1 ? 'session' : 'sessions';
    if (_chartInfoLabel)
        _chartInfoLabel.textContent =
            `LOW $${(pMin + margin).toFixed(2)} | HIGH $${(pMax - margin).toFixed(2)} | ${n} ${_sessionLbl}${zoomInfo} | AVG VOL ${fmtVol(Math.round(avg))}${_srcNote}`;
    // Store chart data for hover interaction
    canvas._chartData = { prices: vPrices, volumes: vVolumes, dates: vDates, ohlc: vOhlc, pad, cw, n, pMin, pMax, pRange, priceZoneH, volZoneH, volMax, w, h, unusualFlags: vUnusual };
    // ── Chart Annotations: earnings dates and ex-dividend dates ────────
    if (vDates && vDates.length > 1 && chartAnnotations) {
        const chartStart = vDates[0];
        const chartEnd = vDates[vDates.length - 1];
        function _annotX(dateStr) {
            let idx = vDates.indexOf(dateStr);
            if (idx >= 0)
                return pad.left + ((idx + 0.5) / n) * cw;
            if (dateStr < chartStart || dateStr > chartEnd)
                return null;
            for (let i = 0; i < vDates.length; i++) {
                if (vDates[i] >= dateStr) {
                    idx = i;
                    break;
                }
            }
            if (idx < 0)
                return null;
            return pad.left + ((idx + 0.5) / n) * cw;
        }
        ctx.save();
        ctx.font = '9px Consolas, monospace';
        ctx.textAlign = 'center';
        (chartAnnotations.earnings || []).forEach(e => {
            const x = _annotX(e.date);
            if (x == null)
                return;
            ctx.strokeStyle = e.beat === true ? THEME.green : e.beat === false ? THEME.red : THEME.muted;
            ctx.lineWidth = 1;
            ctx.setLineDash([3, 3]);
            ctx.beginPath();
            ctx.moveTo(x, pad.top);
            ctx.lineTo(x, priceBottom);
            ctx.stroke();
            ctx.setLineDash([]);
            ctx.fillStyle = ctx.strokeStyle;
            ctx.fillText('E', x, pad.top - 1);
        });
        (chartAnnotations.dividends || []).forEach(dv => {
            const x = _annotX(dv.date);
            if (x == null)
                return;
            ctx.strokeStyle = THEME.blue;
            ctx.lineWidth = 1;
            ctx.setLineDash([3, 3]);
            ctx.beginPath();
            ctx.moveTo(x, pad.top);
            ctx.lineTo(x, priceBottom);
            ctx.stroke();
            ctx.setLineDash([]);
            ctx.fillStyle = THEME.blue;
            ctx.fillText('D', x, pad.top - 1);
        });
        ctx.restore();
    }
    // Draw SMA overlays and RSI sub-chart if toggled
    if (typeof drawIndicatorOverlays === 'function')
        drawIndicatorOverlays();
    if (typeof drawRSISubChart === 'function')
        drawRSISubChart();
    if (typeof drawMACDSubChart === 'function')
        drawMACDSubChart();
    // UX-1: a11y data-table sibling on every render (zoom/pan retain it).
    if (typeof tagCanvasA11y === 'function') {
        var direction = vPrices && vPrices.length >= 2
            ? (vPrices[vPrices.length - 1] >= vPrices[0] ? 'trending up' : 'trending down')
            : '';
        var series = [{ label: 'Date', values: vDates || [] }];
        series.push({ label: 'Price', values: vPrices, format: 'price' });
        if (hasVol)
            series.push({ label: 'Volume', values: vVolumes });
        tagCanvasA11y(canvas, {
            label: 'Price and volume chart' + (direction ? ', ' + direction : ''),
            series: series
        });
    }
}
// ── CHART INDICATOR TOGGLES (SMA / RSI overlays) ──
var activeIndicators = OLStorage.get('activeIndicators', {});
// activeIndicators: { sma20: true/false, sma50: true/false, sma200: true/false, rsi: true/false }
var SMA_COLORS = { get sma20() { return THEME.sma20; }, get sma50() { return THEME.sma50; }, get sma200() { return THEME.sma200; } };
function toggleIndicator(name) {
    // Volume defaults to ON. The activeIndicators object stores `false` only
    // when the user has explicitly hidden it. First click flips ON→false;
    // second flip clears the key entirely (which the renderer treats as ON).
    if (name === 'volume') {
        if (activeIndicators.volume === false) {
            delete activeIndicators.volume; // back to default-on
        }
        else {
            activeIndicators.volume = false; // explicit hide
        }
    }
    else {
        activeIndicators[name] = !activeIndicators[name];
    }
    OLStorage.set('activeIndicators', activeIndicators);
    // Update button active state — volume's "active" reflects ON, not the
    // existence of a truthy value (since ON is the default-no-key state).
    const btn = document.querySelector(`.ind-toggle-btn[data-ind="${name}"]`);
    if (btn) {
        const isActive = name === 'volume'
            ? activeIndicators.volume !== false
            : !!activeIndicators[name];
        btn.classList.toggle('active', isActive);
    }
    // Show/hide RSI sub-chart container
    if (name === 'rsi') {
        const wrap = document.getElementById('rsi-canvas-wrap');
        if (wrap)
            wrap.classList.toggle('d-none', !activeIndicators.rsi);
    }
    // Show/hide MACD sub-chart container (EW-PARTIAL-13b)
    if (name === 'macd') {
        const wrap = document.getElementById('macd-canvas-wrap');
        if (wrap)
            wrap.classList.toggle('d-none', !activeIndicators.macd);
    }
    _redrawCombo();
}
function loadIndicatorState() {
    Object.keys(activeIndicators).forEach(name => {
        const btn = document.querySelector(`.ind-toggle-btn[data-ind="${name}"]`);
        if (btn && activeIndicators[name])
            btn.classList.add('active');
    });
    // Volume button's persistent state — hide its `active` class if the user
    // explicitly turned volume bars off in a prior session.
    if (activeIndicators.volume === false) {
        const volBtn = document.querySelector('.ind-toggle-btn[data-ind="volume"]');
        if (volBtn)
            volBtn.classList.remove('active');
    }
    if (activeIndicators.rsi) {
        const wrap = document.getElementById('rsi-canvas-wrap');
        if (wrap)
            wrap.classList.remove('d-none');
    }
    if (activeIndicators.macd) {
        const wrap = document.getElementById('macd-canvas-wrap');
        if (wrap)
            wrap.classList.remove('d-none');
    }
}
function drawIndicatorOverlays() {
    if (!chartDisplayData || !chartDisplayData.prices)
        return;
    const canvas = document.getElementById('combo-canvas');
    if (!canvas)
        return;
    const ctx = canvas.getContext('2d');
    const dpr = window.devicePixelRatio || 1;
    const rect = canvas.parentElement;
    const w = rect.clientWidth - 16;
    const h = 240;
    const vp = _getViewportSlice();
    const vPrices = vp ? vp.prices : chartDisplayData.prices;
    const n = vPrices.length;
    const hasAnnotations = chartAnnotations && ((chartAnnotations.earnings && chartAnnotations.earnings.length) || (chartAnnotations.dividends && chartAnnotations.dividends.length));
    const pad = { top: hasAnnotations ? 18 : 10, bottom: 22, left: 52, right: 8 };
    const cw = w - pad.left - pad.right;
    const fullH = h - pad.top - pad.bottom;
    const priceZoneH = fullH * 0.75;
    // Determine same price range as drawComboChart
    const useCandlestick = chartMode === 'candle' && vp ? (vp.ohlc && vp.ohlc.length === n) : (chartDisplayData.ohlc && chartDisplayData.ohlc.length === n);
    const vOhlc = vp ? vp.ohlc : chartDisplayData.ohlc;
    let pMin, pMax;
    if (useCandlestick && vOhlc) {
        pMin = vOhlc.reduce((a, bar) => Math.min(a, bar.l), Infinity);
        pMax = vOhlc.reduce((a, bar) => Math.max(a, bar.h), -Infinity);
    }
    else {
        pMin = vPrices.reduce((a, b) => a < b ? a : b, Infinity);
        pMax = vPrices.reduce((a, b) => a > b ? a : b, -Infinity);
    }
    const margin = (pMax - pMin) * 0.02 || 0.01;
    pMin -= margin;
    pMax += margin;
    const pRange = pMax - pMin || 1;
    ctx.save();
    // Draw SMA lines
    ['sma20', 'sma50', 'sma200'].forEach(key => {
        if (!activeIndicators[key])
            return;
        const period = parseInt(key.replace('sma', ''));
        const smaVals = calcSMA(vPrices, period);
        ctx.strokeStyle = SMA_COLORS[key];
        ctx.lineWidth = 1.5;
        ctx.setLineDash([]);
        ctx.beginPath();
        let started = false;
        smaVals.forEach((v, i) => {
            if (v == null)
                return;
            const x = pad.left + ((i + 0.5) / n) * cw;
            const y = pad.top + priceZoneH - ((v - pMin) / pRange) * priceZoneH;
            if (!started) {
                ctx.moveTo(x, y);
                started = true;
            }
            else
                ctx.lineTo(x, y);
        });
        ctx.stroke();
    });
    // EW-PARTIAL-13: Bollinger Bands (20-period, 2-σ). Draw upper + lower
    // as a softer line pair with a low-alpha fill between. Middle band
    // overlaps SMA20 if active so we skip drawing it explicitly.
    if (activeIndicators.bb20 && typeof calcBollinger === 'function') {
        const bb = calcBollinger(vPrices, 20, 2);
        const stroke = (typeof THEME !== 'undefined' && THEME.bollinger) || 'rgba(143,163,184,0.55)';
        const fill = (typeof THEME !== 'undefined' && THEME.bollingerFill) || 'rgba(143,163,184,0.06)';
        // Fill between upper + lower
        ctx.fillStyle = fill;
        ctx.beginPath();
        let fillStarted = false;
        bb.upper.forEach((v, i) => {
            if (v == null)
                return;
            const x = pad.left + ((i + 0.5) / n) * cw;
            const y = pad.top + priceZoneH - ((v - pMin) / pRange) * priceZoneH;
            if (!fillStarted) {
                ctx.moveTo(x, y);
                fillStarted = true;
            }
            else
                ctx.lineTo(x, y);
        });
        for (let i = bb.lower.length - 1; i >= 0; i--) {
            const v = bb.lower[i];
            if (v == null)
                continue;
            const x = pad.left + ((i + 0.5) / n) * cw;
            const y = pad.top + priceZoneH - ((v - pMin) / pRange) * priceZoneH;
            ctx.lineTo(x, y);
        }
        ctx.closePath();
        ctx.fill();
        // Upper + lower band lines
        ctx.strokeStyle = stroke;
        ctx.lineWidth = 1;
        ctx.setLineDash([2, 3]);
        [bb.upper, bb.lower].forEach(arr => {
            ctx.beginPath();
            let started = false;
            arr.forEach((v, i) => {
                if (v == null)
                    return;
                const x = pad.left + ((i + 0.5) / n) * cw;
                const y = pad.top + priceZoneH - ((v - pMin) / pRange) * priceZoneH;
                if (!started) {
                    ctx.moveTo(x, y);
                    started = true;
                }
                else
                    ctx.lineTo(x, y);
            });
            ctx.stroke();
        });
        ctx.setLineDash([]);
    }
    ctx.restore();
}
function drawRSISubChart() {
    if (!activeIndicators.rsi || !chartDisplayData || !chartDisplayData.prices)
        return;
    const canvas = document.getElementById('rsi-canvas');
    if (!canvas)
        return;
    const vp = _getViewportSlice();
    const vPrices = vp ? vp.prices : chartDisplayData.prices;
    const rsiVals = calcRSI(vPrices, 14);
    const ctx = canvas.getContext('2d');
    const dpr = window.devicePixelRatio || 1;
    const rect = canvas.parentElement;
    const w = rect.clientWidth - 16;
    const h = 60;
    canvas.width = w * dpr;
    canvas.height = h * dpr;
    canvas.style.width = w + 'px';
    canvas.style.height = h + 'px';
    ctx.scale(dpr, dpr);
    ctx.clearRect(0, 0, w, h);
    const pad = { top: 4, bottom: 4, left: 52, right: 8 };
    const cw = w - pad.left - pad.right;
    const ch = h - pad.top - pad.bottom;
    const n = vPrices.length;
    // Overbought / oversold zones
    const ob = pad.top + ch - (70 / 100) * ch;
    const os = pad.top + ch - (30 / 100) * ch;
    ctx.fillStyle = 'rgba(231,76,60,0.06)';
    ctx.fillRect(pad.left, pad.top, cw, ob - pad.top);
    ctx.fillStyle = 'rgba(212,184,92,0.06)'; // gold gain-area fill (was banned green)
    ctx.fillRect(pad.left, os, cw, pad.top + ch - os);
    // Reference lines at 30 and 70
    ctx.strokeStyle = THEME.gridLine;
    ctx.lineWidth = 1;
    ctx.setLineDash([3, 3]);
    [30, 50, 70].forEach(level => {
        const y = pad.top + ch - (level / 100) * ch;
        ctx.beginPath();
        ctx.moveTo(pad.left, y);
        ctx.lineTo(pad.left + cw, y);
        ctx.stroke();
    });
    ctx.setLineDash([]);
    // Labels
    ctx.fillStyle = THEME.chartSub;
    ctx.font = '9px Consolas, monospace';
    ctx.textAlign = 'right';
    ctx.fillText('70', pad.left - 4, ob + 3);
    ctx.fillText('30', pad.left - 4, os + 3);
    ctx.fillText('RSI', pad.left - 4, pad.top + ch / 2 + 3);
    // RSI line
    ctx.strokeStyle = THEME.rsiLine;
    ctx.lineWidth = 1.5;
    ctx.beginPath();
    let started = false;
    rsiVals.forEach((v, i) => {
        if (v == null)
            return;
        const x = pad.left + ((i + 0.5) / n) * cw;
        const y = pad.top + ch - (v / 100) * ch;
        if (!started) {
            ctx.moveTo(x, y);
            started = true;
        }
        else
            ctx.lineTo(x, y);
    });
    ctx.stroke();
}
// EW-PARTIAL-13b: MACD sub-chart. Renders to its own #macd-canvas.
// Three series: MACD line (gold), signal line (terracotta), histogram
// bars (gain-tinted on positive, loss-tinted on negative). Zero line
// drawn for reference.
function drawMACDSubChart() {
    if (!activeIndicators.macd || !chartDisplayData || !chartDisplayData.prices)
        return;
    if (typeof calcMACD !== 'function')
        return;
    const canvas = document.getElementById('macd-canvas');
    if (!canvas)
        return;
    const vp = _getViewportSlice();
    const vPrices = vp ? vp.prices : chartDisplayData.prices;
    const macdData = calcMACD(vPrices, 12, 26, 9);
    const ctx = canvas.getContext('2d');
    const dpr = window.devicePixelRatio || 1;
    const rect = canvas.parentElement;
    const w = rect.clientWidth - 16;
    const h = 64;
    canvas.width = w * dpr;
    canvas.height = h * dpr;
    canvas.style.width = w + 'px';
    canvas.style.height = h + 'px';
    ctx.scale(dpr, dpr);
    ctx.clearRect(0, 0, w, h);
    const pad = { top: 4, bottom: 4, left: 52, right: 8 };
    const cw = w - pad.left - pad.right;
    const ch = h - pad.top - pad.bottom;
    const n = vPrices.length;
    // Symmetric range across all three series so the zero line sits center.
    let absMax = 0;
    [macdData.macd, macdData.signal, macdData.histogram].forEach(arr => {
        arr.forEach(v => { if (v != null)
            absMax = Math.max(absMax, Math.abs(v)); });
    });
    if (absMax === 0)
        return;
    absMax *= 1.1; // 10% headroom
    const yPos = (v) => pad.top + ch / 2 - (v / absMax) * (ch / 2);
    // Zero line
    ctx.strokeStyle = THEME.gridLine;
    ctx.lineWidth = 1;
    ctx.setLineDash([3, 3]);
    ctx.beginPath();
    ctx.moveTo(pad.left, pad.top + ch / 2);
    ctx.lineTo(pad.left + cw, pad.top + ch / 2);
    ctx.stroke();
    ctx.setLineDash([]);
    // Histogram bars
    const barW = Math.max(1, cw / n - 0.5);
    macdData.histogram.forEach((v, i) => {
        if (v == null)
            return;
        const x = pad.left + ((i + 0.5) / n) * cw - barW / 2;
        const y = yPos(v);
        const zero = pad.top + ch / 2;
        ctx.fillStyle = v >= 0 ? (THEME.greenAlpha || 'rgba(201,169,97,0.35)') : (THEME.redAlpha || 'rgba(200,116,102,0.35)');
        ctx.fillRect(x, Math.min(y, zero), barW, Math.abs(y - zero));
    });
    // MACD line (gold)
    ctx.strokeStyle = THEME.gold || '#c9a84c';
    ctx.lineWidth = 1.4;
    ctx.beginPath();
    let mStarted = false;
    macdData.macd.forEach((v, i) => {
        if (v == null)
            return;
        const x = pad.left + ((i + 0.5) / n) * cw;
        const y = yPos(v);
        if (!mStarted) {
            ctx.moveTo(x, y);
            mStarted = true;
        }
        else
            ctx.lineTo(x, y);
    });
    ctx.stroke();
    // Signal line (terracotta-ish ink)
    ctx.strokeStyle = THEME.red || '#c87466';
    ctx.lineWidth = 1.2;
    ctx.beginPath();
    let sStarted = false;
    macdData.signal.forEach((v, i) => {
        if (v == null)
            return;
        const x = pad.left + ((i + 0.5) / n) * cw;
        const y = yPos(v);
        if (!sStarted) {
            ctx.moveTo(x, y);
            sStarted = true;
        }
        else
            ctx.lineTo(x, y);
    });
    ctx.stroke();
    // Labels
    ctx.fillStyle = THEME.chartSub;
    ctx.font = '9px Consolas, monospace';
    ctx.textAlign = 'right';
    ctx.fillText('MACD', pad.left - 4, pad.top + ch / 2 + 3);
}
// ── CHART INTERACTION (hover, zoom, pan) ──
var chartOverlay = null;
function _redrawCombo() {
    if (!chartDisplayData)
        return;
    const canvas = document.getElementById('combo-canvas');
    if (canvas)
        drawComboChart(canvas, chartDisplayData.prices, chartDisplayData.volumes, chartDisplayData.dates, chartDisplayData.avgVolume, chartDisplayData.unusualFlags);
    // Show/hide reset zoom button
    const resetBtn = document.getElementById('chart-reset-zoom');
    if (resetBtn) {
        const total = chartDisplayData.prices.length;
        const isZoomed = chartViewport.endIdx >= 0 && (chartViewport.endIdx - chartViewport.startIdx + 1) < total;
        resetBtn.classList.toggle('d-none', !isZoomed);
    }
}
var _chartPeriodDebounce = 0;
function setTickerChartPeriod(period) {
    var now = Date.now();
    if (now - _chartPeriodDebounce < 200)
        return; // debounce 200ms
    _chartPeriodDebounce = now;
    tickerChartPeriod = period;
    OLStorage.setString('chartPeriod', period);
    // Reset zoom/pan on period change — different timeframe = explicit fresh
    // intent. Also clear the persisted fraction so the next render doesn't
    // re-apply old zoom (UX-N6 carries zoom across ticker swap, not period).
    chartViewport = { startIdx: 0, endIdx: -1 };
    try {
        OLStorage.removeSession('ol_chart_zoom_frac');
    }
    catch (_e) { }
    // Update active button state
    var btns = document.querySelectorAll('#ticker-period-btns .ind-period-btn');
    btns.forEach(function (b) { b.classList.toggle('active', b.dataset.period === period); });
    // UX-N7: keep URL in sync so shared/bookmarked links carry the period.
    try {
        if (typeof currentView !== 'undefined' && currentView === 'ticker') {
            var sp = new URLSearchParams(window.location.search);
            sp.set('period', period);
            window.history.replaceState({}, '', window.location.pathname + '?' + sp.toString());
        }
    }
    catch (_e) { }
    // Fetch chart directly — don't re-render all panels
    fetchTickerChart(activeTicker, period);
}
function setChartMode(mode) {
    chartMode = 'line'; // Only line mode supported
    OLStorage.setString('chartMode', 'line');
    _redrawCombo();
}
function _updateChartModeButtons() {
    const lineBtn = document.getElementById('chart-mode-line');
    const candleBtn = document.getElementById('chart-mode-candle');
    if (lineBtn)
        lineBtn.classList.toggle('active', chartMode === 'line');
    if (candleBtn)
        candleBtn.classList.toggle('active', chartMode === 'candle');
}
function chartZoom(delta, anchorRatio) {
    // delta > 0 = zoom in, delta < 0 = zoom out
    if (!chartDisplayData || !chartDisplayData.prices)
        return;
    const total = chartDisplayData.prices.length;
    let s = chartViewport.startIdx;
    let e = chartViewport.endIdx < 0 ? total - 1 : chartViewport.endIdx;
    const visible = e - s + 1;
    const zoomAmount = Math.max(1, Math.round(visible * 0.15));
    if (delta > 0) {
        // Zoom in
        if (visible <= 10)
            return;
        const shrinkLeft = Math.round(zoomAmount * anchorRatio);
        const shrinkRight = zoomAmount - shrinkLeft;
        s = Math.min(s + shrinkLeft, e - 9);
        e = Math.max(e - shrinkRight, s + 9);
    }
    else {
        // Zoom out
        if (visible >= total)
            return;
        const growLeft = Math.round(zoomAmount * anchorRatio);
        const growRight = zoomAmount - growLeft;
        s = Math.max(0, s - growLeft);
        e = Math.min(total - 1, e + growRight);
    }
    chartViewport.startIdx = s;
    chartViewport.endIdx = e;
    if (typeof _persistViewportFraction === 'function')
        _persistViewportFraction();
    _redrawCombo();
}
function chartPan(deltaIdx) {
    if (!chartDisplayData || !chartDisplayData.prices)
        return;
    const total = chartDisplayData.prices.length;
    let s = chartViewport.startIdx;
    let e = chartViewport.endIdx < 0 ? total - 1 : chartViewport.endIdx;
    const visible = e - s;
    s += deltaIdx;
    e += deltaIdx;
    if (s < 0) {
        e -= s;
        s = 0;
    }
    if (e > total - 1) {
        s -= (e - total + 1);
        e = total - 1;
    }
    s = Math.max(0, s);
    chartViewport.startIdx = s;
    chartViewport.endIdx = e;
    if (typeof _persistViewportFraction === 'function')
        _persistViewportFraction();
    _redrawCombo();
}
function chartResetZoom() {
    if (!chartDisplayData)
        return;
    chartViewport = { startIdx: 0, endIdx: chartDisplayData.prices.length - 1 };
    try {
        OLStorage.removeSession('ol_chart_zoom_frac');
    }
    catch (_e) { }
    _redrawCombo();
}
// UX-N6: persist zoom intent across ticker switches as a fractional window
// (0..1 of the visible series). Index-based storage would be meaningless
// when the new ticker has a different price-array length; fractional bounds
// preserve "looking at the last 30%" intent across AAPL → MSFT → GOOG.
function _persistViewportFraction() {
    if (!chartDisplayData || !chartDisplayData.prices)
        return;
    var total = chartDisplayData.prices.length;
    if (total < 2)
        return;
    var s = chartViewport.startIdx;
    var e = chartViewport.endIdx < 0 ? total - 1 : chartViewport.endIdx;
    var startFrac = s / (total - 1);
    var endFrac = e / (total - 1);
    // Don't persist a "fully zoomed out" viewport — that's the default state.
    if (startFrac <= 0.001 && endFrac >= 0.999) {
        try {
            OLStorage.removeSession('ol_chart_zoom_frac');
        }
        catch (_e) { }
        return;
    }
    try {
        OLStorage.setSession('ol_chart_zoom_frac', {
            startFrac: startFrac, endFrac: endFrac
        });
    }
    catch (_e) { }
}
function _restoreViewportFraction(total) {
    if (!total || total < 10)
        return null;
    try {
        var raw = OLStorage.getSessionString('ol_chart_zoom_frac', null);
        if (!raw)
            return null;
        var f = JSON.parse(raw);
        if (typeof f.startFrac !== 'number' || typeof f.endFrac !== 'number')
            return null;
        var s = Math.max(0, Math.round(f.startFrac * (total - 1)));
        var e = Math.min(total - 1, Math.round(f.endFrac * (total - 1)));
        if (e - s < 9)
            return null; // sanity: minimum 10 candles
        return { startIdx: s, endIdx: e };
    }
    catch (_e) {
        return null;
    }
}
function exportChartPNG() {
    var canvas = document.querySelector('#chart-panel canvas');
    if (!canvas) {
        if (typeof showToast === 'function')
            showToast('No chart to export', 'error', 2000);
        return;
    }
    var link = document.createElement('a');
    link.download = (activeTicker || 'chart') + '_chart.png';
    link.href = canvas.toDataURL('image/png');
    link.click();
    if (typeof showToast === 'function')
        showToast('Chart exported as PNG', 'success', 2000);
}
function _renderAnnualFinancialsChart(container, annualData) {
    // annualData: array of {fiscal_year, revenue, net_income, ...} sorted desc
    var sorted = annualData.slice().sort(function (a, b) { return a.fiscal_year - b.fiscal_year; });
    // Filter to rows that have at least revenue (allow single-year display)
    sorted = sorted.filter(function (r) { return r.revenue && r.revenue > 0; });
    if (sorted.length < 1)
        return false;
    var years = sorted.map(function (r) { return r.fiscal_year; });
    var revenues = sorted.map(function (r) { return r.revenue || 0; });
    var netIncomes = sorted.map(function (r) { return r.net_income || 0; });
    var hasNetIncome = netIncomes.some(function (v) { return v !== 0; });
    // Create canvas
    var canvas = document.createElement('canvas');
    canvas.id = 'combo-canvas';
    canvas.style.width = '100%';
    canvas.style.height = '100%';
    // (ol/no-innerhtml-on-live-parent OK) Intentional canvas-recreation pattern: clear container, then append fresh canvas (next line). Not an accidental rebuild — this is the canvas constructor. Future refactor: container.replaceChildren() for modern API.
    container.innerHTML = '';
    container.appendChild(canvas);
    // Add label below
    var label = document.createElement('div');
    label.className = 'csp-chart-label';
    label.textContent = 'Annual financials (daily prices unavailable)';
    container.appendChild(label);
    // Size the canvas
    var dpr = window.devicePixelRatio || 1;
    var rect = canvas.getBoundingClientRect();
    var w = rect.width || 400;
    var h = (rect.height || 220) - 20; // leave room for label
    canvas.width = w * dpr;
    canvas.height = h * dpr;
    canvas.style.height = h + 'px';
    var ctx = canvas.getContext('2d');
    ctx.scale(dpr, dpr);
    // Chart geometry
    var pad = { top: 24, right: 16, bottom: 32, left: 72 };
    var cw = w - pad.left - pad.right;
    var ch = h - pad.top - pad.bottom;
    var n = years.length;
    var barW = Math.min(Math.floor(cw / n * 0.35), 28);
    var gap = hasNetIncome ? Math.max(2, Math.floor(barW * 0.15)) : 0;
    // Scale
    var allVals = revenues.concat(hasNetIncome ? netIncomes : []);
    var maxVal = Math.max.apply(null, allVals);
    var minVal = Math.min(0, Math.min.apply(null, allVals));
    var range = maxVal - minVal || 1;
    function yPos(v) { return pad.top + ch - ((v - minVal) / range) * ch; }
    function fmtVal(v) {
        // DS-P2a: canonical K/M/B axis labels (no $), formatting.ts fmtAbbrev.
        return fmtAbbrev(v, { dollars: false });
    }
    // Background
    ctx.fillStyle = 'transparent';
    ctx.fillRect(0, 0, w, h);
    // Grid lines
    ctx.strokeStyle = THEME.gridLine;
    ctx.lineWidth = 1;
    var gridSteps = 4;
    for (var g = 0; g <= gridSteps; g++) {
        var gy = pad.top + (ch / gridSteps) * g;
        ctx.beginPath();
        ctx.moveTo(pad.left, gy);
        ctx.lineTo(pad.left + cw, gy);
        ctx.stroke();
        // Y-axis labels
        var gv = maxVal - (range / gridSteps) * g;
        ctx.fillStyle = THEME.muted;
        ctx.font = '10px Consolas, monospace';
        ctx.textAlign = 'right';
        ctx.fillText('$' + fmtVal(gv), pad.left - 6, gy + 4);
    }
    // Zero line if we have negatives
    if (minVal < 0) {
        var zeroY = yPos(0);
        ctx.strokeStyle = 'rgba(255,255,255,0.15)';
        ctx.setLineDash([3, 3]);
        ctx.beginPath();
        ctx.moveTo(pad.left, zeroY);
        ctx.lineTo(pad.left + cw, zeroY);
        ctx.stroke();
        ctx.setLineDash([]);
    }
    // Draw bars
    for (var i = 0; i < n; i++) {
        var cx = pad.left + (i + 0.5) / n * cw;
        // Revenue bar
        var revH = (revenues[i] / range) * ch;
        var revY = yPos(Math.max(0, revenues[i]));
        ctx.fillStyle = THEME.accent || 'var(--accent-blue)';
        ctx.globalAlpha = 0.85;
        if (hasNetIncome) {
            ctx.fillRect(cx - barW - gap / 2, revY, barW, Math.abs(revH));
        }
        else {
            ctx.fillRect(cx - barW / 2, revY, barW, Math.abs(revH));
        }
        // Net income bar
        if (hasNetIncome) {
            var niVal = netIncomes[i];
            var niY = yPos(Math.max(0, niVal));
            var niH = (Math.abs(niVal) / range) * ch;
            ctx.fillStyle = niVal >= 0 ? (THEME.green || '#c9a961') : (THEME.red || '#c87466'); // canvas: chart-gain/loss hex (var() doesn't resolve in canvas)
            ctx.fillRect(cx + gap / 2, niY, barW, niH);
        }
        ctx.globalAlpha = 1;
        // Year labels
        ctx.fillStyle = THEME.muted;
        ctx.font = '10px Consolas, monospace';
        ctx.textAlign = 'center';
        ctx.fillText(String(years[i]), cx, h - pad.bottom + 14);
    }
    // Legend
    ctx.font = '10px -apple-system, BlinkMacSystemFont, sans-serif';
    ctx.textAlign = 'left';
    var legendX = pad.left + 4;
    var legendY = pad.top - 8;
    ctx.fillStyle = THEME.accent || 'var(--accent-blue)';
    ctx.fillRect(legendX, legendY - 6, 8, 8);
    ctx.fillStyle = THEME.text;
    ctx.fillText('Revenue', legendX + 12, legendY + 1);
    if (hasNetIncome) {
        var niLegendX = legendX + 70;
        ctx.fillStyle = THEME.green || '#c9a961'; // canvas: chart-gain hex
        ctx.fillRect(niLegendX, legendY - 6, 8, 8);
        ctx.fillStyle = THEME.text;
        ctx.fillText('Net Income', niLegendX + 12, legendY + 1);
    }
    return true;
}
async function _tryAnnualFinancialsFallback(ticker, chartContainer, titleEl) {
    try {
        var res = await fetch(SERVER + '/api/company-financials?ticker=' + encodeURIComponent(ticker) + '&years=10', { signal: (typeof getViewAwareSignal === 'function' ? getViewAwareSignal(8000) : AbortSignal.timeout(8000)) });
        if (!res.ok)
            throw new Error('HTTP ' + res.status);
        var data = await res.json();
        if (data && data.annual && data.annual.length >= 1) {
            titleEl.textContent = 'Annual Financials';
            if (_renderAnnualFinancialsChart(chartContainer, data.annual)) {
                return;
            }
        }
    }
    catch (e) { /* @__PURE__ */
        _olDebugWarn('Chart fallback failed for ' + ticker + ':', e);
    }
    // Only show empty state when ALL data sources truly have nothing
    // Use overlay instead of innerHTML replacement to preserve canvas element
    var _emptyMsg = isLive
        ? 'No price or financial data found for ' + ticker
        : 'Server offline \u2014 no cached data for ' + ticker;
    _showChartEmptyState(chartContainer, _emptyMsg, 'This ticker may not be in our database yet');
}
async function _tryLocalPriceHistory(ticker, canvas, titleEl, infoEl, cacheKey, days) {
    // Try local DB price history (/api/price-history over the price_history table).
    // At least a year, so a 1D/5D fallback still finds its last sessions in a
    // store that lags; longer when the selected period asks for more.
    var _lphDays = Math.max(365, days || 0);
    try {
        var phRes = await fetch(SERVER + '/api/price-history?ticker=' + encodeURIComponent(ticker) + '&days=' + _lphDays + '&points=500', { signal: (typeof getViewAwareSignal === 'function' ? getViewAwareSignal(10000) : AbortSignal.timeout(10000)) });
        var phData = await phRes.json();
        if (_chartPriceWithheld(canvas, titleEl, phData))
            return;
        if (phData.history && phData.history.length >= 2) {
            var ph = phData.history;
            var phPrices = ph.map(function (r) { return r.close || r.price || 0; });
            var phVolumes = ph.map(function (r) { return r.volume || 0; });
            var phDates = ph.map(function (r) { return r.date || ''; });
            // QA-6: the caption rides the stats line (renderComboChart slices this
            // series to the selected period); writing it over #chart-info-label
            // used to erase LOW/HIGH/sessions until the next redraw erased it back.
            _comboSourceNote = 'Local data';
            renderComboChart(phPrices, phVolumes, phDates, null, null, null);
            titleEl.textContent = 'Price & Volume';
            return;
        }
    }
    catch (e) { /* fall through */ }
    // Try localStorage cache
    var _cached = OLStorage.get(cacheKey, null);
    if (_cached && _cached.prices && _cached.prices.length >= 2) {
        _comboSourceNote = 'Cached data';
        renderComboChart(_cached.prices, _cached.volumes, _cached.dates, null, null, _cached.ohlc || null);
        titleEl.textContent = 'Price & Volume';
    }
    else {
        titleEl.textContent = 'Price & Volume';
        // (ol/no-innerhtml-on-live-parent OK) Sibling label; clearing to empty string. .textContent='' would also work but innerHTML matches the surrounding pattern.
        if (infoEl)
            infoEl.innerHTML = '';
        var chartContainer = canvas && canvas.parentElement;
        if (chartContainer) {
            // Don't hijack price chart with financial data — financials have their own panel below
            var _emptyMsg = isLive
                ? 'Price history not available for ' + ticker
                : 'Server offline \u2014 no cached price data';
            _showChartEmptyState(chartContainer, _emptyMsg, 'Financial data may still be available below');
        }
    }
}
// OWNER 2026-10-12 (R3 "Cut back display now"): for an anonymous visitor the
// server answers /api/price-history and /api/indicator-history with an empty,
// FLAGGED series. Say why in the chart area and stop -- the other fallbacks
// are withheld the same way, and an empty chart reads as "no data".
function _chartPriceWithheld(canvas, titleEl, data) {
    if (!data || !data._vendor_prices_withheld)
        return false;
    if (titleEl)
        titleEl.textContent = 'Price & Volume';
    var _c = canvas && canvas.parentElement;
    if (_c) {
        _showChartEmptyState(_c, String(data._price_notice || 'Market prices are shown to signed-in users.'), 'Filed financials are still shown below');
    }
    return true;
}
async function fetchTickerChart(ticker, period) {
    const canvas = document.getElementById('combo-canvas');
    const titleEl = document.getElementById('ticker-chart-title');
    const infoEl = document.getElementById('chart-info-label');
    // If server is not live, show offline message in chart area
    if (!isLive) {
        titleEl.textContent = 'Price & Volume';
        // (ol/no-innerhtml-on-live-parent OK) Sibling label clear; offline path before the chart-empty-overlay below handles the canvas itself.
        if (infoEl)
            infoEl.innerHTML = '';
        var chartContainer = canvas && canvas.parentElement;
        if (chartContainer) {
            _showChartEmptyState(chartContainer, 'Server offline \u2014 no cached price data', 'Reconnecting...');
        }
        return;
    }
    // (ol/no-innerhtml-on-live-parent OK) #ticker-chart-title is a sibling of #combo-canvas, not a parent. Skeleton-bar HTML; converting to .textContent would lose the styled placeholder. Future: CSS-only skeleton (refactor task).
    titleEl.innerHTML = '<span class="skel-bar skel-bar-md"></span>';
    var _chartCacheKey = 'ol_chart_' + ticker + '_' + period;
    // Map period to days for local DB query
    var _periodDays = { '1d': 1, '5d': 5, '1m': 30, '1mo': 30, '3m': 90, '3mo': 90, '6m': 180, '6mo': 180, '1y': 365, 'ytd': 365, '5y': 1825, '10y': 3650, '20y': 7300, 'max': 10950 };
    var _days = _periodDays[period] || 365;
    // Range-flip perf: _chartCacheKey was WRITTEN but never READ, so every range
    // flip re-hit the API even for a (ticker, period) just viewed (5Y→1Y→5Y = 3
    // round-trips). Serve a recently-cached series instead. TTL is range-aware:
    // intraday (<=5d) moves fast so 60s; historical daily bars are stable within
    // a session so 5min — both comfortably cover rapid back-and-forth flipping
    // while bounding staleness (the live hero price is sourced separately).
    try {
        var _cached = OLStorage.get(_chartCacheKey, null);
        var _cacheTtlMs = (_days <= 5) ? 60000 : 300000;
        if (_cached && _cached.prices && _cached.prices.length >= 2 &&
            _cached.ts && (Date.now() - _cached.ts) < _cacheTtlMs) {
            renderComboChart(_cached.prices, _cached.volumes, _cached.dates, null, null, _cached.ohlc || null);
            titleEl.textContent = 'Price & Volume';
            return;
        }
    }
    catch (_e) { /* cache miss / parse error — fall through to fetch */ }
    // Primary: local price_history DB (daily data — skip intraday periods)
    if (_days >= 30)
        try {
            var phRes = await fetch(SERVER + '/api/price-history?ticker=' + encodeURIComponent(ticker) + '&days=' + _days + '&points=500', { signal: (typeof getViewAwareSignal === 'function' ? getViewAwareSignal(10000) : AbortSignal.timeout(10000)) });
            var phData = await phRes.json();
            if (_chartPriceWithheld(canvas, titleEl, phData))
                return;
            // #82 (2026-07-06 OWNER capture): COVERAGE GATE. price_history only has
            // full daily sweeps for the S&P snapshot set; off-index tickers carry a
            // handful of on-view record_price rows. The old `length >= 2` accept
            // rendered PJT's 4 May sessions AS the selected 1Y range (LOW/HIGH
            // footer implied the year's range was $152-156 vs the real $127-195) —
            // and then CACHED it under the 1y key. Require the returned series to
            // SPAN at least half the requested window; otherwise fall through to
            // Finnhub/FMP, which fetch the full period. (A young IPO with genuinely
            // short history falls through too and renders the same short series
            // from the fallback — one extra request, never a mislabeled range.)
            var _phCovered = false;
            if (phData.history && phData.history.length >= 2) {
                try {
                    var _phFirst = new Date(phData.history[0].date || 0).getTime();
                    var _phLast = new Date(phData.history[phData.history.length - 1].date || 0).getTime();
                    var _phSpanDays = Math.abs(_phLast - _phFirst) / 86400000;
                    _phCovered = _phSpanDays >= (_days * 0.5);
                }
                catch (_covE) {
                    _phCovered = false;
                }
            }
            if (_phCovered) {
                var ph = phData.history;
                var _phPrices = ph.map(function (r) { return r.close || r.price || 0; });
                var _phVolumes = ph.map(function (r) { return r.volume || 0; });
                var _phDates = ph.map(function (r) { return r.date || ''; });
                renderComboChart(_phPrices, _phVolumes, _phDates, null, null, null);
                titleEl.textContent = 'Price & Volume';
                // Range-flip perf: populate the client cache on the primary (daily) path
                // too — it was only written on the Finnhub fallback, so daily ranges never
                // cached and re-fetched on every flip.
                OLStorage.set(_chartCacheKey, { prices: _phPrices, volumes: _phVolumes, dates: _phDates, ohlc: null, ts: Date.now() });
                return;
            }
        }
        catch (e) { /* fall through to Finnhub */ }
    // Secondary: Finnhub real-time indicator history
    try {
        const res = await fetch(`${SERVER}/api/indicator-history?symbol=${encodeURIComponent(ticker)}&period=${period}`, { signal: (typeof getViewAwareSignal === 'function' ? getViewAwareSignal(15000) : AbortSignal.timeout(15000)) });
        const data = await res.json();
        if (_chartPriceWithheld(canvas, titleEl, data))
            return;
        if (data.prices && data.prices.length >= 2) {
            renderComboChart(data.prices, data.volumes, data.dates, null, null, data.ohlc || null);
            titleEl.textContent = 'Price & Volume';
            OLStorage.set(_chartCacheKey, { prices: data.prices, volumes: data.volumes, dates: data.dates, ohlc: data.ohlc || null, ts: Date.now() });
            return;
        }
    }
    catch (e) { /* fall through */ }
    // Tertiary: localStorage cache → annual financials
    await _tryLocalPriceHistory(ticker, canvas, titleEl, infoEl, _chartCacheKey, _days);
}
function _drawCrosshair(canvas, cd, idx, mouseY) {
    const ctx = canvas.getContext('2d');
    const dpr = window.devicePixelRatio || 1;
    ctx.save();
    ctx.scale(dpr, dpr);
    const xPos = cd.pad.left + ((idx + 0.5) / cd.n) * cd.cw;
    // Vertical crosshair line
    ctx.strokeStyle = THEME.crosshair;
    ctx.lineWidth = 1;
    ctx.setLineDash([2, 2]);
    ctx.beginPath();
    ctx.moveTo(xPos, cd.pad.top);
    ctx.lineTo(xPos, cd.h - cd.pad.bottom);
    ctx.stroke();
    // Horizontal crosshair line (follows mouse Y within price zone)
    const clampY = Math.max(cd.pad.top, Math.min(mouseY, cd.pad.top + cd.priceZoneH));
    ctx.beginPath();
    ctx.moveTo(cd.pad.left, clampY);
    ctx.lineTo(cd.pad.left + cd.cw, clampY);
    ctx.stroke();
    ctx.setLineDash([]);
    // Price label on Y axis (left side). #230 (2026-07-28 OWNER QA): the chip
    // fill was hardcoded near-black while the ink is THEME.text (live CSS var)
    // — dark ink on light theme made the box black-on-black. Both halves now
    // read the theme: elevated-surface chip + primary ink + subtle border.
    const mousePrice = cd.pMax - ((clampY - cd.pad.top) / cd.priceZoneH) * cd.pRange;
    ctx.fillStyle = THEME.panel2;
    ctx.fillRect(0, clampY - 8, cd.pad.left - 2, 16);
    ctx.strokeStyle = THEME.border2;
    ctx.lineWidth = 1;
    ctx.strokeRect(0.5, clampY - 7.5, cd.pad.left - 3, 15);
    ctx.fillStyle = THEME.text;
    ctx.font = '10px Consolas, monospace';
    ctx.textAlign = 'right';
    ctx.fillText('$' + mousePrice.toFixed(2), cd.pad.left - 4, clampY + 4);
    // Date label on X axis (bottom)
    const date = cd.dates ? cd.dates[idx] : '';
    if (date) {
        ctx.textAlign = 'center';
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        let label = date;
        if (date.includes(' ')) {
            label = date.slice(11);
        }
        else {
            const parts = date.split('-');
            const mon = months[parseInt(parts[1], 10) - 1] || parts[1];
            label = `${mon} ${parts[2]}`;
        }
        const labelW = ctx.measureText(label).width + 8;
        ctx.fillStyle = THEME.panel2; // #230: theme-aware chip (see the Y-axis note)
        ctx.fillRect(xPos - labelW / 2, cd.h - cd.pad.bottom + 2, labelW, 16);
        ctx.strokeStyle = THEME.border2;
        ctx.lineWidth = 1;
        ctx.strokeRect(xPos - labelW / 2 + 0.5, cd.h - cd.pad.bottom + 2.5, labelW - 1, 15);
        ctx.fillStyle = THEME.text;
        ctx.fillText(label, xPos, cd.h - cd.pad.bottom + 13);
    }
    // Price dot
    const price = cd.prices[idx];
    const yPrice = cd.pad.top + cd.priceZoneH - ((price - cd.pMin) / cd.pRange) * cd.priceZoneH;
    ctx.fillStyle = THEME.priceDot;
    ctx.beginPath();
    ctx.arc(xPos, yPrice, 4, 0, Math.PI * 2);
    ctx.fill();
    ctx.strokeStyle = 'rgba(255,255,255,0.6)';
    ctx.lineWidth = 1;
    ctx.stroke();
    ctx.restore();
}
// Teardown previous chart listeners before re-init (prevents document-level leaks)
var _chartHoverAbort = null;
function destroyChartHover() {
    if (_chartHoverAbort) {
        _chartHoverAbort.abort();
        _chartHoverAbort = null;
    }
    var c = document.getElementById('combo-canvas');
    if (c)
        c._hoverInitialized = false;
}
function initChartHover() {
    const canvas = document.getElementById('combo-canvas');
    const tooltip = document.getElementById('chart-tooltip');
    if (!canvas || !tooltip)
        return;
    if (canvas._hoverInitialized)
        return; // Prevent duplicate listeners
    canvas._hoverInitialized = true;
    // Accessibility: label the canvas for screen readers
    canvas.setAttribute('role', 'img');
    canvas.setAttribute('aria-label', 'Price chart — use mouse or touch to explore data points');
    // Ensure tooltip is an aria-live region so screen readers announce crosshair data
    tooltip.setAttribute('role', 'status');
    tooltip.setAttribute('aria-live', 'polite');
    tooltip.setAttribute('aria-atomic', 'true');
    // Abort any previous document-level listeners
    if (_chartHoverAbort)
        _chartHoverAbort.abort();
    _chartHoverAbort = new AbortController();
    var _docSignal = { signal: _chartHoverAbort.signal };
    // ── Mouse wheel zoom ──
    canvas.addEventListener('wheel', (e) => {
        e.preventDefault();
        const rect = canvas.getBoundingClientRect();
        const anchorRatio = (e.clientX - rect.left) / rect.width;
        const delta = e.deltaY < 0 ? 1 : -1;
        chartZoom(delta, anchorRatio);
    }, { passive: false });
    // ── Click + drag to pan ──
    canvas.addEventListener('mousedown', (e) => {
        if (e.button !== 0)
            return;
        const cd = canvas._chartData;
        if (!cd)
            return;
        chartPanState = {
            startX: e.clientX,
            origStartIdx: chartViewport.startIdx,
            origEndIdx: chartViewport.endIdx < 0 ? (chartDisplayData ? chartDisplayData.prices.length - 1 : 0) : chartViewport.endIdx
        };
        canvas.style.cursor = 'grabbing';
        e.preventDefault();
    });
    // ── Touch: tap for crosshair, drag to pan, pinch to zoom ──
    var _touchPanState = null;
    var _pinchDist0 = null;
    canvas.addEventListener('touchstart', (e) => {
        if (e.touches.length === 1) {
            var t = e.touches[0];
            _touchPanState = {
                startX: t.clientX, startY: t.clientY,
                origStartIdx: chartViewport.startIdx,
                origEndIdx: chartViewport.endIdx < 0 ? (chartDisplayData ? chartDisplayData.prices.length - 1 : 0) : chartViewport.endIdx,
                moved: false
            };
        }
        else if (e.touches.length === 2) {
            _touchPanState = null;
            var dx = e.touches[0].clientX - e.touches[1].clientX;
            var dy = e.touches[0].clientY - e.touches[1].clientY;
            _pinchDist0 = Math.sqrt(dx * dx + dy * dy);
        }
    }, { passive: true });
    canvas.addEventListener('touchmove', (e) => {
        if (e.touches.length === 1 && _touchPanState) {
            var t = e.touches[0];
            var dx = t.clientX - _touchPanState.startX;
            if (Math.abs(dx) > 5)
                _touchPanState.moved = true;
            if (!_touchPanState.moved)
                return;
            e.preventDefault();
            var cd = canvas._chartData;
            if (!cd)
                return;
            var rect = canvas.getBoundingClientRect();
            var visible = _touchPanState.origEndIdx - _touchPanState.origStartIdx + 1;
            var pxPerBar = rect.width / visible;
            var barsDelta = Math.round(-dx / pxPerBar);
            var total = chartDisplayData ? chartDisplayData.prices.length : visible;
            var s = _touchPanState.origStartIdx + barsDelta;
            var eI = _touchPanState.origEndIdx + barsDelta;
            if (s < 0) {
                eI -= s;
                s = 0;
            }
            if (eI > total - 1) {
                s -= (eI - total + 1);
                eI = total - 1;
            }
            chartViewport.startIdx = Math.max(0, s);
            chartViewport.endIdx = eI;
            _redrawCombo();
        }
        else if (e.touches.length === 2 && _pinchDist0) {
            e.preventDefault();
            var dx2 = e.touches[0].clientX - e.touches[1].clientX;
            var dy2 = e.touches[0].clientY - e.touches[1].clientY;
            var dist = Math.sqrt(dx2 * dx2 + dy2 * dy2);
            var ratio = dist / _pinchDist0;
            if (ratio > 1.15) {
                chartZoom(1, 0.5);
                _pinchDist0 = dist;
            }
            else if (ratio < 0.85) {
                chartZoom(-1, 0.5);
                _pinchDist0 = dist;
            }
        }
    }, { passive: false });
    canvas.addEventListener('touchend', (e) => {
        if (_touchPanState && !_touchPanState.moved && e.changedTouches.length === 1) {
            // Tap = show crosshair at touch point
            var t = e.changedTouches[0];
            var rect = canvas.getBoundingClientRect();
            canvas.dispatchEvent(new MouseEvent('mousemove', { clientX: t.clientX, clientY: t.clientY }));
        }
        _touchPanState = null;
        _pinchDist0 = null;
    }, { passive: true });
    // Document-level listeners use AbortController for cleanup
    document.addEventListener('mousemove', (e) => {
        if (!chartPanState)
            return;
        const cd = canvas._chartData;
        if (!cd)
            return;
        const rect = canvas.getBoundingClientRect();
        const dx = e.clientX - chartPanState.startX;
        const visible = chartPanState.origEndIdx - chartPanState.origStartIdx + 1;
        const pxPerBar = rect.width / visible;
        const barsDelta = Math.round(-dx / pxPerBar);
        const total = chartDisplayData ? chartDisplayData.prices.length : visible;
        let s = chartPanState.origStartIdx + barsDelta;
        let eI = chartPanState.origEndIdx + barsDelta;
        if (s < 0) {
            eI -= s;
            s = 0;
        }
        if (eI > total - 1) {
            s -= (eI - total + 1);
            eI = total - 1;
        }
        s = Math.max(0, s);
        chartViewport.startIdx = s;
        chartViewport.endIdx = eI;
        _redrawCombo();
    }, _docSignal);
    document.addEventListener('mouseup', () => {
        if (chartPanState) {
            chartPanState = null;
            canvas.style.cursor = 'crosshair';
        }
    }, _docSignal);
    // ── Double-click to reset zoom ──
    canvas.addEventListener('dblclick', () => {
        chartResetZoom();
    });
    // ── Mouse move crosshair + tooltip (throttled via rAF to avoid per-pixel redraws) ──
    var _chartHoverRAF = null;
    canvas.addEventListener('mousemove', (e) => {
        if (chartPanState)
            return; // Don't show crosshair while panning
        if (_chartHoverRAF)
            return; // Skip if a frame is already pending
        _chartHoverRAF = requestAnimationFrame(() => {
            _chartHoverRAF = null;
            const cd = canvas._chartData;
            if (!cd)
                return;
            const rect = canvas.getBoundingClientRect();
            const dpr = window.devicePixelRatio || 1;
            const mx = e.clientX - rect.left;
            const my = e.clientY - rect.top;
            // Scale mouse position to canvas coordinates
            const scaleX = cd.w / rect.width;
            const scaleY = cd.h / rect.height;
            const canvasX = mx * scaleX;
            const canvasY = my * scaleY;
            // Map to data index
            const ratio = (canvasX - cd.pad.left) / cd.cw;
            const idx = Math.floor(ratio * cd.n);
            if (idx < 0 || idx >= cd.n) {
                tooltip.classList.add('d-none');
                tooltip.classList.remove('d-block');
                return;
            }
            const price = cd.prices[idx];
            const vol = cd.volumes ? cd.volumes[idx] : null;
            const date = cd.dates ? cd.dates[idx] : '';
            const chg = idx > 0 ? price - cd.prices[idx - 1] : 0;
            const chgPct = idx > 0 && cd.prices[idx - 1] ? (chg / cd.prices[idx - 1] * 100) : 0;
            const sign = chg >= 0 ? '+' : '';
            const chgColor = chg > 0 ? 'var(--text-positive)' : chg < 0 ? 'var(--text-negative)' : 'var(--text-secondary)';
            const chgCls = chg > 0 ? 'color-positive' : chg < 0 ? 'color-negative' : 'color-text-secondary';
            // OHLC details in candlestick mode
            const ohlcBar = cd.ohlc ? cd.ohlc[idx] : null;
            let priceHtml;
            if (chartMode === 'candle' && ohlcBar && ohlcBar.o != null && ohlcBar.h != null) {
                var bullish = ohlcBar.c >= ohlcBar.o;
                var candleCls = bullish ? 'color-positive' : 'color-negative';
                priceHtml =
                    '<div class="tt-price ' + candleCls + '">O $' + Number(ohlcBar.o).toFixed(2) + '  H $' + Number(ohlcBar.h).toFixed(2) + '  L $' + Number(ohlcBar.l).toFixed(2) + '  C $' + Number(ohlcBar.c).toFixed(2) + '</div>' +
                        '<div class="tt-price gainloss-cell"><span class="tt-chg-inline ' + chgCls + '">' + sign + chg.toFixed(2) + ' (' + sign + chgPct.toFixed(2) + '%)</span></div>';
            }
            else {
                priceHtml =
                    '<div class="tt-price gainloss-cell">$' + price.toFixed(2) + ' <span class="tt-chg-inline ' + chgCls + '">' + sign + chg.toFixed(2) + ' (' + sign + chgPct.toFixed(2) + '%)</span></div>';
            }
            // (ol/no-innerhtml-on-live-parent OK) Tooltip overlay element is positioned absolutely over (not as parent of) the canvas. Updating its content does not affect the chart. Date input passes through escHtml() to prevent XSS.
            tooltip.innerHTML =
                '<div class="tt-date">' + escHtml(date) + '</div>' +
                    priceHtml +
                    (vol != null ? '<div class="tt-vol">VOL ' + fmtVol(vol) + '</div>' : '');
            tooltip.classList.remove('d-none');
            tooltip.classList.add('d-block');
            // Redraw chart then overlay crosshair
            _redrawCombo();
            const cdAfter = canvas._chartData;
            if (cdAfter)
                _drawCrosshair(canvas, cdAfter, idx, canvasY);
        });
    });
    canvas.addEventListener('mouseleave', () => {
        tooltip.classList.add('d-none');
        tooltip.classList.remove('d-block');
        if (!chartPanState)
            _redrawCombo();
    });
}
//# sourceMappingURL=chart-engine.js.map
;
// ═══ ticker-renderer-hf-skeleton.js ═══
;"use strict";
// ticker-renderer-hf-skeleton.ts — the Institutional Investors panel's
// loading-state reservation.
//
// EXTRACTED from ticker-renderer.ts on 2026-08-04, same shape as the #261 D1b
// cut (2026-07-27) and the macro-briefing-skeleton.ts extraction earlier the
// same day. Adding the skeleton inline took ticker-renderer.ts to 4648 of its
// 4650-line budget — two lines of headroom is not headroom, it is the next
// contributor's problem. The budget gate's instruction is to extract rather
// than raise the cap, and this is the piece that comes out cleanly.
//
// SCRIPT MODE, NOT an ES module. tools/build_bundle.py CONCATENATES these
// files; an import/export would make this a module and _hfChangesSkeleton
// would stop being a bundle global, so renderHFChangesPanel's call would
// resolve to nothing at runtime. Registered in JS_MODULES and in the SAME
// `app-tail` chunk as ticker-renderer.js, immediately before it — same chunk
// matters, per the industry-comps.ts:36 note.
//
// Dependency-FREE by construction: a pure string builder, no DOM reads, no
// globals, no cross-file bindings. That is what makes this extraction safe
// where extracting renderHFChangesPanel itself would not be (it closes over
// _hfChangesCache, _hfBucketFilter, TierGate and SERVER).
//
// WHY A SHAPE AND NOT A NUMBER. The filled panel is a title, a four-cell stat
// chip, and a sortable table with a header and up to ten rows. The loading
// state was the title plus ONE `skel-bar-lg` — 18px standing in for something
// roughly ten times taller — so the panel grew on arrival and pushed
// #institutional-holders down beneath it (RUM CLS 0.17). The skeleton is now
// built from the REAL containers (.hf-chip, .hf-chip-cell, .hf-table) with
// .skel-bar primitives inside them, so its height comes from the same CSS the
// filled state uses and tracks any future change to that CSS for free. No new
// stylesheet rule, so the DS token / selector-freeze / breakpoint-ladder
// surface is untouched.
//
// WHY FIVE ROWS. The only non-deterministic part of the filled panel is the
// row count: the chip is always four cells and the header is fixed. The table
// is capped at ten (`top10 = actives.slice(0, 10)`), and a ticker with thin
// institutional coverage can have none. Five is the midpoint, so the
// worst-case reservation error is bounded at five rows in EITHER direction
// rather than ten in one. There is no "correct" number available here — the
// count is a property of the response, not of the viewport — so the bound is
// the thing worth optimising.
//
// Pinned by tests/test_cls_shape_reservation_contract.py.
var _HF_SKELETON_ROWS = 5;
function _hfChangesSkeleton() {
    var cells = '';
    for (var c = 0; c < 4; c++) {
        cells += '<div class="hf-chip-cell">' +
            '<div class="hf-chip-num"><span class="skel-bar skel-bar-sm"></span></div>' +
            '<div class="hf-chip-label"><span class="skel-bar skel-bar-sm"></span></div>' +
            '</div>';
    }
    var rows = '';
    for (var r = 0; r < _HF_SKELETON_ROWS; r++) {
        rows += '<tr>' +
            '<td><span class="skel-bar skel-bar-md"></span></td>' +
            '<td class="hf-num-col"><span class="skel-bar skel-bar-sm"></span></td>' +
            '<td class="hf-num-col"><span class="skel-bar skel-bar-sm"></span></td>' +
            '<td><span class="skel-bar skel-bar-sm"></span></td>' +
            '</tr>';
    }
    // The bars are decorative (aria-hidden); the sr-only status line is the
    // accessible announcement. It is deliberately NOT visible text — a visible
    // "Loading..." line above a correctly-sized skeleton would re-introduce the
    // shift in the opposite direction when it disappears.
    return '<div class="hf-panel-title">Institutional Investors</div>' +
        '<div class="hf-loading sr-only" role="status">Loading institutional-investor changes…</div>' +
        '<div class="hf-chip" aria-hidden="true">' + cells + '</div>' +
        '<table class="hf-table" aria-hidden="true"><thead><tr>' +
        '<th>Fund</th><th class="hf-num-col">Shares</th>' +
        '<th class="hf-num-col">QoQ &Delta;</th><th>As of</th>' +
        '</tr></thead><tbody>' + rows + '</tbody></table>';
}
//# sourceMappingURL=ticker-renderer-hf-skeleton.js.map
;
// ═══ ticker-renderer-graham.js ═══
;"use strict";
// @ts-nocheck
// ticker-renderer-graham.ts -- the Graham calculator's 10-year-yield input:
// a live value, or a LABELLED assumption (2026-10-16, FE-1).
//
// Queue row 2026-09-24 [P2-ux-honesty]: renderOverviewPanel silently pre-filled
// Y = 4.5 when the indicators cache had no 10Y row. The formula is unchanged
// (valuation-calcs.ts _calcIntrinsicGraham); only the provenance of Y is now
// visible. With no saved value and no live 10Y the input carries
// data-yield-assumed and a note reads "4.5% assumed -- live 10-year yield
// unavailable"; a live yield arriving later replaces the value and drops the
// note, never overwriting a figure the user typed.
//
// A new sibling rather than inline code because ticker-renderer.ts sat at
// exactly its 4,685-line size budget. Script-mode; build_bundle.py loads
// ticker-renderer-graham.js directly BEFORE ticker-renderer.js in both the
// JS_MODULES manifest and the app-tail chunk -- renderOverviewPanel reads the
// top-level const _GRAHAM_ASSUMED_YIELD, so the definition must be above its
// reader (same rule as ticker-renderer-hf-skeleton). The .ts is the SoT;
// ticker-renderer-graham.js is the gitignored tsc/esbuild emit.
// Graham Y when no saved value and no live 10Y exists; always shown labelled.
const _GRAHAM_ASSUMED_YIELD = 4.5;
function _grahamLiveYield(cache) {
    try {
        const src = cache !== undefined ? cache : (typeof indicatorsCache !== 'undefined' ? indicatorsCache : null);
        const rates = (src && Array.isArray(src['Rates'])) ? src['Rates'] : [];
        const t10y = rates.find((r) => r && r.name && r.name.includes('10Y Treasury'));
        if (t10y && t10y.price > 0)
            return Math.round(t10y.price * 100) / 100;
    }
    catch (e) { /* no indicators yet */ }
    return null;
}
function _grahamAssumedYieldNote(ticker) {
    return `<div id="iv-gr-y-note-${escHtml(ticker)}" class="iv-label" data-graham-yield-note>${_GRAHAM_ASSUMED_YIELD}% assumed — live 10-year yield unavailable</div>`;
}
// Swap a live 10Y into an assumed Graham field. Only when the field still holds
// the assumed value: a figure the user typed is theirs and is never replaced.
// Either way the field is no longer an unedited assumption, so the note goes.
function _grahamApplyLiveYield(ticker, cache) {
    const note = document.getElementById('iv-gr-y-note-' + ticker);
    const yEl = document.getElementById('iv-gr-y-' + ticker);
    if (!note || !yEl)
        return false;
    const assumed = yEl.getAttribute('data-yield-assumed');
    if (assumed != null && parseFloat(yEl.value) !== parseFloat(assumed)) {
        _grahamClearAssumedYield(ticker);
        return false;
    }
    const live = _grahamLiveYield(cache);
    if (live == null)
        return false;
    yEl.value = String(live);
    _grahamClearAssumedYield(ticker);
    if (typeof _calcIntrinsicGraham === 'function')
        _calcIntrinsicGraham(ticker);
    return true;
}
function _grahamClearAssumedYield(ticker) {
    const note = document.getElementById('iv-gr-y-note-' + ticker);
    const yEl = document.getElementById('iv-gr-y-' + ticker);
    if (note && note.parentNode)
        note.parentNode.removeChild(note);
    if (yEl) {
        yEl.removeAttribute('data-yield-assumed');
        yEl.removeAttribute('aria-describedby');
    }
}
// The yield was assumed at render: ask for the indicators once (OLApi shares
// the in-flight request with the pulse bar) and swap the live 10Y in if it lands.
async function _grahamFetchLiveYield(ticker) {
    if (_grahamApplyLiveYield(ticker))
        return;
    let data = null;
    try {
        const _ola = window.OLApi;
        if (!_ola || typeof _ola.getIndicators !== 'function')
            return;
        const res = await _ola.getIndicators({ signal: AbortSignal.timeout(20000) });
        if (!res || !res.ok)
            return;
        data = await res.json();
    }
    catch (e) {
        return; /* stays labelled as assumed */
    }
    if (data && typeof data === 'object')
        _grahamApplyLiveYield(ticker, data);
}
//# sourceMappingURL=ticker-renderer-graham.js.map
;
// ═══ ticker-renderer-phase2-pending.js ═══
;"use strict";
// @ts-nocheck
// ticker-renderer-phase2-pending.ts -- "still syncing" for every ticker-page
// section whose phase-2 SEC step did not finish (OWNER ruling 2026-10-26,
// CHAOS 2026-10-26 F7).
//
// data_fetching._fetch_phase2 runs the SEC steps under a per-step and overall
// budget (BACKEND-Y). A step the budget abandons is named in
// `_phase2Pending` on the /api/data payload ([] = every step finished;
// "sec_block" = the deadline went before the SEC block began, so every SEC
// step is pending). Until this file nothing read it: a pending section was
// simply absent -- or, for filings on the phase-poll path, still read "No
// recent SEC filings on file" from the phase-1 render. Each section below now
// says "Still syncing -- refresh to retry" when its step is pending AND it
// has nothing to show; a section that has data shows the data. Same D2 rule
// as the null-filings line (EXT-AUDIT T1 #52): a fetch gap never says "none".
//
// The pending payload is a data_store entry, served by /api/data for at most
// its 15-minute window (age_secs < 900); the next phase-2 run rewrites the key
// unconditionally, so a run that finishes clears it.
//
// A sibling rather than inline code because ticker-renderer.ts sits at exactly
// its 4,685-line size budget. Script-mode; build_bundle.py loads it directly
// BEFORE ticker-renderer.js in JS_MODULES and the app-tail chunk. Callers in
// other chunks (debt-panels.ts, peer-view.ts) typeof-guard every call. The .ts
// is the SoT; ticker-renderer-phase2-pending.js is the gitignored emit.
// Section -> the phase-2 step that fills it (data_fetching._fetch_phase2).
const _OL_P2_SECTION_STEP = {
    filings: 'edgar_filings',
    business: 'business_description',
    debt_maturities: 'debt_maturities',
    capital_structure: 'capital_structure',
    insider_transactions: 'insider_transactions',
};
const _OL_P2_SYNCING_TEXT = 'Still syncing — refresh to retry.';
// True when the payload names the section's step (or the whole SEC block) as
// unfinished. A payload without the key (phase 1, a db snapshot, an older
// server) is never "pending": absence of the list is not evidence of a gap.
function olPhase2SectionPending(d, section) {
    const pending = d && d._phase2Pending;
    if (!Array.isArray(pending) || pending.length === 0)
        return false;
    if (pending.indexOf('sec_block') >= 0)
        return true;
    const step = _OL_P2_SECTION_STEP[section];
    return !!step && pending.indexOf(step) >= 0;
}
function olPhase2SyncingHtml() {
    return '<div class="dim-msg">' + _OL_P2_SYNCING_TEXT + '</div>';
}
// The overview's Business section when it has no description to show. Pending:
// the syncing section. Not pending: the same section as a hidden slot
// (data-ol-p2-slot), so the phase-poll path can reveal it in place
// -- a targeted DOM write, never a re-render of the whole overview (CHAOS
// 2026-10-26 follow-up F1).
function olPhase2PendingSectionHtml(d, section, label) {
    const hide = olPhase2SectionPending(d, section) ? '' : ' d-none';
    return '<div class="ov-brief-section' + hide + '" data-ol-p2-slot="' + section + '">'
        + '<div class="ov-brief-section-label">' + label + '</div>'
        + olPhase2SyncingHtml() + '</div>';
}
// A standalone panel's syncing state: its title, then the syncing line.
// debt-panels.ts paints the same markup through this (typeof-guarded).
function olPhase2PanelSyncingHtml(title) {
    return '<h2 class="panel-title dp-panel-title-mb">' + title + '</h2>' + olPhase2SyncingHtml();
}
// The standalone panels a pending step can leave empty: [element id, section, title].
const _OL_P2_PANELS = [
    ['debt-maturity-panel', 'debt_maturities', 'DEBT MATURITY SCHEDULE'],
    ['capital-structure-panel', 'capital_structure', 'CAPITAL STRUCTURE'],
];
// Phase-poll + SSE path (updatePhase2Panels): a section rendered before phase
// 2 arrived, and left with NOTHING to show, now says it is still syncing when
// its step is pending.
//
// DOM-only by construction (CHAOS 2026-10-26 follow-up F1). updatePhase2Panels
// is the SSE listener's narrow exception to the request-storm rule, "audited
// fetch-free end to end" (tooltip-tour.ts; test_ticker_view_fetch_hygiene_
// contract). The first cut of this function re-ran renderDebtMaturityPanel,
// renderCapitalStructurePanel and renderInsiderActivity (each a fetch, and
// each ignoring its lazy-panel priority) and renderOverviewPanel (a full
// innerHTML rebuild that re-fetches the live Graham yield and resets the
// overview's note + time-machine state) on every pending phase-2 arrival. It
// now only reveals or fills the empty section in place:
//   - filings: null, or empty while pending -> the syncing line;
//   - Business: the hidden slot renderOverviewPanel emitted is revealed;
//   - debt / capital structure: a panel its own render HID (nothing to draw)
//     shows the syncing state; a panel with data, a locked card or a fetch
//     still in flight is left alone (that render reads the pending list
//     itself when it lands);
//   - insider: only the empty-state line (data-ol-p2-empty) is replaced.
function olRefreshPhase2Pending(d) {
    if (!d)
        return;
    const filingsEl = document.getElementById('filings-list');
    // null filings on a phase-2 payload is an abandoned step (CHAOS F1), never "none".
    if (filingsEl && (d.filings == null || (olPhase2SectionPending(d, 'filings') && !d.filings.length))) {
        filingsEl.innerHTML = '<div class="dim-msg">Filings are still syncing — refresh to retry.</div>';
    }
    if (olPhase2SectionPending(d, 'business')) {
        const slot = document.querySelector('[data-ol-p2-slot="business"]');
        if (slot)
            slot.classList.remove('d-none');
    }
    _OL_P2_PANELS.forEach(function (p) {
        if (!olPhase2SectionPending(d, p[1]))
            return;
        const el = document.getElementById(p[0]);
        if (!el || !el.classList.contains('hidden'))
            return;
        el.classList.remove('hidden');
        el.innerHTML = olPhase2PanelSyncingHtml(p[2]);
    });
    if (olPhase2SectionPending(d, 'insider_transactions')) {
        const ins = document.getElementById('insider-activity');
        if (ins && ins.querySelector('[data-ol-p2-empty]'))
            ins.innerHTML = olPhase2SyncingHtml();
    }
}
void olPhase2SectionPending;
void olPhase2SyncingHtml;
void olPhase2PendingSectionHtml;
void olPhase2PanelSyncingHtml;
void olRefreshPhase2Pending;
//# sourceMappingURL=ticker-renderer-phase2-pending.js.map
;
// ═══ ticker-renderer.js ═══
;"use strict";
// @ts-nocheck
// ── ticker-renderer.js ───────────────────────────────────────────────────
// Main ticker data renderer: renderData, hero display, phase polling,
// data freshness, key metrics strip/card, consensus estimates, overview
// panel, ticker notes, annotations — extracted from
// app.js §RENDER-DATA + §KEY-METRICS + §13F.
//
// #261 D1b (2026-07-27): the 13F / institutional-ownership cluster (the
// X5b/X5c-2 ownership TREND strips + the whole 13F VIEW: fund search,
// ticker-holder search, fund-holdings loader) moved verbatim to the sibling
// static/js/ticker-renderer-13f.ts to buy size-budget headroom. Same bundle
// chunk (app-tail), loaded directly after this file; every moved symbol keeps
// its global name, so in-file callers (_renderHFChangesData ->
// mount13fTrendStrip) and cross-file callers (app-renderers.ts data-action
// map, view-router.ts, product/surfaces/thirteen-f.ts, calendar-view.ts)
// resolve exactly as before.
//
// TS Migration Phase 2 PR 57 (2026-05-05): renamed .js → .ts as a
// `// @ts-nocheck` initial rename. 4013 LOC — second-largest single
// file in the migration. Heavy DOM rendering across 12+ panels with
// deep cross-chunk surface (dataCache, getData, renderComboChart,
// renderInsiderActivity, renderDivGrowthPanel, renderPeerComparison,
// renderSimilarCompanies, fmt, fmtMktCap, fmtVol, escHtml, showToast,
// switchTicker, OLApi, OLStorage, _authUser, _isProUser, _csrfHeaders,
// currentView, activeTicker). Tighten in PRs 63-65.
//
// The .ts is the SoT; ticker-renderer.js is the gitignored build
// artifact.
// Dependencies: SERVER, THEME, activeTicker, dataCache, isLive, currentView,
// tickers, PORTFOLIO_TICKERS, chartAnnotations, tickerChartPeriod,
// phasePollingTimers, _isMobile, _OL_DEBUG, DEMO_DATA,
// renderComboChart, renderTabs, $id, fmt, fmtM, fmtVol, fmtMktCap,
// escHtml, showToast, _track, registerInterval, clearInterval,
// _lazyPanel, _clearLazyPanels, _hideTickerSkeleton, _updatePhaseIndicator,
// _flashElement, _animateNumber, setLoading, _showSkeleton, _renderError,
// LoadingStates, DataCache, olFetch, updateBrokerageLinks,
// renderETFData, hideETFPanel (typeof-guarded external modules)
//
// Private state (only used within ticker-renderer.js):
//   heroTimestampInterval, _sbFreshnessInterval, _scratchpadDebounceTimer,
//   _annSelectedCat
// Moved to ticker-renderer-13f.ts (#261 D1b): DISTRESSED_FUNDS,
//   MAJOR_CREDIT_HOLDERS, _notableFundsCache, _f13ShowAll (the last one
//   also written by app.js delegation)
/**
 * _sanitizeUrl — strip dangerous URL schemes before inserting into href attributes.
 * Returns '#' for javascript:, data:, and vbscript: URLs; otherwise returns the
 * original URL unchanged.  Call this instead of escHtml() for href values that
 * come from external APIs.
 */
/**
 * CSP-safe inline-style hydrator (Phase 3) — same shape as portfolio.js.
 *
 * Generators emit `data-w`, `data-l`, `data-r` (percent values) and
 * `data-fg` / `data-bg` (color strings). After each innerHTML
 * insertion, call `_hydrateTickerStyles(rootEl)` to apply each via
 * per-property style writes (NOT CSP-governed).
 */
/**
 * _squeezeWatchBadge — render a "Short-Squeeze Watch" banner when
 * the short-interest profile of a ticker meets BOTH thresholds:
 *   - pctOfFloat > 15  (heavily shorted; either a strong bear case OR
 *                       a squeeze setup per glossary.js:1097 "interpret")
 *   - daysToCover > 5  (shorts can't unwind quickly — if the price
 *                       rises, covering forces buying that compounds
 *                       the move)
 * Both criteria from the glossary's own short-interest entry. Conjunction
 * matters: heavy short interest with cheap covering is just bearish
 * positioning; heavy short interest with high days-to-cover is the
 * structural pre-condition for a squeeze.
 *
 * Returns HTML string (empty when conditions not met).
 *
 * EW-PARTIAL-6 ship 2026-04-26: data was always live, only the
 * conditional UI affordance was missing.
 */
// #256 stage e: the first company-PUBLISHED entry from the merged IR
// calendar (earnings.calendar, v201 store), or null. OL_ESTIMATE entries are
// deliberately skipped here — the olEstimate branches already render those
// with their own label, and provenance must never be blurred.
function _irPublishedEntry(earn) {
    try {
        const es = earn && earn.calendar && earn.calendar.entries;
        if (!es || !es.length)
            return null;
        for (let i = 0; i < es.length; i++) {
            if (es[i] && es[i].provenance === 'PUBLISHED' && es[i].date)
                return es[i];
        }
    }
    catch (_e) { /* noop */ }
    return null;
}
function _squeezeWatchBadge(si) {
    if (!si)
        return '';
    var pct = si.pctOfFloat;
    var dtc = si.daysToCover;
    if (pct == null || dtc == null)
        return '';
    if (!(pct > 15 && dtc > 5))
        return '';
    // Voice: report the structural setup, not a prediction. "Squeeze
    // setup" matches the glossary entry's own framing; we are not
    // recommending a trade.
    var pctText = (typeof fmt === 'function') ? fmt(pct, 1) : pct.toFixed(1);
    var dtcText = (typeof fmt === 'function') ? fmt(dtc, 1) : dtc.toFixed(1);
    return ('<a class="sq-watch-badge skill-advanced-chip" href="/glossary/#short-interest" ' +
        'title="Heavily shorted (>15% of float) and high days-to-cover (>5). ' +
        'If the price rises, shorts must buy to cover — that buying can compound ' +
        'the move. Setup, not a prediction.">' +
        '<span class="sq-watch-eyebrow">Short-Squeeze Watch</span>' +
        '<span class="sq-watch-stats">' +
        pctText + '% short &middot; ' + dtcText + ' days to cover' +
        '</span>' +
        '</a>');
}
/**
 * renderHFChangesPanel — EW-1 + EW-2 paired sprint (2026-04-26).
 *
 * Surfaces the /api/institutional-holders/changes payload as:
 *   - EW-1: an "Institutional-holdings QoQ" stat chip (new/increased/decreased/exited counts)
 *   - EW-2: a top-10 mini-table with Δ shares + Δ % per fund
 *
 * Renders into #hf-changes-panel (sits above #institutional-holders so
 * the change-of-mind story precedes the snapshot of who's there now).
 *
 * Tier-gated to Plus+. Three-state UX:
 *   - Pre-flight tier-gate fail → inline upgrade placeholder (no fetch)
 *   - Network/server error → "Unable to load" with retry data-action
 *   - Empty result (zero quarters of data) → silent skip (don't pollute
 *     the page with "no data" cards for newly-IPO'd tickers)
 *
 * Cache-keyed by (ticker, currentTier) so a tier upgrade re-fetches.
 */
var _hfChangesCache = {};
// #189 step 4 (2026-05-19 OWNER prod-QA): per-ticker chip filter
// (new|increased|decreased|exited|null). null = show the current
// active-funds default; clicking a chip toggles the filter so the
// Δ-table shows ONLY the entries for that bucket. Click the same
// chip again to clear. State lives module-scope (not per-cache-key)
// so navigating to a different ticker resets via the renderHF call.
var _hfBucketFilter = null;
var _hfChangesFilterTicker = null;
// ── Revenue Segments panel (SF-EDGAR-XBRL P2, 2026-06-09) ──────────────────
// Operating + geographic (+ product) revenue breakdown from first-party SEC
// EDGAR (XBRL) via the FREE /api/segments route. Additive + self-hiding: any
// failure or no-segment filer collapses the panel to empty (never an error
// card) so it can't degrade the research column for the many tickers that
// report no segments.
var _segmentsCache = {};
// SF-FDIC Phase B: per-ticker cache for the FDIC Regulatory View panel.
var _fdicCache = {};
function _segEsc(s) {
    return String(s == null ? '' : s)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
}
function _segFmtUSD(v) {
    if (v == null || isNaN(Number(v)))
        return '—';
    return fmtAbbrev(Number(v)); // DS-P2a: canonical $ K/M/B
}
function _segGroupHtml(title, list) {
    if (!list || !list.length)
        return '';
    var rows = [], total = 0;
    for (var i = 0; i < list.length; i++) {
        var s = list[i];
        var yr = (s.years && s.years.length) ? s.years[0] : null;
        if (!yr || yr.revenue == null)
            continue;
        rows.push({ name: s.name, rev: Number(yr.revenue), year: yr.year });
        total += Number(yr.revenue);
    }
    if (!rows.length)
        return '';
    var max = rows[0].rev || 1; // route pre-sorts desc by latest revenue
    var body = '';
    for (var j = 0; j < rows.length; j++) {
        var r = rows[j];
        var pct = total > 0 ? Math.round((r.rev / total) * 100) : 0;
        var w = max > 0 ? Math.max(2, Math.round((r.rev / max) * 100)) : 0;
        body +=
            '<div class="seg-row">' +
                '<div class="seg-row-head"><span class="seg-name">' + _segEsc(r.name) + '</span>' +
                '<span class="seg-val">' + _segFmtUSD(r.rev) +
                '<span class="seg-pct">' + pct + '%</span></span></div>' +
                '<div class="seg-bar-track"><div class="seg-bar-fill" data-segw="' + w + '"></div></div>' +
                '</div>';
    }
    // Total for absolute context (e.g. "FY2025 · Total $416.2B") — a 43% share
    // is only meaningful against the base.
    return '<div class="seg-group"><div class="seg-group-title">' + _segEsc(title) +
        ' <span class="seg-fy">FY' + _segEsc(rows[0].year) + ' · Total ' + _segFmtUSD(total) +
        '</span></div>' + body + '</div>';
}
function _renderSegmentsData(el, t, data) {
    var html = _segGroupHtml('By segment', data.operating) +
        _segGroupHtml('By geography', data.geographic) +
        _segGroupHtml('By product', data.product);
    if (!html) {
        el.innerHTML = '';
        return;
    } // self-hide: nothing renderable
    el.innerHTML =
        '<h2 class="panel-title d-flex-between" data-gloss="Revenue Segments">' +
            '<span>Revenue Segments</span>' +
            '<span class="seg-source" title="First-party SEC EDGAR XBRL data">SEC EDGAR</span>' +
            '</h2>' + html;
    // CSP-safe bar widths: set via CSSOM (element.style), NOT an inline `style=`
    // attribute in the innerHTML above — strict `style-src 'self'` blocks inline
    // style attributes, which silently left every bar width:0 (no large/small
    // differentiation). Matches the codebase pattern (ticker-renderer.ts:498).
    var fills = el.querySelectorAll('.seg-bar-fill');
    for (var i = 0; i < fills.length; i++) {
        var w = fills[i].getAttribute('data-segw');
        if (w != null)
            fills[i].style.width = w + '%';
    }
}
function renderSegmentsPanel(ticker) {
    var el = document.getElementById('segments-panel');
    if (!el || !ticker)
        return;
    var t = String(ticker).trim().toUpperCase();
    if (!t) {
        el.innerHTML = '';
        return;
    }
    if (_segmentsCache[t]) {
        _renderSegmentsData(el, t, _segmentsCache[t]);
        return;
    }
    el.innerHTML =
        '<h2 class="panel-title d-flex-between" data-gloss="Revenue Segments">' +
            '<span>Revenue Segments</span><span class="seg-source">SEC EDGAR</span></h2>' +
            '<div class="seg-loading"><span class="skel-bar skel-bar-lg"></span>' +
            '<span class="skel-bar skel-bar-md"></span></div>';
    var url = (typeof SERVER !== 'undefined' ? SERVER : '') +
        '/api/segments?ticker=' + encodeURIComponent(t);
    var sig = (typeof AbortSignal !== 'undefined' && AbortSignal.timeout)
        ? AbortSignal.timeout(20000) : undefined;
    fetch(url, { signal: sig })
        .then(function (res) { return (res && res.ok) ? res.json() : null; })
        .then(function (data) {
        if (!data || !data.has_data) {
            el.innerHTML = '';
            return;
        } // self-hide
        _segmentsCache[t] = data;
        _renderSegmentsData(el, t, data);
    })
        .catch(function () { el.innerHTML = ''; }); // additive: never show an error card
}
// ── FDIC Regulatory View (SF-FDIC Phase B) ──────────────────────────────────
// Additive + self-hiding: only banks in the verified CERT->ticker map return
// available:true; everything else (and any fetch error) collapses the panel to
// empty. Renders into the standalone #fdic-regulatory-panel container (no canvas
// child, so el.innerHTML is safe per feedback_never_destroy_dom). Figures are
// the FDIC-insured bank SUBSIDIARY's call report — labeled honestly. Units are
// already converted server-side ($thousands->USD); percents are passthrough.
function _fdicFmtUSD(v) {
    if (v == null || isNaN(Number(v)))
        return '—';
    return fmtAbbrev(Number(v)); // DS-P2a: canonical $ K/M/B
}
function _fdicPct(v) {
    return (v == null || isNaN(Number(v))) ? '—' : Number(v).toFixed(2) + '%';
}
function _renderFDICData(el, d) {
    var stats = [];
    function stat(label, val) {
        if (val == null || val === '—' || val === '')
            return;
        stats.push('<div class="fdic-stat"><span class="fdic-stat-label">' + escHtml(label) +
            '</span><span class="fdic-stat-val">' + escHtml(val) + '</span></div>');
    }
    var f = d.financials || {};
    stat('Total assets', _fdicFmtUSD(d.asset_usd));
    stat('Total deposits', _fdicFmtUSD(d.deposits_usd));
    if (f.net_interest_margin_pct != null)
        stat('Net interest margin', _fdicPct(f.net_interest_margin_pct));
    if (f.return_on_assets_pct != null)
        stat('Return on assets', _fdicPct(f.return_on_assets_pct));
    if (f.return_on_equity_pct != null)
        stat('Return on equity', _fdicPct(f.return_on_equity_pct));
    if (f.efficiency_ratio_pct != null)
        stat('Efficiency ratio', _fdicPct(f.efficiency_ratio_pct));
    if (f.tier1_leverage_ratio_pct != null)
        stat('Tier 1 leverage ratio', _fdicPct(f.tier1_leverage_ratio_pct));
    if (f.net_income_usd != null)
        stat('Net income (quarter)', _fdicFmtUSD(f.net_income_usd));
    if (f.total_offices != null)
        stat('Domestic offices', Number(f.total_offices).toLocaleString());
    // Defence-in-depth: escHtml() escapes quotes, so even the FDIC-sourced URL +
    // name can't break out of the href attribute (SEC-4 lesson).
    var srcUrl = d.source_url || 'https://banks.data.fdic.gov/bankfind-suite/bankfind';
    var asof = d.as_of ? 'As of ' + escHtml(d.as_of) : '';
    var nameHtml = d.institution_name
        ? '<a href="' + escHtml(srcUrl) + '" target="_blank" rel="noopener" class="fdic-inst-name">' +
            escHtml(d.institution_name) + '</a>'
        : '';
    el.innerHTML =
        '<h2 class="panel-title d-flex-between">' +
            '<span>FDIC Regulatory View</span>' +
            (asof ? '<span class="fdic-asof">' + asof + '</span>' : '') +
            '</h2>' +
            (nameHtml ? '<div class="fdic-inst">' + nameHtml + '</div>' : '') +
            (d.subsidiary_note ? '<div class="fdic-sub-note">' + escHtml(d.subsidiary_note) + '</div>' : '') +
            '<div class="fdic-stats">' + stats.join('') + '</div>' +
            '<div class="fdic-foot">Source: <a href="' + escHtml(srcUrl) + '" target="_blank" rel="noopener">' +
            'FDIC BankFind</a> · figures are for the FDIC-insured bank subsidiary</div>';
}
function renderFDICRegulatoryPanel(ticker) {
    var el = document.getElementById('fdic-regulatory-panel');
    if (!el || !ticker)
        return;
    var t = String(ticker).trim().toUpperCase();
    if (!t) {
        el.innerHTML = '';
        return;
    }
    if (_fdicCache[t]) {
        if (_fdicCache[t].available) {
            _renderFDICData(el, _fdicCache[t]);
        }
        else {
            el.innerHTML = '';
        }
        return;
    }
    var url = (typeof SERVER !== 'undefined' ? SERVER : '') +
        '/api/fdic/regulatory?ticker=' + encodeURIComponent(t);
    var sig = (typeof AbortSignal !== 'undefined' && AbortSignal.timeout)
        ? AbortSignal.timeout(15000) : undefined;
    fetch(url, { signal: sig })
        .then(function (res) { return (res && res.ok) ? res.json() : null; })
        .then(function (data) {
        if (!data)
            return; // network/parse miss — leave as-is
        _fdicCache[t] = data;
        if (!data.available) {
            el.innerHTML = '';
            return;
        } // self-hide non-banks
        _renderFDICData(el, data);
    })
        .catch(function () { el.innerHTML = ''; }); // additive: never an error card
}
function renderHFChangesPanel(ticker) {
    var el = document.getElementById('hf-changes-panel');
    if (!el || !ticker)
        return;
    var t = String(ticker).trim().toUpperCase();
    if (!t) {
        el.innerHTML = '';
        return;
    }
    // Reset filter when entering a new ticker context (panel is also
    // re-called on cache-hit re-renders — keep filter then via the
    // _hfChangesFilterTicker memo).
    if (_hfChangesFilterTicker !== t) {
        _hfBucketFilter = null;
        _hfChangesFilterTicker = t;
    }
    var url = (typeof SERVER !== 'undefined' ? SERVER : '') +
        '/api/institutional-holders/changes?ticker=' + encodeURIComponent(t) + '&quarters=4';
    // Pre-flight tier check — render upgrade UI without firing a network call.
    if (typeof TierGate !== 'undefined' && typeof TierGate.canCall === 'function' && !TierGate.canCall(url)) {
        if (typeof TierGate.renderInlineUpgrade === 'function') {
            TierGate.renderInlineUpgrade(el, {
                featureId: 'institutional-holders-changes',
                featureName: 'Institutional Investors QoQ change tracking',
                description: 'See which funds are buying, trimming, or exiting this name across recent 13F-HR filings.',
                minTier: 'plus',
            });
        }
        else {
            el.textContent = '';
        }
        return;
    }
    // Cache hit — render synchronously (sub-second nav between tickers in a
    // session shouldn't re-paint with skeleton). Keyed by ticker only since
    // the data refreshes quarterly.
    if (_hfChangesCache[t]) {
        _renderHFChangesData(el, t, _hfChangesCache[t]);
        return;
    }
    // Loading skeleton — reserves the SHAPE, not one bar. The filled panel is
    // a 4-cell stat chip plus a header + up to 10 rows; a single skel-bar-lg
    // reserved 18px of it, so the panel grew ~10x and pushed
    // #institutional-holders down (RUM CLS 0.17). Built from the REAL
    // containers so the height tracks the same CSS the filled state uses.
    // Row count: see the contract test for why 5 and not 10.
    el.innerHTML = _hfChangesSkeleton();
    var fetchFn = (typeof TierGate !== 'undefined' && TierGate.fetchIfAllowed)
        ? TierGate.fetchIfAllowed(url, { signal: (typeof AbortSignal !== 'undefined' && AbortSignal.timeout) ? AbortSignal.timeout(15000) : undefined })
        : fetch(url);
    Promise.resolve(fetchFn)
        .then(function (res) {
        // F-04 (2026-05-21 external code review): tier-gate intercept now
        // resolves with a synthetic 402 Response. Handle 402 inline here
        // BEFORE the !res.ok throw — else the existing tier-gated catch
        // below never fires (the catch keyed on e.code === 'tier-gated'
        // which only existed on the pre-F-04 bare Error rejection).
        if (res && res.status === 402 && typeof TierGate !== 'undefined' && TierGate.renderInlineUpgrade) {
            return res.clone().json().catch(function () { return {}; }).then(function (body) {
                TierGate.renderInlineUpgrade(el, {
                    featureId: 'institutional-holders-changes',
                    featureName: 'Institutional Investors QoQ change tracking',
                    description: 'See which funds are buying, trimming, or exiting this name across recent 13F-HR filings.',
                    minTier: (body && body.requiredTier) || 'plus',
                });
                return null; // sentinel: skip downstream rendering
            });
        }
        if (!res || !res.ok)
            throw new Error('HTTP ' + (res && res.status));
        return res.json();
    })
        .then(function (data) {
        if (data === null)
            return; // 402 sentinel — chip already painted
        if (!data || data.error) {
            // Empty payload (newly-public ticker, no 13F coverage) — silent skip.
            if (data && (data.quarters_analyzed === 0 || (data.summary && data.summary.new === 0 && data.summary.increased === 0 && data.summary.decreased === 0 && data.summary.exited === 0))) {
                // The OTHER direction of the same CLS defect: this fires AFTER the
                // skeleton has painted, so collapsing the panel to nothing yanks
                // #institutional-holders upward. Say so instead — a ticker with no
                // 13F overlap is a real fact about the ticker, not an absence to
                // hide (same call as the briefing's stale-pool branch).
                el.innerHTML =
                    '<div class="hf-panel-title">Institutional Investors</div>' +
                        '<div class="hf-empty">No institutional position changes to report — ' +
                        'no 13F filer reported a change in this name over the last four quarters.</div>';
                return;
            }
            throw new Error(data && data.error ? data.error : 'Empty response');
        }
        _hfChangesCache[t] = data;
        _renderHFChangesData(el, t, data);
    })
        .catch(function (e) {
        // Belt-and-suspenders: keep the bare-Error tier-gated branch in
        // case any code path is still rejecting (e.g., TierGate.fetchIfAllowed
        // at tier-gate.ts:194-196 still uses Promise.reject — that's a
        // different code path from the window.fetch interceptor at line
        // 759 which now resolves with 402).
        if (e && e.code === 'tier-gated' && typeof TierGate !== 'undefined' && TierGate.renderInlineUpgrade) {
            TierGate.renderInlineUpgrade(el, {
                featureId: 'institutional-holders-changes',
                featureName: 'Institutional Investors QoQ change tracking',
                description: 'See which funds are buying, trimming, or exiting this name across recent 13F-HR filings.',
                minTier: e.minTier || 'plus',
            });
            return;
        }
        el.innerHTML =
            '<div class="hf-panel-title">Institutional Investors</div>' +
                '<div class="hf-error">Unable to load institutional-investor changes. ' +
                '<button type="button" class="hf-retry" data-action="hf-changes-retry" data-ticker="' + escHtml(t) + '">Retry</button>' +
                '</div>';
    });
}
// T2 (2026-07-14): above this QoQ % the prior-quarter base was negligible
// (a >1000% jump ⇒ prior holding < ~1/11th of current), so the percentage is a
// garbage-denominator artifact rather than a meaningful change — render it as a
// newly built position instead. See the guard in _renderHFChangesData's row map.
var _HF_QOQ_NEAR_ZERO_BASE_PCT = 1000;
/**
 * Inner render — called from both the cache-hit path and the fresh-fetch
 * path. Pure-data → DOM mapping, no network. Brand v2 styling: gold-link
 * eyebrow, Geist Mono numbers, hairline rows, no green for "increased"
 * (gold fits financial-up per the de-greening sweep).
 */
function _renderHFChangesData(el, ticker, data) {
    var summary = data.summary || {};
    var newCount = summary.new || 0;
    var incCount = summary.increased || 0;
    var decCount = summary.decreased || 0;
    var extCount = summary.exited || 0;
    var qAnalyzed = data.quarters_analyzed || 0;
    // Pairs whose verdict the split guard WITHHELD: dropped from
    // increased/decreased upstream and absent from `summary`, so NOT reading
    // them paints a confident zero. `|| []` covers SSR + pre-c2eedc40 cache.
    // Why: docs/board/audit/2026-09-08_CHAOS_13f_split_delta.md §9.
    var withheld = data.split_suspect || [];
    // EW-1 chip — four stat cells. Numbers in Geist Mono so they read as
    // data, not prose. "New" + "Increased" use the gold positive token;
    // "Decreased" + "Exited" use the terracotta negative token.
    // #189 step 4 (2026-05-19): each chip cell is a clickable
    // button toggling the bucket filter on the Delta-table below.
    function _hfChipCellHtml(bucket, num, label, polarity) {
        var sign = polarity === 'pos' ? '+' : '\u2212';
        var activeCls = _hfBucketFilter === bucket ? ' hf-chip-cell--active' : '';
        return '<button type="button" class="hf-chip-cell' + activeCls +
            '" data-action="hf-filter-bucket" data-bucket="' + bucket +
            '" data-ticker="' + escHtml(ticker) +
            '" aria-pressed="' + (_hfBucketFilter === bucket ? 'true' : 'false') +
            '" title="Click to filter the table to ' + label + ' positions">' +
            '<div class="hf-chip-num hf-' + polarity + '">' + sign + num + '</div>' +
            '<div class="hf-chip-label">' + label + '</div>' +
            '</button>';
    }
    var chipHtml = '<div class="hf-chip">' +
        _hfChipCellHtml('new', newCount, 'new', 'pos') +
        _hfChipCellHtml('increased', incCount, 'increased', 'pos') +
        _hfChipCellHtml('decreased', decCount, 'decreased', 'neg') +
        _hfChipCellHtml('exited', extCount, 'exited', 'neg') +
        '</div>';
    // CR-C2 (2026-05-01): Silent-shadow guard — branch BEFORE coercing
    // arrays with `|| []`. If the backend returns an error envelope without
    // the array keys (paywall 402, quota, partial 5xx), the previous code
    // rendered a blank table with no error indicator. Third instance of the
    // CLAUDE.md shape-drift defect class (incidents 2026-04-26 + 2026-04-27).
    if (data && (data.error || data._data_status === 'error')) {
        el.innerHTML =
            '<div class="hf-panel-title">Institutional Investors</div>' +
                '<div class="hf-error">' + escHtml(data.error || 'Holders data unavailable') + '</div>';
        return;
    }
    if (!('increased' in data) && !('decreased' in data) && !('new_positions' in data)) {
        el.innerHTML =
            '<div class="hf-panel-title">Institutional Investors</div>' +
                '<div class="hf-error">Holders changes unavailable — try refreshing</div>';
        return;
    }
    // EW-2 mini-table — top funds by current shares, with Δ % column.
    // #189 step 4: when a bucket filter is active, show only that
    // bucket (including exited — which is otherwise hidden because
    // exited rows have zero current shares; the explicit-click filter
    // makes them visible on demand). Default combines increased +
    // decreased + new (skip unchanged, hide exited unless filtered).
    var actives;
    if (_hfBucketFilter === 'new') {
        actives = (data.new_positions || []).slice();
    }
    else if (_hfBucketFilter === 'increased') {
        actives = (data.increased || []).slice();
    }
    else if (_hfBucketFilter === 'decreased') {
        actives = (data.decreased || []).slice();
    }
    else if (_hfBucketFilter === 'exited') {
        actives = (data.exited || []).slice();
    }
    else {
        actives = []
            .concat(data.increased || [])
            .concat(data.decreased || [])
            .concat(data.new_positions || [])
            // As-filed shares, so they belong in a table sorted by shares.
            .concat(withheld);
    }
    actives.sort(function (a, b) { return (b.shares || 0) - (a.shares || 0); });
    var top10 = actives.slice(0, 10);
    var tableHtml = '';
    if (top10.length > 0) {
        var rows = top10.map(function (h) {
            var fundName = h.fund_name || ('CIK ' + (h.fund_cik || ''));
            var shares = h.shares != null ? h.shares.toLocaleString() : '\u2014';
            var sharesRaw = h.shares != null ? h.shares : 0;
            // #189 step 4 follow-up (2026-05-19): the backend
            // (data/institutional_holdings.py:_get_ownership_changes) emits
            // `pct_change`, NOT `shares_pct_change`. The prior name was wrong
            // → deltaPct was always undefined → EVERY row rendered the
            // synthetic "NEW" badge even for funds with prior-quarter holdings
            // (OWNER observation 2026-05-19: "Berkshire has been a long-term
            // holder" but the panel labeled it NEW). Read both names for
            // forward/backward compat; prefer `pct_change` (the truth).
            var deltaPct = h.pct_change != null ? h.pct_change : h.shares_pct_change;
            // "new" entries from data.new_positions don't have shares_pct_change;
            // synthesize a "NEW" badge.
            var deltaCell;
            // F9 follow-on (2026-04-30 PM): sort key for the QoQ \u0394 column.
            // NEW positions sort as +Infinity (most-positive); flat as 0;
            // others use their numeric pct.
            var deltaSortVal;
            if (_hfBucketFilter === 'exited') {
                deltaCell = '<span class="hf-delta hf-neg">EXITED</span>';
                deltaSortVal = Number.MIN_SAFE_INTEGER;
            }
            else if (h.reason === 'cohort_rescale_signature' ||
                h.reason === 'registry_candidate') {
                // MUST precede the null-delta branch: a withheld row has no
                // `pct_change`, so it would otherwise render the NEW badge -- the
                // 2026-05-19 defect the comment below records.
                deltaCell = '<span class="hf-delta hf-delta-withheld" title="' +
                    escHtml(h.note || '') + '">WITHHELD</span>';
                deltaSortVal = 0;
            }
            else if (deltaPct == null) {
                deltaCell = '<span class="hf-delta hf-delta-new">NEW</span>';
                deltaSortVal = Number.MAX_SAFE_INTEGER;
            }
            else if (deltaPct > _HF_QOQ_NEAR_ZERO_BASE_PCT) {
                // T2 (2026-07-14 OWNER prod-QA): a garbage-denominator guard. The
                // backend pct_change is (curr - prev)/|prev| * 100, so a fund that
                // held a negligible prior-quarter position (e.g. a few hundred shares)
                // and then built a real stake renders an absurd six-digit QoQ \u2014
                // "Pacer Advisors +436,563.2%". A >1000% QoQ jump means the prior base
                // was <~1/11th of the current holding, i.e. effectively a newly
                // established position; label it as such instead of a fabricated
                // percentage. (Same garbage-denominator class as the BDC
                // mark-dispersion near-zero-par guard.) The durable fix is a
                // prior-shares floor in data/institutional_holdings.py
                // _get_ownership_changes; this is the display-side backstop.
                deltaCell = '<span class="hf-delta hf-delta-new" title="Prior-quarter position was negligible, so a QoQ % is not meaningful \u2014 this reads as a newly built stake.">New position</span>';
                deltaSortVal = deltaPct;
            }
            else if (deltaPct > 0) {
                deltaCell = '<span class="hf-delta hf-pos">\u25B2 ' + (typeof fmt === 'function' ? fmt(deltaPct, 1) : deltaPct.toFixed(1)) + '%</span>';
                deltaSortVal = deltaPct;
            }
            else if (deltaPct < 0) {
                deltaCell = '<span class="hf-delta hf-neg">\u25BC ' + (typeof fmt === 'function' ? fmt(Math.abs(deltaPct), 1) : Math.abs(deltaPct).toFixed(1)) + '%</span>';
                deltaSortVal = deltaPct;
            }
            else {
                deltaCell = '<span class="hf-delta hf-flat">\u2014</span>';
                deltaSortVal = 0;
            }
            // #189 step 2: fund name is a clickable affordance to load
            // the fund's full 13F-HR holdings in /?view=13f. Reuses the
            // established `load-13f-holdings` action that the fund-search
            // UI already emits (app-renderers.ts -> load13fHoldings).
            var fundCellInner = h.fund_cik
                ? '<button type="button" class="hf-fund-link" data-action="load-13f-holdings" data-cik="' + escHtml(String(h.fund_cik)) + '" data-name="' + escHtml(fundName) + '" title="Open ' + escHtml(fundName) + '\u2019s full 13F-HR holdings">' + escHtml(fundName) + '</button>'
                : escHtml(fundName);
            // #189 step 3 follow-up (2026-05-19 OWNER prod-QA): "need to show
            // as of date for fund holdings (separate column)". The backend
            // (data/institutional_holdings.py) now emits `filing_date` on
            // each entry; fall back to `quarter` (e.g. "2025Q1") for legacy
            // rows that pre-date the field.
            var asOf = h.filing_date || h.quarter || '\u2014';
            var asOfSort = h.filing_date || (h.quarter ? String(h.quarter) : '');
            return '<tr>' +
                '<td class="hf-table-fund" data-sort-value="' + escHtml(fundName.toLowerCase()) + '">' + fundCellInner + '</td>' +
                '<td class="hf-table-shares" data-sort-value="' + sharesRaw + '">' + shares + '</td>' +
                '<td class="hf-table-delta" data-sort-value="' + deltaSortVal + '">' + deltaCell + '</td>' +
                '<td class="hf-table-asof" data-sort-value="' + escHtml(String(asOfSort)) + '">' + escHtml(String(asOf)) + '</td>' +
                '</tr>';
        }).join('');
        // F9 follow-on: sortable headers on Institutional-holdings QoQ table \u2014 Fund
        // (string), Shares (number desc default), QoQ \u0394 (number desc).
        tableHtml =
            '<table class="hf-table"><thead><tr>' +
                '<th data-sort-key="fund" data-sort-type="string">Fund</th>' +
                '<th class="hf-num-col" data-sort-key="shares" data-sort-type="number">Shares</th>' +
                '<th class="hf-num-col" data-sort-key="delta" data-sort-type="number">QoQ &Delta;</th>' +
                '<th data-sort-key="asof" data-sort-type="string">As of</th>' +
                '</tr></thead><tbody>' + rows + '</tbody></table>';
    }
    else if (_hfBucketFilter) {
        tableHtml = '<div class="hf-empty">No funds in the ' + escHtml(_hfBucketFilter) + ' bucket for this ticker.</div>';
    }
    // EXT-AUDIT #60/T5 (2026-07-06): the As-of column repeats one date down
    // every row and truncated to "202 / 05-" fragments at 425px — the column
    // hides on mobile (css) and the newest date is hoisted here once.
    var _hfAsofHoist = '';
    try {
        var _hfDates = top10.map(function (h) { return h.filing_date || ''; }).filter(Boolean).sort();
        if (_hfDates.length)
            _hfAsofHoist = ' · as of ' + _hfDates[_hfDates.length - 1];
    }
    catch (_e) { /* label enrichment only */ }
    // The chips count only the buckets the guard left intact. Copy comes from
    // the backend row, which names the observed factor (checkable, not faith).
    var withheldHtml = '';
    if (withheld.length) {
        withheldHtml = '<div class="hf-withheld-note">' + withheld.length +
            (withheld.length === 1 ? ' fund is' : ' funds are') +
            ' not counted in the figures above. ' +
            escHtml((withheld[0] && withheld[0].note) || '') + '</div>';
    }
    var qLabel = (qAnalyzed > 0 ? (qAnalyzed + (qAnalyzed === 1 ? ' quarter' : ' quarters') + ' analyzed') : 'No quarter overlap') + _hfAsofHoist;
    // #189 step 4: when filter is active, surface a chip in the
    // as-of label with an x button to clear.
    var filterTag = _hfBucketFilter
        ? ' \u00B7 filter: ' + escHtml(_hfBucketFilter) +
            ' <button type="button" class="hf-filter-clear" data-action="hf-filter-bucket" data-bucket="" data-ticker="' + escHtml(ticker) +
            '" title="Clear filter">\u00D7</button>'
        : '';
    el.innerHTML =
        '<div class="hf-panel-title d-flex-between" data-gloss="Institutional Investors">' +
            '<span>Institutional Investors</span>' +
            '<span class="hf-panel-asof">' + escHtml(qLabel) + filterTag + '</span>' +
            '</div>' +
            chipHtml +
            withheldHtml +
            tableHtml +
            '<div class="hf-disclaimer">13F-HR positions reported quarterly with a 45-day delay. Not a recommendation to follow fund managers.</div>';
    // F9 follow-on: attach sort handler. Default sort matches the
    // pre-render order (shares desc), so first paint is unchanged.
    try {
        var t = el.querySelector('table.hf-table');
        if (t && typeof OLSortableTable !== 'undefined' && OLSortableTable.attach) {
            OLSortableTable.attach(t, { initialKey: 'shares', initialDir: 'desc' });
        }
    }
    catch (_e) { /* helper missing → table renders without sort affordance */ }
    // X5b: mount the longitudinal ownership-trend strip above the chip (decoupled;
    // additive insertBefore, re-runs on every render so it survives the innerHTML above).
    mount13fTrendStrip(el, ticker);
}
function _hydrateTickerStyles(rootEl) {
    if (!rootEl || typeof rootEl.querySelectorAll !== 'function')
        return;
    rootEl.querySelectorAll('[data-w],[data-l],[data-r],[data-fg],[data-bg]').forEach(function (n) {
        var ds = n.dataset;
        if (ds.w != null)
            n.style.width = ds.w + '%';
        if (ds.l != null)
            n.style.left = ds.l + '%';
        if (ds.r != null)
            n.style.right = ds.r + '%';
        if (ds.fg)
            n.style.color = ds.fg;
        if (ds.bg)
            n.style.backgroundColor = ds.bg;
    });
}
function _sanitizeUrl(url) {
    if (typeof url !== 'string' || !url)
        return '#';
    // Strip leading whitespace / control chars that browsers silently skip
    var trimmed = url.replace(/^[\s\u0000-\u001f]+/, '');
    if (/^(javascript|data|vbscript):/i.test(trimmed))
        return '#';
    return url;
}
function setMetricWithSource(elId, value, source) {
    var el = document.getElementById(elId);
    if (!el)
        return;
    // Detect changes for flash animation (compare old vs new text)
    var oldText = el.textContent;
    el.textContent = value;
    if (source)
        el.title = 'Source: ' + source;
    // Flash if value changed (parse numeric portions for direction)
    if (oldText && oldText !== '\u2014' && oldText !== value) {
        var oldNum = parseFloat((oldText || '').replace(/[^0-9.\-]/g, ''));
        var newNum = parseFloat((value || '').replace(/[^0-9.\-]/g, ''));
        if (!isNaN(oldNum) && !isNaN(newNum) && Math.abs(oldNum - newNum) > 0.001) {
            _flashElement(el, newNum > oldNum ? 'up' : 'down');
        }
    }
}
function _resolveDataSource(d) {
    var p = d.price || {};
    // S42 task #17 item 4: DB-first snapshot tier. Marked _source: "db" by
    // services/db_snapshot.py when serving from local PG+SQLite+CSV rather
    // than a live provider. Rendered as "from Oxford Ledge database" so
    // users see clear provenance; the background enrichment fetch is
    // already running and will replace this with live data on the next
    // request cycle.
    if (d._source === 'db' || p.source === 'db')
        return 'from Oxford Ledge database';
    if (d._source === 'ticker_cache')
        return 'cached';
    if (p.source === 'fmp' || d.fmpProfile)
        return 'via FMP';
    // BOARD Q10 (2026-09-28, T19): an unrecognised source used to read "via
    // Finnhub". Name only the providers the quote chain has (fetch_info's
    // finnhub / massive / cache); anything else is '' and callers say so.
    if (p.source === 'finnhub')
        return 'via Finnhub';
    if (p.source === 'massive')
        return 'via Massive';
    if (p.source === 'cache')
        return 'cached';
    return '';
}
// BOARD Q6 (2026-09-28): the ticker view names its ticker in the tab title; a view in _OL_VIEW_TITLES (QA P3-17:
// bdc) names itself; every other view keeps the page's own title, restored by setView (view-router.ts) on the way out.
var _olBaseTitle = null;
var _olTickerTitle = '';
var _OL_VIEW_TITLES = { bdc: 'BDC browser \u00B7 Private credit \u2014 Oxford Ledge' };
function _olSyncTickerTitle(next) {
    if (_olBaseTitle === null)
        _olBaseTitle = document.title;
    if (typeof next === 'string')
        _olTickerTitle = next;
    const onTicker = typeof currentView === 'undefined' || currentView === 'ticker';
    document.title = (onTicker && _olTickerTitle) ? _olTickerTitle : ((!onTicker && _OL_VIEW_TITLES[String(currentView)]) || _olBaseTitle);
}
// #158 (2026-06-09): "incomplete load after hard refresh" — below-the-fold
// ticker panels whose render fns live in the lazy 'research' chunk were called
// BARE inside their fire-once _lazyPanel observer. On a cold hard-refresh the
// chunk is still in flight, so the bare call no-ops (typeof guard) or throws a
// swallowed ReferenceError, the observer sets fired=true, and the panel stays
// BLANK with no re-fire when the chunk arrives ~100ms later (fixed only by a
// 2nd refresh that warms the chunk cache). This generalizes the 2026-06-02
// insider-panel fix: try now; if the gating global isn't defined yet, load the
// chunk via lazy-loader's deduped loadChunk and retry ONCE. `ready` probes the
// gating global with a bare `typeof name === 'function'` (NOT window[name] —
// bundled fns aren't reliably window props).
function _renderOrChunkRetry(ready, render, chunk, onFail) {
    if (ready()) {
        render();
        return;
    }
    var _retried = false;
    // 2026-09-28: onFail paints an honest error, never an endless "loading" (peers).
    var _fail = function () { if (onFail) {
        try {
            onFail();
        }
        catch (_e) { /* defensive */ }
    } };
    function _go() {
        if (ready()) {
            render();
            return;
        }
        if (_retried) {
            _fail();
            return;
        }
        _retried = true;
        try {
            // QA 2026-09-03: window.OxfordChunks never existed on the dashboard, so this retry half was INERT since #158 -- prefer the real _loadChunk global (verified live); OxfordChunks kept as legacy fallback.
            var _lc = (typeof _loadChunk === 'function') ? _loadChunk : (window.OxfordChunks || {}).loadChunk;
            if (typeof _lc === 'function') {
                _lc(chunk || 'research').then(_go).catch(_fail);
            }
            else {
                _fail();
            }
        }
        catch (_e) {
            _fail(); /* fail closed — no crash */
        }
    }
    _go();
}
// The honest end state for the peers panel when its chunk never arrives.
function _peersPanelUnavailable() {
    var c = document.getElementById('peers-panel-content');
    if (!c)
        return;
    var s = document.createElement('span');
    s.className = 'pv-msg-muted';
    s.textContent = 'Peer comparison could not load — refresh to retry.';
    c.textContent = '';
    c.appendChild(s);
}
// §RENDER-DATA ═════════════════════════════════════════════════════════════════
function renderData(d) {
    if (typeof currentView !== 'undefined' && currentView !== 'ticker')
        return;
    // BUG FIX 2026-04-25: first-time visitors landing on /?view=ticker&symbol=…
    // were stuck on the welcome-flow loading bridge ("Preparing your research
    // view…") because _dismissLoadingBridge was only called by
    // _startGuidedTour (which fires only on ?walkthrough=1). When ticker
    // data actually renders, the bridge has done its job — dismiss it here.
    if (typeof _dismissLoadingBridge === 'function') {
        try {
            _dismissLoadingBridge();
        }
        catch (_e) { }
    }
    _clearLazyPanels(); // Cancel stale lazy observers from previous ticker
    _hideTickerSkeleton();
    // #82 Fix B (2026-07-22): a valid payload arriving AFTER an earlier failure
    // painted LoadingStates.showError('ticker-view', …) must clear that banner —
    // otherwise the stale .load-error div stays appended and the hero reads as a
    // dead / all-dashes page even though fresh data just rendered (the observed
    // LDOS late-200 terminal-dashes bug: 11 of 15 /api/data hits returned 200 yet
    // the hero never re-hydrated). clearError is a no-op when no banner is present.
    if (typeof LoadingStates !== 'undefined' && typeof LoadingStates.clearError === 'function') {
        try {
            LoadingStates.clearError('ticker-view');
        }
        catch (_e) { /* defensive */ }
    }
    _updatePhaseIndicator(d.dataPhase, d.fetchedAt || d.lastUpdated, _quoteIsNotCurrent(d));
    const p = d.price || {};
    const m = d.metrics || {};
    const f = d.financials || {};
    const div = d.dividends || {};
    const earn = d.earnings || {};
    const si = d.shortInterest || {};
    const spark = d.sparkline || {};
    // ── C10 Error Taxonomy: contextual data status messages ──
    (function _renderDataStatus() {
        // Remove any previous status banner
        var prev = document.getElementById('data-status-banner');
        if (prev)
            prev.remove();
        var status = d._data_status;
        if (!status || status === 'complete')
            return;
        var msg = d._data_status_msg || '';
        var bannerClass = 'data-status-banner';
        var html = '';
        if (status === 'invalid_ticker') {
            // Full replacement — show centered error
            var tv = document.getElementById('ticker-view');
            if (tv) {
                var overlay = document.createElement('div');
                overlay.id = 'data-status-banner';
                overlay.className = bannerClass + ' data-status-invalid';
                overlay.innerHTML = '<div class="tk-invalid-overlay">'
                    + '<div class="tk-invalid-icon">\u26A0</div>'
                    + '<div class="tk-invalid-msg">' + escHtml(msg || 'Invalid ticker symbol') + '</div>'
                    + '<div class="tk-invalid-hint">Try a different ticker</div></div>';
                tv.prepend(overlay);
            }
            return;
        }
        if (status === 'api_unavailable') {
            html = '<div id="data-status-banner" class="' + bannerClass + ' data-status-api-down tk-banner-api-down">'
                + '\u26A0 ' + escHtml(msg || 'Market data temporarily unavailable. Showing cached data where available.') + '</div>';
        }
        else if (status === 'no_financials') {
            html = '<div id="data-status-banner" class="' + bannerClass + ' data-status-no-fin tk-banner-no-fin">'
                + escHtml(msg) + '</div>'; // Wave 9: the U+2139 + VS16 emoji prefix is gone (BRAND.md)
        }
        else if (status === 'partial') {
            html = '<div id="data-status-banner" class="' + bannerClass + ' data-status-partial tk-banner-partial">'
                + escHtml(msg) + '</div>';
        }
        if (html) {
            var container = document.getElementById('ticker-view') || document.getElementById('main-content');
            if (container) {
                var tmp = document.createElement('div');
                tmp.innerHTML = html;
                container.prepend(tmp.firstChild);
            }
        }
    })();
    // ETF detection — hide stock-only sections, adapt metrics
    var _isETF = false;
    try {
        var _etfSet = new Set(['SPY', 'QQQ', 'DIA', 'IWM', 'IVV', 'VOO', 'VTI', 'GLD', 'SLV', 'TLT', 'HYG', 'LQD', 'BND', 'AGG',
            'XLF', 'XLE', 'XLK', 'XLV', 'XLI', 'XLP', 'XLU', 'XLY', 'XLB', 'XLRE', 'XLC', 'VGT', 'VHT', 'ARKK', 'ARKW', 'ARKG',
            'TQQQ', 'SQQQ', 'VEA', 'VWO', 'EFA', 'EEM', 'IEFA', 'IEMG', 'SCHD', 'VIG', 'VYM', 'VNQ', 'IBIT', 'FBTC',
            'ONEQ', 'SCHB', 'MDY', 'IJR', 'IJH', 'RSP', 'SPXL', 'UPRO', 'SOXL', 'USO', 'UNG', 'GDX', 'IAU',
            'IEF', 'SHY', 'TIP', 'VCIT', 'VCSH', 'MUB', 'JNK', 'EMB', 'BNDX', 'DVY', 'HDV', 'NOBL', 'DGRO',
            'ICLN', 'TAN', 'LIT', 'HACK', 'BOTZ', 'UVXY', 'SVXY']);
        _isETF = _etfSet.has(d.ticker) || (d.profile && d.profile.isETF) || (d.type === 'ETF');
    }
    catch (e) { }
    window._currentIsETF = _isETF;
    // 2026-06-02 (OWNER browser-pass): the SSR "Opening a company file"
    // orientation tile auto-hides via body.has-active-ticker — but that class was
    // referenced in CSS + a comment yet NEVER SET, so the tile lingered on every
    // ticker view (and read as "can't be closed"). S6 (first-time-user audit,
    // 2026-09-25): boot always paints a ticker, so stamping on the FIRST paint hid
    // the tile unread; stamp only once _olOrientTileShouldHide (welcome-flow.ts)
    // has seen a SECOND distinct ticker in this tab. One-way; dismissal unchanged.
    try {
        const _oh = window._olOrientTileShouldHide;
        if (d && d.ticker && (typeof _oh !== 'function' || _oh(String(d.ticker))))
            document.body.classList.add('has-active-ticker');
    }
    catch (_e) { /* noop */ }
    if (_isETF) {
        // Hide sections not applicable to ETFs
        ['insider-feed-section', 'earnings-info', 'short-interest-detail', 'transcripts-section'].forEach(function (id) {
            var el = document.getElementById(id);
            if (el)
                el.classList.add('d-none');
        });
        // Hide earnings row in hero
        var earnEl = document.getElementById('next-earnings');
        if (earnEl)
            earnEl.classList.add('d-none');
        // Render ETF-specific data (holdings, sectors)
        if (typeof renderETFData === 'function')
            renderETFData(d.ticker);
    }
    else {
        // Restore visibility for non-ETF tickers (in case user switches from ETF to stock)
        ['insider-feed-section', 'earnings-info', 'short-interest-detail', 'transcripts-section'].forEach(function (id) {
            var el = document.getElementById(id);
            if (el)
                el.classList.remove('d-none');
        });
        var earnEl = document.getElementById('next-earnings');
        if (earnEl)
            earnEl.classList.remove('d-none');
        if (typeof hideETFPanel === 'function')
            hideETFPanel();
    }
    // Company name: prefer d.company, fall back to companyInfo.name if d.company is just the ticker
    var _heroCompany = d.company || '';
    if (!_heroCompany || _heroCompany === d.ticker) {
        var _ci = d.companyInfo || d.profile || {};
        _heroCompany = _ci.name || _ci.longName || _ci.shortName || d.company || d.ticker || '\u2014';
    }
    if (d.ticker)
        _olSyncTickerTitle(d.ticker + ((_heroCompany && _heroCompany !== d.ticker && _heroCompany !== '\u2014') ? ' \u00B7 ' + _heroCompany : '') + ' \u2014 Oxford Ledge');
    // #158: replaced the cap/link emoji (&#127891; / &#128279;) with hairline
    // inline SVGs — BRAND.md §Iconography bans emoji on public surfaces (#146
    // house pattern). currentColor inherits each control's color; pointer-events
    // none keeps the click target on the button/anchor, not the glyph.
    // Company-facts button removed 2026-06-09 (OWNER): it was a no-op next to the
    // company name; superseded by the Company Overview + financial detail below.
    const _linkIcon = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" class="tk-inline-icon"><path d="M14 4h6v6"/><path d="M20 4 11 13"/><path d="M18 14v4a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4"/></svg>';
    const _compName = $id('company-name');
    if (_compName)
        _compName.innerHTML = escHtml(_heroCompany.toUpperCase()) + (d.ticker ? ' <a href="/stock/' + encodeURIComponent(d.ticker) + '/" class="btn-ghost hero-public-link" title="View public stock page (SEO, shareable)" target="_blank" rel="noopener">' + _linkIcon + '</a>' : '');
    const _tickerHero = $id('ticker-hero');
    if (_tickerHero)
        _tickerHero.textContent = d.ticker || '\u2014';
    // Wei: API hint for expert users
    (function () {
        var _existingHint = document.querySelector('.hero-api-hint');
        var _sl = OLStorage.getString('skillLevel', null) || '';
        var _ul = OLStorage.getString('_userLevel', null) || OLStorage.getString('ol_user_level', null) || '';
        if (_sl === 'expert' || _sl === 'EXP' || _ul === 'expert') {
            if (!_existingHint && _tickerHero && _tickerHero.parentElement) {
                var _hintEl = document.createElement('span');
                _hintEl.className = 'hero-api-hint';
                _hintEl.innerHTML = 'Available via API &middot; <code class="ol-api-hint-code">pip install ol-sdk</code>';
                _hintEl.className = 'csp-metric-hint';
                _hintEl.title = 'Access this ticker programmatically via the Oxford Ledge SDK';
                _tickerHero.parentElement.appendChild(_hintEl);
            }
        }
        else if (_existingHint) {
            _existingHint.remove();
        }
    })();
    updateBrokerageLinks(d.ticker);
    const priceHeroEl = $id('price-hero');
    const chgEl = $id('change-hero');
    // Ensure ARIA live regions are set for screen reader announcements of price updates
    if (priceHeroEl && !priceHeroEl.getAttribute('aria-live'))
        priceHeroEl.setAttribute('aria-live', 'polite');
    if (chgEl && !chgEl.getAttribute('aria-live'))
        chgEl.setAttribute('aria-live', 'polite');
    // Issue 9: Show dash instead of misleading +0.00 when no price data.
    // Wave-2 F1 (2026-07-16 prod-QA): the limited-coverage store returns
    // current === 0 (not null) for thin tickers — `!= null` passed, the hero's
    // own `if (p.current)` truthiness painted the dash, but the change branch
    // still ran with chg=0/pct=0 and fabricated "+0.00 (+0.00%)" beside "—".
    // A real listed equity never trades at $0.00: zero/negative/NaN is
    // no-data, and both hero + change must agree on that.
    const hasPrice = !!(p && p.current != null && Number(p.current) > 0);
    if (d && d._vendor_prices_withheld) {
        olPriceWithheldHero(priceHeroEl, chgEl, d);
    }
    else if (!hasPrice) {
        if (priceHeroEl)
            priceHeroEl.textContent = '\u2014';
        if (chgEl) {
            chgEl.textContent = 'Price unavailable';
            chgEl.className = 'change-hero neu';
        }
    }
    // 2026-10-03 (long-tail quote investigation): a NULL change is unknown, not
    // flat -- a one-bar snapshot has no prior close. Paint a dash, never +0.00.
    const chgMissing = p.change == null || p.changePct == null;
    const chg = p.change || 0, pct = p.changePct || 0;
    const sign = chg >= 0 ? '+' : '';
    // Determine extended-hours state (debounced to prevent badge flicker — max once per 2s)
    const extData = _getExtHoursInfo(p);
    var _extNow = Date.now();
    var _extBadgeThrottled = (_extNow - _extBadgeLastUpdate) < 2000;
    if (hasPrice && extData && p.current) {
        if (!_extBadgeThrottled) {
            _extBadgeLastUpdate = _extNow;
            // Market closed with ext-hours data: show ext price as hero, close underneath
            if (priceHeroEl)
                priceHeroEl.innerHTML = `<span class="hero-ext-price-color">$${fmt(extData.price)}</span><span class="ext-badge">${escHtml(extData.label)}</span>`;
            const extChgSign = extData.chg >= 0 ? '+' : '';
            const extChgCls = extData.chg > 0 ? 'color-positive' : extData.chg < 0 ? 'color-negative' : 'color-neutral';
            if (chgEl) {
                chgEl.innerHTML = `<span class="chg-dynamic ${escHtml(extChgCls)}">${escHtml(extChgSign)}${fmt(extData.chg)} (${escHtml(extChgSign)}${fmt(extData.pct)}%)</span>`;
                chgEl.className = 'change-hero gainloss-cell ' + (extData.chg > 0 ? 'pos' : extData.chg < 0 ? 'neg' : 'neu');
            }
        }
    }
    else if (hasPrice) {
        // Market open or no ext data: show regular close price.
        // #180 (2026-08-16, live-traced): every hero text write for this render
        // is queued into _heroWrites and flushed in ONE rAF at the bottom of
        // this branch. The prior shape animated the price synchronously while
        // the change rebuild waited on its own rAF \u2014 so for >=1 painted frame
        // the growing price string coexisted with the OLD full-width change
        // text, pushing #hero-primary across its flex-wrap threshold and
        // bouncing #hero-right to a second line and back (the RUM cls_sources
        // flap; observed live on BRK.B: price-hero 165.8->181.3px width with
        // hero-right 42->64px in the same layout-shift entry). Each animated
        // element also reserves its FINAL string width in `ch` (font-data is
        // monospace + tabular-nums in CSS, so length-in-ch is exact) BEFORE the
        // count-up starts \u2014 the transient strings cannot widen the row, and the
        // change pill cannot collapse on its empty-then-rebuild frame.
        // min-width is ASSIGNED every render, never accumulated, so a wide
        // symbol (BRK.A) cannot leave a stale reservation on the next one.
        var _heroWrites = [];
        if (priceHeroEl) {
            if (p.current) {
                (function (_el, _val) {
                    var _dec = Math.abs(_val) >= 1 ? 2 : 4;
                    var _num = _val.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: _dec });
                    var _final = '$' + _num;
                    // Same fixed-width count-up as the change pill below: pin the frames
                    // to the SETTLED value's digit count so no frame can print wider than
                    // the `ch` reservation. Inert for a >= $1 price (always 2 decimals) —
                    // it matters for a sub-dollar ticker, where the settled string may be
                    // 3 decimals while a frame prints 4.
                    var _numDec = (_num.split('.')[1] || '').length;
                    _heroWrites.push(function () {
                        var _curLen = (_el.textContent || '').length;
                        _el.style.minWidth = Math.max(_final.length, _curLen) + 'ch';
                        _animateNumber(_el, _val, 400, '$', '', { fixedDecimals: _numDec });
                    });
                })(priceHeroEl, p.current);
            }
            else {
                _heroWrites.push(function () {
                    priceHeroEl.textContent = '\u2014';
                    priceHeroEl.style.minWidth = '';
                });
            }
        }
        if (chgEl) {
            // #101-1b: on a degraded/stale snapshot, the abs change and the pct
            // can come from different refresh cycles — yielding a self-
            // contradictory pair (e.g. "+0.00 (+0.68%)" or sign(chg)!=sign(pct)).
            // Per the #96 morning-brief discipline: never DISPLAY a misleading
            // value — show an honest cached/neutral delta instead of fabricating.
            var _degraded = !!(d._provider_degraded || d._stale);
            var _chgRoundsZero = Math.abs(chg) < 0.005;
            var _pctNonTrivial = Math.abs(pct) >= 0.01;
            var _signMismatch = (chg > 0 && pct < 0) || (chg < 0 && pct > 0);
            // 2026-09-28 audit: when the only price is a COMPLETED session's close
            // (quoteKind previous_close -- the Massive free-plan fallback), the hero
            // must say so. It rendered MSFT's prior close as a live-looking price with
            // a fabricated "+0.00 (+0.00%)" day change. Server shape: api/quote_kind.py.
            // M3 (CHAOS 2026-10-03): previous_close is checked BEFORE chgMissing -- a
            // previous close has no day change by construction, and testing chgMissing
            // first would replace "Prev close (date)" with a bare dash.
            if (p.quoteKind === 'previous_close') {
                var _pcLabel = 'Prev close' + (p.previousCloseDate ? ' (' + String(p.previousCloseDate) + ')' : '');
                _heroWrites.push(function () {
                    chgEl.className = 'change-hero neu';
                    chgEl.style.minWidth = '';
                    chgEl.textContent = _pcLabel;
                });
            }
            else if (chgMissing) {
                _heroWrites.push(function () { chgEl.className = 'change-hero neu'; chgEl.style.minWidth = ''; chgEl.textContent = '—'; });
            }
            else if (_degraded && ((_chgRoundsZero && _pctNonTrivial) || _signMismatch)) {
                _heroWrites.push(function () {
                    chgEl.className = 'change-hero neu';
                    chgEl.style.minWidth = '';
                    chgEl.textContent = '— cached';
                });
            }
            else {
                var _chgCls = 'change-hero ' + (chg > 0 ? 'pos' : chg < 0 ? 'neg' : 'neu');
                if (chg !== 0 || pct !== 0) {
                    // The class write rides in the same batched frame as the rebuild —
                    // the pill background must not change a frame before its text does.
                    (function (_c, _pv, _cls) {
                        var _cd = Math.abs(_c) >= 1 ? 2 : 4;
                        var _chgNum = _c.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: _cd });
                        var _chgFinal = (_c >= 0 ? '+' : '')
                            + _chgNum
                            + ' (' + (_pv >= 0 ? '+' : '')
                            + _pv.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '%)';
                        // #180's `ch` reservation is a min-width — a FLOOR — so it cannot stop
                        // a count-up frame printing MORE digits than the settled value and
                        // widening the pill through it (measured 2026-08-17: 0.3526 of a
                        // 0.3604 CLS). Pin the frames to the settled digit count. Full
                        // per-frame evidence: tests/test_ticker_hero_cls_batching_contract.py.
                        var _chgDec = (_chgNum.split('.')[1] || '').length;
                        _heroWrites.push(function () {
                            chgEl.className = _cls;
                            var _curLen = (chgEl.textContent || '').length;
                            chgEl.style.minWidth = Math.max(_chgFinal.length, _curLen) + 'ch';
                            chgEl.textContent = '';
                            var chgSpan = document.createElement('span');
                            var pctSpan = document.createElement('span');
                            chgEl.appendChild(chgSpan);
                            chgEl.appendChild(document.createTextNode(' ('));
                            chgEl.appendChild(pctSpan);
                            chgEl.appendChild(document.createTextNode(')'));
                            _animateNumber(chgSpan, _c, 400, _c >= 0 ? '+' : '', '', { fixedDecimals: _chgDec });
                            _animateNumber(pctSpan, _pv, 400, _pv >= 0 ? '+' : '', '%', { fixedDecimals: 2 });
                        });
                    })(chg, pct, _chgCls);
                }
                else {
                    _heroWrites.push(function () {
                        chgEl.className = _chgCls;
                        chgEl.style.minWidth = '';
                        chgEl.textContent = `${sign}${fmt(chg)} (${sign}${fmt(pct)}%)`;
                    });
                }
            } // end honest-degradation else
        } // end if (chgEl)
        // #180 ONE flush (same painted frame). QA 2026-09-03: rAF never fires
        // in a HIDDEN tab (hero stayed a dash, payload cached) — flush sync there.
        if (_heroWrites.length) {
            var _fh = function () { for (var _wi = 0; _wi < _heroWrites.length; _wi++)
                _heroWrites[_wi](); };
            if (document.visibilityState === 'hidden') {
                _fh();
            }
            else {
                requestAnimationFrame(_fh);
            }
        }
    }
    // Close price line (shown under ext-hours hero, hidden otherwise)
    const heroPrimary = $id('hero-primary');
    let closeLineEl = $id('hero-close-line');
    if (!closeLineEl && heroPrimary) {
        closeLineEl = document.createElement('div');
        closeLineEl.id = 'hero-close-line';
        heroPrimary.insertBefore(closeLineEl, chgEl);
    }
    if (closeLineEl) {
        if (extData && p.current) {
            closeLineEl.innerHTML = chgMissing ? `Close: $${fmt(p.current)}` : `Close: $${fmt(p.current)} <span class="gainloss-cell"><span class="hero-close-chg ${chg >= 0 ? 'color-positive' : 'color-negative'}">${escHtml(sign)}${fmt(chg)} (${escHtml(sign)}${fmt(pct)}%)</span></span>`;
            closeLineEl.classList.remove('d-none');
        }
        else {
            closeLineEl.classList.add('d-none');
            closeLineEl.textContent = '';
        }
    }
    // Legacy ext-hours span (remove if exists, we now show it in the hero itself)
    let extEl = $id('ext-hours-hero');
    if (!extEl && heroPrimary) {
        extEl = document.createElement('span');
        extEl.id = 'ext-hours-hero';
        if (chgEl)
            heroPrimary.insertBefore(extEl, chgEl.nextSibling);
        else
            heroPrimary.appendChild(extEl);
    }
    if (extEl)
        extEl.textContent = '';
    // ── "AS OF · delayed" stripe — CHAMP §5.5 (queued task 2026-05-27) ──
    // Users in CHAMP user-sim round 3 repeatedly asked "is this real-time
    // or delayed?". Per `feedback_user_trust`, the only honest answer is a
    // small ambient stripe that names the timestamp + the delay. Per
    // `feedback_zero_ux_friction`, muted/small/ambient — NOT a banner.
    // Branches:
    //   delayed    (asOf <= 24h old)      → "AS OF HH:MM ET · delayed"
    //   stale      (asOf > 24h old)       → "AS OF YYYY-MM-DD · market closed"
    //   missing    (no asOf)              → render nothing (no fake stamp)
    // OWNER 2026-09-26 ("we do not have real time quotes"): the "live" branch
    // (delayMinutes === 0) and the "<N>-min delayed" suffix are gone. No feed is
    // real-time, and delayMinutes is a convention the fetch path stamps
    // (data_fetching.py sets 15 for every quote), not a measured delay -- so the
    // stripe states only what is true: the time and that the quote is delayed.
    let asOfEl = $id('hero-as-of-stripe');
    if (!asOfEl && heroPrimary) {
        asOfEl = document.createElement('div');
        asOfEl.id = 'hero-as-of-stripe';
        asOfEl.className = 'hero-as-of-stripe';
        // Insert immediately after the change-hero so it sits directly
        // beneath the price/change line as a sub-line — ambient, not a banner.
        if (chgEl && chgEl.nextSibling) {
            heroPrimary.insertBefore(asOfEl, chgEl.nextSibling);
        }
        else if (chgEl) {
            heroPrimary.appendChild(asOfEl);
        }
        else {
            heroPrimary.appendChild(asOfEl);
        }
    }
    if (asOfEl) {
        const asOfRaw = p.asOf;
        if (!asOfRaw) {
            // Missing data — render nothing (per scope: don't fake a timestamp)
            asOfEl.textContent = '';
            asOfEl.classList.add('hidden');
        }
        else {
            let asOfDate = null;
            try {
                asOfDate = new Date(asOfRaw);
            }
            catch (e) {
                asOfDate = null;
            }
            if (!asOfDate || isNaN(asOfDate.getTime())) {
                asOfEl.textContent = '';
                asOfEl.classList.add('hidden');
            }
            else {
                const ageMs = Date.now() - asOfDate.getTime();
                const ageHours = ageMs / 3600000;
                let stripeText = '';
                // BOARD Q10 (2026-09-28, T17): the clock is CONVERTED to New York time
                // (it printed the reader's local getHours() under an "ET" label), and a
                // quote older than a day says how old it is instead of "market closed"
                // -- which it printed during trading hours whenever a stale quote was
                // served. A date-only asOf (the daily-close snapshot) has no clock.
                const _dateOnly = /^\d{4}-\d{2}-\d{2}$/.test(String(asOfRaw));
                const _etDate = _dateOnly ? String(asOfRaw)
                    : asOfDate.toLocaleDateString('en-CA', { timeZone: 'America/New_York' });
                // CHAOS F10 (2026-09-28): a date-only asOf that IS the latest session's
                // close is current, not stale -- "Close of <date>". The latest close is
                // on or after the last weekday before today in New York (holidays are
                // not modelled, so the day after one reads "Not updated since").
                const _prevSess = new Date(new Date(Date.now()).toLocaleDateString('en-CA', { timeZone: 'America/New_York' }) + 'T12:00:00Z');
                do {
                    _prevSess.setUTCDate(_prevSess.getUTCDate() - 1);
                } while (_prevSess.getUTCDay() === 0 || _prevSess.getUTCDay() === 6);
                if (p.quoteKind === 'previous_close') {
                    // A completed session's close (9c9df6ce): name the session, never "delayed".
                    stripeText = 'PREVIOUS CLOSE · ' + (p.previousCloseDate ? String(p.previousCloseDate) : _etDate);
                }
                else if (p.quoteKind === 'session_close') {
                    stripeText = p.closeLabel || 'Last close'; // market closed at fetch (2026-10-10 QA)
                }
                else if (_dateOnly && _etDate >= _prevSess.toISOString().slice(0, 10)) {
                    stripeText = 'Close of ' + _etDate;
                }
                else if (ageHours > 24 || _dateOnly) {
                    stripeText = 'Not updated since ' + _etDate;
                }
                else {
                    const _etTime = asOfDate.toLocaleTimeString('en-GB', { timeZone: 'America/New_York', hour: '2-digit', minute: '2-digit', hour12: false });
                    stripeText = 'AS OF ' + _etTime + ' ET · delayed';
                }
                asOfEl.textContent = stripeText;
                asOfEl.classList.remove('hidden');
            }
        }
    }
    // 1M / 1Y return labels beneath change hero
    let returnsEl = $id('hero-returns-line');
    if (!returnsEl && heroPrimary) {
        returnsEl = document.createElement('div');
        returnsEl.id = 'hero-returns-line';
        returnsEl.className = 'csp-returns-row gainloss-cell';
        heroPrimary.appendChild(returnsEl);
    }
    if (returnsEl)
        returnsEl.classList.add('gainloss-cell');
    if (hasPrice && p.current) {
        let returnsParts = [];
        // CYCLE-G F2 (2026-05-28): sparkline window is 60d (services/
        // db_snapshot.py:247 _fetch_sparkline limit=60), ordered DESC and
        // then reversed before emit -- so spark.prices[0] is the OLDEST
        // close in the window (~60 trading days ago, NOT 1M). The original
        // code computed (current/prices[0] - 1) and labelled it "1M",
        // producing a return ~3x the true 1M figure. Two-branch fix:
        //   (A) If the sparkline carries >=21 closes (~1 trading month),
        //       index from the END (-21) to get the true 1M anchor and
        //       label "1M" accurately.
        //   (B) Otherwise (shorter window), label honestly as the actual
        //       window length in trading days rather than fabricating
        //       a 1M reading from a non-1M anchor.
        if (spark.prices && spark.prices.length > 5) {
            var sparkLen = spark.prices.length;
            var anchorIdx, anchorLabel;
            if (sparkLen >= 21) {
                anchorIdx = sparkLen - 21;
                anchorLabel = '1M';
            }
            else {
                anchorIdx = 0;
                anchorLabel = sparkLen + 'd';
            }
            var anchorPrice = spark.prices[anchorIdx];
            if (anchorPrice && anchorPrice > 0) {
                var mPct = ((p.current / anchorPrice - 1) * 100).toFixed(1);
                var mCls = mPct > 0 ? 'color-positive' : mPct < 0 ? 'color-negative' : 'color-neutral';
                returnsParts.push('<span class="returns-span ' + mCls + '">' + anchorLabel + ' ' + (mPct >= 0 ? '+' : '') + mPct + '%</span>');
            }
        }
        // 1Y return: compute from 52-week low/high midpoint or yearReturn if available
        if (p.yearReturn != null) {
            var yPct = p.yearReturn.toFixed(1);
            var yCls = yPct > 0 ? 'color-positive' : yPct < 0 ? 'color-negative' : 'color-neutral';
            returnsParts.push('<span class="returns-span ' + yCls + '">1Y ' + (yPct >= 0 ? '+' : '') + yPct + '%</span>');
        }
        else if (p.week52Low && p.week52High) {
            // Show 52W position as context
            var range52 = p.week52High - p.week52Low;
            if (range52 > 0) {
                // #101-2: clamp to [0,100] — a stale current outside the cached
                // 52W range must never render an impossible >100% position.
                var pos52 = Math.min(100, Math.max(0, (p.current - p.week52Low) / range52 * 100)).toFixed(0);
                returnsParts.push('<span class="returns-span-52w">52W ' + pos52 + '%</span>');
            }
        }
        if (returnsEl) {
            returnsEl.innerHTML = returnsParts.join('');
            returnsEl.classList.toggle('hidden', returnsParts.length === 0);
        }
    }
    else {
        if (returnsEl) {
            returnsEl.classList.add('hidden');
            returnsEl.innerHTML = '';
        }
    }
    // Bid/Ask spread — populate detail row field
    const hBidAsk = $id('h-bidask');
    if (p.bid != null && p.ask != null && p.bid > 0 && p.ask > 0) {
        const spread = Math.abs(p.ask - p.bid);
        const spreadPct = p.ask > 0 ? (spread / p.ask * 100) : 0;
        if (hBidAsk)
            hBidAsk.innerHTML = `$${fmt(p.bid)} / $${fmt(p.ask)} <span class="hero-bidask-detail">($${fmt(spread)}, ${spreadPct.toFixed(2)}%)</span>`;
        const _heroDetailBidAsk = $id('hero-detail-bidask');
        if (_heroDetailBidAsk)
            _heroDetailBidAsk.classList.remove('hidden');
    }
    else {
        if (hBidAsk) {
            hBidAsk.textContent = '\u2014';
            hBidAsk.title = 'Bid/Ask not available — market may be closed';
        }
    }
    // Extended hours price — populate detail row field
    const hExtPrice = $id('h-ext-price');
    const heroDetailExt = $id('hero-detail-ext');
    if (extData) {
        const extSign = extData.chg >= 0 ? '+' : '';
        const extCls = extData.chg > 0 ? 'color-positive' : extData.chg < 0 ? 'color-negative' : 'color-neutral';
        if (hExtPrice) {
            hExtPrice.innerHTML = `$${fmt(extData.price)} <span class="gainloss-cell"><span class="hero-ext-detail-chg ${escHtml(extCls)}">${escHtml(extSign)}${fmt(extData.chg)} (${escHtml(extSign)}${fmt(extData.pct)}%)</span></span> <span class="hero-ext-detail-label">${escHtml(extData.label)}</span>`;
            hExtPrice.title = '';
        }
        if (heroDetailExt)
            heroDetailExt.classList.remove('hidden');
    }
    else {
        if (hExtPrice) {
            hExtPrice.textContent = '\u2014';
            hExtPrice.title = 'No pre/post-market trading data available';
        }
    }
    // Day range — use sparkline data if available
    const hDayRange = $id('h-day-range');
    const hDayRangeLabel = $id('h-day-range-label');
    if (hDayRange) {
        if (p.high != null && p.low != null && p.high > 0 && p.low > 0) {
            // CYCLE-G F2 (2026-05-28): true intraday range from FMP dayHigh/dayLow
            // (data/ticker_cache.py:179-180 maps to p.high/p.low). Use this when
            // the quote envelope carries live intraday OHLC.
            hDayRange.textContent = '$' + fmt(p.low) + ' – $' + fmt(p.high);
            hDayRange.title = '';
            if (hDayRangeLabel)
                hDayRangeLabel.textContent = 'Day range';
        }
        else if (spark && spark.prices && spark.prices.length > 0) {
            // CYCLE-G F2 (2026-05-28): sparkline window is 60d
            // (services/db_snapshot.py:247 limit=60), NOT intraday. A reduce
            // over spark.prices produces a 60-DAY range. Mislabelling that as
            // "Day range" produced the GOOG "$273.14-$386.40" bug. Fall back
            // to an HONEST "60d range" label rather than fabricating an
            // intraday spread. Same honesty impulse as the T1 derived 52W range
            // (#101-2 lineage): show what the data supports, never a fabricated span.
            const sparkLow = spark.prices.reduce((a, b) => a < b ? a : b, Infinity);
            const sparkHigh = spark.prices.reduce((a, b) => a > b ? a : b, -Infinity);
            hDayRange.textContent = '$' + fmt(sparkLow) + ' \u2013 $' + fmt(sparkHigh);
            hDayRange.title = 'Intraday high/low not available; showing 60-day window from sparkline.';
            if (hDayRangeLabel)
                hDayRangeLabel.textContent = '60d range';
        }
        else {
            if (hDayRangeLabel)
                hDayRangeLabel.textContent = 'Day range';
            hDayRange.textContent = '\u2014';
            hDayRange.title = 'Day range unavailable — market may not have opened yet';
        }
    }
    // Avg volume
    const hAvgVol = $id('h-avg-volume');
    if (hAvgVol) {
        if (p.avgVolume) {
            hAvgVol.textContent = fmtVol(p.avgVolume);
            hAvgVol.title = '';
        }
        else {
            hAvgVol.textContent = '\u2014';
            hAvgVol.title = 'Average volume data not yet available';
        }
    }
    // Dividend yield
    const hDivYield = $id('h-div-yield');
    if (hDivYield) {
        if (m.dividendYield) {
            hDivYield.textContent = fmt(m.dividendYield, 1) + '%';
            hDivYield.title = '';
        }
        else {
            hDivYield.textContent = '\u2014';
            hDivYield.title = 'This company does not pay a dividend';
        }
    }
    // Next earnings date (secondary row)
    const hNextEarn = $id('h-next-earnings');
    const _hNed = _validNextEarningsDate(earn.nextDate);
    if (hNextEarn) {
        if (_hNed) {
            const ed = new Date(_hNed + 'T00:00:00');
            const now = new Date();
            const daysUntil = Math.ceil((ed - now) / 86400000);
            const dateStr = ed.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
            hNextEarn.innerHTML = escHtml(dateStr) + (daysUntil > 0 ? ` <span class="color-positive fs-10">(${daysUntil}d)</span>` : '');
            hNextEarn.title = '';
        }
        else if (_irPublishedEntry(earn)) {
            // #256 stage e: a company-announced date from the issuer's own IR
            // calendar (v201 store, provenance PUBLISHED). Stated as such — it
            // outranks the OL cadence estimate but never overwrites nextDate.
            try {
                const _ir = _irPublishedEntry(earn);
                const _ird = new Date(_ir.date + 'T00:00:00');
                const _irStr = _ird.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
                hNextEarn.innerHTML = escHtml(_irStr) + ' <span class="fs-10">IR calendar</span>';
                hNextEarn.title = "Announced on the company's investor-relations calendar";
            }
            catch (_e) {
                hNextEarn.textContent = '—';
            }
        }
        else if (earn.olEstimate && earn.olEstimate.estimates && earn.olEstimate.estimates.length) {
            // #125: SEC-cadence OL estimate \u2014 ALWAYS labelled, never dressed as a
            // published date (honesty contract in data/earnings_estimator.py).
            try {
                const _oe = earn.olEstimate.estimates[0];
                const _oed = new Date(_oe.date + 'T00:00:00');
                const _oeStr = _oed.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
                hNextEarn.innerHTML = '~' + escHtml(_oeStr) + ' <span class="fs-10">OL est.</span>';
                hNextEarn.title = 'Oxford Ledge estimate from the company\u2019s 8-K filing cadence (\u00b1' + (_oe.window_days || 0) + ' days) \u2014 not a company-announced date';
            }
            catch (_e) {
                hNextEarn.textContent = '\u2014';
            }
        }
        else {
            hNextEarn.textContent = '\u2014';
            hNextEarn.title = 'Next earnings date not announced yet';
        }
    }
    // Legacy bid-ask element (keep for backward compat but hide — data now in detail row)
    let bidAskEl = $id('bid-ask-hero');
    if (!bidAskEl && heroPrimary) {
        bidAskEl = document.createElement('div');
        bidAskEl.id = 'bid-ask-hero';
        heroPrimary.appendChild(bidAskEl);
    }
    if (bidAskEl) {
        bidAskEl.classList.add('hidden');
        bidAskEl.innerHTML = '';
    }
    var _src = _resolveDataSource(d) || 'not recorded';
    // BOARD Q10 (2026-09-28, T19): `_mCalc` was declared further down (the P1-3
    // block), so this line read the hoisted `var` as undefined and the tooltip
    // said "Source: via FMPundefined". Declared here, where it is first used.
    var _mCalc = p.marketCap && !d.fmpProfile ? ' (calculated)' : '';
    setMetricWithSource('h-volume', fmtVol(p.volume), _src);
    setMetricWithSource('h-mktcap', fmtMktCap(p.marketCap), _src + _mCalc);
    // T1 (2026-07-14 OWNER prod-QA): the 52W high/low off the quote envelope
    // (company_core.week_52_high) can go STALE, and a stale value produced a
    // self-contradicting hero \u2014 a live price of $125.20 sitting ABOVE a "52W
    // high" of $120.00, and a 60d sparkline high of $130.85 EXCEEDING the 52W
    // high (logically impossible). The prior #101-2 code just annotated
    // "(intraday extreme \u2014 52W range refreshing)" \u2014 a band-aid over numbers that
    // were simply wrong. Instead DERIVE the displayed range so it can never be
    // lower than a value already on the page: bound the high by
    // max(cached 52W high, live price, 60d sparkline high) and the low by the
    // symmetric min. Applied to BOTH the h-high/h-low metric cells and the 52W
    // range bar so the whole hero stays internally consistent when the cached
    // field lags. (The main price chart's y-axis is drawn by chart-engine from a
    // separately-fetched series, not available synchronously here; the 60d
    // sparkline is the freshest bound we hold at render time.)
    var _spHi = -Infinity, _spLo = Infinity;
    if (spark && spark.prices && spark.prices.length) {
        for (var _si = 0; _si < spark.prices.length; _si++) {
            var _sp = spark.prices[_si];
            if (typeof _sp === 'number' && _sp > 0) {
                if (_sp > _spHi)
                    _spHi = _sp;
                if (_sp < _spLo)
                    _spLo = _sp;
            }
        }
    }
    var _eff52High = p.week52High
        ? Math.max(p.week52High, p.current || 0, _spHi === -Infinity ? 0 : _spHi)
        : null;
    var _eff52Low = p.week52Low
        ? Math.min(p.week52Low, p.current || Infinity, _spLo === Infinity ? Infinity : _spLo)
        : null;
    const hHigh = $id('h-high');
    const hLow = $id('h-low');
    if (hHigh) {
        hHigh.textContent = _eff52High != null ? '$' + fmt(_eff52High) : '\u2014';
        hHigh.title = 'Source: ' + _src;
    }
    if (hLow) {
        hLow.textContent = _eff52Low != null ? '$' + fmt(_eff52Low) : '\u2014';
        hLow.title = 'Source: ' + _src;
    }
    // "Updated X min ago" from fetchedAt
    updateHeroTimestamp(d);
    startHeroTimestampInterval(d);
    startStatusbarFreshnessTimer();
    if (_eff52High != null && _eff52Low != null && p.current) {
        const range = _eff52High - _eff52Low;
        const _rawPos = range > 0 ? ((p.current - _eff52Low) / range * 100) : 50;
        // The derived range now contains `current` and the 60d window by
        // construction, so the position is naturally in [0,100] and the old
        // stale-range "intraday extreme" annotation is gone. Keep the clamp as a
        // belt-and-suspenders guard against a NaN/degenerate spark array.
        const _clamped = Math.min(100, Math.max(0, _rawPos));
        const pos = _clamped.toFixed(1);
        const _weekFill = $id('week-fill');
        if (_weekFill)
            _weekFill.style.width = pos + '%';
        const weekDot = $id('week-dot');
        if (weekDot)
            weekDot.style.left = pos + '%';
        const _wkLow = $id('wk-low');
        if (_wkLow)
            _wkLow.textContent = '$' + fmt(_eff52Low);
        const _wkHigh = $id('wk-high');
        if (_wkHigh)
            _wkHigh.textContent = '$' + fmt(_eff52High);
        const _wkPct = $id('wk-pct');
        if (_wkPct)
            _wkPct.textContent = pos + '%';
    }
    // P1-3: Determine data source per metric for attribution
    var _mSrc = _resolveDataSource(d) || 'not recorded';
    // Financial ratios come from EDGAR (XBRL 10-K/10-Q) via company DB;
    // price-derived metrics (P/E, yield) combine EDGAR earnings + live price
    var _fSrc = f.revenue || f.netIncome ? 'SEC EDGAR' : (d.fmpProfile ? 'FMP' : _mSrc);
    const metrics = [
        ['P/E (TTM)', m.pe != null ? (m.pe < 0 ? 'N/M' : fmt(m.pe, 1) + 'x') : '<span class="metric-na" title="Not reported — company may be pre-revenue or an ETF/fund">\u2014</span>', true, 'Price-to-Earnings: How much investors pay per $1 of earnings. Lower = cheaper. TTM = trailing 12 months. [Source: ' + _mSrc + ']'],
        ['P/E (Fwd)', m.forwardPe != null ? (m.forwardPe < 0 ? 'N/M' : fmt(m.forwardPe, 1) + 'x') : '<span class="metric-na" title="No analyst estimates available for forward earnings">\u2014</span>', false, 'Forward P/E: Uses estimated future earnings. [Source: ' + _mSrc + ']'],
        ['EV/EBITDA', m.evEbitda ? fmt(m.evEbitda, 1) + 'x' : '<span class="metric-na" title="Not available — company may have negative EBITDA or insufficient data">\u2014</span>', true, 'Enterprise Value / EBITDA: Total company value vs. operating profit. More comprehensive than P/E. [Source: ' + _fSrc + ']'],
        ['P/B', m.pb ? fmt(m.pb, 2) + 'x' : '<span class="metric-na" title="Not reported — book value data unavailable for this company">\u2014</span>', false, 'Price-to-Book: Stock price vs. net asset value. Below 1.0x = below book. [Source: ' + _mSrc + ']'],
        ['P/S', m.ps ? fmt(m.ps, 2) + 'x' : '<span class="metric-na" title="Not reported — revenue data unavailable">\u2014</span>', false, 'Price-to-Sales: Market cap / revenue. Useful for unprofitable companies. [Source: ' + _fSrc + ']'],
        ['Debt/Equity', m.debtEquity ? fmt(m.debtEquity, 2) : '<span class="metric-na" title="Not reported — balance sheet data unavailable">\u2014</span>', false, 'Total debt / shareholders\' equity. Higher = more leveraged. [Source: ' + _fSrc + ']'],
        ['Div Yield', m.dividendYield ? fmt(m.dividendYield, 1) + '%' : '<span class="metric-na" title="This company does not pay a dividend">\u2014</span>', true, 'Annual dividend as % of stock price. [Source: ' + _mSrc + ']'],
        ['ROE', m.roe ? fmt(m.roe, 1) + '%' : '<span class="metric-na" title="Not reported — earnings or equity data unavailable">\u2014</span>', false, 'Return on Equity: Profit efficiency with shareholder money. 15%+ is strong. [Source: ' + _fSrc + ']'],
        ['ROA', m.roa ? fmt(m.roa, 1) + '%' : '<span class="metric-na" title="Not reported — earnings or asset data unavailable">\u2014</span>', false, 'Return on Assets: Profit per dollar of assets. 5%+ is good. [Source: ' + _fSrc + ']'],
        ['ROIC', d.roic ? fmt(d.roic, 1) + '%' : '<span class="metric-na" title="Requires net income, debt, and equity data to calculate">\u2014</span>', false, 'Return on Invested Capital: Efficiency of ALL capital. 15%+ is excellent. [Source: ' + _fSrc + ']'],
        ['FCF Yield', (_fcfYieldFor(d) != null) ? fmt(_fcfYieldFor(d), 1) + '%' : '<span class="metric-na" title="Free cash flow data not available for this company">\u2014</span>', true, 'Free Cash Flow Yield: FCF / market cap. Above 5% is attractive. [Source: ' + _fSrc + ']'],
    ];
    // Sector median benchmarks for P/E, EV/EBITDA, P/B in the metrics panel
    const _mSectorMed = computeSectorMedians(d.ticker || activeTicker);
    const _metricMedMap = { 'P/E (TTM)': ['pe', m.pe, 'x'], 'EV/EBITDA': ['evEbitda', m.evEbitda, 'x'], 'P/B': ['pb', m.pb, 'x'] };
    var _isNewUser = !OLStorage.getString('_metricHintSeen', null);
    var _miTicker = d.ticker || activeTicker;
    const _metricsRowsEl = $id('metrics-rows');
    if (_metricsRowsEl)
        _metricsRowsEl.innerHTML = metrics.map(([label, val, hi, tip], idx) => {
            const medInfo = _metricMedMap[label];
            const medAnnotation = (medInfo && _mSectorMed && _mSectorMed[medInfo[0]] != null) ? _sectorMedianAnnotation(medInfo[1], _mSectorMed[medInfo[0]], medInfo[2]) : '';
            // Layer 2: Pulse the first 3 help icons for new users so they discover hover explanations
            const pulseClass = (_isNewUser && idx < 3) ? ' metric-help-pulse' : '';
            const helpIcon = tip ? `<span class="metric-help${pulseClass}" data-gloss="${escHtml(label)}" title="${escHtml(tip)}">?</span>` : '';
            // #137 (OWNER 2026-06-04): the per-row plain-English sentence was
            // removed — ~9 stacked paragraphs read as "way too much". The table is
            // now compact (label · value); a consolidated "What stands out" 3-bullet
            // summary of the most impactful metrics renders below (#metrics-summary).
            // MetricInsights.getInsight is retained (API + pr25 contract) but no
            // longer rendered inline.
            return `<div class="metric-row${tip ? ' metric-row-help' : ''}">
      <span class="metric-label">${olMetricLabel(label, m)}${helpIcon}</span>
      <span class="metric-val ${hi ? 'highlight' : ''}" title="Source: ${escHtml(_src)}">${val}${medAnnotation}</span>
    </div>`;
        }).join('');
    // Valuation panel provenance label (per-metric tooltips still show exact source)
    var _valSrcEl = document.getElementById('val-source-label');
    if (!_valSrcEl) {
        var _mRows = document.getElementById('metrics-rows');
        if (_mRows) {
            _valSrcEl = document.createElement('div');
            _valSrcEl.id = 'val-source-label';
            _valSrcEl.className = 'panel-source-label';
            _mRows.parentNode.insertBefore(_valSrcEl, _mRows.nextSibling);
        }
    }
    if (_valSrcEl) {
        var _valSources = _mSrc === _fSrc ? _mSrc : (_mSrc + ' · ' + _fSrc);
        // #47 1.11/T4 (2026-07-06): pointer-neutral copy — "hover" is a lie on
        // touch devices (the majority of this view's traffic per the mobile
        // audit). "select" covers hover AND tap/focus. The full tap-to-reveal
        // path for title=-only tooltips is the tracked Wave-B follow-up.
        // #83 T4 (OWNER): "hover" was a lie on touch; "tap" names the real
        // affordance — the ? icons open the gloss popover on tap AND click.
        _valSrcEl.textContent = 'Source: ' + _valSources + ' — tap any ? for detail';
    }
    // #137 (OWNER 2026-06-04): consolidated "What stands out" summary —
    // up to 3 bullets for the most impactful metrics (replaces the per-row
    // sentences). Rendered just below the compact metric table + source label.
    var _valSummaryEl = document.getElementById('metrics-summary');
    if (!_valSummaryEl) {
        var _mRows2 = document.getElementById('metrics-rows');
        if (_mRows2 && _mRows2.parentNode) {
            _valSummaryEl = document.createElement('div');
            _valSummaryEl.id = 'metrics-summary';
            _valSummaryEl.className = 'metric-summary';
            var _summaryAnchor = document.getElementById('val-source-label') || _mRows2;
            _summaryAnchor.parentNode.insertBefore(_valSummaryEl, _summaryAnchor.nextSibling);
        }
    }
    if (_valSummaryEl) {
        var _topInsights = (typeof MetricInsights !== 'undefined' && MetricInsights.getTopInsights)
            ? MetricInsights.getTopInsights(_miTicker, m, d, p, 3) : [];
        if (_topInsights && _topInsights.length) {
            _valSummaryEl.innerHTML = '<div class="metric-summary-head">What stands out</div>'
                + '<ul class="metric-summary-list">'
                + _topInsights.map(function (s) { return '<li>' + escHtml(s) + '</li>'; }).join('')
                + '</ul>';
            _valSummaryEl.classList.remove('hidden');
        }
        else {
            _valSummaryEl.innerHTML = '';
            _valSummaryEl.classList.add('hidden');
        }
    }
    // #137 (OWNER 2026-06-04): the "Tap any ? for a plain-English
    // explanation" hint banner was REMOVED — the ? icon next to each term
    // is self-explanatory. The ? help icons (with hover/tap tooltips) stay;
    // only the instructional banner is gone. `_isNewUser` still drives the
    // subtle first-3-icon pulse above.
    // Issue 10: Show notice when all metrics are empty/unavailable.
    // 2026-04-26: copy now reflects actual cause when known —
    // window._olProviderDegraded is set by /api/health/providers poll
    // in app.js. Replaces the generic "temporarily unavailable" with
    // honest framing that names the provider quota state.
    if (!m || (!m.pe && !m.forwardPe && !m.evEbitda && !m.pb && !m.ps && !m.debtEquity && !m.dividendYield && !m.roe && !m.roa)) {
        var metricsNotice = document.getElementById('metrics-rows');
        if (metricsNotice) {
            var _emCopy = window._olProviderDegraded
                ? 'Metrics not loaded — daily provider quota reached. Cached values resume after 00:00 UTC.'
                : 'Metrics not loaded yet for this ticker. Try refreshing in a moment.';
            metricsNotice.insertAdjacentHTML('beforeend', '<div class="metrics-unavailable">' + _emCopy + '</div>');
        }
    }
    // analyst row -- OWNER ruling 4 (2026-09-28): no Buy/Hold/Sell pill, no bare
    // price target. analystConsensusHtml (ticker-renderer-consensus.ts) renders
    // count + mean target + source + as-of together, or "none on file".
    const _analystBar = $id('analyst-bar');
    if (_analystBar)
        _analystBar.innerHTML = typeof analystConsensusHtml === 'function' ? analystConsensusHtml(d) : '';
    // #82 (2026-07-18 QA): dataPhase 1 means "phase-1 quote, enrichment
    // coming" ONLY for live provider payloads. A db-snapshot payload
    // (_source 'db') IS the complete record -- earnings/dividends/short
    // interest are genuinely absent and no phase-2 re-render is coming
    // (observed live: BAC weekend payload held the Earnings card as a
    // skeleton forever). Skeleton only while genuinely enriching.
    const _phase1Enriching = d.dataPhase === 1
        && d._source !== 'db';
    if (_phase1Enriching && !(div.history && div.history.length > 0)) {
        const _divRows = document.getElementById('dividend-rows');
        if (_divRows)
            _divRows.innerHTML = '<div class="loading-skeleton-text skel-wrap-pad"><span class="skel-bar skel-bar-lg"></span></div>';
        const _nextExdiv = document.getElementById('next-exdiv');
        if (_nextExdiv)
            _nextExdiv.textContent = '';
    }
    else {
        const divHistory = (div.history || []);
        let divHtml = divHistory.map(dh => `<div class="div-row">
        <span class="div-quarter">${escHtml(dh.quarter || '')}</span>
        <span class="div-amount">$${fmt(dh.amount, 2)}</span>
        <span class="div-date">${escHtml(dh.exDate || '')}</span>
      </div>`).join('');
        if (div.annualAmount) {
            divHtml += `<div class="div-row div-row-annual"><span class="div-quarter">Annual</span><span class="div-amount">$${fmt(div.annualAmount, 2)}</span><span></span></div>`;
        }
        const _divRowsEl2 = document.getElementById('dividend-rows');
        if (_divRowsEl2)
            _divRowsEl2.innerHTML = divHtml || '<span class="dim-msg-sm">No dividend data</span>';
        var _divSrcEl = document.getElementById('div-source-label');
        if (!_divSrcEl && _divRowsEl2) {
            _divSrcEl = document.createElement('div');
            _divSrcEl.id = 'div-source-label';
            _divSrcEl.className = 'panel-source-label';
            _divRowsEl2.parentNode.insertBefore(_divSrcEl, _divRowsEl2.nextSibling);
        }
        if (_divSrcEl)
            _divSrcEl.textContent = 'Source: FMP dividends history';
        // Next ex-div date - estimate if past
        let exDivHtml = '';
        if (div.nextExDate) {
            const exDate = new Date(div.nextExDate + 'T00:00:00');
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            if (exDate < today) {
                // Estimate next ex-div: add ~90 days (quarterly) to the last known date
                const estimated = new Date(exDate);
                estimated.setDate(estimated.getDate() + 91);
                while (estimated < today)
                    estimated.setDate(estimated.getDate() + 91);
                const estStr = estimated.toISOString().slice(0, 10);
                // BOARD Q10 (2026-09-28): the +91-day step assumes a quarterly payer;
                // the label now says so rather than presenting it as a schedule.
                exDivHtml = `<span class="upcoming-badge badge-exdiv" title="Estimated: last ex-dividend date plus 91-day steps. Assumes the company pays quarterly.">Est. Next Ex-Div (if quarterly): ~${escHtml(estStr)}</span>`;
            }
            else {
                const daysUntil = Math.ceil((exDate - today) / 86400000);
                const countdown = daysUntil === 0 ? 'today' : `in ${daysUntil} days`;
                exDivHtml = `<span class="upcoming-badge badge-exdiv">Next Ex-Div: ${escHtml(div.nextExDate)} · ${countdown}</span>`;
            }
        }
        const _nextExdivEl2 = document.getElementById('next-exdiv');
        if (_nextExdivEl2)
            _nextExdivEl2.innerHTML = exDivHtml;
    }
    // Earnings with countdown and surprise table
    if (_phase1Enriching && !earn.nextDate && !(earn.surpriseHistory && earn.surpriseHistory.length > 0)) {
        const _earnInfoSkel = document.getElementById('earnings-info');
        if (_earnInfoSkel)
            _earnInfoSkel.innerHTML = '<div class="loading-skeleton-text skel-wrap-pad"><span class="skel-bar skel-bar-lg"></span></div>';
    }
    else {
        let earnHtml = '';
        const _cNed = _validNextEarningsDate(earn.nextDate);
        if (_cNed) {
            let countdown = '';
            try {
                const ed = new Date(_cNed + 'T00:00:00');
                const now = new Date();
                const diffMs = ed.getTime() - now.getTime();
                const diffDays = Math.ceil(diffMs / (1000 * 60 * 60 * 24));
                if (diffDays > 0)
                    countdown = ` <span class="earn-countdown">\u00b7 in ${diffDays} days</span>`;
                else if (diffDays === 0)
                    countdown = ` <span class="earn-countdown">\u00b7 today</span>`;
                else
                    countdown = ` <span class="earn-countdown">\u00b7 reported</span>`;
            }
            catch (e) { }
            earnHtml += `<span class="upcoming-badge badge-earnings">Next Earnings: ${escHtml(_cNed)}${countdown}</span><br>`;
        }
        else if (_irPublishedEntry(earn)) {
            // #256 stage e: company-announced date from the issuer's IR calendar —
            // provenance stated inline; source link is hygiene-gated upstream and
            // ESCAPED here, never fetched.
            const _ir2 = _irPublishedEntry(earn);
            const _irTitle2 = "Announced on the company's investor-relations calendar"
                + (_ir2.source_url ? ' — ' + _ir2.source_url : '');
            earnHtml += `<span class="upcoming-badge badge-earnings" title="${escHtml(_irTitle2)}">Next Earnings (IR calendar): ${escHtml(_ir2.date)}</span><br>`;
        }
        else if (earn.olEstimate && earn.olEstimate.estimates && earn.olEstimate.estimates.length) {
            // #125: labelled OL estimate (SEC 8-K cadence) — see honesty contract.
            const _oe1 = earn.olEstimate.estimates[0];
            earnHtml += `<span class="upcoming-badge badge-earnings" title="Oxford Ledge estimate from the company's 8-K filing cadence — not a company-announced date">Next Earnings (OL est.): ~${escHtml(_oe1.date)} ±${_oe1.window_days || 0}d</span><br>`;
        }
        if (earn.epsEstimate != null) {
            earnHtml += `<div class="metric-row metric-row-mt6" data-gloss="EPS"><span class="metric-label">EPS Est${earn.epsEstimatePeriod ? ' (' + escHtml(earn.epsEstimatePeriod) + ')' : ''}</span><span class="metric-val highlight">${fmtUsd(earn.epsEstimate, 2)}</span></div>`;
        }
        if (earn.epsPrior != null) {
            earnHtml += `<div class="metric-row" data-gloss="EPS"><span class="metric-label">EPS Prior</span><span class="metric-val">$${fmt(earn.epsPrior, 2)}</span></div>`;
        }
        if (earn.surpriseHistory && earn.surpriseHistory.length > 0) {
            earnHtml += `<table class="data-table earnings-table"><thead><tr><th>Quarter</th><th>Est</th><th>Actual</th></tr></thead><tbody>`;
            earn.surpriseHistory.slice(0, 4).forEach(s => {
                const beatMissCls = s.actual != null && s.estimate != null ? (s.actual > s.estimate ? 'color-positive' : s.actual < s.estimate ? 'color-negative' : '') : '';
                earnHtml += `<tr>
        <td>${escHtml(s.quarter || '')}</td>
        <td>${s.estimate != null ? '$' + fmt(s.estimate, 2) : '\u2014'}</td>
        <td class="${beatMissCls}">${s.actual != null ? '$' + fmt(s.actual, 2) : '\u2014'}</td>
      </tr>`;
            });
            earnHtml += `</tbody></table>`;
        }
        // EXT-AUDIT T1 (#52): d.earnings === null = section not fetched (thin
        // snapshot / aborted phase) — only an earnings object with no rows is a
        // confirmed "none on file". The false claim shipped for AAPL.
        const _earnInfoEl = document.getElementById('earnings-info');
        if (_earnInfoEl)
            _earnInfoEl.innerHTML = earnHtml || '<span class="dim-msg-sm">' + (window._olProviderDegraded ? 'Earnings cached — provider quota reached for today' : (d.earnings == null ? 'Earnings are still syncing — refresh to retry.' : 'No earnings on file for this ticker')) + '</span>';
        var _earnSrcEl = document.getElementById('earn-source-label');
        if (!_earnSrcEl && _earnInfoEl) {
            _earnSrcEl = document.createElement('div');
            _earnSrcEl.id = 'earn-source-label';
            _earnSrcEl.className = 'panel-source-label';
            _earnInfoEl.parentNode.insertBefore(_earnSrcEl, _earnInfoEl.nextSibling);
        }
        if (_earnSrcEl)
            _earnSrcEl.textContent = 'Source: SEC EDGAR 8-K + FMP estimates';
    } // end earnings phase check
    // Short Interest
    if (_phase1Enriching && si.pctOfFloat == null) {
        const _shortInfoSkel = document.getElementById('short-info');
        if (_shortInfoSkel)
            _shortInfoSkel.innerHTML = '<div class="loading-skeleton-text skel-wrap-pad"><span class="skel-bar skel-bar-lg"></span></div>';
    }
    else {
        let siHtml = _squeezeWatchBadge(si);
        const siHighClass = si.pctOfFloat >= 10 ? 'badge-short-high' : 'badge-short-low';
        if (si.pctOfFloat != null) {
            siHtml += `<div class="metric-row" data-gloss="Short Interest"><span class="metric-label">Short % Float</span><span class="metric-val"><span class="upcoming-badge ${siHighClass}">${fmt(si.pctOfFloat, 1)}%</span></span></div>`;
        }
        if (si.sharesShort) {
            siHtml += `<div class="metric-row" data-gloss="Short Interest"><span class="metric-label">Shares Short</span><span class="metric-val">${fmtVol(si.sharesShort)}</span></div>`;
        }
        if (si.costToBorrow != null) {
            siHtml += `<div class="metric-row" data-gloss="Cost to Borrow"><span class="metric-label">Cost to Borrow</span><span class="metric-val">${fmt(si.costToBorrow, 1)}%</span></div>`;
        }
        if (si.daysToCover != null) {
            siHtml += `<div class="metric-row" data-gloss="Days to Cover"><span class="metric-label">Days to Cover</span><span class="metric-val">${fmt(si.daysToCover, 1)}</span></div>`;
        }
        // 2026-06-09 (DESIGN trust): the empty copy named "FINRA … not yet
        // ingested", which no pipeline feeds. BOARD Q10 (2026-09-28, T16): the
        // same was true of the SOURCE label below, which still said FINRA. The
        // numbers come from Finnhub's company-metrics feed (api/finnhub_api.py
        // shortInterestPercentOfFloat / shortRatio -> data_fetching.py
        // short_interest); the comment here that said "yfinance" was stale.
        // EXT-AUDIT T1 (#52): null section = not fetched, not absent.
        const _shortInfoEl = document.getElementById('short-info');
        if (_shortInfoEl)
            _shortInfoEl.innerHTML = siHtml || '<span class="dim-msg-sm">' + (d.shortInterest == null ? 'Short interest is still syncing — refresh to retry.' : 'Short-interest data not available for this ticker.') + '</span>';
        var _siSrcEl = document.getElementById('si-source-label');
        if (!_siSrcEl && _shortInfoEl) {
            _siSrcEl = document.createElement('div');
            _siSrcEl.id = 'si-source-label';
            _siSrcEl.className = 'panel-source-label';
            _shortInfoEl.parentNode.insertBefore(_siSrcEl, _shortInfoEl.nextSibling);
        }
        if (_siSrcEl)
            _siSrcEl.textContent = siHtml ? 'Source: Finnhub company metrics' : '';
    }
    _renderFinTable(d, f); // Financials table (extracted 2026-09-01)
    // Financials panel provenance label
    var _finSourceEl = document.getElementById('fin-source-label');
    if (!_finSourceEl) {
        var _finWrap = document.getElementById('fin-table-wrap');
        if (_finWrap) {
            _finSourceEl = document.createElement('div');
            _finSourceEl.id = 'fin-source-label';
            _finSourceEl.className = 'panel-source-label';
            _finWrap.appendChild(_finSourceEl);
        }
    }
    if (_finSourceEl) {
        _finSourceEl.textContent = 'Source: ' + _fSrc + (d._source === 'fmp_auto' ? ' (auto-populated)' : '');
    }
    // OWNER 2026-06-09: link the Financials (TTM) panel to the full multi-year
    // fundamentals page. Created once + reused across re-renders (like the
    // source label above). Plain in-app href so the SPA router handles it.
    var _finFullLink = document.getElementById('fin-full-link');
    if (!_finFullLink) {
        var _finWrap2 = document.getElementById('fin-table-wrap');
        if (_finWrap2) {
            _finFullLink = document.createElement('a');
            _finFullLink.id = 'fin-full-link';
            _finFullLink.className = 'fin-full-link';
            _finWrap2.appendChild(_finFullLink);
        }
    }
    if (_finFullLink) {
        _finFullLink.setAttribute('href', '/?view=fundamentals&symbol=' + encodeURIComponent(d.ticker || activeTicker || ''));
        _finFullLink.textContent = 'View full financials →';
    }
    // News (8-10 items, clickable links).
    // 2026-04-26: dropped the phase-1-skeleton-lock branch. Previously
    // an empty d.news on phase 1 kept the skeleton, and if phase 2
    // failed (FMP quota exhausted, network), the skeleton stayed
    // forever. Now: empty d.news shows the empty-state copy
    // immediately on phase 1; if phase 2 brings news, it replaces the
    // empty state with content. Honest UX, no phantom loaders.
    {
        // #140 (OWNER 2026-06-04): show ALL recent-news items. Previously a
        // .slice(0, 5) + a "Showing N of M most recent" footer signaled that
        // more existed but gave NO way to reach the rest (OWNER: "unable to
        // access the next 10 items"). The backend already bounds d.news to a
        // recent window, so rendering them all gives full access without a
        // dead-end footer. (Supersedes CR-L1's truncate-and-footer for news;
        // the INSIDER feed keeps its tier-gate footer — see valuation-trends.)
        const _newsItems = (d.news || []);
        const _newsListEl = document.getElementById('news-list');
        if (_newsListEl)
            _newsListEl.innerHTML = _newsItems.map(n => {
                const _nSafeUrl = _sanitizeUrl(n.url);
                const headlineContent = n.url
                    ? `<a href="${escHtml(_nSafeUrl)}" target="_blank" rel="noopener noreferrer nofollow">${escHtml(n.headline)}</a>`
                    : escHtml(n.headline);
                const recency = newsRecencyClass(n.date);
                return `<div class="news-item ${recency}">
        <div class="news-headline">${headlineContent}</div>
        <div class="news-meta">
          <span class="news-source">${escHtml(n.source || '')}</span>
          <span>${escHtml(n.date || '')}</span>
          ${typeof creditTagsHtml === 'function' ? creditTagsHtml(n.headline) : ''}
        </div>
      </div>`;
            }).join('') || '<div class="dim-msg">' + (window._olProviderDegraded ? 'News feed cached — provider quota reached for today' : 'No recent news on file for this ticker') + '</div>';
        // #140 (OWNER 2026-06-04): the panel-level "Source: Oxford Ledge
        // archive" provenance label was REMOVED — each news row already cites
        // its own source inline (.news-source), so the aggregate label was
        // redundant chrome. (The per-item source is the honest, granular
        // attribution; a rolled-up panel label added noise without value.)
    }
    // 2026-04-26: same fix as news — empty d.filings shows the empty-
    // state copy immediately, no phase-1-skeleton-lock that strands
    // the user on FMP-quota-exhausted sessions.
    {
        // EXT-AUDIT T1 (#52): d.filings === null means the section was NOT
        // FETCHED (thin cached snapshot / aborted phase fetch) — only a real []
        // is a confirmed absence. "No recent SEC filings" for AAPL was a fetch
        // gap presented as fact. The D2 rule: failures say retry, never "none".
        const _filingsUnknown = (d.filings == null);
        const _filingsListEl = document.getElementById('filings-list');
        if (_filingsListEl)
            _filingsListEl.innerHTML = (_filingsUnknown || (typeof olPhase2SectionPending === 'function' && olPhase2SectionPending(d, 'filings') && !d.filings.length))
                ? '<div class="dim-msg">Filings are still syncing — refresh to retry.</div>'
                : _filingsWithAsk(d, (d.filings || []).map(f => {
                    const _fSafeUrl = _sanitizeUrl(f.url);
                    const desc = f.url
                        ? `<a href="${escHtml(_fSafeUrl)}" target="_blank" rel="noopener noreferrer nofollow">${escHtml(f.description || f.type)}</a>`
                        : escHtml(f.description || f.type);
                    return `<div class="filing-item">
        <span class="filing-type">${escHtml(f.type)}</span>
        <span class="filing-desc">${desc}</span>
        <span class="filing-date">${escHtml(f.date || '')}</span>
      </div>`;
                }).join('')) || '<div class="dim-msg">No recent SEC filings on file for this ticker</div>';
        // Filings panel provenance
        var _filingsSourceEl = document.getElementById('filings-source-label');
        if (!_filingsSourceEl) {
            var _filingsListRef = document.getElementById('filings-list');
            if (_filingsListRef) {
                _filingsSourceEl = document.createElement('div');
                _filingsSourceEl.id = 'filings-source-label';
                _filingsSourceEl.className = 'panel-source-label';
                _filingsListRef.parentNode.insertBefore(_filingsSourceEl, _filingsListRef.nextSibling);
            }
        }
        if (_filingsSourceEl) {
            _filingsSourceEl.textContent = 'Source: SEC EDGAR';
        }
    }
    // Summary - Rich Overview Panel (B3)
    try {
        renderOverviewPanel(d);
    }
    catch (e) { /* @__PURE__ */
        _olDebugError('Overview panel error:', e);
    }
    // Anomaly flags (top of ticker view, below hero)
    try {
        renderAnomalyFlags(d);
    }
    catch (e) { /* @__PURE__ */
        _olDebugError('Anomaly flags error:', e);
    }
    // Key Metrics Strip (below hero)
    try {
        renderKeyMetricsStrip(d);
    }
    catch (e) { /* @__PURE__ */
        _olDebugError('Key metrics strip error:', e);
    }
    // 5-Year Financial History (C1) — renderFiveYearHistory is a 'research'-chunk
    // canvas engine (company-panels.js). LH-1c Phase 5: gate the call on chunk
    // readiness (retry-once) like the company-profile-panel does, so a cold
    // hard-refresh doesn't silently drop the chart when the research chunk hasn't
    // loaded yet (#158 class) — and so the heavy-canvas init is explicitly off the
    // synchronous mount path (pinned by test_ticker_canvas_lazy_init_contract.py).
    // Warm path (chunk ready) renders synchronously — same timing, no new CLS.
    if (d.fiveYearHistory) {
        _renderOrChunkRetry(function () { return typeof renderFiveYearHistory === 'function'; }, function () {
            try {
                renderFiveYearHistory(d.fiveYearHistory);
            }
            catch (e) { /* @__PURE__ */
                _olDebugError('5yr history error:', e);
            }
        });
    }
    // Consensus Estimates
    try {
        renderConsensusEstimates(d);
    }
    catch (e) { /* @__PURE__ */
        _olDebugError('Consensus estimates error:', e);
    }
    // Estimate Revisions + Momentum Score — #158 retry (QA 2026-09-03: the bare typeof no-op'd forever when the research chunk was in flight; panel absent on cold loads)
    _renderOrChunkRetry(function () { return typeof renderEstimateRevisions === 'function'; }, function () { try {
        renderEstimateRevisions(d.ticker || activeTicker);
    }
    catch (e) { } });
    // Debt Maturity Schedule (standalone panel, async fetch) — lazy loaded
    if (isLive) {
        var _dtk = d.ticker || activeTicker;
        // Phase 3: low priority — deep credit analysis, not first-scan content
        _lazyPanel('debt-maturity-panel', _dtk, function () {
            try {
                renderDebtMaturityPanel(_dtk);
            }
            catch (e) { }
            try {
                renderCapitalStructurePanel(_dtk);
            }
            catch (e) { }
            try {
                renderRatingEvents(_dtk);
            }
            catch (e) { }
        }, { priority: 'low' });
        // Phase 3: critical — "what/who is this company?" is the first question
        _lazyPanel('company-profile-panel', _dtk, function () {
            // #158: these render fns are 'research'-chunk-resident; gate on chunk
            // readiness (retry-once) so a cold hard-refresh doesn't leave this
            // priority:'critical' panel (it fires at 0ms) blank.
            _renderOrChunkRetry(function () { return typeof renderCompanyProfilePanel === 'function'; }, function () {
                try {
                    renderCompanyProfilePanel(_dtk);
                }
                catch (e) { }
                try {
                    renderCorporateEventsPanel(_dtk);
                }
                catch (e) { }
                try {
                    if (typeof renderMAComps === 'function')
                        renderMAComps(_dtk);
                }
                catch (e) { }
            });
        }, { priority: 'critical' });
    }
    // Options chain — lazy loaded
    if (isLive) {
        // Phase 3: medium — premium feature, not needed by most visitors
        _lazyPanel('options-panel', d.ticker, function () {
            try {
                fetchOptions(d.ticker, '');
            }
            catch (e) { }
        }, { priority: 'medium' });
    }
    // Earnings History
    if (d.earningsHistory && d.earningsHistory.length > 0) {
        if (typeof renderEarningsHistory === 'function')
            renderEarningsHistory(d.earningsHistory);
    }
    // Institutional Holders
    if (typeof renderInstitutionalHolders === 'function') {
        renderInstitutionalHolders(d.institutionalHolders || [], d.ticker); // empty clears the MCP line
    }
    // EW-1 + EW-2 (2026-04-26): Institutional Holdings QoQ chip + top-10
    // Δ-table (renamed 2026-05-20 per OWNER directive). rename-history: smart-money
    // Renders ABOVE the canonical 13F snapshot in #hf-changes-panel.
    // Tier-gated to Plus+ via /api/institutional-holders/changes; falls
    // back to inline upgrade UI for free users.
    if (typeof renderHFChangesPanel === 'function') {
        renderHFChangesPanel(d.ticker || activeTicker);
    }
    // Revenue Segments (free, first-party EDGAR XBRL) — additive + self-hiding.
    if (typeof renderSegmentsPanel === 'function') {
        renderSegmentsPanel(d.ticker || activeTicker);
    }
    // FDIC Regulatory View (SF-FDIC Phase B) — bank-ticker only, additive +
    // self-hiding. Public-domain FDIC call-report lens for bank stocks.
    if (typeof renderFDICRegulatoryPanel === 'function') {
        renderFDICRegulatoryPanel(d.ticker || activeTicker);
    }
    // Capital Allocation Display (after 5-year history)
    if (typeof renderCapitalAllocation === 'function')
        renderCapitalAllocation(activeTicker);
    // Credit Metrics Card (top of details-panel)
    if (typeof renderCreditMetrics === 'function')
        renderCreditMetrics(d.debtInfo);
    // Debt Info Display (after capital allocation)
    if (d.debtInfo) {
        if (typeof renderDebtInfo === 'function')
            renderDebtInfo(d.debtInfo);
    }
    // Credit Health Summary Card (traffic light system)
    if (typeof renderCreditHealthCard === 'function') {
        renderCreditHealthCard(activeTicker);
    }
    // Sarah: Credit Analysis CTA link — visible shortcut to credit view
    (function () {
        var _creditCta = document.getElementById('credit-analysis-cta');
        if (!_creditCta) {
            var _chCard = document.getElementById('credit-health-card');
            if (_chCard && _chCard.parentElement) {
                _creditCta = document.createElement('div');
                _creditCta.id = 'credit-analysis-cta';
                _creditCta.className = 'data-section';
                _chCard.parentElement.insertBefore(_creditCta, _chCard.nextSibling);
            }
        }
        if (_creditCta) {
            // CR-2026-04-25: was innerHTML write. _creditCta is a sibling of
            // the chart canvas card, not a parent of one, so the live-DOM
            // risk is theoretical here — but converting to targeted DOM
            // construction makes it safe even if a future rebuild moves the
            // canvas under the same parent. Idempotent: drop existing child,
            // append fresh anchor.
            while (_creditCta.firstChild)
                _creditCta.removeChild(_creditCta.firstChild);
            var _ccLink = document.createElement('a');
            _ccLink.href = '#';
            _ccLink.setAttribute('data-action', 'navigate-credit-view');
            _ccLink.className = 'ol-credit-cta-link';
            _ccLink.title = 'Full credit analysis with bond screener, debt maturity, capital structure';
            _ccLink.textContent = 'View credit analysis \u2192';
            _creditCta.appendChild(_ccLink);
            _creditCta.classList.remove('hidden');
        }
    })();
    // Liquidity Dashboard removed 2026-06-09 (ticker-page redesign): the
    // standalone full-width dashboard was clunky; Cash/Total Debt live in the
    // Financials (TTM) panel. Hide the container so it never paints.
    var _liqPanel = document.getElementById('liquidity-dashboard-panel');
    if (_liqPanel)
        _liqPanel.classList.add('d-none');
    // Peer Comparison Table (async fetch) — lazy loaded
    // Phase 3: high — "who are the competitors?" is a top follow-up question
    _lazyPanel('peers-panel', d.ticker, function () {
        // #158: peer/similar render fns are 'research'-chunk-resident — retry-once
        // on chunk-ready so a cold hard-refresh doesn't leave the panel blank.
        _renderOrChunkRetry(function () { return typeof renderPeerComparison === 'function'; }, function () {
            renderPeerComparison(d.ticker);
            // Similar Companies Discovery (sector + ROIC proximity)
            if (typeof renderSimilarCompanies === 'function')
                renderSimilarCompanies(d.ticker);
        }, undefined, _peersPanelUnavailable);
        // Audit M1 caller review (2026-09-24): a "You have compared 5 peers. Plus
        // removes the comparison limit." toast fired here for every non-pro user.
        // There is no comparison limit on any tier -- GET /api/peers carries no
        // tier dependency (routes/routes_portfolio_fastapi/market_passthrough.py)
        // and nothing client-side counts or caps peers -- so the toast named a
        // limit the reader had not hit and a tier ("Plus") that is not sold under
        // that name. Removed rather than re-gated: re-gating it at Researcher would
        // still advertise a nonexistent limit to free users.
    }, { priority: 'high' });
    // Insider Activity — lazy loaded
    // Phase 3: high — insider signal matters to most users; load soon after peers
    _lazyPanel('insider-activity', d.ticker, function () {
        // 2026-06-02 (OWNER "not seeing Insider Activity"): renderInsiderActivity
        // lives in the 'research' chunk. If the lazy-panel fires BEFORE research
        // loads (flaky-chunk sessions — the same class as the chart-features toast),
        // the typeof check failed and the panel stayed BLANK with no re-fire when
        // the chunk later arrived. 2026-09-28: that retry went through
        // window.OxfordChunks, which never existed on the dashboard (QA 2026-09-03),
        // so it was INERT -- it now rides the shared _renderOrChunkRetry (_loadChunk).
        _renderOrChunkRetry(function () { return typeof renderInsiderActivity === 'function'; }, function () {
            renderInsiderActivity(d.ticker).then(function () { if (isLive && typeof fetchInsiderActivity === 'function')
                fetchInsiderActivity(d.ticker); }).catch(function (e) { /* @__PURE__ */ _olDebugWarn('[insider] render error:', e); });
        });
        if (isLive) {
            if (typeof renderInsiderFeed === 'function')
                renderInsiderFeed(d.ticker);
            if (typeof renderShortInterest === 'function')
                renderShortInterest(d.ticker);
            renderGovernance(d.ticker);
        }
    }, { priority: 'high' });
    // Analyst Estimates + Annotations + Transcripts — lazy loaded
    if (isLive) {
        var _t = d.ticker || activeTicker;
        // Phase 3: medium — adds context, premium-gated but visible to paying users
        _lazyPanel('analyst-estimates-panel', _t, function () {
            // #158: renderAnalystEstimates is chunk-resident + was called BARE (no
            // typeof guard) — retry-once on chunk-ready.
            _renderOrChunkRetry(function () { return typeof renderAnalystEstimates === 'function'; }, function () { renderAnalystEstimates(_t); });
        }, { priority: 'medium' });
        // Phase 3: low — user's own notes; scroll is deliberate by the time they reach it
        _lazyPanel('annotations-panel', _t, function () {
            _loadAnnotations(_t);
        }, { priority: 'low' });
        // Phase 3: medium — deep-research content; premium users expect it soon after scroll
        _lazyPanel('transcripts-section', _t, function () {
            // #158: loadTranscriptList is chunk-resident — retry-once on chunk-ready.
            _renderOrChunkRetry(function () { return typeof loadTranscriptList === 'function'; }, function () { loadTranscriptList(_t); });
        }, { priority: 'medium' });
        // These are lightweight (no network fetch or tiny payload)
        if (typeof fetchArchivedNews === 'function')
            fetchArchivedNews(_t);
        if (typeof fetchFinvizEnrichment === 'function')
            fetchFinvizEnrichment(_t);
    }
    // OWNER 2026-09-27: the status-bar UPDATED segment (#sb-updated) was
    // REMOVED as clutter, and with it the writes that lived here (its
    // lastUpdated text + the "Issue 20" DEGRADED/amber override below).
    // Per-ticker age is on the panels' .freshness-label; provider degradation
    // is disclosed by #ol-provider-banner / #stale-data-banner (next block).
    // Issue 11 (provider-degraded banner) CONSOLIDATED 2026-06-02 (#1 banner
    // de-dup). This block used to un-hide #demo-banner with "Data providers
    // degraded \u2026" on the SAME d._provider_degraded condition that already drives
    // the purpose-built #stale-data-banner below ("Data source degraded \u2014
    // showing cached data \u2026", role=status + aria-live). The two near-identical
    // top banners stacked on every degraded ticker view. #stale-data-banner now
    // owns the disclosure (it also covers the >60min data-age case AND is
    // accessible); #demo-banner is left for its DISTINCT connection/reconnect
    // state (toggled by app-init.ts / system-messages.ts). De-dup only \u2014 the
    // provider-degraded signal is still shown, just once + via the a11y banner.
    // ── DATA CZAR: Stale data disclosure banner ──
    // Show thin amber bar below metrics strip when data is >1hr old OR provider degraded
    (function _updateStaleBanner() {
        var staleBanner = document.getElementById('stale-data-banner');
        if (!staleBanner)
            return;
        var isStale = false;
        var staleMsg = 'Data may be delayed';
        var staleCause = '';
        // #1b DESIGN consolidation (2026-06-02): provider-degradation and data-age
        // are now MUTUALLY EXCLUSIVE causes (provider degradation dominates \u2014 a
        // stale age is its consequence, not an independent signal). For the
        // provider case, #ol-provider-banner is the AUTHORITATIVE disclosure (it
        // names the cause, shows the quota numbers, carries the upgrade path +
        // telemetry), so this generic restatement only fires when that banner is
        // NOT in the DOM (not yet triggered, or dismissed for the day) \u2014 the
        // degraded state is then disclosed exactly once, never zero times. The
        // staleCause tag lets _renderProviderBanner retract THIS provider variant
        // if its banner lands AFTER this render (the cold-load race: the health
        // probe resolves after the first ticker paint).
        if (d._provider_degraded) {
            if (!document.getElementById('ol-provider-banner')) {
                isStale = true;
                // EVAL-9: when the degraded payload came from the local fundamentals
                // store, _as_of is the latest fiscal year of that data \u2014 name it so
                // the user knows HOW old the cached numbers are, not just that they
                // are "outdated" (feedback_user_trust).
                var _asOf = d._as_of;
                staleMsg = _asOf
                    ? 'Data source degraded \u2014 showing cached fundamentals as of FY' + _asOf + ', some values may be outdated'
                    : 'Data source degraded \u2014 showing cached data, some values may be outdated';
                staleCause = 'provider';
            }
        }
        else {
            // Provider healthy \u2014 data age is a standalone cause (>60 min stale).
            var fetchedAt = d.fetchedAt || d.lastUpdated;
            if (fetchedAt && fetchedAt !== 'DEMO') {
                try {
                    var ts = new Date(fetchedAt);
                    if (!isNaN(ts.getTime())) {
                        var ageMin = Math.floor((Date.now() - ts.getTime()) / 60000);
                        if (ageMin > 60) {
                            isStale = true;
                            var ageStr = ageMin > 1440 ? Math.floor(ageMin / 1440) + 'd' :
                                ageMin > 60 ? Math.floor(ageMin / 60) + 'h' : ageMin + 'm';
                            staleMsg = 'Data last refreshed ' + ageStr + ' ago \u2014 values may not reflect current prices';
                            staleCause = 'age';
                        }
                    }
                }
                catch (e) { }
            }
        }
        if (isStale) {
            staleBanner.classList.remove('d-none');
            staleBanner.classList.add('stale-visible');
            staleBanner.dataset.staleCause = staleCause;
            var msgEl = document.getElementById('stale-data-msg');
            if (msgEl)
                msgEl.textContent = staleMsg;
        }
        else {
            staleBanner.classList.add('d-none');
            staleBanner.classList.remove('stale-visible');
            delete staleBanner.dataset.staleCause;
        }
    })();
    // OWNER 2026-09-28: the bottom bar's SOURCE segment (#sb-source) that named
    // the quote provider here is removed with the bar. The end-of-page footer
    // names this view's sources from services/data_source_registry.py, and
    // the ticker panel keeps its own Delayed badge.
    // Delayed badge — shown to EVERY tier whenever a live-provider quote is
    // on screen. OWNER 2026-09-26 ("we do not have real time quotes"): it used
    // to hide for Investor / Power User / Institutional (a `_realtimeTiers` set),
    // which told paying users their quote was real-time when it was the same
    // delayed payload everyone gets. The A2 rule it replaced (2026-05-12: never
    // key the badge off `d._stale`) still holds -- the badge states policy, and
    // the policy is now the same for everyone. Text and title are set here so
    // the tier-split copy in the static markup never reaches a user.
    const delayBadge = document.getElementById('price-delay-badge');
    if (delayBadge) {
        delayBadge.textContent = 'Delayed';
        delayBadge.title = 'Quotes are delayed on every plan.';
        delayBadge.classList.toggle('hidden', !isLive);
        delayBadge.style.cursor = 'default';
        delayBadge.onclick = null;
    }
    // Per-field source attribution under the price. Shows ONLY the
    // provider name (Finnhub / Massive / FMP) — freshness lives on the
    // dedicated hero-delayed-badge below, so including "(15-min delayed)"
    // here duplicated the label three times on free-tier + market-open
    // (regression spotted 2026-04-17).
    const priceSourceLabel = document.getElementById('price-source-label');
    if (priceSourceLabel && isLive) {
        if (p.source === 'finnhub') {
            priceSourceLabel.textContent = 'Finnhub';
        }
        else if (p.source === 'massive') {
            priceSourceLabel.textContent = 'Massive';
        }
        else if (p.source === 'fmp') {
            priceSourceLabel.textContent = 'FMP';
        }
        else {
            priceSourceLabel.textContent = '';
        }
    }
    else if (priceSourceLabel) {
        priceSourceLabel.textContent = '';
    }
    // The hero upsell nudge ('Real-time quotes on Investor ->') was DELETED
    // 2026-09-26, OWNER: "we do not have real time quotes". It sold a feed no
    // plan receives, and it is not replaced by another upsell. Pinned by
    // tests/test_no_realtime_quote_claims_contract.py.
    // P2-34: Behavioral scaffolding on ticker view — calm reminders on sharp moves.
    // Only show once per ticker per session via an in-memory Set to avoid nagging.
    try {
        if (!window._olBehavioralShown)
            window._olBehavioralShown = new Set();
        var _curTick = (typeof activeTicker !== 'undefined' && activeTicker) ? activeTicker : null;
        var _behNudgeEl = document.getElementById('ticker-behavioral-nudge');
        if (_curTick && hasPrice && !window._olBehavioralShown.has(_curTick)) {
            var _behMsg = null;
            var _behDir = null;
            if (pct <= -5) {
                _behMsg = 'Sharp drops often feel urgent but rarely require immediate action. Check the underlying fundamentals before deciding.';
                _behDir = 'down';
            }
            else if (pct >= 5) {
                _behMsg = 'Rapid gains can trigger FOMO. Remember, one good day isn\u2019t a thesis.';
                _behDir = 'up';
            }
            // 24-hour cooldown: avoid repeating the same-direction nudge for the same ticker too often
            if (_behMsg) {
                try {
                    var _nudgeKey = 'ol_nudge_lastShown_' + _curTick;
                    var _raw = OLStorage.getString(_nudgeKey, null);
                    if (_raw) {
                        var _parts = _raw.split('|');
                        var _lastTs = parseInt(_parts[0] || '0', 10);
                        var _lastDir = _parts[1] || '';
                        var _oneDayMs = 24 * 60 * 60 * 1000;
                        if (_lastDir === _behDir && (Date.now() - _lastTs) < _oneDayMs) {
                            _behMsg = null; // cooldown active for this direction
                        }
                    }
                }
                catch (_nudgeCdErr) { /* ignore storage errors */ }
            }
            if (_behMsg) {
                if (!_behNudgeEl) {
                    _behNudgeEl = document.createElement('div');
                    _behNudgeEl.id = 'ticker-behavioral-nudge';
                    _behNudgeEl.className = 'behavioral-nudge-banner tk-beh-nudge';
                    // Anchored on the price-source label (2026-09-26): the realtime
                    // upsell nudge it used to follow sat directly after that label and
                    // was deleted, so the banner keeps the same position.
                    if (priceSourceLabel && priceSourceLabel.parentElement) {
                        priceSourceLabel.parentElement.insertBefore(_behNudgeEl, priceSourceLabel.nextSibling);
                    }
                }
                _behNudgeEl.innerHTML = '<span class="tk-beh-nudge-msg">' + _behMsg + '</span>'
                    + '<button type="button" aria-label="Dismiss" class="tk-beh-nudge-dismiss" data-action="dismiss-beh-nudge">&times;</button>';
                _behNudgeEl.style.display = '';
                window._olBehavioralShown.add(_curTick);
                try {
                    OLStorage.setString('ol_nudge_lastShown_' + _curTick, String(Date.now()) + '|' + (_behDir || ''));
                }
                catch (_nudgeSetErr) { }
            }
            else if (_behNudgeEl) {
                _behNudgeEl.style.display = 'none';
            }
        }
        else if (_behNudgeEl) {
            _behNudgeEl.style.display = 'none';
        }
    }
    catch (_behErr) { }
    // Chart period buttons
    const tPeriods = [['1D', '1d'], ['5D', '5d'], ['1M', '1mo'], ['3M', '3mo'], ['6M', '6mo'], ['1Y', '1y'], ['YTD', 'ytd'], ['5Y', '5y'], ['10Y', '10y'], ['20Y', '20y'], ['MAX', 'max']];
    const _tPeriodBtns = document.getElementById('ticker-period-btns');
    if (_tPeriodBtns)
        _tPeriodBtns.innerHTML = tPeriods.map(([label, val]) => `<button class="ind-period-btn ${val === tickerChartPeriod ? 'active' : ''}" data-action="set-ticker-chart-period" data-period="${val}" aria-label="Period ${label}">${label}</button>`).join('');
    _updateChartModeButtons();
    // Chart provenance label
    var _chartSourceEl = document.getElementById('chart-source-label');
    if (!_chartSourceEl) {
        var _chartInfoLabel = document.getElementById('chart-info-label');
        if (_chartInfoLabel) {
            _chartSourceEl = document.createElement('div');
            _chartSourceEl.id = 'chart-source-label';
            _chartSourceEl.className = 'panel-source-label';
            _chartInfoLabel.parentNode.insertBefore(_chartSourceEl, _chartInfoLabel.nextSibling);
        }
    }
    if (_chartSourceEl) {
        var _chartSrc = p.source === 'finnhub' ? 'Finnhub' : (p.source === 'fmp' ? 'FMP' : 'Oxford Ledge cache');
        // OWNER 2026-09-26: no provider path is real-time, and no mechanism
        // guarantees a specific delay -- so a provider quote is just 'delayed'.
        var _chartDelay = (p.source === 'finnhub' || p.source === 'fmp') ? 'delayed' : 'cached';
        _chartSourceEl.textContent = 'Chart data: ' + _chartSrc + ' (' + _chartDelay + ')';
    }
    // Build chart annotations from earnings history and dividend history
    chartAnnotations = { earnings: [], dividends: [] };
    if (d.earningsHistory && d.earningsHistory.length > 0) {
        d.earningsHistory.forEach(e => {
            if (e.date) {
                chartAnnotations.earnings.push({
                    date: e.date,
                    beat: e.epsActual != null && e.epsEstimated != null ? e.epsActual >= e.epsEstimated : null
                });
            }
        });
    }
    if (earn.nextDate) {
        const exists = chartAnnotations.earnings.some(e => e.date === earn.nextDate);
        if (!exists)
            chartAnnotations.earnings.push({ date: earn.nextDate, beat: null });
    }
    if (div.history && div.history.length > 0) {
        div.history.forEach(dh => {
            if (dh.exDate)
                chartAnnotations.dividends.push({ date: dh.exDate });
        });
    }
    if (div.nextExDate) {
        const exists = chartAnnotations.dividends.some(d => d.date === div.nextExDate);
        if (!exists)
            chartAnnotations.dividends.push({ date: div.nextExDate });
    }
    // Chart — store data and render when ticker view is visible
    const _chartTitle = document.getElementById('ticker-chart-title');
    if (_chartTitle)
        _chartTitle.textContent = 'Price & Volume';
    var _chartRetries = 0;
    function _tryRenderChart() {
        // Only render if ticker view is visible (has non-zero width)
        const chartBox = document.querySelector('.chart-box');
        if (!chartBox || chartBox.clientWidth <= 0) {
            // Not visible yet — retry up to 5 times with increasing delay
            if (_chartRetries < 5) {
                _chartRetries++;
                setTimeout(_tryRenderChart, 300 * _chartRetries);
            }
            else {
                // Force chart fetch even if box not visible — data will render when view activates
                fetchTickerChart(d.ticker, tickerChartPeriod);
            }
            return;
        }
        var _chartRendered = false;
        // QA-6b: the snapshot sparkline is ~60 bars (~3 months). Draw it under 1Y only
        // when its dates span the period; otherwise fall through to the 1Y fetch.
        if (tickerChartPeriod === '1y' && _sparkCoversDays(spark, 350)) {
            renderComboChart(spark.prices, spark.volumes, spark.dates, p.avgVolume, spark.volumeData ? spark.volumeData.map(v => v.unusualVolume) : spark.unusualVolume, spark.ohlc);
            _chartRendered = true;
        }
        // Always fall through to fetchTickerChart if spark data didn't render
        if (!_chartRendered || !chartDisplayData) {
            fetchTickerChart(d.ticker, tickerChartPeriod);
        }
    }
    if (currentView === 'ticker') {
        setTimeout(_tryRenderChart, 150);
    }
    // Store for deferred render when switching to ticker view
    window._pendingChartRender = _tryRenderChart;
    // TASK #17: ambient chart-freshness badge sourced from the X-Data-Age
    // response header (middleware/data_age.py). Writes only to its own
    // sibling span (#chart-freshness-badge), never the canvas parent.
    try {
        _renderChartFreshnessBadge(d.ticker);
    }
    catch (_e) { /* additive — never block render */ }
    // Phase 1/2 placeholder polling (change #19)
    if (d.dataPhase === 1 && isLive) {
        startPhasePolling(d.ticker);
    }
    // S27: Lazy-init ticker-view modules after data renders
    if (typeof initSmartInsights === 'function')
        initSmartInsights();
    else
        setTimeout(function () { _loadModule('smart-insights').then(function () { if (typeof initSmartInsights === 'function')
            initSmartInsights(); }).catch(function () { }); }, 10000);
    if (typeof initChartOverlays === 'function')
        initChartOverlays();
    if (typeof initExtHoursTabs === 'function')
        initExtHoursTabs();
    if (typeof initFeaturesExtra === 'function')
        initFeaturesExtra();
    // ── Data freshness labels on ticker panels ──
    const _freshLabel = formatFreshnessLabel(d.fetchedAt || d.lastUpdated);
    if (_freshLabel) {
        // Inject freshness into panel titles in ticker view
        const _freshTargets = [
            ['#metrics-panel .metrics-col-left > .panel-title', 'Valuation'], // Step 2c wrapper (2026-09-01)
            ['#metrics-panel .data-section > .panel-title', 'Financials'],
            ['#details-panel > .panel-title[data-gloss="EPS"]', 'Earnings'],
        ];
        _freshTargets.forEach(([sel, _name]) => {
            const el = document.querySelector(sel);
            // #83 T5 (2026-07-06): skip titles that already carry a PanelAsof
            // (I-14) .panel-asof slot — both systems stamped the SAME header,
            // printing "as of 12:55 PM STALE · as of 12:55" (the time twice).
            // PanelAsof is the structured slot; this legacy injector only fills
            // panels that lack one.
            if (el && el.querySelector('.panel-asof'))
                return;
            if (el && !el.querySelector('.freshness-label')) {
                el.insertAdjacentHTML('beforeend', _freshLabel);
                _hydrateTickerStyles(el);
            }
        });
        // Key metrics strip — wrap in kms-item so it stays aligned in flexbox
        const kms = document.getElementById('key-metrics-strip');
        if (kms && !kms.querySelector('.freshness-label')) {
            kms.insertAdjacentHTML('beforeend', '<div class="kms-item kms-item-fresh">' + _freshLabel + '</div>');
            _hydrateTickerStyles(kms);
        }
    }
    // ── Data sources footer (provenance disclosure) ──
    var sourcesEl = document.getElementById('data-sources-footer');
    if (!sourcesEl) {
        sourcesEl = document.createElement('div');
        sourcesEl.id = 'data-sources-footer';
        sourcesEl.className = 'csp-sources-footer';
        var detailsPanel = document.getElementById('details-panel') || document.querySelector('.detail-sections');
        if (detailsPanel)
            detailsPanel.appendChild(sourcesEl);
    }
    if (sourcesEl) {
        var sources = [];
        // S42 task #17 item 4: friendly label for the DB-first snapshot tier
        // so the footer shows "Oxford Ledge DB" rather than the raw "db" flag.
        if (d._source === 'db')
            sources.push('Oxford Ledge DB');
        else if (d._source === 'ticker_cache')
            sources.push('Oxford Ledge cache');
        else if (d._source)
            sources.push(d._source);
        if (p.source === 'finnhub')
            sources.push('Finnhub');
        if (p.source === 'fmp' || d.fmpProfile)
            sources.push('FMP');
        // BOARD Q10 (2026-09-28): "SEC EDGAR" and "FRED" were pushed for EVERY
        // ticker. EDGAR is named when this payload carries filing-derived
        // financials; FRED feeds no field of the ticker payload and is dropped.
        if (f.revenue != null || f.netIncome != null)
            sources.push('SEC EDGAR');
        sourcesEl.textContent = 'Data sources: ' + [...new Set(sources)].join(' \u00B7 ');
    }
    // ── I-14: Populate panel asof timestamp slots ──
    if (typeof PanelAsof !== 'undefined') {
        var _asofTs = d.fetchedAt || d.lastUpdated;
        var _asofEpoch = _asofTs && _asofTs !== 'DEMO' ? (new Date(_asofTs)).getTime() : NaN;
        // BOARD Q10 (2026-09-28, T19): an undated payload used to be stamped
        // Date.now() -- a fabricated "as of". Unknown shows nothing.
        if (isNaN(_asofEpoch))
            PanelAsof.clear();
        else
            PanelAsof.update(_asofEpoch);
    }
    // ── I-24: Apply user's saved ticker module order after render ──
    if (typeof window._tickerModulesApply === 'function') {
        window._tickerModulesApply();
    }
    // ── I-25: Clear all async panel skeletons once renderData completes ──
    if (typeof LoadingStates !== 'undefined' && typeof LoadingStates.hideAllPanelSkeletons === 'function') {
        LoadingStates.hideAllPanelSkeletons();
    }
    // ── Insider 90-day net-flow badge ─────────────────────────────────────────
    // EW-3: Fetch /api/insiders?ticker=X&period=90d; render INSIDERS BUYING /
    // INSIDERS SELLING / INSIDERS FLAT chip near the ticker hero.
    // Fails closed on 404 / network error — chip is simply absent.
    if (d.ticker && !_isETF) {
        _renderInsiderNetFlowChip(d.ticker);
        // #37 (2026-07-10): institutional-confluence chip (13F accumulation x
        // insider net-buy x cluster). Free for registered users; anon gets the
        // partial view (verdict real, detail blanked) -- public SEC-derived
        // data per OWNER 2026-07-10. Fails closed on any error (chip absent).
        _renderInstitutionalConfluenceChip(d.ticker);
        // SF-5 5E.1: insider-cluster header badge (reads the free 5D endpoint).
        // Cross-chunk guard — cluster-badge.ts is in the same core-utils chunk but
        // load order isn't guaranteed; the typeof shim avoids a boot-abort race.
        try {
            var _ocb = window.OLClusterBadge;
            if (_ocb && typeof _ocb.render === 'function')
                _ocb.render(d.ticker);
        }
        catch (_e) { /* fail closed — badge absent */ }
    }
}
// ── INSIDER NET-FLOW CHIP (EW-3 / 2026-04-26 roadmap item 10) ─────────────────
// Fetches /api/insiders?ticker=<X>&period=90d.
// Computes net_shares = sum(buys) - sum(sells), both share MAGNITUDES.
// Thresholds (vs. shares_outstanding / float where available):
//   net_shares > 0  and buy total > 1% of float → "INSIDERS BUYING" (green)
//   net_shares < 0  and sell total > 1% of float → "INSIDERS SELLING" (red)
//   else → "INSIDERS FLAT" (muted)
// Chip is appended to #hero-insider-chip container if it exists in the DOM,
// or inserted after #change-hero via appendChild — never innerHTML on parent.
// Fails closed: if route returns 404 / non-200 / network error, chip is absent.
// Cache: results are cached per-ticker for the session to avoid repeat fetches
// when the user switches back to the same ticker.
var _insiderNetFlowCache = {}; // ticker → {label, buyShares, sellShares, ts}
function _renderInsiderNetFlowChip(ticker) {
    // insider-net-flow — AC grep target
    try {
        var chipId = 'hero-insider-net-chip';
        // Remove stale chip from a previous ticker
        var existing = document.getElementById(chipId);
        if (existing)
            existing.remove();
        // Determine host element: prefer dedicated slot, fall back to change-hero parent
        var hostEl = document.getElementById('hero-insider-chip-slot');
        if (!hostEl) {
            var chgEl = document.getElementById('change-hero');
            hostEl = chgEl ? chgEl.parentElement : null;
        }
        if (!hostEl)
            return; // DOM not ready; fail closed
        // Use session cache to avoid redundant fetches
        var cached = _insiderNetFlowCache[ticker];
        if (cached && (Date.now() - cached.ts) < 300000) { // 5-min TTL
            _applyInsiderNetFlowChip(hostEl, chipId, cached);
            return;
        }
        var fetchFn = (typeof olFetch === 'function') ? olFetch : window.fetch;
        fetchFn('/api/insiders?ticker=' + encodeURIComponent(ticker) + '&period=90d')
            .then(function (resp) {
            if (!resp || !resp.ok)
                return null;
            return resp.json();
        })
            .then(function (data) {
            if (!data)
                return; // 404 / error — fail closed, no chip
            var transactions = data.transactions || data.insiders || data || [];
            if (!Array.isArray(transactions) || transactions.length === 0)
                return;
            var buyShares = 0, sellShares = 0;
            transactions.forEach(function (tx) {
                if (tx.issuerSelfFiled === true)
                    return;
                if (tx.isDerivative === true || tx.isCommonStock === false)
                    return; // never counted, as the server summary: issuer-self-filed (OWNER 2026-09-24); derivative / notes / preferred units are not common shares (CRWV 2026-10-11)
                var shares = Math.abs(parseFloat(tx.shares || tx.sharesTraded || tx.qty || 0) || 0); // magnitude: the store keeps a sale as NEGATIVE shares (2026-10-19 P0)
                // `transType` is the canonical alias /api/insiders emits
                // (insiders.py: `transaction_code AS "transType"`). It MUST
                // lead the read chain — without it the chip never classifies
                // any txn and silently paints "INSIDERS FLAT" on every
                // non-ETF ticker (CYCLE 2026-05-18 P0; feedback_user_trust).
                // The other keys stay as defensive fallbacks for the
                // /api/insider-summary "Buy"/"Sell" shape + legacy callers.
                var ttype = (tx.transType || tx.type || tx.transactionType || tx.transaction_type || '').toUpperCase();
                // BOARD CYCLE 2026-05-22 (DATA_CZAR P1): count ONLY open-market
                // purchases (P) / sales (S) as the buy/sell signal — matching the
                // route's own summary (insiders.py net90dayValue sums P/S only) and
                // pg_get_recent_insider_buys (WHERE transaction_code='P'). SEC code
                // 'A' is an acquisition/AWARD (RSU vest, option grant — non-
                // discretionary comp) and 'D' a disposition TO the issuer (tax/
                // forfeiture); counting them painted "INSIDERS BUYING" on a pure
                // RSU grant while the panel below showed buys:0 (directional
                // misinformation; feedback_user_trust).
                if (ttype === 'BUY' || ttype === 'PURCHASE' || ttype === 'P') {
                    buyShares += shares;
                }
                else if (ttype === 'SELL' || ttype === 'SALE' || ttype === 'S') {
                    sellShares += shares;
                }
            });
            // #45 (2026-08-12): prefer the SERVER-SIDE share totals, which are
            // computed over ALL rows. `data.transactions` is TRUNCATED TO 3 for
            // anyone below the Researcher tier, so summing it and comparing to
            // 1% of the whole float used a 3-row numerator against a
            // whole-company denominator — the verdict collapsed to FLAT, and
            // differed by the VIEWER'S TIER for the same company.
            //
            // Fallback to the local loop keeps a cached pre-#45 response (or any
            // caller of the /api/insider-summary shape) rendering rather than
            // silently showing nothing — a missing key must not blank the chip.
            var _sum = data.summary || {};
            if (typeof _sum.buyShares === 'number' && typeof _sum.sellShares === 'number') {
                buyShares = _sum.buyShares;
                sellShares = _sum.sellShares;
            }
            buyShares = Math.abs(buyShares || 0);
            sellShares = Math.abs(sellShares || 0); // 2026-10-19 P0: a signed sellShares made `buy - sell` ADD the sales, so SELLING never fired
            // 2026-09-08: the window claim is the SERVER'S (SQL-enforced, carried here);
            // absent => state no window, never invent one. `period=90d` is compat only.
            // docs/board/audit/2026-09-08_CHAOS_insiders_90day_window.md
            var windowDays = (typeof _sum.windowDays === 'number' && _sum.windowDays > 0) ? _sum.windowDays : null;
            var netShares = buyShares - sellShares;
            var floatShares = (data.float || data.sharesFloat || data.sharesOutstanding || 0);
            // Run 2 item 1: fail-closed when float data is missing. Without
            // a real float the 1%-of-float threshold collapses to 0 and any
            // single-share net-buy paints "INSIDERS BUYING" — directional
            // misinformation. Render FLAT with a clear unavailable title.
            if (!floatShares || floatShares <= 0) {
                // Roadmap 2026-04-27 Run 1 item 5: visible label disambiguates
                // the data-unavailable case from the legitimate no-activity
                // case. Both used to say "INSIDERS FLAT" so sighted users
                // without hover couldn't tell apart "we don't know" vs
                // "we know and it's balanced". The em-dash makes the
                // unavailable case visibly distinct without losing the chip
                // shape; aria-label + title carry the explanatory detail.
                var fallback = {
                    label: 'INSIDERS \u2014', chipClass: 'hero-insider-chip-flat',
                    buyShares: buyShares, sellShares: sellShares,
                    windowDays: windowDays,
                    unavailable: true, ts: Date.now(),
                };
                _insiderNetFlowCache[ticker] = fallback;
                _applyInsiderNetFlowChip(hostEl, chipId, fallback);
                return;
            }
            var threshold = floatShares * 0.01; // 1% of float
            var label, chipClass;
            if (netShares > 0 && buyShares >= threshold) {
                label = 'INSIDERS BUYING';
                chipClass = 'hero-insider-chip-buy';
            }
            else if (netShares < 0 && sellShares >= threshold) {
                label = 'INSIDERS SELLING';
                chipClass = 'hero-insider-chip-sell';
            }
            else {
                label = 'INSIDERS FLAT';
                chipClass = 'hero-insider-chip-flat';
            }
            var result = { label: label, chipClass: chipClass, buyShares: buyShares, sellShares: sellShares, windowDays: windowDays, ts: Date.now() };
            _insiderNetFlowCache[ticker] = result;
            _applyInsiderNetFlowChip(hostEl, chipId, result);
        })
            .catch(function () { }); // fail closed on network error
    }
    catch (e) { }
}
// ── INSTITUTIONAL-CONFLUENCE CHIP (#37, 2026-07-10; renamed same-day per ──────
// OWNER: never 'smart money' in customer-visible labels — 2026-05-20 directive  (rename-history: smart-money — meta-comment stating the rule)
// reconfirmed 2026-07-10; the phrase reads as degrading to retail investors.)
// Fetches /api/institutional-confluence (K3 fusion: 13F QoQ accumulation x
// insider Form-4 net-buy x buy-cluster confirmation; PLUS-gated per OWNER
// 2026-07-10 — raw 13F/Form-4 stay free). Renders a hero chip ONLY for the
// four signal verdicts; the honesty verdicts (insufficient_13f_coverage /
// insufficient_history) and neutral render NOTHING — "no data" must never
// cosplay as signal. Fails closed on 401/402/tier-gate/network: chip absent.
// Reuses the insider-chip CSS classes — no new selectors (DS-14).
var _instConfluenceChipCache = {}; // ticker -> {label, chipClass, icon, detail, ts}
function _renderInstitutionalConfluenceChip(ticker) {
    try {
        var chipId = 'hero-institutional-confluence-chip';
        var existing = document.getElementById(chipId);
        if (existing)
            existing.remove();
        var hostEl = document.getElementById('hero-insider-chip-slot');
        if (!hostEl) {
            var chgEl = document.getElementById('change-hero');
            hostEl = chgEl ? chgEl.parentElement : null;
        }
        if (!hostEl)
            return; // DOM not ready; fail closed
        var cached = _instConfluenceChipCache[ticker];
        if (cached && (Date.now() - cached.ts) < 1800000) { // 30-min TTL (quarterly data)
            if (cached.label)
                _applyInstitutionalConfluenceChip(hostEl, chipId, cached);
            return;
        }
        var fetchFn = (typeof olFetch === 'function') ? olFetch : window.fetch;
        fetchFn('/api/institutional-confluence?ticker=' + encodeURIComponent(ticker))
            .then(function (resp) {
            if (!resp || !resp.ok)
                return null; // 401/402/5xx — fail closed
            return resp.json();
        })
            .then(function (data) {
            if (!data || !data.verdict) {
                _instConfluenceChipCache[ticker] = { label: null, ts: Date.now() };
                return;
            }
            // Signal verdicts only. neutral + the two honesty verdicts render
            // nothing (cached as null so we don't refetch for 30 min).
            var map = {
                confluence_accumulation: { label: 'INSTITUTIONS ACCUMULATING', chipClass: 'hero-insider-chip-buy', icon: '▲ ' },
                confluence_distribution: { label: 'INSTITUTIONS DISTRIBUTING', chipClass: 'hero-insider-chip-sell', icon: '▼ ' },
                partial_net_adding: { label: '13F OR FORM 4: NET ADDING', chipClass: 'hero-insider-chip-flat', icon: '▲ ' },
                partial_net_reducing: { label: '13F OR FORM 4: NET REDUCING', chipClass: 'hero-insider-chip-flat', icon: '▼ ' },
            };
            var m = map[data.verdict];
            if (!m) {
                _instConfluenceChipCache[ticker] = { label: null, ts: Date.now() };
                return;
            }
            var inst = data.institutional || {};
            var ins = data.insider || {};
            var cov = data.coverage || {};
            var instWithheld = inst.evaluated === false, w4 = { partial_net_adding: 'FORM 4: INSIDERS BUYING', partial_net_reducing: 'FORM 4: INSIDERS SELLING' }[data.verdict];
            if (instWithheld && w4)
                m = { label: w4, chipClass: m.chipClass, icon: m.icon }; // CHAOS 2026-10-17: 13F half withheld (HON CUSIP change) -> verdict is Form 4 alone; no holder count
            var detail = (data.partial ? 'Sign in (free) for the fund-level and insider breakdown. ' : '')
                + 'Quarter ' + (data.quarter || '?') + ': '
                + (instWithheld ? '13F holder changes not evaluated (holders could not be matched across the two quarters)' : inst.funds_increased != null ? inst.funds_increased + ' funds increased vs ' + (inst.funds_decreased || 0) + ' decreased' : 'fund deltas unavailable')
                + '; insider filings ' + (ins.buy_filings || 0) + ' buys / ' + (ins.sell_filings || 0) + ' sells'
                + (data.cluster_confirmed ? '; buy-cluster confirmed' : '')
                + (cov.fund_count != null && !instWithheld ? '. Coverage: ' + cov.fund_count + ' funds.' : '.');
            var result = { label: m.label, chipClass: m.chipClass, icon: m.icon, detail: detail, ts: Date.now() };
            _instConfluenceChipCache[ticker] = result;
            _applyInstitutionalConfluenceChip(hostEl, chipId, result);
        })
            .catch(function () { }); // tier-gated rejection / network — fail closed
    }
    catch (e) { }
}
function _applyInstitutionalConfluenceChip(hostEl, chipId, data) {
    try {
        if (document.getElementById(chipId))
            return;
        var chip = document.createElement('span');
        chip.id = chipId;
        chip.className = 'hero-insider-chip skill-advanced-chip ' + data.chipClass;
        chip.setAttribute('role', 'status');
        chip.setAttribute('tabindex', '0');
        chip.title = 'Institutional confluence — SEC 13F-HR institutional position changes x Form 4 insider open-market activity x insider buy-cluster detection, aligned on the reference 13F quarter. '
            + data.detail
            + ' 13F filings lag up to 45 days. Statistical observation only, not investment advice.';
        chip.setAttribute('aria-label', 'Institutional confluence: ' + data.label
            + '. SEC 13F and Form 4 source. Statistical observation only, not investment advice.');
        chip.textContent = data.icon + data.label;
        hostEl.appendChild(chip); // appendChild only — never innerHTML on the hero parent
    }
    catch (e) { }
}
function _applyInsiderNetFlowChip(hostEl, chipId, data) {
    // Run 2 item 2: aria-label (WCAG 4.1.2) + Form 4 SEC EDGAR attribution
    // + "not investment advice" disclaimer + colorblind-safe icon prefix.
    // Title carries the full Form-4-source disclaimer so hover/long-press
    // users see it; aria-label gives screen readers the same context.
    try {
        var chip = document.createElement('span');
        chip.id = chipId;
        chip.className = 'hero-insider-chip skill-advanced-chip ' + data.chipClass;
        chip.setAttribute('role', 'status');
        chip.setAttribute('tabindex', '0');
        var buyK = fmtAbbrev(data.buyShares, { dollars: false }); // DS-P2a: canonical K/M (share counts, no $)
        var sellK = fmtAbbrev(data.sellShares, { dollars: false });
        if (data.unavailable) {
            // Roadmap 2026-04-27 Run 1 item 9: aria-label trimmed for screen-
            // reader brevity (~80 chars); full disclosure stays in title for
            // sighted hover/long-press users.
            chip.title = 'Insider net-flow unavailable — public-float data missing for this ticker. Form 4 filings exist but threshold cannot be computed. Statistical observation only, not investment advice.';
            chip.setAttribute('aria-label', 'Insider net-flow: data unavailable. Statistical observation only, not investment advice.');
        }
        else {
            // 2026-09-08: window phrase = the server's `summary.windowDays`, never a literal.
            var _wd = (data && typeof data.windowDays === 'number' && data.windowDays > 0) ? data.windowDays : null;
            var _overPhrase = _wd ? ('over the past ' + _wd + ' days') : 'in recent Form 4 filings';
            var _inPhrase = _wd ? ('in ' + _wd + ' days') : 'in recent filings';
            chip.title = 'Form 4 filings (SEC EDGAR) — ' + buyK + ' shares bought, ' + sellK + ' shares sold ' + _overPhrase + '. Shown as buying or selling only when the larger side reaches 1% of shares outstanding. Statistical observation only, not investment advice.';
            chip.setAttribute('aria-label', 'Insider net-flow: bought ' + buyK + ' vs sold ' + sellK + ' ' + _inPhrase + '. Form 4 source. Statistical observation only, not investment advice.');
        }
        // Colorblind-safe icon prefix (WCAG 1.4.1 — non-color differentiator).
        // BUY = ▲ (up triangle), SELL = ▼ (down triangle), FLAT = ─ (em dash).
        var iconPrefix = '';
        if (data.chipClass === 'hero-insider-chip-buy')
            iconPrefix = '\u25B2 ';
        else if (data.chipClass === 'hero-insider-chip-sell')
            iconPrefix = '\u25BC ';
        else
            iconPrefix = '\u2014 ';
        chip.textContent = iconPrefix + data.label;
        // A1 (UX audit 2026-05-12, quorum FAST-TRACK): make chip
        // click-to-scroll to the insider-feed section at
        // dashboard.html:868. The hover/title already explains the
        // methodology (1%-of-float threshold + SEC Form-4 source);
        // the click affordance turns the chip from a passive read-out
        // into a "see the underlying data" entry point. Cursor cue
        // makes the affordance discoverable.
        chip.style.cursor = 'pointer';
        function _scrollToInsiderFeed() {
            var target = document.getElementById('insider-feed-section');
            if (target && typeof target.scrollIntoView === 'function') {
                try {
                    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
                catch (_e) {
                    target.scrollIntoView();
                }
            }
        }
        chip.onclick = _scrollToInsiderFeed;
        // Keyboard parity (WCAG 2.1.1): tabindex=0 above maps to focus;
        // Enter/Space fire the same scroll handler so keyboard users
        // get the same nav as click users.
        chip.onkeydown = function (ev) {
            var key = ev && (ev.key || ev.keyCode);
            if (key === 'Enter' || key === ' ' || key === 13 || key === 32) {
                ev.preventDefault();
                _scrollToInsiderFeed();
            }
        };
        // P2-1 (2026-04-30): inline pedagogical caption next to the
        // dimmed chip in beginner-mode (CHAMP F1 + Thaler C2 + von Ahn C1).
        // CSS in oxford.css `.chip-skill-hint` makes this visible only
        // when body.beginner-mode is set; otherwise display:none so it
        // doesn't add noise for paid/intermediate users. The skillLevel
        // wiring lives in static/js/adaptive-ui.js — here we just emit
        // the caption sibling. 2026-09-25 audit: the chip still works, so no "Unlock".
        var hint = document.createElement('span');
        hint.className = 'chip-skill-hint';
        hint.textContent = 'Intermediate-level signal';
        // Remove any existing chip + hint before appending (re-render).
        var prev = document.getElementById(chipId);
        if (prev)
            prev.remove();
        var prevHint = document.getElementById(chipId + '-hint');
        if (prevHint)
            prevHint.remove();
        hint.id = chipId + '-hint';
        hostEl.appendChild(chip); // L3 2026-10-05: hint goes LAST (both exits) so the glyph hugs the chip
        // A1 close (2026-05-14): surface the methodology page as a small
        // adjacent link. The chip-click already scrolls to the insider
        // feed and the hover-title explains the 1%-of-float threshold
        // inline, but neither surfaces the full SEC Form-4-pipeline
        // methodology write-up at /methodology/insider-chip. This link
        // closes the FAST-TRACK ratified A1 deliverable. Always-visible
        // (intentional — Beth + Sam wanted the methodology one click
        // away on every render, not gated behind a hover).
        var prevMethLink = document.getElementById(chipId + '-methodology');
        if (prevMethLink)
            prevMethLink.remove();
        // #83 T6 (2026-07-06 OWNER capture): don't append the ⓘ beside the
        // data-unavailable "INSIDERS —" state — on the wrapped mobile layout it
        // rendered as an orphan glyph with no anchor text, and there's no
        // computed signal for the methodology to explain. BUYING/SELLING/FLAT
        // keep the always-visible link (Beth+Sam A1 requirement intact).
        if (data && typeof data.label === 'string' && data.label.indexOf('—') !== -1) {
            hostEl.appendChild(hint);
            return;
        }
        var methLink = document.createElement('a');
        methLink.id = chipId + '-methodology';
        methLink.className = 'chip-methodology-link';
        methLink.href = '/methodology/insider-chip';
        methLink.target = '_blank';
        methLink.rel = 'noopener';
        methLink.textContent = 'ⓘ'; // circled lowercase i — methodology cue
        methLink.setAttribute('aria-label', 'Insider chip methodology — opens in new tab');
        methLink.title = 'How we compute INSIDERS BUYING / SELLING / FLAT — full methodology';
        hostEl.appendChild(methLink);
        hostEl.appendChild(hint);
    }
    catch (e) { }
}
// ── CHART DATA-FRESHNESS BADGE (TASK #17) ──
//
// Ambient "data as of N hours ago" badge that sits in the chart panel
// header, beside the "Price & Volume" title. Sourced from the
// X-Data-Age response header stamped by middleware/data_age.py on
// /api/data responses (NOT recomputed from a client clock) so the badge
// reflects the same staleness signal the backend reports.
//
// DOM-safety: the badge writes ONLY to its own pre-existing sibling
// span (#chart-freshness-badge in dashboard.html). It NEVER touches the
// #combo-canvas parent — no innerHTML on a canvas-bearing node — so the
// FOUNDATIONAL never-destroy-DOM rule (feedback_never_destroy_dom) holds.
//
// Tiers match middleware/data_age.py: fresh <15m, warm <1h, stale <6h,
// ancient >=6h. Per feedback_zero_ux_friction this is muted + small;
// per feedback_user_trust the timestamp is honest (no fake "live" stamp
// when the header is absent — the badge just stays hidden).
var _chartFreshnessBadgeTicker = null;
function _fmtChartDataAge(seconds) {
    if (seconds == null || isNaN(seconds))
        return '';
    if (seconds < 45)
        return 'as of just now';
    if (seconds < 90)
        return 'as of 1 min ago';
    if (seconds < 3600)
        return 'as of ' + Math.round(seconds / 60) + ' min ago';
    if (seconds < 5400)
        return 'as of 1 hour ago';
    if (seconds < 86400)
        return 'as of ' + Math.round(seconds / 3600) + ' hours ago';
    if (seconds < 172800)
        return 'as of 1 day ago';
    return 'as of ' + Math.round(seconds / 86400) + ' days ago';
}
function _renderChartFreshnessBadge(ticker) {
    var badge = document.getElementById('chart-freshness-badge');
    if (!badge)
        return;
    var t = String(ticker || '').trim().toUpperCase();
    if (!t) {
        badge.hidden = true;
        badge.textContent = '';
        return;
    }
    // Avoid a redundant fetch when re-rendering the same ticker in a session.
    if (_chartFreshnessBadgeTicker === t && !badge.hidden)
        return;
    // Prefer the headers the ticker payload fetch ALREADY received.
    // data-pipeline.ts stashes X-Data-Age / X-Data-Staleness on window
    // .__olDataAge when it fetches /api/data. Without this, rendering the badge
    // cost a second request for the same ticker ~246ms after the payload it is
    // rendering beside (measured live 2026-08-17 on a switchTicker). The fetch
    // below stays as the fallback for the cases the map cannot cover: a render
    // served from dataCache with no network fetch behind it, a consumer that
    // runs before the pipeline publishes, or a response with no age header.
    var _published = null;
    try {
        var _map = (typeof window !== 'undefined' && window.__olDataAge) || null;
        var _hit = _map ? _map[t] : null;
        // 60s guard: an entry older than the badge's own coarsest bucket would
        // paint a stale age. Falling through to the fetch is the honest branch.
        if (_hit && typeof _hit.age === 'number' && (Date.now() - _hit.at) < 60000) {
            _published = { age: _hit.age + Math.round((Date.now() - _hit.at) / 1000), tier: _hit.tier || '' };
        }
    }
    catch (_e) { /* fall through to the fetch */ }
    if (_published) {
        _paintChartFreshnessBadge(badge, t, _published);
        return;
    }
    var base = (typeof SERVER !== 'undefined' ? SERVER : '');
    var sig = (typeof AbortSignal !== 'undefined' && AbortSignal.timeout)
        ? AbortSignal.timeout(12000) : undefined;
    // Slim fields= projection: we only need the headers, not the body.
    // eslint-disable-next-line ol/prefer-typed-api-client -- needs the raw Response to read the X-Data-Age / X-Data-Staleness headers; OLApi.getTickerData() returns parsed JSON only and discards the Response (same constraint documented in data-freshness-pill.ts).
    fetch(base + '/api/data?ticker=' + encodeURIComponent(t) + '&fields=ticker,fetchedAt', {
        credentials: 'same-origin',
        signal: sig,
    })
        .then(function (r) {
        if (!r || !r.ok)
            return null;
        var ageRaw = r.headers.get('X-Data-Age');
        if (ageRaw == null)
            return null;
        var age = parseInt(ageRaw, 10);
        if (isNaN(age))
            return null;
        var tier = r.headers.get('X-Data-Staleness') || '';
        return { age: age, tier: tier };
    })
        .then(function (info) {
        _paintChartFreshnessBadge(badge, t, info);
    })
        .catch(function () { });
}
// The paint half of the badge, shared by the published-header path and the
// fetch fallback so the two can never drift into rendering the same age
// differently.
function _paintChartFreshnessBadge(badge, t, info) {
    if (!info) {
        badge.hidden = true;
        badge.textContent = '';
        return;
    }
    var label = _fmtChartDataAge(info.age);
    if (!label) {
        badge.hidden = true;
        badge.textContent = '';
        return;
    }
    var tier = (info.tier === 'fresh' || info.tier === 'warm' ||
        info.tier === 'stale' || info.tier === 'ancient')
        ? info.tier : 'warm';
    badge.className = 'chart-freshness-badge chart-freshness-badge-' + tier;
    badge.textContent = label;
    badge.title = 'Price/fundamentals data ' + label +
        ' (Oxford Ledge data pipeline). Chart may update on the next refresh.';
    badge.setAttribute('aria-label', 'Chart data freshness: ' + label);
    badge.hidden = false;
    _chartFreshnessBadgeTicker = t;
}
// ── DATA FRESHNESS INDICATOR (dot + age text) ──
function _renderFreshnessIndicator(fetchedAt) {
    if (!fetchedAt || fetchedAt === 'DEMO')
        return '';
    try {
        const ts = new Date(fetchedAt);
        if (isNaN(ts.getTime()))
            return '';
        const ageMs = Date.now() - ts.getTime();
        const ageHrs = ageMs / 3600000;
        let dotColor, label;
        if (ageHrs < 1) {
            // Fresh — no indicator needed (or subtle green)
            return '';
        }
        else if (ageHrs < 6) {
            dotColor = 'var(--oxford-blue-vivid)';
            label = Math.floor(ageHrs) + 'h ago';
        }
        else if (ageHrs < 24) {
            dotColor = 'var(--amber)';
            label = Math.floor(ageHrs) + 'h ago';
        }
        else {
            dotColor = 'var(--alert-text)';
            const ageDays = Math.floor(ageHrs / 24);
            label = ageDays + 'd ago \u2014 data may be stale';
        }
        return '<span class="freshness-indicator freshness-indicator-wrap" data-fg="' + dotColor + '">'
            + '<span class="freshness-dot" data-bg="' + dotColor + '"></span>'
            + label + '</span>'; /* CSP Phase 3: data-fg/data-bg → applied via _hydrateTickerStyles */
    }
    catch (e) {
        return '';
    }
}
// ── DATA FRESHNESS LABEL ──
function formatFreshnessLabel(fetchedAt) {
    if (!fetchedAt || fetchedAt === 'DEMO')
        return '';
    try {
        const ts = new Date(fetchedAt);
        if (isNaN(ts.getTime()))
            return '';
        const hh = String(ts.getHours()).padStart(2, '0');
        const mm = String(ts.getMinutes()).padStart(2, '0');
        const diffMin = Math.floor((Date.now() - ts.getTime()) / 60000);
        let color = 'var(--text-muted)';
        let prefix = '';
        if (diffMin > 120) {
            color = 'var(--alert-text)';
            prefix = 'STALE · ';
        } // #76: separate the UPPERCASE state word from the lowercase "as of" time
        else if (diffMin > 30) {
            color = 'var(--amber)';
        }
        return `<span class="freshness-label freshness-label-base" data-fg="${color}">${prefix}as of ${hh}:${mm}</span>`;
    }
    catch (e) {
        return '';
    }
}
// ── HERO TIMESTAMP ──
// CHAOS 2026-10-03 F3: a quote that is NOT the current session's -- a typed
// previous close (price.quoteKind 'previous_close', api/quote_kind.py; its
// fetchedAt is the ASSEMBLY time) or the degraded stale-snapshot fallback
// (_stale, routes_ticker_data_fastapi._serve_stale_snapshot) or, 2026-10-10, a
// quote fetched with the market CLOSED ('session_close': the last close) -- never
// reads as fresh: no "QUOTE FRESH" chip (chrome-indicators.ts), no "just now".
function _quoteIsNotCurrent(d) {
    return !!(d && (d._stale || (d.price && (d.price.quoteKind === 'previous_close' || d.price.quoteKind === 'session_close'))));
}
var heroTimestampInterval = null;
function updateHeroTimestamp(d) {
    const el = document.getElementById('last-updated-hero');
    if (!el)
        return;
    const fetchedAt = d.fetchedAt || d.lastUpdated;
    if (!fetchedAt || fetchedAt === 'DEMO') {
        el.textContent = d.lastUpdated ? 'Updated: ' + d.lastUpdated : '';
        el.style.color = '';
        el.title = '';
        const heroEl = document.getElementById('hero');
        if (heroEl)
            heroEl.classList.remove('_stale');
        return;
    }
    try {
        // EXT-AUDIT T2 (#66): a NAIVE timestamp (no Z/offset) is parsed by JS as
        // DEVICE-LOCAL time — on a PT device a UTC-naive value lands hours ahead,
        // so the label claimed "Prior close (Mon 7/6)" ON SUNDAY 7/5. Normalize
        // naive ISO to UTC (same rule as formatting.ts timeAgo); aware strings
        // ("+00:00"/"Z") parse unchanged.
        let _fa = String(fetchedAt);
        if (!/[zZ]|[+-]\d{2}:?\d{2}$/.test(_fa))
            _fa = _fa.replace(' ', 'T') + 'Z';
        let ts = new Date(_fa);
        if (isNaN(ts.getTime())) {
            el.textContent = 'Updated: ' + fetchedAt;
            el.style.color = '';
            return;
        }
        // F3: a previous close is dated by its session's close (price.asOf), not
        // by when the payload was assembled.
        const _pq = d.price || {};
        const _notCurrent = _quoteIsNotCurrent(d);
        if ((_pq.quoteKind === 'previous_close' || _pq.quoteKind === 'session_close') && _pq.asOf) {
            const _pcTs = new Date(String(_pq.asOf));
            if (!isNaN(_pcTs.getTime()))
                ts = _pcTs;
        }
        const now = new Date();
        const diffMs = now.getTime() - ts.getTime();
        const diffMin = Math.floor(diffMs / 60000);
        // Absolute time string (HH:MM ET)
        const etOpts = { timeZone: 'America/New_York', hour: '2-digit', minute: '2-digit', hour12: false };
        const absTime = ts.toLocaleTimeString('en-US', etOpts) + ' ET';
        // Check if data is from a previous trading day
        const todayET = new Date(now.toLocaleString('en-US', { timeZone: 'America/New_York' }));
        const dataET = new Date(ts.toLocaleString('en-US', { timeZone: 'America/New_York' }));
        const isSameDay = todayET.getFullYear() === dataET.getFullYear() && todayET.getMonth() === dataET.getMonth() && todayET.getDate() === dataET.getDate();
        const marketOpen = _isMarketOpenNow();
        let relativeText = '';
        let color = '';
        let icon = '';
        // EXT-AUDIT T2 (#66): a data-day AHEAD of today is IMPOSSIBLE (a fetch
        // cannot be from the future) — it means a timestamp parse/write bug, not a
        // prior close. Never label the future; log loudly so Sentry sees it.
        const _dataAheadOfToday = dataET.getTime() - todayET.getTime() > 0 &&
            (dataET.getFullYear() > todayET.getFullYear() || dataET.getMonth() > todayET.getMonth() || dataET.getDate() > todayET.getDate());
        if (_dataAheadOfToday) {
            // eslint-disable-next-line no-console -- deliberate ops signal: an impossible future-dated fetch is a timestamp bug; Sentry captures console.error (EXT-AUDIT T2 #66)
            console.error('[freshness] fetchedAt resolves to a FUTURE day (' + dataET.toDateString() + ' vs ' + todayET.toDateString() + ') — timestamp bug, suppressing prior-close label');
        }
        if (_pq.quoteKind === 'session_close' && !_dataAheadOfToday) {
            relativeText = _pq.closeLabel || 'Last close'; // closed market: current, neutral
        }
        else if ((!isSameDay || _notCurrent) && !_dataAheadOfToday) {
            // Data from a previous trading day -- or a quote typed as not current
            // (F3), which never takes the "just now" / "Nm ago" branch below.
            const dayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
            const dataDay = dayNames[dataET.getDay()];
            const dateStr = `${dataET.getMonth() + 1}/${dataET.getDate()}`;
            relativeText = _pq.quoteKind === 'previous_close'
                ? 'Prev close (' + (_pq.previousCloseDate ? String(_pq.previousCloseDate) : dataDay + ' ' + dateStr) + ')'
                : `Prior close (${dataDay} ${dateStr})`;
            color = 'var(--amber)';
            icon = '\u23F0 ';
        }
        else if (_notCurrent) {
            relativeText = _pq.quoteKind === 'previous_close' ? 'Prev close' : 'Not current';
            color = 'var(--amber)';
        }
        else if (diffMin < 1) {
            relativeText = 'just now';
        }
        else if (diffMin === 1) {
            relativeText = '1m ago';
        }
        else if (diffMin < 60) {
            relativeText = diffMin + 'm ago';
        }
        else {
            const diffHrs = Math.floor(diffMin / 60);
            relativeText = diffHrs + 'h ' + (diffMin % 60) + 'm ago';
        }
        // Amber if >30min old during market hours
        if (isSameDay && marketOpen && diffMin > 30 && !color) {
            color = 'var(--amber)';
            icon = '\u23F0 ';
        }
        // Red if >2hrs old during market hours
        if (isSameDay && marketOpen && diffMin > 120) {
            color = 'var(--alert-text)';
        }
        const freshnessDot = _renderFreshnessIndicator(fetchedAt);
        // #162 (P2 trust): surface data PROVENANCE as a visible ambient badge here
        // — the hero "Updated:" line is the view-level panel header for the price/
        // metrics block. Previously provenance lived ONLY in per-metric hover
        // `title`s (setMetricWithSource), invisible on touch and easy to miss.
        // _resolveDataSource() yields a plain-language label ("via FMP", "from
        // Oxford Ledge database", "cached", …). Kept muted + ambient (zero-friction).
        const _prov = (typeof _resolveDataSource === 'function') ? _resolveDataSource(d) : '';
        const provHtml = _prov
            ? ` <span class="prov-badge" title="Where this data came from">&middot; ${escHtml(_prov)}</span>`
            : '';
        // eslint-disable-next-line ol/no-unescaped-innerhtml-interpolation -- provHtml + freshnessDot are pre-built trusted HTML fragments (escHtml'd leaves / _renderFreshnessIndicator output); icon is a Date-derived emoji prefix
        el.innerHTML = `${escHtml(icon)}Updated: ${escHtml(relativeText)} <span class="updated-detail">(${escHtml(absTime)})</span>${provHtml}${freshnessDot}`;
        _hydrateTickerStyles(el);
        el.style.color = color;
        el.title = `Data fetched at ${ts.toLocaleString('en-US', { timeZone: 'America/New_York' })} ET`;
        // Toggle _stale class on hero when data is >24h old
        const heroEl = document.getElementById('hero');
        if (heroEl) {
            const ageHrs = diffMs / 3600000;
            heroEl.classList.toggle('_stale', ageHrs > 24 && _pq.quoteKind !== 'session_close'); // a Sunday's Friday close is current
        }
        // ── Compact hero timestamp next to price (Steve Jobs R2: data freshness) ──
        const heroTsEl = document.getElementById('hero-timestamp');
        if (heroTsEl) {
            const h12Opts = { timeZone: 'America/New_York', hour: 'numeric', minute: '2-digit', hour12: true };
            const compactTime = ts.toLocaleTimeString('en-US', h12Opts) + ' ET';
            heroTsEl.textContent = compactTime;
            heroTsEl.title = `Price as of ${compactTime}`;
        }
        // The #hero-delayed-badge block that lived here was DELETED 2026-09-26
        // (CHAOS RTQ T3): its element was removed from dashboard.html on
        // 2026-05-07, so the block wrote to nothing. The delayed badge is
        // #price-delay-badge, wired in renderData.
    }
    catch (e) {
        el.textContent = 'Updated: ' + fetchedAt;
        el.style.color = '';
    }
}
function startHeroTimestampInterval(d) {
    heroTimestampInterval = registerInterval('heroTimestamp', () => {
        const current = getData(activeTicker);
        if (current)
            updateHeroTimestamp(current);
    }, 60000);
}
// ── FRESHNESS TIMER ──
// Re-evaluates the ticker panels' freshness labels + the stale-data banner
// every 30s so stale data is surfaced. OWNER 2026-09-27: the status-bar
// UPDATED segment (#sb-updated) this timer also painted (relative age +
// amber >30min / red >120min) was REMOVED as clutter; the two surfaces
// below carry the same per-ticker age signal and are KEPT.
var _sbFreshnessInterval = null;
function startStatusbarFreshnessTimer() {
    _sbFreshnessInterval = registerInterval('sbFreshness', () => {
        const d = getData(activeTicker);
        if (!d)
            return;
        // Refresh data freshness labels on ticker panels
        const freshLabel = formatFreshnessLabel(d.fetchedAt || d.lastUpdated);
        document.querySelectorAll('.freshness-label').forEach(el => {
            if (freshLabel) {
                const tmp = document.createElement('span');
                tmp.innerHTML = freshLabel;
                const newEl = tmp.firstChild;
                if (newEl) {
                    el.replaceWith(newEl);
                    _hydrateTickerStyles(newEl.parentNode || newEl);
                }
            }
        });
        // Update stale data banner on timer tick
        var staleBanner = document.getElementById('stale-data-banner');
        if (staleBanner) {
            var fetchedAt = d.fetchedAt || d.lastUpdated;
            var isStale = !!d._provider_degraded;
            if (fetchedAt && fetchedAt !== 'DEMO') {
                try {
                    var ts = new Date(fetchedAt);
                    if (!isNaN(ts.getTime())) {
                        var ageMin = Math.floor((Date.now() - ts.getTime()) / 60000);
                        if (ageMin > 60)
                            isStale = true;
                    }
                }
                catch (e) { }
            }
            if (isStale) {
                staleBanner.classList.remove('d-none');
                staleBanner.classList.add('stale-visible');
            }
            else {
                staleBanner.classList.add('d-none');
                staleBanner.classList.remove('stale-visible');
            }
        }
    }, 30000);
}
// ── HERO DETAIL TOGGLE ──
function toggleHeroDetails() {
    const details = document.getElementById('hero-details');
    const btn = document.getElementById('hero-toggle-btn');
    if (!details || !btn)
        return;
    const expanded = details.classList.toggle('expanded');
    btn.innerHTML = expanded ? '&#9652; Less' : '&#9662; More';
    btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    OLStorage.setString('heroDetailsExpanded', expanded ? '1' : '0');
}
function _restoreHeroDetails() {
    if (OLStorage.getString('heroDetailsExpanded', null) === '1') {
        const details = document.getElementById('hero-details');
        const btn = document.getElementById('hero-toggle-btn');
        if (details && btn) {
            details.classList.add('expanded');
            btn.innerHTML = '&#9652; Less';
            btn.setAttribute('aria-expanded', 'true');
        }
    }
}
// QA-6b: true when the sparkline has >=2 prices and its dates span >= `days`.
function _sparkCoversDays(spark, days) {
    if (!spark || !spark.prices || spark.prices.length < 2 || !spark.dates || spark.dates.length < 2)
        return false;
    var a = Date.parse(String(spark.dates[0]).slice(0, 10)), b = Date.parse(String(spark.dates[spark.dates.length - 1]).slice(0, 10));
    return isFinite(a) && isFinite(b) && Math.abs(b - a) >= days * 86400000;
}
// Update hero beta when the /api/finviz (Finnhub) supplemental data arrives
function _updateHeroBeta(ticker) {
    const hBeta = document.getElementById('h-beta');
    if (!hBeta)
        return;
    const cached = dataCache[ticker];
    if (cached && cached._finviz && cached._finviz.beta) {
        hBeta.textContent = cached._finviz.beta;
    }
}
// ── PHASE 1/2 POLLING ──
//
// CR-C1 fix (2026-04-30): migrated from raw setInterval to OLPolling.create().
// OLPolling provides:
//   1. Auto-pause on document.hidden (background tabs stop hammering /api/data).
//   2. Auto-resume when the tab becomes visible again.
//   3. Global concurrency cap of 3 (FIFO queue for excess requests).
//   4. clearByKeyPrefix('phase:') to stop all phase polls at once on
//      view-change or bulk-clear — no more manual iteration over
//      phasePollingTimers keys.
//
// The phasePollingTimers map is kept as a thin shim that maps ticker →
// OLPolling handle so that legacy call sites (removeTicker in app.js,
// the B-36 view-change block in view-router.js) continue to compile
// without edits. Those sites call .clear() or clearByKeyPrefix instead
// of clearInterval + delete, but both paths are wired through this shim.
function startPhasePolling(ticker) {
    // OLPolling.create() already handles the "key already active" case by
    // cancelling the stale handle before starting the new one, so no
    // early-return guard is needed. The legacy phasePollingTimers check is
    // left here as a belt-and-suspenders no-op for readability continuity.
    if (typeof OLPolling === 'undefined') {
        // Fallback: OLPolling not yet loaded (very early DOMContentLoaded race).
        // This should not happen given the load-order in dashboard.html, but
        // guard defensively so the app doesn't crash on a timing edge case.
        /* @__PURE__ */ _olDebugWarn('[phase] OLPolling not available for ticker ' + ticker + '; poll skipped');
        return;
    }
    var consecutiveErrors = 0;
    var _ticker = ticker; // capture for closure
    var handle = OLPolling.create({
        key: 'phase:' + _ticker,
        intervalMs: 3000,
        maxIterations: 30, // 30 × 3s = 90s max — ETFs often never reach Phase 2
        onTick: function () {
            // onTick is called with (iterationNumber) but we don't need it here;
            // termination is handled by the data response, not just the count.
            var sig;
            try {
                sig = (typeof getViewSignal === 'function' && getViewSignal()) ||
                    AbortSignal.timeout(10000);
            }
            catch (_e) {
                sig = AbortSignal.timeout(10000);
            }
            // eslint-disable-next-line ol/prefer-typed-api-client -- phase-poll loop intentionally uses raw fetch: pre-existing AbortSignal handoff (getViewSignal) + custom error-bucketing + circuit-breaker integration in onTick callback. Migrating to OLApi would require wrapping the abort + breaker plumbing through the typed surface (P2 follow-on).
            return fetch((typeof SERVER !== 'undefined' ? SERVER : '') +
                '/api/data?ticker=' + encodeURIComponent(_ticker), { signal: sig }).then(function (res) {
                if (!res.ok)
                    throw new Error('HTTP ' + res.status);
                consecutiveErrors = 0;
                return res.json();
            }).then(function (data) {
                if (data.dataPhase === 2 || data.dataPhase == null || data.dataPhase === undefined) {
                    // Phase complete — stop polling this ticker.
                    if (phasePollingTimers[_ticker]) {
                        phasePollingTimers[_ticker].clear();
                        delete phasePollingTimers[_ticker];
                    }
                    if (data.dataPhase === 2) {
                        // Defensive only — do NOT read this as a fixed bug. The comment
                        // here previously claimed phase 2 wipes the phase-1 quote; that was
                        // wrong and is corrected in place. Measured 2026-07-30: ORCL went
                        // phase 1 `price.current 117.77 (db)` -> phase 2 `127.575 (fmp)`,
                        // i.e. the quote is PRESERVED and enriched, and the server's phase-2
                        // promotion (data_fetching.py:1540) mutates its stored dict in place
                        // and never assigns `price`. The AMD `price: {}` that prompted this
                        // was a TRANSIENT empty quote, not a wipe — AMD carries a full fmp
                        // quote now. So this branch guards a case not demonstrated to occur;
                        // it is cheap and cannot misfire (it only acts when phase 2 has no
                        // usable price AND phase 1 had one), so it stays as belt-and-braces
                        // for any future payload that does drop the field.
                        const _prev = dataCache[_ticker];
                        if (_prev && _prev.price && _prev.price.current != null
                            && (!data.price || data.price.current == null)) {
                            data.price = _prev.price;
                        }
                        dataCache[_ticker] = data;
                        if (_ticker === activeTicker)
                            updatePhase2Panels(data);
                    }
                }
            }).catch(function () {
                consecutiveErrors++;
                if (consecutiveErrors >= 5) {
                    /* @__PURE__ */ _olDebugWarn('[phase] polling stopped for ' + _ticker + ' after 5 errors');
                    if (phasePollingTimers[_ticker]) {
                        phasePollingTimers[_ticker].clear();
                        delete phasePollingTimers[_ticker];
                    }
                }
            });
        },
        onComplete: function () {
            // Called when maxIterations is reached (90s elapsed with no Phase 2).
            delete phasePollingTimers[_ticker];
        }
    });
    // Store the OLPolling handle under the old key so legacy call sites
    // (removeTicker, view-router B-36 block) can still reach it.
    phasePollingTimers[_ticker] = handle;
}
function showPhasePlaceholder(elId) {
    const el = document.getElementById(elId);
    if (el && (!el.innerHTML || el.innerHTML.includes('Loading') || el.innerHTML.includes('skel-bar'))) {
        el.innerHTML = '<div class="loading-skeleton-text skel-flex-col"><span class="skel-bar skel-bar-xl"></span><span class="skel-bar skel-bar-w65h14"></span></div>';
    }
}
// Fin table incl. Y/Y (Y/Y needs fiveYearHistory = phase 2's cargo). Callers:
// renderData + updatePhase2Panels. DOM-only; ZERO fetches (SSE storm rule).
function _renderFinTable(d, f) {
    var _fyr = d.fiveYearHistory || [];
    function _yoy(field) {
        if (f.yoy)
            return f.yoy[field] != null ? fmt(f.yoy[field], 1) + '%' : ''; // same basis as the value (QA 2026-10-04)
        if (_fyr.length >= 2) {
            var curr = _fyr[_fyr.length - 1][field];
            var prev = _fyr[_fyr.length - 2][field];
            if (curr && prev && prev !== 0)
                return fmt(((curr - prev) / Math.abs(prev)) * 100, 1) + '%';
        }
        // T4 (2026-07-14 OWNER prod-QA): OMIT, NEVER DASH (the BDC/stock house
        // rule). When fiveYearHistory lacks a prior-year value for this field we
        // have no Y/Y to show \u2014 render a BLANK cell, not a "\u2014". A stack of six
        // dashes under a "+2.8%" revenue row read as broken; a blank column reads
        // as "no prior-year data for these lines," which is the honest state.
        return '';
    }
    var _revYoY = f.revenueGrowth ? fmt(f.revenueGrowth, 1) + '%' + (f._revenue_anomaly ? ' <span class="anomaly-warn" title="Unusual revenue change (&gt;90% YoY). Verify with SEC filings.">\u26A0</span>' : '') : _yoy('revenue');
    // Audit 6.8 (2026-06-12): 6th tuple element = GLOSSARY key for the
    // hover-glossary (data-gloss on the label cell). Keys MUST exist in
    // static/js/glossary.ts \u2014 pinned by
    // tests/test_ticker_renderer_data_gloss_contract.py.
    const rows = [
        ['Revenue', f.revenue, null, _revYoY, 'Total money the company earned from selling its products/services over the last 12 months', 'Revenue'],
        ['EBITDA', f.ebitda, null, _yoy('ebitda'), 'Earnings Before Interest, Taxes, Depreciation & Amortization: A measure of operating profitability that ignores financing and accounting decisions', 'EBITDA'],
        ['Net Income', f.netIncome, null, _yoy('netIncome'), 'The company\'s bottom-line profit after all expenses, taxes, and interest. This is what\'s left for shareholders', 'Net Income'],
        ['EPS', null, f.eps != null ? fmtUsd(f.eps, 2) : '\u2014', _yoy('eps'), 'Earnings Per Share: Net income divided by number of shares. Higher = more profit per share you own', 'EPS'],
        ['Free Cash Flow', f.freeCashFlow, null, _yoy('freeCashFlow'), 'Cash generated after all operating expenses and capital investments. This is real cash the company can use for dividends, buybacks, or growth', 'Free Cash Flow'],
        ['Cash', f.cash, null, '', 'Total cash and equivalents on the balance sheet. More cash = stronger financial cushion', 'Cash & Equivalents'],
        ['Total Debt', f.totalDebt, null, '', 'Total borrowings the company owes. Compare to cash and EBITDA to assess financial risk', 'Total Debt'],
    ];
    const _finTitle = document.getElementById('fin-panel-title');
    if (_finTitle) {
        _finTitle.textContent = finPanelTitle(f);
        _finTitle.title = (f.period && f.period.title) || '';
    }
    const _finTbody = document.getElementById('fin-tbody');
    if (_finTbody)
        _finTbody.innerHTML = rows.map(([label, mval, raw, extra, tip, glossKey]) => `<tr ${tip ? `title="${escHtml(tip)}" class="cursor-help"` : ''}>
      <td${glossKey ? ` data-gloss="${escHtml(glossKey)}"` : ''}>${label}${finRowStamp(f, glossKey)}</td>
      <td>${raw || fmtM(mval)}</td>
      <td class="fin-extra-col">${extra}</td>
    </tr>`).join('');
}
// BOARD R7 (2026-09-26): both filings renders put the ask-your-assistant line
// under a list that has rows, never under an empty one or "still syncing".
// filings_panel asks about recent 8-Ks, answered free by get_corporate_events,
// so it shows only when the list itself carries an 8-K (CHAOS 2026-09-27).
function _filingsWithAsk(d, items) {
    if (!items || typeof olMcpEntryHtml !== 'function')
        return items;
    var has8k = (d.filings || []).some(function (f) { return /^8-K/i.test(String(f.type || '')); });
    return has8k ? items + olMcpEntryHtml('filings_panel', d.ticker, _olMcpAskNameOf(d)) : items;
}
function updatePhase2Panels(d) {
    _updatePhaseIndicator(2, d.fetchedAt || d.lastUpdated, _quoteIsNotCurrent(d));
    // Y/Y computes from fiveYearHistory = phase 2's cargo; narrow DOM-only re-render.
    try {
        _renderFinTable(d, d.financials || {});
    }
    catch (e) { /* @__PURE__ */
        _olDebugError('finTable phase2:', e);
    }
    // Update SEC Filings
    const filingsEl = document.getElementById('filings-list');
    if (filingsEl && d.filings) {
        filingsEl.innerHTML = _filingsWithAsk(d, (d.filings || []).map(f => {
            const _fSafeUrl2 = _sanitizeUrl(f.url);
            const desc = f.url
                ? `<a href="${escHtml(_fSafeUrl2)}" target="_blank" rel="noopener noreferrer nofollow">${escHtml(f.description || f.type)}</a>`
                : escHtml(f.description || f.type);
            return `<div class="filing-item">
        <span class="filing-type">${escHtml(f.type)}</span>
        <span class="filing-desc">${desc}</span>
        <span class="filing-date">${escHtml(f.date || '')}</span>
      </div>`;
        }).join('')) || '<div class="dim-msg">No recent SEC filings on file for this ticker</div>';
    }
    if (typeof olRefreshPhase2Pending === 'function')
        olRefreshPhase2Pending(d); // pending sections (after filings), then Earnings
    const earn = d.earnings || {};
    if (earn.nextDate || _irPublishedEntry(earn) || (earn.olEstimate && earn.olEstimate.estimates && earn.olEstimate.estimates.length) || (earn.surpriseHistory && earn.surpriseHistory.length > 0)) {
        let earnHtml = '';
        const _cNed2 = _validNextEarningsDate(earn.nextDate);
        if (_cNed2) {
            let cd = '';
            try {
                const ed = new Date(_cNed2 + 'T00:00:00');
                const diffMs = ed.getTime() - Date.now();
                const diffDays = Math.ceil(diffMs / (1000 * 60 * 60 * 24));
                if (diffDays > 0)
                    cd = ` <span class="earn-countdown">\u00b7 in ${diffDays} days</span>`;
                else if (diffDays === 0)
                    cd = ` <span class="earn-countdown">\u00b7 today</span>`;
                else
                    cd = ` <span class="earn-countdown">\u00b7 reported</span>`;
            }
            catch (e) { }
            earnHtml += `<span class="upcoming-badge badge-earnings">Next Earnings: ${escHtml(_cNed2)}${cd}</span><br>`;
        }
        else if (earn.olEstimate && earn.olEstimate.estimates && earn.olEstimate.estimates.length) {
            // #125: labelled OL estimate (SEC 8-K cadence) \u2014 see honesty contract.
            const _oe2 = earn.olEstimate.estimates[0];
            earnHtml += `<span class="upcoming-badge badge-earnings" title="Oxford Ledge estimate from the company\u2019s 8-K filing cadence \u2014 not a company-announced date">Next Earnings (OL est.): ~${escHtml(_oe2.date)} \u00b1${_oe2.window_days || 0}d</span><br>`;
        }
        if (earn.surpriseHistory && earn.surpriseHistory.length > 0) {
            earnHtml += `<table class="data-table earnings-table"><thead><tr><th>Quarter</th><th>Est</th><th>Actual</th></tr></thead><tbody>`;
            earn.surpriseHistory.slice(0, 4).forEach(s => {
                const beatMissCls2 = s.actual != null && s.estimate != null ? (s.actual > s.estimate ? 'color-positive' : s.actual < s.estimate ? 'color-negative' : '') : '';
                earnHtml += `<tr><td>${escHtml(s.quarter || '')}</td><td>${s.estimate != null ? '$' + fmt(s.estimate, 2) : '\u2014'}</td><td class="${beatMissCls2}">${s.actual != null ? '$' + fmt(s.actual, 2) : '\u2014'}</td></tr>`;
            });
            earnHtml += `</tbody></table>`;
        }
        const _earnInfoEl2 = document.getElementById('earnings-info');
        if (_earnInfoEl2)
            _earnInfoEl2.innerHTML = earnHtml;
    }
    // Update Dividends
    const div = d.dividends || {};
    if (div.history && div.history.length > 0) {
        let divHtml = div.history.map(dh => `<div class="div-row"><span class="div-quarter">${escHtml(dh.quarter || '')}</span><span class="div-amount">$${fmt(dh.amount, 2)}</span><span class="div-date">${escHtml(dh.exDate || '')}</span></div>`).join('');
        if (div.annualAmount)
            divHtml += `<div class="div-row div-row-annual"><span class="div-quarter">Annual</span><span class="div-amount">$${fmt(div.annualAmount, 2)}</span><span></span></div>`;
        const _divRowsEl2 = document.getElementById('dividend-rows');
        if (_divRowsEl2)
            _divRowsEl2.innerHTML = divHtml;
    }
    // Update Short Interest
    const si = d.shortInterest || {};
    let siHtml = _squeezeWatchBadge(si);
    if (si.pctOfFloat != null) {
        const siHighClass = si.pctOfFloat >= 10 ? 'badge-short-high' : 'badge-short-low';
        siHtml += `<div class="metric-row" data-gloss="Short Interest"><span class="metric-label">Short % Float</span><span class="metric-val"><span class="upcoming-badge ${siHighClass}">${fmt(si.pctOfFloat, 1)}%</span></span></div>`;
    }
    if (si.sharesShort)
        siHtml += `<div class="metric-row" data-gloss="Short Interest"><span class="metric-label">Shares Short</span><span class="metric-val">${fmtVol(si.sharesShort)}</span></div>`;
    if (si.daysToCover != null)
        siHtml += `<div class="metric-row" data-gloss="Days to Cover"><span class="metric-label">Days to Cover</span><span class="metric-val">${fmt(si.daysToCover, 1)}</span></div>`;
    if (siHtml) {
        const _siEl = document.getElementById('short-info');
        if (_siEl)
            _siEl.innerHTML = siHtml;
    }
    if (d.news && d.news.length > 0) {
        const _newsListEl2 = document.getElementById('news-list');
        if (_newsListEl2)
            _newsListEl2.innerHTML = d.news.map(n => {
                const _nSafeUrl2 = _sanitizeUrl(n.url);
                const headlineContent = n.url
                    ? `<a href="${escHtml(_nSafeUrl2)}" target="_blank" rel="noopener noreferrer nofollow">${escHtml(n.headline)}</a>`
                    : escHtml(n.headline);
                const nrc = newsRecencyClass(n.date);
                return `<div class="news-item ${nrc}"><div class="news-headline">${headlineContent}</div><div class="news-meta"><span class="news-source">${escHtml(n.source || '')}</span><span>${escHtml(n.date || '')}</span>${typeof creditTagsHtml === 'function' ? creditTagsHtml(n.headline) : ''}</div></div>`;
            }).join('');
    }
    // Update earnings and holders panels
    if (d.earningsHistory && d.earningsHistory.length > 0) {
        if (typeof renderEarningsHistory === 'function')
            renderEarningsHistory(d.earningsHistory);
    }
    if (typeof renderInstitutionalHolders === 'function') {
        renderInstitutionalHolders(d.institutionalHolders || [], d.ticker); // empty clears the MCP line
    }
    // Re-render chart with Phase 2 sparkline data if available
    if (d.sparkline && d.sparkline.prices && d.sparkline.prices.length >= 2) {
        var chartBox = document.getElementById('price-chart');
        // chart-engine's renderComboChart signature is (prices, volumes, dates,
        // avgVolume, unusualFlags, ohlc) — mirror the canonical call in
        // _tryRenderChart. The old (ticker, sparkline, period) 3-arg shape silently
        // passed a ticker string where the prices array belongs, so the re-render
        // never drew. avgVolume isn't in scope here (no profile object), so pass
        // null — valid per the engine's cached-render path.
        var _spRenderChart = function () {
            var _sp = d.sparkline;
            var _flags = _sp.volumeData ? _sp.volumeData.map(v => v.unusualVolume) : (_sp.unusualVolume || null);
            try {
                renderComboChart(_sp.prices, _sp.volumes, _sp.dates, null, _flags, _sp.ohlc || null);
            }
            catch (e) { }
        };
        if (chartBox && chartBox.clientWidth > 0) {
            if (typeof renderComboChart === 'function') {
                _spRenderChart();
            }
        }
        else {
            // Chart not visible yet — store pending render
            window._pendingChartRender = function () {
                if (typeof renderComboChart === 'function') {
                    _spRenderChart();
                }
            };
        }
    }
}
// Portfolio view -- extracted to static/js/portfolio.js
// News view -- extracted to static/js/news.js
// ── INDICATOR COMPARE MODE ──
function getCompareIndicatorList() {
    if (typeof indicatorsCache === 'undefined' || !indicatorsCache)
        return [];
    var list = [];
    var seen = {};
    var groups = ['Indexes', 'Futures', 'Commodities', 'Rates', 'FX', 'Bonds', 'Shipping', 'Crypto'];
    for (var gi = 0; gi < groups.length; gi++) {
        var items = indicatorsCache[groups[gi]];
        if (!Array.isArray(items))
            continue;
        for (var ii = 0; ii < items.length; ii++) {
            var ind = items[ii];
            if (ind.symbol && ind.name && !seen[ind.symbol]) {
                seen[ind.symbol] = true;
                list.push({ symbol: ind.symbol, name: ind.name });
            }
        }
    }
    return list;
}
function populateCompareDropdowns() {
    var list = getCompareIndicatorList();
    var selA = document.getElementById('ind-compare-a');
    var selB = document.getElementById('ind-compare-b');
    if (!selA || !selB)
        return;
    var makeOpts = function (sel, defaultSym) {
        sel.innerHTML = list.map(function (i) {
            return '<option value="' + escHtml(i.symbol) + '"' + (i.symbol === defaultSym ? ' selected' : '') + '>' + escHtml(i.name) + '</option>';
        }).join('');
    };
    var syms = list.map(function (i) { return i.symbol; });
    var defA = syms.indexOf('SPY') !== -1 ? 'SPY' : (syms[0] || '');
    var defB = syms.indexOf('QQQ') !== -1 ? 'QQQ' : (syms[1] || '');
    makeOpts(selA, defA);
    makeOpts(selB, defB);
}
function toggleIndCompare() {
    if (typeof indCompareMode === 'undefined')
        window.indCompareMode = false;
    if (typeof indCompareData === 'undefined')
        window.indCompareData = null;
    indCompareMode = !indCompareMode;
    var btn = document.getElementById('ind-compare-btn');
    var controls = document.getElementById('ind-compare-controls');
    if (!btn || !controls)
        return;
    if (indCompareMode) {
        btn.classList.add('active');
        controls.classList.remove('d-none');
        controls.classList.add('d-block');
        populateCompareDropdowns();
        onIndCompareChange();
    }
    else {
        btn.classList.remove('active');
        controls.classList.add('d-none');
        controls.classList.remove('d-block');
        indCompareData = null;
        var canvas = document.getElementById('ind-chart-canvas');
        if (canvas)
            canvas._indCompareData = null;
        var _indChartLabel = document.getElementById('ind-chart-label');
        if (_indChartLabel)
            _indChartLabel.textContent = (typeof indChartName !== 'undefined' ? indChartName : 'S&P 500');
        if (typeof fetchIndChart === 'function')
            fetchIndChart();
    }
}
async function onIndCompareChange() {
    var selA = document.getElementById('ind-compare-a');
    var selB = document.getElementById('ind-compare-b');
    if (!selA || !selB)
        return;
    var symA = selA.value;
    var symB = selB.value;
    var nameA = (selA.options[selA.selectedIndex] ? selA.options[selA.selectedIndex].text : '') || symA;
    var nameB = (selB.options[selB.selectedIndex] ? selB.options[selB.selectedIndex].text : '') || symB;
    if (!symA || !symB)
        return;
    var labelEl = document.getElementById('ind-chart-label');
    var infoEl = document.getElementById('ind-chart-info');
    if (!labelEl || !infoEl)
        return;
    var _period = typeof indChartPeriod !== 'undefined' ? indChartPeriod : '1mo';
    labelEl.innerHTML = '<span class="chart-compare-a">' + escHtml(nameA) + '</span> <span class="chart-compare-vs">vs</span> <span class="chart-compare-b">' + escHtml(nameB) + '</span> <span class="chart-compare-vs">...</span>';
    try {
        var results = await Promise.all([
            fetch(SERVER + '/api/indicator-history?symbol=' + encodeURIComponent(symA) + '&period=' + _period, { signal: getViewAwareSignal(15000) }),
            fetch(SERVER + '/api/indicator-history?symbol=' + encodeURIComponent(symB) + '&period=' + _period, { signal: getViewAwareSignal(15000) })
        ]);
        var dataA = await results[0].json();
        var dataB = await results[1].json();
        if (dataA.prices && dataA.prices.length >= 2 && dataB.prices && dataB.prices.length >= 2) {
            indCompareData = {
                a: { prices: dataA.prices, dates: dataA.dates, name: nameA, symbol: symA },
                b: { prices: dataB.prices, dates: dataB.dates, name: nameB, symbol: symB }
            };
            var canvas = document.getElementById('ind-chart-canvas');
            if (canvas)
                drawIndCompareChart(canvas, indCompareData);
            labelEl.innerHTML = '<span class="chart-compare-a">' + escHtml(nameA) + '</span> <span class="chart-compare-vs">vs</span> <span class="chart-compare-b">' + escHtml(nameB) + '</span>';
            var lastA = dataA.prices[dataA.prices.length - 1];
            var lastB = dataB.prices[dataB.prices.length - 1];
            var chgA = lastA - dataA.prices[0], pctA = (chgA / dataA.prices[0] * 100);
            var chgB = lastB - dataB.prices[0], pctB = (chgB / dataB.prices[0] * 100);
            var sA = chgA >= 0 ? '+' : '', sB = chgB >= 0 ? '+' : '';
            infoEl.innerHTML = '<span class="chart-compare-a">' + escHtml(nameA) + ': ' + lastA.toFixed(2) + ' (' + sA + pctA.toFixed(2) + '%)</span> &nbsp; <span class="chart-compare-b-color">' + escHtml(nameB) + ': ' + lastB.toFixed(2) + ' (' + sB + pctB.toFixed(2) + '%)</span>';
        }
        else {
            labelEl.innerHTML = '<span class="chart-compare-a">' + escHtml(nameA) + '</span> <span class="chart-compare-vs">vs</span> <span class="chart-compare-b">' + escHtml(nameB) + '</span>';
            infoEl.textContent = 'Insufficient data for comparison';
        }
    }
    catch (e) {
        if (labelEl)
            labelEl.innerHTML = '<span class="chart-compare-a">' + escHtml(nameA) + '</span> <span class="chart-compare-vs">vs</span> <span class="chart-compare-b">' + escHtml(nameB) + '</span>';
        if (infoEl)
            infoEl.textContent = 'Unable to load comparison data. Please try again.';
    }
}
// drawIndCompareChart: canonical implementation is in charts.ts. The
// untyped legacy copy that used to live here was deleted 2026-05-11
// (cross-chunk collision gate). Callers in this file + news.ts resolve
// it via the global declaration in globals.d.ts.
// ── SECTOR MEDIAN BENCHMARKS ──
function computeSectorMedians(ticker) {
    const d = dataCache[ticker] || (typeof DEMO_DATA !== 'undefined' ? DEMO_DATA[ticker] : null);
    if (!d)
        return null;
    const ci = d.companyInfo || {};
    const sector = ci.sector || ci.industry || d.sector || '';
    if (!sector)
        return null;
    const peerMetrics = { pe: [], evEbitda: [], pb: [], roe: [], fcfYield: [] };
    const allData = Object.assign({}, typeof DEMO_DATA !== 'undefined' ? DEMO_DATA : {}, dataCache);
    Object.entries(allData).forEach(([t, td]) => {
        if (!td)
            return;
        const tci = td.companyInfo || {};
        const tSector = tci.sector || tci.industry || td.sector || '';
        if (tSector !== sector)
            return;
        const tm = td.metrics || {};
        if (tm.pe && tm.pe > 0)
            peerMetrics.pe.push(tm.pe);
        if (tm.evEbitda && tm.evEbitda > 0)
            peerMetrics.evEbitda.push(tm.evEbitda);
        if (tm.pb && tm.pb > 0)
            peerMetrics.pb.push(tm.pb);
        if (tm.roe != null)
            peerMetrics.roe.push(tm.roe);
        const tf = td.financials || {};
        const tp = td.price || {};
        const tMktCap = tp.marketCap || 0;
        const tFcf = tf.freeCashFlow || 0;
        const tFcfYield = td.fcfYield || (tMktCap > 0 ? (tFcf / (tMktCap * 1000)) * 100 : null);
        if (tFcfYield != null)
            peerMetrics.fcfYield.push(tFcfYield);
    });
    function median(arr) {
        if (arr.length === 0)
            return null;
        const s = arr.slice().sort((a, b) => a - b);
        const mid = Math.floor(s.length / 2);
        return s.length % 2 !== 0 ? s[mid] : (s[mid - 1] + s[mid]) / 2;
    }
    const minPeers = 3;
    const result = {};
    let hasSome = false;
    Object.entries(peerMetrics).forEach(([key, arr]) => {
        if (arr.length >= minPeers) {
            result[key] = median(arr);
            hasSome = true;
        }
    });
    result._peerCount = Object.values(peerMetrics).map(a => a.length).reduce((a, b) => a > b ? a : b, 0);
    result._sector = sector;
    // Fallback to static SECTOR_BENCHMARKS when fewer than 3 peers
    if (!hasSome && typeof SECTOR_BENCHMARKS !== 'undefined' && SECTOR_BENCHMARKS[sector]) {
        const sb = SECTOR_BENCHMARKS[sector];
        return { pe: sb.pe, evEbitda: sb.evEbitda, pb: sb.pb, _peerCount: 0, _sector: sector, _static: true };
    }
    return hasSome ? result : null;
}
function _sectorMedianAnnotation(metricVal, medianVal, suffix) {
    if (medianVal == null || metricVal == null || metricVal === 0)
        return '';
    let color = 'var(--text-muted)';
    let arrow = '';
    // Green if below avg (cheap), red if above (expensive) for valuation ratios
    if (metricVal < medianVal * 0.85) {
        color = 'var(--text-positive)';
        arrow = '\u25BC ';
    }
    else if (metricVal > medianVal * 1.15) {
        color = 'var(--text-negative)';
        arrow = '\u25B2 ';
    }
    const display = suffix === '%' ? fmt(medianVal, 1) + '%' : fmt(medianVal, 1) + 'x';
    const saCls = color === 'var(--text-positive)' ? 'color-positive' : color === 'var(--text-negative)' ? 'color-negative' : 'color-neutral';
    return ` <span class="sector-avg-label ${saCls}">(${arrow}sector avg: ${display})</span>`;
}
// #83 T1 (2026-07-06): ONE FCF-Yield source for every panel. The Company
// keystat computed it locally (fcf/(mktCap*1000)*100) while the Valuation
// grid + metric table read the server field d.fcfYield — null for
// off-coverage tickers, so PJT showed 11.4% and an em-dash for the SAME
// metric on the SAME page. Precedence: server value when present (SEC/FMP-
// derived), else the local calc from the same financials envelope. mktCap
// arrives in billions, freeCashFlow in millions.
// MODULE scope is load-bearing (fix 2026-07-07): renderData (the 'FCF Yield'
// metric row), renderOverviewPanel, AND renderKeyMetricsStrip all call this.
// It was nested INSIDE renderOverviewPanel, so renderData's call threw
// "ReferenceError: _fcfYieldFor is not defined" and aborted the ENTIRE ticker
// render — every ticker page hung on "Loading market data...". Placed OUTSIDE
// renderOverviewPanel's body so the flat-fallback grep window in
// test_ticker_overview_flat_fallback_contract.py is not truncated.
function _fcfYieldFor(d) {
    if (d && d.fcfYield != null)
        return d.fcfYield;
    var f = (d && d.financials) || {};
    var pp = (d && d.price) || {};
    var fcf = f.freeCashFlow;
    var mktCap = pp.marketCap || 0;
    return (fcf != null && mktCap > 0) ? (fcf / (mktCap * 1000)) * 100 : null;
}
// ── OVERVIEW PANEL (B3) ──
function renderOverviewPanel(d) {
    const el = document.getElementById('summary-text');
    if (!el)
        return;
    const ticker = d.ticker || activeTicker;
    const ci = d.companyInfo || {};
    const f = d.financials || {};
    const p = d.price || {};
    const m = d.metrics || {};
    // 2026-06-09 root-cause: GLOSSARY (glossary.ts) lives in a DIFFERENT bundle
    // chunk than ticker-renderer, so a bare `GLOSS['Business']` deref below
    // threw "Cannot read properties of undefined" and aborted the ENTIRE Overview
    // panel for every ticker (left #summary-text at its "—" placeholder). Per
    // the bundle-chunk rule, cross-chunk symbols need a typeof guard. Resolve a
    // safe glossary source once; tooltips degrade to empty if it isn't loaded.
    const GLOSS = (typeof GLOSSARY !== 'undefined' && GLOSSARY)
        ? GLOSSARY
        : ((typeof window !== 'undefined' && window.GLOSSARY) || {});
    // ── COLUMN 1: COMPANY SNAPSHOT ──
    // Nested helpers — indented so they are not mistaken for top-level
    // declarations (the flat-fallback contract extracts renderOverviewPanel's
    // body up to the next column-0 `function`; a column-0 nested decl truncated
    // the body and false-flagged the present #186 fallbacks as missing).
    // NOTE: _fcfYieldFor was moved to MODULE scope (just above this function) —
    // renderData + renderKeyMetricsStrip also call it and a nested copy was
    // invisible to them (ReferenceError, prod 2026-07-07). factRow stays nested
    // (only renderOverviewPanel uses it).
    function factRow(key, val, isMono) {
        if (!val)
            return '';
        const monoCls = isMono ? ' font-mono' : '';
        return `<div class="ov-fact-row"><span class="ov-fact-key">${key}</span><span class="ov-fact-val${monoCls}">${val}</span></div>`;
    }
    let col1 = '<h2 class="panel-title panel-title-mb8">Company</h2>';
    col1 += factRow('Founded', escHtml(String(ci.founded || '')));
    col1 += factRow('HQ', escHtml(ci.headquarters || ci.hq || ''));
    col1 += factRow('Employees', ci.employees ? (typeof ci.employees === 'number' ? ci.employees.toLocaleString() : escHtml(String(ci.employees))) : '', true);
    // #186 (2026-05-19 OWNER prod-QA): the DB-snapshot serving tier
    // (services/db_snapshot.py:build_ticker_snapshot, the dominant prod
    // path per the #172 investigation) emits company-profile fields
    // FLAT at the top level of `d` (`d.description` / `d.ceo` /
    // `d.website` / `d.exchange` / `d.industry`), NOT nested under
    // `d.companyInfo` or `d.fmpProfile`. Without these `|| d.<field>`
    // fallbacks, every snapshot-served caller (incl. anon and expired
    // session) renders an empty Company column + a skeleton-bar Business
    // section even though the data IS in the payload. The renderer-side
    // fallback matches the long-standing `ci.sector || d.sector` pattern
    // immediately below and is the minimum-blast-radius fix; the
    // architecturally-cleaner snapshot-side wrap-into-companyInfo would
    // affect every other /api/data consumer (TickerDataResponse Pydantic
    // model, SDK, MCP get_company_data, Phase-2 hydrator) and is tracked
    // separately. Snapshot has no `founded`/`headquarters`/`employees`
    // at all \u2014 those stay blank on the snapshot tier (data gap, not
    // shape gap; `feedback_user_trust`: do NOT silently map ipoDate to
    // "Founded" \u2014 they are different facts).
    col1 += factRow('Exchange', escHtml(ci.exchange || d.exchange || ''), true);
    col1 += factRow('CEO', escHtml(ci.ceo || d.ceo || ''));
    col1 += factRow('Sector', escHtml(ci.sector || ci.industry || d.sector || d.industry || ''));
    const _ovWebsite = ci.website || d.website || '';
    if (_ovWebsite) {
        const domain = _ovWebsite.replace(/^https?:\/\/(www\.)?/, '').replace(/\/$/, '');
        col1 += `<div class="ov-fact-row"><span class="ov-fact-key">Website</span><span class="ov-fact-val"><a href="${escHtml(_ovWebsite)}" target="_blank" rel="noopener">${escHtml(domain.length > 28 ? domain.slice(0, 28) + '\u2026' : domain)}</a></span></div>`;
    }
    // Key stats strip
    // EXT-AUDIT T1 (#52, 2026-07-05): NEVER render 0 for a null. The `|| 0`
    // defaults turned a thin cached snapshot (financials not yet loaded) into
    // "Net Cash $0M / FCF Yield 0.0%" for AAPL — a fetch gap presented as a
    // financial FACT (feedback_user_trust). Null balance-sheet fields render
    // an em-dash like every other unknown metric on this page.
    const _nc = fmtNetCashStat(f); // QA 2026-10-04: "Net Debt" + magnitude when negative; withheld for lenders
    const mktCap = p.marketCap || 0;
    const fcfYield = _fcfYieldFor(d); // #83 T1: shared single source — see helper
    const evRev = d.metrics && d.metrics.evRevenue ? d.metrics.evRevenue : null;
    const fcfCls = fcfYield != null ? (fcfYield >= 2 ? 'color-positive' : 'color-text-secondary') : 'color-text-secondary';
    col1 += `<div class="ov-keystats">
    <div title="${escHtml(_nc.title)}"><div class="ov-keystat-label">${_nc.label}</div><div class="ov-keystat-val ${_nc.cls}">${_nc.text}</div></div>
    <div><div class="ov-keystat-label">FCF Yield</div><div class="ov-keystat-val ${fcfCls}">${fcfYield != null ? fmt(fcfYield, 1) + '%' : '\u2014'}</div></div>
    <div><div class="ov-keystat-label">EV/Rev</div><div class="ov-keystat-val ov-keystat-secondary">${evRev != null ? fmt(evRev, 1) + 'x' : '\u2014'}</div></div>
  </div>`;
    // ── COLUMN 2: STRUCTURED COMPANY BRIEF ──
    let col2 = '';
    // Business description — FIRST-PARTY ONLY (OWNER 2026-07-07: FMP disconnected).
    // d.companyDescription (the verified first-party 10-K Item-1 summary, injected
    // server-side) is the ONLY source: no FMP / raw-EDGAR / yfinance fallback (vendor
    // + unverified prose violates audience_framing). No summary -> NO section.
    const firstPartyDesc = (typeof d.companyDescription === 'string' && d.companyDescription.length > 50)
        ? d.companyDescription : '';
    if (firstPartyDesc) {
        const cleaned = firstPartyDesc.replace(/\s+/g, ' ').trim();
        col2 += '<div class="ov-brief-section">';
        col2 += `<div class="ov-brief-section-label" title="${escHtml(GLOSS['Business'] || '')}">Business</div>`;
        col2 += `<p class="ov-brief-body">${escHtml(cleaned)}</p>`;
        // Provenance line, always visible; EDGAR link only for a real https sec.gov URL.
        const src = d.companyDescriptionSource || {};
        const form = (typeof src.form === 'string' && src.form) ? src.form : '10-K';
        const period = (typeof src.period === 'string' && src.period) ? src.period : '';
        const url = (typeof src.url === 'string' && /^https:\/\/www\.sec\.gov\//.test(src.url)) ? src.url : '';
        let prov = `Summarized by Oxford Ledge from the company&#39;s ${escHtml(form)}${period ? ' (' + escHtml(period) + ')' : ''}`;
        // AI label (#119 class, wave J / J1 2026-09-13): the summary is an LLM paraphrase, so the
        // payload's ai_generated_note (services/first_party_desc.py) prints beside the source line;
        // fail-CLOSED to the canonical literal when the flag is absent, off only on an explicit false.
        const _aiNote = (src.ai_generated === false) ? '' : ((typeof src.ai_generated_note === 'string' && src.ai_generated_note.trim())
            || 'AI-generated analysis. Not investment advice. May contain errors.');
        if (_aiNote)
            prov += ` &middot; ${escHtml(_aiNote)}`;
        if (url) {
            prov += ` &middot; <a class="ov-prov-link" href="${escHtml(url)}" target="_blank" rel="noopener noreferrer">Read the filing &rarr;</a>`;
        }
        col2 += `<p class="ov-brief-prov ov-muted-text">${prov}</p>`;
        col2 += '</div>';
    }
    else if (typeof olPhase2PendingSectionHtml === 'function')
        col2 += olPhase2PendingSectionHtml(d, 'business', 'Business');
    // Section 2: UPDATES — auto-generated from filings, dividends, insider activity
    col2 += '<div class="ov-brief-section">';
    col2 += `<div class="ov-brief-section-label" title="${escHtml(GLOSS['Updates'] || '')}">Updates</div>`;
    const updates = [];
    // Check for recent material filings (8-K, SC 13D)
    const filings = d.filings || [];
    filings.slice(0, 8).forEach(f2 => {
        const ft = (f2.type || '').toUpperCase();
        if (ft === '8-K')
            updates.push({ label: 'Material Event', text: `Filed ${ft} on ${f2.date || 'recently'}: ${f2.description || 'material event disclosure'}.` });
        else if (ft.includes('13D'))
            updates.push({ label: 'Ownership Change', text: `${ft} filed on ${f2.date || 'recently'} — activist/large holder disclosure.` });
    });
    // Dividend changes
    const divHist = (d.dividends || {}).history || [];
    if (divHist.length >= 2) {
        const latest = divHist[0]?.amount;
        const prior = divHist[1]?.amount;
        if (latest && prior && latest !== prior) {
            const direction = latest > prior ? 'increased' : 'decreased';
            updates.push({ label: 'Dividend', text: `Quarterly dividend ${direction} from $${fmt(prior, 2)} to $${fmt(latest, 2)} per share.` });
        }
    }
    // Earnings surprise
    const earnHist = d.earningsHistory || [];
    if (earnHist.length > 0) {
        const last = earnHist[0];
        if (last.epsActual != null && last.epsEstimated != null) {
            const beat = last.epsActual > last.epsEstimated;
            const diff = Math.abs(((last.epsActual - last.epsEstimated) / Math.abs(last.epsEstimated || 1)) * 100).toFixed(1);
            updates.push({ label: 'Earnings', text: `Most recent quarter (${last.date || ''}): EPS $${fmt(last.epsActual, 2)} vs est. $${fmt(last.epsEstimated, 2)} — ${beat ? 'beat' : 'missed'} by ${diff}%.` });
        }
    }
    // Capital allocation
    const capAlloc = d.capitalAllocation || {};
    if (capAlloc.buybacks && capAlloc.buybacks > 0) {
        updates.push({ label: 'Buyback', text: `Share repurchases of $${fmtM(capAlloc.buybacks)} in the trailing twelve months.` });
    }
    if (updates.length > 0) {
        updates.slice(0, 4).forEach(u => {
            col2 += `<div class="ov-brief-update-row"><span class="ov-brief-update-label">${escHtml(u.label)}</span><span class="ov-brief-update-text">${escHtml(u.text)}</span></div>`;
        });
    }
    else {
        col2 += '<div class="ov-muted-text">No material updates detected in recent data.</div>';
    }
    col2 += '</div>';
    // Management Commentary — first-party MD&A + earnings-call excerpts.
    // Replaces the removed formulaic 'Trends & Outlook' line (2026-06-09 redesign);
    // OWNER wants the MD&A/earnings excerpts KEPT. Renders ONLY when there is real
    // content, so there's no orphan label for filers without MD&A/transcripts
    // (e.g. foreign 20-F issuers like DAC have none -> nothing shows, by design).
    let _commentaryHtml = '';
    const _mdaText = d.mdaText || '';
    if (_mdaText.length > 100) {
        const _mdaSentences = _mdaText.replace(/\s+/g, ' ').match(/[^.!?]+[.!?]+/g) || [];
        // QA4b (2026-06-15): the MD&A opens with a boilerplate preamble (cross-refs +
        // FLS pointer: "Please read the following discussion ... together with ...
        // Item 1A Risk Factors ..."), so the bare first-2-sentences excerpt surfaced
        // that legalese as "Management Commentary". Skip preamble/cross-reference
        // sentences and take the first 2 SUBSTANTIVE ones (fall back to the raw first
        // two if every sentence looks like preamble, so real content never vanishes).
        const _mdaBoiler = /(please read|should be read|read in conjunction|together with|forward.looking|risk factors|item\s*1a\b|item\s*[78]\b|the following discussion|discussion and analysis of (?:our )?financial condition|undertake no obligation|accompanying notes|the notes to)/i;
        const _mdaSubstantive = _mdaSentences.filter(s => !_mdaBoiler.test(s));
        const _mdaExcerpt = (_mdaSubstantive.length ? _mdaSubstantive : _mdaSentences).slice(0, 2).join(' ').trim();
        if (_mdaExcerpt.length > 40) {
            _commentaryHtml += `<p class="ov-brief-body ov-mda-excerpt">From MD&A: ${escHtml(_mdaExcerpt.slice(0, 300))}</p>`;
        }
    }
    const _transcript = d.earningsTranscript || {};
    if (_transcript.quarter && _transcript.preparedRemarks && _transcript.preparedRemarks.length > 100) {
        const _remarks = _transcript.preparedRemarks.replace(/\s+/g, ' ');
        const _remarkSentences = _remarks.match(/[^.!?]+[.!?]+/g) || [];
        const _remarkExcerpt = _remarkSentences.slice(0, 2).join(' ').trim();
        if (_remarkExcerpt.length > 40) {
            _commentaryHtml += `<p class="ov-brief-body ov-mda-excerpt">From ${escHtml(_transcript.quarter)} call: ${escHtml(_remarkExcerpt.slice(0, 300))}</p>`;
        }
    }
    if (_commentaryHtml) {
        col2 += '<div class="ov-brief-section">';
        col2 += '<div class="ov-brief-section-label">Management Commentary</div>';
        col2 += _commentaryHtml;
        col2 += '</div>';
    }
    // Section: CREDIT HIGHLIGHTS — extracted from MD&A
    if (d.creditHighlights && d.creditHighlights.length > 0) {
        col2 += '<div class="ov-brief-section">';
        col2 += '<div class="ov-brief-section-label">Credit Highlights</div>';
        col2 += '<ul class="ov-highlights-list">';
        d.creditHighlights.forEach(h => {
            if (typeof h === 'object' && h.keyword && h.excerpt) {
                const esc = escHtml(h.excerpt);
                const kwPattern = escHtml(h.keyword).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
                const highlighted = esc.replace(new RegExp('(' + kwPattern + ')', 'gi'), '<b class="ov-highlight-keyword">$1</b>');
                col2 += `<li class="ov-highlight-item">${highlighted}</li>`;
            }
            else {
                col2 += `<li class="ov-highlight-item">${escHtml(typeof h === 'string' ? h : String(h))}</li>`;
            }
        });
        col2 += '</ul></div>';
    }
    // #187 (2026-05-19): mirror the col1 fallback chain (ci.website ||
    // d.website) \u2014 snapshot tier emits flat, live nests. Without this,
    // snapshot users saw the Website fact-row in col1 but no IR-WEBSITE
    // arrow in col2.
    const _ovIrWebsite = ci.website || d.website || '';
    if (_ovIrWebsite) {
        col2 += `<div class="ov-desc-ir"><a href="${escHtml(_ovIrWebsite)}" target="_blank" rel="noopener">IR website \u2192</a></div>`;
    }
    // ── COLUMN 3: VALUATION TOOLS + QUICK LINKS ──
    // Key Ratios removed 2026-06-09 (ticker-page redesign): the Financials &
    // Valuation panel is the single source for multiples. This column is now
    // the interactive valuation tools + research links.
    let col3 = ''; // no standalone label (redesign 2026-06-09)
    // ── IMPLIED GROWTH (Reverse-DCF) CALCULATOR ──
    {
        const _fcfRaw = f.freeCashFlow || 0;
        const _mktCapB = p.marketCap || 0;
        // Enterprise Value = Market Cap + Total Debt - Cash (all in $M for calculation)
        const _di = d.debtInfo || {};
        const _debt = f.totalDebt || _di.totalDebt || 0;
        const _cash = f.cash || _di.cash || _di.cashAndEquivalents || 0;
        const _evB = _mktCapB > 0 ? (_mktCapB * 1000 + _debt - _cash) / 1000 : (m.evEbitda && f.ebitda ? m.evEbitda * f.ebitda / 1000 : 0);
        const _fcfDisp = _fcfRaw !== 0 ? fmt(Math.abs(_fcfRaw), 0) : '';
        const _evDisp = _evB > 0 ? fmt(_evB, 2) : '';
        const _secId = 'implied-growth-' + ticker;
        col3 += `<div class="ig-section-wrap">`;
        col3 += `<h2 class="panel-title ig-toggle-header" data-action="toggle-section" data-section-id="${_secId}" role="button" aria-expanded="false" aria-controls="${_secId}" tabindex="0">
      <span class="ig-arrow-label">Implied Growth <span class="ig-arrow">\u25B6</span></span>
    </h2>`;
        col3 += `<div id="${_secId}" class="ig-body d-none">`;
        col3 += `<div class="ig-grid">
      <label class="ig-label">FCF ($M)
        <input type="number" id="ig-fcf-${ticker}" value="${_fcfDisp}" class="ig-input" data-input-action="calc-implied-growth" data-ticker="${escHtml(ticker)}">
      </label>
      <label class="ig-label">Current EV ($B)
        <input type="number" id="ig-ev-${ticker}" value="${_evDisp}" step="0.1" class="ig-input" data-input-action="calc-implied-growth" data-ticker="${escHtml(ticker)}">
      </label>
      <label class="ig-label">Discount Rate (%)
        <input type="number" id="ig-dr-${ticker}" value="10" min="1" max="30" step="0.5" class="ig-input" data-input-action="calc-implied-growth" data-ticker="${escHtml(ticker)}">
      </label>
      <label class="ig-label">Terminal Multiple (x)
        <input type="number" id="ig-tm-${ticker}" value="15" min="1" max="50" step="1" class="ig-input" data-input-action="calc-implied-growth" data-ticker="${escHtml(ticker)}">
      </label>
    </div>
    <div id="ig-result-${ticker}" class="ig-result">Enter values above</div>
    <div id="ig-context-${ticker}" class="ig-context"></div>
    <div class="ig-disclaimer">Model estimates are for educational purposes only. Not a recommendation to buy or sell.</div>`;
        col3 += `</div></div>`;
    }
    // ── INTRINSIC VALUE CALCULATOR ──
    {
        const _ivId = 'intrinsic-val-' + ticker;
        const _ivFcf = f.freeCashFlow || 0;
        const _ivEps = f.eps || 0;
        const _ivPrice = p.current || 0;
        const _ivMktCapB = p.marketCap || 0;
        const _ivMktCapM = _ivMktCapB * 1000;
        const _ivDebt = f.totalDebt || 0;
        const _ivCash = f.cash || 0;
        const _ivNetDebt = _ivDebt - _ivCash;
        const _ivEbitda = f.ebitda || 0;
        const _ivNetIncome = f.netIncome || 0;
        // Estimate shares outstanding from market cap and price
        const _ivShares = (_ivPrice > 0 && _ivMktCapB > 0) ? (_ivMktCapB * 1e9 / _ivPrice) : 0;
        const _ivSharesM = _ivShares / 1e6;
        // Estimate EBIT from EBITDA (rough: EBIT ~ 85% of EBITDA if no better data)
        const _ivOpIncome = f.operatingIncome || f.operating_income || 0;
        const _ivEbit = _ivOpIncome > 0 ? Math.round(_ivOpIncome) : (_ivEbitda > 0 ? Math.round(_ivEbitda * 0.85) : (_ivNetIncome > 0 ? Math.round(_ivNetIncome * 1.3) : 0));
        // Estimate tax rate from net income and EBIT
        const _ivTaxRate = (_ivEbit > 0 && _ivNetIncome > 0 && _ivNetIncome < _ivEbit) ? Math.round((1 - _ivNetIncome / _ivEbit) * 100) : 21;
        // Estimate growth from revenue growth or EPS history
        const _ivGrowth = f.revenueGrowth != null ? Math.max(0, Math.min(25, Math.round(f.revenueGrowth))) : 8;
        // Load saved assumptions
        const _ivSaved = OLStorage.get('iv_assumptions_' + ticker, {});
        col3 += `<div class="iv-container">`;
        col3 += `<h2 class="panel-title iv-header" data-action="toggle-section" data-section-id="${_ivId}" role="button" aria-expanded="false" aria-controls="${_ivId}" tabindex="0">
      <span class="iv-header-label">Intrinsic Value Calculator <span class="iv-arrow">\u25B6</span></span>
    </h2>`;
        // 2026-06-12 OWNER bug: start collapsed via the d-none CLASS — the
        // toggle-section handler flips d-none, but the old CSS display:none
        // on .iv-body meant the panel could NEVER open (mechanism mismatch).
        col3 += `<div id="${_ivId}" class="iv-body d-none">`;
        // Method tabs
        col3 += `<div class="iv-tabs">
      <button class="iv-tab active" data-iv-tab="dcf" data-action="iv-switch-tab" data-ticker="${escHtml(ticker)}" data-tab="dcf">DCF</button>
      <button class="iv-tab" data-iv-tab="epv" data-action="iv-switch-tab" data-ticker="${escHtml(ticker)}" data-tab="epv">EPV</button>
      <button class="iv-tab" data-iv-tab="graham" data-action="iv-switch-tab" data-ticker="${escHtml(ticker)}" data-tab="graham">Graham</button>
    </div>`;
        // ── DCF Tab ──
        const _dcfFcf = _ivSaved.dcfFcf != null ? _ivSaved.dcfFcf : (_ivFcf > 0 ? Math.round(_ivFcf) : '');
        const _dcfG1 = _ivSaved.dcfG1 != null ? _ivSaved.dcfG1 : _ivGrowth;
        const _dcfYrs = _ivSaved.dcfYrs != null ? _ivSaved.dcfYrs : 10;
        const _dcfG2 = _ivSaved.dcfG2 != null ? _ivSaved.dcfG2 : 3;
        const _dcfDr = _ivSaved.dcfDr != null ? _ivSaved.dcfDr : 10;
        const _dcfNd = _ivSaved.dcfNd != null ? _ivSaved.dcfNd : Math.round(_ivNetDebt);
        const _dcfSh = _ivSaved.dcfSh != null ? _ivSaved.dcfSh : (_ivSharesM > 0 ? Math.round(_ivSharesM * 100) / 100 : '');
        col3 += `<div id="iv-dcf-${ticker}" class="iv-panel">
      <div class="iv-grid">
        <div class="iv-field">
          <label class="iv-label" for="iv-dcf-fcf-${ticker}">Current FCF ($M)</label>
          <input type="number" id="iv-dcf-fcf-${ticker}" class="iv-input" value="${_dcfFcf}" data-input-action="calc-intrinsic-dcf" data-ticker="${escHtml(ticker)}">
        </div>
        <div class="iv-field">
          <label class="iv-label" for="iv-dcf-sh-${ticker}">Shares Out (M)</label>
          <input type="number" id="iv-dcf-sh-${ticker}" class="iv-input" value="${_dcfSh}" step="0.01" data-input-action="calc-intrinsic-dcf" data-ticker="${escHtml(ticker)}">
        </div>
        <div class="iv-field">
          <label class="iv-label" for="iv-dcf-nd-${ticker}">Net Debt ($M)</label>
          <input type="number" id="iv-dcf-nd-${ticker}" class="iv-input" value="${_dcfNd}" data-input-action="calc-intrinsic-dcf" data-ticker="${escHtml(ticker)}">
        </div>
        <div class="iv-field">
          <label class="iv-label" for="iv-dcf-yrs-${ticker}">Stage 1 Years</label>
          <input type="number" id="iv-dcf-yrs-${ticker}" class="iv-input" value="${_dcfYrs}" min="5" max="15" step="1" data-input-action="calc-intrinsic-dcf" data-ticker="${escHtml(ticker)}">
        </div>
      </div>
      <div class="iv-slider-row">
        <div class="iv-slider-label"><span>Stage 1 Growth</span><span class="iv-slider-value" id="iv-dcf-g1-val-${ticker}">${_dcfG1}%</span></div>
        <input type="range" class="iv-slider" id="iv-dcf-g1-${ticker}" value="${_dcfG1}" min="0" max="25" step="0.5" data-input-action="slider-update-label" data-ticker="${escHtml(ticker)}" data-label-id="iv-dcf-g1-val-${ticker}" data-suffix="%" data-calc-action="calc-intrinsic-dcf">
      </div>
      <div class="iv-slider-row">
        <div class="iv-slider-label"><span>Terminal Growth</span><span class="iv-slider-value" id="iv-dcf-g2-val-${ticker}">${_dcfG2}%</span></div>
        <input type="range" class="iv-slider" id="iv-dcf-g2-${ticker}" value="${_dcfG2}" min="0" max="4" step="0.5" data-input-action="slider-update-label" data-ticker="${escHtml(ticker)}" data-label-id="iv-dcf-g2-val-${ticker}" data-suffix="%" data-calc-action="calc-intrinsic-dcf">
      </div>
      <div class="iv-slider-row">
        <div class="iv-slider-label"><span>Discount Rate (WACC)</span><span class="iv-slider-value" id="iv-dcf-dr-val-${ticker}">${_dcfDr}%</span></div>
        <input type="range" class="iv-slider" id="iv-dcf-dr-${ticker}" value="${_dcfDr}" min="6" max="15" step="0.5" data-input-action="slider-update-label" data-ticker="${escHtml(ticker)}" data-label-id="iv-dcf-dr-val-${ticker}" data-suffix="%" data-calc-action="calc-intrinsic-dcf">
      </div>
      <div id="iv-dcf-result-${ticker}" class="iv-result">Enter values above</div>
      <div id="iv-dcf-sensitivity-${ticker}" class="iv-sensitivity"></div>
    </div>`;
        // ── EPV Tab (Greenwald) ──
        const _epvEbit = _ivSaved.epvEbit != null ? _ivSaved.epvEbit : (_ivEbit > 0 ? _ivEbit : '');
        const _epvTax = _ivSaved.epvTax != null ? _ivSaved.epvTax : _ivTaxRate;
        const _epvWacc = _ivSaved.epvWacc != null ? _ivSaved.epvWacc : 10;
        const _epvNd = _ivSaved.epvNd != null ? _ivSaved.epvNd : Math.round(_ivNetDebt);
        const _epvSh = _ivSaved.epvSh != null ? _ivSaved.epvSh : (_ivSharesM > 0 ? Math.round(_ivSharesM * 100) / 100 : '');
        col3 += `<div id="iv-epv-${ticker}" class="iv-panel d-none">
      <div class="iv-formula">Earnings Power Value: EBIT &times; (1 - tax) / WACC - Net Debt</div>
      <div class="iv-grid">
        <div class="iv-field">
          <label class="iv-label" for="iv-epv-ebit-${ticker}">Normalized EBIT ($M)</label>
          <input type="number" id="iv-epv-ebit-${ticker}" class="iv-input" value="${_epvEbit}" data-input-action="calc-intrinsic-epv" data-ticker="${escHtml(ticker)}">
        </div>
        <div class="iv-field">
          <label class="iv-label" for="iv-epv-tax-${ticker}">Tax Rate (%)</label>
          <input type="number" id="iv-epv-tax-${ticker}" class="iv-input" value="${_epvTax}" min="0" max="50" step="1" data-input-action="calc-intrinsic-epv" data-ticker="${escHtml(ticker)}">
        </div>
        <div class="iv-field">
          <label class="iv-label" for="iv-epv-wacc-${ticker}">WACC (%)</label>
          <input type="number" id="iv-epv-wacc-${ticker}" class="iv-input" value="${_epvWacc}" min="4" max="20" step="0.5" data-input-action="calc-intrinsic-epv" data-ticker="${escHtml(ticker)}">
        </div>
        <div class="iv-field">
          <label class="iv-label" for="iv-epv-nd-${ticker}">Net Debt ($M)</label>
          <input type="number" id="iv-epv-nd-${ticker}" class="iv-input" value="${_epvNd}" data-input-action="calc-intrinsic-epv" data-ticker="${escHtml(ticker)}">
        </div>
        <div class="iv-field">
          <label class="iv-label" for="iv-epv-sh-${ticker}">Shares Out (M)</label>
          <input type="number" id="iv-epv-sh-${ticker}" class="iv-input" value="${_epvSh}" step="0.01" data-input-action="calc-intrinsic-epv" data-ticker="${escHtml(ticker)}">
        </div>
      </div>
      <div id="iv-epv-result-${ticker}" class="iv-result">Enter values above</div>
      <div id="iv-epv-sensitivity-${ticker}" class="iv-sensitivity"></div>
    </div>`;
        // ── Graham Tab ──
        const _grEps = _ivSaved.grEps != null ? _ivSaved.grEps : (_ivEps > 0 ? Math.round(_ivEps * 100) / 100 : '');
        const _grG = _ivSaved.grG != null ? _ivSaved.grG : _ivGrowth;
        // Y: saved, else the live 10Y, else 4.5 LABELLED as assumed (ticker-renderer-graham.ts).
        const _liveYield = _grahamLiveYield();
        const _grYAssumed = _ivSaved.grY == null && _liveYield == null;
        const _grY = _ivSaved.grY != null ? _ivSaved.grY : (_liveYield != null ? _liveYield : _GRAHAM_ASSUMED_YIELD);
        col3 += `<div id="iv-graham-${ticker}" class="iv-panel d-none">
      <div class="iv-formula">V = EPS &times; (8.5 + 2G) &times; 4.4 / Y</div>
      <div class="iv-grid-3">
        <div class="iv-field">
          <label class="iv-label" for="iv-gr-eps-${ticker}">EPS (TTM)</label>
          <input type="number" id="iv-gr-eps-${ticker}" class="iv-input" value="${_grEps}" step="0.01" data-input-action="calc-intrinsic-graham" data-ticker="${escHtml(ticker)}">
        </div>
        <div class="iv-field">
          <label class="iv-label" for="iv-gr-g-${ticker}">Growth G (%)</label>
          <input type="number" id="iv-gr-g-${ticker}" class="iv-input" value="${_grG}" min="0" max="30" step="0.5" data-input-action="calc-intrinsic-graham" data-ticker="${escHtml(ticker)}">
        </div>
        <div class="iv-field">
          <label class="iv-label" for="iv-gr-y-${ticker}">10Y Yield Y (%)</label>
          <input type="number" id="iv-gr-y-${ticker}" class="iv-input" value="${_grY}" min="1" max="15" step="0.1"${_grYAssumed ? ` data-yield-assumed="${_GRAHAM_ASSUMED_YIELD}" aria-describedby="iv-gr-y-note-${escHtml(ticker)}"` : ''} data-input-action="calc-intrinsic-graham" data-ticker="${escHtml(ticker)}">
        </div>
      </div>
      ${_grYAssumed ? _grahamAssumedYieldNote(ticker) : ''}
      <div id="iv-gr-result-${ticker}" class="iv-result">Enter values above</div>
    </div>`;
        // Margin of Safety summary
        col3 += `<div id="iv-mos-${ticker}" class="iv-mos"></div>`;
        // Single disclaimer for all methods
        col3 += `<div class="iv-disclaimer">Model estimates are for educational purposes only. Not a recommendation to buy or sell.</div>`;
        col3 += `</div></div>`;
    }
    // Quick external links
    col3 += '<div class="ql-section">';
    col3 += '<h2 class="panel-title panel-title-mb6 ql-title-flex">Quick Links <button data-action="copy-ticker-summary" class="ql-btn">Copy summary</button><button id="print-export-btn" data-action="export-ticker-pdf" class="ql-btn">Export PDF</button><span class="share-dropdown-wrap"><button class="sb-help-btn fs-11" data-action="toggle-share-menu">Share \u25be</button><div class="share-dropdown" id="share-dropdown"><button class="share-dropdown-item" data-action="share-copy-summary-ql">Copy summary</button><button class="share-dropdown-item" data-action="share-copy-for-ai">Copy for AI</button><button class="share-dropdown-item" data-action="share-via-email">Email</button><div class="share-dropdown-sep"></div><button class="share-dropdown-item" data-action="generate-share-card">Download card (PNG)</button><button class="share-dropdown-item" data-action="share-copy-link">Copy link</button></div></span></h2>';
    const links = [
        [`https://finance.yahoo.com/quote/${ticker}`, 'Yahoo Finance'],
        // QA3 (2026-06-15): BAMSEC company pages are /companies/<CIK>/<slug> — the
        // bare-ticker /companies/<ticker> 404'd. BAMSEC resolves on the CIK alone
        // (the slug is decorative — verified /companies/1652044/c -> Alphabet), so
        // when the backend supplies the SEC CIK (from cik_map) we deep-link straight
        // to the company; otherwise fall back to the ticker search (also verified),
        // so the link never 404s.
        [d.cik ? `https://www.bamsec.com/companies/${encodeURIComponent(d.cik)}/c` : `https://www.bamsec.com/search?q=${encodeURIComponent(ticker)}`, 'BAMSEC'],
        [`https://finviz.com/quote.ashx?t=${ticker}`, 'Finviz'],
        [`https://seekingalpha.com/symbol/${ticker}`, 'Seeking Alpha'],
        [`https://www.sec.gov/cgi-bin/browse-edgar?action=getcompany&company=&CIK=${encodeURIComponent(ticker)}&type=&dateb=&owner=include&count=40&search_text=&action=getcompany`, 'SEC EDGAR'],
    ];
    links.forEach(([url, label]) => {
        col3 += `<a href="${escHtml(_sanitizeUrl(url))}" target="_blank" rel="noopener nofollow" class="ql-link">${escHtml(label)} \u2192</a>`;
    });
    col3 += '</div>';
    // \u2500\u2500 DF-14 TIME MACHINE ("As of date") \u2500\u2500
    // Ambient, opt-in control appended under Quick Links: pick a past date and
    // see what this ticker looked like from the captured daily-snapshot moat
    // (GET /api/ticker/as-of). DOM-safety: this writes ONLY into its own
    // dedicated #tm-result container (created fresh by this innerHTML build, so
    // it auto-resets on every per-ticker overview render \u2014 AAPL's card never
    // bleeds onto MSFT). It NEVER touches the price header or any canvas-bearing
    // node, per the FOUNDATIONAL never-destroy-DOM rule (ticker-renderer.ts:2336).
    // The submit/render flow is wired by _wireTimeMachine() after el.innerHTML.
    {
        const _tmToday = _tmTodayStr();
        col3 += '<div class="ql-section tm-section">';
        col3 += '<h2 class="panel-title panel-title-mb6">Time Machine</h2>';
        col3 += '<div class="tm-hint">See what ' + escHtml(ticker) + ' looked like on a past date.</div>';
        col3 += '<div class="tm-controls">'
            + '<label class="tm-label" for="tm-date-input">As of</label>'
            + '<input type="date" id="tm-date-input" class="tm-date" max="' + escHtml(_tmToday) + '" value="' + escHtml(_tmToday) + '">'
            + '<button type="button" id="tm-view-btn" class="ql-btn tm-view-btn">View</button>'
            + '</div>';
        col3 += '<div id="tm-result" class="tm-result" aria-live="polite"></div>';
        col3 += '</div>';
    }
    // Research Notes scratchpad removed 2026-06-09 (ticker-page redesign):
    // the page-level "Your Notes" surface is the single notes home.
    // ── ASSEMBLE GRID ──
    let html = `<div class="ov-grid"><div>${col1}</div><div>${col2}</div><div>${col3}</div></div>`;
    // ── RESEARCH LINKS (full width below grid) ──
    // ovRenderLinks (quality-alerts.ts) is in another bundle chunk — guard the
    // cross-chunk call so an unloaded chunk degrades to "no links" instead of
    // throwing and blanking the whole Overview (same 2026-06-09 root-cause).
    if (typeof ovRenderLinks === 'function')
        html += ovRenderLinks(ticker);
    el.innerHTML = html;
    _loadTickerNote(ticker);
    _wireTimeMachine(ticker);
    // Auto-calculate intrinsic value if panel exists. The _calcIntrinsic* helpers
    // live in valuation-calcs.ts (another chunk) — guard each so a missing chunk
    // doesn't throw an uncaught async error after the panel has rendered.
    setTimeout(function () {
        if (typeof _calcIntrinsicDCF === 'function')
            _calcIntrinsicDCF(ticker);
        if (typeof _calcIntrinsicEPV === 'function')
            _calcIntrinsicEPV(ticker);
        if (typeof _calcIntrinsicGraham === 'function')
            _calcIntrinsicGraham(ticker);
    }, 50);
    if (document.getElementById('iv-gr-y-note-' + ticker))
        _grahamFetchLiveYield(ticker);
}
// ── DF-14 TIME MACHINE ("As of date") helpers ───────────────────────────────
// Local YYYY-MM-DD for the date input's max/value (avoids the UTC-shift a bare
// toISOString() would introduce near midnight in western timezones).
function _tmTodayStr() {
    var now = new Date();
    var y = now.getFullYear();
    var m = String(now.getMonth() + 1).padStart(2, '0');
    var d = String(now.getDate()).padStart(2, '0');
    return y + '-' + m + '-' + d;
}
// Format a marketCap that may arrive raw-dollars or already-in-billions. The
// snapshot JSONB stores raw dollars for marketCap; fmtMktCap expects billions,
// so normalize > 1e7 raw values down before formatting (mirrors toM/fmtM intent
// in formatting.ts). Returns '' when absent so the caller can skip the row.
function _tmFmtMktCap(v) {
    if (v == null || isNaN(Number(v)))
        return '';
    var n = Number(v);
    if (Math.abs(n) >= 1e7)
        n = n / 1e9; // raw dollars -> billions
    if (typeof fmtMktCap === 'function')
        return fmtMktCap(n);
    return '$' + n.toFixed(1) + 'B';
}
// Wire the Time Machine control for the just-rendered overview panel. Scoped to
// the freshly-created #tm-date-input / #tm-view-btn nodes inside #summary-text,
// so listeners are re-bound cleanly on every per-ticker render (no document-
// level leak, no stale-ticker closure — `ticker` is captured per render).
function _wireTimeMachine(ticker) {
    var input = document.getElementById('tm-date-input');
    var btn = document.getElementById('tm-view-btn');
    if (!input || !btn)
        return;
    function go() {
        var picked = (input && input.value) ? input.value.trim() : '';
        _runTimeMachine(ticker, picked);
    }
    btn.addEventListener('click', go);
    // change fires on date-picker commit (calendar select / typed + blur).
    input.addEventListener('change', go);
}
// Render an "As of <date>" snapshot card into the dedicated #tm-result node.
// found:true  -> company/price/marketCap/volume + nearest-date hint + note
// found:false -> clean empty-state
// fetch error -> quiet inline error line (never throws / never blanks panel)
function _runTimeMachine(ticker, dateStr) {
    var box = document.getElementById('tm-result');
    if (!box)
        return;
    if (!dateStr) {
        box.innerHTML = '<div class="tm-empty">Pick a date to view a past snapshot.</div>';
        return;
    }
    box.innerHTML = '<div class="tm-loading">Loading snapshot...</div>';
    var url = SERVER + '/api/ticker/as-of?symbol=' + encodeURIComponent(ticker) + '&date=' + encodeURIComponent(dateStr);
    var sig = (typeof getViewAwareSignal === 'function' ? getViewAwareSignal(12000) : AbortSignal.timeout(12000));
    // Raw fetch (not OLApi): public no-auth endpoint; mirrors the file's existing
    // raw-fetch + getViewSignal abort pattern (line 3028 holders fetch).
    fetch(url, { credentials: 'same-origin', signal: sig })
        .then(function (r) { if (!r.ok)
        throw new Error('HTTP ' + r.status); return r.json(); })
        .then(function (resp) {
        var cur = document.getElementById('tm-result');
        if (!cur)
            return;
        _renderTimeMachineResult(cur, resp, dateStr);
    })
        .catch(function () {
        var cur = document.getElementById('tm-result');
        if (cur)
            cur.innerHTML = '<div class="tm-error">Could not load the snapshot. Please try again.</div>';
    });
}
function _renderTimeMachineResult(box, resp, requestedDate) {
    resp = resp || {};
    if (!resp.found) {
        var emptyNote = resp.note ? '<div class="tm-note">' + escHtml(resp.note) + '</div>' : '';
        box.innerHTML = '<div class="tm-empty">No snapshot on or before ' + escHtml(requestedDate) + '.</div>' + emptyNote;
        return;
    }
    var data = resp.data || {};
    var snapDate = resp.snapshot_date || requestedDate;
    // Nearest-on-or-before hint when the captured date precedes the request.
    var nearestHint = (resp.snapshot_date && resp.snapshot_date !== requestedDate)
        ? ' <span class="tm-nearest">(nearest on/before ' + escHtml(requestedDate) + ')</span>'
        : '';
    var name = data.name || data.companyName || '';
    var priceRaw = (data.price != null) ? data.price : data.current;
    var price = (priceRaw != null && !isNaN(Number(priceRaw)))
        ? '$' + Number(priceRaw).toFixed(2)
        : '';
    var rows = '';
    if (name)
        rows += '<div class="tm-row"><span class="tm-k">Company</span><span class="tm-v">' + escHtml(name) + '</span></div>';
    if (price)
        rows += '<div class="tm-row"><span class="tm-k">Price</span><span class="tm-v font-mono">' + escHtml(price) + '</span></div>';
    var mcap = _tmFmtMktCap(data.marketCap);
    if (mcap)
        rows += '<div class="tm-row"><span class="tm-k">Market Cap</span><span class="tm-v font-mono">' + escHtml(mcap) + '</span></div>';
    if (data.volume != null && !isNaN(Number(data.volume))) {
        rows += '<div class="tm-row"><span class="tm-k">Volume</span><span class="tm-v font-mono">' + escHtml(Number(data.volume).toLocaleString()) + '</span></div>';
    }
    if (!rows)
        rows = '<div class="tm-empty">Snapshot captured, but no displayable fields.</div>';
    var note = resp.note ? '<div class="tm-note">' + escHtml(resp.note) + '</div>' : '';
    box.innerHTML = '<div class="tm-card">'
        + '<div class="tm-card-head">As of ' + escHtml(snapDate) + nearestHint + '</div>'
        + rows
        + note
        + '</div>';
}
// ── TICKER SCRATCHPAD NOTES (per-ticker, localStorage + server) ──
var _scratchpadDebounceTimer = null;
// A7 (UX audit 2026-05-12, quorum FAST-TRACK): keep the counter
// in sync with the textarea content. Mirrors paper-trading.ts
// `_wireThesisCounter` (the canonical pattern). Warn class fires
// at >90% capacity so users know they're approaching the cap
// before they're blocked by the maxlength attribute.
function _updateScratchpadCounter() {
    var ta = document.getElementById('ticker-scratchpad');
    var counter = document.getElementById('scratchpad-counter');
    if (!ta || !counter)
        return;
    var len = ta.value.length;
    counter.textContent = len.toLocaleString() + ' / 2,000';
    counter.classList.toggle('scratchpad-counter-warn', len > 1800);
}
function _loadTickerNote(ticker) {
    const ta = document.getElementById('ticker-scratchpad');
    if (!ta)
        return;
    // First load from localStorage for instant display
    try {
        const local = OLStorage.getString('scratchpad_' + ticker, null);
        if (local)
            ta.value = local;
    }
    catch (e) { }
    _updateScratchpadCounter();
    // Phase 4: Skip server fetch for anonymous users. Anonymous sessions
    // never save to the server (save requires auth), so the GET returns
    // empty and localStorage is the authoritative source. Saves one
    // fetch per ticker render for every unauthed user.
    if (!window._userTier || window._userTier === 'anonymous')
        return;
    // Then try server (overwrites local if server has data)
    fetch(`${SERVER}/api/ticker-notes?ticker=${encodeURIComponent(ticker)}`, { signal: AbortSignal.timeout(8000) })
        .then(function (r) { if (!r.ok)
        throw new Error('HTTP ' + r.status); return r.json(); })
        .then(data => {
        const ta2 = document.getElementById('ticker-scratchpad');
        if (ta2 && data.note) {
            ta2.value = data.note;
            try {
                OLStorage.setString('scratchpad_' + ticker, data.note);
            }
            catch (e) { }
            _updateScratchpadCounter();
        }
    })
        .catch(() => { });
}
function _debounceSaveTickerNote(ticker) {
    // Save to localStorage immediately
    const ta = document.getElementById('ticker-scratchpad');
    if (ta) {
        try {
            OLStorage.setString('scratchpad_' + ticker, ta.value);
        }
        catch (e) { }
    }
    // A7: keep the live char counter in sync on every keystroke.
    _updateScratchpadCounter();
    // Debounce server save by 500ms
    if (_scratchpadDebounceTimer)
        clearTimeout(_scratchpadDebounceTimer);
    _scratchpadDebounceTimer = setTimeout(function () { _saveTickerNote(ticker); }, 500);
}
function _saveTickerNote(ticker) {
    if (!authGate('save notes'))
        return;
    const ta = document.getElementById('ticker-scratchpad');
    if (!ta)
        return;
    var noteText = ta.value;
    try {
        OLStorage.setString('scratchpad_' + ticker, noteText);
    }
    catch (e) { }
    // P2-14: post to per-ticker endpoint (existing shared store)
    fetch(`${SERVER}/api/ticker-notes`, {
        method: 'POST',
        headers: _csrfHeaders(),
        body: JSON.stringify({ ticker: ticker, note: noteText }),
        signal: AbortSignal.timeout(8000)
    }).catch(() => { });
    // P2-14: also sync to user-scoped notes store (merge, fire-and-forget)
    var _notesPatch = {};
    _notesPatch[ticker] = noteText;
    fetch('/api/notes/sync', {
        method: 'POST',
        headers: _csrfHeaders(),
        credentials: 'include',
        body: JSON.stringify({ notes: _notesPatch }),
        signal: AbortSignal.timeout(8000)
    }).catch(function () { });
}
// ── TICKER ANNOTATIONS ──
var _annSelectedCat = 'note';
function _setAnnCat(btn) {
    document.querySelectorAll('.ann-cat-btn').forEach(b => b.classList.remove('ann-cat-active'));
    btn.classList.add('ann-cat-active');
    _annSelectedCat = btn.getAttribute('data-cat') || 'note';
}
function _loadAnnotations(ticker) {
    const feed = document.getElementById('annotations-feed');
    const countEl = document.getElementById('annotations-count');
    if (!feed)
        return;
    // Phase 4: Skip server fetch for anonymous users. Posting annotations
    // requires auth; anonymous sessions have nothing stored server-side,
    // so the GET returns empty. Show the empty-state hint directly and
    // save one round-trip per scroll into the annotations panel.
    if (!window._userTier || window._userTier === 'anonymous') {
        feed.innerHTML = '<div class="ann-empty-msg">Sign in to save notes and annotations on this ticker.</div>';
        if (countEl)
            countEl.textContent = '';
        return;
    }
    feed.innerHTML = '<div class="fetching-msg">Loading annotations...</div>';
    fetch(`${SERVER}/api/ticker-annotations?ticker=${encodeURIComponent(ticker)}&limit=50`, { signal: AbortSignal.timeout(8000) })
        .then(function (r) { if (!r.ok)
        throw new Error('HTTP ' + r.status); return r.json(); })
        .then(data => {
        const anns = data.annotations || [];
        countEl.textContent = anns.length > 0 ? anns.length + ' annotation' + (anns.length !== 1 ? 's' : '') : '';
        if (anns.length === 0) {
            feed.innerHTML = '<div class="ann-empty-msg">No annotations yet. Add your first note above.</div>';
            return;
        }
        feed.innerHTML = anns.map(a => {
            const cat = a.category || 'note';
            const dateStr = a.createdAt ? new Date(a.createdAt).toLocaleString(undefined, { month: 'short', day: 'numeric', year: 'numeric', hour: '2-digit', minute: '2-digit' }) : '';
            return `<div class="ann-card"><div class="ann-card-header"><span class="ann-badge ann-badge-${escHtml(cat)}">${escHtml(cat)}</span></div><div class="ann-card-body">${escHtml(a.body)}</div><div class="ann-card-meta"><span>${escHtml(dateStr)}</span><button class="ann-delete-btn" data-action="delete-annotation" data-ann-id="${a.id}" data-ticker="${escHtml(ticker)}" title="Archive" aria-label="Archive note">&times;</button></div></div>`;
        }).join('');
    })
        .catch(() => { feed.innerHTML = '<div class="ann-error-msg">Notes unavailable \u2014 check connection</div>'; });
}
function _postAnnotation() {
    if (!authGate('save annotations'))
        return;
    const bodyEl = document.getElementById('ann-body');
    if (!bodyEl)
        return;
    const text = bodyEl.value.trim();
    if (!text)
        return;
    const ticker = activeTicker;
    if (!ticker)
        return;
    const btn = document.getElementById('ann-submit-btn');
    if (btn) {
        btn.disabled = true;
        btn.textContent = '...';
    }
    fetch(`${SERVER}/api/ticker-annotations`, {
        method: 'POST',
        headers: _csrfHeaders(),
        body: JSON.stringify({ ticker: ticker, body: text, category: _annSelectedCat })
    })
        .then(function (r) { if (!r.ok)
        throw new Error('HTTP ' + r.status); return r.json(); })
        .then(data => {
        if (data.status === 'ok') {
            bodyEl.value = '';
            _loadAnnotations(ticker);
        }
    })
        .catch(function (err) {
        /* @__PURE__ */ _olDebugError('Post annotation error:', err);
        if (typeof showToast === 'function')
            showToast('Unable to save annotation. Check your connection and try again.', 'error', 3000);
    })
        .finally(() => { if (btn) {
        btn.disabled = false;
        btn.textContent = 'POST';
    } });
}
function _deleteAnnotation(id, ticker) {
    if (!confirm('Archive this annotation?'))
        return;
    fetch(`${SERVER}/api/ticker-annotations?id=${id}`, { method: 'DELETE', headers: { 'X-CSRF-Token': _getCsrfToken() } })
        .then(function (r) { if (!r.ok)
        throw new Error('HTTP ' + r.status); return r.json(); })
        .then(data => { if (data.status === 'ok')
        _loadAnnotations(ticker); })
        .catch(function (err) {
        /* @__PURE__ */ _olDebugError('Delete annotation error:', err);
        if (typeof showToast === 'function')
            showToast('Unable to delete annotation. Check your connection and try again.', 'error', 3000);
    });
}
// §VALUATION — extracted to static/js/valuation-calcs.js
// Moat scorecard, research links, anomaly flags -- extracted to static/js/quality-alerts.js
// ── KEY METRICS STRIP ──
function renderKeyMetricsStrip(d) {
    const el = document.getElementById('key-metrics-strip');
    if (!el)
        return;
    const m = d.metrics || {};
    const f = d.financials || {};
    const ci = d.companyInfo || {};
    const sector = ci.sector || ci.industry || d.sector || '';
    const sb = (typeof SECTOR_BENCHMARKS !== 'undefined' && SECTOR_BENCHMARKS[sector]) ? SECTOR_BENCHMARKS[sector] : null;
    // Signal classification: returns {signal, arrow, tooltip}
    function classify(metric, val) {
        if (val == null)
            return { signal: 'dim', arrow: '', tooltip: '' };
        let signal, arrow, tooltip;
        const sectorNote = sb ? ' (' + sector + ' sector)' : '';
        switch (metric) {
            // BOARD Q11 (2026-09-28, T18): no valuation VERDICT. P/E and EV/EBITDA
            // were coloured green/red and captioned "potentially undervalued /
            // overvalued / fairly valued / attractively priced" from fixed cutoffs
            // (P/E <15 / >25) or a hardcoded sector table -- a buy/sell-shaped call
            // on an education product. The tooltip states the comparison as a fact;
            // the vs-5y-median / vs-sector context is M5 and will replace this.
            case 'pe': {
                const sectorPe = sb ? sb.pe : null;
                signal = 'dim';
                arrow = '';
                if (val < 0)
                    tooltip = 'Negative P/E: the company reported a loss over the last 12 months';
                else if (sectorPe)
                    tooltip = 'P/E of ' + fmt(val, 1) + 'x; ' + sector + ' reference ' + fmt(sectorPe, 0) + 'x';
                else
                    tooltip = 'P/E of ' + fmt(val, 1) + 'x (no sector comparison on file)';
                break;
            }
            case 'evEbitda': {
                const sectorEv = sb ? sb.evEbitda : null;
                signal = 'dim';
                arrow = '';
                if (val < 0)
                    tooltip = 'Negative EV/EBITDA: operating earnings were negative';
                else if (sectorEv)
                    tooltip = 'EV/EBITDA of ' + fmt(val, 1) + 'x; ' + sector + ' reference ' + fmt(sectorEv, 0) + 'x';
                else
                    tooltip = 'EV/EBITDA of ' + fmt(val, 1) + 'x (no sector comparison on file)';
                break;
            }
            case 'debtEquity': {
                if (val < 0) {
                    signal = 'red';
                    arrow = '\u2716';
                    tooltip = 'Negative D/E \u2014 negative equity (liabilities exceed assets)';
                }
                else if (val <= 0.5) {
                    signal = 'green';
                    arrow = '\u25B2';
                    tooltip = 'D/E of ' + fmt(val, 2) + ' is conservative \u2014 low financial leverage';
                }
                else if (val <= 1.5) {
                    signal = 'amber';
                    arrow = '\u25C6';
                    tooltip = 'D/E of ' + fmt(val, 2) + ' is moderate \u2014 manageable leverage for most sectors';
                }
                else {
                    signal = 'red';
                    arrow = '\u25BC';
                    tooltip = 'D/E of ' + fmt(val, 2) + ' is high \u2014 significant leverage, higher financial risk';
                }
                break;
            }
            case 'roe': {
                if (val >= 15) {
                    signal = 'green';
                    arrow = '\u25B2';
                    tooltip = 'ROE of ' + fmt(val, 1) + '% is strong \u2014 efficient use of shareholder equity';
                }
                else if (val >= 8) {
                    signal = 'amber';
                    arrow = '\u25C6';
                    tooltip = 'ROE of ' + fmt(val, 1) + '% is moderate \u2014 adequate but not exceptional';
                }
                else {
                    signal = 'red';
                    arrow = '\u25BC';
                    tooltip = 'ROE of ' + fmt(val, 1) + '% is low \u2014 poor return on shareholder equity';
                }
                break;
            }
            case 'fcfYield': {
                if (val >= 5) {
                    signal = 'green';
                    arrow = '\u25B2';
                    tooltip = 'FCF Yield of ' + fmt(val, 1) + '% is strong \u2014 generates significant free cash relative to price';
                }
                else if (val >= 2) {
                    signal = 'amber';
                    arrow = '\u25C6';
                    tooltip = 'FCF Yield of ' + fmt(val, 1) + '% is moderate \u2014 adequate cash generation';
                }
                else {
                    signal = 'red';
                    arrow = '\u25BC';
                    tooltip = 'FCF Yield of ' + fmt(val, 1) + '% is low \u2014 limited free cash flow relative to valuation';
                }
                break;
            }
            case 'divYield': {
                if (val >= 3) {
                    signal = 'green';
                    arrow = '\u25B2';
                    tooltip = 'Div Yield of ' + fmt(val, 1) + '% is attractive \u2014 strong income generation';
                }
                else if (val >= 1) {
                    signal = 'amber';
                    arrow = '\u25C6';
                    tooltip = 'Div Yield of ' + fmt(val, 1) + '% is moderate \u2014 some income, growth-oriented';
                }
                else {
                    signal = 'dim';
                    arrow = '\u2014';
                    tooltip = val > 0 ? 'Div Yield of ' + fmt(val, 2) + '% is minimal' : 'No dividend paid';
                }
                break;
            }
            default:
                signal = 'dim';
                arrow = '';
                tooltip = '';
        }
        return { signal, arrow, tooltip };
    }
    // Forward P/E: check metrics first, then consensusEstimates
    const fwdPe = m.forwardPe || (d.consensusEstimates ? d.consensusEstimates.forwardPE : null);
    // Build P/E display: "28.5x" or "28.5x | Fwd 24.1x" when forward is available
    let peDisplay = '\u2014';
    if (m.pe != null) {
        peDisplay = m.pe < 0 ? 'N/M' : fmt(m.pe, 1) + 'x';
        if (fwdPe != null && fwdPe > 0 && m.pe > 0) {
            peDisplay += ' | Fwd ' + fmt(fwdPe, 1) + 'x';
        }
    }
    const divY = m.dividendYield;
    const items = [
        ['P/E', m.pe, peDisplay, 'pe'],
        ['EV/EBITDA', m.evEbitda, m.evEbitda != null ? fmt(m.evEbitda, 1) + 'x' : '\u2014', 'evEbitda'],
        ['D/E', m.debtEquity, m.debtEquity != null ? fmt(m.debtEquity, 2) : '\u2014', 'debtEquity'],
        ['ROE', m.roe, m.roe != null ? fmt(m.roe, 1) + '%' : '\u2014', 'roe'],
        ['FCF Yield', _fcfYieldFor(d), _fcfYieldFor(d) != null ? fmt(_fcfYieldFor(d), 1) + '%' : '\u2014', 'fcfYield'],
        ['Div Yield', divY, divY != null ? fmt(divY, 1) + '%' : '\u2014', 'divYield'],
    ];
    const hasAny = items.some(([, , , key]) => {
        if (key === 'fcfYield')
            return _fcfYieldFor(d) != null; // #83 T1: same source as the row
        if (key === 'divYield')
            return divY != null;
        return m[key] != null;
    });
    if (!hasAny) {
        el.classList.add('hidden');
        const ctw = document.getElementById('credit-toggle-wrap');
        if (ctw)
            ctw.classList.add('hidden');
        return;
    }
    el.classList.remove('hidden');
    const ctw = document.getElementById('credit-toggle-wrap');
    if (ctw)
        ctw.classList.remove('hidden');
    // Beginner-friendly tooltip overrides for key metrics strip
    var _kmsBeginnerMode = (typeof _isBeginnerMode === 'function' && _isBeginnerMode()) ||
        (function () { var sl = OLStorage.getString('skillLevel', null); return sl === 'beginner' || sl === 'learner' || sl === 'LRN'; })();
    var _kmsBeginnerTips = {
        'pe': 'How many years of profits it would take to pay back the stock price. Lower = cheaper.',
        'evEbitda': 'Total company price compared to its operating profits. Lower = cheaper. Think of it like P/E, but for the whole company including its debts.',
        'debtEquity': 'How much the company borrowed vs. how much its owners put in. Higher = more debt = more risk.',
        'roe': 'How good the company is at turning its owners\' money into profit. Higher = better.',
        'fcfYield': 'How much real cash the business generates compared to its price. Like an interest rate on your investment. Higher = better value.',
        'divYield': 'Cash paid to you each year just for owning the stock, as a percentage of the price. Higher = more income.'
    };
    el.innerHTML = items.map(([label, val, display, key]) => {
        const c = classify(key, val);
        const signalCls = c.signal !== 'dim' ? ' kms-signal-' + c.signal : '';
        var tooltipText = c.tooltip;
        if (_kmsBeginnerMode && _kmsBeginnerTips[key])
            tooltipText = _kmsBeginnerTips[key];
        // Add forward P/E tooltip context
        if (key === 'pe' && fwdPe != null && fwdPe > 0 && val > 0) {
            var fwdNote = fwdPe < val
                ? ' Forward P/E of ' + fmt(fwdPe, 1) + 'x suggests analysts expect earnings growth.'
                : ' Forward P/E of ' + fmt(fwdPe, 1) + 'x suggests analysts expect earnings to decline.';
            tooltipText = (tooltipText || '') + fwdNote;
        }
        const tipHtml = tooltipText ? '<span class="kms-tooltip">' + escHtml(tooltipText) + '</span>' : '';
        // Highlight forward P/E in green when lower than trailing (value signal)
        var valHtml = display;
        if (key === 'pe' && fwdPe != null && fwdPe > 0 && val > 0 && display.indexOf('Fwd') !== -1) {
            var fwdStr = 'Fwd ' + fmt(fwdPe, 1) + 'x';
            if (fwdPe < val) {
                valHtml = display.replace(fwdStr, '<span class="ol-fwd-pe-highlight">' + fwdStr + '</span>');
            }
        }
        return '<div class="kms-item' + signalCls + '" data-action="kms-toggle-tooltip">' +
            '<span class="kms-dot ' + c.signal + '"></span>' +
            '<span class="kms-label">' + label + '</span>' +
            '<span class="kms-val">' + valHtml + '</span>' +
            (c.arrow ? '<span class="kms-arrow ' + c.signal + '">' + c.arrow + '</span>' : '') +
            tipHtml +
            '</div>';
    }).join('') + _kmsSourceTag('Finnhub', d);
}
/** Build the trailing source + "as of" tag for key metrics strip */
function _kmsSourceTag(source, d) {
    var asOf = '';
    if (d && d.price && d.price.fetchedAt) {
        var ta = typeof timeAgo === 'function' ? timeAgo(d.price.fetchedAt) : null;
        asOf = ta ? ' \u00B7 as of ' + ta : '';
    }
    else if (d && d._fetchedAt) {
        var ta2 = typeof timeAgo === 'function' ? timeAgo(d._fetchedAt) : null;
        asOf = ta2 ? ' \u00B7 as of ' + ta2 : '';
    }
    return '<div class="kms-item kms-item-source"><span class="kms-item-source-text">Source: ' + source + asOf + '</span></div>';
}
// ── ETF METRICS STRIP ADAPTATION ──
function _fmtETFStripNum(val) {
    if (val == null || isNaN(val))
        return '\u2014';
    return fmtAbbrev(val); // DS-P2a: canonical $ K/M/B
}
function _updateMetricsStripForETF(fund) {
    var el = document.getElementById('key-metrics-strip');
    if (!el || !fund)
        return;
    var er = fund.expenseRatio != null ? parseFloat(fund.expenseRatio) : null;
    var nav = fund.navPerShare != null ? parseFloat(fund.navPerShare) : null;
    var secYield = fund.yield30daySec != null ? parseFloat(fund.yield30daySec) : (fund.yieldPct != null ? parseFloat(fund.yieldPct) : null);
    var aum = fund.aum != null ? parseFloat(fund.aum) : null;
    var turnover = fund.turnoverRate != null ? parseFloat(fund.turnoverRate) : null;
    var pd = fund.premiumDiscount != null ? parseFloat(fund.premiumDiscount) : null;
    function classifyETF(metric, val) {
        if (val == null)
            return { signal: 'dim', arrow: '', tooltip: '' };
        var signal, arrow, tooltip;
        switch (metric) {
            case 'er':
                if (val <= 0.1) {
                    signal = 'green';
                    arrow = '\u25B2';
                    tooltip = 'Expense ratio of ' + val.toFixed(2) + '% is very low -- cost-efficient';
                }
                else if (val <= 0.5) {
                    signal = 'amber';
                    arrow = '\u25C6';
                    tooltip = 'Expense ratio of ' + val.toFixed(2) + '% is moderate';
                }
                else {
                    signal = 'red';
                    arrow = '\u25BC';
                    tooltip = 'Expense ratio of ' + val.toFixed(2) + '% is high -- erodes returns over time';
                }
                break;
            case 'yield':
                if (val >= 3) {
                    signal = 'green';
                    arrow = '\u25B2';
                    tooltip = 'Yield of ' + val.toFixed(2) + '% is attractive for income';
                }
                else if (val >= 1) {
                    signal = 'amber';
                    arrow = '\u25C6';
                    tooltip = 'Yield of ' + val.toFixed(2) + '% is moderate';
                }
                else {
                    signal = 'dim';
                    arrow = '\u2014';
                    tooltip = val > 0 ? 'Yield of ' + val.toFixed(2) + '% is minimal' : 'No yield data';
                }
                break;
            case 'pd':
                if (val < -0.5) {
                    signal = 'green';
                    arrow = '\u25B2';
                    tooltip = 'Trading at ' + Math.abs(val).toFixed(2) + '% discount to NAV';
                }
                else if (val > 0.5) {
                    signal = 'red';
                    arrow = '\u25BC';
                    tooltip = 'Trading at ' + val.toFixed(2) + '% premium to NAV';
                }
                else {
                    signal = 'amber';
                    arrow = '\u25C6';
                    tooltip = 'Trading near NAV';
                }
                break;
            default:
                signal = 'dim';
                arrow = '';
                tooltip = '';
        }
        return { signal: signal, arrow: arrow, tooltip: tooltip };
    }
    var items = [
        ['Expense Ratio', er, er != null ? er.toFixed(2) + '%' : '\u2014', 'er'],
        ['NAV', nav, nav != null ? '$' + nav.toFixed(2) : '\u2014', ''],
        ['Yield', secYield, secYield != null ? secYield.toFixed(2) + '%' : '\u2014', 'yield'],
        ['AUM', aum, _fmtETFStripNum(aum), ''],
        ['Turnover', turnover, turnover != null ? turnover.toFixed(2) + '%' : '\u2014', ''],
    ];
    if (pd != null) {
        items.push(['Prem/Disc', pd, (pd > 0 ? '+' : '') + pd.toFixed(2) + '%', 'pd']);
    }
    var hasAny = items.some(function (it) { return it[1] != null; });
    if (!hasAny)
        return; // Keep stock metrics if no ETF data
    el.classList.remove('hidden');
    el.innerHTML = items.map(function (item) {
        var label = item[0], val = item[1], display = item[2], key = item[3];
        var c = key ? classifyETF(key, val) : { signal: 'dim', arrow: '', tooltip: '' };
        var signalCls = c.signal !== 'dim' ? ' kms-signal-' + c.signal : '';
        var tipHtml = c.tooltip ? '<span class="kms-tooltip">' + escHtml(c.tooltip) + '</span>' : '';
        return '<div class="kms-item' + signalCls + '" data-action="kms-toggle-tooltip">' +
            '<span class="kms-dot ' + c.signal + '"></span>' +
            '<span class="kms-label">' + label + '</span>' +
            '<span class="kms-val">' + display + '</span>' +
            (c.arrow ? '<span class="kms-arrow ' + c.signal + '">' + c.arrow + '</span>' : '') +
            tipHtml +
            '</div>';
    }).join('') + _kmsSourceTag('FMP', null);
}
// renderConsensusEstimates moved VERBATIM to ticker-renderer-consensus.ts
// (#180 size-budget cut, 2026-08-16). Same bundle, loads after this file;
// the only inbound edge is the runtime call above.
//# sourceMappingURL=ticker-renderer.js.map
;
// ═══ ticker-renderer-13f.js ═══
;"use strict";
// @ts-nocheck
// ticker-renderer-13f.ts — 13F / institutional-ownership cluster (#261 D1b cut).
//
// Extracted verbatim from ticker-renderer.ts (2026-07-27) to buy size-budget
// headroom on the repo's tightest file (5,362 of a 5,380-line cap). Two
// blocks, one subject:
//   1. X5b/X5c-2 ownership TREND strips — _13fTrendCache, _fmt13fUsd,
//      _13fQuarterIndex, _build13fSparkline, _build13fTrendStripHtml,
//      _wire13fTrendToggle, mount13fTrendStrip, _13fFundTrendCache,
//      _build13fFundTrendHtml, mount13fFundTrendStrip.
//   2. The 13F VIEW — DISTRESSED_FUNDS, MAJOR_CREDIT_HOLDERS, fundBadgeHtml,
//      search13fTicker, crossSearchFund, crossSearchTicker, _notableFundsCache,
//      _loadNotableFunds, _f13FundReqSeq, _f13FundInFlightQ, search13fFund,
//      _f13ShowAll, _f13ViewBeaconSent, _emitFundHoldingsView, load13fHoldings.
//
// Free-name analysis: the two blocks are mutually closed — load13fHoldings is
// the only caller of mount13fFundTrendStrip, and the only inbound edge from the
// parent is _renderHFChangesData -> mount13fTrendStrip (a runtime call, so load
// order is not load-bearing). Everything else resolved is a bundle global
// (SERVER, escHtml, fmt, fmtAbbrev, fmtVal13f, dataCache, switchTicker, setView,
// showToast, TierGate, olFetch, _track, _hydrateTickerStyles, _f13ShowAll).
// External callers (app-renderers.ts data-action map, view-router.ts,
// product/surfaces/thirteen-f.ts, product/cards/featured-filer-card.ts,
// calendar-view.ts window.fundBadgeHtml) reach these by GLOBAL NAME, which is
// unchanged — build_bundle.py concatenates, there are no ES modules here.
//
// Script-mode; build_bundle.py loads ticker-renderer-13f.js directly after
// ticker-renderer.js in both the JS_MODULES manifest and the app-tail chunk.
// The .ts is the SoT; ticker-renderer-13f.js is the gitignored tsc/esbuild
// emit. Inherits the parent's @ts-nocheck.
// ── X5b: 13F ownership TREND strip (quarter-over-quarter) ─────────────────────
// The longitudinal companion to the latest-2Q QoQ chip below it. Reads the
// /api/institutional-holders/timeseries endpoint (S3 summary — the same rows the
// Ask-AI X4 injection reads). Aggregate altitude ONLY (holder count + total value
// per quarter) so it never duplicates the per-fund chip, and never renders a fund
// name (no XSS surface). Canvas-free inline SVG (feedback_never_destroy_dom).
// DESIGN spec 2026-07-02. Mounted as a decoupled insertBefore (does not touch the
// working chip render flow) at the end of _renderHFChangesData.
var _13fTrendCache = {};
function _fmt13fUsd(v) {
    var n = typeof v === 'number' ? v : parseFloat(v);
    if (!isFinite(n))
        return '—';
    return fmtAbbrev(n); // DS-P2a: canonical $ K/M/B
}
// "2024-Q4" -> 2024*4 + 4 (a contiguous quarter index; NaN when unparseable).
function _13fQuarterIndex(q) {
    var m = /^(\d{4})-Q([1-4])$/.exec(String(q || ''));
    return m ? (parseInt(m[1], 10) * 4 + parseInt(m[2], 10)) : NaN;
}
// Inline SVG sparkline of `vals` positioned by quarter INDEX, so a MISSING
// middle quarter leaves a real gap in the line — the path BREAKS (moveto), never
// interpolates across an un-filed quarter (DESIGN trust rule; no fabricated data).
function _build13fSparkline(vals, quarters) {
    var W = 240, H = 40, PAD = 3;
    var nums = [];
    for (var a = 0; a < vals.length; a++) {
        if (typeof vals[a] === 'number' && isFinite(vals[a]))
            nums.push(vals[a]);
    }
    if (nums.length < 2)
        return '';
    var min = Math.min.apply(null, nums), max = Math.max.apply(null, nums);
    var span = (max - min) || 1;
    var idx = quarters.map(_13fQuarterIndex);
    var i0 = idx[0], iN = idx[idx.length - 1];
    var ispan = (iN - i0) || 1;
    function _x(i) { return PAD + (i - i0) / ispan * (W - 2 * PAD); }
    function _y(v) { return H - PAD - (v - min) / span * (H - 2 * PAD); }
    var d = '', pen = false, lastIdx = null, lastPt = null;
    for (var k = 0; k < vals.length; k++) {
        var v = vals[k], qi = idx[k];
        if (typeof v !== 'number' || !isFinite(v) || isNaN(qi)) {
            pen = false;
            continue;
        }
        var x = _x(qi), y = _y(v);
        if (!pen || (lastIdx !== null && qi - lastIdx > 1)) {
            d += 'M' + x.toFixed(1) + ',' + y.toFixed(1); // break: gap or first point
        }
        else {
            d += 'L' + x.toFixed(1) + ',' + y.toFixed(1);
        }
        pen = true;
        lastIdx = qi;
        lastPt = [x, y];
    }
    var dot = lastPt
        ? '<circle cx="' + lastPt[0].toFixed(1) + '" cy="' + lastPt[1].toFixed(1) + '" r="2.5" class="ol-13f-trend__dot"/>'
        : '';
    return '<svg class="ol-13f-trend__spark" viewBox="0 0 ' + W + ' ' + H + '" preserveAspectRatio="none" aria-hidden="true">' +
        '<path d="' + d + '" fill="none" class="ol-13f-trend__line"/>' + dot + '</svg>';
}
// QA-12 (2026-10-04 prod QA, AAPL): the server's coverage regime trims by
// GLOBAL filer counts, which can pass a quarter whose holders of THIS ticker
// were barely ingested -- AAPL read "Net +5,868 holders since 2016-Q4" against
// 5,872 today, i.e. a 4-holder baseline. A quarter is a comparable baseline
// only when it holds at least this fraction of the latest full quarter's
// holder count; earlier quarters stay in the table but never anchor the net
// line, the sparkline, or a QoQ percent. The rule states a fact about the
// counts (under 25% of today's), not a cause, so it stays true for a ticker
// whose ownership genuinely grew that much.
var _13F_BASELINE_MIN_FRACTION = 0.25;
// Index into `full` of the first quarter comparable with the latest one.
// Returns 0 when the latest count is unusable (nothing to compare against).
function _13fComparableBaselineIdx(full) {
    if (!full || !full.length)
        return 0;
    var latestN = full[full.length - 1].n_holders;
    if (typeof latestN !== 'number' || !isFinite(latestN) || latestN <= 0)
        return 0;
    var floor = latestN * _13F_BASELINE_MIN_FRACTION;
    for (var i = 0; i < full.length; i++) {
        var n = full[i].n_holders;
        if (typeof n === 'number' && isFinite(n) && n >= floor)
            return i;
    }
    return full.length - 1;
}
function _build13fTrendStripHtml(series, coverageBegan) {
    // EXT-AUDIT #61: the net line, sparkline endpoints, and "as of" all use
    // FULL quarters only — a partial (mid-ingest) newest quarter would render
    // as a fake ownership collapse in every one of them.
    var full = series.filter(function (s) { return !s.partial; });
    if (full.length < 2)
        full = series;
    // QA-12: the net line + sparkline start at the first COMPARABLE quarter.
    var baseIdx = _13fComparableBaselineIdx(full);
    var comparable = full.slice(baseIdx);
    var notComparable = {};
    for (var b = 0; b < baseIdx; b++)
        notComparable[String(full[b].quarter)] = true;
    var trend = comparable.length >= 2 ? comparable : full.slice(full.length - 1);
    var quarters = trend.map(function (s) { return s.quarter; });
    var holders = trend.map(function (s) { return typeof s.n_holders === 'number' ? s.n_holders : null; });
    var latest = full[full.length - 1];
    var first = comparable[0];
    var nq = series.length;
    var net = (latest.n_holders || 0) - (first.n_holders || 0);
    var netCls = '';
    var netTxt;
    if (comparable.length >= 2) {
        netCls = net > 0 ? 'ol-13f-trend__net--up' : (net < 0 ? 'ol-13f-trend__net--down' : '');
        var netArrow = net > 0 ? '▲' : (net < 0 ? '▼' : '·');
        netTxt = netArrow + ' Net ' + (net >= 0 ? '+' : '') + net.toLocaleString() +
            ' holders since ' + escHtml(String(first.quarter || ''));
    }
    else {
        // No earlier quarter is comparable: a "since" delta would be measured
        // against a thin baseline, so none is stated.
        netTxt = '<span class="hf-flat">Net change not shown</span>';
    }
    if (baseIdx > 0) {
        netTxt += ' <span class="hf-flat">· quarters before ' + escHtml(String(first.quarter || '')) +
            ' report under 25% of the latest holder count and are not used as a baseline</span>';
    }
    if (coverageBegan) {
        netTxt += ' <span class="hf-flat">· broad 13F coverage began ' + escHtml(String(coverageBegan)) + '; earlier quarters not shown</span>';
    }
    // OWNER 2026-07-13: default the table to the last 4 quarters; older rows are
    // marked --extra (hidden by CSS) and revealed by the expand/collapse toggle.
    // The sparkline + net line keep their FULL history so the at-a-glance trend is
    // unchanged; only the table detail collapses. QoQ still computes against the
    // true series[i-1], so hiding older rows never distorts a visible row's delta.
    var VISIBLE_Q = 4;
    var extraCount = series.length > VISIBLE_Q ? series.length - VISIBLE_Q : 0;
    var rows = '';
    for (var i = 0; i < series.length; i++) {
        var s = series[i], prev = i > 0 ? series[i - 1] : null;
        var qoq;
        if (s.partial) {
            // EXT-AUDIT #61: the newest quarter's GLOBAL ingest is mid-arrival —
            // a QoQ percent against it is a fake collapse (2025-Q4 read as ▼94%).
            qoq = '<span class="hf-flat">ingest in progress</span>';
        }
        else if (prev && notComparable[String(prev.quarter)]) {
            // QA-12: a percent against a thin, non-comparable quarter is not a
            // change in ownership (4 -> 5,000 would read as +124,900%).
            qoq = '<span class="hf-flat">—</span>';
        }
        else if (prev && prev.n_holders && !prev.partial) {
            var pct = ((s.n_holders - prev.n_holders) / prev.n_holders) * 100;
            var flat = Math.abs(pct) < 0.05, up = pct > 0;
            var cls = flat ? 'hf-flat' : (up ? 'ol-13f-trend__pos' : 'ol-13f-trend__neg');
            var arr = flat ? '—' : (up ? '▲' : '▼');
            qoq = '<span class="' + cls + '">' + arr + ' ' + Math.abs(pct).toFixed(1) + '%</span>';
        }
        else {
            qoq = '<span class="hf-flat">—</span>';
        }
        var rowCls = i < extraCount ? ' class="ol-13f-trend__row--extra"' : '';
        rows += '<tr' + rowCls + '>' +
            '<td class="ol-13f-trend__q">' + escHtml(String(s.quarter || '')) + (s.partial ? ' <span class="hf-flat">·</span>' : '') + '</td>' +
            '<td class="ol-13f-trend__num">' + (typeof s.n_holders === 'number' ? s.n_holders.toLocaleString() : '—') + '</td>' +
            '<td class="ol-13f-trend__num ol-13f-trend__hide-mobile">' + _fmt13fUsd(s.total_value) + '</td>' +
            '<td class="ol-13f-trend__num">' + qoq + '</td>' +
            '</tr>';
    }
    return '<div class="ol-13f-trend__head">' +
        '<span class="ol-13f-trend__eyebrow">Ownership trend</span>' +
        '<span class="ol-13f-trend__asof">as of ' + escHtml(String(latest.quarter || '')) +
        ' · ' + nq + (nq === 1 ? ' qtr' : ' qtrs') + '</span>' +
        '</div>' +
        '<div class="ol-13f-trend__sparkwrap">' +
        '<span class="ol-13f-trend__axis">holders</span>' + _build13fSparkline(holders, quarters) +
        '</div>' +
        '<table class="ol-13f-trend__table"><thead><tr>' +
        '<th>Quarter</th><th class="ol-13f-trend__num">Holders</th>' +
        '<th class="ol-13f-trend__num ol-13f-trend__hide-mobile">Total value</th>' +
        '<th class="ol-13f-trend__num">QoQ</th>' +
        '</tr></thead><tbody>' + rows + '</tbody></table>' +
        (extraCount > 0
            ? '<button type="button" class="ol-13f-trend__toggle" aria-expanded="false">Show all ' +
                series.length + ' quarters</button>'
            : '') +
        '<div class="ol-13f-trend__net ' + netCls + '">' + netTxt + '</div>';
}
// OWNER 2026-07-13: wire the last-4-quarters expand/collapse toggle. Self-
// contained (listener attached to the freshly-built strip after insert) rather
// than routed through the global data-action delegator — keeps the trend widget
// dependency-free of the app-renderers dispatch table.
function _wire13fTrendToggle(wrap, totalQuarters) {
    if (!wrap)
        return;
    var btn = wrap.querySelector('.ol-13f-trend__toggle');
    if (!btn)
        return;
    btn.addEventListener('click', function () {
        var expanded = wrap.classList.toggle('ol-13f-trend--expanded');
        btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        btn.textContent = expanded
            ? 'Show recent 4 quarters'
            : 'Show all ' + totalQuarters + ' quarters';
    });
}
function mount13fTrendStrip(panelEl, ticker) {
    if (!panelEl || !ticker)
        return;
    var t = String(ticker).trim().toUpperCase();
    function _insert(payload) {
        var series = payload && payload.series;
        if (!series || series.length < 2)
            return; // <2 quarters -> not a trend; suppress (DESIGN)
        if (panelEl.querySelector('.ol-13f-trend'))
            return; // already mounted this render
        var wrap = document.createElement('div');
        wrap.className = 'ol-13f-trend';
        // innerHTML on a FRESH detached div (no canvas/observer children) — safe.
        wrap.innerHTML = _build13fTrendStripHtml(series, payload.coverage_began);
        _wire13fTrendToggle(wrap, series.length);
        var chip = panelEl.querySelector('.hf-chip');
        if (chip && chip.parentNode === panelEl)
            panelEl.insertBefore(wrap, chip);
        else
            panelEl.insertBefore(wrap, panelEl.children.length > 1 ? panelEl.children[1] : null);
    }
    if (_13fTrendCache[t]) {
        _insert(_13fTrendCache[t]);
        return;
    }
    var url = (typeof SERVER !== 'undefined' ? SERVER : '') +
        '/api/institutional-holders/timeseries?ticker=' + encodeURIComponent(t);
    // #74: view-aware signal — the old `view || timeout` shape dropped the
    // deadline whenever a view signal existed.
    var signal = (typeof getViewAwareSignal === 'function') ? getViewAwareSignal(15000)
        : ((typeof AbortSignal !== 'undefined' && AbortSignal.timeout) ? AbortSignal.timeout(15000) : undefined);
    fetch(url, { signal: signal })
        .then(function (r) { return r && r.ok ? r.json() : null; })
        .then(function (d) {
        if (!d || d.error || !d.series)
            return;
        // EXT-AUDIT #61: cache the payload (series + coverage_began), not the
        // bare series — the coverage note must survive the cache path too.
        _13fTrendCache[t] = { series: d.series, coverage_began: d.coverage_began };
        _insert(_13fTrendCache[t]);
    })
        .catch(function () { });
}
// X5c-2: the FUND variant of the trend strip for /?view=13f (a fund's portfolio
// over time). Reuses the sparkline + USD formatter; the metric is total portfolio
// VALUE (a fund's size over quarters is the natural longitudinal read). Carries the
// full source line since the fund result has no sibling disclaimer (DESIGN).
var _13fFundTrendCache = {};
// QA 2026-10-27 P1-4: the API labels each quarter (`filing_status`) and says
// whether a QoQ against the prior calendar quarter is meaningful
// (`qoq_comparable`). An amendment stored as the quarter, or a quarter stored
// in thousands of dollars, is shown but never drawn or diffed. A payload
// without the keys (an older cache) renders as before.
function _13fRowComplete(s) {
    return !s || !s.filing_status || s.filing_status === 'complete';
}
function _build13fFundTrendHtml(series) {
    var quarters = series.map(function (s) { return s.quarter; });
    var values = series.map(function (s) {
        return (typeof s.total_value === 'number' && _13fRowComplete(s)) ? s.total_value : null;
    });
    var complete = series.filter(_13fRowComplete);
    var latest = complete.length ? complete[complete.length - 1] : series[series.length - 1];
    var first = complete.length ? complete[0] : series[0];
    var nq = series.length;
    var net = (latest.total_value || 0) - (first.total_value || 0);
    var netCls = net > 0 ? 'ol-13f-trend__net--up' : (net < 0 ? 'ol-13f-trend__net--down' : '');
    var netArrow = net > 0 ? '▲' : (net < 0 ? '▼' : '·');
    var netTxt = netArrow + ' Net ' + (net >= 0 ? '+' : '-') + _fmt13fUsd(Math.abs(net)) +
        ' since ' + escHtml(String(first.quarter || ''));
    // OWNER 2026-07-13: last-4-quarters default + expand/collapse (mirror of the
    // holders trend strip). Sparkline + net keep full history; table collapses.
    var VISIBLE_Q = 4;
    var extraCount = series.length > VISIBLE_Q ? series.length - VISIBLE_Q : 0;
    var rows = '';
    for (var i = 0; i < series.length; i++) {
        var s = series[i], prev = i > 0 ? series[i - 1] : null;
        var qoq;
        if (s.qoq_comparable === false) {
            // PROFESSOR 2026-10-31: 'partial' is a size test, not an amendment flag
            // (a fund that sold most of its book reads the same), and a complete
            // quarter can be non-comparable because the PRIOR one is partial.
            var why = s.filing_status === 'partial' ? 'partial filing'
                : (s.filing_status === 'unit_suspect' ? 'unit check' : 'not comparable');
            qoq = '<span class="hf-flat">' + why + '</span>';
        }
        else if (prev && prev.total_value) {
            var pct = ((s.total_value - prev.total_value) / prev.total_value) * 100;
            var flat = Math.abs(pct) < 0.05, up = pct > 0;
            var cls = flat ? 'hf-flat' : (up ? 'ol-13f-trend__pos' : 'ol-13f-trend__neg');
            var arr = flat ? '—' : (up ? '▲' : '▼');
            qoq = '<span class="' + cls + '">' + arr + ' ' + Math.abs(pct).toFixed(1) + '%</span>';
        }
        else {
            qoq = '<span class="hf-flat">—</span>';
        }
        var rowCls = i < extraCount ? ' class="ol-13f-trend__row--extra"' : '';
        rows += '<tr' + rowCls + '>' +
            '<td class="ol-13f-trend__q">' + escHtml(String(s.quarter || '')) + '</td>' +
            '<td class="ol-13f-trend__num">' + (typeof s.n_positions === 'number' ? s.n_positions.toLocaleString() : '—') + '</td>' +
            '<td class="ol-13f-trend__num ol-13f-trend__hide-mobile">' + _fmt13fUsd(s.total_value) + '</td>' +
            '<td class="ol-13f-trend__num">' + qoq + '</td>' +
            '</tr>';
    }
    return '<div class="ol-13f-trend__head">' +
        '<span class="ol-13f-trend__eyebrow">Portfolio trend</span>' +
        '<span class="ol-13f-trend__asof">as of ' + escHtml(String(latest.quarter || '')) +
        ' · ' + nq + (nq === 1 ? ' qtr' : ' qtrs') + '</span>' +
        '</div>' +
        '<div class="ol-13f-trend__sparkwrap">' +
        '<span class="ol-13f-trend__axis">value</span>' + _build13fSparkline(values, quarters) +
        '</div>' +
        '<table class="ol-13f-trend__table"><thead><tr>' +
        '<th>Quarter</th><th class="ol-13f-trend__num">Positions</th>' +
        '<th class="ol-13f-trend__num ol-13f-trend__hide-mobile">Total value</th>' +
        '<th class="ol-13f-trend__num">QoQ</th>' +
        '</tr></thead><tbody>' + rows + '</tbody></table>' +
        (extraCount > 0
            ? '<button type="button" class="ol-13f-trend__toggle" aria-expanded="false">Show all ' +
                series.length + ' quarters</button>'
            : '') +
        '<div class="ol-13f-trend__net ' + netCls + '">' + netTxt + '</div>' +
        '<div class="hf-disclaimer">13F-HR portfolios are reported quarterly with a ~45-day delay, cover long U.S.-equity positions only, and are not a recommendation to follow fund managers.</div>';
}
function mount13fFundTrendStrip(resultEl, cik) {
    if (!resultEl || !cik)
        return;
    var c = String(cik).trim();
    function _insert(series) {
        if (!series || series.length < 2)
            return; // <2 quarters -> not a trend; suppress
        if (resultEl.querySelector('.ol-13f-trend'))
            return;
        var wrap = document.createElement('div');
        wrap.className = 'ol-13f-trend';
        wrap.innerHTML = _build13fFundTrendHtml(series);
        _wire13fTrendToggle(wrap, series.length);
        var tbl = resultEl.querySelector('.f13-table');
        resultEl.insertBefore(wrap, tbl || null); // above the positions table (or append)
    }
    if (_13fFundTrendCache[c]) {
        _insert(_13fFundTrendCache[c]);
        return;
    }
    var url = (typeof SERVER !== 'undefined' ? SERVER : '') +
        '/api/fund-holdings/timeseries?cik=' + encodeURIComponent(c);
    fetch(url, { signal: (typeof AbortSignal !== 'undefined' && AbortSignal.timeout) ? AbortSignal.timeout(15000) : undefined })
        .then(function (r) { return r && r.ok ? r.json() : null; })
        .then(function (d) { if (!d || d.error || !d.series)
        return; _13fFundTrendCache[c] = d.series; _insert(d.series); })
        .catch(function () { });
}
// ── 13F VIEW ──
var DISTRESSED_FUNDS = [
    'oaktree', 'apollo', 'ares', 'baupost', 'anchorage', 'cerberus',
    'elliott', 'king street', 'mudrick', 'aurelius', 'canyon', 'centerbridge',
    'fortress', 'avenue capital', 'marathon asset', 'silver point',
    'solus', 'blackstone credit', 'carlyle', 'kkr credit'
];
var MAJOR_CREDIT_HOLDERS = ['pimco', 'blackrock', 'vanguard'];
function fundBadgeHtml(holderName) {
    if (!holderName)
        return '';
    const lower = holderName.toLowerCase();
    if (DISTRESSED_FUNDS.some(f => lower.includes(f))) {
        return '<span class="fund-badge fund-badge-distressed">HY/DISTRESSED</span>';
    }
    if (MAJOR_CREDIT_HOLDERS.some(f => lower.includes(f))) {
        return '<span class="fund-badge fund-badge-major">Major Holder</span>';
    }
    return '';
}
// fmtVal13f loaded from static/js/formatting.js
async function search13fTicker() {
    const input = document.getElementById('f13-ticker-input');
    const el = document.getElementById('f13-ticker-results');
    let ticker = input.value.trim().toUpperCase();
    if (!ticker)
        return;
    el.innerHTML = '<div class="f13-loading">Fetching holders...</div>';
    // Fix B (2026-06-30 OWNER): accept a company NAME as well as a ticker.
    // Clicking a holding on the right panel can populate a full company name;
    // resolve it to a ticker via /api/company/search before the holders lookup.
    // #21 (2026-07-07): when the name does NOT resolve to a listed ticker, STOP
    // and say so honestly — do NOT fall through firing ?ticker=<name>, which
    // returns an empty set the UI then paints as "No institutional holders on
    // record" (a false negative: KO has plenty of holders; we just failed to map
    // "COCA COLA CO" -> KO). The right FUND HOLDINGS panel now passes the
    // server-resolved ticker directly (data-ticker), so this branch is the
    // fallback for the unresolved-CUSIP tail + names typed by hand.
    if (!/^[A-Z][A-Z.\-]{0,5}$/.test(ticker)) {
        let _resolved = '';
        try {
            const rq = input.value.trim();
            const rr = await fetch(`${SERVER}/api/company/search?q=${encodeURIComponent(rq)}`, { signal: getViewAwareSignal(8000) });
            if (rr.ok) {
                const rd = await rr.json();
                const hit = (rd.results || rd.companies || rd.matches || [])[0];
                if (hit && (hit.ticker || hit.symbol))
                    _resolved = String(hit.ticker || hit.symbol).toUpperCase();
            }
        }
        catch { /* network error — treated as unresolved below */ }
        if (!_resolved) {
            el.innerHTML = OLEmpty.render({
                title: 'No matching ticker',
                body: 'We could not map "' + escHtml(input.value.trim())
                    + '" to a listed ticker. Try the ticker symbol directly (e.g. KO for Coca-Cola).',
            });
            return;
        }
        ticker = _resolved;
    }
    try {
        // Fix D (2026-06-30 OWNER): combine SC 13D/G (>=5% holders) AND 13F
        // institutional holders into ONE table, each tagged with its filing type,
        // for the fullest shareholder base (matches the '13F Browser' framing + the
        // right FUND HOLDINGS panel). Either source may be empty; both are optional.
        const [res, res13f] = await Promise.all([
            fetch(`${SERVER}/api/holders?ticker=${encodeURIComponent(ticker)}`, { signal: getViewAwareSignal(15000) }).catch(() => null),
            fetch(`${SERVER}/api/institutional-holders?ticker=${encodeURIComponent(ticker)}`, { signal: getViewAwareSignal(15000) }).catch(() => null),
        ]);
        // CYCLE P1-2 (2026-09-01): the backend fail-loud (PgPoolExhausted ->
        // 503) stopped HERE -- a !ok response skipped its branch silently, so
        // an outage rendered either a 13D/G-only table with no hint the
        // institutional rows were missing, or the OLEmpty 'No institutional
        // holders on record' -- an outage mislabeled as an empty universe.
        // Track availability per source and say what actually happened.
        const dgUnavailable = !res || !res.ok;
        const instUnavailable = !res13f || !res13f.ok;
        const data = (res && res.ok) ? await res.json() : {};
        let holders = (data.holders || []).map(h => ({ ...h, filingType: h.filingType || '13D/G' }));
        let coverage13f = null; // P2: {shares_13f, fund_count, shares_outstanding, pct, quarter}
        let inst13fShown = 0; // 13F holders actually displayed (API caps at top-100)
        let inst13fTotal = 0; // true 13F filer count (from the full-aggregate coverage)
        // P1-13f DATA_CZAR 2026-09-21 (L1): the rows the backend WITHHELD. Defaults
        // to [] so an SSR payload, a cached payload predating the key, or a 13F
        // outage renders exactly as before.
        let withheld13f = [];
        if (res13f && res13f.ok) {
            try {
                const d13f = await res13f.json();
                coverage13f = d13f.coverage || null;
                withheld13f = d13f.superseded_parents || [];
                inst13fTotal = (coverage13f && coverage13f.fund_count) || (d13f.total_holders || 0);
                // P1-13f (2026-09-19): the route labels each row with how many
                // quarters behind the ticker's as-of quarter its filing is
                // (stale_quarters, 0 = current). Carry it into the Reported cell so a
                // fund that has not filed since an older quarter is legible as such
                // instead of reading like a current position.
                const inst = (d13f.holders || []).map(h => ({
                    holder: h.fund_name, type: 'Institution',
                    shares: h.shares, value: h.value_usd, pctHeld: null,
                    dateReported: h.quarter || h.filing_date || '', filingType: '13F',
                    staleQuarters: (typeof h.stale_quarters === 'number' && h.stale_quarters > 0)
                        ? h.stale_quarters : null,
                    // DATA_CZAR 2026-09-21 (L7): the opposite direction, which the
                    // clamped stale_quarters cannot express. A row struck at a quarter
                    // NEWER than the panel's as-of carries ahead_quarters >= 1 and was
                    // previously rendered as though it were current at the panel's
                    // as-of (12 of the 100 measured AAPL rows).
                    aheadQuarters: (typeof h.ahead_quarters === 'number' && h.ahead_quarters > 0)
                        ? h.ahead_quarters : null,
                }));
                inst13fShown = inst.length;
                holders = holders.concat(inst);
            }
            catch { /* 13F optional */ }
        }
        // OWNER 2026-07-09: ONE ENTITY, ONE ROW. The 13D/G + 13F concat above
        // duplicated filers present in BOTH sources (VANGUARD CAPITAL MANAGEMENT
        // appeared twice on CRM — once as Schedule 13G, once as 13F). Dedupe by
        // normalized holder name keeping the most recently REPORTED entry, and
        // merge the fields only the losing source carries (pctHeld comes from
        // 13D/G; filingUrl varies). Rows with no name pass through untouched.
        const _hKey = (nm) => String(nm || '').toUpperCase().replace(/[^A-Z0-9 ]+/g, ' ').replace(/\s+/g, ' ').trim();
        const _hDate = (d) => {
            const s = String(d || '');
            const m = s.match(/^(\d{4})-Q([1-4])$/);
            // quarter labels sort against ISO dates via their quarter-end date
            return m ? m[1] + '-' + ['03-31', '06-30', '09-30', '12-31'][Number(m[2]) - 1] : s;
        };
        const _byName = {};
        const _order = [];
        const _unnamed = [];
        holders.forEach((h) => {
            const k = _hKey(h.holder);
            if (!k) {
                _unnamed.push(h);
                return;
            }
            const prev = _byName[k];
            if (!prev) {
                _byName[k] = h;
                _order.push(k);
                return;
            }
            const keep = _hDate(h.dateReported) >= _hDate(prev.dateReported) ? h : prev;
            const lose = keep === h ? prev : h;
            if (keep.pctHeld == null && lose.pctHeld != null)
                keep.pctHeld = lose.pctHeld;
            if (!keep.filingUrl && lose.filingUrl)
                keep.filingUrl = lose.filingUrl;
            if (lose.filingType && keep.filingType && lose.filingType !== keep.filingType)
                keep.filingType = '13F + 13D/G';
            _byName[k] = keep;
        });
        holders = _order.map((k) => _byName[k]).concat(_unnamed);
        holders.sort((a, b) => (b.value || 0) - (a.value || 0));
        data.holders = holders;
        data.ticker = data.ticker || ticker;
        if ((data.error || (dgUnavailable && instUnavailable)) && !holders.length) {
            /* @__PURE__ */ _olDebugError('[holders fetch]', data.error || 'both holder sources unavailable');
            el.innerHTML = `<div class="f13-error-msg">We couldn't load holder data for this ticker. Try again in a moment.</div>`;
            return;
        }
        let html = '';
        if (data.summary && Object.keys(data.summary).length > 0) {
            const s = data.summary;
            html += '<div class="f13-summary">';
            for (const [key, val] of Object.entries(s)) {
                const display = typeof val === 'number' && val < 200 ? val.toFixed(2) + '%' : escHtml(String(val));
                html += `${escHtml(key)}: <span class="f13-val-primary">${display}</span> &nbsp; `;
            }
            html += '</div>';
        }
        if (data.holders && data.holders.length > 0) {
            // #102b (2026-07-19): when the 13F lookup returned ZERO (no institutional
            // rows merged in above) and ONLY Schedule 13D/G filers render, SAY so
            // explicitly — never present a handful of 5%+ owners/insiders as the
            // institutional universe. The resolve_siblings / ticker_match_variants fix
            // upstream makes this rare (class-share dot-form tickers now resolve to the
            // dash-keyed store), but the honest regime label must exist for genuinely-
            // thin tickers with no 13F coverage at all.
            if (inst13fShown === 0) {
                html += '<div class="f13-summary f13-summary-box f13-regime-note">'
                    + '13F holdings unavailable for this symbol form; showing Schedule '
                    + '13D/G filers (5%+ owners + insiders) instead.</div>';
            }
            // Company totals
            const sharesOut = data.sharesOutstanding;
            const mktCap = data.marketCap;
            if (sharesOut || mktCap) {
                html += `<div class="f13-summary f13-summary-box">
          <strong class="f13-val-primary cursor-pointer" data-action="switch-ticker" data-ticker="${escHtml(data.ticker)}">${escHtml(data.ticker)}</strong>
          ${sharesOut ? `<span class="f13-ml12">Shares Outstanding: <strong class="f13-val-primary">${(sharesOut / 1e6).toFixed(2)}M</strong></span>` : ''}
          ${mktCap ? `<span class="f13-ml12">Market Cap: <strong class="f13-val-primary">${fmtAbbrev(mktCap)}</strong></span>` : ''}
        </div>`;
            }
            // P2 (2026-06-30, 13F broad-coverage): "% of shares accounted for" — the
            // fraction of shares outstanding held by the tracked 13F filers. Rises as
            // the bulk-ingest widens the filer universe toward the >=90% goal.
            if (coverage13f && coverage13f.pct != null) {
                const _fc = coverage13f.fund_count || 0;
                // #89: basis-aware copy — when the universe aggregate degraded
                // (mega-cap timeout) the numbers cover only the capped display list,
                // and claiming "N filers hold X%" as the universe would be false.
                const _isTopOnly = coverage13f.basis === 'top_display';
                // R12 (2026-08-15, CUSIP-hygiene review F2/F3): the % below is built
                // from CUSIP-resolved rows — the store where preferred/notes rows were
                // measurably counted as common. The caveat renders under the SAME
                // condition as the figure (a first draft attached it to the capped-list
                // disclaimer below, which does not render when every filer is shown —
                // so a small ticker displayed the % uncaveated).
                html += `<div class="f13-summary f13-summary-inline">
          ${_isTopOnly ? 'The <strong class="f13-val-primary">top ' + _fc.toLocaleString() + ' filers by position</strong> hold' : `<strong class="f13-val-primary">${_fc.toLocaleString()} 13F filer${_fc === 1 ? '' : 's'}</strong> hold`}
          <strong class="f13-val-primary">${coverage13f.pct}%</strong> of shares outstanding
          ${coverage13f.quarter ? `<span class="color-text-secondary">(${escHtml(String(coverage13f.quarter))})</span>` : ''}
          ${_isTopOnly ? '<span class="color-text-secondary">(full filer universe unavailable for this ticker right now)</span>' : ''}
          <span class="color-text-secondary">— counts every holding that matched to this ticker, so it measures how complete the match is, not whether every match is correct</span>
        </div>`;
            }
            // Totals for listed holders
            const totalShares = data.holders.reduce((s, h) => s + (h.shares || 0), 0);
            const totalValue = data.holders.reduce((s, h) => s + (h.value || 0), 0);
            const totalPct = data.holders.reduce((s, h) => s + (h.pctHeld || 0), 0);
            // #102a (2026-07-19): two percentages on one screen was the trust-leak.
            // The coverage line above ("N filers hold X% of shares outstanding") is
            // the HONEST aggregate over ALL tracked 13F filers (e.g. AAPL 63.1%). This
            // per-row pctHeld sum only covers rows that CARRY a pct — Schedule 13D/G
            // (>=5%) filers — because every 13F row has pctHeld=null (set above), so
            // summing it produced a partial figure (e.g. 7.48%) that CONTRADICTED the
            // 63.1% coverage line for the SAME top-100 set. Show the combined-stake %
            // ONLY in the pure 13D/G case (no coverage line), where each row's pctHeld
            // is a real % of shares outstanding; otherwise DROP the second stat.
            const _showTotalPct = !coverage13f && totalPct > 0;
            html += `<div class="f13-summary f13-summary-inline">
        <strong class="f13-val-primary">Top ${data.holders.length} Holders:</strong>
        <strong class="f13-val-primary">${totalShares.toLocaleString()} shares</strong> |
        <strong class="f13-val-primary">${fmtVal13f(totalValue)}</strong>${_showTotalPct ? ` |
        <strong class="f13-val-primary">${totalPct.toFixed(2)}% of shares</strong>` : ''}
      </div>`;
            // MA-P2 #34 Wave-1b (VOICE: holder TYPE is a taxonomy, not a verdict —
            // insider buying is often bullish, so it must NOT wear a "bad" hue).
            // Neutral categorical chart series, zero good/bad valence.
            const typeColors = { 'Institution': 'var(--chart-1)', 'Mutual Fund': 'var(--chart-3)', 'Insider/Trust': 'var(--chart-6)', 'Large Holder': 'var(--chart-quinary)' };
            // OWNER 2026-07-08: the free-tier 5-row fade is REMOVED — 13F holder
            // data is public SEC data, freely available elsewhere, and the standing
            // monetization doctrine (sf_monetization_v3) never paywalls public data
            // (revenue comes from AI/tool usage). Everyone sees the full top-100
            // display list (the server cap still bounds the payload).
            // #102c (2026-07-19): wrap the results table in an overflow-x scroll
            // container (the /bdcs .bd-table-wrap pattern) so it no longer overflows
            // its card and overlaps the FUND HOLDINGS panel (~958px); cells nowrap via
            // .f13-table-wrap so long Type labels stop truncating mid-word.
            html += '<div class="f13-table-wrap"><table class="data-table f13-table"><thead><tr><th>Holder</th><th>Type</th><th>Shares</th><th>Value</th><th>% Held</th><th>Reported</th></tr></thead><tbody>';
            data.holders.forEach((h) => {
                const typeColor = typeColors[h.type] || 'var(--text-secondary)';
                const _f13SafeUrl = _sanitizeUrl(h.filingUrl);
                const nameHtml = h.filingUrl
                    ? `<a href="${escHtml(_f13SafeUrl)}" target="_blank" rel="noopener noreferrer nofollow" class="f13-filing-link">${escHtml(h.holder)}</a>`
                    : escHtml(h.holder);
                const crossSearchBtn = `<span class="cross-search-btn" title="Search ${escHtml(h.holder)}'s holdings" data-action="cross-search-fund" data-holder="${escHtml(h.holder || '')}">\u2192 holdings</span>`;
                const typeLabel = h.filingType ? `${h.type} (${h.filingType})` : h.type || '';
                html += `<tr>
          <td>${nameHtml}${fundBadgeHtml(h.holder)}${crossSearchBtn}</td>
          <td data-fg="${typeColor}" class="fs-10">${escHtml(typeLabel)}</td>
          <td>${h.shares ? h.shares.toLocaleString() : '\u2014'}</td>
          <td>${fmtVal13f(h.value)}</td>
          <td>${h.pctHeld ? h.pctHeld.toFixed(2) + '%' : '\u2014'}</td>
          <td class="color-text-secondary">${escHtml(h.dateReported || '')}${h.staleQuarters ? ` <span title="This filer has not reported since ${escHtml(String(h.dateReported || ''))}; the position may have moved to an affiliate.">stale (${h.staleQuarters} quarter${h.staleQuarters === 1 ? '' : 's'} behind)</span>` : ''}${h.aheadQuarters ? ` <span title="This filing is NEWER than the ${escHtml(String(coverage13f && coverage13f.quarter || ''))} snapshot this panel is labelled with; it is not comparable like-for-like with the rows at that quarter.">(${h.aheadQuarters} quarter${h.aheadQuarters === 1 ? '' : 's'} ahead of as-of)</span>` : ''}</td>
        </tr>`;
            });
            html += '</tbody></table></div>';
            // P1-13f DATA_CZAR 2026-09-21 (L1): SAY WHAT WAS WITHHELD. The fold
            // removes a stale parent row whose book now arrives under sibling CIKs,
            // and its own justification is "so the decision is auditable instead of
            // invisible" — but `superseded_parents` shipped with ZERO readers on any
            // surface, which is the same defect
            // tests/test_13f_withheld_verdict_is_rendered_contract.py closed for this
            // panel eleven days earlier (2026-09-08: the backend was already
            // shipping the remedy and nobody read it). A holder vanishing from the
            // table with no explanation is not a disclosure. Both operands of the
            // reconciliation are printed, so the reader can check the claim rather
            // than take it on faith (`feedback_inherited_ratio_check_the_denominator`).
            if (withheld13f.length) {
                const _wItems = withheld13f.map((w) => {
                    const _n = (w.superseded_by || []).length;
                    const _own = Number(w.shares || 0).toLocaleString();
                    const _sib = Number(w.superseded_by_shares || 0).toLocaleString();
                    const _pct = (typeof w.reconciled_pct === 'number') ? w.reconciled_pct : null;
                    return `${escHtml(String(w.fund_name || 'This filer'))} (last filed ${escHtml(String(w.quarter || ''))}, ${escHtml(_own)} shares) reconciles to its ${_n} current affiliate${_n === 1 ? '' : 's'} (${escHtml(_sib)} shares)${_pct === null ? '' : ` &mdash; ${escHtml(_pct.toFixed(3))}% apart`}`;
                }).join('; ');
                // DESIGN F10 (2026-09-21): the `disclosure-verdict` MODIFIER on the
                // disclaimer utility. This note is not COUNSEL-04 boilerplate -- it is
                // a two-operand nine-figure provenance claim printed so the reader can
                // check it, and the bare utility set it at 9px italic --text-muted,
                // visually identical to the 45-day-delay line below that a reader has
                // trained themselves to skip. The modifier promotes it to --text-sm +
                // --text-muted-body and drops the italic; see dashboard-styles.css.
                html += `<div class="feature-disclaimer disclosure-verdict">${withheld13f.length} parent filing${withheld13f.length === 1 ? '' : 's'} withheld from the table above, and from the coverage figures, to avoid listing one book twice: ${_wItems}.</div>`;
            }
            // 13F broad-coverage (2026-07-01): the API caps the 13F holder list at
            // top-100 by value, but coverage.fund_count is the TRUE total. When the
            // list is capped, tell the user they're seeing the largest positions of a
            // bigger set (honest — the "% of shares" line above already reflects ALL).
            if (instUnavailable) {
                // 13D/G rendered but the 13F source failed: the table is NOT the
                // institutional universe and must say so (f13-inst-unavailable is
                // the contract pin).
                html += `<div class="feature-disclaimer f13-inst-unavailable">Institutional (13F) data is temporarily unavailable - showing 5%+ beneficial owners (13D/G) only. Refresh in a moment for the full institutional table.</div>`;
            }
            if (inst13fTotal > inst13fShown && inst13fShown > 0) {
                html += `<div class="feature-disclaimer">Showing the top ${inst13fShown.toLocaleString()} of ${inst13fTotal.toLocaleString()} 13F filers by position value. The "% of shares outstanding" above reflects all of them.</div>`;
            }
            html += '<div class="feature-disclaimer">Holdings are reported quarterly with a 45-day delay. Not a recommendation to follow fund managers.</div>';
        }
        else {
            // CR-H3 fix: use OLEmpty.render for zero-holders path so users
            // see an informative state rather than a blank rectangle.
            // (Previously rendered bespoke .f13-empty-wrap HTML — replaced
            // with canonical factory to converge on the .ol-empty CSS family.)
            if (instUnavailable) {
                // An outage must NEVER read as an empty universe: 'no holders on
                // record' is a data claim we cannot make when the source 503'd.
                el.innerHTML = `<div class="f13-error-msg">Institutional holder data is temporarily unavailable. Try again in a moment.</div>`;
                return;
            }
            el.innerHTML = OLEmpty.render({
                title: 'No institutional holders on record',
                body: 'This company has no 13F coverage in the latest filing window. '
                    + '13F filings are required only for institutional managers with &gt;$100M AUM. '
                    + 'Try a larger-cap ticker like AAPL or MSFT.'
            });
            return;
        }
        el.innerHTML = html;
        _hydrateTickerStyles(el);
    }
    catch (e) {
        // Un-silenced 2026-07-08: this catch swallowed a ReferenceError (cik not
        // defined) for FOUR rounds of screenshots. A data-surface catch that paints
        // a generic error MUST surface the real cause (feedback_incident_debugging).
        // Report to Sentry (the prod-visible signal; _olDebugError is @__PURE__-
        // stripped in prod, and console.* trips the no-console ratchet).
        try {
            var _S13 = window.Sentry;
            if (_S13 && typeof _S13.captureException === 'function') {
                _S13.captureException(e, { tags: { feature: '13f_holders_render' } });
            }
        }
        catch (_se) { /* Sentry optional */ }
        el.innerHTML = '<div class="f13-error-wrap">'
            + '<div class="f13-error-title">Unable to load institutional holders</div>'
            + '<div class="f13-error-detail">This data may not be available for this company, or the server is temporarily unreachable.</div>'
            + '</div>';
    }
}
document.getElementById('f13-ticker-input')?.addEventListener('keydown', e => { if (e.key === 'Enter')
    search13fTicker(); });
// Cross-search between 13F panels
function crossSearchFund(fundName) {
    const inp = document.getElementById('f13-fund-input');
    if (inp) {
        inp.value = fundName;
        search13fFund();
    }
    if (typeof trackUniqueAchievement === 'function')
        trackUniqueAchievement('f13_drilldowns', fundName);
    if (typeof trackAchievement === 'function')
        trackAchievement('fund_overlaps');
    // Suppressed: routine search toast removed for silent fetching
    // showToast(`Searching holdings for: ${fundName}`, '', 2500);
}
function crossSearchTicker(nameOrTicker) {
    const inp = document.getElementById('f13-ticker-input');
    if (inp) {
        // #21 name<->ticker round trip (2026-07-05): search13fTicker resolves
        // company NAMES via /api/company/search (Fix B, 06-30), so the
        // "<- holders" button now RUNS the search instead of pasting the name
        // and telling the user to type the ticker themselves (the old dead-end
        // toast "Enter ticker for: ...").
        inp.value = nameOrTicker.trim();
        if (typeof trackUniqueAchievement === 'function')
            trackUniqueAchievement('f13_drilldowns', nameOrTicker + ':' + inp.value.toUpperCase());
        search13fTicker();
    }
}
// Cache for notable funds JSON (loaded on demand)
var _notableFundsCache = null;
async function _loadNotableFunds(container) {
    try {
        if (!_notableFundsCache) {
            var resp = await fetch('/static/data/notable-funds.json', { signal: AbortSignal.timeout(10000) });
            if (!resp.ok)
                throw new Error('HTTP ' + resp.status);
            _notableFundsCache = await resp.json();
        }
        var cats = _notableFundsCache.categories || [];
        // D2 honesty header: state what the directory IS (curated filer
        // names) and what selecting one DOES (searches SEC EDGAR for the
        // filer's latest 13F) — never imply a pre-loaded holdings catalog.
        // Count computed from the data so the label can't drift stale.
        var _dirTotal = 0;
        cats.forEach(function (cat) { _dirTotal += (cat.funds || []).length; });
        var html = '<div class="dim-msg">A curated directory of ' + _dirTotal
            + ' notable filer names. Selecting one searches SEC EDGAR for that filer\u2019s most recent 13F filing.</div>';
        cats.forEach(function (cat) {
            html += '<div class="f13-fund-category"><div class="f13-fund-category-label">' + escHtml(cat.label) + '</div>';
            cat.funds.forEach(function (f) {
                html += '<div class="f13-fund-result" data-action="try-13f-fund" data-fund-name="' + escHtml(f) + '"><div class="f13-fund-name">' + escHtml(f) + '</div></div>';
            });
            html += '</div>';
        });
        container.innerHTML = html;
    }
    catch (e) {
        container.innerHTML = '<div class="f13-error-detail">Could not load fund directory. Please try again.</div>';
    }
}
// #35 stale-response guard (2026-07-09): search13fFund and load13fHoldings
// share the f13-fund-results container. Without a generation counter, a slow
// or duplicate search response landing AFTER a newer render (fresh search OR
// a holdings panel the user clicked into) overwrote it — the Point72 flicker:
// holdings rendered, then a late failed search painted "SEC search is
// temporarily unavailable" over them. Every async writer captures the seq at
// start and drops its write if the panel has moved on.
var _f13FundReqSeq = 0;
var _f13FundInFlightQ = null;
async function search13fFund() {
    const input = document.getElementById('f13-fund-input');
    const el = document.getElementById('f13-fund-results');
    const query = input.value.trim();
    if (!query)
        return;
    // Duplicate-trigger dedupe (double-bound button class): an identical query
    // already in flight will render; a second concurrent fetch adds only risk.
    if (query === _f13FundInFlightQ)
        return;
    const _seq = ++_f13FundReqSeq;
    _f13FundInFlightQ = query;
    el.innerHTML = '<div class="f13-loading">Searching EDGAR...</div>';
    try {
        const res = await fetch(`${SERVER}/api/fund-search?q=${encodeURIComponent(query)}`, { signal: AbortSignal.timeout(15000) });
        if (_seq !== _f13FundReqSeq)
            return; // panel claimed by newer search/holdings
        if (!res.ok)
            throw new Error('HTTP ' + res.status);
        const data = await res.json();
        if (_seq !== _f13FundReqSeq)
            return;
        if (!data.results || data.results.length === 0) {
            el.innerHTML = OLEmpty.render({
                title: 'No Funds Found',
                body: 'No funds found matching \u2018' + escHtml(query) + '\u2019. Try a shorter name or browse notable funds.'
                    + '<br><button class="f13-browse-btn btn btn-secondary btn-sm" data-action="browse-top-funds">Browse the fund directory</button>',
            })
                // D2 (OWNER 2026-06-11, 13F CYCLE): was "Browse 730+ Notable
                // Funds" — a coverage overclaim (we ingest holdings weekly for
                // ~89 filers; the directory is name-only and its count had
                // drifted to 788 anyway). The directory is real and useful, so
                // it keeps the door — but the label stops implying a holdings
                // catalog and the rendered list says what selecting a name does.
                + '<div class="f13-top-funds-list ol-hidden"><div class="f13-loading">Loading fund directory...</div></div>';
            el.querySelector('.f13-browse-btn').addEventListener('click', function () {
                var list = el.querySelector('.f13-top-funds-list');
                if (list) {
                    list.classList.remove('ol-hidden');
                    this.classList.add('ol-hidden');
                    _loadNotableFunds(list);
                }
            });
            return;
        }
        el.innerHTML = data.results.map(r => `<div class="f13-fund-result" data-action="load-13f-holdings" data-cik="${escHtml(r.cik)}" data-name="${escHtml(r.name)}">
        <div class="f13-fund-name">${escHtml(r.name)}${fundBadgeHtml(r.name)}</div>
        <div class="f13-fund-meta">CIK: ${escHtml(r.cik)} | Last 13F: ${escHtml(r.lastFiling)}</div>
      </div>`).join('');
    }
    catch (e) {
        if (_seq !== _f13FundReqSeq)
            return; // never paint a stale failure over a live panel
        el.innerHTML = '<div class="f13-error-wrap">'
            + '<div class="f13-error-title">SEC search is temporarily unavailable</div>'
            + '<div class="f13-error-detail">EDGAR may be experiencing delays. Try again in a moment.</div>'
            + '</div>';
    }
    finally {
        // Clear the in-flight marker only if it is still ours — a newer search
        // for a DIFFERENT query owns it now; an identical query can't exist
        // concurrently (it would have been deduped above).
        if (_f13FundInFlightQ === query)
            _f13FundInFlightQ = null;
    }
}
document.getElementById('f13-fund-input')?.addEventListener('keydown', e => { if (e.key === 'Enter')
    search13fFund(); });
var _f13ShowAll = false;
// 13F CYCLE 2026-06-11 Batch-1 (GTM fix 6): fund_holdings_view funnel
// beacon — which path users take to a filer's holdings (details.source:
// featured_card | search). Deduped per CIK per page-life so the
// show-all re-render doesn't double-count. Analytics must never break
// the panel: best-effort, swallowed.
var _f13ViewBeaconSent = {};
function _emitFundHoldingsView(cik, source) {
    try {
        if (!cik || _f13ViewBeaconSent[cik])
            return;
        _f13ViewBeaconSent[cik] = true;
        if (navigator.sendBeacon) {
            navigator.sendBeacon('/api/billing/funnel-event', new Blob([JSON.stringify({ event: 'fund_holdings_view', details: { cik: cik, source: source || 'search' } })], { type: 'application/json' }));
        }
    }
    catch (_e) { /* never break the holdings panel for telemetry */ }
}
async function load13fHoldings(cik, fundName, source) {
    // Achievement: unique 13F filers viewed
    var _f13 = OLStorage.get('ol_f13_viewed', []);
    if (_f13.indexOf(cik) < 0) {
        _f13.push(cik);
        OLStorage.set('ol_f13_viewed', _f13);
    }
    if (typeof setAchievement === 'function')
        setAchievement('f13_viewed', _f13.length);
    _emitFundHoldingsView(cik, source);
    // 2026-05-19 #189 follow-up: the fund-name link added to the
    // Institutional Holdings QoQ panel (renamed 2026-05-20) on
    // /?view=ticker routes through this same handler — but the
    // `f13-fund-results` container only mounts on /?view=13f.
    // rename-history: smart-money
    // Pre-fix, clicking the link from the ticker view threw
    // `TypeError: Cannot set properties of null (setting 'innerHTML')`
    // (OWNER prod-QA breadcrumb 2026-05-20T00:31:42Z, button.hf-fund-link).
    // Now we route through the view first when not already there.
    let el = document.getElementById('f13-fund-results');
    if (!el) {
        if (typeof setView === 'function') {
            setView('13f');
            // Allow one render tick for the 13F view to mount, then retry.
            await new Promise(r => setTimeout(r, 80));
            el = document.getElementById('f13-fund-results');
        }
        if (!el)
            return; // 13F view failed to mount — give up silently
    }
    // #35: claim the shared container — invalidates any in-flight
    // search13fFund response so a late/failed search can never overwrite
    // the holdings we are about to render.
    _f13FundReqSeq++;
    el.innerHTML = `<div class="f13-loading">Loading ${escHtml(fundName)} holdings...</div>`;
    try {
        const res = await fetch(`${SERVER}/api/fund-holdings?cik=${encodeURIComponent(cik)}`, { signal: AbortSignal.timeout(30000) });
        if (!res.ok)
            throw new Error('HTTP ' + res.status);
        const data = await res.json();
        let html = `<div class="f13-summary">
      <span class="f13-fund-name-label">${escHtml(data.fundName || fundName)}</span><br>
      Filing: ${escHtml(data.filingDate || '\u2014')} | Holdings: ${data.totalHoldings || 0} | Total Value: ${fmtVal13f(data.totalValue)}
      <br><span class="fund-detail-back" data-action="search-13f-back">&larr; Back to search</span>
    </div>`;
        // OWNER ruling 2026-10-19 (2): an anonymous reader gets the STORED quarter
        // (top positions only), not the live SEC parse -- say which it is.
        if (data._source === 'stored_13f') {
            // QA 2026-10-27 (P2-1/P1-7): say how many of the positions are shown --
            // the stored answer now honours max_holdings, so it is not always a cut.
            const shown = (data.holdings || []).length;
            const total = data.totalHoldings || shown;
            const scope = shown >= total ? `all ${total} positions` : `${shown} of ${total} positions`;
            html += `<div class="dim-msg">Stored ${escHtml(data.quarter || '')} 13F, ${scope}. Sign in (free) for the live filing with quarter-over-quarter changes.</div>`;
        }
        if (data.holdings && data.holdings.length > 0) {
            html += '<table class="data-table f13-table"><thead><tr><th>Company</th><th>Shares</th><th>Value</th><th>% of Fund</th></tr></thead><tbody>';
            data.holdings.forEach(h => {
                const pct = data.totalValue > 0 ? (h.value / data.totalValue * 100).toFixed(2) : '\u2014';
                // #21 (2026-07-07): carry the server-resolved ticker (cusip_ticker_map,
                // the SAME source nameLink uses below) so the "<- holders" button
                // searches by TICKER directly instead of round-tripping the company NAME
                // through /api/company/search. That fuzzy match resolved AXP but NOT KO
                // ("COCA COLA CO"), which then fell through to ?ticker=COCA%20COLA%20CO
                // and a misleading "No institutional holders on record". data-ticker is
                // the deterministic path; data-name remains the fallback for the tail of
                // holdings whose CUSIP isn't resolved (handled honestly in search13fTicker).
                const crossBtn = h.name ? `<span class="cross-ticker-btn cross-search-btn" data-name="${escHtml(h.name)}"${h.ticker ? ` data-ticker="${escHtml(h.ticker)}"` : ''} title="Search holders of ${escHtml(h.name)}">\u2190 holders</span>` : '';
                // Fix A (2026-06-30 OWNER): link ONLY when the holding has a real,
                // server-resolved ticker (from cusip_ticker_map). Never fabricate a
                // symbol from the company name (name.split(' ')[0] -> 'AMAZON' -> a
                // broken /?view=ticker page that also showed stale prior-ticker data).
                const nameLink = (h.name && h.ticker)
                    ? `<span class="holding-link" data-action="add-ticker-by-symbol" data-sym="${escHtml(h.ticker)}" title="View ${escHtml(h.ticker)}">${escHtml(h.name)}</span>`
                    : escHtml(h.name || '');
                html += `<tr>
          <td>${nameLink}${crossBtn}</td>
          <td>${h.shares ? h.shares.toLocaleString() : '\u2014'}</td>
          <td>${fmtVal13f(h.value)}</td>
          <td>${pct}%</td>
        </tr>`;
            });
            html += '</tbody></table>';
        }
        else if (data._live_fetch_withheld) {
            // Not stored yet, and an anonymous reader fires no SEC fetch: not "empty".
            html += '<div class="dim-msg">Not stored yet for this fund. Sign in (free) to load its latest 13F from SEC.</div>';
        }
        else {
            html += '<div class="dim-msg">No holdings data in filing.</div>';
        }
        el.innerHTML = html;
        // X5c-2: mount the fund's portfolio-over-time trend strip above the positions
        // table (decoupled; additive insertBefore, suppressed below 2 quarters).
        mount13fFundTrendStrip(el, cik);
        el.querySelectorAll('.cross-ticker-btn').forEach(btn => {
            btn.addEventListener('mouseover', () => btn.style.opacity = '1');
            btn.addEventListener('mouseout', () => btn.style.opacity = '0.7');
            btn.addEventListener('click', (e) => { e.stopPropagation(); crossSearchTicker(btn.dataset.ticker || btn.dataset.name); });
        });
        const f13CsvBtn = document.getElementById('f13-csv-btn');
        if (f13CsvBtn)
            f13CsvBtn.classList.remove('hidden');
    }
    catch (e) {
        el.innerHTML = `<div class="f13-error-msg">Unable to load holdings. Please try again.</div>`;
    }
}
//# sourceMappingURL=ticker-renderer-13f.js.map
;
// ═══ ticker-renderer-consensus.js ═══
;"use strict";
// @ts-nocheck
// ticker-renderer-consensus.ts — analyst consensus-estimates panel (#180 cut).
//
// Extracted VERBATIM from ticker-renderer.ts (2026-08-16) to buy size-budget
// headroom: the #180 hero CLS batch put the parent at 4,687 of a 4,650-line
// cap, and this panel is the file's only remaining block with ZERO inbound
// test pins (measured: `git grep -l renderConsensusEstimates tests/` is
// empty) and exactly ONE inbound edge — a try/catch-wrapped RUNTIME call at
// renderTickerData's panel fan-out, so load order is not load-bearing.
//
// Free-name analysis: everything resolved here is a bundle global (fmt,
// escHtml, fmtAbbrev, _hydrateTickerStyles). The function is reached by
// GLOBAL NAME, which is unchanged — build_bundle.py concatenates in script
// mode, there are no ES modules here (same pattern as ticker-renderer-13f).
//
// Script-mode; build_bundle.py loads ticker-renderer-consensus.js directly
// after ticker-renderer-13f.js in both the JS_MODULES manifest and the
// app-tail chunk. The .ts is the SoT; ticker-renderer-consensus.js is the
// gitignored tsc/esbuild emit. Inherits the parent's @ts-nocheck.
// ── Consensus row: price target + source + fetch date (OWNER ruling 4, 2026-09-28) ──
//
// The ticker view's analyst row. It rendered a Buy/Hold/Sell pill from
// `analystRating` plus a bare "PT $X" -- a verdict and a target with no source
// or date. Now it reads ONLY the API's `analyst_consensus` block
// ({mean_target, source, as_of[, count]}, services/analyst_consensus.py):
// target + source + date together, the count only when that same source sent
// one, or "none on file". `as_of` is the date OXFORD LEDGE FETCHED the figure
// (2026-10-04 ruling), so the label says so -- never the analysts' own date.
// A rating key on the payload has nowhere to render. Plain JS on purpose --
// tests/test_no_verdict_labels_contract.py executes these bodies under node
// straight from the .ts.
function _tcFetchLabel(iso, src) {
    var m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(iso || ''));
    var mon = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    var day = m ? mon[Number(m[2]) - 1] + ' ' + Number(m[3]) + ', ' + m[1] : String(iso || '');
    return 'as of ' + escHtml(day) + ' (our fetch date), via ' + escHtml(src);
}
function analystConsensusHtml(d) {
    // R3 cut-back (CHAOS 2026-10-13 F4): an anonymous body has the target
    // WITHHELD (services/public_price_gate.py), not absent -- "none on file"
    // would be a false statement about coverage. Say why instead.
    if (d && d._vendor_prices_withheld) {
        return '<span class="consensus-est-label">Analyst price targets: '
            + escHtml(String(d._price_notice || 'Market prices are shown to signed-in users.')) + '</span>';
    }
    var ac = d && d.analyst_consensus;
    var tgt = ac ? Number(ac.mean_target) : NaN;
    var src = ac && typeof ac.source === 'string' ? ac.source.trim() : '';
    var asOf = ac && typeof ac.as_of === 'string' ? ac.as_of.trim() : '';
    if (!(tgt > 0) || !src || !asOf) {
        return '<span class="consensus-est-label">No analyst price target on file for this ticker.</span>';
    }
    var n = Number(ac.count);
    var cnt = (n > 0 && n === Math.floor(n)) ? ' \u00B7 ' + n + ' analyst' + (n === 1 ? '' : 's') : '';
    return '<span class="consensus-est-label">Mean analyst price target $' + fmt(tgt) + cnt
        + ' \u00B7 ' + _tcFetchLabel(asOf, src) + '</span>';
}
// ── CONSENSUS ESTIMATES PANEL ──
// CONTENT GATE, default OFF -- OWNER ruling 2026-10-26 (B): "review content
// first". The panel never showed (template `d-none` + an #id `display: none`
// vs a renderer that toggles only `hidden`); the mechanism is fixed, so this
// constant is what keeps it dark. Every figure on it is VENDOR data: Finnhub
// price targets and Finnhub/FMP EPS estimates (data_fetching.py "Consensus
// Estimates"). Finnhub's free plan is personal-use only and FMP's display
// licence is unsigned (COUNSEL R3, docs/board/audit/2026-10-12_COUNSEL_R3_
// price_display_licensing.md, OWNER 2026-10-12); targets are dollar prices.
// Do not flip without a COUNSEL clearance on the display terms.
const _TC_CONSENSUS_PANEL_ON = false;
function consensusTargetCardHtml(ce) {
    var src = ce && typeof ce.targetSource === 'string' ? ce.targetSource.trim() : '';
    var asOf = ce && typeof ce.targetAsOf === 'string' ? ce.targetAsOf.trim() : '';
    if (!ce || !(Number(ce.targetMean) > 0) || !src || !asOf)
        return '';
    var h = '<div class="ce-card"><div class="ce-card-title" data-gloss="Price Target">Price Target</div>';
    if (ce.targetLow)
        h += '<div class="ce-est-row"><span class="ce-est-label">Low</span><span class="ce-est-val">$' + fmt(ce.targetLow) + '</span></div>';
    h += '<div class="ce-est-row"><span class="ce-est-label">Mean</span><span class="ce-est-val ce-est-fw600">$' + fmt(ce.targetMean) + '</span></div>';
    if (ce.targetHigh)
        h += '<div class="ce-est-row"><span class="ce-est-label">High</span><span class="ce-est-val">$' + fmt(ce.targetHigh) + '</span></div>';
    var n = Number(ce.numberOfAnalysts);
    if (n > 0 && n === Math.floor(n))
        h += '<div class="ce-analyst-count">' + n + ' analyst' + (n === 1 ? '' : 's') + '</div>';
    h += '<div class="ce-analyst-count">' + _tcFetchLabel(asOf, src) + '</div>';
    return h + '</div>';
}
function renderConsensusEstimates(d) {
    const el = document.getElementById('consensus-estimates-panel');
    if (!el)
        return;
    if (!_TC_CONSENSUS_PANEL_ON) {
        el.classList.add('hidden');
        el.setAttribute('data-content-gate', 'off');
        return;
    }
    el.removeAttribute('data-content-gate');
    const ce = d.consensusEstimates;
    if (!ce || (!ce.targetMean && !ce.epsEstimates && !ce.revenueEstimates)) {
        el.classList.add('hidden');
        return;
    }
    el.classList.remove('hidden');
    let html = '<h2 class="panel-title ce-panel-title" data-gloss="Consensus">Consensus Estimates</h2>';
    html += '<div class="ce-grid">';
    // Price Target card -- OWNER ruling 4 follow-up (2026-10-04): only with its
    // source + our fetch date; no "Upside %" and no current-price marker (a
    // target set against today's price reads as a call). The count is shown only
    // when the same response carried it (the API drops any other).
    html += consensusTargetCardHtml(ce);
    // EPS Estimates card
    if (ce.epsEstimates && ce.epsEstimates.length > 0) {
        html += '<div class="ce-card">';
        html += '<div class="ce-card-title">EPS Estimates</div>';
        ce.epsEstimates.slice(0, 4).forEach(ep => {
            const avg = ep['Avg. Estimate'] || ep['avg'] || ep['Average Estimate'];
            const lo = ep['Low Estimate'] || ep['low'];
            const hi = ep['High Estimate'] || ep['high'];
            html += `<div class="ce-est-row"><span class="ce-est-label">${escHtml(ep.period || '')}</span><span class="ce-est-val">${avg != null ? '$' + fmt(avg, 2) : '\u2014'}</span></div>`;
            if (lo != null && hi != null) {
                html += `<div class="ae-est-range">Range: $${fmt(lo, 2)} \u2013 $${fmt(hi, 2)}</div>`;
            }
        });
        html += '</div>';
    }
    // Revenue Estimates card
    if (ce.revenueEstimates && ce.revenueEstimates.length > 0) {
        html += '<div class="ce-card">';
        html += '<div class="ce-card-title">Revenue Estimates</div>';
        ce.revenueEstimates.slice(0, 4).forEach(re => {
            const avg = re['Avg. Estimate'] || re['avg'] || re['Average Estimate'];
            const lo = re['Low Estimate'] || re['low'];
            const hi = re['High Estimate'] || re['high'];
            const display = avg != null ? fmtAbbrev(avg) : '\u2014'; // DS-P2a: canonical $ K/M/B
            html += `<div class="ce-est-row"><span class="ce-est-label">${escHtml(re.period || '')}</span><span class="ce-est-val">${display}</span></div>`;
            if (lo != null && hi != null) {
                const loD = fmtAbbrev(lo); // DS-P2a: canonical $ K/M/B
                const hiD = fmtAbbrev(hi);
                html += `<div class="ae-est-range">Range: ${loD} \u2013 ${hiD}</div>`;
            }
        });
        html += '</div>';
    }
    html += '</div>';
    html += '<div class="ae-disclaimer">Consensus estimates via market data providers. For informational purposes only.</div>';
    el.innerHTML = html;
    _hydrateTickerStyles(el);
}
//# sourceMappingURL=ticker-renderer-consensus.js.map
;